/*! lodash.js */
(function () {
    var n,
        r = "Expected a function",
        t = 1,
        e = 2,
        u = 1,
        o = 1 / 0,
        i = 9007199254740991,
        c = "[object Arguments]",
        f = "[object Array]",
        a = "[object AsyncFunction]",
        l = "[object Boolean]",
        p = "[object Date]",
        s = "[object Error]",
        v = "[object Function]",
        h = "[object GeneratorFunction]",
        y = "[object Number]",
        g = "[object Object]",
        _ = "[object Proxy]",
        b = "[object RegExp]",
        j = "[object String]",
        d = /[&<>"']/g,
        m = RegExp(d.source),
        O = /^(?:0|[1-9]\d*)$/,
        x = "object" == typeof global && global && global.Object === Object && global,
        w = "object" == typeof self && self && self.Object === Object && self,
        A = x || w || Function("return this")(),
        E = "object" == typeof exports && exports && !exports.nodeType && exports,
        N = E && "object" == typeof module && module && !module.nodeType && module;
    function k(n, r) {
        return n.push.apply(n, r), n;
    }
    function F(r) {
        return function (t) {
            return null == t ? n : t[r];
        };
    }
    var T,
        S =
            ((T = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }),
            function (r) {
                return null == T ? n : T[r];
            });
    var B,
        I,
        R = Array.prototype,
        $ = Object.prototype,
        q = $.hasOwnProperty,
        D = 0,
        P = $.toString,
        z = A._,
        C = Object.create,
        G = $.propertyIsEnumerable,
        J = A.isFinite,
        M =
            ((B = Object.keys),
            (I = Object),
            function (n) {
                return B(I(n));
            }),
        U = Math.max;
    function V(n) {
        return n instanceof K ? n : new K(n);
    }
    var H = (function () {
        function r() {}
        return function (t) {
            if (!Vn(t)) return {};
            if (C) return C(t);
            r.prototype = t;
            var e = new r();
            return (r.prototype = n), e;
        };
    })();
    function K(n, r) {
        (this.__wrapped__ = n), (this.__actions__ = []), (this.__chain__ = !!r);
    }
    function L(n, r, t) {
        n[r] = t;
    }
    function Q(t, e, u) {
        if ("function" != typeof t) throw new TypeError(r);
        return setTimeout(function () {
            t.apply(n, u);
        }, e);
    }
    (K.prototype = H(V.prototype)), (K.prototype.constructor = K);
    var W,
        X,
        Y =
            ((W = un),
            function (n, r) {
                if (null == n) return n;
                if (!Jn(n)) return W(n, r);
                for (var t = n.length, e = X ? t : -1, u = Object(n); (X ? e-- : ++e < t) && !1 !== r(u[e], e, u); );
                return n;
            });
    function Z(r, t, e) {
        for (var u = -1, o = r.length; ++u < o; ) {
            var i = r[u],
                c = t(i);
            if (null != c && (f === n ? c == c : e(c, f)))
                var f = c,
                    a = i;
        }
        return a;
    }
    function nn(n, r) {
        var t = [];
        return (
            Y(n, function (n, e, u) {
                r(n, e, u) && t.push(n);
            }),
            t
        );
    }
    function rn(n, r, t, e, u) {
        var o = -1,
            i = n.length;
        for (t || (t = On), u || (u = []); ++o < i; ) {
            var c = n[o];
            r > 0 && t(c) ? (r > 1 ? rn(c, r - 1, t, e, u) : k(u, c)) : e || (u[u.length] = c);
        }
        return u;
    }
    var tn,
        en = function (n, r, t) {
            for (var e = -1, u = Object(n), o = t(n), i = o.length; i--; ) {
                var c = o[tn ? i : ++e];
                if (!1 === r(u[c], c, u)) break;
            }
            return n;
        };
    function un(n, r) {
        return n && en(n, r, er);
    }
    function on(n, r) {
        return nn(r, function (r) {
            return Un(n[r]);
        });
    }
    function cn(n) {
        return (r = n), P.call(r);
        var r;
    }
    function fn(n, r) {
        return n > r;
    }
    var an = pr;
    function ln(r, u, o, i, a) {
        return (
            r === u ||
            (null == r || null == u || (!Hn(r) && !Hn(u))
                ? r != r && u != u
                : (function (r, u, o, i, a, v) {
                      var h = Gn(r),
                          _ = Gn(u),
                          d = h ? f : cn(r),
                          m = _ ? f : cn(u),
                          O = (d = d == c ? g : d) == g,
                          x = (m = m == c ? g : m) == g,
                          w = d == m;
                      v || (v = []);
                      var A = Bn(v, function (n) {
                              return n[0] == r;
                          }),
                          E = Bn(v, function (n) {
                              return n[0] == u;
                          });
                      if (A && E) return A[1] == u;
                      if ((v.push([r, u]), v.push([u, r]), w && !O)) {
                          var N = h
                              ? (function (r, u, o, i, c, f) {
                                    var a = o & t,
                                        l = r.length,
                                        p = u.length;
                                    if (l != p && !(a && p > l)) return !1;
                                    var s = -1,
                                        v = !0,
                                        h = o & e ? [] : n;
                                    for (; ++s < l; ) {
                                        var y = r[s],
                                            g = u[s];
                                        if (void 0 !== n) {
                                            void 0, (v = !1);
                                            break;
                                        }
                                        if (h) {
                                            if (
                                                !bn(u, function (n, r) {
                                                    if (!Fn(h, r) && (y === n || c(y, n, o, i, f))) return h.push(r);
                                                })
                                            ) {
                                                v = !1;
                                                break;
                                            }
                                        } else if (y !== g && !c(y, g, o, i, f)) {
                                            v = !1;
                                            break;
                                        }
                                    }
                                    return v;
                                })(r, u, o, i, a, v)
                              : (function (n, r, t, e, u, o, i) {
                                    switch (t) {
                                        case l:
                                        case p:
                                        case y:
                                            return zn(+n, +r);
                                        case s:
                                            return n.name == r.name && n.message == r.message;
                                        case b:
                                        case j:
                                            return n == r + "";
                                    }
                                    return !1;
                                })(r, u, d);
                          return v.pop(), N;
                      }
                      if (!(o & t)) {
                          var k = O && q.call(r, "__wrapped__"),
                              F = x && q.call(u, "__wrapped__");
                          if (k || F) {
                              var T = k ? r.value() : r,
                                  S = F ? u.value() : u,
                                  N = a(T, S, o, i, v);
                              return v.pop(), N;
                          }
                      }
                      if (!w) return !1;
                      var N = (function (r, e, u, o, i, c) {
                          var f = u & t,
                              a = er(r),
                              l = a.length,
                              p = er(e).length;
                          if (l != p && !f) return !1;
                          var s = l;
                          for (; s--; ) {
                              var v = a[s];
                              if (!(f ? v in e : q.call(e, v))) return !1;
                          }
                          var h = !0,
                              y = f;
                          for (; ++s < l; ) {
                              v = a[s];
                              var g = r[v],
                                  _ = e[v];
                              if (!(void 0 === n ? g === _ || i(g, _, u, o, c) : void 0)) {
                                  h = !1;
                                  break;
                              }
                              y || (y = "constructor" == v);
                          }
                          if (h && !y) {
                              var b = r.constructor,
                                  j = e.constructor;
                              b != j && "constructor" in r && "constructor" in e && !("function" == typeof b && b instanceof b && "function" == typeof j && j instanceof j) && (h = !1);
                          }
                          return h;
                      })(r, u, o, i, a, v);
                      return v.pop(), N;
                  })(r, u, o, i, ln, a))
        );
    }
    function pn(n) {
        return "function" == typeof n ? n : null == n ? cr : ("object" == typeof n ? hn : F)(n);
    }
    function sn(n, r) {
        return n < r;
    }
    function vn(n, r) {
        var t = -1,
            e = Jn(n) ? Array(n.length) : [];
        return (
            Y(n, function (n, u, o) {
                e[++t] = r(n, u, o);
            }),
            e
        );
    }
    function hn(n) {
        var r = M(n);
        return function (u) {
            var o = r.length;
            if (null == u) return !o;
            for (u = Object(u); o--; ) {
                var i = r[o];
                if (!(i in u && ln(n[i], u[i], t | e))) return !1;
            }
            return !0;
        };
    }
    function yn(n, r) {
        return En(An(n, r, cr), n + "");
    }
    function gn(n, r, t) {
        var e = -1,
            u = n.length;
        r < 0 && (r = -r > u ? 0 : u + r), (t = t > u ? u : t) < 0 && (t += u), (u = r > t ? 0 : (t - r) >>> 0), (r >>>= 0);
        for (var o = Array(u); ++e < u; ) o[e] = n[e + r];
        return o;
    }
    function _n(n) {
        return gn(n, 0, n.length);
    }
    function bn(n, r) {
        var t;
        return (
            Y(n, function (n, e, u) {
                return !(t = r(n, e, u));
            }),
            !!t
        );
    }
    function jn(r, t, e, u) {
        var o = !e;
        e || (e = {});
        for (var i, c, f, a, l = -1, p = t.length; ++l < p; ) {
            var s = t[l],
                v = u ? u(e[s], r[s], s, e, r) : n;
            v === n && (v = r[s]), o ? L(e, s, v) : ((f = v), void 0, (a = (i = e)[(c = s)]), (q.call(i, c) && zn(a, f) && (f !== n || c in i)) || L(i, c, f));
        }
        return e;
    }
    function dn(r) {
        return yn(function (t, e) {
            var u = -1,
                o = e.length,
                i = o > 1 ? e[o - 1] : n;
            for (i = r.length > 3 && "function" == typeof i ? (o--, i) : n, t = Object(t); ++u < o; ) {
                var c = e[u];
                c && r(t, c, u, i);
            }
            return t;
        });
    }
    function mn(n, t, e, o) {
        if ("function" != typeof n) throw new TypeError(r);
        var i,
            c = t & u,
            f =
                ((i = n),
                function () {
                    var n = arguments,
                        r = H(i.prototype),
                        t = i.apply(r, n);
                    return Vn(t) ? t : r;
                });
        return function r() {
            for (var t = -1, u = arguments.length, i = -1, a = o.length, l = Array(a + u), p = this && this !== A && this instanceof r ? f : n; ++i < a; ) l[i] = o[i];
            for (; u--; ) l[i++] = arguments[++t];
            return p.apply(c ? e : this, l);
        };
    }
    function On(n) {
        return Gn(n) || Cn(n);
    }
    function xn(n, r, t) {
        if (!Vn(t)) return !1;
        var e,
            u,
            o,
            c = typeof r;
        return !!("number" == c ? Jn(t) && ((e = r), (u = t.length), (o = typeof e), (u = null == u ? i : u) && ("number" == o || ("symbol" != o && O.test(e))) && e > -1 && e % 1 == 0 && e < u) : "string" == c && r in t) && zn(t[r], n);
    }
    function wn(n) {
        var r = [];
        if (null != n) for (var t in Object(n)) r.push(t);
        return r;
    }
    function An(r, t, e) {
        return (
            (t = U(t === n ? r.length - 1 : t, 0)),
            function () {
                for (var n = arguments, u = -1, o = U(n.length - t, 0), i = Array(o); ++u < o; ) i[u] = n[t + u];
                u = -1;
                for (var c = Array(t + 1); ++u < t; ) c[u] = n[u];
                return (c[t] = e(i)), r.apply(this, c);
            }
        );
    }
    var En = cr;
    function Nn(n) {
        return (null == n ? 0 : n.length) ? rn(n, 1) : [];
    }
    function kn(r) {
        return r && r.length ? r[0] : n;
    }
    function Fn(n, r, t) {
        for (var e = null == n ? 0 : n.length, u = ((t = "number" == typeof t ? (t < 0 ? U(e + t, 0) : t) : 0) || 0) - 1, o = r == r; ++u < e; ) {
            var i = n[u];
            if (o ? i === r : i != i) return u;
        }
        return -1;
    }
    function Tn(n) {
        var r = V(n);
        return (r.__chain__ = !0), r;
    }
    var Sn,
        Bn =
            ((Sn = function (n, r, t) {
                var e = null == n ? 0 : n.length;
                if (!e) return -1;
                var u = null == t ? 0 : Wn(t);
                return (
                    u < 0 && (u = U(e + u, 0)),
                    (function (n, r, t, e) {
                        for (var u = n.length, o = t + (e ? 1 : -1); e ? o-- : ++o < u; ) if (r(n[o], o, n)) return o;
                        return -1;
                    })(n, pn(r), u)
                );
            }),
            function (r, t, e) {
                var u = Object(r);
                if (!Jn(r)) {
                    var o = pn(t);
                    (r = er(r)),
                        (t = function (n) {
                            return o(u[n], n, u);
                        });
                }
                var i = Sn(r, t, e);
                return i > -1 ? u[o ? r[i] : i] : n;
            });
    function In(n, r) {
        return Y(n, pn(r));
    }
    function Rn(n, r, t) {
        return (
            (e = n),
            (u = pn(r)),
            (o = t),
            (i = arguments.length < 3),
            Y(e, function (n, r, t) {
                o = i ? ((i = !1), n) : u(o, n, r, t);
            }),
            o
        );
        var e, u, o, i;
    }
    function $n(t, e) {
        var u;
        if ("function" != typeof e) throw new TypeError(r);
        return (
            (t = Wn(t)),
            function () {
                return --t > 0 && (u = e.apply(this, arguments)), t <= 1 && (e = n), u;
            }
        );
    }
    var qn = yn(function (n, r, t) {
            return mn(n, 32 | u, r, t);
        }),
        Dn = yn(function (n, r) {
            return Q(n, 1, r);
        }),
        Pn = yn(function (n, r, t) {
            return Q(n, Xn(r) || 0, t);
        });
    function zn(n, r) {
        return n === r || (n != n && r != r);
    }
    var Cn = an(
            (function () {
                return arguments;
            })()
        )
            ? an
            : function (n) {
                  return Hn(n) && q.call(n, "callee") && !G.call(n, "callee");
              },
        Gn = Array.isArray;
    function Jn(n) {
        return null != n && "number" == typeof (r = n.length) && r > -1 && r % 1 == 0 && r <= i && !Un(n);
        var r;
    }
    var Mn = function (n) {
        return Hn(n) && cn(n) == p;
    };
    function Un(n) {
        if (!Vn(n)) return !1;
        var r = cn(n);
        return r == v || r == h || r == a || r == _;
    }
    function Vn(n) {
        var r = typeof n;
        return null != n && ("object" == r || "function" == r);
    }
    function Hn(n) {
        return null != n && "object" == typeof n;
    }
    function Kn(n) {
        return "number" == typeof n || (Hn(n) && cn(n) == y);
    }
    var Ln = function (n) {
        return Hn(n) && cn(n) == b;
    };
    function Qn(n) {
        return "string" == typeof n || (!Gn(n) && Hn(n) && cn(n) == j);
    }
    var Wn = Number,
        Xn = Number;
    function Yn(n) {
        return "string" == typeof n ? n : null == n ? "" : n + "";
    }
    var Zn = dn(function (n, r) {
            jn(r, M(r), n);
        }),
        nr = dn(function (n, r) {
            jn(r, wn(r), n);
        });
    var rr = yn(function (r, t) {
        r = Object(r);
        var e = -1,
            u = t.length,
            o = u > 2 ? t[2] : n;
        for (o && xn(t[0], t[1], o) && (u = 1); ++e < u; )
            for (var i = t[e], c = ur(i), f = -1, a = c.length; ++f < a; ) {
                var l = c[f],
                    p = r[l];
                (p === n || (zn(p, $[l]) && !q.call(r, l))) && (r[l] = i[l]);
            }
        return r;
    });
    var tr,
        er = M,
        ur = wn,
        or = En(
            An(
                (tr = function (n, r) {
                    return null == n
                        ? {}
                        : ((t = n),
                          (e = r),
                          (t = Object(t)),
                          Rn(
                              e,
                              function (n, r) {
                                  return r in t && (n[r] = t[r]), n;
                              },
                              {}
                          ));
                    var t, e;
                }),
                n,
                Nn
            ),
            tr + ""
        );
    function ir(n) {
        return null == n
            ? []
            : ((r = n),
              vn(er(n), function (n) {
                  return r[n];
              }));
        var r;
    }
    function cr(n) {
        return n;
    }
    var fr,
        ar = pn;
    function lr(n, r, t) {
        var e = er(r),
            u = on(r, e);
        null != t || (Vn(r) && (u.length || !e.length)) || ((t = r), (r = n), (n = this), (u = on(r, er(r))));
        var o = !(Vn(t) && "chain" in t && !t.chain),
            i = Un(n);
        return (
            Y(u, function (t) {
                var e = r[t];
                (n[t] = e),
                    i &&
                        (n.prototype[t] = function () {
                            var r = this.__chain__;
                            if (o || r) {
                                var t = n(this.__wrapped__);
                                return (t.__actions__ = _n(this.__actions__)).push({ func: e, args: arguments, thisArg: n }), (t.__chain__ = r), t;
                            }
                            return e.apply(n, k([this.value()], arguments));
                        });
            }),
            n
        );
    }
    function pr() {}
    (V.assignIn = nr),
        (V.before = $n),
        (V.bind = qn),
        (V.chain = Tn),
        (V.compact = function (n) {
            return nn(n, Boolean);
        }),
        (V.concat = function () {
            var n = arguments.length;
            if (!n) return [];
            for (var r = Array(n - 1), t = arguments[0], e = n; e--; ) r[e - 1] = arguments[e];
            return k(Gn(t) ? _n(t) : [t], rn(r, 1));
        }),
        (V.create = function (n, r) {
            var t = H(n);
            return null == r ? t : Zn(t, r);
        }),
        (V.defaults = rr),
        (V.defer = Dn),
        (V.delay = Pn),
        (V.filter = function (n, r) {
            return nn(n, pn(r));
        }),
        (V.flatten = Nn),
        (V.flattenDeep = function (n) {
            return null != n && n.length ? rn(n, o) : [];
        }),
        (V.iteratee = ar),
        (V.keys = er),
        (V.map = function (n, r) {
            return vn(n, pn(r));
        }),
        (V.matches = function (n) {
            return hn(Zn({}, n));
        }),
        (V.mixin = lr),
        (V.negate = function (n) {
            if ("function" != typeof n) throw new TypeError(r);
            return function () {
                var r = arguments;
                return !n.apply(this, r);
            };
        }),
        (V.once = function (n) {
            return $n(2, n);
        }),
        (V.pick = or),
        (V.slice = function (r, t, e) {
            var u = null == r ? 0 : r.length;
            return (t = null == t ? 0 : +t), (e = e === n ? u : +e), u ? gn(r, t, e) : [];
        }),
        (V.sortBy = function (r, t) {
            var e = 0;
            return (
                (t = pn(t)),
                vn(
                    vn(r, function (n, r, u) {
                        return { value: n, index: e++, criteria: t(n, r, u) };
                    }).sort(function (r, t) {
                        return (
                            (function (r, t) {
                                if (r !== t) {
                                    var e = r !== n,
                                        u = null === r,
                                        o = r == r,
                                        i = t !== n,
                                        c = null === t,
                                        f = t == t;
                                    if ((!c && r > t) || (u && i && f) || (!e && f) || !o) return 1;
                                    if ((!u && r < t) || (c && e && o) || (!i && o) || !f) return -1;
                                }
                                return 0;
                            })(r.criteria, t.criteria) || r.index - t.index
                        );
                    }),
                    F("value")
                )
            );
        }),
        (V.tap = function (n, r) {
            return r(n), n;
        }),
        (V.thru = function (n, r) {
            return r(n);
        }),
        (V.toArray = function (n) {
            return Jn(n) ? (n.length ? _n(n) : []) : ir(n);
        }),
        (V.values = ir),
        (V.extend = nr),
        lr(V, V),
        (V.clone = function (n) {
            return Vn(n) ? (Gn(n) ? _n(n) : jn(n, M(n))) : n;
        }),
        (V.escape = function (n) {
            return (n = Yn(n)) && m.test(n) ? n.replace(d, S) : n;
        }),
        (V.every = function (r, t, e) {
            return (
                (u = r),
                (o = pn((t = e ? n : t))),
                (i = !0),
                Y(u, function (n, r, t) {
                    return (i = !!o(n, r, t));
                }),
                i
            );
            var u, o, i;
        }),
        (V.find = Bn),
        (V.forEach = In),
        (V.has = function (n, r) {
            return null != n && q.call(n, r);
        }),
        (V.head = kn),
        (V.identity = cr),
        (V.indexOf = Fn),
        (V.isArguments = Cn),
        (V.isArray = Gn),
        (V.isBoolean = function (n) {
            return !0 === n || !1 === n || (Hn(n) && cn(n) == l);
        }),
        (V.isDate = Mn),
        (V.isEmpty = function (n) {
            return Jn(n) && (Gn(n) || Qn(n) || Un(n.splice) || Cn(n)) ? !n.length : !M(n).length;
        }),
        (V.isEqual = function (n, r) {
            return ln(n, r);
        }),
        (V.isFinite = function (n) {
            return "number" == typeof n && J(n);
        }),
        (V.isFunction = Un),
        (V.isNaN = function (n) {
            return Kn(n) && n != +n;
        }),
        (V.isNull = function (n) {
            return null === n;
        }),
        (V.isNumber = Kn),
        (V.isObject = Vn),
        (V.isRegExp = Ln),
        (V.isString = Qn),
        (V.isUndefined = function (r) {
            return r === n;
        }),
        (V.last = function (r) {
            var t = null == r ? 0 : r.length;
            return t ? r[t - 1] : n;
        }),
        (V.max = function (r) {
            return r && r.length ? Z(r, cr, fn) : n;
        }),
        (V.min = function (r) {
            return r && r.length ? Z(r, cr, sn) : n;
        }),
        (V.noConflict = function () {
            return A._ === this && (A._ = z), this;
        }),
        (V.noop = pr),
        (V.reduce = Rn),
        (V.result = function (r, t, e) {
            var u = null == r ? n : r[t];
            return u === n && (u = e), Un(u) ? u.call(r) : u;
        }),
        (V.size = function (n) {
            return null == n ? 0 : (n = Jn(n) ? n : M(n)).length;
        }),
        (V.some = function (r, t, e) {
            return bn(r, pn((t = e ? n : t)));
        }),
        (V.uniqueId = function (n) {
            var r = ++D;
            return Yn(n) + r;
        }),
        (V.each = In),
        (V.first = kn),
        lr(
            V,
            ((fr = {}),
            un(V, function (n, r) {
                q.call(V.prototype, r) || (fr[r] = n);
            }),
            fr),
            { chain: !1 }
        ),
        (V.VERSION = "4.17.10"),
        Y(["pop", "join", "replace", "reverse", "split", "push", "shift", "sort", "splice", "unshift"], function (n) {
            var r = (/^(?:replace|split)$/.test(n) ? String.prototype : R)[n],
                t = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru",
                e = /^(?:pop|join|replace|shift)$/.test(n);
            V.prototype[n] = function () {
                var n = arguments;
                if (e && !this.__chain__) {
                    var u = this.value();
                    return r.apply(Gn(u) ? u : [], n);
                }
                return this[t](function (t) {
                    return r.apply(Gn(t) ? t : [], n);
                });
            };
        }),
        (V.prototype.toJSON = V.prototype.valueOf = V.prototype.value = function () {
            return (
                (n = this.__wrapped__),
                Rn(
                    this.__actions__,
                    function (n, r) {
                        return r.func.apply(r.thisArg, k([n], r.args));
                    },
                    n
                )
            );
            var n;
        }),
        "function" == typeof define && "object" == typeof define.amd && define.amd
            ? ((A._ = V),
              define(function () {
                  return V;
              }))
            : N
            ? (((N.exports = V)._ = V), (E._ = V))
            : (A._ = V);
}.call(this));
/*! Shopify query params */
if (
    ("undefined" == typeof window.Shopify && (window.Shopify = {}),
    (Shopify.bind = function (a, b) {
        return function () {
            return a.apply(b, arguments);
        };
    }),
    (Shopify.setSelectorByValue = function (a, b) {
        for (var c = 0, d = a.options.length; d > c; c++) {
            var e = a.options[c];
            if (b == e.value || b == e.innerHTML) return (a.selectedIndex = c), c;
        }
    }),
    (Shopify.addListener = function (a, b, c) {
        a.addEventListener ? a.addEventListener(b, c, !1) : a.attachEvent("on" + b, c);
    }),
    (Shopify.postLink = function (a, b) {
        b = b || {};
        var c = b.method || "post",
            d = b.parameters || {},
            e = document.createElement("form");
        e.setAttribute("method", c), e.setAttribute("action", a);
        for (var f in d) {
            var g = document.createElement("input");
            g.setAttribute("type", "hidden"), g.setAttribute("name", f), g.setAttribute("value", d[f]), e.appendChild(g);
        }
        document.body.appendChild(e), e.submit(), document.body.removeChild(e);
    }),
    (Shopify.CountryProvinceSelector = function (a, b, c) {
        (this.countryEl = document.getElementById(a)),
            (this.provinceEl = document.getElementById(b)),
            (this.provinceContainer = document.getElementById(c.hideElement || b)),
            Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
            this.initCountry(),
            this.initProvince();
    }),
    (Shopify.CountryProvinceSelector.prototype = {
        initCountry: function () {
            var a = this.countryEl.getAttribute("data-default");
            Shopify.setSelectorByValue(this.countryEl, a), this.countryHandler();
        },
        initProvince: function () {
            var a = this.provinceEl.getAttribute("data-default");
            a && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, a);
        },
        countryHandler: function (a) {
            var b = this.countryEl.options[this.countryEl.selectedIndex],
                c = b.getAttribute("data-provinces"),
                d = JSON.parse(c);
            if ((this.clearOptions(this.provinceEl), d && 0 == d.length)) this.provinceContainer.style.display = "none";
            else {
                for (var e = 0; e < d.length; e++) {
                    var b = document.createElement("option");
                    (b.value = d[e][0]), (b.innerHTML = d[e][1]), this.provinceEl.appendChild(b);
                }
                this.provinceContainer.style.display = "";
            }
        },
        clearOptions: function (a) {
            for (; a.firstChild; ) a.removeChild(a.firstChild);
        },
        setOptions: function (a, b) {
            var c = 0;
            for (b.length; c < b.length; c++) {
                var d = document.createElement("option");
                (d.value = b[c]), (d.innerHTML = b[c]), a.appendChild(d);
            }
        },
    }),
    (Shopify.CustomerAddress = {
        toggleForm: function (a) {
            var b = document.getElementById("view_addresses"),
                c = document.getElementById("edit_address_" + a);
            return (b.style.display = "none" == b.style.display ? "" : "none"), (c.style.display = "none" == c.style.display ? "" : "none"), !1;
        },
        toggleNewForm: function () {
            var a = document.getElementById("add_address"),
                b = document.getElementById("address_tables");
            return (a.style.display = "none" == a.style.display ? "" : "none"), (b.style.display = "none" == a.style.display ? "" : "none"), !1;
        },
        destroy: function (a, b) {
            confirm(b || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + a, { parameters: { _method: "delete" } });
        },
    }),
    (Shopify.queryParams = {}),
    location.search.length)
)
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&"); i < aCouples.length; i++)
        (aKeyValue = aCouples[i].split("=")), aKeyValue.length > 1 && (Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]));
/*! enquire.js v2.1.2 */
!(function (t, i, n) {
    var e = window.matchMedia;
    "undefined" != typeof module && module.exports
        ? (module.exports = n(e))
        : "function" == typeof define && define.amd
        ? define(function () {
              return (i[t] = n(e));
          })
        : (i[t] = n(e));
})("enquire", this, function (t) {
    "use strict";
    function i(t, i) {
        for (var n = 0, e = t.length; e > n && !1 !== i(t[n], n); n++);
    }
    function n(t) {
        return "function" == typeof t;
    }
    function e(t) {
        (this.options = t), !t.deferSetup && this.setup();
    }
    function s(i, n) {
        (this.query = i), (this.isUnconditional = n), (this.handlers = []), (this.mql = t(i));
        var e = this;
        (this.listener = function (t) {
            (e.mql = t), e.assess();
        }),
            this.mql.addListener(this.listener);
    }
    function o() {
        if (!t) throw new Error("matchMedia not present, legacy browsers require a polyfill");
        (this.queries = {}), (this.browserIsIncapable = !t("only all").matches);
    }
    return (
        (e.prototype = {
            setup: function () {
                this.options.setup && this.options.setup(), (this.initialised = !0);
            },
            on: function () {
                !this.initialised && this.setup(), this.options.match && this.options.match();
            },
            off: function () {
                this.options.unmatch && this.options.unmatch();
            },
            destroy: function () {
                this.options.destroy ? this.options.destroy() : this.off();
            },
            equals: function (t) {
                return this.options === t || this.options.match === t;
            },
        }),
        (s.prototype = {
            addHandler: function (t) {
                var i = new e(t);
                this.handlers.push(i), this.matches() && i.on();
            },
            removeHandler: function (t) {
                var n = this.handlers;
                i(n, function (i, e) {
                    return i.equals(t) ? (i.destroy(), !n.splice(e, 1)) : void 0;
                });
            },
            matches: function () {
                return this.mql.matches || this.isUnconditional;
            },
            clear: function () {
                i(this.handlers, function (t) {
                    t.destroy();
                }),
                    this.mql.removeListener(this.listener),
                    (this.handlers.length = 0);
            },
            assess: function () {
                var t = this.matches() ? "on" : "off";
                i(this.handlers, function (i) {
                    i[t]();
                });
            },
        }),
        (o.prototype = {
            register: function (t, e, o) {
                var r,
                    h = this.queries,
                    u = o && this.browserIsIncapable;
                return (
                    h[t] || (h[t] = new s(t, u)),
                    n(e) && (e = { match: e }),
                    (r = e),
                    "[object Array]" === Object.prototype.toString.apply(r) || (e = [e]),
                    i(e, function (i) {
                        n(i) && (i = { match: i }), h[t].addHandler(i);
                    }),
                    this
                );
            },
            unregister: function (t, i) {
                var n = this.queries[t];
                return n && (i ? n.removeHandler(i) : (n.clear(), delete this.queries[t])), this;
            },
        }),
        new o()
    );
});
/*! jQuery v2.2.3 */
!(function (e, t) {
    "object" == typeof module && "object" == typeof module.exports
        ? (module.exports = e.document
              ? t(e, !0)
              : function (e) {
                    if (!e.document) throw new Error("jQuery requires a window with a document");
                    return t(e);
                })
        : t(e);
})("undefined" != typeof window ? window : this, function (e, t) {
    var n = [],
        r = e.document,
        i = n.slice,
        o = n.concat,
        s = n.push,
        a = n.indexOf,
        u = {},
        l = u.toString,
        c = u.hasOwnProperty,
        f = {},
        p = "2.2.3",
        d = function (e, t) {
            return new d.fn.init(e, t);
        },
        h = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
        g = /^-ms-/,
        v = /-([\da-z])/gi,
        m = function (e, t) {
            return t.toUpperCase();
        };
    function y(e) {
        var t = !!e && "length" in e && e.length,
            n = d.type(e);
        return "function" !== n && !d.isWindow(e) && ("array" === n || 0 === t || ("number" == typeof t && t > 0 && t - 1 in e));
    }
    (d.fn = d.prototype = {
        jquery: p,
        constructor: d,
        selector: "",
        length: 0,
        toArray: function () {
            return i.call(this);
        },
        get: function (e) {
            return null != e ? (0 > e ? this[e + this.length] : this[e]) : i.call(this);
        },
        pushStack: function (e) {
            var t = d.merge(this.constructor(), e);
            return (t.prevObject = this), (t.context = this.context), t;
        },
        each: function (e) {
            return d.each(this, e);
        },
        map: function (e) {
            return this.pushStack(
                d.map(this, function (t, n) {
                    return e.call(t, n, t);
                })
            );
        },
        slice: function () {
            return this.pushStack(i.apply(this, arguments));
        },
        first: function () {
            return this.eq(0);
        },
        last: function () {
            return this.eq(-1);
        },
        eq: function (e) {
            var t = this.length,
                n = +e + (0 > e ? t : 0);
            return this.pushStack(n >= 0 && t > n ? [this[n]] : []);
        },
        end: function () {
            return this.prevObject || this.constructor();
        },
        push: s,
        sort: n.sort,
        splice: n.splice,
    }),
        (d.extend = d.fn.extend = function () {
            var e,
                t,
                n,
                r,
                i,
                o,
                s = arguments[0] || {},
                a = 1,
                u = arguments.length,
                l = !1;
            for ("boolean" == typeof s && ((l = s), (s = arguments[a] || {}), a++), "object" == typeof s || d.isFunction(s) || (s = {}), a === u && ((s = this), a--); u > a; a++)
                if (null != (e = arguments[a]))
                    for (t in e)
                        (n = s[t]),
                            s !== (r = e[t]) &&
                                (l && r && (d.isPlainObject(r) || (i = d.isArray(r))) ? (i ? ((i = !1), (o = n && d.isArray(n) ? n : [])) : (o = n && d.isPlainObject(n) ? n : {}), (s[t] = d.extend(l, o, r))) : void 0 !== r && (s[t] = r));
            return s;
        }),
        d.extend({
            expando: "jQuery" + (p + Math.random()).replace(/\D/g, ""),
            isReady: !0,
            error: function (e) {
                throw new Error(e);
            },
            noop: function () {},
            isFunction: function (e) {
                return "function" === d.type(e);
            },
            isArray: Array.isArray,
            isWindow: function (e) {
                return null != e && e === e.window;
            },
            isNumeric: function (e) {
                var t = e && e.toString();
                return !d.isArray(e) && t - parseFloat(t) + 1 >= 0;
            },
            isPlainObject: function (e) {
                var t;
                if ("object" !== d.type(e) || e.nodeType || d.isWindow(e)) return !1;
                if (e.constructor && !c.call(e, "constructor") && !c.call(e.constructor.prototype || {}, "isPrototypeOf")) return !1;
                for (t in e);
                return void 0 === t || c.call(e, t);
            },
            isEmptyObject: function (e) {
                var t;
                for (t in e) return !1;
                return !0;
            },
            type: function (e) {
                return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? u[l.call(e)] || "object" : typeof e;
            },
            globalEval: function (e) {
                var t,
                    n = eval;
                (e = d.trim(e)) && (1 === e.indexOf("use strict") ? (((t = r.createElement("script")).text = e), r.head.appendChild(t).parentNode.removeChild(t)) : n(e));
            },
            camelCase: function (e) {
                return e.replace(g, "ms-").replace(v, m);
            },
            nodeName: function (e, t) {
                return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
            },
            each: function (e, t) {
                var n,
                    r = 0;
                if (y(e)) for (n = e.length; n > r && !1 !== t.call(e[r], r, e[r]); r++);
                else for (r in e) if (!1 === t.call(e[r], r, e[r])) break;
                return e;
            },
            trim: function (e) {
                return null == e ? "" : (e + "").replace(h, "");
            },
            makeArray: function (e, t) {
                var n = t || [];
                return null != e && (y(Object(e)) ? d.merge(n, "string" == typeof e ? [e] : e) : s.call(n, e)), n;
            },
            inArray: function (e, t, n) {
                return null == t ? -1 : a.call(t, e, n);
            },
            merge: function (e, t) {
                for (var n = +t.length, r = 0, i = e.length; n > r; r++) e[i++] = t[r];
                return (e.length = i), e;
            },
            grep: function (e, t, n) {
                for (var r = [], i = 0, o = e.length, s = !n; o > i; i++) !t(e[i], i) !== s && r.push(e[i]);
                return r;
            },
            map: function (e, t, n) {
                var r,
                    i,
                    s = 0,
                    a = [];
                if (y(e)) for (r = e.length; r > s; s++) null != (i = t(e[s], s, n)) && a.push(i);
                else for (s in e) null != (i = t(e[s], s, n)) && a.push(i);
                return o.apply([], a);
            },
            guid: 1,
            proxy: function (e, t) {
                var n, r, o;
                return (
                    "string" == typeof t && ((n = e[t]), (t = e), (e = n)),
                    d.isFunction(e)
                        ? ((r = i.call(arguments, 2)),
                          ((o = function () {
                              return e.apply(t || this, r.concat(i.call(arguments)));
                          }).guid = e.guid = e.guid || d.guid++),
                          o)
                        : void 0
                );
            },
            now: Date.now,
            support: f,
        }),
        "function" == typeof Symbol && (d.fn[Symbol.iterator] = n[Symbol.iterator]),
        d.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
            u["[object " + t + "]"] = t.toLowerCase();
        });
    var x = (function (e) {
        var t,
            n,
            r,
            i,
            o,
            s,
            a,
            u,
            l,
            c,
            f,
            p,
            d,
            h,
            g,
            v,
            m,
            y,
            x,
            b = "sizzle" + 1 * new Date(),
            w = e.document,
            T = 0,
            C = 0,
            k = oe(),
            E = oe(),
            N = oe(),
            S = function (e, t) {
                return e === t && (f = !0), 0;
            },
            D = 1 << 31,
            j = {}.hasOwnProperty,
            A = [],
            q = A.pop,
            L = A.push,
            H = A.push,
            O = A.slice,
            F = function (e, t) {
                for (var n = 0, r = e.length; r > n; n++) if (e[n] === t) return n;
                return -1;
            },
            P = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            R = "[\\x20\\t\\r\\n\\f]",
            M = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
            I = "\\[" + R + "*(" + M + ")(?:" + R + "*([*^$|!~]?=)" + R + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + M + "))|)" + R + "*\\]",
            W = ":(" + M + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + I + ")*)|.*)\\)|)",
            $ = new RegExp(R + "+", "g"),
            B = new RegExp("^" + R + "+|((?:^|[^\\\\])(?:\\\\.)*)" + R + "+$", "g"),
            _ = new RegExp("^" + R + "*," + R + "*"),
            X = new RegExp("^" + R + "*([>+~]|" + R + ")" + R + "*"),
            z = new RegExp("=" + R + "*([^\\]'\"]*?)" + R + "*\\]", "g"),
            U = new RegExp(W),
            V = new RegExp("^" + M + "$"),
            Y = {
                ID: new RegExp("^#(" + M + ")"),
                CLASS: new RegExp("^\\.(" + M + ")"),
                TAG: new RegExp("^(" + M + "|[*])"),
                ATTR: new RegExp("^" + I),
                PSEUDO: new RegExp("^" + W),
                CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + R + "*(even|odd|(([+-]|)(\\d*)n|)" + R + "*(?:([+-]|)" + R + "*(\\d+)|))" + R + "*\\)|)", "i"),
                bool: new RegExp("^(?:" + P + ")$", "i"),
                needsContext: new RegExp("^" + R + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + R + "*((?:-\\d)?\\d*)" + R + "*\\)|)(?=[^-]|$)", "i"),
            },
            G = /^(?:input|select|textarea|button)$/i,
            Q = /^h\d$/i,
            J = /^[^{]+\{\s*\[native \w/,
            K = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            Z = /[+~]/,
            ee = /'|\\/g,
            te = new RegExp("\\\\([\\da-f]{1,6}" + R + "?|(" + R + ")|.)", "ig"),
            ne = function (e, t, n) {
                var r = "0x" + t - 65536;
                return r != r || n ? t : 0 > r ? String.fromCharCode(r + 65536) : String.fromCharCode((r >> 10) | 55296, (1023 & r) | 56320);
            },
            re = function () {
                p();
            };
        try {
            H.apply((A = O.call(w.childNodes)), w.childNodes), A[w.childNodes.length].nodeType;
        } catch (e) {
            H = {
                apply: A.length
                    ? function (e, t) {
                          L.apply(e, O.call(t));
                      }
                    : function (e, t) {
                          for (var n = e.length, r = 0; (e[n++] = t[r++]); );
                          e.length = n - 1;
                      },
            };
        }
        function ie(e, t, r, i) {
            var o,
                a,
                l,
                c,
                f,
                h,
                m,
                y,
                T = t && t.ownerDocument,
                C = t ? t.nodeType : 9;
            if (((r = r || []), "string" != typeof e || !e || (1 !== C && 9 !== C && 11 !== C))) return r;
            if (!i && ((t ? t.ownerDocument || t : w) !== d && p(t), (t = t || d), g)) {
                if (11 !== C && (h = K.exec(e)))
                    if ((o = h[1])) {
                        if (9 === C) {
                            if (!(l = t.getElementById(o))) return r;
                            if (l.id === o) return r.push(l), r;
                        } else if (T && (l = T.getElementById(o)) && x(t, l) && l.id === o) return r.push(l), r;
                    } else {
                        if (h[2]) return H.apply(r, t.getElementsByTagName(e)), r;
                        if ((o = h[3]) && n.getElementsByClassName && t.getElementsByClassName) return H.apply(r, t.getElementsByClassName(o)), r;
                    }
                if (n.qsa && !N[e + " "] && (!v || !v.test(e))) {
                    if (1 !== C) (T = t), (y = e);
                    else if ("object" !== t.nodeName.toLowerCase()) {
                        for ((c = t.getAttribute("id")) ? (c = c.replace(ee, "\\$&")) : t.setAttribute("id", (c = b)), a = (m = s(e)).length, f = V.test(c) ? "#" + c : "[id='" + c + "']"; a--; ) m[a] = f + " " + ge(m[a]);
                        (y = m.join(",")), (T = (Z.test(e) && de(t.parentNode)) || t);
                    }
                    if (y)
                        try {
                            return H.apply(r, T.querySelectorAll(y)), r;
                        } catch (e) {
                        } finally {
                            c === b && t.removeAttribute("id");
                        }
                }
            }
            return u(e.replace(B, "$1"), t, r, i);
        }
        function oe() {
            var e = [];
            return function t(n, i) {
                return e.push(n + " ") > r.cacheLength && delete t[e.shift()], (t[n + " "] = i);
            };
        }
        function se(e) {
            return (e[b] = !0), e;
        }
        function ae(e) {
            var t = d.createElement("div");
            try {
                return !!e(t);
            } catch (e) {
                return !1;
            } finally {
                t.parentNode && t.parentNode.removeChild(t), (t = null);
            }
        }
        function ue(e, t) {
            for (var n = e.split("|"), i = n.length; i--; ) r.attrHandle[n[i]] = t;
        }
        function le(e, t) {
            var n = t && e,
                r = n && 1 === e.nodeType && 1 === t.nodeType && (~t.sourceIndex || D) - (~e.sourceIndex || D);
            if (r) return r;
            if (n) for (; (n = n.nextSibling); ) if (n === t) return -1;
            return e ? 1 : -1;
        }
        function ce(e) {
            return function (t) {
                return "input" === t.nodeName.toLowerCase() && t.type === e;
            };
        }
        function fe(e) {
            return function (t) {
                var n = t.nodeName.toLowerCase();
                return ("input" === n || "button" === n) && t.type === e;
            };
        }
        function pe(e) {
            return se(function (t) {
                return (
                    (t = +t),
                    se(function (n, r) {
                        for (var i, o = e([], n.length, t), s = o.length; s--; ) n[(i = o[s])] && (n[i] = !(r[i] = n[i]));
                    })
                );
            });
        }
        function de(e) {
            return e && void 0 !== e.getElementsByTagName && e;
        }
        for (t in ((n = ie.support = {}),
        (o = ie.isXML = function (e) {
            var t = e && (e.ownerDocument || e).documentElement;
            return !!t && "HTML" !== t.nodeName;
        }),
        (p = ie.setDocument = function (e) {
            var t,
                i,
                s = e ? e.ownerDocument || e : w;
            return s !== d && 9 === s.nodeType && s.documentElement
                ? ((h = (d = s).documentElement),
                  (g = !o(d)),
                  (i = d.defaultView) && i.top !== i && (i.addEventListener ? i.addEventListener("unload", re, !1) : i.attachEvent && i.attachEvent("onunload", re)),
                  (n.attributes = ae(function (e) {
                      return (e.className = "i"), !e.getAttribute("className");
                  })),
                  (n.getElementsByTagName = ae(function (e) {
                      return e.appendChild(d.createComment("")), !e.getElementsByTagName("*").length;
                  })),
                  (n.getElementsByClassName = J.test(d.getElementsByClassName)),
                  (n.getById = ae(function (e) {
                      return (h.appendChild(e).id = b), !d.getElementsByName || !d.getElementsByName(b).length;
                  })),
                  n.getById
                      ? ((r.find.ID = function (e, t) {
                            if (void 0 !== t.getElementById && g) {
                                var n = t.getElementById(e);
                                return n ? [n] : [];
                            }
                        }),
                        (r.filter.ID = function (e) {
                            var t = e.replace(te, ne);
                            return function (e) {
                                return e.getAttribute("id") === t;
                            };
                        }))
                      : (delete r.find.ID,
                        (r.filter.ID = function (e) {
                            var t = e.replace(te, ne);
                            return function (e) {
                                var n = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                                return n && n.value === t;
                            };
                        })),
                  (r.find.TAG = n.getElementsByTagName
                      ? function (e, t) {
                            return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : n.qsa ? t.querySelectorAll(e) : void 0;
                        }
                      : function (e, t) {
                            var n,
                                r = [],
                                i = 0,
                                o = t.getElementsByTagName(e);
                            if ("*" === e) {
                                for (; (n = o[i++]); ) 1 === n.nodeType && r.push(n);
                                return r;
                            }
                            return o;
                        }),
                  (r.find.CLASS =
                      n.getElementsByClassName &&
                      function (e, t) {
                          return void 0 !== t.getElementsByClassName && g ? t.getElementsByClassName(e) : void 0;
                      }),
                  (m = []),
                  (v = []),
                  (n.qsa = J.test(d.querySelectorAll)) &&
                      (ae(function (e) {
                          (h.appendChild(e).innerHTML = "<a id='" + b + "'></a><select id='" + b + "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                              e.querySelectorAll("[msallowcapture^='']").length && v.push("[*^$]=" + R + "*(?:''|\"\")"),
                              e.querySelectorAll("[selected]").length || v.push("\\[" + R + "*(?:value|" + P + ")"),
                              e.querySelectorAll("[id~=" + b + "-]").length || v.push("~="),
                              e.querySelectorAll(":checked").length || v.push(":checked"),
                              e.querySelectorAll("a#" + b + "+*").length || v.push(".#.+[+~]");
                      }),
                      ae(function (e) {
                          var t = d.createElement("input");
                          t.setAttribute("type", "hidden"),
                              e.appendChild(t).setAttribute("name", "D"),
                              e.querySelectorAll("[name=d]").length && v.push("name" + R + "*[*^$|!~]?="),
                              e.querySelectorAll(":enabled").length || v.push(":enabled", ":disabled"),
                              e.querySelectorAll("*,:x"),
                              v.push(",.*:");
                      })),
                  (n.matchesSelector = J.test((y = h.matches || h.webkitMatchesSelector || h.mozMatchesSelector || h.oMatchesSelector || h.msMatchesSelector))) &&
                      ae(function (e) {
                          (n.disconnectedMatch = y.call(e, "div")), y.call(e, "[s!='']:x"), m.push("!=", W);
                      }),
                  (v = v.length && new RegExp(v.join("|"))),
                  (m = m.length && new RegExp(m.join("|"))),
                  (t = J.test(h.compareDocumentPosition)),
                  (x =
                      t || J.test(h.contains)
                          ? function (e, t) {
                                var n = 9 === e.nodeType ? e.documentElement : e,
                                    r = t && t.parentNode;
                                return e === r || !(!r || 1 !== r.nodeType || !(n.contains ? n.contains(r) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r)));
                            }
                          : function (e, t) {
                                if (t) for (; (t = t.parentNode); ) if (t === e) return !0;
                                return !1;
                            }),
                  (S = t
                      ? function (e, t) {
                            if (e === t) return (f = !0), 0;
                            var r = !e.compareDocumentPosition - !t.compareDocumentPosition;
                            return (
                                r ||
                                (1 & (r = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || (!n.sortDetached && t.compareDocumentPosition(e) === r)
                                    ? e === d || (e.ownerDocument === w && x(w, e))
                                        ? -1
                                        : t === d || (t.ownerDocument === w && x(w, t))
                                        ? 1
                                        : c
                                        ? F(c, e) - F(c, t)
                                        : 0
                                    : 4 & r
                                    ? -1
                                    : 1)
                            );
                        }
                      : function (e, t) {
                            if (e === t) return (f = !0), 0;
                            var n,
                                r = 0,
                                i = e.parentNode,
                                o = t.parentNode,
                                s = [e],
                                a = [t];
                            if (!i || !o) return e === d ? -1 : t === d ? 1 : i ? -1 : o ? 1 : c ? F(c, e) - F(c, t) : 0;
                            if (i === o) return le(e, t);
                            for (n = e; (n = n.parentNode); ) s.unshift(n);
                            for (n = t; (n = n.parentNode); ) a.unshift(n);
                            for (; s[r] === a[r]; ) r++;
                            return r ? le(s[r], a[r]) : s[r] === w ? -1 : a[r] === w ? 1 : 0;
                        }),
                  d)
                : d;
        }),
        (ie.matches = function (e, t) {
            return ie(e, null, null, t);
        }),
        (ie.matchesSelector = function (e, t) {
            if (((e.ownerDocument || e) !== d && p(e), (t = t.replace(z, "='$1']")), n.matchesSelector && g && !N[t + " "] && (!m || !m.test(t)) && (!v || !v.test(t))))
                try {
                    var r = y.call(e, t);
                    if (r || n.disconnectedMatch || (e.document && 11 !== e.document.nodeType)) return r;
                } catch (e) {}
            return ie(t, d, null, [e]).length > 0;
        }),
        (ie.contains = function (e, t) {
            return (e.ownerDocument || e) !== d && p(e), x(e, t);
        }),
        (ie.attr = function (e, t) {
            (e.ownerDocument || e) !== d && p(e);
            var i = r.attrHandle[t.toLowerCase()],
                o = i && j.call(r.attrHandle, t.toLowerCase()) ? i(e, t, !g) : void 0;
            return void 0 !== o ? o : n.attributes || !g ? e.getAttribute(t) : (o = e.getAttributeNode(t)) && o.specified ? o.value : null;
        }),
        (ie.error = function (e) {
            throw new Error("Syntax error, unrecognized expression: " + e);
        }),
        (ie.uniqueSort = function (e) {
            var t,
                r = [],
                i = 0,
                o = 0;
            if (((f = !n.detectDuplicates), (c = !n.sortStable && e.slice(0)), e.sort(S), f)) {
                for (; (t = e[o++]); ) t === e[o] && (i = r.push(o));
                for (; i--; ) e.splice(r[i], 1);
            }
            return (c = null), e;
        }),
        (i = ie.getText = function (e) {
            var t,
                n = "",
                r = 0,
                o = e.nodeType;
            if (o) {
                if (1 === o || 9 === o || 11 === o) {
                    if ("string" == typeof e.textContent) return e.textContent;
                    for (e = e.firstChild; e; e = e.nextSibling) n += i(e);
                } else if (3 === o || 4 === o) return e.nodeValue;
            } else for (; (t = e[r++]); ) n += i(t);
            return n;
        }),
        ((r = ie.selectors = {
            cacheLength: 50,
            createPseudo: se,
            match: Y,
            attrHandle: {},
            find: {},
            relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } },
            preFilter: {
                ATTR: function (e) {
                    return (e[1] = e[1].replace(te, ne)), (e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne)), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
                },
                CHILD: function (e) {
                    return (
                        (e[1] = e[1].toLowerCase()),
                        "nth" === e[1].slice(0, 3) ? (e[3] || ie.error(e[0]), (e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3]))), (e[5] = +(e[7] + e[8] || "odd" === e[3]))) : e[3] && ie.error(e[0]),
                        e
                    );
                },
                PSEUDO: function (e) {
                    var t,
                        n = !e[6] && e[2];
                    return Y.CHILD.test(e[0])
                        ? null
                        : (e[3] ? (e[2] = e[4] || e[5] || "") : n && U.test(n) && (t = s(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))), e.slice(0, 3));
                },
            },
            filter: {
                TAG: function (e) {
                    var t = e.replace(te, ne).toLowerCase();
                    return "*" === e
                        ? function () {
                              return !0;
                          }
                        : function (e) {
                              return e.nodeName && e.nodeName.toLowerCase() === t;
                          };
                },
                CLASS: function (e) {
                    var t = k[e + " "];
                    return (
                        t ||
                        ((t = new RegExp("(^|" + R + ")" + e + "(" + R + "|$)")) &&
                            k(e, function (e) {
                                return t.test(("string" == typeof e.className && e.className) || (void 0 !== e.getAttribute && e.getAttribute("class")) || "");
                            }))
                    );
                },
                ATTR: function (e, t, n) {
                    return function (r) {
                        var i = ie.attr(r, e);
                        return null == i
                            ? "!=" === t
                            : !t ||
                                  ((i += ""),
                                  "=" === t
                                      ? i === n
                                      : "!=" === t
                                      ? i !== n
                                      : "^=" === t
                                      ? n && 0 === i.indexOf(n)
                                      : "*=" === t
                                      ? n && i.indexOf(n) > -1
                                      : "$=" === t
                                      ? n && i.slice(-n.length) === n
                                      : "~=" === t
                                      ? (" " + i.replace($, " ") + " ").indexOf(n) > -1
                                      : "|=" === t && (i === n || i.slice(0, n.length + 1) === n + "-"));
                    };
                },
                CHILD: function (e, t, n, r, i) {
                    var o = "nth" !== e.slice(0, 3),
                        s = "last" !== e.slice(-4),
                        a = "of-type" === t;
                    return 1 === r && 0 === i
                        ? function (e) {
                              return !!e.parentNode;
                          }
                        : function (t, n, u) {
                              var l,
                                  c,
                                  f,
                                  p,
                                  d,
                                  h,
                                  g = o !== s ? "nextSibling" : "previousSibling",
                                  v = t.parentNode,
                                  m = a && t.nodeName.toLowerCase(),
                                  y = !u && !a,
                                  x = !1;
                              if (v) {
                                  if (o) {
                                      for (; g; ) {
                                          for (p = t; (p = p[g]); ) if (a ? p.nodeName.toLowerCase() === m : 1 === p.nodeType) return !1;
                                          h = g = "only" === e && !h && "nextSibling";
                                      }
                                      return !0;
                                  }
                                  if (((h = [s ? v.firstChild : v.lastChild]), s && y)) {
                                      for (
                                          x = (d = (l = (c = (f = (p = v)[b] || (p[b] = {}))[p.uniqueID] || (f[p.uniqueID] = {}))[e] || [])[0] === T && l[1]) && l[2], p = d && v.childNodes[d];
                                          (p = (++d && p && p[g]) || (x = d = 0) || h.pop());

                                      )
                                          if (1 === p.nodeType && ++x && p === t) {
                                              c[e] = [T, d, x];
                                              break;
                                          }
                                  } else if ((y && (x = d = (l = (c = (f = (p = t)[b] || (p[b] = {}))[p.uniqueID] || (f[p.uniqueID] = {}))[e] || [])[0] === T && l[1]), !1 === x))
                                      for (
                                          ;
                                          (p = (++d && p && p[g]) || (x = d = 0) || h.pop()) &&
                                          ((a ? p.nodeName.toLowerCase() !== m : 1 !== p.nodeType) || !++x || (y && ((c = (f = p[b] || (p[b] = {}))[p.uniqueID] || (f[p.uniqueID] = {}))[e] = [T, x]), p !== t));

                                      );
                                  return (x -= i) === r || (x % r == 0 && x / r >= 0);
                              }
                          };
                },
                PSEUDO: function (e, t) {
                    var n,
                        i = r.pseudos[e] || r.setFilters[e.toLowerCase()] || ie.error("unsupported pseudo: " + e);
                    return i[b]
                        ? i(t)
                        : i.length > 1
                        ? ((n = [e, e, "", t]),
                          r.setFilters.hasOwnProperty(e.toLowerCase())
                              ? se(function (e, n) {
                                    for (var r, o = i(e, t), s = o.length; s--; ) e[(r = F(e, o[s]))] = !(n[r] = o[s]);
                                })
                              : function (e) {
                                    return i(e, 0, n);
                                })
                        : i;
                },
            },
            pseudos: {
                not: se(function (e) {
                    var t = [],
                        n = [],
                        r = a(e.replace(B, "$1"));
                    return r[b]
                        ? se(function (e, t, n, i) {
                              for (var o, s = r(e, null, i, []), a = e.length; a--; ) (o = s[a]) && (e[a] = !(t[a] = o));
                          })
                        : function (e, i, o) {
                              return (t[0] = e), r(t, null, o, n), (t[0] = null), !n.pop();
                          };
                }),
                has: se(function (e) {
                    return function (t) {
                        return ie(e, t).length > 0;
                    };
                }),
                contains: se(function (e) {
                    return (
                        (e = e.replace(te, ne)),
                        function (t) {
                            return (t.textContent || t.innerText || i(t)).indexOf(e) > -1;
                        }
                    );
                }),
                lang: se(function (e) {
                    return (
                        V.test(e || "") || ie.error("unsupported lang: " + e),
                        (e = e.replace(te, ne).toLowerCase()),
                        function (t) {
                            var n;
                            do {
                                if ((n = g ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang"))) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-");
                            } while ((t = t.parentNode) && 1 === t.nodeType);
                            return !1;
                        }
                    );
                }),
                target: function (t) {
                    var n = e.location && e.location.hash;
                    return n && n.slice(1) === t.id;
                },
                root: function (e) {
                    return e === h;
                },
                focus: function (e) {
                    return e === d.activeElement && (!d.hasFocus || d.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
                },
                enabled: function (e) {
                    return !1 === e.disabled;
                },
                disabled: function (e) {
                    return !0 === e.disabled;
                },
                checked: function (e) {
                    var t = e.nodeName.toLowerCase();
                    return ("input" === t && !!e.checked) || ("option" === t && !!e.selected);
                },
                selected: function (e) {
                    return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
                },
                empty: function (e) {
                    for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
                    return !0;
                },
                parent: function (e) {
                    return !r.pseudos.empty(e);
                },
                header: function (e) {
                    return Q.test(e.nodeName);
                },
                input: function (e) {
                    return G.test(e.nodeName);
                },
                button: function (e) {
                    var t = e.nodeName.toLowerCase();
                    return ("input" === t && "button" === e.type) || "button" === t;
                },
                text: function (e) {
                    var t;
                    return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
                },
                first: pe(function () {
                    return [0];
                }),
                last: pe(function (e, t) {
                    return [t - 1];
                }),
                eq: pe(function (e, t, n) {
                    return [0 > n ? n + t : n];
                }),
                even: pe(function (e, t) {
                    for (var n = 0; t > n; n += 2) e.push(n);
                    return e;
                }),
                odd: pe(function (e, t) {
                    for (var n = 1; t > n; n += 2) e.push(n);
                    return e;
                }),
                lt: pe(function (e, t, n) {
                    for (var r = 0 > n ? n + t : n; --r >= 0; ) e.push(r);
                    return e;
                }),
                gt: pe(function (e, t, n) {
                    for (var r = 0 > n ? n + t : n; ++r < t; ) e.push(r);
                    return e;
                }),
            },
        }).pseudos.nth = r.pseudos.eq),
        { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
            r.pseudos[t] = ce(t);
        for (t in { submit: !0, reset: !0 }) r.pseudos[t] = fe(t);
        function he() {}
        function ge(e) {
            for (var t = 0, n = e.length, r = ""; n > t; t++) r += e[t].value;
            return r;
        }
        function ve(e, t, n) {
            var r = t.dir,
                i = n && "parentNode" === r,
                o = C++;
            return t.first
                ? function (t, n, o) {
                      for (; (t = t[r]); ) if (1 === t.nodeType || i) return e(t, n, o);
                  }
                : function (t, n, s) {
                      var a,
                          u,
                          l,
                          c = [T, o];
                      if (s) {
                          for (; (t = t[r]); ) if ((1 === t.nodeType || i) && e(t, n, s)) return !0;
                      } else
                          for (; (t = t[r]); )
                              if (1 === t.nodeType || i) {
                                  if ((a = (u = (l = t[b] || (t[b] = {}))[t.uniqueID] || (l[t.uniqueID] = {}))[r]) && a[0] === T && a[1] === o) return (c[2] = a[2]);
                                  if (((u[r] = c), (c[2] = e(t, n, s)))) return !0;
                              }
                  };
        }
        function me(e) {
            return e.length > 1
                ? function (t, n, r) {
                      for (var i = e.length; i--; ) if (!e[i](t, n, r)) return !1;
                      return !0;
                  }
                : e[0];
        }
        function ye(e, t, n, r, i) {
            for (var o, s = [], a = 0, u = e.length, l = null != t; u > a; a++) (o = e[a]) && ((n && !n(o, r, i)) || (s.push(o), l && t.push(a)));
            return s;
        }
        function xe(e, t, n, r, i, o) {
            return (
                r && !r[b] && (r = xe(r)),
                i && !i[b] && (i = xe(i, o)),
                se(function (o, s, a, u) {
                    var l,
                        c,
                        f,
                        p = [],
                        d = [],
                        h = s.length,
                        g =
                            o ||
                            (function (e, t, n) {
                                for (var r = 0, i = t.length; i > r; r++) ie(e, t[r], n);
                                return n;
                            })(t || "*", a.nodeType ? [a] : a, []),
                        v = !e || (!o && t) ? g : ye(g, p, e, a, u),
                        m = n ? (i || (o ? e : h || r) ? [] : s) : v;
                    if ((n && n(v, m, a, u), r)) for (l = ye(m, d), r(l, [], a, u), c = l.length; c--; ) (f = l[c]) && (m[d[c]] = !(v[d[c]] = f));
                    if (o) {
                        if (i || e) {
                            if (i) {
                                for (l = [], c = m.length; c--; ) (f = m[c]) && l.push((v[c] = f));
                                i(null, (m = []), l, u);
                            }
                            for (c = m.length; c--; ) (f = m[c]) && (l = i ? F(o, f) : p[c]) > -1 && (o[l] = !(s[l] = f));
                        }
                    } else (m = ye(m === s ? m.splice(h, m.length) : m)), i ? i(null, s, m, u) : H.apply(s, m);
                })
            );
        }
        function be(e) {
            for (
                var t,
                    n,
                    i,
                    o = e.length,
                    s = r.relative[e[0].type],
                    a = s || r.relative[" "],
                    u = s ? 1 : 0,
                    c = ve(
                        function (e) {
                            return e === t;
                        },
                        a,
                        !0
                    ),
                    f = ve(
                        function (e) {
                            return F(t, e) > -1;
                        },
                        a,
                        !0
                    ),
                    p = [
                        function (e, n, r) {
                            var i = (!s && (r || n !== l)) || ((t = n).nodeType ? c(e, n, r) : f(e, n, r));
                            return (t = null), i;
                        },
                    ];
                o > u;
                u++
            )
                if ((n = r.relative[e[u].type])) p = [ve(me(p), n)];
                else {
                    if ((n = r.filter[e[u].type].apply(null, e[u].matches))[b]) {
                        for (i = ++u; o > i && !r.relative[e[i].type]; i++);
                        return xe(u > 1 && me(p), u > 1 && ge(e.slice(0, u - 1).concat({ value: " " === e[u - 2].type ? "*" : "" })).replace(B, "$1"), n, i > u && be(e.slice(u, i)), o > i && be((e = e.slice(i))), o > i && ge(e));
                    }
                    p.push(n);
                }
            return me(p);
        }
        return (
            (he.prototype = r.filters = r.pseudos),
            (r.setFilters = new he()),
            (s = ie.tokenize = function (e, t) {
                var n,
                    i,
                    o,
                    s,
                    a,
                    u,
                    l,
                    c = E[e + " "];
                if (c) return t ? 0 : c.slice(0);
                for (a = e, u = [], l = r.preFilter; a; ) {
                    for (s in ((n && !(i = _.exec(a))) || (i && (a = a.slice(i[0].length) || a), u.push((o = []))),
                    (n = !1),
                    (i = X.exec(a)) && ((n = i.shift()), o.push({ value: n, type: i[0].replace(B, " ") }), (a = a.slice(n.length))),
                    r.filter))
                        !(i = Y[s].exec(a)) || (l[s] && !(i = l[s](i))) || ((n = i.shift()), o.push({ value: n, type: s, matches: i }), (a = a.slice(n.length)));
                    if (!n) break;
                }
                return t ? a.length : a ? ie.error(e) : E(e, u).slice(0);
            }),
            (a = ie.compile = function (e, t) {
                var n,
                    i,
                    o,
                    a,
                    u,
                    c,
                    f = [],
                    h = [],
                    v = N[e + " "];
                if (!v) {
                    for (t || (t = s(e)), n = t.length; n--; ) (v = be(t[n]))[b] ? f.push(v) : h.push(v);
                    (v = N(
                        e,
                        ((i = h),
                        (a = (o = f).length > 0),
                        (u = i.length > 0),
                        (c = function (e, t, n, s, c) {
                            var f,
                                h,
                                v,
                                m = 0,
                                y = "0",
                                x = e && [],
                                b = [],
                                w = l,
                                C = e || (u && r.find.TAG("*", c)),
                                k = (T += null == w ? 1 : Math.random() || 0.1),
                                E = C.length;
                            for (c && (l = t === d || t || c); y !== E && null != (f = C[y]); y++) {
                                if (u && f) {
                                    for (h = 0, t || f.ownerDocument === d || (p(f), (n = !g)); (v = i[h++]); )
                                        if (v(f, t || d, n)) {
                                            s.push(f);
                                            break;
                                        }
                                    c && (T = k);
                                }
                                a && ((f = !v && f) && m--, e && x.push(f));
                            }
                            if (((m += y), a && y !== m)) {
                                for (h = 0; (v = o[h++]); ) v(x, b, t, n);
                                if (e) {
                                    if (m > 0) for (; y--; ) x[y] || b[y] || (b[y] = q.call(s));
                                    b = ye(b);
                                }
                                H.apply(s, b), c && !e && b.length > 0 && m + o.length > 1 && ie.uniqueSort(s);
                            }
                            return c && ((T = k), (l = w)), x;
                        }),
                        a ? se(c) : c)
                    )).selector = e;
                }
                return v;
            }),
            (u = ie.select = function (e, t, i, o) {
                var u,
                    l,
                    c,
                    f,
                    p,
                    d = "function" == typeof e && e,
                    h = !o && s((e = d.selector || e));
                if (((i = i || []), 1 === h.length)) {
                    if ((l = h[0] = h[0].slice(0)).length > 2 && "ID" === (c = l[0]).type && n.getById && 9 === t.nodeType && g && r.relative[l[1].type]) {
                        if (!(t = (r.find.ID(c.matches[0].replace(te, ne), t) || [])[0])) return i;
                        d && (t = t.parentNode), (e = e.slice(l.shift().value.length));
                    }
                    for (u = Y.needsContext.test(e) ? 0 : l.length; u-- && ((c = l[u]), !r.relative[(f = c.type)]); )
                        if ((p = r.find[f]) && (o = p(c.matches[0].replace(te, ne), (Z.test(l[0].type) && de(t.parentNode)) || t))) {
                            if ((l.splice(u, 1), !(e = o.length && ge(l)))) return H.apply(i, o), i;
                            break;
                        }
                }
                return (d || a(e, h))(o, t, !g, i, !t || (Z.test(e) && de(t.parentNode)) || t), i;
            }),
            (n.sortStable = b.split("").sort(S).join("") === b),
            (n.detectDuplicates = !!f),
            p(),
            (n.sortDetached = ae(function (e) {
                return 1 & e.compareDocumentPosition(d.createElement("div"));
            })),
            ae(function (e) {
                return (e.innerHTML = "<a href='#'></a>"), "#" === e.firstChild.getAttribute("href");
            }) ||
                ue("type|href|height|width", function (e, t, n) {
                    return n ? void 0 : e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
                }),
            (n.attributes &&
                ae(function (e) {
                    return (e.innerHTML = "<input/>"), e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
                })) ||
                ue("value", function (e, t, n) {
                    return n || "input" !== e.nodeName.toLowerCase() ? void 0 : e.defaultValue;
                }),
            ae(function (e) {
                return null == e.getAttribute("disabled");
            }) ||
                ue(P, function (e, t, n) {
                    var r;
                    return n ? void 0 : !0 === e[t] ? t.toLowerCase() : (r = e.getAttributeNode(t)) && r.specified ? r.value : null;
                }),
            ie
        );
    })(e);
    (d.find = x), (d.expr = x.selectors), (d.expr[":"] = d.expr.pseudos), (d.uniqueSort = d.unique = x.uniqueSort), (d.text = x.getText), (d.isXMLDoc = x.isXML), (d.contains = x.contains);
    var b = function (e, t, n) {
            for (var r = [], i = void 0 !== n; (e = e[t]) && 9 !== e.nodeType; )
                if (1 === e.nodeType) {
                    if (i && d(e).is(n)) break;
                    r.push(e);
                }
            return r;
        },
        w = function (e, t) {
            for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
            return n;
        },
        T = d.expr.match.needsContext,
        C = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,
        k = /^.[^:#\[\.,]*$/;
    function E(e, t, n) {
        if (d.isFunction(t))
            return d.grep(e, function (e, r) {
                return !!t.call(e, r, e) !== n;
            });
        if (t.nodeType)
            return d.grep(e, function (e) {
                return (e === t) !== n;
            });
        if ("string" == typeof t) {
            if (k.test(t)) return d.filter(t, e, n);
            t = d.filter(t, e);
        }
        return d.grep(e, function (e) {
            return a.call(t, e) > -1 !== n;
        });
    }
    (d.filter = function (e, t, n) {
        var r = t[0];
        return (
            n && (e = ":not(" + e + ")"),
            1 === t.length && 1 === r.nodeType
                ? d.find.matchesSelector(r, e)
                    ? [r]
                    : []
                : d.find.matches(
                      e,
                      d.grep(t, function (e) {
                          return 1 === e.nodeType;
                      })
                  )
        );
    }),
        d.fn.extend({
            find: function (e) {
                var t,
                    n = this.length,
                    r = [],
                    i = this;
                if ("string" != typeof e)
                    return this.pushStack(
                        d(e).filter(function () {
                            for (t = 0; n > t; t++) if (d.contains(i[t], this)) return !0;
                        })
                    );
                for (t = 0; n > t; t++) d.find(e, i[t], r);
                return ((r = this.pushStack(n > 1 ? d.unique(r) : r)).selector = this.selector ? this.selector + " " + e : e), r;
            },
            filter: function (e) {
                return this.pushStack(E(this, e || [], !1));
            },
            not: function (e) {
                return this.pushStack(E(this, e || [], !0));
            },
            is: function (e) {
                return !!E(this, "string" == typeof e && T.test(e) ? d(e) : e || [], !1).length;
            },
        });
    var N,
        S = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/;
    ((d.fn.init = function (e, t, n) {
        var i, o;
        if (!e) return this;
        if (((n = n || N), "string" == typeof e)) {
            if (!(i = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : S.exec(e)) || (!i[1] && t)) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
            if (i[1]) {
                if (((t = t instanceof d ? t[0] : t), d.merge(this, d.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : r, !0)), C.test(i[1]) && d.isPlainObject(t)))
                    for (i in t) d.isFunction(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
                return this;
            }
            return (o = r.getElementById(i[2])) && o.parentNode && ((this.length = 1), (this[0] = o)), (this.context = r), (this.selector = e), this;
        }
        return e.nodeType
            ? ((this.context = this[0] = e), (this.length = 1), this)
            : d.isFunction(e)
            ? void 0 !== n.ready
                ? n.ready(e)
                : e(d)
            : (void 0 !== e.selector && ((this.selector = e.selector), (this.context = e.context)), d.makeArray(e, this));
    }).prototype = d.fn),
        (N = d(r));
    var D = /^(?:parents|prev(?:Until|All))/,
        j = { children: !0, contents: !0, next: !0, prev: !0 };
    function A(e, t) {
        for (; (e = e[t]) && 1 !== e.nodeType; );
        return e;
    }
    d.fn.extend({
        has: function (e) {
            var t = d(e, this),
                n = t.length;
            return this.filter(function () {
                for (var e = 0; n > e; e++) if (d.contains(this, t[e])) return !0;
            });
        },
        closest: function (e, t) {
            for (var n, r = 0, i = this.length, o = [], s = T.test(e) || "string" != typeof e ? d(e, t || this.context) : 0; i > r; r++)
                for (n = this[r]; n && n !== t; n = n.parentNode)
                    if (n.nodeType < 11 && (s ? s.index(n) > -1 : 1 === n.nodeType && d.find.matchesSelector(n, e))) {
                        o.push(n);
                        break;
                    }
            return this.pushStack(o.length > 1 ? d.uniqueSort(o) : o);
        },
        index: function (e) {
            return e ? ("string" == typeof e ? a.call(d(e), this[0]) : a.call(this, e.jquery ? e[0] : e)) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
        },
        add: function (e, t) {
            return this.pushStack(d.uniqueSort(d.merge(this.get(), d(e, t))));
        },
        addBack: function (e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
        },
    }),
        d.each(
            {
                parent: function (e) {
                    var t = e.parentNode;
                    return t && 11 !== t.nodeType ? t : null;
                },
                parents: function (e) {
                    return b(e, "parentNode");
                },
                parentsUntil: function (e, t, n) {
                    return b(e, "parentNode", n);
                },
                next: function (e) {
                    return A(e, "nextSibling");
                },
                prev: function (e) {
                    return A(e, "previousSibling");
                },
                nextAll: function (e) {
                    return b(e, "nextSibling");
                },
                prevAll: function (e) {
                    return b(e, "previousSibling");
                },
                nextUntil: function (e, t, n) {
                    return b(e, "nextSibling", n);
                },
                prevUntil: function (e, t, n) {
                    return b(e, "previousSibling", n);
                },
                siblings: function (e) {
                    return w((e.parentNode || {}).firstChild, e);
                },
                children: function (e) {
                    return w(e.firstChild);
                },
                contents: function (e) {
                    return e.contentDocument || d.merge([], e.childNodes);
                },
            },
            function (e, t) {
                d.fn[e] = function (n, r) {
                    var i = d.map(this, t, n);
                    return "Until" !== e.slice(-5) && (r = n), r && "string" == typeof r && (i = d.filter(r, i)), this.length > 1 && (j[e] || d.uniqueSort(i), D.test(e) && i.reverse()), this.pushStack(i);
                };
            }
        );
    var q,
        L = /\S+/g;
    function H() {
        r.removeEventListener("DOMContentLoaded", H), e.removeEventListener("load", H), d.ready();
    }
    (d.Callbacks = function (e) {
        var t, n;
        e =
            "string" == typeof e
                ? ((t = e),
                  (n = {}),
                  d.each(t.match(L) || [], function (e, t) {
                      n[t] = !0;
                  }),
                  n)
                : d.extend({}, e);
        var r,
            i,
            o,
            s,
            a = [],
            u = [],
            l = -1,
            c = function () {
                for (s = e.once, o = r = !0; u.length; l = -1) for (i = u.shift(); ++l < a.length; ) !1 === a[l].apply(i[0], i[1]) && e.stopOnFalse && ((l = a.length), (i = !1));
                e.memory || (i = !1), (r = !1), s && (a = i ? [] : "");
            },
            f = {
                add: function () {
                    return (
                        a &&
                            (i && !r && ((l = a.length - 1), u.push(i)),
                            (function t(n) {
                                d.each(n, function (n, r) {
                                    d.isFunction(r) ? (e.unique && f.has(r)) || a.push(r) : r && r.length && "string" !== d.type(r) && t(r);
                                });
                            })(arguments),
                            i && !r && c()),
                        this
                    );
                },
                remove: function () {
                    return (
                        d.each(arguments, function (e, t) {
                            for (var n; (n = d.inArray(t, a, n)) > -1; ) a.splice(n, 1), l >= n && l--;
                        }),
                        this
                    );
                },
                has: function (e) {
                    return e ? d.inArray(e, a) > -1 : a.length > 0;
                },
                empty: function () {
                    return a && (a = []), this;
                },
                disable: function () {
                    return (s = u = []), (a = i = ""), this;
                },
                disabled: function () {
                    return !a;
                },
                lock: function () {
                    return (s = u = []), i || (a = i = ""), this;
                },
                locked: function () {
                    return !!s;
                },
                fireWith: function (e, t) {
                    return s || ((t = [e, (t = t || []).slice ? t.slice() : t]), u.push(t), r || c()), this;
                },
                fire: function () {
                    return f.fireWith(this, arguments), this;
                },
                fired: function () {
                    return !!o;
                },
            };
        return f;
    }),
        d.extend({
            Deferred: function (e) {
                var t = [
                        ["resolve", "done", d.Callbacks("once memory"), "resolved"],
                        ["reject", "fail", d.Callbacks("once memory"), "rejected"],
                        ["notify", "progress", d.Callbacks("memory")],
                    ],
                    n = "pending",
                    r = {
                        state: function () {
                            return n;
                        },
                        always: function () {
                            return i.done(arguments).fail(arguments), this;
                        },
                        then: function () {
                            var e = arguments;
                            return d
                                .Deferred(function (n) {
                                    d.each(t, function (t, o) {
                                        var s = d.isFunction(e[t]) && e[t];
                                        i[o[1]](function () {
                                            var e = s && s.apply(this, arguments);
                                            e && d.isFunction(e.promise) ? e.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[o[0] + "With"](this === r ? n.promise() : this, s ? [e] : arguments);
                                        });
                                    }),
                                        (e = null);
                                })
                                .promise();
                        },
                        promise: function (e) {
                            return null != e ? d.extend(e, r) : r;
                        },
                    },
                    i = {};
                return (
                    (r.pipe = r.then),
                    d.each(t, function (e, o) {
                        var s = o[2],
                            a = o[3];
                        (r[o[1]] = s.add),
                            a &&
                                s.add(
                                    function () {
                                        n = a;
                                    },
                                    t[1 ^ e][2].disable,
                                    t[2][2].lock
                                ),
                            (i[o[0]] = function () {
                                return i[o[0] + "With"](this === i ? r : this, arguments), this;
                            }),
                            (i[o[0] + "With"] = s.fireWith);
                    }),
                    r.promise(i),
                    e && e.call(i, i),
                    i
                );
            },
            when: function (e) {
                var t,
                    n,
                    r,
                    o = 0,
                    s = i.call(arguments),
                    a = s.length,
                    u = 1 !== a || (e && d.isFunction(e.promise)) ? a : 0,
                    l = 1 === u ? e : d.Deferred(),
                    c = function (e, n, r) {
                        return function (o) {
                            (n[e] = this), (r[e] = arguments.length > 1 ? i.call(arguments) : o), r === t ? l.notifyWith(n, r) : --u || l.resolveWith(n, r);
                        };
                    };
                if (a > 1) for (t = new Array(a), n = new Array(a), r = new Array(a); a > o; o++) s[o] && d.isFunction(s[o].promise) ? s[o].promise().progress(c(o, n, t)).done(c(o, r, s)).fail(l.reject) : --u;
                return u || l.resolveWith(r, s), l.promise();
            },
        }),
        (d.fn.ready = function (e) {
            return d.ready.promise().done(e), this;
        }),
        d.extend({
            isReady: !1,
            readyWait: 1,
            holdReady: function (e) {
                e ? d.readyWait++ : d.ready(!0);
            },
            ready: function (e) {
                (!0 === e ? --d.readyWait : d.isReady) || ((d.isReady = !0), (!0 !== e && --d.readyWait > 0) || (q.resolveWith(r, [d]), d.fn.triggerHandler && (d(r).triggerHandler("ready"), d(r).off("ready"))));
            },
        }),
        (d.ready.promise = function (t) {
            return (
                q || ((q = d.Deferred()), "complete" === r.readyState || ("loading" !== r.readyState && !r.documentElement.doScroll) ? e.setTimeout(d.ready) : (r.addEventListener("DOMContentLoaded", H), e.addEventListener("load", H))),
                q.promise(t)
            );
        }),
        d.ready.promise();
    var O = function (e, t, n, r, i, o, s) {
            var a = 0,
                u = e.length,
                l = null == n;
            if ("object" === d.type(n)) for (a in ((i = !0), n)) O(e, t, a, n[a], !0, o, s);
            else if (
                void 0 !== r &&
                ((i = !0),
                d.isFunction(r) || (s = !0),
                l &&
                    (s
                        ? (t.call(e, r), (t = null))
                        : ((l = t),
                          (t = function (e, t, n) {
                              return l.call(d(e), n);
                          }))),
                t)
            )
                for (; u > a; a++) t(e[a], n, s ? r : r.call(e[a], a, t(e[a], n)));
            return i ? e : l ? t.call(e) : u ? t(e[0], n) : o;
        },
        F = function (e) {
            return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
        };
    function P() {
        this.expando = d.expando + P.uid++;
    }
    (P.uid = 1),
        (P.prototype = {
            register: function (e, t) {
                var n = t || {};
                return e.nodeType ? (e[this.expando] = n) : Object.defineProperty(e, this.expando, { value: n, writable: !0, configurable: !0 }), e[this.expando];
            },
            cache: function (e) {
                if (!F(e)) return {};
                var t = e[this.expando];
                return t || ((t = {}), F(e) && (e.nodeType ? (e[this.expando] = t) : Object.defineProperty(e, this.expando, { value: t, configurable: !0 }))), t;
            },
            set: function (e, t, n) {
                var r,
                    i = this.cache(e);
                if ("string" == typeof t) i[t] = n;
                else for (r in t) i[r] = t[r];
                return i;
            },
            get: function (e, t) {
                return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][t];
            },
            access: function (e, t, n) {
                var r;
                return void 0 === t || (t && "string" == typeof t && void 0 === n) ? (void 0 !== (r = this.get(e, t)) ? r : this.get(e, d.camelCase(t))) : (this.set(e, t, n), void 0 !== n ? n : t);
            },
            remove: function (e, t) {
                var n,
                    r,
                    i,
                    o = e[this.expando];
                if (void 0 !== o) {
                    if (void 0 === t) this.register(e);
                    else {
                        d.isArray(t) ? (r = t.concat(t.map(d.camelCase))) : ((i = d.camelCase(t)), t in o ? (r = [t, i]) : (r = (r = i) in o ? [r] : r.match(L) || [])), (n = r.length);
                        for (; n--; ) delete o[r[n]];
                    }
                    (void 0 === t || d.isEmptyObject(o)) && (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
                }
            },
            hasData: function (e) {
                var t = e[this.expando];
                return void 0 !== t && !d.isEmptyObject(t);
            },
        });
    var R = new P(),
        M = new P(),
        I = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        W = /[A-Z]/g;
    function $(e, t, n) {
        var r;
        if (void 0 === n && 1 === e.nodeType)
            if (((r = "data-" + t.replace(W, "-$&").toLowerCase()), "string" == typeof (n = e.getAttribute(r)))) {
                try {
                    n = "true" === n || ("false" !== n && ("null" === n ? null : +n + "" === n ? +n : I.test(n) ? d.parseJSON(n) : n));
                } catch (e) {}
                M.set(e, t, n);
            } else n = void 0;
        return n;
    }
    d.extend({
        hasData: function (e) {
            return M.hasData(e) || R.hasData(e);
        },
        data: function (e, t, n) {
            return M.access(e, t, n);
        },
        removeData: function (e, t) {
            M.remove(e, t);
        },
        _data: function (e, t, n) {
            return R.access(e, t, n);
        },
        _removeData: function (e, t) {
            R.remove(e, t);
        },
    }),
        d.fn.extend({
            data: function (e, t) {
                var n,
                    r,
                    i,
                    o = this[0],
                    s = o && o.attributes;
                if (void 0 === e) {
                    if (this.length && ((i = M.get(o)), 1 === o.nodeType && !R.get(o, "hasDataAttrs"))) {
                        for (n = s.length; n--; ) s[n] && 0 === (r = s[n].name).indexOf("data-") && ((r = d.camelCase(r.slice(5))), $(o, r, i[r]));
                        R.set(o, "hasDataAttrs", !0);
                    }
                    return i;
                }
                return "object" == typeof e
                    ? this.each(function () {
                          M.set(this, e);
                      })
                    : O(
                          this,
                          function (t) {
                              var n, r;
                              if (o && void 0 === t) {
                                  if (void 0 !== (n = M.get(o, e) || M.get(o, e.replace(W, "-$&").toLowerCase()))) return n;
                                  if (((r = d.camelCase(e)), void 0 !== (n = M.get(o, r)))) return n;
                                  if (void 0 !== (n = $(o, r, void 0))) return n;
                              } else
                                  (r = d.camelCase(e)),
                                      this.each(function () {
                                          var n = M.get(this, r);
                                          M.set(this, r, t), e.indexOf("-") > -1 && void 0 !== n && M.set(this, e, t);
                                      });
                          },
                          null,
                          t,
                          arguments.length > 1,
                          null,
                          !0
                      );
            },
            removeData: function (e) {
                return this.each(function () {
                    M.remove(this, e);
                });
            },
        }),
        d.extend({
            queue: function (e, t, n) {
                var r;
                return e ? ((t = (t || "fx") + "queue"), (r = R.get(e, t)), n && (!r || d.isArray(n) ? (r = R.access(e, t, d.makeArray(n))) : r.push(n)), r || []) : void 0;
            },
            dequeue: function (e, t) {
                t = t || "fx";
                var n = d.queue(e, t),
                    r = n.length,
                    i = n.shift(),
                    o = d._queueHooks(e, t);
                "inprogress" === i && ((i = n.shift()), r--),
                    i &&
                        ("fx" === t && n.unshift("inprogress"),
                        delete o.stop,
                        i.call(
                            e,
                            function () {
                                d.dequeue(e, t);
                            },
                            o
                        )),
                    !r && o && o.empty.fire();
            },
            _queueHooks: function (e, t) {
                var n = t + "queueHooks";
                return (
                    R.get(e, n) ||
                    R.access(e, n, {
                        empty: d.Callbacks("once memory").add(function () {
                            R.remove(e, [t + "queue", n]);
                        }),
                    })
                );
            },
        }),
        d.fn.extend({
            queue: function (e, t) {
                var n = 2;
                return (
                    "string" != typeof e && ((t = e), (e = "fx"), n--),
                    arguments.length < n
                        ? d.queue(this[0], e)
                        : void 0 === t
                        ? this
                        : this.each(function () {
                              var n = d.queue(this, e, t);
                              d._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && d.dequeue(this, e);
                          })
                );
            },
            dequeue: function (e) {
                return this.each(function () {
                    d.dequeue(this, e);
                });
            },
            clearQueue: function (e) {
                return this.queue(e || "fx", []);
            },
            promise: function (e, t) {
                var n,
                    r = 1,
                    i = d.Deferred(),
                    o = this,
                    s = this.length,
                    a = function () {
                        --r || i.resolveWith(o, [o]);
                    };
                for ("string" != typeof e && ((t = e), (e = void 0)), e = e || "fx"; s--; ) (n = R.get(o[s], e + "queueHooks")) && n.empty && (r++, n.empty.add(a));
                return a(), i.promise(t);
            },
        });
    var B = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        _ = new RegExp("^(?:([+-])=|)(" + B + ")([a-z%]*)$", "i"),
        X = ["Top", "Right", "Bottom", "Left"],
        z = function (e, t) {
            return (e = t || e), "none" === d.css(e, "display") || !d.contains(e.ownerDocument, e);
        };
    function U(e, t, n, r) {
        var i,
            o = 1,
            s = 20,
            a = r
                ? function () {
                      return r.cur();
                  }
                : function () {
                      return d.css(e, t, "");
                  },
            u = a(),
            l = (n && n[3]) || (d.cssNumber[t] ? "" : "px"),
            c = (d.cssNumber[t] || ("px" !== l && +u)) && _.exec(d.css(e, t));
        if (c && c[3] !== l) {
            (l = l || c[3]), (n = n || []), (c = +u || 1);
            do {
                (c /= o = o || ".5"), d.style(e, t, c + l);
            } while (o !== (o = a() / u) && 1 !== o && --s);
        }
        return n && ((c = +c || +u || 0), (i = n[1] ? c + (n[1] + 1) * n[2] : +n[2]), r && ((r.unit = l), (r.start = c), (r.end = i))), i;
    }
    var V = /^(?:checkbox|radio)$/i,
        Y = /<([\w:-]+)/,
        G = /^$|\/(?:java|ecma)script/i,
        Q = {
            option: [1, "<select multiple='multiple'>", "</select>"],
            thead: [1, "<table>", "</table>"],
            col: [2, "<table><colgroup>", "</colgroup></table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
            _default: [0, "", ""],
        };
    function J(e, t) {
        var n = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : [];
        return void 0 === t || (t && d.nodeName(e, t)) ? d.merge([e], n) : n;
    }
    function K(e, t) {
        for (var n = 0, r = e.length; r > n; n++) R.set(e[n], "globalEval", !t || R.get(t[n], "globalEval"));
    }
    (Q.optgroup = Q.option), (Q.tbody = Q.tfoot = Q.colgroup = Q.caption = Q.thead), (Q.th = Q.td);
    var Z,
        ee,
        te = /<|&#?\w+;/;
    function ne(e, t, n, r, i) {
        for (var o, s, a, u, l, c, f = t.createDocumentFragment(), p = [], h = 0, g = e.length; g > h; h++)
            if ((o = e[h]) || 0 === o)
                if ("object" === d.type(o)) d.merge(p, o.nodeType ? [o] : o);
                else if (te.test(o)) {
                    for (s = s || f.appendChild(t.createElement("div")), a = (Y.exec(o) || ["", ""])[1].toLowerCase(), u = Q[a] || Q._default, s.innerHTML = u[1] + d.htmlPrefilter(o) + u[2], c = u[0]; c--; ) s = s.lastChild;
                    d.merge(p, s.childNodes), ((s = f.firstChild).textContent = "");
                } else p.push(t.createTextNode(o));
        for (f.textContent = "", h = 0; (o = p[h++]); )
            if (r && d.inArray(o, r) > -1) i && i.push(o);
            else if (((l = d.contains(o.ownerDocument, o)), (s = J(f.appendChild(o), "script")), l && K(s), n)) for (c = 0; (o = s[c++]); ) G.test(o.type || "") && n.push(o);
        return f;
    }
    (Z = r.createDocumentFragment().appendChild(r.createElement("div"))),
        (ee = r.createElement("input")).setAttribute("type", "radio"),
        ee.setAttribute("checked", "checked"),
        ee.setAttribute("name", "t"),
        Z.appendChild(ee),
        (f.checkClone = Z.cloneNode(!0).cloneNode(!0).lastChild.checked),
        (Z.innerHTML = "<textarea>x</textarea>"),
        (f.noCloneChecked = !!Z.cloneNode(!0).lastChild.defaultValue);
    var re = /^key/,
        ie = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
        oe = /^([^.]*)(?:\.(.+)|)/;
    function se() {
        return !0;
    }
    function ae() {
        return !1;
    }
    function ue() {
        try {
            return r.activeElement;
        } catch (e) {}
    }
    function le(e, t, n, r, i, o) {
        var s, a;
        if ("object" == typeof t) {
            for (a in ("string" != typeof n && ((r = r || n), (n = void 0)), t)) le(e, a, n, r, t[a], o);
            return e;
        }
        if ((null == r && null == i ? ((i = n), (r = n = void 0)) : null == i && ("string" == typeof n ? ((i = r), (r = void 0)) : ((i = r), (r = n), (n = void 0))), !1 === i)) i = ae;
        else if (!i) return e;
        return (
            1 === o &&
                ((s = i),
                ((i = function (e) {
                    return d().off(e), s.apply(this, arguments);
                }).guid = s.guid || (s.guid = d.guid++))),
            e.each(function () {
                d.event.add(this, t, i, r, n);
            })
        );
    }
    (d.event = {
        global: {},
        add: function (e, t, n, r, i) {
            var o,
                s,
                a,
                u,
                l,
                c,
                f,
                p,
                h,
                g,
                v,
                m = R.get(e);
            if (m)
                for (
                    n.handler && ((n = (o = n).handler), (i = o.selector)),
                        n.guid || (n.guid = d.guid++),
                        (u = m.events) || (u = m.events = {}),
                        (s = m.handle) ||
                            (s = m.handle = function (t) {
                                return void 0 !== d && d.event.triggered !== t.type ? d.event.dispatch.apply(e, arguments) : void 0;
                            }),
                        l = (t = (t || "").match(L) || [""]).length;
                    l--;

                )
                    (h = v = (a = oe.exec(t[l]) || [])[1]),
                        (g = (a[2] || "").split(".").sort()),
                        h &&
                            ((f = d.event.special[h] || {}),
                            (h = (i ? f.delegateType : f.bindType) || h),
                            (f = d.event.special[h] || {}),
                            (c = d.extend({ type: h, origType: v, data: r, handler: n, guid: n.guid, selector: i, needsContext: i && d.expr.match.needsContext.test(i), namespace: g.join(".") }, o)),
                            (p = u[h]) || (((p = u[h] = []).delegateCount = 0), (f.setup && !1 !== f.setup.call(e, r, g, s)) || (e.addEventListener && e.addEventListener(h, s))),
                            f.add && (f.add.call(e, c), c.handler.guid || (c.handler.guid = n.guid)),
                            i ? p.splice(p.delegateCount++, 0, c) : p.push(c),
                            (d.event.global[h] = !0));
        },
        remove: function (e, t, n, r, i) {
            var o,
                s,
                a,
                u,
                l,
                c,
                f,
                p,
                h,
                g,
                v,
                m = R.hasData(e) && R.get(e);
            if (m && (u = m.events)) {
                for (l = (t = (t || "").match(L) || [""]).length; l--; )
                    if (((h = v = (a = oe.exec(t[l]) || [])[1]), (g = (a[2] || "").split(".").sort()), h)) {
                        for (f = d.event.special[h] || {}, p = u[(h = (r ? f.delegateType : f.bindType) || h)] || [], a = a[2] && new RegExp("(^|\\.)" + g.join("\\.(?:.*\\.|)") + "(\\.|$)"), s = o = p.length; o--; )
                            (c = p[o]),
                                (!i && v !== c.origType) ||
                                    (n && n.guid !== c.guid) ||
                                    (a && !a.test(c.namespace)) ||
                                    (r && r !== c.selector && ("**" !== r || !c.selector)) ||
                                    (p.splice(o, 1), c.selector && p.delegateCount--, f.remove && f.remove.call(e, c));
                        s && !p.length && ((f.teardown && !1 !== f.teardown.call(e, g, m.handle)) || d.removeEvent(e, h, m.handle), delete u[h]);
                    } else for (h in u) d.event.remove(e, h + t[l], n, r, !0);
                d.isEmptyObject(u) && R.remove(e, "handle events");
            }
        },
        dispatch: function (e) {
            e = d.event.fix(e);
            var t,
                n,
                r,
                o,
                s,
                a = [],
                u = i.call(arguments),
                l = (R.get(this, "events") || {})[e.type] || [],
                c = d.event.special[e.type] || {};
            if (((u[0] = e), (e.delegateTarget = this), !c.preDispatch || !1 !== c.preDispatch.call(this, e))) {
                for (a = d.event.handlers.call(this, e, l), t = 0; (o = a[t++]) && !e.isPropagationStopped(); )
                    for (e.currentTarget = o.elem, n = 0; (s = o.handlers[n++]) && !e.isImmediatePropagationStopped(); )
                        (e.rnamespace && !e.rnamespace.test(s.namespace)) ||
                            ((e.handleObj = s), (e.data = s.data), void 0 !== (r = ((d.event.special[s.origType] || {}).handle || s.handler).apply(o.elem, u)) && !1 === (e.result = r) && (e.preventDefault(), e.stopPropagation()));
                return c.postDispatch && c.postDispatch.call(this, e), e.result;
            }
        },
        handlers: function (e, t) {
            var n,
                r,
                i,
                o,
                s = [],
                a = t.delegateCount,
                u = e.target;
            if (a && u.nodeType && ("click" !== e.type || isNaN(e.button) || e.button < 1))
                for (; u !== this; u = u.parentNode || this)
                    if (1 === u.nodeType && (!0 !== u.disabled || "click" !== e.type)) {
                        for (r = [], n = 0; a > n; n++) void 0 === r[(i = (o = t[n]).selector + " ")] && (r[i] = o.needsContext ? d(i, this).index(u) > -1 : d.find(i, this, null, [u]).length), r[i] && r.push(o);
                        r.length && s.push({ elem: u, handlers: r });
                    }
            return a < t.length && s.push({ elem: this, handlers: t.slice(a) }), s;
        },
        props: "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
        fixHooks: {},
        keyHooks: {
            props: "char charCode key keyCode".split(" "),
            filter: function (e, t) {
                return null == e.which && (e.which = null != t.charCode ? t.charCode : t.keyCode), e;
            },
        },
        mouseHooks: {
            props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
            filter: function (e, t) {
                var n,
                    i,
                    o,
                    s = t.button;
                return (
                    null == e.pageX &&
                        null != t.clientX &&
                        ((i = (n = e.target.ownerDocument || r).documentElement),
                        (o = n.body),
                        (e.pageX = t.clientX + ((i && i.scrollLeft) || (o && o.scrollLeft) || 0) - ((i && i.clientLeft) || (o && o.clientLeft) || 0)),
                        (e.pageY = t.clientY + ((i && i.scrollTop) || (o && o.scrollTop) || 0) - ((i && i.clientTop) || (o && o.clientTop) || 0))),
                    e.which || void 0 === s || (e.which = 1 & s ? 1 : 2 & s ? 3 : 4 & s ? 2 : 0),
                    e
                );
            },
        },
        fix: function (e) {
            if (e[d.expando]) return e;
            var t,
                n,
                i,
                o = e.type,
                s = e,
                a = this.fixHooks[o];
            for (a || (this.fixHooks[o] = a = ie.test(o) ? this.mouseHooks : re.test(o) ? this.keyHooks : {}), i = a.props ? this.props.concat(a.props) : this.props, e = new d.Event(s), t = i.length; t--; ) e[(n = i[t])] = s[n];
            return e.target || (e.target = r), 3 === e.target.nodeType && (e.target = e.target.parentNode), a.filter ? a.filter(e, s) : e;
        },
        special: {
            load: { noBubble: !0 },
            focus: {
                trigger: function () {
                    return this !== ue() && this.focus ? (this.focus(), !1) : void 0;
                },
                delegateType: "focusin",
            },
            blur: {
                trigger: function () {
                    return this === ue() && this.blur ? (this.blur(), !1) : void 0;
                },
                delegateType: "focusout",
            },
            click: {
                trigger: function () {
                    return "checkbox" === this.type && this.click && d.nodeName(this, "input") ? (this.click(), !1) : void 0;
                },
                _default: function (e) {
                    return d.nodeName(e.target, "a");
                },
            },
            beforeunload: {
                postDispatch: function (e) {
                    void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
                },
            },
        },
    }),
        (d.removeEvent = function (e, t, n) {
            e.removeEventListener && e.removeEventListener(t, n);
        }),
        (d.Event = function (e, t) {
            return this instanceof d.Event
                ? (e && e.type ? ((this.originalEvent = e), (this.type = e.type), (this.isDefaultPrevented = e.defaultPrevented || (void 0 === e.defaultPrevented && !1 === e.returnValue) ? se : ae)) : (this.type = e),
                  t && d.extend(this, t),
                  (this.timeStamp = (e && e.timeStamp) || d.now()),
                  void (this[d.expando] = !0))
                : new d.Event(e, t);
        }),
        (d.Event.prototype = {
            constructor: d.Event,
            isDefaultPrevented: ae,
            isPropagationStopped: ae,
            isImmediatePropagationStopped: ae,
            preventDefault: function () {
                var e = this.originalEvent;
                (this.isDefaultPrevented = se), e && e.preventDefault();
            },
            stopPropagation: function () {
                var e = this.originalEvent;
                (this.isPropagationStopped = se), e && e.stopPropagation();
            },
            stopImmediatePropagation: function () {
                var e = this.originalEvent;
                (this.isImmediatePropagationStopped = se), e && e.stopImmediatePropagation(), this.stopPropagation();
            },
        }),
        d.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (e, t) {
            d.event.special[e] = {
                delegateType: t,
                bindType: t,
                handle: function (e) {
                    var n,
                        r = e.relatedTarget,
                        i = e.handleObj;
                    return (r && (r === this || d.contains(this, r))) || ((e.type = i.origType), (n = i.handler.apply(this, arguments)), (e.type = t)), n;
                },
            };
        }),
        d.fn.extend({
            on: function (e, t, n, r) {
                return le(this, e, t, n, r);
            },
            one: function (e, t, n, r) {
                return le(this, e, t, n, r, 1);
            },
            off: function (e, t, n) {
                var r, i;
                if (e && e.preventDefault && e.handleObj) return (r = e.handleObj), d(e.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler), this;
                if ("object" == typeof e) {
                    for (i in e) this.off(i, t, e[i]);
                    return this;
                }
                return (
                    (!1 !== t && "function" != typeof t) || ((n = t), (t = void 0)),
                    !1 === n && (n = ae),
                    this.each(function () {
                        d.event.remove(this, e, n, t);
                    })
                );
            },
        });
    var ce = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
        fe = /<script|<style|<link/i,
        pe = /checked\s*(?:[^=]|=\s*.checked.)/i,
        de = /^true\/(.*)/,
        he = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    function ge(e, t) {
        return d.nodeName(e, "table") && d.nodeName(11 !== t.nodeType ? t : t.firstChild, "tr") ? e.getElementsByTagName("tbody")[0] || e.appendChild(e.ownerDocument.createElement("tbody")) : e;
    }
    function ve(e) {
        return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
    }
    function me(e) {
        var t = de.exec(e.type);
        return t ? (e.type = t[1]) : e.removeAttribute("type"), e;
    }
    function ye(e, t) {
        var n, r, i, o, s, a, u, l;
        if (1 === t.nodeType) {
            if (R.hasData(e) && ((o = R.access(e)), (s = R.set(t, o)), (l = o.events))) for (i in (delete s.handle, (s.events = {}), l)) for (n = 0, r = l[i].length; r > n; n++) d.event.add(t, i, l[i][n]);
            M.hasData(e) && ((a = M.access(e)), (u = d.extend({}, a)), M.set(t, u));
        }
    }
    function xe(e, t, n, r) {
        t = o.apply([], t);
        var i,
            s,
            a,
            u,
            l,
            c,
            p = 0,
            h = e.length,
            g = h - 1,
            v = t[0],
            m = d.isFunction(v);
        if (m || (h > 1 && "string" == typeof v && !f.checkClone && pe.test(v)))
            return e.each(function (i) {
                var o = e.eq(i);
                m && (t[0] = v.call(this, i, o.html())), xe(o, t, n, r);
            });
        if (h && ((s = (i = ne(t, e[0].ownerDocument, !1, e, r)).firstChild), 1 === i.childNodes.length && (i = s), s || r)) {
            for (u = (a = d.map(J(i, "script"), ve)).length; h > p; p++) (l = i), p !== g && ((l = d.clone(l, !0, !0)), u && d.merge(a, J(l, "script"))), n.call(e[p], l, p);
            if (u)
                for (c = a[a.length - 1].ownerDocument, d.map(a, me), p = 0; u > p; p++)
                    (l = a[p]), G.test(l.type || "") && !R.access(l, "globalEval") && d.contains(c, l) && (l.src ? d._evalUrl && d._evalUrl(l.src) : d.globalEval(l.textContent.replace(he, "")));
        }
        return e;
    }
    function be(e, t, n) {
        for (var r, i = t ? d.filter(t, e) : e, o = 0; null != (r = i[o]); o++) n || 1 !== r.nodeType || d.cleanData(J(r)), r.parentNode && (n && d.contains(r.ownerDocument, r) && K(J(r, "script")), r.parentNode.removeChild(r));
        return e;
    }
    d.extend({
        htmlPrefilter: function (e) {
            return e.replace(ce, "<$1></$2>");
        },
        clone: function (e, t, n) {
            var r,
                i,
                o,
                s,
                a,
                u,
                l,
                c = e.cloneNode(!0),
                p = d.contains(e.ownerDocument, e);
            if (!(f.noCloneChecked || (1 !== e.nodeType && 11 !== e.nodeType) || d.isXMLDoc(e)))
                for (s = J(c), r = 0, i = (o = J(e)).length; i > r; r++)
                    (a = o[r]), (u = s[r]), void 0, "input" === (l = u.nodeName.toLowerCase()) && V.test(a.type) ? (u.checked = a.checked) : ("input" !== l && "textarea" !== l) || (u.defaultValue = a.defaultValue);
            if (t)
                if (n) for (o = o || J(e), s = s || J(c), r = 0, i = o.length; i > r; r++) ye(o[r], s[r]);
                else ye(e, c);
            return (s = J(c, "script")).length > 0 && K(s, !p && J(e, "script")), c;
        },
        cleanData: function (e) {
            for (var t, n, r, i = d.event.special, o = 0; void 0 !== (n = e[o]); o++)
                if (F(n)) {
                    if ((t = n[R.expando])) {
                        if (t.events) for (r in t.events) i[r] ? d.event.remove(n, r) : d.removeEvent(n, r, t.handle);
                        n[R.expando] = void 0;
                    }
                    n[M.expando] && (n[M.expando] = void 0);
                }
        },
    }),
        d.fn.extend({
            domManip: xe,
            detach: function (e) {
                return be(this, e, !0);
            },
            remove: function (e) {
                return be(this, e);
            },
            text: function (e) {
                return O(
                    this,
                    function (e) {
                        return void 0 === e
                            ? d.text(this)
                            : this.empty().each(function () {
                                  (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || (this.textContent = e);
                              });
                    },
                    null,
                    e,
                    arguments.length
                );
            },
            append: function () {
                return xe(this, arguments, function (e) {
                    (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || ge(this, e).appendChild(e);
                });
            },
            prepend: function () {
                return xe(this, arguments, function (e) {
                    if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                        var t = ge(this, e);
                        t.insertBefore(e, t.firstChild);
                    }
                });
            },
            before: function () {
                return xe(this, arguments, function (e) {
                    this.parentNode && this.parentNode.insertBefore(e, this);
                });
            },
            after: function () {
                return xe(this, arguments, function (e) {
                    this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
                });
            },
            empty: function () {
                for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (d.cleanData(J(e, !1)), (e.textContent = ""));
                return this;
            },
            clone: function (e, t) {
                return (
                    (e = null != e && e),
                    (t = null == t ? e : t),
                    this.map(function () {
                        return d.clone(this, e, t);
                    })
                );
            },
            html: function (e) {
                return O(
                    this,
                    function (e) {
                        var t = this[0] || {},
                            n = 0,
                            r = this.length;
                        if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                        if ("string" == typeof e && !fe.test(e) && !Q[(Y.exec(e) || ["", ""])[1].toLowerCase()]) {
                            e = d.htmlPrefilter(e);
                            try {
                                for (; r > n; n++) 1 === (t = this[n] || {}).nodeType && (d.cleanData(J(t, !1)), (t.innerHTML = e));
                                t = 0;
                            } catch (e) {}
                        }
                        t && this.empty().append(e);
                    },
                    null,
                    e,
                    arguments.length
                );
            },
            replaceWith: function () {
                var e = [];
                return xe(
                    this,
                    arguments,
                    function (t) {
                        var n = this.parentNode;
                        d.inArray(this, e) < 0 && (d.cleanData(J(this)), n && n.replaceChild(t, this));
                    },
                    e
                );
            },
        }),
        d.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (e, t) {
            d.fn[e] = function (e) {
                for (var n, r = [], i = d(e), o = i.length - 1, a = 0; o >= a; a++) (n = a === o ? this : this.clone(!0)), d(i[a])[t](n), s.apply(r, n.get());
                return this.pushStack(r);
            };
        });
    var we,
        Te = { HTML: "block", BODY: "block" };
    function Ce(e, t) {
        var n = d(t.createElement(e)).appendTo(t.body),
            r = d.css(n[0], "display");
        return n.detach(), r;
    }
    function ke(e) {
        var t = r,
            n = Te[e];
        return (
            n || (("none" !== (n = Ce(e, t)) && n) || ((t = (we = (we || d("<iframe frameborder='0' width='0' height='0'/>")).appendTo(t.documentElement))[0].contentDocument).write(), t.close(), (n = Ce(e, t)), we.detach()), (Te[e] = n)), n
        );
    }
    var Ee = /^margin/,
        Ne = new RegExp("^(" + B + ")(?!px)[a-z%]+$", "i"),
        Se = function (t) {
            var n = t.ownerDocument.defaultView;
            return (n && n.opener) || (n = e), n.getComputedStyle(t);
        },
        De = function (e, t, n, r) {
            var i,
                o,
                s = {};
            for (o in t) (s[o] = e.style[o]), (e.style[o] = t[o]);
            for (o in ((i = n.apply(e, r || [])), t)) e.style[o] = s[o];
            return i;
        },
        je = r.documentElement;
    function Ae(e, t, n) {
        var r,
            i,
            o,
            s,
            a = e.style;
        return (
            ("" !== (s = (n = n || Se(e)) ? n.getPropertyValue(t) || n[t] : void 0) && void 0 !== s) || d.contains(e.ownerDocument, e) || (s = d.style(e, t)),
            n && !f.pixelMarginRight() && Ne.test(s) && Ee.test(t) && ((r = a.width), (i = a.minWidth), (o = a.maxWidth), (a.minWidth = a.maxWidth = a.width = s), (s = n.width), (a.width = r), (a.minWidth = i), (a.maxWidth = o)),
            void 0 !== s ? s + "" : s
        );
    }
    function qe(e, t) {
        return {
            get: function () {
                return e() ? void delete this.get : (this.get = t).apply(this, arguments);
            },
        };
    }
    !(function () {
        var t,
            n,
            i,
            o,
            s = r.createElement("div"),
            a = r.createElement("div");
        if (a.style) {
            function u() {
                (a.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%"), (a.innerHTML = ""), je.appendChild(s);
                var r = e.getComputedStyle(a);
                (t = "1%" !== r.top), (o = "2px" === r.marginLeft), (n = "4px" === r.width), (a.style.marginRight = "50%"), (i = "4px" === r.marginRight), je.removeChild(s);
            }
            (a.style.backgroundClip = "content-box"),
                (a.cloneNode(!0).style.backgroundClip = ""),
                (f.clearCloneStyle = "content-box" === a.style.backgroundClip),
                (s.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute"),
                s.appendChild(a),
                d.extend(f, {
                    pixelPosition: function () {
                        return u(), t;
                    },
                    boxSizingReliable: function () {
                        return null == n && u(), n;
                    },
                    pixelMarginRight: function () {
                        return null == n && u(), i;
                    },
                    reliableMarginLeft: function () {
                        return null == n && u(), o;
                    },
                    reliableMarginRight: function () {
                        var t,
                            n = a.appendChild(r.createElement("div"));
                        return (
                            (n.style.cssText = a.style.cssText = "-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0"),
                            (n.style.marginRight = n.style.width = "0"),
                            (a.style.width = "1px"),
                            je.appendChild(s),
                            (t = !parseFloat(e.getComputedStyle(n).marginRight)),
                            je.removeChild(s),
                            a.removeChild(n),
                            t
                        );
                    },
                });
        }
    })();
    var Le = /^(none|table(?!-c[ea]).+)/,
        He = { position: "absolute", visibility: "hidden", display: "block" },
        Oe = { letterSpacing: "0", fontWeight: "400" },
        Fe = ["Webkit", "O", "Moz", "ms"],
        Pe = r.createElement("div").style;
    function Re(e) {
        if (e in Pe) return e;
        for (var t = e[0].toUpperCase() + e.slice(1), n = Fe.length; n--; ) if ((e = Fe[n] + t) in Pe) return e;
    }
    function Me(e, t, n) {
        var r = _.exec(t);
        return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t;
    }
    function Ie(e, t, n, r, i) {
        for (var o = n === (r ? "border" : "content") ? 4 : "width" === t ? 1 : 0, s = 0; 4 > o; o += 2)
            "margin" === n && (s += d.css(e, n + X[o], !0, i)),
                r
                    ? ("content" === n && (s -= d.css(e, "padding" + X[o], !0, i)), "margin" !== n && (s -= d.css(e, "border" + X[o] + "Width", !0, i)))
                    : ((s += d.css(e, "padding" + X[o], !0, i)), "padding" !== n && (s += d.css(e, "border" + X[o] + "Width", !0, i)));
        return s;
    }
    function We(t, n, i) {
        var o = !0,
            s = "width" === n ? t.offsetWidth : t.offsetHeight,
            a = Se(t),
            u = "border-box" === d.css(t, "boxSizing", !1, a);
        if ((r.msFullscreenElement && e.top !== e && t.getClientRects().length && (s = Math.round(100 * t.getBoundingClientRect()[n])), 0 >= s || null == s)) {
            if (((0 > (s = Ae(t, n, a)) || null == s) && (s = t.style[n]), Ne.test(s))) return s;
            (o = u && (f.boxSizingReliable() || s === t.style[n])), (s = parseFloat(s) || 0);
        }
        return s + Ie(t, n, i || (u ? "border" : "content"), o, a) + "px";
    }
    function $e(e, t) {
        for (var n, r, i, o = [], s = 0, a = e.length; a > s; s++)
            (r = e[s]).style &&
                ((o[s] = R.get(r, "olddisplay")),
                (n = r.style.display),
                t
                    ? (o[s] || "none" !== n || (r.style.display = ""), "" === r.style.display && z(r) && (o[s] = R.access(r, "olddisplay", ke(r.nodeName))))
                    : ((i = z(r)), ("none" === n && i) || R.set(r, "olddisplay", i ? n : d.css(r, "display"))));
        for (s = 0; a > s; s++) (r = e[s]).style && ((t && "none" !== r.style.display && "" !== r.style.display) || (r.style.display = t ? o[s] || "" : "none"));
        return e;
    }
    function Be(e, t, n, r, i) {
        return new Be.prototype.init(e, t, n, r, i);
    }
    d.extend({
        cssHooks: {
            opacity: {
                get: function (e, t) {
                    if (t) {
                        var n = Ae(e, "opacity");
                        return "" === n ? "1" : n;
                    }
                },
            },
        },
        cssNumber: { animationIterationCount: !0, columnCount: !0, fillOpacity: !0, flexGrow: !0, flexShrink: !0, fontWeight: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, widows: !0, zIndex: !0, zoom: !0 },
        cssProps: { float: "cssFloat" },
        style: function (e, t, n, r) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var i,
                    o,
                    s,
                    a = d.camelCase(t),
                    u = e.style;
                return (
                    (t = d.cssProps[a] || (d.cssProps[a] = Re(a) || a)),
                    (s = d.cssHooks[t] || d.cssHooks[a]),
                    void 0 === n
                        ? s && "get" in s && void 0 !== (i = s.get(e, !1, r))
                            ? i
                            : u[t]
                        : ("string" === (o = typeof n) && (i = _.exec(n)) && i[1] && ((n = U(e, t, i)), (o = "number")),
                          void (
                              null != n &&
                              n == n &&
                              ("number" === o && (n += (i && i[3]) || (d.cssNumber[a] ? "" : "px")),
                              f.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (u[t] = "inherit"),
                              (s && "set" in s && void 0 === (n = s.set(e, n, r))) || (u[t] = n))
                          ))
                );
            }
        },
        css: function (e, t, n, r) {
            var i,
                o,
                s,
                a = d.camelCase(t);
            return (
                (t = d.cssProps[a] || (d.cssProps[a] = Re(a) || a)),
                (s = d.cssHooks[t] || d.cssHooks[a]) && "get" in s && (i = s.get(e, !0, n)),
                void 0 === i && (i = Ae(e, t, r)),
                "normal" === i && t in Oe && (i = Oe[t]),
                "" === n || n ? ((o = parseFloat(i)), !0 === n || isFinite(o) ? o || 0 : i) : i
            );
        },
    }),
        d.each(["height", "width"], function (e, t) {
            d.cssHooks[t] = {
                get: function (e, n, r) {
                    return n
                        ? Le.test(d.css(e, "display")) && 0 === e.offsetWidth
                            ? De(e, He, function () {
                                  return We(e, t, r);
                              })
                            : We(e, t, r)
                        : void 0;
                },
                set: function (e, n, r) {
                    var i,
                        o = r && Se(e),
                        s = r && Ie(e, t, r, "border-box" === d.css(e, "boxSizing", !1, o), o);
                    return s && (i = _.exec(n)) && "px" !== (i[3] || "px") && ((e.style[t] = n), (n = d.css(e, t))), Me(0, n, s);
                },
            };
        }),
        (d.cssHooks.marginLeft = qe(f.reliableMarginLeft, function (e, t) {
            return t
                ? (parseFloat(Ae(e, "marginLeft")) ||
                      e.getBoundingClientRect().left -
                          De(e, { marginLeft: 0 }, function () {
                              return e.getBoundingClientRect().left;
                          })) + "px"
                : void 0;
        })),
        (d.cssHooks.marginRight = qe(f.reliableMarginRight, function (e, t) {
            return t ? De(e, { display: "inline-block" }, Ae, [e, "marginRight"]) : void 0;
        })),
        d.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
            (d.cssHooks[e + t] = {
                expand: function (n) {
                    for (var r = 0, i = {}, o = "string" == typeof n ? n.split(" ") : [n]; 4 > r; r++) i[e + X[r] + t] = o[r] || o[r - 2] || o[0];
                    return i;
                },
            }),
                Ee.test(e) || (d.cssHooks[e + t].set = Me);
        }),
        d.fn.extend({
            css: function (e, t) {
                return O(
                    this,
                    function (e, t, n) {
                        var r,
                            i,
                            o = {},
                            s = 0;
                        if (d.isArray(t)) {
                            for (r = Se(e), i = t.length; i > s; s++) o[t[s]] = d.css(e, t[s], !1, r);
                            return o;
                        }
                        return void 0 !== n ? d.style(e, t, n) : d.css(e, t);
                    },
                    e,
                    t,
                    arguments.length > 1
                );
            },
            show: function () {
                return $e(this, !0);
            },
            hide: function () {
                return $e(this);
            },
            toggle: function (e) {
                return "boolean" == typeof e
                    ? e
                        ? this.show()
                        : this.hide()
                    : this.each(function () {
                          z(this) ? d(this).show() : d(this).hide();
                      });
            },
        }),
        (d.Tween = Be),
        (Be.prototype = {
            constructor: Be,
            init: function (e, t, n, r, i, o) {
                (this.elem = e), (this.prop = n), (this.easing = i || d.easing._default), (this.options = t), (this.start = this.now = this.cur()), (this.end = r), (this.unit = o || (d.cssNumber[n] ? "" : "px"));
            },
            cur: function () {
                var e = Be.propHooks[this.prop];
                return e && e.get ? e.get(this) : Be.propHooks._default.get(this);
            },
            run: function (e) {
                var t,
                    n = Be.propHooks[this.prop];
                return (
                    this.options.duration ? (this.pos = t = d.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration)) : (this.pos = t = e),
                    (this.now = (this.end - this.start) * t + this.start),
                    this.options.step && this.options.step.call(this.elem, this.now, this),
                    n && n.set ? n.set(this) : Be.propHooks._default.set(this),
                    this
                );
            },
        }),
        (Be.prototype.init.prototype = Be.prototype),
        (Be.propHooks = {
            _default: {
                get: function (e) {
                    var t;
                    return 1 !== e.elem.nodeType || (null != e.elem[e.prop] && null == e.elem.style[e.prop]) ? e.elem[e.prop] : (t = d.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0;
                },
                set: function (e) {
                    d.fx.step[e.prop] ? d.fx.step[e.prop](e) : 1 !== e.elem.nodeType || (null == e.elem.style[d.cssProps[e.prop]] && !d.cssHooks[e.prop]) ? (e.elem[e.prop] = e.now) : d.style(e.elem, e.prop, e.now + e.unit);
                },
            },
        }),
        (Be.propHooks.scrollTop = Be.propHooks.scrollLeft = {
            set: function (e) {
                e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
            },
        }),
        (d.easing = {
            linear: function (e) {
                return e;
            },
            swing: function (e) {
                return 0.5 - Math.cos(e * Math.PI) / 2;
            },
            _default: "swing",
        }),
        (d.fx = Be.prototype.init),
        (d.fx.step = {});
    var _e,
        Xe,
        ze,
        Ue,
        Ve,
        Ye = /^(?:toggle|show|hide)$/,
        Ge = /queueHooks$/;
    function Qe() {
        return (
            e.setTimeout(function () {
                _e = void 0;
            }),
            (_e = d.now())
        );
    }
    function Je(e, t) {
        var n,
            r = 0,
            i = { height: e };
        for (t = t ? 1 : 0; 4 > r; r += 2 - t) i["margin" + (n = X[r])] = i["padding" + n] = e;
        return t && (i.opacity = i.width = e), i;
    }
    function Ke(e, t, n) {
        for (var r, i = (Ze.tweeners[t] || []).concat(Ze.tweeners["*"]), o = 0, s = i.length; s > o; o++) if ((r = i[o].call(n, t, e))) return r;
    }
    function Ze(e, t, n) {
        var r,
            i,
            o = 0,
            s = Ze.prefilters.length,
            a = d.Deferred().always(function () {
                delete u.elem;
            }),
            u = function () {
                if (i) return !1;
                for (var t = _e || Qe(), n = Math.max(0, l.startTime + l.duration - t), r = 1 - (n / l.duration || 0), o = 0, s = l.tweens.length; s > o; o++) l.tweens[o].run(r);
                return a.notifyWith(e, [l, r, n]), 1 > r && s ? n : (a.resolveWith(e, [l]), !1);
            },
            l = a.promise({
                elem: e,
                props: d.extend({}, t),
                opts: d.extend(!0, { specialEasing: {}, easing: d.easing._default }, n),
                originalProperties: t,
                originalOptions: n,
                startTime: _e || Qe(),
                duration: n.duration,
                tweens: [],
                createTween: function (t, n) {
                    var r = d.Tween(e, l.opts, t, n, l.opts.specialEasing[t] || l.opts.easing);
                    return l.tweens.push(r), r;
                },
                stop: function (t) {
                    var n = 0,
                        r = t ? l.tweens.length : 0;
                    if (i) return this;
                    for (i = !0; r > n; n++) l.tweens[n].run(1);
                    return t ? (a.notifyWith(e, [l, 1, 0]), a.resolveWith(e, [l, t])) : a.rejectWith(e, [l, t]), this;
                },
            }),
            c = l.props;
        for (
            (function (e, t) {
                var n, r, i, o, s;
                for (n in e)
                    if (((i = t[(r = d.camelCase(n))]), (o = e[n]), d.isArray(o) && ((i = o[1]), (o = e[n] = o[0])), n !== r && ((e[r] = o), delete e[n]), (s = d.cssHooks[r]) && ("expand" in s)))
                        for (n in ((o = s.expand(o)), delete e[r], o)) (n in e) || ((e[n] = o[n]), (t[n] = i));
                    else t[r] = i;
            })(c, l.opts.specialEasing);
            s > o;
            o++
        )
            if ((r = Ze.prefilters[o].call(l, e, c, l.opts))) return d.isFunction(r.stop) && (d._queueHooks(l.elem, l.opts.queue).stop = d.proxy(r.stop, r)), r;
        return (
            d.map(c, Ke, l),
            d.isFunction(l.opts.start) && l.opts.start.call(e, l),
            d.fx.timer(d.extend(u, { elem: e, anim: l, queue: l.opts.queue })),
            l.progress(l.opts.progress).done(l.opts.done, l.opts.complete).fail(l.opts.fail).always(l.opts.always)
        );
    }
    (d.Animation = d.extend(Ze, {
        tweeners: {
            "*": [
                function (e, t) {
                    var n = this.createTween(e, t);
                    return U(n.elem, e, _.exec(t), n), n;
                },
            ],
        },
        tweener: function (e, t) {
            d.isFunction(e) ? ((t = e), (e = ["*"])) : (e = e.match(L));
            for (var n, r = 0, i = e.length; i > r; r++) (n = e[r]), (Ze.tweeners[n] = Ze.tweeners[n] || []), Ze.tweeners[n].unshift(t);
        },
        prefilters: [
            function (e, t, n) {
                var r,
                    i,
                    o,
                    s,
                    a,
                    u,
                    l,
                    c = this,
                    f = {},
                    p = e.style,
                    h = e.nodeType && z(e),
                    g = R.get(e, "fxshow");
                for (r in (n.queue ||
                    (null == (a = d._queueHooks(e, "fx")).unqueued &&
                        ((a.unqueued = 0),
                        (u = a.empty.fire),
                        (a.empty.fire = function () {
                            a.unqueued || u();
                        })),
                    a.unqueued++,
                    c.always(function () {
                        c.always(function () {
                            a.unqueued--, d.queue(e, "fx").length || a.empty.fire();
                        });
                    })),
                1 === e.nodeType &&
                    ("height" in t || "width" in t) &&
                    ((n.overflow = [p.overflow, p.overflowX, p.overflowY]), "inline" === ("none" === (l = d.css(e, "display")) ? R.get(e, "olddisplay") || ke(e.nodeName) : l) && "none" === d.css(e, "float") && (p.display = "inline-block")),
                n.overflow &&
                    ((p.overflow = "hidden"),
                    c.always(function () {
                        (p.overflow = n.overflow[0]), (p.overflowX = n.overflow[1]), (p.overflowY = n.overflow[2]);
                    })),
                t))
                    if (((i = t[r]), Ye.exec(i))) {
                        if ((delete t[r], (o = o || "toggle" === i), i === (h ? "hide" : "show"))) {
                            if ("show" !== i || !g || void 0 === g[r]) continue;
                            h = !0;
                        }
                        f[r] = (g && g[r]) || d.style(e, r);
                    } else l = void 0;
                if (d.isEmptyObject(f)) "inline" === ("none" === l ? ke(e.nodeName) : l) && (p.display = l);
                else
                    for (r in (g ? "hidden" in g && (h = g.hidden) : (g = R.access(e, "fxshow", {})),
                    o && (g.hidden = !h),
                    h
                        ? d(e).show()
                        : c.done(function () {
                              d(e).hide();
                          }),
                    c.done(function () {
                        var t;
                        for (t in (R.remove(e, "fxshow"), f)) d.style(e, t, f[t]);
                    }),
                    f))
                        (s = Ke(h ? g[r] : 0, r, c)), r in g || ((g[r] = s.start), h && ((s.end = s.start), (s.start = "width" === r || "height" === r ? 1 : 0)));
            },
        ],
        prefilter: function (e, t) {
            t ? Ze.prefilters.unshift(e) : Ze.prefilters.push(e);
        },
    })),
        (d.speed = function (e, t, n) {
            var r = e && "object" == typeof e ? d.extend({}, e) : { complete: n || (!n && t) || (d.isFunction(e) && e), duration: e, easing: (n && t) || (t && !d.isFunction(t) && t) };
            return (
                (r.duration = d.fx.off ? 0 : "number" == typeof r.duration ? r.duration : r.duration in d.fx.speeds ? d.fx.speeds[r.duration] : d.fx.speeds._default),
                (null != r.queue && !0 !== r.queue) || (r.queue = "fx"),
                (r.old = r.complete),
                (r.complete = function () {
                    d.isFunction(r.old) && r.old.call(this), r.queue && d.dequeue(this, r.queue);
                }),
                r
            );
        }),
        d.fn.extend({
            fadeTo: function (e, t, n, r) {
                return this.filter(z).css("opacity", 0).show().end().animate({ opacity: t }, e, n, r);
            },
            animate: function (e, t, n, r) {
                var i = d.isEmptyObject(e),
                    o = d.speed(t, n, r),
                    s = function () {
                        var t = Ze(this, d.extend({}, e), o);
                        (i || R.get(this, "finish")) && t.stop(!0);
                    };
                return (s.finish = s), i || !1 === o.queue ? this.each(s) : this.queue(o.queue, s);
            },
            stop: function (e, t, n) {
                var r = function (e) {
                    var t = e.stop;
                    delete e.stop, t(n);
                };
                return (
                    "string" != typeof e && ((n = t), (t = e), (e = void 0)),
                    t && !1 !== e && this.queue(e || "fx", []),
                    this.each(function () {
                        var t = !0,
                            i = null != e && e + "queueHooks",
                            o = d.timers,
                            s = R.get(this);
                        if (i) s[i] && s[i].stop && r(s[i]);
                        else for (i in s) s[i] && s[i].stop && Ge.test(i) && r(s[i]);
                        for (i = o.length; i--; ) o[i].elem !== this || (null != e && o[i].queue !== e) || (o[i].anim.stop(n), (t = !1), o.splice(i, 1));
                        (!t && n) || d.dequeue(this, e);
                    })
                );
            },
            finish: function (e) {
                return (
                    !1 !== e && (e = e || "fx"),
                    this.each(function () {
                        var t,
                            n = R.get(this),
                            r = n[e + "queue"],
                            i = n[e + "queueHooks"],
                            o = d.timers,
                            s = r ? r.length : 0;
                        for (n.finish = !0, d.queue(this, e, []), i && i.stop && i.stop.call(this, !0), t = o.length; t--; ) o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0), o.splice(t, 1));
                        for (t = 0; s > t; t++) r[t] && r[t].finish && r[t].finish.call(this);
                        delete n.finish;
                    })
                );
            },
        }),
        d.each(["toggle", "show", "hide"], function (e, t) {
            var n = d.fn[t];
            d.fn[t] = function (e, r, i) {
                return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(Je(t, !0), e, r, i);
            };
        }),
        d.each({ slideDown: Je("show"), slideUp: Je("hide"), slideToggle: Je("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (e, t) {
            d.fn[e] = function (e, n, r) {
                return this.animate(t, e, n, r);
            };
        }),
        (d.timers = []),
        (d.fx.tick = function () {
            var e,
                t = 0,
                n = d.timers;
            for (_e = d.now(); t < n.length; t++) (e = n[t])() || n[t] !== e || n.splice(t--, 1);
            n.length || d.fx.stop(), (_e = void 0);
        }),
        (d.fx.timer = function (e) {
            d.timers.push(e), e() ? d.fx.start() : d.timers.pop();
        }),
        (d.fx.interval = 13),
        (d.fx.start = function () {
            Xe || (Xe = e.setInterval(d.fx.tick, d.fx.interval));
        }),
        (d.fx.stop = function () {
            e.clearInterval(Xe), (Xe = null);
        }),
        (d.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
        (d.fn.delay = function (t, n) {
            return (
                (t = (d.fx && d.fx.speeds[t]) || t),
                (n = n || "fx"),
                this.queue(n, function (n, r) {
                    var i = e.setTimeout(n, t);
                    r.stop = function () {
                        e.clearTimeout(i);
                    };
                })
            );
        }),
        (ze = r.createElement("input")),
        (Ue = r.createElement("select")),
        (Ve = Ue.appendChild(r.createElement("option"))),
        (ze.type = "checkbox"),
        (f.checkOn = "" !== ze.value),
        (f.optSelected = Ve.selected),
        (Ue.disabled = !0),
        (f.optDisabled = !Ve.disabled),
        ((ze = r.createElement("input")).value = "t"),
        (ze.type = "radio"),
        (f.radioValue = "t" === ze.value);
    var et,
        tt = d.expr.attrHandle;
    d.fn.extend({
        attr: function (e, t) {
            return O(this, d.attr, e, t, arguments.length > 1);
        },
        removeAttr: function (e) {
            return this.each(function () {
                d.removeAttr(this, e);
            });
        },
    }),
        d.extend({
            attr: function (e, t, n) {
                var r,
                    i,
                    o = e.nodeType;
                if (3 !== o && 8 !== o && 2 !== o)
                    return void 0 === e.getAttribute
                        ? d.prop(e, t, n)
                        : ((1 === o && d.isXMLDoc(e)) || ((t = t.toLowerCase()), (i = d.attrHooks[t] || (d.expr.match.bool.test(t) ? et : void 0))),
                          void 0 !== n
                              ? null === n
                                  ? void d.removeAttr(e, t)
                                  : i && "set" in i && void 0 !== (r = i.set(e, n, t))
                                  ? r
                                  : (e.setAttribute(t, n + ""), n)
                              : i && "get" in i && null !== (r = i.get(e, t))
                              ? r
                              : null == (r = d.find.attr(e, t))
                              ? void 0
                              : r);
            },
            attrHooks: {
                type: {
                    set: function (e, t) {
                        if (!f.radioValue && "radio" === t && d.nodeName(e, "input")) {
                            var n = e.value;
                            return e.setAttribute("type", t), n && (e.value = n), t;
                        }
                    },
                },
            },
            removeAttr: function (e, t) {
                var n,
                    r,
                    i = 0,
                    o = t && t.match(L);
                if (o && 1 === e.nodeType) for (; (n = o[i++]); ) (r = d.propFix[n] || n), d.expr.match.bool.test(n) && (e[r] = !1), e.removeAttribute(n);
            },
        }),
        (et = {
            set: function (e, t, n) {
                return !1 === t ? d.removeAttr(e, n) : e.setAttribute(n, n), n;
            },
        }),
        d.each(d.expr.match.bool.source.match(/\w+/g), function (e, t) {
            var n = tt[t] || d.find.attr;
            tt[t] = function (e, t, r) {
                var i, o;
                return r || ((o = tt[t]), (tt[t] = i), (i = null != n(e, t, r) ? t.toLowerCase() : null), (tt[t] = o)), i;
            };
        });
    var nt = /^(?:input|select|textarea|button)$/i,
        rt = /^(?:a|area)$/i;
    d.fn.extend({
        prop: function (e, t) {
            return O(this, d.prop, e, t, arguments.length > 1);
        },
        removeProp: function (e) {
            return this.each(function () {
                delete this[d.propFix[e] || e];
            });
        },
    }),
        d.extend({
            prop: function (e, t, n) {
                var r,
                    i,
                    o = e.nodeType;
                if (3 !== o && 8 !== o && 2 !== o)
                    return (
                        (1 === o && d.isXMLDoc(e)) || ((t = d.propFix[t] || t), (i = d.propHooks[t])),
                        void 0 !== n ? (i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : (e[t] = n)) : i && "get" in i && null !== (r = i.get(e, t)) ? r : e[t]
                    );
            },
            propHooks: {
                tabIndex: {
                    get: function (e) {
                        var t = d.find.attr(e, "tabindex");
                        return t ? parseInt(t, 10) : nt.test(e.nodeName) || (rt.test(e.nodeName) && e.href) ? 0 : -1;
                    },
                },
            },
            propFix: { for: "htmlFor", class: "className" },
        }),
        f.optSelected ||
            (d.propHooks.selected = {
                get: function (e) {
                    var t = e.parentNode;
                    return t && t.parentNode && t.parentNode.selectedIndex, null;
                },
                set: function (e) {
                    var t = e.parentNode;
                    t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
                },
            }),
        d.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
            d.propFix[this.toLowerCase()] = this;
        });
    var it = /[\t\r\n\f]/g;
    function ot(e) {
        return (e.getAttribute && e.getAttribute("class")) || "";
    }
    d.fn.extend({
        addClass: function (e) {
            var t,
                n,
                r,
                i,
                o,
                s,
                a,
                u = 0;
            if (d.isFunction(e))
                return this.each(function (t) {
                    d(this).addClass(e.call(this, t, ot(this)));
                });
            if ("string" == typeof e && e)
                for (t = e.match(L) || []; (n = this[u++]); )
                    if (((i = ot(n)), (r = 1 === n.nodeType && (" " + i + " ").replace(it, " ")))) {
                        for (s = 0; (o = t[s++]); ) r.indexOf(" " + o + " ") < 0 && (r += o + " ");
                        i !== (a = d.trim(r)) && n.setAttribute("class", a);
                    }
            return this;
        },
        removeClass: function (e) {
            var t,
                n,
                r,
                i,
                o,
                s,
                a,
                u = 0;
            if (d.isFunction(e))
                return this.each(function (t) {
                    d(this).removeClass(e.call(this, t, ot(this)));
                });
            if (!arguments.length) return this.attr("class", "");
            if ("string" == typeof e && e)
                for (t = e.match(L) || []; (n = this[u++]); )
                    if (((i = ot(n)), (r = 1 === n.nodeType && (" " + i + " ").replace(it, " ")))) {
                        for (s = 0; (o = t[s++]); ) for (; r.indexOf(" " + o + " ") > -1; ) r = r.replace(" " + o + " ", " ");
                        i !== (a = d.trim(r)) && n.setAttribute("class", a);
                    }
            return this;
        },
        toggleClass: function (e, t) {
            var n = typeof e;
            return "boolean" == typeof t && "string" === n
                ? t
                    ? this.addClass(e)
                    : this.removeClass(e)
                : d.isFunction(e)
                ? this.each(function (n) {
                      d(this).toggleClass(e.call(this, n, ot(this), t), t);
                  })
                : this.each(function () {
                      var t, r, i, o;
                      if ("string" === n) for (r = 0, i = d(this), o = e.match(L) || []; (t = o[r++]); ) i.hasClass(t) ? i.removeClass(t) : i.addClass(t);
                      else (void 0 !== e && "boolean" !== n) || ((t = ot(this)) && R.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : R.get(this, "__className__") || ""));
                  });
        },
        hasClass: function (e) {
            var t,
                n,
                r = 0;
            for (t = " " + e + " "; (n = this[r++]); ) if (1 === n.nodeType && (" " + ot(n) + " ").replace(it, " ").indexOf(t) > -1) return !0;
            return !1;
        },
    });
    var st = /\r/g,
        at = /[\x20\t\r\n\f]+/g;
    d.fn.extend({
        val: function (e) {
            var t,
                n,
                r,
                i = this[0];
            return arguments.length
                ? ((r = d.isFunction(e)),
                  this.each(function (n) {
                      var i;
                      1 === this.nodeType &&
                          (null == (i = r ? e.call(this, n, d(this).val()) : e)
                              ? (i = "")
                              : "number" == typeof i
                              ? (i += "")
                              : d.isArray(i) &&
                                (i = d.map(i, function (e) {
                                    return null == e ? "" : e + "";
                                })),
                          ((t = d.valHooks[this.type] || d.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, i, "value")) || (this.value = i));
                  }))
                : i
                ? (t = d.valHooks[i.type] || d.valHooks[i.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(i, "value"))
                    ? n
                    : "string" == typeof (n = i.value)
                    ? n.replace(st, "")
                    : null == n
                    ? ""
                    : n
                : void 0;
        },
    }),
        d.extend({
            valHooks: {
                option: {
                    get: function (e) {
                        var t = d.find.attr(e, "value");
                        return null != t ? t : d.trim(d.text(e)).replace(at, " ");
                    },
                },
                select: {
                    get: function (e) {
                        for (var t, n, r = e.options, i = e.selectedIndex, o = "select-one" === e.type || 0 > i, s = o ? null : [], a = o ? i + 1 : r.length, u = 0 > i ? a : o ? i : 0; a > u; u++)
                            if (((n = r[u]).selected || u === i) && (f.optDisabled ? !n.disabled : null === n.getAttribute("disabled")) && (!n.parentNode.disabled || !d.nodeName(n.parentNode, "optgroup"))) {
                                if (((t = d(n).val()), o)) return t;
                                s.push(t);
                            }
                        return s;
                    },
                    set: function (e, t) {
                        for (var n, r, i = e.options, o = d.makeArray(t), s = i.length; s--; ) ((r = i[s]).selected = d.inArray(d.valHooks.option.get(r), o) > -1) && (n = !0);
                        return n || (e.selectedIndex = -1), o;
                    },
                },
            },
        }),
        d.each(["radio", "checkbox"], function () {
            (d.valHooks[this] = {
                set: function (e, t) {
                    return d.isArray(t) ? (e.checked = d.inArray(d(e).val(), t) > -1) : void 0;
                },
            }),
                f.checkOn ||
                    (d.valHooks[this].get = function (e) {
                        return null === e.getAttribute("value") ? "on" : e.value;
                    });
        });
    var ut = /^(?:focusinfocus|focusoutblur)$/;
    d.extend(d.event, {
        trigger: function (t, n, i, o) {
            var s,
                a,
                u,
                l,
                f,
                p,
                h,
                g = [i || r],
                v = c.call(t, "type") ? t.type : t,
                m = c.call(t, "namespace") ? t.namespace.split(".") : [];
            if (
                ((a = u = i = i || r),
                3 !== i.nodeType &&
                    8 !== i.nodeType &&
                    !ut.test(v + d.event.triggered) &&
                    (v.indexOf(".") > -1 && ((v = (m = v.split(".")).shift()), m.sort()),
                    (f = v.indexOf(":") < 0 && "on" + v),
                    ((t = t[d.expando] ? t : new d.Event(v, "object" == typeof t && t)).isTrigger = o ? 2 : 3),
                    (t.namespace = m.join(".")),
                    (t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + m.join("\\.(?:.*\\.|)") + "(\\.|$)") : null),
                    (t.result = void 0),
                    t.target || (t.target = i),
                    (n = null == n ? [t] : d.makeArray(n, [t])),
                    (h = d.event.special[v] || {}),
                    o || !h.trigger || !1 !== h.trigger.apply(i, n)))
            ) {
                if (!o && !h.noBubble && !d.isWindow(i)) {
                    for (l = h.delegateType || v, ut.test(l + v) || (a = a.parentNode); a; a = a.parentNode) g.push(a), (u = a);
                    u === (i.ownerDocument || r) && g.push(u.defaultView || u.parentWindow || e);
                }
                for (s = 0; (a = g[s++]) && !t.isPropagationStopped(); )
                    (t.type = s > 1 ? l : h.bindType || v),
                        (p = (R.get(a, "events") || {})[t.type] && R.get(a, "handle")) && p.apply(a, n),
                        (p = f && a[f]) && p.apply && F(a) && ((t.result = p.apply(a, n)), !1 === t.result && t.preventDefault());
                return (
                    (t.type = v),
                    o ||
                        t.isDefaultPrevented() ||
                        (h._default && !1 !== h._default.apply(g.pop(), n)) ||
                        !F(i) ||
                        (f && d.isFunction(i[v]) && !d.isWindow(i) && ((u = i[f]) && (i[f] = null), (d.event.triggered = v), i[v](), (d.event.triggered = void 0), u && (i[f] = u))),
                    t.result
                );
            }
        },
        simulate: function (e, t, n) {
            var r = d.extend(new d.Event(), n, { type: e, isSimulated: !0 });
            d.event.trigger(r, null, t), r.isDefaultPrevented() && n.preventDefault();
        },
    }),
        d.fn.extend({
            trigger: function (e, t) {
                return this.each(function () {
                    d.event.trigger(e, t, this);
                });
            },
            triggerHandler: function (e, t) {
                var n = this[0];
                return n ? d.event.trigger(e, t, n, !0) : void 0;
            },
        }),
        d.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function (
            e,
            t
        ) {
            d.fn[t] = function (e, n) {
                return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
            };
        }),
        d.fn.extend({
            hover: function (e, t) {
                return this.mouseenter(e).mouseleave(t || e);
            },
        }),
        (f.focusin = "onfocusin" in e),
        f.focusin ||
            d.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
                var n = function (e) {
                    d.event.simulate(t, e.target, d.event.fix(e));
                };
                d.event.special[t] = {
                    setup: function () {
                        var r = this.ownerDocument || this,
                            i = R.access(r, t);
                        i || r.addEventListener(e, n, !0), R.access(r, t, (i || 0) + 1);
                    },
                    teardown: function () {
                        var r = this.ownerDocument || this,
                            i = R.access(r, t) - 1;
                        i ? R.access(r, t, i) : (r.removeEventListener(e, n, !0), R.remove(r, t));
                    },
                };
            });
    var lt = e.location,
        ct = d.now(),
        ft = /\?/;
    (d.parseJSON = function (e) {
        return JSON.parse(e + "");
    }),
        (d.parseXML = function (t) {
            var n;
            if (!t || "string" != typeof t) return null;
            try {
                n = new e.DOMParser().parseFromString(t, "text/xml");
            } catch (e) {
                n = void 0;
            }
            return (n && !n.getElementsByTagName("parsererror").length) || d.error("Invalid XML: " + t), n;
        });
    var pt = /#.*$/,
        dt = /([?&])_=[^&]*/,
        ht = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        gt = /^(?:GET|HEAD)$/,
        vt = /^\/\//,
        mt = {},
        yt = {},
        xt = "*/".concat("*"),
        bt = r.createElement("a");
    function wt(e) {
        return function (t, n) {
            "string" != typeof t && ((n = t), (t = "*"));
            var r,
                i = 0,
                o = t.toLowerCase().match(L) || [];
            if (d.isFunction(n)) for (; (r = o[i++]); ) "+" === r[0] ? ((r = r.slice(1) || "*"), (e[r] = e[r] || []).unshift(n)) : (e[r] = e[r] || []).push(n);
        };
    }
    function Tt(e, t, n, r) {
        var i = {},
            o = e === yt;
        function s(a) {
            var u;
            return (
                (i[a] = !0),
                d.each(e[a] || [], function (e, a) {
                    var l = a(t, n, r);
                    return "string" != typeof l || o || i[l] ? (o ? !(u = l) : void 0) : (t.dataTypes.unshift(l), s(l), !1);
                }),
                u
            );
        }
        return s(t.dataTypes[0]) || (!i["*"] && s("*"));
    }
    function Ct(e, t) {
        var n,
            r,
            i = d.ajaxSettings.flatOptions || {};
        for (n in t) void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
        return r && d.extend(!0, e, r), e;
    }
    (bt.href = lt.href),
        d.extend({
            active: 0,
            lastModified: {},
            etag: {},
            ajaxSettings: {
                url: lt.href,
                type: "GET",
                isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(lt.protocol),
                global: !0,
                processData: !0,
                async: !0,
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                accepts: { "*": xt, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" },
                contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" },
                converters: { "* text": String, "text html": !0, "text json": d.parseJSON, "text xml": d.parseXML },
                flatOptions: { url: !0, context: !0 },
            },
            ajaxSetup: function (e, t) {
                return t ? Ct(Ct(e, d.ajaxSettings), t) : Ct(d.ajaxSettings, e);
            },
            ajaxPrefilter: wt(mt),
            ajaxTransport: wt(yt),
            ajax: function (t, n) {
                "object" == typeof t && ((n = t), (t = void 0)), (n = n || {});
                var i,
                    o,
                    s,
                    a,
                    u,
                    l,
                    c,
                    f,
                    p = d.ajaxSetup({}, n),
                    h = p.context || p,
                    g = p.context && (h.nodeType || h.jquery) ? d(h) : d.event,
                    v = d.Deferred(),
                    m = d.Callbacks("once memory"),
                    y = p.statusCode || {},
                    x = {},
                    b = {},
                    w = 0,
                    T = "canceled",
                    C = {
                        readyState: 0,
                        getResponseHeader: function (e) {
                            var t;
                            if (2 === w) {
                                if (!a) for (a = {}; (t = ht.exec(s)); ) a[t[1].toLowerCase()] = t[2];
                                t = a[e.toLowerCase()];
                            }
                            return null == t ? null : t;
                        },
                        getAllResponseHeaders: function () {
                            return 2 === w ? s : null;
                        },
                        setRequestHeader: function (e, t) {
                            var n = e.toLowerCase();
                            return w || ((e = b[n] = b[n] || e), (x[e] = t)), this;
                        },
                        overrideMimeType: function (e) {
                            return w || (p.mimeType = e), this;
                        },
                        statusCode: function (e) {
                            var t;
                            if (e)
                                if (2 > w) for (t in e) y[t] = [y[t], e[t]];
                                else C.always(e[C.status]);
                            return this;
                        },
                        abort: function (e) {
                            var t = e || T;
                            return i && i.abort(t), k(0, t), this;
                        },
                    };
                if (
                    ((v.promise(C).complete = m.add),
                    (C.success = C.done),
                    (C.error = C.fail),
                    (p.url = ((t || p.url || lt.href) + "").replace(pt, "").replace(vt, lt.protocol + "//")),
                    (p.type = n.method || n.type || p.method || p.type),
                    (p.dataTypes = d
                        .trim(p.dataType || "*")
                        .toLowerCase()
                        .match(L) || [""]),
                    null == p.crossDomain)
                ) {
                    l = r.createElement("a");
                    try {
                        (l.href = p.url), (l.href = l.href), (p.crossDomain = bt.protocol + "//" + bt.host != l.protocol + "//" + l.host);
                    } catch (e) {
                        p.crossDomain = !0;
                    }
                }
                if ((p.data && p.processData && "string" != typeof p.data && (p.data = d.param(p.data, p.traditional)), Tt(mt, p, n, C), 2 === w)) return C;
                for (f in ((c = d.event && p.global) && 0 == d.active++ && d.event.trigger("ajaxStart"),
                (p.type = p.type.toUpperCase()),
                (p.hasContent = !gt.test(p.type)),
                (o = p.url),
                p.hasContent || (p.data && ((o = p.url += (ft.test(o) ? "&" : "?") + p.data), delete p.data), !1 === p.cache && (p.url = dt.test(o) ? o.replace(dt, "$1_=" + ct++) : o + (ft.test(o) ? "&" : "?") + "_=" + ct++)),
                p.ifModified && (d.lastModified[o] && C.setRequestHeader("If-Modified-Since", d.lastModified[o]), d.etag[o] && C.setRequestHeader("If-None-Match", d.etag[o])),
                ((p.data && p.hasContent && !1 !== p.contentType) || n.contentType) && C.setRequestHeader("Content-Type", p.contentType),
                C.setRequestHeader("Accept", p.dataTypes[0] && p.accepts[p.dataTypes[0]] ? p.accepts[p.dataTypes[0]] + ("*" !== p.dataTypes[0] ? ", " + xt + "; q=0.01" : "") : p.accepts["*"]),
                p.headers))
                    C.setRequestHeader(f, p.headers[f]);
                if (p.beforeSend && (!1 === p.beforeSend.call(h, C, p) || 2 === w)) return C.abort();
                for (f in ((T = "abort"), { success: 1, error: 1, complete: 1 })) C[f](p[f]);
                if ((i = Tt(yt, p, n, C))) {
                    if (((C.readyState = 1), c && g.trigger("ajaxSend", [C, p]), 2 === w)) return C;
                    p.async &&
                        p.timeout > 0 &&
                        (u = e.setTimeout(function () {
                            C.abort("timeout");
                        }, p.timeout));
                    try {
                        (w = 1), i.send(x, k);
                    } catch (e) {
                        if (!(2 > w)) throw e;
                        k(-1, e);
                    }
                } else k(-1, "No Transport");
                function k(t, n, r, a) {
                    var l,
                        f,
                        x,
                        b,
                        T,
                        k = n;
                    2 !== w &&
                        ((w = 2),
                        u && e.clearTimeout(u),
                        (i = void 0),
                        (s = a || ""),
                        (C.readyState = t > 0 ? 4 : 0),
                        (l = (t >= 200 && 300 > t) || 304 === t),
                        r &&
                            (b = (function (e, t, n) {
                                for (var r, i, o, s, a = e.contents, u = e.dataTypes; "*" === u[0]; ) u.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"));
                                if (r)
                                    for (i in a)
                                        if (a[i] && a[i].test(r)) {
                                            u.unshift(i);
                                            break;
                                        }
                                if (u[0] in n) o = u[0];
                                else {
                                    for (i in n) {
                                        if (!u[0] || e.converters[i + " " + u[0]]) {
                                            o = i;
                                            break;
                                        }
                                        s || (s = i);
                                    }
                                    o = o || s;
                                }
                                return o ? (o !== u[0] && u.unshift(o), n[o]) : void 0;
                            })(p, C, r)),
                        (b = (function (e, t, n, r) {
                            var i,
                                o,
                                s,
                                a,
                                u,
                                l = {},
                                c = e.dataTypes.slice();
                            if (c[1]) for (s in e.converters) l[s.toLowerCase()] = e.converters[s];
                            for (o = c.shift(); o; )
                                if ((e.responseFields[o] && (n[e.responseFields[o]] = t), !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)), (u = o), (o = c.shift())))
                                    if ("*" === o) o = u;
                                    else if ("*" !== u && u !== o) {
                                        if (!(s = l[u + " " + o] || l["* " + o]))
                                            for (i in l)
                                                if ((a = i.split(" "))[1] === o && (s = l[u + " " + a[0]] || l["* " + a[0]])) {
                                                    !0 === s ? (s = l[i]) : !0 !== l[i] && ((o = a[0]), c.unshift(a[1]));
                                                    break;
                                                }
                                        if (!0 !== s)
                                            if (s && e.throws) t = s(t);
                                            else
                                                try {
                                                    t = s(t);
                                                } catch (e) {
                                                    return { state: "parsererror", error: s ? e : "No conversion from " + u + " to " + o };
                                                }
                                    }
                            return { state: "success", data: t };
                        })(p, b, C, l)),
                        l
                            ? (p.ifModified && ((T = C.getResponseHeader("Last-Modified")) && (d.lastModified[o] = T), (T = C.getResponseHeader("etag")) && (d.etag[o] = T)),
                              204 === t || "HEAD" === p.type ? (k = "nocontent") : 304 === t ? (k = "notmodified") : ((k = b.state), (f = b.data), (l = !(x = b.error))))
                            : ((x = k), (!t && k) || ((k = "error"), 0 > t && (t = 0))),
                        (C.status = t),
                        (C.statusText = (n || k) + ""),
                        l ? v.resolveWith(h, [f, k, C]) : v.rejectWith(h, [C, k, x]),
                        C.statusCode(y),
                        (y = void 0),
                        c && g.trigger(l ? "ajaxSuccess" : "ajaxError", [C, p, l ? f : x]),
                        m.fireWith(h, [C, k]),
                        c && (g.trigger("ajaxComplete", [C, p]), --d.active || d.event.trigger("ajaxStop")));
                }
                return C;
            },
            getJSON: function (e, t, n) {
                return d.get(e, t, n, "json");
            },
            getScript: function (e, t) {
                return d.get(e, void 0, t, "script");
            },
        }),
        d.each(["get", "post"], function (e, t) {
            d[t] = function (e, n, r, i) {
                return d.isFunction(n) && ((i = i || r), (r = n), (n = void 0)), d.ajax(d.extend({ url: e, type: t, dataType: i, data: n, success: r }, d.isPlainObject(e) && e));
            };
        }),
        (d._evalUrl = function (e) {
            return d.ajax({ url: e, type: "GET", dataType: "script", async: !1, global: !1, throws: !0 });
        }),
        d.fn.extend({
            wrapAll: function (e) {
                var t;
                return d.isFunction(e)
                    ? this.each(function (t) {
                          d(this).wrapAll(e.call(this, t));
                      })
                    : (this[0] &&
                          ((t = d(e, this[0].ownerDocument).eq(0).clone(!0)),
                          this[0].parentNode && t.insertBefore(this[0]),
                          t
                              .map(function () {
                                  for (var e = this; e.firstElementChild; ) e = e.firstElementChild;
                                  return e;
                              })
                              .append(this)),
                      this);
            },
            wrapInner: function (e) {
                return d.isFunction(e)
                    ? this.each(function (t) {
                          d(this).wrapInner(e.call(this, t));
                      })
                    : this.each(function () {
                          var t = d(this),
                              n = t.contents();
                          n.length ? n.wrapAll(e) : t.append(e);
                      });
            },
            wrap: function (e) {
                var t = d.isFunction(e);
                return this.each(function (n) {
                    d(this).wrapAll(t ? e.call(this, n) : e);
                });
            },
            unwrap: function () {
                return this.parent()
                    .each(function () {
                        d.nodeName(this, "body") || d(this).replaceWith(this.childNodes);
                    })
                    .end();
            },
        }),
        (d.expr.filters.hidden = function (e) {
            return !d.expr.filters.visible(e);
        }),
        (d.expr.filters.visible = function (e) {
            return e.offsetWidth > 0 || e.offsetHeight > 0 || e.getClientRects().length > 0;
        });
    var kt = /%20/g,
        Et = /\[\]$/,
        Nt = /\r?\n/g,
        St = /^(?:submit|button|image|reset|file)$/i,
        Dt = /^(?:input|select|textarea|keygen)/i;
    function jt(e, t, n, r) {
        var i;
        if (d.isArray(t))
            d.each(t, function (t, i) {
                n || Et.test(e) ? r(e, i) : jt(e + "[" + ("object" == typeof i && null != i ? t : "") + "]", i, n, r);
            });
        else if (n || "object" !== d.type(t)) r(e, t);
        else for (i in t) jt(e + "[" + i + "]", t[i], n, r);
    }
    (d.param = function (e, t) {
        var n,
            r = [],
            i = function (e, t) {
                (t = d.isFunction(t) ? t() : null == t ? "" : t), (r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t));
            };
        if ((void 0 === t && (t = d.ajaxSettings && d.ajaxSettings.traditional), d.isArray(e) || (e.jquery && !d.isPlainObject(e))))
            d.each(e, function () {
                i(this.name, this.value);
            });
        else for (n in e) jt(n, e[n], t, i);
        return r.join("&").replace(kt, "+");
    }),
        d.fn.extend({
            serialize: function () {
                return d.param(this.serializeArray());
            },
            serializeArray: function () {
                return this.map(function () {
                    var e = d.prop(this, "elements");
                    return e ? d.makeArray(e) : this;
                })
                    .filter(function () {
                        var e = this.type;
                        return this.name && !d(this).is(":disabled") && Dt.test(this.nodeName) && !St.test(e) && (this.checked || !V.test(e));
                    })
                    .map(function (e, t) {
                        var n = d(this).val();
                        return null == n
                            ? null
                            : d.isArray(n)
                            ? d.map(n, function (e) {
                                  return { name: t.name, value: e.replace(Nt, "\r\n") };
                              })
                            : { name: t.name, value: n.replace(Nt, "\r\n") };
                    })
                    .get();
            },
        }),
        (d.ajaxSettings.xhr = function () {
            try {
                return new e.XMLHttpRequest();
            } catch (e) {}
        });
    var At = { 0: 200, 1223: 204 },
        qt = d.ajaxSettings.xhr();
    (f.cors = !!qt && "withCredentials" in qt),
        (f.ajax = qt = !!qt),
        d.ajaxTransport(function (t) {
            var n, r;
            return f.cors || (qt && !t.crossDomain)
                ? {
                      send: function (i, o) {
                          var s,
                              a = t.xhr();
                          if ((a.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields)) for (s in t.xhrFields) a[s] = t.xhrFields[s];
                          for (s in (t.mimeType && a.overrideMimeType && a.overrideMimeType(t.mimeType), t.crossDomain || i["X-Requested-With"] || (i["X-Requested-With"] = "XMLHttpRequest"), i)) a.setRequestHeader(s, i[s]);
                          (n = function (e) {
                              return function () {
                                  n &&
                                      ((n = r = a.onload = a.onerror = a.onabort = a.onreadystatechange = null),
                                      "abort" === e
                                          ? a.abort()
                                          : "error" === e
                                          ? "number" != typeof a.status
                                              ? o(0, "error")
                                              : o(a.status, a.statusText)
                                          : o(
                                                At[a.status] || a.status,
                                                a.statusText,
                                                "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? { binary: a.response } : { text: a.responseText },
                                                a.getAllResponseHeaders()
                                            ));
                              };
                          }),
                              (a.onload = n()),
                              (r = a.onerror = n("error")),
                              void 0 !== a.onabort
                                  ? (a.onabort = r)
                                  : (a.onreadystatechange = function () {
                                        4 === a.readyState &&
                                            e.setTimeout(function () {
                                                n && r();
                                            });
                                    }),
                              (n = n("abort"));
                          try {
                              a.send((t.hasContent && t.data) || null);
                          } catch (e) {
                              if (n) throw e;
                          }
                      },
                      abort: function () {
                          n && n();
                      },
                  }
                : void 0;
        }),
        d.ajaxSetup({
            accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" },
            contents: { script: /\b(?:java|ecma)script\b/ },
            converters: {
                "text script": function (e) {
                    return d.globalEval(e), e;
                },
            },
        }),
        d.ajaxPrefilter("script", function (e) {
            void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
        }),
        d.ajaxTransport("script", function (e) {
            var t, n;
            if (e.crossDomain)
                return {
                    send: function (i, o) {
                        (t = d("<script>")
                            .prop({ charset: e.scriptCharset, src: e.url })
                            .on(
                                "load error",
                                (n = function (e) {
                                    t.remove(), (n = null), e && o("error" === e.type ? 404 : 200, e.type);
                                })
                            )),
                            r.head.appendChild(t[0]);
                    },
                    abort: function () {
                        n && n();
                    },
                };
        });
    var Lt = [],
        Ht = /(=)\?(?=&|$)|\?\?/;
    d.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function () {
            var e = Lt.pop() || d.expando + "_" + ct++;
            return (this[e] = !0), e;
        },
    }),
        d.ajaxPrefilter("json jsonp", function (t, n, r) {
            var i,
                o,
                s,
                a = !1 !== t.jsonp && (Ht.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && Ht.test(t.data) && "data");
            return a || "jsonp" === t.dataTypes[0]
                ? ((i = t.jsonpCallback = d.isFunction(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback),
                  a ? (t[a] = t[a].replace(Ht, "$1" + i)) : !1 !== t.jsonp && (t.url += (ft.test(t.url) ? "&" : "?") + t.jsonp + "=" + i),
                  (t.converters["script json"] = function () {
                      return s || d.error(i + " was not called"), s[0];
                  }),
                  (t.dataTypes[0] = "json"),
                  (o = e[i]),
                  (e[i] = function () {
                      s = arguments;
                  }),
                  r.always(function () {
                      void 0 === o ? d(e).removeProp(i) : (e[i] = o), t[i] && ((t.jsonpCallback = n.jsonpCallback), Lt.push(i)), s && d.isFunction(o) && o(s[0]), (s = o = void 0);
                  }),
                  "script")
                : void 0;
        }),
        (d.parseHTML = function (e, t, n) {
            if (!e || "string" != typeof e) return null;
            "boolean" == typeof t && ((n = t), (t = !1)), (t = t || r);
            var i = C.exec(e),
                o = !n && [];
            return i ? [t.createElement(i[1])] : ((i = ne([e], t, o)), o && o.length && d(o).remove(), d.merge([], i.childNodes));
        });
    var Ot = d.fn.load;
    function Ft(e) {
        return d.isWindow(e) ? e : 9 === e.nodeType && e.defaultView;
    }
    (d.fn.load = function (e, t, n) {
        if ("string" != typeof e && Ot) return Ot.apply(this, arguments);
        var r,
            i,
            o,
            s = this,
            a = e.indexOf(" ");
        return (
            a > -1 && ((r = d.trim(e.slice(a))), (e = e.slice(0, a))),
            d.isFunction(t) ? ((n = t), (t = void 0)) : t && "object" == typeof t && (i = "POST"),
            s.length > 0 &&
                d
                    .ajax({ url: e, type: i || "GET", dataType: "html", data: t })
                    .done(function (e) {
                        (o = arguments), s.html(r ? d("<div>").append(d.parseHTML(e)).find(r) : e);
                    })
                    .always(
                        n &&
                            function (e, t) {
                                s.each(function () {
                                    n.apply(this, o || [e.responseText, t, e]);
                                });
                            }
                    ),
            this
        );
    }),
        d.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
            d.fn[t] = function (e) {
                return this.on(t, e);
            };
        }),
        (d.expr.filters.animated = function (e) {
            return d.grep(d.timers, function (t) {
                return e === t.elem;
            }).length;
        }),
        (d.offset = {
            setOffset: function (e, t, n) {
                var r,
                    i,
                    o,
                    s,
                    a,
                    u,
                    l = d.css(e, "position"),
                    c = d(e),
                    f = {};
                "static" === l && (e.style.position = "relative"),
                    (a = c.offset()),
                    (o = d.css(e, "top")),
                    (u = d.css(e, "left")),
                    ("absolute" === l || "fixed" === l) && (o + u).indexOf("auto") > -1 ? ((s = (r = c.position()).top), (i = r.left)) : ((s = parseFloat(o) || 0), (i = parseFloat(u) || 0)),
                    d.isFunction(t) && (t = t.call(e, n, d.extend({}, a))),
                    null != t.top && (f.top = t.top - a.top + s),
                    null != t.left && (f.left = t.left - a.left + i),
                    "using" in t ? t.using.call(e, f) : c.css(f);
            },
        }),
        d.fn.extend({
            offset: function (e) {
                if (arguments.length)
                    return void 0 === e
                        ? this
                        : this.each(function (t) {
                              d.offset.setOffset(this, e, t);
                          });
                var t,
                    n,
                    r = this[0],
                    i = { top: 0, left: 0 },
                    o = r && r.ownerDocument;
                return o ? ((t = o.documentElement), d.contains(t, r) ? ((i = r.getBoundingClientRect()), (n = Ft(o)), { top: i.top + n.pageYOffset - t.clientTop, left: i.left + n.pageXOffset - t.clientLeft }) : i) : void 0;
            },
            position: function () {
                if (this[0]) {
                    var e,
                        t,
                        n = this[0],
                        r = { top: 0, left: 0 };
                    return (
                        "fixed" === d.css(n, "position")
                            ? (t = n.getBoundingClientRect())
                            : ((e = this.offsetParent()), (t = this.offset()), d.nodeName(e[0], "html") || (r = e.offset()), (r.top += d.css(e[0], "borderTopWidth", !0)), (r.left += d.css(e[0], "borderLeftWidth", !0))),
                        { top: t.top - r.top - d.css(n, "marginTop", !0), left: t.left - r.left - d.css(n, "marginLeft", !0) }
                    );
                }
            },
            offsetParent: function () {
                return this.map(function () {
                    for (var e = this.offsetParent; e && "static" === d.css(e, "position"); ) e = e.offsetParent;
                    return e || je;
                });
            },
        }),
        d.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (e, t) {
            var n = "pageYOffset" === t;
            d.fn[e] = function (r) {
                return O(
                    this,
                    function (e, r, i) {
                        var o = Ft(e);
                        return void 0 === i ? (o ? o[t] : e[r]) : void (o ? o.scrollTo(n ? o.pageXOffset : i, n ? i : o.pageYOffset) : (e[r] = i));
                    },
                    e,
                    r,
                    arguments.length
                );
            };
        }),
        d.each(["top", "left"], function (e, t) {
            d.cssHooks[t] = qe(f.pixelPosition, function (e, n) {
                return n ? ((n = Ae(e, t)), Ne.test(n) ? d(e).position()[t] + "px" : n) : void 0;
            });
        }),
        d.each({ Height: "height", Width: "width" }, function (e, t) {
            d.each({ padding: "inner" + e, content: t, "": "outer" + e }, function (n, r) {
                d.fn[r] = function (r, i) {
                    var o = arguments.length && (n || "boolean" != typeof r),
                        s = n || (!0 === r || !0 === i ? "margin" : "border");
                    return O(
                        this,
                        function (t, n, r) {
                            var i;
                            return d.isWindow(t)
                                ? t.document.documentElement["client" + e]
                                : 9 === t.nodeType
                                ? ((i = t.documentElement), Math.max(t.body["scroll" + e], i["scroll" + e], t.body["offset" + e], i["offset" + e], i["client" + e]))
                                : void 0 === r
                                ? d.css(t, n, s)
                                : d.style(t, n, r, s);
                        },
                        t,
                        o ? r : void 0,
                        o,
                        null
                    );
                };
            });
        }),
        d.fn.extend({
            bind: function (e, t, n) {
                return this.on(e, null, t, n);
            },
            unbind: function (e, t) {
                return this.off(e, null, t);
            },
            delegate: function (e, t, n, r) {
                return this.on(t, e, n, r);
            },
            undelegate: function (e, t, n) {
                return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
            },
            size: function () {
                return this.length;
            },
        }),
        (d.fn.andSelf = d.fn.addBack),
        "function" == typeof define &&
            define.amd &&
            define("jquery", [], function () {
                return d;
            });
    var Pt = e.jQuery,
        Rt = e.$;
    return (
        (d.noConflict = function (t) {
            return e.$ === d && (e.$ = Rt), t && e.jQuery === d && (e.jQuery = Pt), d;
        }),
        t || (e.jQuery = e.$ = d),
        d
    );
});
/*! Zoom 1.7.21 */
!(function (o) {
    var t = { url: !1, callback: !1, target: !1, duration: 120, on: "mouseover", touch: !0, onZoomIn: !1, onZoomOut: !1, magnify: 1 };
    (o.zoom = function (t, n, e, i) {
        var u,
            c,
            a,
            r,
            m,
            l,
            s,
            f = o(t),
            h = f.css("position"),
            d = o(n);
        return (
            (t.style.position = /(absolute|fixed)/.test(h) ? h : "relative"),
            (t.style.overflow = "hidden"),
            (e.style.width = e.style.height = ""),
            o(e)
                .addClass("zoomImg")
                .css({ position: "absolute", top: 0, left: 0, opacity: 0, width: e.width * i, height: e.height * i, border: "none", maxWidth: "none", maxHeight: "none" })
                .appendTo(t),
            {
                init: function () {
                    (c = f.outerWidth()), (u = f.outerHeight()), n === t ? ((r = c), (a = u)) : ((r = d.outerWidth()), (a = d.outerHeight())), (m = (e.width - c) / r), (l = (e.height - u) / a), (s = d.offset());
                },
                move: function (o) {
                    var t = o.pageX - s.left,
                        n = o.pageY - s.top;
                    (n = Math.max(Math.min(n, a), 0)), (t = Math.max(Math.min(t, r), 0)), (e.style.left = t * -m + "px"), (e.style.top = n * -l + "px");
                },
            }
        );
    }),
        (o.fn.zoom = function (n) {
            return this.each(function () {
                var e = o.extend({}, t, n || {}),
                    i = (e.target && o(e.target)[0]) || this,
                    u = this,
                    c = o(u),
                    a = document.createElement("img"),
                    r = o(a),
                    m = "mousemove.zoom",
                    l = !1,
                    s = !1;
                if (!e.url) {
                    var f = u.querySelector("img");
                    if ((f && (e.url = f.getAttribute("data-src") || f.currentSrc || f.src), !e.url)) return;
                }
                c.one(
                    "zoom.destroy",
                    function (o, t) {
                        c.off(".zoom"), (i.style.position = o), (i.style.overflow = t), (a.onload = null), r.remove();
                    }.bind(this, i.style.position, i.style.overflow)
                ),
                    (a.onload = function () {
                        function t(t) {
                            f.init(), f.move(t), r.stop().fadeTo(o.support.opacity ? e.duration : 0, 1, !!o.isFunction(e.onZoomIn) && e.onZoomIn.call(a));
                        }
                        function n() {
                            r.stop().fadeTo(e.duration, 0, !!o.isFunction(e.onZoomOut) && e.onZoomOut.call(a));
                        }
                        var f = o.zoom(i, u, a, e.magnify);
                        "grab" === e.on
                            ? c.on("mousedown.zoom", function (e) {
                                  1 === e.which &&
                                      (o(document).one("mouseup.zoom", function () {
                                          n(), o(document).off(m, f.move);
                                      }),
                                      t(e),
                                      o(document).on(m, f.move),
                                      e.preventDefault());
                              })
                            : "click" === e.on
                            ? c.on("click.zoom", function (e) {
                                  return l
                                      ? void 0
                                      : ((l = !0),
                                        t(e),
                                        o(document).on(m, f.move),
                                        o(document).one("click.zoom", function () {
                                            n(), (l = !1), o(document).off(m, f.move);
                                        }),
                                        !1);
                              })
                            : "toggle" === e.on
                            ? c.on("click.zoom", function (o) {
                                  l ? n() : t(o), (l = !l);
                              })
                            : "mouseover" === e.on && (f.init(), c.on("mouseenter.zoom", t).on("mouseleave.zoom", n).on(m, f.move)),
                            e.touch &&
                                c
                                    .on("touchstart.zoom", function (o) {
                                        o.preventDefault(), s ? ((s = !1), n()) : ((s = !0), t(o.originalEvent.touches[0] || o.originalEvent.changedTouches[0]));
                                    })
                                    .on("touchmove.zoom", function (o) {
                                        o.preventDefault(), f.move(o.originalEvent.touches[0] || o.originalEvent.changedTouches[0]);
                                    })
                                    .on("touchend.zoom", function (o) {
                                        o.preventDefault(), s && ((s = !1), n());
                                    }),
                            o.isFunction(e.callback) && e.callback.call(a);
                    }),
                    a.setAttribute("role", "presentation"),
                    (a.alt = ""),
                    (a.src = e.url);
            });
        }),
        (o.fn.zoom.defaults = t);
})(window.jQuery);
/*! mobile-sniff.min.js */
window.mobileCheck = function () {
    var i,
        a = !1;
    return (
        (i = navigator.userAgent || navigator.vendor || window.opera),
        (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            i
        ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                i.substr(0, 4)
            )) &&
            (a = !0),
        a
    );
};
/*! modernizr 3.3.1 */
!(function (e, n, t) {
    function s(e, n) {
        return typeof e === n;
    }
    function r() {
        return "function" != typeof n.createElement ? n.createElement(arguments[0]) : v ? n.createElementNS.call(n, "http://www.w3.org/2000/svg", arguments[0]) : n.createElement.apply(n, arguments);
    }
    function o(e, n) {
        return function () {
            return e.apply(n, arguments);
        };
    }
    function i(e) {
        return e
            .replace(/([A-Z])/g, function (e, n) {
                return "-" + n.toLowerCase();
            })
            .replace(/^ms-/, "-ms-");
    }
    function a(e, t, s, o) {
        var i,
            a,
            l,
            f,
            u,
            d = "modernizr",
            p = r("div"),
            c = ((u = n.body) || ((u = r(v ? "svg" : "body")).fake = !0), u);
        if (parseInt(s, 10)) for (; s--; ) ((l = r("div")).id = o ? o[s] : d + (s + 1)), p.appendChild(l);
        return (
            ((i = r("style")).type = "text/css"),
            (i.id = "s" + d),
            (c.fake ? c : p).appendChild(i),
            c.appendChild(p),
            i.styleSheet ? (i.styleSheet.cssText = e) : i.appendChild(n.createTextNode(e)),
            (p.id = d),
            c.fake && ((c.style.background = ""), (c.style.overflow = "hidden"), (f = h.style.overflow), (h.style.overflow = "hidden"), h.appendChild(c)),
            (a = t(p, e)),
            c.fake ? (c.parentNode.removeChild(c), (h.style.overflow = f), h.offsetHeight) : p.parentNode.removeChild(p),
            !!a
        );
    }
    function l(n, o, l, f) {
        function u() {
            p && (delete x.style, delete x.modElem);
        }
        if (((f = !s(f, "undefined") && f), !s(l, "undefined"))) {
            var d = (function (n, s) {
                var r = n.length;
                if ("CSS" in e && "supports" in e.CSS) {
                    for (; r--; ) if (e.CSS.supports(i(n[r]), s)) return !0;
                    return !1;
                }
                if ("CSSSupportsRule" in e) {
                    for (var o = []; r--; ) o.push("(" + i(n[r]) + ":" + s + ")");
                    return a("@supports (" + (o = o.join(" or ")) + ") { #modernizr { position: absolute; } }", function (e) {
                        return "absolute" == getComputedStyle(e, null).position;
                    });
                }
                return t;
            })(n, l);
            if (!s(d, "undefined")) return d;
        }
        for (var p, c, m, h, v, y = ["modernizr", "tspan", "samp"]; !x.style && y.length; ) (p = !0), (x.modElem = r(y.shift())), (x.style = x.modElem.style);
        for (m = n.length, c = 0; m > c; c++)
            if (
                ((h = n[c]),
                (v = x.style[h]),
                !!~("" + h).indexOf("-") &&
                    (h = h
                        .replace(/([a-z])-([a-z])/g, function (e, n, t) {
                            return n + t.toUpperCase();
                        })
                        .replace(/^-/, "")),
                x.style[h] !== t)
            ) {
                if (f || s(l, "undefined")) return u(), "pfx" != o || h;
                try {
                    x.style[h] = l;
                } catch (n) {}
                if (x.style[h] != v) return u(), "pfx" != o || h;
            }
        return u(), !1;
    }
    function f(e, n, t, r, i) {
        var a = e.charAt(0).toUpperCase() + e.slice(1),
            f = (e + " " + g.join(a + " ") + a).split(" ");
        return s(n, "string") || s(n, "undefined")
            ? l(f, n, r, i)
            : (function (e, n, t) {
                  var r;
                  for (var i in e) if (e[i] in n) return !1 === t ? e[i] : s((r = n[e[i]]), "function") ? o(r, t || n) : r;
                  return !1;
              })((f = (e + " " + w.join(a + " ") + a).split(" ")), n, t);
    }
    function u(e, n, s) {
        return f(e, t, t, n, s);
    }
    var d = [],
        p = [],
        c = {
            _version: "3.3.1",
            _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 },
            _q: [],
            on: function (e, n) {
                var t = this;
                setTimeout(function () {
                    n(t[e]);
                }, 0);
            },
            addTest: function (e, n, t) {
                p.push({ name: e, fn: n, options: t });
            },
            addAsyncTest: function (e) {
                p.push({ name: null, fn: e });
            },
        },
        m = function () {};
    (m.prototype = c), (m = new m()).addTest("svg", !!n.createElementNS && !!n.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect);
    var h = n.documentElement,
        v = "svg" === h.nodeName.toLowerCase(),
        y = "Moz O ms Webkit",
        g = c._config.usePrefixes ? y.split(" ") : [];
    c._cssomPrefixes = g;
    var w = c._config.usePrefixes ? y.toLowerCase().split(" ") : [];
    c._domPrefixes = w;
    var C = { elem: r("modernizr") };
    m._q.push(function () {
        delete C.elem;
    });
    var x = { style: C.elem.style };
    m._q.unshift(function () {
        delete x.style;
    }),
        (c.testAllProps = f),
        (c.testAllProps = u),
        m.addTest("flexbox", u("flexBasis", "1px", !0)),
        m.addTest("csstransforms", function () {
            return -1 === navigator.userAgent.indexOf("Android 2.") && u("transform", "scale(1)", !0);
        }),
        (function () {
            var e, n, t, r, o, i;
            for (var a in p)
                if (p.hasOwnProperty(a)) {
                    if (((e = []), (n = p[a]).name && (e.push(n.name.toLowerCase()), n.options && n.options.aliases && n.options.aliases.length))) for (t = 0; t < n.options.aliases.length; t++) e.push(n.options.aliases[t].toLowerCase());
                    for (r = s(n.fn, "function") ? n.fn() : n.fn, o = 0; o < e.length; o++)
                        1 === (i = e[o].split(".")).length ? (m[i[0]] = r) : (!m[i[0]] || m[i[0]] instanceof Boolean || (m[i[0]] = new Boolean(m[i[0]])), (m[i[0]][i[1]] = r)), d.push((r ? "" : "no-") + i.join("-"));
                }
        })(),
        (function (e) {
            var n = h.className,
                t = m._config.classPrefix || "";
            if ((v && (n = n.baseVal), m._config.enableJSClass)) {
                var s = new RegExp("(^|\\s)" + t + "no-js(\\s|$)");
                n = n.replace(s, "$1" + t + "js$2");
            }
            m._config.enableClasses && ((n += " " + t + e.join(" " + t)), v ? (h.className.baseVal = n) : (h.className = n));
        })(d),
        delete c.addTest,
        delete c.addAsyncTest;
    for (var S = 0; S < m._q.length; S++) m._q[S]();
    e.Modernizr = m;
})(window, document);
/*! prepare-transition.min.js */
!(function (n) {
    n.fn.prepareTransition = function () {
        return this.each(function () {
            var i = n(this);
            i.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function () {
                i.removeClass("is-transitioning");
            });
            var t = 0;
            n.each(["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"], function (n, o) {
                t || (t = parseFloat(i.css(o)));
            }),
                0 != t && (i.addClass("is-transitioning"), i[0].offsetWidth);
        });
    };
})(jQuery);
/*! slick.min.js v1.8.1 */
!(function (i) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], i) : "undefined" != typeof exports ? (module.exports = i(require("jquery"))) : i(jQuery);
})(function (a) {
    "use strict";
    var s,
        r = window.Slick;
    (((s = 0),
    (r = function (i, e) {
        var t,
            o = this;
        (o.defaults = {
            accessibility: !0,
            adaptiveHeight: !1,
            appendArrows: a(i),
            appendDots: a(i),
            arrows: !0,
            asNavFor: null,
            prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
            nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
            autoplay: !1,
            autoplaySpeed: 3e3,
            centerMode: !1,
            centerPadding: "50px",
            cssEase: "ease",
            customPaging: function (i, e) {
                return a('<button type="button" />').text(e + 1);
            },
            dots: !1,
            dotsClass: "slick-dots",
            draggable: !0,
            easing: "linear",
            edgeFriction: 0.35,
            fade: !1,
            focusOnSelect: !1,
            focusOnChange: !1,
            infinite: !0,
            initialSlide: 0,
            lazyLoad: "ondemand",
            mobileFirst: !1,
            pauseOnHover: !0,
            pauseOnFocus: !0,
            pauseOnDotsHover: !1,
            respondTo: "window",
            responsive: null,
            rows: 1,
            rtl: !1,
            slide: "",
            slidesPerRow: 1,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
            delay: !1,
            swipe: !0,
            swipeToSlide: !1,
            touchMove: !0,
            touchThreshold: 5,
            useCSS: !0,
            useTransform: !0,
            variableWidth: !1,
            vertical: !1,
            verticalSwiping: !1,
            waitForAnimate: !0,
            zIndex: 1e3,
        }),
            (o.initials = {
                animating: !1,
                dragging: !1,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: !1,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: !1,
                slideOffset: 0,
                swipeLeft: null,
                swiping: !1,
                $list: null,
                touchObject: {},
                transformsEnabled: !1,
                unslicked: !1,
            }),
            a.extend(o, o.initials),
            (o.activeBreakpoint = null),
            (o.animType = null),
            (o.animProp = null),
            (o.breakpoints = []),
            (o.breakpointSettings = []),
            (o.cssTransitions = !1),
            (o.focussed = !1),
            (o.interrupted = !1),
            (o.hidden = "hidden"),
            (o.paused = !0),
            (o.positionProp = null),
            (o.respondTo = null),
            (o.rowCount = 1),
            (o.shouldClick = !0),
            (o.$slider = a(i)),
            (o.$slidesCache = null),
            (o.transformType = null),
            (o.transitionType = null),
            (o.visibilityChange = "visibilitychange"),
            (o.windowWidth = 0),
            (o.windowTimer = null),
            (t = a(i).data("slick") || {}),
            (o.options = a.extend({}, o.defaults, e, t)),
            (o.currentSlide = o.options.initialSlide),
            (o.originalSettings = o.options),
            void 0 !== document.mozHidden ? ((o.hidden = "mozHidden"), (o.visibilityChange = "mozvisibilitychange")) : void 0 !== document.webkitHidden && ((o.hidden = "webkitHidden"), (o.visibilityChange = "webkitvisibilitychange")),
            (o.autoPlay = a.proxy(o.autoPlay, o)),
            (o.autoPlayClear = a.proxy(o.autoPlayClear, o)),
            (o.autoPlayIterator = a.proxy(o.autoPlayIterator, o)),
            (o.changeSlide = a.proxy(o.changeSlide, o)),
            (o.clickHandler = a.proxy(o.clickHandler, o)),
            (o.selectHandler = a.proxy(o.selectHandler, o)),
            (o.setPosition = a.proxy(o.setPosition, o)),
            (o.swipeHandler = a.proxy(o.swipeHandler, o)),
            (o.dragHandler = a.proxy(o.dragHandler, o)),
            (o.keyHandler = a.proxy(o.keyHandler, o)),
            (o.instanceUid = s++),
            (o.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
            o.registerBreakpoints(),
            o.init(!0);
    })).prototype.activateADA = function () {
        this.$slideTrack.find(".slick-active").attr({ "aria-hidden": "false" }).find("a, input, button, select").attr({ tabindex: "0" });
    }),
        (r.prototype.addSlide = r.prototype.slickAdd = function (i, e, t) {
            var o = this;
            if ("boolean" == typeof e) (t = e), (e = null);
            else if (e < 0 || e >= o.slideCount) return !1;
            o.unload(),
                "number" == typeof e
                    ? 0 === e && 0 === o.$slides.length
                        ? a(i).appendTo(o.$slideTrack)
                        : t
                        ? a(i).insertBefore(o.$slides.eq(e))
                        : a(i).insertAfter(o.$slides.eq(e))
                    : !0 === t
                    ? a(i).prependTo(o.$slideTrack)
                    : a(i).appendTo(o.$slideTrack),
                (o.$slides = o.$slideTrack.children(this.options.slide)),
                o.$slideTrack.children(this.options.slide).detach(),
                o.$slideTrack.append(o.$slides),
                o.$slides.each(function (i, e) {
                    a(e).attr("data-slick-index", i);
                }),
                (o.$slidesCache = o.$slides),
                o.reinit();
        }),
        (r.prototype.animateHeight = function () {
            var i = this;
            if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
                var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
                i.$list.animate({ height: e }, i.options.speed);
            }
        }),
        (r.prototype.animateSlide = function (i, e) {
            var t = {},
                o = this;
            o.animateHeight(),
                !0 === o.options.rtl && !1 === o.options.vertical && (i = -i),
                !1 === o.transformsEnabled
                    ? !1 === o.options.vertical
                        ? o.$slideTrack.animate({ left: i }, o.options.speed, o.options.easing, e)
                        : o.$slideTrack.animate({ top: i }, o.options.speed, o.options.easing, e)
                    : !1 === o.cssTransitions
                    ? (!0 === o.options.rtl && (o.currentLeft = -o.currentLeft),
                      a({ animStart: o.currentLeft }).animate(
                          { animStart: i },
                          {
                              duration: o.options.speed,
                              easing: o.options.easing,
                              step: function (i) {
                                  (i = Math.ceil(i)), !1 === o.options.vertical ? (t[o.animType] = "translate(" + i + "px, 0px)") : (t[o.animType] = "translate(0px," + i + "px)"), o.$slideTrack.css(t);
                              },
                              complete: function () {
                                  e && e.call();
                              },
                          }
                      ))
                    : (o.applyTransition(),
                      (i = Math.ceil(i)),
                      !1 === o.options.vertical ? (t[o.animType] = "translate3d(" + i + "px, 0px, 0px)") : (t[o.animType] = "translate3d(0px," + i + "px, 0px)"),
                      o.$slideTrack.css(t),
                      e &&
                          setTimeout(
                              function () {
                                  o.disableTransition(), e.call();
                              },
                              o.options.delay ? o.options.delay : o.options.speed
                          ));
        }),
        (r.prototype.getNavTarget = function () {
            var i = this.options.asNavFor;
            return i && null !== i && (i = a(i).not(this.$slider)), i;
        }),
        (r.prototype.asNavFor = function (e) {
            var i = this.getNavTarget();
            null !== i &&
                "object" == typeof i &&
                i.each(function () {
                    var i = a(this).slick("getSlick");
                    i.unslicked || i.slideHandler(e, !0);
                });
        }),
        (r.prototype.applyTransition = function (i) {
            var e = this,
                t = {};
            !1 === e.options.fade ? (t[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase) : (t[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase),
                !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
        }),
        (r.prototype.autoPlay = function () {
            var i = this;
            i.autoPlayClear(), i.slideCount > i.options.slidesToShow && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed));
        }),
        (r.prototype.autoPlayClear = function () {
            this.autoPlayTimer && clearInterval(this.autoPlayTimer);
        }),
        (r.prototype.autoPlayIterator = function () {
            var i = this,
                e = i.currentSlide + i.options.slidesToScroll;
            i.paused ||
                i.interrupted ||
                i.focussed ||
                (!1 === i.options.infinite &&
                    (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1 ? (i.direction = 0) : 0 === i.direction && ((e = i.currentSlide - i.options.slidesToScroll), i.currentSlide - 1 == 0 && (i.direction = 1))),
                i.slideHandler(e));
        }),
        (r.prototype.buildArrows = function () {
            var i = this;
            !0 === i.options.arrows &&
                ((i.$prevArrow = a(i.options.prevArrow).addClass("slick-arrow")),
                (i.$nextArrow = a(i.options.nextArrow).addClass("slick-arrow")),
                i.slideCount > i.options.slidesToShow
                    ? (i.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                      i.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                      i.htmlExpr.test(i.options.prevArrow) && i.$prevArrow.prependTo(i.options.appendArrows),
                      i.htmlExpr.test(i.options.nextArrow) && i.$nextArrow.appendTo(i.options.appendArrows),
                      !0 !== i.options.infinite && i.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"))
                    : i.$prevArrow.add(i.$nextArrow).addClass("slick-hidden").attr({ "aria-disabled": "true", tabindex: "-1" }));
        }),
        (r.prototype.buildDots = function () {
            var i,
                e,
                t = this;
            if (!0 === t.options.dots) {
                for (t.$slider.addClass("slick-dotted"), e = a("<ul />").addClass(t.options.dotsClass), i = 0; i <= t.getDotCount(); i += 1) e.append(a("<li />").append(t.options.customPaging.call(this, t, i)));
                (t.$dots = e.appendTo(t.options.appendDots)), t.$dots.find("li").first().addClass("slick-active");
            }
        }),
        (r.prototype.buildOut = function () {
            var i = this;
            (i.$slides = i.$slider.children(i.options.slide + ":not(.slick-cloned)").addClass("slick-slide")),
                (i.slideCount = i.$slides.length),
                i.$slides.each(function (i, e) {
                    a(e)
                        .attr("data-slick-index", i)
                        .data("originalStyling", a(e).attr("style") || "");
                }),
                i.$slider.addClass("slick-slider"),
                (i.$slideTrack = 0 === i.slideCount ? a('<div class="slick-track"/>').appendTo(i.$slider) : i.$slides.wrapAll('<div class="slick-track"/>').parent()),
                (i.$list = i.$slideTrack.wrap('<div class="slick-list"/>').parent()),
                i.$slideTrack.css("opacity", 0),
                (!0 !== i.options.centerMode && !0 !== i.options.swipeToSlide) || (i.options.slidesToScroll = 1),
                a("img[data-lazy]", i.$slider).not("[src]").addClass("slick-loading"),
                i.setupInfinite(),
                i.buildArrows(),
                i.buildDots(),
                i.updateDots(),
                i.setSlideClasses("number" == typeof i.currentSlide ? i.currentSlide : 0),
                !0 === i.options.draggable && i.$list.addClass("draggable");
        }),
        (r.prototype.buildRows = function () {
            var i,
                e,
                t,
                o,
                s,
                n,
                r,
                l = this;
            if (((o = document.createDocumentFragment()), (n = l.$slider.children()), 1 < l.options.rows)) {
                for (r = l.options.slidesPerRow * l.options.rows, s = Math.ceil(n.length / r), i = 0; i < s; i++) {
                    var d = document.createElement("div");
                    for (e = 0; e < l.options.rows; e++) {
                        var a = document.createElement("div");
                        for (t = 0; t < l.options.slidesPerRow; t++) {
                            var c = i * r + (e * l.options.slidesPerRow + t);
                            n.get(c) && a.appendChild(n.get(c));
                        }
                        d.appendChild(a);
                    }
                    o.appendChild(d);
                }
                l.$slider.empty().append(o),
                    l.$slider
                        .children()
                        .children()
                        .children()
                        .css({ width: 100 / l.options.slidesPerRow + "%", display: "inline-block" });
            }
        }),
        (r.prototype.checkResponsive = function (i, e) {
            var t,
                o,
                s,
                n = this,
                r = !1,
                l = n.$slider.width(),
                d = window.innerWidth || a(window).width();
            if (("window" === n.respondTo ? (s = d) : "slider" === n.respondTo ? (s = l) : "min" === n.respondTo && (s = Math.min(d, l)), n.options.responsive && n.options.responsive.length && null !== n.options.responsive)) {
                for (t in ((o = null), n.breakpoints)) n.breakpoints.hasOwnProperty(t) && (!1 === n.originalSettings.mobileFirst ? s < n.breakpoints[t] && (o = n.breakpoints[t]) : s > n.breakpoints[t] && (o = n.breakpoints[t]));
                null !== o
                    ? null !== n.activeBreakpoint
                        ? (o !== n.activeBreakpoint || e) &&
                          ((n.activeBreakpoint = o),
                          "unslick" === n.breakpointSettings[o] ? n.unslick(o) : ((n.options = a.extend({}, n.originalSettings, n.breakpointSettings[o])), !0 === i && (n.currentSlide = n.options.initialSlide), n.refresh(i)),
                          (r = o))
                        : ((n.activeBreakpoint = o),
                          "unslick" === n.breakpointSettings[o] ? n.unslick(o) : ((n.options = a.extend({}, n.originalSettings, n.breakpointSettings[o])), !0 === i && (n.currentSlide = n.options.initialSlide), n.refresh(i)),
                          (r = o))
                    : null !== n.activeBreakpoint && ((n.activeBreakpoint = null), (n.options = n.originalSettings), !0 === i && (n.currentSlide = n.options.initialSlide), n.refresh(i), (r = o)),
                    i || !1 === r || n.$slider.trigger("breakpoint", [n, r]);
            }
        }),
        (r.prototype.changeSlide = function (i, e) {
            var t,
                o,
                s = this,
                n = a(i.currentTarget);
            switch ((n.is("a") && i.preventDefault(), n.is("li") || (n = n.closest("li")), (t = s.slideCount % s.options.slidesToScroll != 0 ? 0 : (s.slideCount - s.currentSlide) % s.options.slidesToScroll), i.data.message)) {
                case "previous":
                    (o = 0 === t ? s.options.slidesToScroll : s.options.slidesToShow - t), s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide - o, !1, e);
                    break;
                case "next":
                    (o = 0 === t ? s.options.slidesToScroll : t), s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide + o, !1, e);
                    break;
                case "index":
                    var r = 0 === i.data.index ? 0 : i.data.index || n.index() * s.options.slidesToScroll;
                    s.slideHandler(s.checkNavigable(r), !1, e), n.children().trigger("focus");
                    break;
                default:
                    return;
            }
        }),
        (r.prototype.checkNavigable = function (i) {
            var e, t;
            if (((t = 0), i > (e = this.getNavigableIndexes())[e.length - 1])) i = e[e.length - 1];
            else
                for (var o in e) {
                    if (i < e[o]) {
                        i = t;
                        break;
                    }
                    t = e[o];
                }
            return i;
        }),
        (r.prototype.cleanUpEvents = function () {
            var i = this;
            i.options.dots &&
                null !== i.$dots &&
                (a("li", i.$dots).off("click.slick", i.changeSlide).off("mouseenter.slick", a.proxy(i.interrupt, i, !0)).off("mouseleave.slick", a.proxy(i.interrupt, i, !1)),
                !0 === i.options.accessibility && i.$dots.off("keydown.slick", i.keyHandler)),
                i.$slider.off("focus.slick blur.slick"),
                !0 === i.options.arrows &&
                    i.slideCount > i.options.slidesToShow &&
                    (i.$prevArrow && i.$prevArrow.off("click.slick", i.changeSlide),
                    i.$nextArrow && i.$nextArrow.off("click.slick", i.changeSlide),
                    !0 === i.options.accessibility && (i.$prevArrow && i.$prevArrow.off("keydown.slick", i.keyHandler), i.$nextArrow && i.$nextArrow.off("keydown.slick", i.keyHandler))),
                i.$list.off("touchstart.slick mousedown.slick", i.swipeHandler),
                i.$list.off("touchmove.slick mousemove.slick", i.swipeHandler),
                i.$list.off("touchend.slick mouseup.slick", i.swipeHandler),
                i.$list.off("touchcancel.slick mouseleave.slick", i.swipeHandler),
                i.$list.off("click.slick", i.clickHandler),
                a(document).off(i.visibilityChange, i.visibility),
                i.cleanUpSlideEvents(),
                !0 === i.options.accessibility && i.$list.off("keydown.slick", i.keyHandler),
                !0 === i.options.focusOnSelect && a(i.$slideTrack).children().off("click.slick", i.selectHandler),
                a(window).off("orientationchange.slick.slick-" + i.instanceUid, i.orientationChange),
                a(window).off("resize.slick.slick-" + i.instanceUid, i.resize),
                a("[draggable!=true]", i.$slideTrack).off("dragstart", i.preventDefault),
                a(window).off("load.slick.slick-" + i.instanceUid, i.setPosition);
        }),
        (r.prototype.cleanUpSlideEvents = function () {
            var i = this;
            i.$list.off("mouseenter.slick", a.proxy(i.interrupt, i, !0)), i.$list.off("mouseleave.slick", a.proxy(i.interrupt, i, !1));
        }),
        (r.prototype.cleanUpRows = function () {
            var i;
            1 < this.options.rows && ((i = this.$slides.children().children()).removeAttr("style"), this.$slider.empty().append(i));
        }),
        (r.prototype.clickHandler = function (i) {
            !1 === this.shouldClick && (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault());
        }),
        (r.prototype.destroy = function (i) {
            var e = this;
            e.autoPlayClear(),
                (e.touchObject = {}),
                e.cleanUpEvents(),
                a(".slick-cloned", e.$slider).detach(),
                e.$dots && e.$dots.remove(),
                e.$prevArrow &&
                    e.$prevArrow.length &&
                    (e.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove()),
                e.$nextArrow &&
                    e.$nextArrow.length &&
                    (e.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove()),
                e.$slides &&
                    (e.$slides
                        .removeClass("slick-slide slick-active slick-center slick-visible slick-current")
                        .removeAttr("aria-hidden")
                        .removeAttr("data-slick-index")
                        .each(function () {
                            a(this).attr("style", a(this).data("originalStyling"));
                        }),
                    e.$slideTrack.children(this.options.slide).detach(),
                    e.$slideTrack.detach(),
                    e.$list.detach(),
                    e.$slider.append(e.$slides)),
                e.cleanUpRows(),
                e.$slider.removeClass("slick-slider"),
                e.$slider.removeClass("slick-initialized"),
                e.$slider.removeClass("slick-dotted"),
                (e.unslicked = !0),
                i || e.$slider.trigger("destroy", [e]);
        }),
        (r.prototype.disableTransition = function (i) {
            var e = {};
            (e[this.transitionType] = ""), !1 === this.options.fade ? this.$slideTrack.css(e) : this.$slides.eq(i).css(e);
        }),
        (r.prototype.fadeSlide = function (i, e) {
            var t = this;
            !1 === t.cssTransitions
                ? (t.$slides.eq(i).css({ zIndex: t.options.zIndex }), t.$slides.eq(i).animate({ opacity: 1 }, t.options.speed, t.options.easing, e))
                : (t.applyTransition(i),
                  t.$slides.eq(i).css({ opacity: 1, zIndex: t.options.zIndex }),
                  e &&
                      setTimeout(function () {
                          t.disableTransition(i), e.call();
                      }, t.options.speed));
        }),
        (r.prototype.fadeSlideOut = function (i) {
            var e = this;
            !1 === e.cssTransitions ? e.$slides.eq(i).animate({ opacity: 0, zIndex: e.options.zIndex - 2 }, e.options.speed, e.options.easing) : (e.applyTransition(i), e.$slides.eq(i).css({ opacity: 0, zIndex: e.options.zIndex - 2 }));
        }),
        (r.prototype.filterSlides = r.prototype.slickFilter = function (i) {
            var e = this;
            null !== i && ((e.$slidesCache = e.$slides), e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(i).appendTo(e.$slideTrack), e.reinit());
        }),
        (r.prototype.focusHandler = function () {
            var t = this;
            t.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function (i) {
                i.stopImmediatePropagation();
                var e = a(this);
                setTimeout(function () {
                    t.options.pauseOnFocus && ((t.focussed = e.is(":focus")), t.autoPlay());
                }, 0);
            });
        }),
        (r.prototype.getCurrent = r.prototype.slickCurrentSlide = function () {
            return this.currentSlide;
        }),
        (r.prototype.getDotCount = function () {
            var i = this,
                e = 0,
                t = 0,
                o = 0;
            if (!0 === i.options.infinite)
                if (i.slideCount <= i.options.slidesToShow) ++o;
                else for (; e < i.slideCount; ) ++o, (e = t + i.options.slidesToScroll), (t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow);
            else if (!0 === i.options.centerMode) o = i.slideCount;
            else if (i.options.asNavFor) for (; e < i.slideCount; ) ++o, (e = t + i.options.slidesToScroll), (t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow);
            else o = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll);
            return o - 1;
        }),
        (r.prototype.getLeft = function (i) {
            var e,
                t,
                o,
                s,
                n = this,
                r = 0;
            return (
                (n.slideOffset = 0),
                (t = n.$slides.first().outerHeight(!0)),
                !0 === n.options.infinite
                    ? (n.slideCount > n.options.slidesToShow &&
                          ((n.slideOffset = n.slideWidth * n.options.slidesToShow * -1),
                          (s = -1),
                          !0 === n.options.vertical && !0 === n.options.centerMode && (2 === n.options.slidesToShow ? (s = -1.5) : 1 === n.options.slidesToShow && (s = -2)),
                          (r = t * n.options.slidesToShow * s)),
                      n.slideCount % n.options.slidesToScroll != 0 &&
                          i + n.options.slidesToScroll > n.slideCount &&
                          n.slideCount > n.options.slidesToShow &&
                          (r =
                              i > n.slideCount
                                  ? ((n.slideOffset = (n.options.slidesToShow - (i - n.slideCount)) * n.slideWidth * -1), (n.options.slidesToShow - (i - n.slideCount)) * t * -1)
                                  : ((n.slideOffset = (n.slideCount % n.options.slidesToScroll) * n.slideWidth * -1), (n.slideCount % n.options.slidesToScroll) * t * -1)))
                    : i + n.options.slidesToShow > n.slideCount && ((n.slideOffset = (i + n.options.slidesToShow - n.slideCount) * n.slideWidth), (r = (i + n.options.slidesToShow - n.slideCount) * t)),
                n.slideCount <= n.options.slidesToShow && (r = n.slideOffset = 0),
                !0 === n.options.centerMode && n.slideCount <= n.options.slidesToShow
                    ? (n.slideOffset = (n.slideWidth * Math.floor(n.options.slidesToShow)) / 2 - (n.slideWidth * n.slideCount) / 2)
                    : !0 === n.options.centerMode && !0 === n.options.infinite
                    ? (n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2) - n.slideWidth)
                    : !0 === n.options.centerMode && ((n.slideOffset = 0), (n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2))),
                (e = !1 === n.options.vertical ? i * n.slideWidth * -1 + n.slideOffset : i * t * -1 + r),
                !0 === n.options.variableWidth &&
                    ((o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow)),
                    (e = !0 === n.options.rtl ? (o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0) : o[0] ? -1 * o[0].offsetLeft : 0),
                    !0 === n.options.centerMode &&
                        ((o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow + 1)),
                        (e = !0 === n.options.rtl ? (o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0) : o[0] ? -1 * o[0].offsetLeft : 0),
                        (e += (n.$list.width() - o.outerWidth()) / 2))),
                e
            );
        }),
        (r.prototype.getOption = r.prototype.slickGetOption = function (i) {
            return this.options[i];
        }),
        (r.prototype.getNavigableIndexes = function () {
            var i,
                e = this,
                t = 0,
                o = 0,
                s = [];
            for (i = !1 === e.options.infinite ? e.slideCount : ((t = -1 * e.options.slidesToScroll), (o = -1 * e.options.slidesToScroll), 2 * e.slideCount); t < i; )
                s.push(t), (t = o + e.options.slidesToScroll), (o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow);
            return s;
        }),
        (r.prototype.getSlick = function () {
            return this;
        }),
        (r.prototype.getSlideCount = function () {
            var t,
                o,
                s = this;
            return (
                (o = !0 === s.options.centerMode ? s.slideWidth * Math.floor(s.options.slidesToShow / 2) : 0),
                !0 === s.options.swipeToSlide
                    ? (s.$slideTrack.find(".slick-slide").each(function (i, e) {
                          if (e.offsetLeft - o + a(e).outerWidth() / 2 > -1 * s.swipeLeft) return (t = e), !1;
                      }),
                      Math.abs(a(t).attr("data-slick-index") - s.currentSlide) || 1)
                    : s.options.slidesToScroll
            );
        }),
        (r.prototype.goTo = r.prototype.slickGoTo = function (i, e) {
            this.changeSlide({ data: { message: "index", index: parseInt(i) } }, e);
        }),
        (r.prototype.init = function (i) {
            var e = this;
            a(e.$slider).hasClass("slick-initialized") ||
                (a(e.$slider).addClass("slick-initialized"), e.buildRows(), e.buildOut(), e.setProps(), e.startLoad(), e.loadSlider(), e.initializeEvents(), e.updateArrows(), e.updateDots(), e.checkResponsive(!0), e.focusHandler()),
                i && e.$slider.trigger("init", [e]),
                !0 === e.options.accessibility && e.initADA(),
                e.options.autoplay && ((e.paused = !1), e.autoPlay());
        }),
        (r.prototype.initADA = function () {
            var t = this,
                o = Math.ceil(t.slideCount / t.options.slidesToShow),
                s = t.getNavigableIndexes().filter(function (i) {
                    return 0 <= i && i < t.slideCount;
                });
            t.$slides.add(t.$slideTrack.find(".slick-cloned")).attr({ "aria-hidden": "true", tabindex: "-1" }).find("a, input, button, select").attr({ tabindex: "-1" }),
                null !== t.$dots &&
                    (t.$slides.not(t.$slideTrack.find(".slick-cloned")).each(function (i) {
                        var e = s.indexOf(i);
                        a(this).attr({ role: "tabpanel", id: "slick-slide" + t.instanceUid + i, tabindex: -1 }), -1 !== e && a(this).attr({ "aria-describedby": "slick-slide-control" + t.instanceUid + e });
                    }),
                    t.$dots
                        .attr("role", "tablist")
                        .find("li")
                        .each(function (i) {
                            var e = s[i];
                            a(this).attr({ role: "presentation" }),
                                a(this)
                                    .find("button")
                                    .first()
                                    .attr({ role: "tab", id: "slick-slide-control" + t.instanceUid + i, "aria-controls": "slick-slide" + t.instanceUid + e, "aria-label": i + 1 + " of " + o, "aria-selected": null, tabindex: "-1" });
                        })
                        .eq(t.currentSlide)
                        .find("button")
                        .attr({ "aria-selected": "true", tabindex: "0" })
                        .end());
            for (var i = t.currentSlide, e = i + t.options.slidesToShow; i < e; i++) t.$slides.eq(i).attr("tabindex", 0);
            t.activateADA();
        }),
        (r.prototype.initArrowEvents = function () {
            var i = this;
            !0 === i.options.arrows &&
                i.slideCount > i.options.slidesToShow &&
                (i.$prevArrow.off("click.slick").on("click.slick", { message: "previous" }, i.changeSlide),
                i.$nextArrow.off("click.slick").on("click.slick", { message: "next" }, i.changeSlide),
                !0 === i.options.accessibility && (i.$prevArrow.on("keydown.slick", i.keyHandler), i.$nextArrow.on("keydown.slick", i.keyHandler)));
        }),
        (r.prototype.initDotEvents = function () {
            var i = this;
            !0 === i.options.dots && (a("li", i.$dots).on("click.slick", { message: "index" }, i.changeSlide), !0 === i.options.accessibility && i.$dots.on("keydown.slick", i.keyHandler)),
                !0 === i.options.dots && !0 === i.options.pauseOnDotsHover && a("li", i.$dots).on("mouseenter.slick", a.proxy(i.interrupt, i, !0)).on("mouseleave.slick", a.proxy(i.interrupt, i, !1));
        }),
        (r.prototype.initSlideEvents = function () {
            var i = this;
            i.options.pauseOnHover && (i.$list.on("mouseenter.slick", a.proxy(i.interrupt, i, !0)), i.$list.on("mouseleave.slick", a.proxy(i.interrupt, i, !1)));
        }),
        (r.prototype.initializeEvents = function () {
            var i = this;
            i.initArrowEvents(),
                i.initDotEvents(),
                i.initSlideEvents(),
                i.$list.on("touchstart.slick mousedown.slick", { action: "start" }, i.swipeHandler),
                i.$list.on("touchmove.slick mousemove.slick", { action: "move" }, i.swipeHandler),
                i.$list.on("touchend.slick mouseup.slick", { action: "end" }, i.swipeHandler),
                i.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, i.swipeHandler),
                i.$list.on("click.slick", i.clickHandler),
                a(document).on(i.visibilityChange, a.proxy(i.visibility, i)),
                !0 === i.options.accessibility && i.$list.on("keydown.slick", i.keyHandler),
                !0 === i.options.focusOnSelect && a(i.$slideTrack).children().on("click.slick", i.selectHandler),
                a(window).on("orientationchange.slick.slick-" + i.instanceUid, a.proxy(i.orientationChange, i)),
                a(window).on("resize.slick.slick-" + i.instanceUid, a.proxy(i.resize, i)),
                a("[draggable!=true]", i.$slideTrack).on("dragstart", i.preventDefault),
                a(window).on("load.slick.slick-" + i.instanceUid, i.setPosition),
                a(i.setPosition);
        }),
        (r.prototype.initUI = function () {
            var i = this;
            !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(), i.$nextArrow.show()), !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.show();
        }),
        (r.prototype.keyHandler = function (i) {
            var e = this;
            i.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
                (37 === i.keyCode && !0 === e.options.accessibility
                    ? e.changeSlide({ data: { message: !0 === e.options.rtl ? "next" : "previous" } })
                    : 39 === i.keyCode && !0 === e.options.accessibility && e.changeSlide({ data: { message: !0 === e.options.rtl ? "previous" : "next" } }));
        }),
        (r.prototype.lazyLoad = function () {
            function i(i) {
                a("img[data-lazy]", i).each(function () {
                    var i = a(this),
                        e = a(this).attr("data-lazy"),
                        t = a(this).attr("data-srcset"),
                        o = a(this).attr("data-sizes") || n.$slider.attr("data-sizes"),
                        s = document.createElement("img");
                    (s.onload = function () {
                        i.animate({ opacity: 0 }, 100, function () {
                            t && (i.attr("srcset", t), o && i.attr("sizes", o)),
                                i.attr("src", e).animate({ opacity: 1 }, 200, function () {
                                    i.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading");
                                }),
                                n.$slider.trigger("lazyLoaded", [n, i, e]);
                        });
                    }),
                        (s.onerror = function () {
                            i.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), n.$slider.trigger("lazyLoadError", [n, i, e]);
                        }),
                        (s.src = e);
                });
            }
            var e,
                t,
                o,
                n = this;
            if (
                (!0 === n.options.centerMode
                    ? (o =
                          !0 === n.options.infinite
                              ? (t = n.currentSlide + (n.options.slidesToShow / 2 + 1)) + n.options.slidesToShow + 2
                              : ((t = Math.max(0, n.currentSlide - (n.options.slidesToShow / 2 + 1))), n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide))
                    : ((t = n.options.infinite ? n.options.slidesToShow + n.currentSlide : n.currentSlide), (o = Math.ceil(t + n.options.slidesToShow)), !0 === n.options.fade && (0 < t && t--, o <= n.slideCount && o++)),
                (e = n.$slider.find(".slick-slide").slice(t, o)),
                "anticipated" === n.options.lazyLoad)
            )
                for (var s = t - 1, r = o, l = n.$slider.find(".slick-slide"), d = 0; d < n.options.slidesToScroll; d++) s < 0 && (s = n.slideCount - 1), (e = (e = e.add(l.eq(s))).add(l.eq(r))), s--, r++;
            i(e),
                n.slideCount <= n.options.slidesToShow
                    ? i(n.$slider.find(".slick-slide"))
                    : n.currentSlide >= n.slideCount - n.options.slidesToShow
                    ? i(n.$slider.find(".slick-cloned").slice(0, n.options.slidesToShow))
                    : 0 === n.currentSlide && i(n.$slider.find(".slick-cloned").slice(-1 * n.options.slidesToShow));
        }),
        (r.prototype.loadSlider = function () {
            var i = this;
            i.setPosition(), i.$slideTrack.css({ opacity: 1 }), i.$slider.removeClass("slick-loading"), i.initUI(), "progressive" === i.options.lazyLoad && i.progressiveLazyLoad();
        }),
        (r.prototype.next = r.prototype.slickNext = function () {
            this.changeSlide({ data: { message: "next" } });
        }),
        (r.prototype.orientationChange = function () {
            this.checkResponsive(), this.setPosition();
        }),
        (r.prototype.pause = r.prototype.slickPause = function () {
            this.autoPlayClear(), (this.paused = !0);
        }),
        (r.prototype.play = r.prototype.slickPlay = function () {
            var i = this;
            i.autoPlay(), (i.options.autoplay = !0), (i.paused = !1), (i.focussed = !1), (i.interrupted = !1);
        }),
        (r.prototype.postSlide = function (i) {
            var e = this;
            e.unslicked ||
                (e.$slider.trigger("afterChange", [e, i]),
                (e.animating = !1),
                e.slideCount > e.options.slidesToShow && e.setPosition(),
                (e.swipeLeft = null),
                e.options.autoplay && e.autoPlay(),
                !0 === e.options.accessibility && (e.initADA(), e.options.focusOnChange && a(e.$slides.get(e.currentSlide)).attr("tabindex", 0).focus()));
        }),
        (r.prototype.prev = r.prototype.slickPrev = function () {
            this.changeSlide({ data: { message: "previous" } });
        }),
        (r.prototype.preventDefault = function (i) {
            i.preventDefault();
        }),
        (r.prototype.progressiveLazyLoad = function (i) {
            i = i || 1;
            var e,
                t,
                o,
                s,
                n,
                r = this,
                l = a("img[data-lazy]", r.$slider);
            l.length
                ? ((e = l.first()),
                  (t = e.attr("data-lazy")),
                  (o = e.attr("data-srcset")),
                  (s = e.attr("data-sizes") || r.$slider.attr("data-sizes")),
                  ((n = document.createElement("img")).onload = function () {
                      o && (e.attr("srcset", o), s && e.attr("sizes", s)),
                          e.attr("src", t).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),
                          !0 === r.options.adaptiveHeight && r.setPosition(),
                          r.$slider.trigger("lazyLoaded", [r, e, t]),
                          r.progressiveLazyLoad();
                  }),
                  (n.onerror = function () {
                      i < 3
                          ? setTimeout(function () {
                                r.progressiveLazyLoad(i + 1);
                            }, 500)
                          : (e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), r.$slider.trigger("lazyLoadError", [r, e, t]), r.progressiveLazyLoad());
                  }),
                  (n.src = t))
                : r.$slider.trigger("allImagesLoaded", [r]);
        }),
        (r.prototype.refresh = function (i) {
            var e,
                t,
                o = this;
            (t = o.slideCount - o.options.slidesToShow),
                !o.options.infinite && o.currentSlide > t && (o.currentSlide = t),
                o.slideCount <= o.options.slidesToShow && (o.currentSlide = 0),
                (e = o.currentSlide),
                o.destroy(!0),
                a.extend(o, o.initials, { currentSlide: e }),
                o.init(),
                i || o.changeSlide({ data: { message: "index", index: e } }, !1);
        }),
        (r.prototype.registerBreakpoints = function () {
            var i,
                e,
                t,
                o = this,
                s = o.options.responsive || null;
            if ("array" === a.type(s) && s.length) {
                for (i in ((o.respondTo = o.options.respondTo || "window"), s))
                    if (((t = o.breakpoints.length - 1), s.hasOwnProperty(i))) {
                        for (e = s[i].breakpoint; 0 <= t; ) o.breakpoints[t] && o.breakpoints[t] === e && o.breakpoints.splice(t, 1), t--;
                        o.breakpoints.push(e), (o.breakpointSettings[e] = s[i].settings);
                    }
                o.breakpoints.sort(function (i, e) {
                    return o.options.mobileFirst ? i - e : e - i;
                });
            }
        }),
        (r.prototype.reinit = function () {
            var i = this;
            (i.$slides = i.$slideTrack.children(i.options.slide).addClass("slick-slide")),
                (i.slideCount = i.$slides.length),
                i.currentSlide >= i.slideCount && 0 !== i.currentSlide && (i.currentSlide = i.currentSlide - i.options.slidesToScroll),
                i.slideCount <= i.options.slidesToShow && (i.currentSlide = 0),
                i.registerBreakpoints(),
                i.setProps(),
                i.setupInfinite(),
                i.buildArrows(),
                i.updateArrows(),
                i.initArrowEvents(),
                i.buildDots(),
                i.updateDots(),
                i.initDotEvents(),
                i.cleanUpSlideEvents(),
                i.initSlideEvents(),
                i.checkResponsive(!1, !0),
                !0 === i.options.focusOnSelect && a(i.$slideTrack).children().on("click.slick", i.selectHandler),
                i.setSlideClasses("number" == typeof i.currentSlide ? i.currentSlide : 0),
                i.setPosition(),
                i.focusHandler(),
                (i.paused = !i.options.autoplay),
                i.autoPlay(),
                i.$slider.trigger("reInit", [i]);
        }),
        (r.prototype.resize = function () {
            var i = this;
            a(window).width() !== i.windowWidth &&
                (clearTimeout(i.windowDelay),
                (i.windowDelay = window.setTimeout(function () {
                    (i.windowWidth = a(window).width()), i.checkResponsive(), i.unslicked || i.setPosition();
                }, 50)));
        }),
        (r.prototype.removeSlide = r.prototype.slickRemove = function (i, e, t) {
            var o = this;
            if (((i = "boolean" == typeof i ? (!0 === (e = i) ? 0 : o.slideCount - 1) : !0 === e ? --i : i), o.slideCount < 1 || i < 0 || i > o.slideCount - 1)) return !1;
            o.unload(),
                !0 === t ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(i).remove(),
                (o.$slides = o.$slideTrack.children(this.options.slide)),
                o.$slideTrack.children(this.options.slide).detach(),
                o.$slideTrack.append(o.$slides),
                (o.$slidesCache = o.$slides),
                o.reinit();
        }),
        (r.prototype.setCSS = function (i) {
            var e,
                t,
                o = this,
                s = {};
            !0 === o.options.rtl && (i = -i),
                (e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px"),
                (t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px"),
                (s[o.positionProp] = i),
                !1 === o.transformsEnabled || (!(s = {}) === o.cssTransitions ? (s[o.animType] = "translate(" + e + ", " + t + ")") : (s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)")),
                o.$slideTrack.css(s);
        }),
        (r.prototype.setDimensions = function () {
            var i = this;
            !1 === i.options.vertical
                ? !0 === i.options.centerMode && i.$list.css({ padding: "0px " + i.options.centerPadding })
                : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow), !0 === i.options.centerMode && i.$list.css({ padding: i.options.centerPadding + " 0px" })),
                (i.listWidth = i.$list.width()),
                (i.listHeight = i.$list.height()),
                !1 === i.options.vertical && !1 === i.options.variableWidth
                    ? ((i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow)), i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children(".slick-slide").length)))
                    : !0 === i.options.variableWidth
                    ? i.$slideTrack.width(5e3 * i.slideCount)
                    : ((i.slideWidth = Math.ceil(i.listWidth)), i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children(".slick-slide").length)));
            var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
            !1 === i.options.variableWidth && i.$slideTrack.children(".slick-slide").width(i.slideWidth - e);
        }),
        (r.prototype.setFade = function () {
            var t,
                o = this;
            o.$slides.each(function (i, e) {
                (t = o.slideWidth * i * -1),
                    !0 === o.options.rtl ? a(e).css({ position: "relative", right: t, top: 0, zIndex: o.options.zIndex - 2, opacity: 0 }) : a(e).css({ position: "relative", left: t, top: 0, zIndex: o.options.zIndex - 2, opacity: 0 });
            }),
                o.$slides.eq(o.currentSlide).css({ zIndex: o.options.zIndex - 1, opacity: 1 });
        }),
        (r.prototype.setHeight = function () {
            var i = this;
            if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
                var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
                i.$list.css("height", e);
            }
        }),
        (r.prototype.setOption = r.prototype.slickSetOption = function () {
            var i,
                e,
                t,
                o,
                s,
                n = this,
                r = !1;
            if (
                ("object" === a.type(arguments[0])
                    ? ((t = arguments[0]), (r = arguments[1]), (s = "multiple"))
                    : "string" === a.type(arguments[0]) &&
                      ((t = arguments[0]), (o = arguments[1]), (r = arguments[2]), "responsive" === arguments[0] && "array" === a.type(arguments[1]) ? (s = "responsive") : void 0 !== arguments[1] && (s = "single")),
                "single" === s)
            )
                n.options[t] = o;
            else if ("multiple" === s)
                a.each(t, function (i, e) {
                    n.options[i] = e;
                });
            else if ("responsive" === s)
                for (e in o)
                    if ("array" !== a.type(n.options.responsive)) n.options.responsive = [o[e]];
                    else {
                        for (i = n.options.responsive.length - 1; 0 <= i; ) n.options.responsive[i].breakpoint === o[e].breakpoint && n.options.responsive.splice(i, 1), i--;
                        n.options.responsive.push(o[e]);
                    }
            r && (n.unload(), n.reinit());
        }),
        (r.prototype.setPosition = function () {
            var i = this;
            i.setDimensions(), i.setHeight(), !1 === i.options.fade ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(), i.$slider.trigger("setPosition", [i]);
        }),
        (r.prototype.setProps = function () {
            var i = this,
                e = document.body.style;
            (i.positionProp = !0 === i.options.vertical ? "top" : "left"),
                "top" === i.positionProp ? i.$slider.addClass("slick-vertical") : i.$slider.removeClass("slick-vertical"),
                (void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition) || (!0 === i.options.useCSS && (i.cssTransitions = !0)),
                i.options.fade && ("number" == typeof i.options.zIndex ? i.options.zIndex < 3 && (i.options.zIndex = 3) : (i.options.zIndex = i.defaults.zIndex)),
                void 0 !== e.OTransform && ((i.animType = "OTransform"), (i.transformType = "-o-transform"), (i.transitionType = "OTransition"), void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)),
                void 0 !== e.MozTransform && ((i.animType = "MozTransform"), (i.transformType = "-moz-transform"), (i.transitionType = "MozTransition"), void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)),
                void 0 !== e.webkitTransform &&
                    ((i.animType = "webkitTransform"), (i.transformType = "-webkit-transform"), (i.transitionType = "webkitTransition"), void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)),
                void 0 !== e.msTransform && ((i.animType = "msTransform"), (i.transformType = "-ms-transform"), (i.transitionType = "msTransition"), void 0 === e.msTransform && (i.animType = !1)),
                void 0 !== e.transform && !1 !== i.animType && ((i.animType = "transform"), (i.transformType = "transform"), (i.transitionType = "transition")),
                (i.transformsEnabled = i.options.useTransform && null !== i.animType && !1 !== i.animType);
        }),
        (r.prototype.setSlideClasses = function (i) {
            var e,
                t,
                o,
                s,
                n = this;
            if (((t = n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true")), n.$slides.eq(i).addClass("slick-current"), !0 === n.options.centerMode)) {
                var r = n.options.slidesToShow % 2 == 0 ? 1 : 0;
                (e = Math.floor(n.options.slidesToShow / 2)),
                    !0 === n.options.infinite &&
                        (e <= i && i <= n.slideCount - 1 - e
                            ? n.$slides
                                  .slice(i - e + r, i + e + 1)
                                  .addClass("slick-active")
                                  .attr("aria-hidden", "false")
                            : ((o = n.options.slidesToShow + i),
                              t
                                  .slice(o - e + 1 + r, o + e + 2)
                                  .addClass("slick-active")
                                  .attr("aria-hidden", "false")),
                        0 === i ? t.eq(t.length - 1 - n.options.slidesToShow).addClass("slick-center") : i === n.slideCount - 1 && t.eq(n.options.slidesToShow).addClass("slick-center")),
                    n.$slides.eq(i).addClass("slick-center");
            } else
                0 <= i && i <= n.slideCount - n.options.slidesToShow
                    ? n.$slides
                          .slice(i, i + n.options.slidesToShow)
                          .addClass("slick-active")
                          .attr("aria-hidden", "false")
                    : t.length <= n.options.slidesToShow
                    ? t.addClass("slick-active").attr("aria-hidden", "false")
                    : ((s = n.slideCount % n.options.slidesToShow),
                      (o = !0 === n.options.infinite ? n.options.slidesToShow + i : i),
                      n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - i < n.options.slidesToShow
                          ? t
                                .slice(o - (n.options.slidesToShow - s), o + s)
                                .addClass("slick-active")
                                .attr("aria-hidden", "false")
                          : t
                                .slice(o, o + n.options.slidesToShow)
                                .addClass("slick-active")
                                .attr("aria-hidden", "false"));
            ("ondemand" !== n.options.lazyLoad && "anticipated" !== n.options.lazyLoad) || n.lazyLoad();
        }),
        (r.prototype.setupInfinite = function () {
            var i,
                e,
                t,
                o = this;
            if ((!0 === o.options.fade && (o.options.centerMode = !1), !0 === o.options.infinite && !1 === o.options.fade && ((e = null), o.slideCount > o.options.slidesToShow))) {
                for (t = !0 === o.options.centerMode ? o.options.slidesToShow + 1 : o.options.slidesToShow, i = o.slideCount; i > o.slideCount - t; i -= 1)
                    (e = i - 1),
                        a(o.$slides[e])
                            .clone(!0)
                            .attr("id", "")
                            .attr("data-slick-index", e - o.slideCount)
                            .prependTo(o.$slideTrack)
                            .addClass("slick-cloned");
                for (i = 0; i < t + o.slideCount; i += 1)
                    (e = i),
                        a(o.$slides[e])
                            .clone(!0)
                            .attr("id", "")
                            .attr("data-slick-index", e + o.slideCount)
                            .appendTo(o.$slideTrack)
                            .addClass("slick-cloned");
                o.$slideTrack
                    .find(".slick-cloned")
                    .find("[id]")
                    .each(function () {
                        a(this).attr("id", "");
                    });
            }
        }),
        (r.prototype.interrupt = function (i) {
            i || this.autoPlay(), (this.interrupted = i);
        }),
        (r.prototype.selectHandler = function (i) {
            var e = a(i.target).is(".slick-slide") ? a(i.target) : a(i.target).parents(".slick-slide"),
                t = parseInt(e.attr("data-slick-index"));
            t || (t = 0), this.slideCount <= this.options.slidesToShow ? this.slideHandler(t, !1, !0) : this.slideHandler(t);
        }),
        (r.prototype.slideHandler = function (i, e, t) {
            var o,
                s,
                n,
                r,
                l,
                d = null,
                a = this;
            if (((e = e || !1), !((!0 === a.animating && !0 === a.options.waitForAnimate) || (!0 === a.options.fade && a.currentSlide === i))))
                if (
                    (!1 === e && a.asNavFor(i),
                    (o = i),
                    (d = a.getLeft(o)),
                    (r = a.getLeft(a.currentSlide)),
                    (a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft),
                    !1 === a.options.infinite && !1 === a.options.centerMode && (i < 0 || i > a.getDotCount() * a.options.slidesToScroll))
                )
                    !1 === a.options.fade &&
                        ((o = a.currentSlide),
                        !0 !== t
                            ? a.animateSlide(r, function () {
                                  a.postSlide(o);
                              })
                            : a.postSlide(o));
                else if (!1 === a.options.infinite && !0 === a.options.centerMode && (i < 0 || i > a.slideCount - a.options.slidesToScroll))
                    !1 === a.options.fade &&
                        ((o = a.currentSlide),
                        !0 !== t
                            ? a.animateSlide(r, function () {
                                  a.postSlide(o);
                              })
                            : a.postSlide(o));
                else {
                    if (
                        (a.options.autoplay && clearInterval(a.autoPlayTimer),
                        (s =
                            o < 0
                                ? a.slideCount % a.options.slidesToScroll != 0
                                    ? a.slideCount - (a.slideCount % a.options.slidesToScroll)
                                    : a.slideCount + o
                                : o >= a.slideCount
                                ? a.slideCount % a.options.slidesToScroll != 0
                                    ? 0
                                    : o - a.slideCount
                                : o),
                        (a.animating = !0),
                        a.$slider.trigger("beforeChange", [a, a.currentSlide, s, o]),
                        (n = a.currentSlide),
                        (a.currentSlide = s),
                        a.setSlideClasses(a.currentSlide),
                        a.options.asNavFor && (l = (l = a.getNavTarget()).slick("getSlick")).slideCount <= l.options.slidesToShow && l.setSlideClasses(a.currentSlide),
                        a.updateDots(),
                        a.updateArrows(),
                        !0 === a.options.fade)
                    )
                        return (
                            !0 !== t
                                ? (a.fadeSlideOut(n),
                                  a.fadeSlide(s, function () {
                                      a.postSlide(s);
                                  }))
                                : a.postSlide(s),
                            void a.animateHeight()
                        );
                    !0 !== t
                        ? a.animateSlide(d, function () {
                              a.postSlide(s);
                          })
                        : a.postSlide(s);
                }
        }),
        (r.prototype.startLoad = function () {
            var i = this;
            !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(), i.$nextArrow.hide()),
                !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.hide(),
                i.$slider.addClass("slick-loading");
        }),
        (r.prototype.swipeDirection = function () {
            var i,
                e,
                t,
                o,
                s = this;
            return (
                (i = s.touchObject.startX - s.touchObject.curX),
                (e = s.touchObject.startY - s.touchObject.curY),
                (t = Math.atan2(e, i)),
                (o = Math.round((180 * t) / Math.PI)) < 0 && (o = 360 - Math.abs(o)),
                o <= 45 && 0 <= o
                    ? !1 === s.options.rtl
                        ? "left"
                        : "right"
                    : o <= 360 && 315 <= o
                    ? !1 === s.options.rtl
                        ? "left"
                        : "right"
                    : 135 <= o && o <= 225
                    ? !1 === s.options.rtl
                        ? "right"
                        : "left"
                    : !0 === s.options.verticalSwiping
                    ? 35 <= o && o <= 135
                        ? "down"
                        : "up"
                    : "vertical"
            );
        }),
        (r.prototype.swipeEnd = function (i) {
            var e,
                t,
                o = this;
            if (((o.dragging = !1), (o.swiping = !1), o.scrolling)) return (o.scrolling = !1);
            if (((o.interrupted = !1), (o.shouldClick = !(10 < o.touchObject.swipeLength)), void 0 === o.touchObject.curX)) return !1;
            if ((!0 === o.touchObject.edgeHit && o.$slider.trigger("edge", [o, o.swipeDirection()]), o.touchObject.swipeLength >= o.touchObject.minSwipe)) {
                switch ((t = o.swipeDirection())) {
                    case "left":
                    case "down":
                        (e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide + o.getSlideCount()) : o.currentSlide + o.getSlideCount()), (o.currentDirection = 0);
                        break;
                    case "right":
                    case "up":
                        (e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide - o.getSlideCount()) : o.currentSlide - o.getSlideCount()), (o.currentDirection = 1);
                }
                "vertical" != t && (o.slideHandler(e), (o.touchObject = {}), o.$slider.trigger("swipe", [o, t]));
            } else o.touchObject.startX !== o.touchObject.curX && (o.slideHandler(o.currentSlide), (o.touchObject = {}));
        }),
        (r.prototype.swipeHandler = function (i) {
            var e = this;
            if (!(!1 === e.options.swipe || ("ontouchend" in document && !1 === e.options.swipe) || (!1 === e.options.draggable && -1 !== i.type.indexOf("mouse"))))
                switch (
                    ((e.touchObject.fingerCount = i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1),
                    (e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold),
                    !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold),
                    i.data.action)
                ) {
                    case "start":
                        e.swipeStart(i);
                        break;
                    case "move":
                        e.swipeMove(i);
                        break;
                    case "end":
                        e.swipeEnd(i);
                }
        }),
        (r.prototype.swipeMove = function (i) {
            var e,
                t,
                o,
                s,
                n,
                r,
                l = this;
            return (
                (n = void 0 !== i.originalEvent ? i.originalEvent.touches : null),
                !(!l.dragging || l.scrolling || (n && 1 !== n.length)) &&
                    ((e = l.getLeft(l.currentSlide)),
                    (l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX),
                    (l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY),
                    (l.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2)))),
                    (r = Math.round(Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2)))),
                    !l.options.verticalSwiping && !l.swiping && 4 < r
                        ? !(l.scrolling = !0)
                        : (!0 === l.options.verticalSwiping && (l.touchObject.swipeLength = r),
                          (t = l.swipeDirection()),
                          void 0 !== i.originalEvent && 4 < l.touchObject.swipeLength && ((l.swiping = !0), i.preventDefault()),
                          (s = (!1 === l.options.rtl ? 1 : -1) * (l.touchObject.curX > l.touchObject.startX ? 1 : -1)),
                          !0 === l.options.verticalSwiping && (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1),
                          (o = l.touchObject.swipeLength),
                          (l.touchObject.edgeHit = !1) === l.options.infinite &&
                              ((0 === l.currentSlide && "right" === t) || (l.currentSlide >= l.getDotCount() && "left" === t)) &&
                              ((o = l.touchObject.swipeLength * l.options.edgeFriction), (l.touchObject.edgeHit = !0)),
                          !1 === l.options.vertical ? (l.swipeLeft = e + o * s) : (l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s),
                          !0 === l.options.verticalSwiping && (l.swipeLeft = e + o * s),
                          !0 !== l.options.fade && !1 !== l.options.touchMove && (!0 === l.animating ? ((l.swipeLeft = null), !1) : void l.setCSS(l.swipeLeft))))
            );
        }),
        (r.prototype.swipeStart = function (i) {
            var e,
                t = this;
            if (((t.interrupted = !0), 1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow)) return !(t.touchObject = {});
            void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]),
                (t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX),
                (t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY),
                (t.dragging = !0);
        }),
        (r.prototype.unfilterSlides = r.prototype.slickUnfilter = function () {
            var i = this;
            null !== i.$slidesCache && (i.unload(), i.$slideTrack.children(this.options.slide).detach(), i.$slidesCache.appendTo(i.$slideTrack), i.reinit());
        }),
        (r.prototype.unload = function () {
            var i = this;
            a(".slick-cloned", i.$slider).remove(),
                i.$dots && i.$dots.remove(),
                i.$prevArrow && i.htmlExpr.test(i.options.prevArrow) && i.$prevArrow.remove(),
                i.$nextArrow && i.htmlExpr.test(i.options.nextArrow) && i.$nextArrow.remove(),
                i.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "");
        }),
        (r.prototype.unslick = function (i) {
            this.$slider.trigger("unslick", [this, i]), this.destroy();
        }),
        (r.prototype.updateArrows = function () {
            var i = this;
            Math.floor(i.options.slidesToShow / 2),
                !0 === i.options.arrows &&
                    i.slideCount > i.options.slidesToShow &&
                    !i.options.infinite &&
                    (i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                    i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                    0 === i.currentSlide
                        ? (i.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))
                        : i.currentSlide >= i.slideCount - i.options.slidesToShow && !1 === i.options.centerMode
                        ? (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))
                        : i.currentSlide >= i.slideCount - 1 &&
                          !0 === i.options.centerMode &&
                          (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")));
        }),
        (r.prototype.updateDots = function () {
            var i = this;
            null !== i.$dots &&
                (i.$dots.find("li").removeClass("slick-active").end(),
                i.$dots
                    .find("li")
                    .eq(Math.floor(i.currentSlide / i.options.slidesToScroll))
                    .addClass("slick-active"));
        }),
        (r.prototype.visibility = function () {
            this.options.autoplay && (document[this.hidden] ? (this.interrupted = !0) : (this.interrupted = !1));
        }),
        (a.fn.slick = function () {
            var i,
                e,
                t = this,
                o = arguments[0],
                s = Array.prototype.slice.call(arguments, 1),
                n = t.length;
            for (i = 0; i < n; i++) if (("object" == typeof o || void 0 === o ? (t[i].slick = new r(t[i], o)) : (e = t[i].slick[o].apply(t[i].slick, s)), void 0 !== e)) return e;
            return t;
        });
});
/*! Flickity v2.2.0 */
!(function (e, i) {
    "function" == typeof define && define.amd
        ? define("jquery-bridget/jquery-bridget", ["jquery"], function (t) {
              return i(e, t);
          })
        : "object" == typeof module && module.exports
        ? (module.exports = i(e, require("jquery")))
        : (e.jQueryBridget = i(e, e.jQuery));
})(window, function (t, e) {
    "use strict";
    var d = Array.prototype.slice,
        i = t.console,
        u =
            void 0 === i
                ? function () {}
                : function (t) {
                      i.error(t);
                  };
    function n(h, s, c) {
        (c = c || e || t.jQuery) &&
            (s.prototype.option ||
                (s.prototype.option = function (t) {
                    c.isPlainObject(t) && (this.options = c.extend(!0, this.options, t));
                }),
            (c.fn[h] = function (t) {
                if ("string" != typeof t)
                    return (
                        (n = t),
                        this.each(function (t, e) {
                            var i = c.data(e, h);
                            i ? (i.option(n), i._init()) : ((i = new s(e, n)), c.data(e, h, i));
                        }),
                        this
                    );
                var e,
                    o,
                    r,
                    a,
                    l,
                    n,
                    i = d.call(arguments, 1);
                return (
                    (r = i),
                    (l = "$()." + h + '("' + (o = t) + '")'),
                    (e = this).each(function (t, e) {
                        var i = c.data(e, h);
                        if (i) {
                            var n = i[o];
                            if (n && "_" != o.charAt(0)) {
                                var s = n.apply(i, r);
                                a = void 0 === a ? s : a;
                            } else u(l + " is not a valid method");
                        } else u(h + " not initialized. Cannot call methods, i.e. " + l);
                    }),
                    void 0 !== a ? a : e
                );
            }),
            o(c));
    }
    function o(t) {
        !t || (t && t.bridget) || (t.bridget = n);
    }
    return o(e || t.jQuery), n;
}),
    (function (t, e) {
        "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == typeof module && module.exports ? (module.exports = e()) : (t.EvEmitter = e());
    })("undefined" != typeof window ? window : this, function () {
        function t() {}
        var e = t.prototype;
        return (
            (e.on = function (t, e) {
                if (t && e) {
                    var i = (this._events = this._events || {}),
                        n = (i[t] = i[t] || []);
                    return -1 == n.indexOf(e) && n.push(e), this;
                }
            }),
            (e.once = function (t, e) {
                if (t && e) {
                    this.on(t, e);
                    var i = (this._onceEvents = this._onceEvents || {});
                    return ((i[t] = i[t] || {})[e] = !0), this;
                }
            }),
            (e.off = function (t, e) {
                var i = this._events && this._events[t];
                if (i && i.length) {
                    var n = i.indexOf(e);
                    return -1 != n && i.splice(n, 1), this;
                }
            }),
            (e.emitEvent = function (t, e) {
                var i = this._events && this._events[t];
                if (i && i.length) {
                    (i = i.slice(0)), (e = e || []);
                    for (var n = this._onceEvents && this._onceEvents[t], s = 0; s < i.length; s++) {
                        var o = i[s];
                        n && n[o] && (this.off(t, o), delete n[o]), o.apply(this, e);
                    }
                    return this;
                }
            }),
            (e.allOff = function () {
                delete this._events, delete this._onceEvents;
            }),
            t
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd ? define("get-size/get-size", e) : "object" == typeof module && module.exports ? (module.exports = e()) : (t.getSize = e());
    })(window, function () {
        "use strict";
        function m(t) {
            var e = parseFloat(t);
            return -1 == t.indexOf("%") && !isNaN(e) && e;
        }
        var i =
                "undefined" == typeof console
                    ? function () {}
                    : function (t) {
                          console.error(t);
                      },
            y = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
            b = y.length;
        function E(t) {
            var e = getComputedStyle(t);
            return e || i("Style returned " + e + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), e;
        }
        var S,
            C = !1;
        function x(t) {
            if (
                ((function () {
                    if (!C) {
                        C = !0;
                        var t = document.createElement("div");
                        (t.style.width = "200px"), (t.style.padding = "1px 2px 3px 4px"), (t.style.borderStyle = "solid"), (t.style.borderWidth = "1px 2px 3px 4px"), (t.style.boxSizing = "border-box");
                        var e = document.body || document.documentElement;
                        e.appendChild(t);
                        var i = E(t);
                        (S = 200 == Math.round(m(i.width))), (x.isBoxSizeOuter = S), e.removeChild(t);
                    }
                })(),
                "string" == typeof t && (t = document.querySelector(t)),
                t && "object" == typeof t && t.nodeType)
            ) {
                var e = E(t);
                if ("none" == e.display)
                    return (function () {
                        for (var t = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 }, e = 0; e < b; e++) t[y[e]] = 0;
                        return t;
                    })();
                var i = {};
                (i.width = t.offsetWidth), (i.height = t.offsetHeight);
                for (var n = (i.isBorderBox = "border-box" == e.boxSizing), s = 0; s < b; s++) {
                    var o = y[s],
                        r = e[o],
                        a = parseFloat(r);
                    i[o] = isNaN(a) ? 0 : a;
                }
                var l = i.paddingLeft + i.paddingRight,
                    h = i.paddingTop + i.paddingBottom,
                    c = i.marginLeft + i.marginRight,
                    d = i.marginTop + i.marginBottom,
                    u = i.borderLeftWidth + i.borderRightWidth,
                    f = i.borderTopWidth + i.borderBottomWidth,
                    p = n && S,
                    g = m(e.width);
                !1 !== g && (i.width = g + (p ? 0 : l + u));
                var v = m(e.height);
                return !1 !== v && (i.height = v + (p ? 0 : h + f)), (i.innerWidth = i.width - (l + u)), (i.innerHeight = i.height - (h + f)), (i.outerWidth = i.width + c), (i.outerHeight = i.height + d), i;
            }
        }
        return x;
    }),
    (function (t, e) {
        "use strict";
        "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", e) : "object" == typeof module && module.exports ? (module.exports = e()) : (t.matchesSelector = e());
    })(window, function () {
        "use strict";
        var i = (function () {
            var t = window.Element.prototype;
            if (t.matches) return "matches";
            if (t.matchesSelector) return "matchesSelector";
            for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
                var n = e[i] + "MatchesSelector";
                if (t[n]) return n;
            }
        })();
        return function (t, e) {
            return t[i](e);
        };
    }),
    (function (e, i) {
        "function" == typeof define && define.amd
            ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function (t) {
                  return i(e, t);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = i(e, require("desandro-matches-selector")))
            : (e.fizzyUIUtils = i(e, e.matchesSelector));
    })(window, function (h, o) {
        var c = {
                extend: function (t, e) {
                    for (var i in e) t[i] = e[i];
                    return t;
                },
                modulo: function (t, e) {
                    return ((t % e) + e) % e;
                },
            },
            e = Array.prototype.slice;
        (c.makeArray = function (t) {
            return Array.isArray(t) ? t : null == t ? [] : "object" == typeof t && "number" == typeof t.length ? e.call(t) : [t];
        }),
            (c.removeFrom = function (t, e) {
                var i = t.indexOf(e);
                -1 != i && t.splice(i, 1);
            }),
            (c.getParent = function (t, e) {
                for (; t.parentNode && t != document.body; ) if (((t = t.parentNode), o(t, e))) return t;
            }),
            (c.getQueryElement = function (t) {
                return "string" == typeof t ? document.querySelector(t) : t;
            }),
            (c.handleEvent = function (t) {
                var e = "on" + t.type;
                this[e] && this[e](t);
            }),
            (c.filterFindElements = function (t, n) {
                t = c.makeArray(t);
                var s = [];
                return (
                    t.forEach(function (t) {
                        if (t instanceof HTMLElement)
                            if (n) {
                                o(t, n) && s.push(t);
                                for (var e = t.querySelectorAll(n), i = 0; i < e.length; i++) s.push(e[i]);
                            } else s.push(t);
                    }),
                    s
                );
            }),
            (c.debounceMethod = function (t, e, n) {
                n = n || 100;
                var s = t.prototype[e],
                    o = e + "Timeout";
                t.prototype[e] = function () {
                    var t = this[o];
                    clearTimeout(t);
                    var e = arguments,
                        i = this;
                    this[o] = setTimeout(function () {
                        s.apply(i, e), delete i[o];
                    }, n);
                };
            }),
            (c.docReady = function (t) {
                var e = document.readyState;
                "complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t);
            }),
            (c.toDashed = function (t) {
                return t
                    .replace(/(.)([A-Z])/g, function (t, e, i) {
                        return e + "-" + i;
                    })
                    .toLowerCase();
            });
        var d = h.console;
        return (
            (c.htmlInit = function (a, l) {
                c.docReady(function () {
                    var t = c.toDashed(l),
                        s = "data-" + t,
                        e = document.querySelectorAll("[" + s + "]"),
                        i = document.querySelectorAll(".js-" + t),
                        n = c.makeArray(e).concat(c.makeArray(i)),
                        o = s + "-options",
                        r = h.jQuery;
                    n.forEach(function (e) {
                        var t,
                            i = e.getAttribute(s) || e.getAttribute(o);
                        try {
                            t = i && JSON.parse(i);
                        } catch (t) {
                            return void (d && d.error("Error parsing " + s + " on " + e.className + ": " + t));
                        }
                        var n = new a(e, t);
                        r && r.data(e, l, n);
                    });
                });
            }),
            c
        );
    }),
    (function (e, i) {
        "function" == typeof define && define.amd
            ? define("flickity/js/cell", ["get-size/get-size"], function (t) {
                  return i(e, t);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = i(e, require("get-size")))
            : ((e.Flickity = e.Flickity || {}), (e.Flickity.Cell = i(e, e.getSize)));
    })(window, function (t, e) {
        function i(t, e) {
            (this.element = t), (this.parent = e), this.create();
        }
        var n = i.prototype;
        return (
            (n.create = function () {
                (this.element.style.position = "absolute"), this.element.setAttribute("aria-hidden", "true"), (this.x = 0), (this.shift = 0);
            }),
            (n.destroy = function () {
                this.unselect(), (this.element.style.position = "");
                var t = this.parent.originSide;
                this.element.style[t] = "";
            }),
            (n.getSize = function () {
                this.size = e(this.element);
            }),
            (n.setPosition = function (t) {
                (this.x = t), this.updateTarget(), this.renderPosition(t);
            }),
            (n.updateTarget = n.setDefaultTarget = function () {
                var t = "left" == this.parent.originSide ? "marginLeft" : "marginRight";
                this.target = this.x + this.size[t] + this.size.width * this.parent.cellAlign;
            }),
            (n.renderPosition = function (t) {
                var e = this.parent.originSide;
                this.element.style[e] = this.parent.getPositionValue(t);
            }),
            (n.select = function () {
                this.element.classList.add("is-selected"), this.element.removeAttribute("aria-hidden");
            }),
            (n.unselect = function () {
                this.element.classList.remove("is-selected"), this.element.setAttribute("aria-hidden", "true");
            }),
            (n.wrapShift = function (t) {
                (this.shift = t), this.renderPosition(this.x + this.parent.slideableWidth * t);
            }),
            (n.remove = function () {
                this.element.parentNode.removeChild(this.element);
            }),
            i
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd ? define("flickity/js/slide", e) : "object" == typeof module && module.exports ? (module.exports = e()) : ((t.Flickity = t.Flickity || {}), (t.Flickity.Slide = e()));
    })(window, function () {
        "use strict";
        function t(t) {
            (this.parent = t), (this.isOriginLeft = "left" == t.originSide), (this.cells = []), (this.outerWidth = 0), (this.height = 0);
        }
        var e = t.prototype;
        return (
            (e.addCell = function (t) {
                if ((this.cells.push(t), (this.outerWidth += t.size.outerWidth), (this.height = Math.max(t.size.outerHeight, this.height)), 1 == this.cells.length)) {
                    this.x = t.x;
                    var e = this.isOriginLeft ? "marginLeft" : "marginRight";
                    this.firstMargin = t.size[e];
                }
            }),
            (e.updateTarget = function () {
                var t = this.isOriginLeft ? "marginRight" : "marginLeft",
                    e = this.getLastCell(),
                    i = e ? e.size[t] : 0,
                    n = this.outerWidth - (this.firstMargin + i);
                this.target = this.x + this.firstMargin + n * this.parent.cellAlign;
            }),
            (e.getLastCell = function () {
                return this.cells[this.cells.length - 1];
            }),
            (e.select = function () {
                this.cells.forEach(function (t) {
                    t.select();
                });
            }),
            (e.unselect = function () {
                this.cells.forEach(function (t) {
                    t.unselect();
                });
            }),
            (e.getCellElements = function () {
                return this.cells.map(function (t) {
                    return t.element;
                });
            }),
            t
        );
    }),
    (function (e, i) {
        "function" == typeof define && define.amd
            ? define("flickity/js/animate", ["fizzy-ui-utils/utils"], function (t) {
                  return i(e, t);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = i(e, require("fizzy-ui-utils")))
            : ((e.Flickity = e.Flickity || {}), (e.Flickity.animatePrototype = i(e, e.fizzyUIUtils)));
    })(window, function (t, e) {
        var i = {
            startAnimation: function () {
                this.isAnimating || ((this.isAnimating = !0), (this.restingFrames = 0), this.animate());
            },
            animate: function () {
                this.applyDragForce(), this.applySelectedAttraction();
                var t = this.x;
                if ((this.integratePhysics(), this.positionSlider(), this.settle(t), this.isAnimating)) {
                    var e = this;
                    requestAnimationFrame(function () {
                        e.animate();
                    });
                }
            },
            positionSlider: function () {
                var t = this.x;
                this.options.wrapAround && 1 < this.cells.length && ((t = e.modulo(t, this.slideableWidth)), (t -= this.slideableWidth), this.shiftWrapCells(t)), this.setTranslateX(t, this.isAnimating), this.dispatchScrollEvent();
            },
            setTranslateX: function (t, e) {
                (t += this.cursorPosition), (t = this.options.rightToLeft ? -t : t);
                var i = this.getPositionValue(t);
                this.slider.style.transform = e ? "translate3d(" + i + ",0,0)" : "translateX(" + i + ")";
            },
            dispatchScrollEvent: function () {
                var t = this.slides[0];
                if (t) {
                    var e = -this.x - t.target,
                        i = e / this.slidesWidth;
                    this.dispatchEvent("scroll", null, [i, e]);
                }
            },
            positionSliderAtSelected: function () {
                this.cells.length && ((this.x = -this.selectedSlide.target), (this.velocity = 0), this.positionSlider());
            },
            getPositionValue: function (t) {
                return this.options.percentPosition ? 0.01 * Math.round((t / this.size.innerWidth) * 1e4) + "%" : Math.round(t) + "px";
            },
            settle: function (t) {
                this.isPointerDown || Math.round(100 * this.x) != Math.round(100 * t) || this.restingFrames++,
                    2 < this.restingFrames && ((this.isAnimating = !1), delete this.isFreeScrolling, this.positionSlider(), this.dispatchEvent("settle", null, [this.selectedIndex]));
            },
            shiftWrapCells: function (t) {
                var e = this.cursorPosition + t;
                this._shiftCells(this.beforeShiftCells, e, -1);
                var i = this.size.innerWidth - (t + this.slideableWidth + this.cursorPosition);
                this._shiftCells(this.afterShiftCells, i, 1);
            },
            _shiftCells: function (t, e, i) {
                for (var n = 0; n < t.length; n++) {
                    var s = t[n],
                        o = 0 < e ? i : 0;
                    s.wrapShift(o), (e -= s.size.outerWidth);
                }
            },
            _unshiftCells: function (t) {
                if (t && t.length) for (var e = 0; e < t.length; e++) t[e].wrapShift(0);
            },
            integratePhysics: function () {
                (this.x += this.velocity), (this.velocity *= this.getFrictionFactor());
            },
            applyForce: function (t) {
                this.velocity += t;
            },
            getFrictionFactor: function () {
                return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"];
            },
            getRestingPosition: function () {
                return this.x + this.velocity / (1 - this.getFrictionFactor());
            },
            applyDragForce: function () {
                if (this.isDraggable && this.isPointerDown) {
                    var t = this.dragX - this.x - this.velocity;
                    this.applyForce(t);
                }
            },
            applySelectedAttraction: function () {
                if (!(this.isDraggable && this.isPointerDown) && !this.isFreeScrolling && this.slides.length) {
                    var t = (-1 * this.selectedSlide.target - this.x) * this.options.selectedAttraction;
                    this.applyForce(t);
                }
            },
        };
        return i;
    }),
    (function (r, a) {
        if ("function" == typeof define && define.amd)
            define("flickity/js/flickity", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./cell", "./slide", "./animate"], function (t, e, i, n, s, o) {
                return a(r, t, e, i, n, s, o);
            });
        else if ("object" == typeof module && module.exports) module.exports = a(r, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./cell"), require("./slide"), require("./animate"));
        else {
            var t = r.Flickity;
            r.Flickity = a(r, r.EvEmitter, r.getSize, r.fizzyUIUtils, t.Cell, t.Slide, t.animatePrototype);
        }
    })(window, function (n, t, e, a, i, r, s) {
        var l = n.jQuery,
            o = n.getComputedStyle,
            h = n.console;
        function c(t, e) {
            for (t = a.makeArray(t); t.length; ) e.appendChild(t.shift());
        }
        var d = 0,
            u = {};
        function f(t, e) {
            var i = a.getQueryElement(t);
            if (i) {
                if (((this.element = i), this.element.flickityGUID)) {
                    var n = u[this.element.flickityGUID];
                    return n.option(e), n;
                }
                l && (this.$element = l(this.element)), (this.options = a.extend({}, this.constructor.defaults)), this.option(e), this._create();
            } else h && h.error("Bad element for Flickity: " + (i || t));
        }
        (f.defaults = { accessibility: !0, cellAlign: "center", freeScrollFriction: 0.075, friction: 0.28, namespaceJQueryEvents: !0, percentPosition: !0, resize: !0, selectedAttraction: 0.025, setGallerySize: !0 }), (f.createMethods = []);
        var p = f.prototype;
        a.extend(p, t.prototype),
            (p._create = function () {
                var t = (this.guid = ++d);
                for (var e in ((this.element.flickityGUID = t),
                ((u[t] = this).selectedIndex = 0),
                (this.restingFrames = 0),
                (this.x = 0),
                (this.velocity = 0),
                (this.originSide = this.options.rightToLeft ? "right" : "left"),
                (this.viewport = document.createElement("div")),
                (this.viewport.className = "flickity-viewport"),
                this._createSlider(),
                (this.options.resize || this.options.watchCSS) && n.addEventListener("resize", this),
                this.options.on)) {
                    var i = this.options.on[e];
                    this.on(e, i);
                }
                f.createMethods.forEach(function (t) {
                    this[t]();
                }, this),
                    this.options.watchCSS ? this.watchCSS() : this.activate();
            }),
            (p.option = function (t) {
                a.extend(this.options, t);
            }),
            (p.activate = function () {
                this.isActive ||
                    ((this.isActive = !0),
                    this.element.classList.add("flickity-enabled"),
                    this.options.rightToLeft && this.element.classList.add("flickity-rtl"),
                    this.getSize(),
                    c(this._filterFindCellElements(this.element.children), this.slider),
                    this.viewport.appendChild(this.slider),
                    this.element.appendChild(this.viewport),
                    this.reloadCells(),
                    this.options.accessibility && ((this.element.tabIndex = 0), this.element.addEventListener("keydown", this)),
                    this.emitEvent("activate"),
                    this.selectInitialIndex(),
                    (this.isInitActivated = !0),
                    this.dispatchEvent("ready"));
            }),
            (p._createSlider = function () {
                var t = document.createElement("div");
                (t.className = "flickity-slider"), (t.style[this.originSide] = 0), (this.slider = t);
            }),
            (p._filterFindCellElements = function (t) {
                return a.filterFindElements(t, this.options.cellSelector);
            }),
            (p.reloadCells = function () {
                (this.cells = this._makeCells(this.slider.children)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize();
            }),
            (p._makeCells = function (t) {
                return this._filterFindCellElements(t).map(function (t) {
                    return new i(t, this);
                }, this);
            }),
            (p.getLastCell = function () {
                return this.cells[this.cells.length - 1];
            }),
            (p.getLastSlide = function () {
                return this.slides[this.slides.length - 1];
            }),
            (p.positionCells = function () {
                this._sizeCells(this.cells), this._positionCells(0);
            }),
            (p._positionCells = function (t) {
                (t = t || 0), (this.maxCellHeight = (t && this.maxCellHeight) || 0);
                var e = 0;
                if (0 < t) {
                    var i = this.cells[t - 1];
                    e = i.x + i.size.outerWidth;
                }
                for (var n = this.cells.length, s = t; s < n; s++) {
                    var o = this.cells[s];
                    o.setPosition(e), (e += o.size.outerWidth), (this.maxCellHeight = Math.max(o.size.outerHeight, this.maxCellHeight));
                }
                (this.slideableWidth = e), this.updateSlides(), this._containSlides(), (this.slidesWidth = n ? this.getLastSlide().target - this.slides[0].target : 0);
            }),
            (p._sizeCells = function (t) {
                t.forEach(function (t) {
                    t.getSize();
                });
            }),
            (p.updateSlides = function () {
                if (((this.slides = []), this.cells.length)) {
                    var n = new r(this);
                    this.slides.push(n);
                    var s = "left" == this.originSide ? "marginRight" : "marginLeft",
                        o = this._getCanCellFit();
                    this.cells.forEach(function (t, e) {
                        if (n.cells.length) {
                            var i = n.outerWidth - n.firstMargin + (t.size.outerWidth - t.size[s]);
                            o.call(this, e, i) || (n.updateTarget(), (n = new r(this)), this.slides.push(n)), n.addCell(t);
                        } else n.addCell(t);
                    }, this),
                        n.updateTarget(),
                        this.updateSelectedSlide();
                }
            }),
            (p._getCanCellFit = function () {
                var t = this.options.groupCells;
                if (!t)
                    return function () {
                        return !1;
                    };
                if ("number" == typeof t) {
                    var e = parseInt(t, 10);
                    return function (t) {
                        return t % e != 0;
                    };
                }
                var i = "string" == typeof t && t.match(/^(\d+)%$/),
                    n = i ? parseInt(i[1], 10) / 100 : 1;
                return function (t, e) {
                    return e <= (this.size.innerWidth + 1) * n;
                };
            }),
            (p._init = p.reposition = function () {
                this.positionCells(), this.positionSliderAtSelected();
            }),
            (p.getSize = function () {
                (this.size = e(this.element)), this.setCellAlign(), (this.cursorPosition = this.size.innerWidth * this.cellAlign);
            });
        var g = { center: { left: 0.5, right: 0.5 }, left: { left: 0, right: 1 }, right: { right: 0, left: 1 } };
        return (
            (p.setCellAlign = function () {
                var t = g[this.options.cellAlign];
                this.cellAlign = t ? t[this.originSide] : this.options.cellAlign;
            }),
            (p.setGallerySize = function () {
                if (this.options.setGallerySize) {
                    var t = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
                    this.viewport.style.height = t + "px";
                }
            }),
            (p._getWrapShiftCells = function () {
                if (this.options.wrapAround) {
                    this._unshiftCells(this.beforeShiftCells), this._unshiftCells(this.afterShiftCells);
                    var t = this.cursorPosition,
                        e = this.cells.length - 1;
                    (this.beforeShiftCells = this._getGapCells(t, e, -1)), (t = this.size.innerWidth - this.cursorPosition), (this.afterShiftCells = this._getGapCells(t, 0, 1));
                }
            }),
            (p._getGapCells = function (t, e, i) {
                for (var n = []; 0 < t; ) {
                    var s = this.cells[e];
                    if (!s) break;
                    n.push(s), (e += i), (t -= s.size.outerWidth);
                }
                return n;
            }),
            (p._containSlides = function () {
                if (this.options.contain && !this.options.wrapAround && this.cells.length) {
                    var t = this.options.rightToLeft,
                        e = t ? "marginRight" : "marginLeft",
                        i = t ? "marginLeft" : "marginRight",
                        n = this.slideableWidth - this.getLastCell().size[i],
                        s = n < this.size.innerWidth,
                        o = this.cursorPosition + this.cells[0].size[e],
                        r = n - this.size.innerWidth * (1 - this.cellAlign);
                    this.slides.forEach(function (t) {
                        t.target = s ? n * this.cellAlign : ((t.target = Math.max(t.target, o)), Math.min(t.target, r));
                    }, this);
                }
            }),
            (p.dispatchEvent = function (t, e, i) {
                var n = e ? [e].concat(i) : i;
                if ((this.emitEvent(t, n), l && this.$element)) {
                    var s = (t += this.options.namespaceJQueryEvents ? ".flickity" : "");
                    if (e) {
                        var o = l.Event(e);
                        (o.type = t), (s = o);
                    }
                    this.$element.trigger(s, i);
                }
            }),
            (p.select = function (t, e, i) {
                if (this.isActive && ((t = parseInt(t, 10)), this._wrapSelect(t), (this.options.wrapAround || e) && (t = a.modulo(t, this.slides.length)), this.slides[t])) {
                    var n = this.selectedIndex;
                    (this.selectedIndex = t),
                        this.updateSelectedSlide(),
                        i ? this.positionSliderAtSelected() : this.startAnimation(),
                        this.options.adaptiveHeight && this.setGallerySize(),
                        this.dispatchEvent("select", null, [t]),
                        t != n && this.dispatchEvent("change", null, [t]),
                        this.dispatchEvent("cellSelect");
                }
            }),
            (p._wrapSelect = function (t) {
                var e = this.slides.length;
                if (!(this.options.wrapAround && 1 < e)) return t;
                var i = a.modulo(t, e),
                    n = Math.abs(i - this.selectedIndex),
                    s = Math.abs(i + e - this.selectedIndex),
                    o = Math.abs(i - e - this.selectedIndex);
                !this.isDragSelect && s < n ? (t += e) : !this.isDragSelect && o < n && (t -= e), t < 0 ? (this.x -= this.slideableWidth) : e <= t && (this.x += this.slideableWidth);
            }),
            (p.previous = function (t, e) {
                this.select(this.selectedIndex - 1, t, e);
            }),
            (p.next = function (t, e) {
                this.select(this.selectedIndex + 1, t, e);
            }),
            (p.updateSelectedSlide = function () {
                var t = this.slides[this.selectedIndex];
                t &&
                    (this.unselectSelectedSlide(),
                    (this.selectedSlide = t).select(),
                    (this.selectedCells = t.cells),
                    (this.selectedElements = t.getCellElements()),
                    (this.selectedCell = t.cells[0]),
                    (this.selectedElement = this.selectedElements[0]));
            }),
            (p.unselectSelectedSlide = function () {
                this.selectedSlide && this.selectedSlide.unselect();
            }),
            (p.selectInitialIndex = function () {
                var t = this.options.initialIndex;
                if (this.isInitActivated) this.select(this.selectedIndex, !1, !0);
                else {
                    if (t && "string" == typeof t) if (this.queryCell(t)) return void this.selectCell(t, !1, !0);
                    var e = 0;
                    t && this.slides[t] && (e = t), this.select(e, !1, !0);
                }
            }),
            (p.selectCell = function (t, e, i) {
                var n = this.queryCell(t);
                if (n) {
                    var s = this.getCellSlideIndex(n);
                    this.select(s, e, i);
                }
            }),
            (p.getCellSlideIndex = function (t) {
                for (var e = 0; e < this.slides.length; e++) {
                    if (-1 != this.slides[e].cells.indexOf(t)) return e;
                }
            }),
            (p.getCell = function (t) {
                for (var e = 0; e < this.cells.length; e++) {
                    var i = this.cells[e];
                    if (i.element == t) return i;
                }
            }),
            (p.getCells = function (t) {
                t = a.makeArray(t);
                var i = [];
                return (
                    t.forEach(function (t) {
                        var e = this.getCell(t);
                        e && i.push(e);
                    }, this),
                    i
                );
            }),
            (p.getCellElements = function () {
                return this.cells.map(function (t) {
                    return t.element;
                });
            }),
            (p.getParentCell = function (t) {
                var e = this.getCell(t);
                return e || ((t = a.getParent(t, ".flickity-slider > *")), this.getCell(t));
            }),
            (p.getAdjacentCellElements = function (t, e) {
                if (!t) return this.selectedSlide.getCellElements();
                e = void 0 === e ? this.selectedIndex : e;
                var i = this.slides.length;
                if (i <= 1 + 2 * t) return this.getCellElements();
                for (var n = [], s = e - t; s <= e + t; s++) {
                    var o = this.options.wrapAround ? a.modulo(s, i) : s,
                        r = this.slides[o];
                    r && (n = n.concat(r.getCellElements()));
                }
                return n;
            }),
            (p.queryCell = function (t) {
                if ("number" == typeof t) return this.cells[t];
                if ("string" == typeof t) {
                    if (t.match(/^[#\.]?[\d\/]/)) return;
                    t = this.element.querySelector(t);
                }
                return this.getCell(t);
            }),
            (p.uiChange = function () {
                this.emitEvent("uiChange");
            }),
            (p.childUIPointerDown = function (t) {
                "touchstart" != t.type && t.preventDefault(), this.focus();
            }),
            (p.onresize = function () {
                this.watchCSS(), this.resize();
            }),
            a.debounceMethod(f, "onresize", 150),
            (p.resize = function () {
                if (this.isActive) {
                    this.getSize(), this.options.wrapAround && (this.x = a.modulo(this.x, this.slideableWidth)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize(), this.emitEvent("resize");
                    var t = this.selectedElements && this.selectedElements[0];
                    this.selectCell(t, !1, !0);
                }
            }),
            (p.watchCSS = function () {
                this.options.watchCSS && (-1 != o(this.element, ":after").content.indexOf("flickity") ? this.activate() : this.deactivate());
            }),
            (p.onkeydown = function (t) {
                var e = document.activeElement && document.activeElement != this.element;
                if (this.options.accessibility && !e) {
                    var i = f.keyboardHandlers[t.keyCode];
                    i && i.call(this);
                }
            }),
            (f.keyboardHandlers = {
                37: function () {
                    var t = this.options.rightToLeft ? "next" : "previous";
                    this.uiChange(), this[t]();
                },
                39: function () {
                    var t = this.options.rightToLeft ? "previous" : "next";
                    this.uiChange(), this[t]();
                },
            }),
            (p.focus = function () {
                var t = n.pageYOffset;
                this.element.focus({ preventScroll: !0 }), n.pageYOffset != t && n.scrollTo(n.pageXOffset, t);
            }),
            (p.deactivate = function () {
                this.isActive &&
                    (this.element.classList.remove("flickity-enabled"),
                    this.element.classList.remove("flickity-rtl"),
                    this.unselectSelectedSlide(),
                    this.cells.forEach(function (t) {
                        t.destroy();
                    }),
                    this.element.removeChild(this.viewport),
                    c(this.slider.children, this.element),
                    this.options.accessibility && (this.element.removeAttribute("tabIndex"), this.element.removeEventListener("keydown", this)),
                    (this.isActive = !1),
                    this.emitEvent("deactivate"));
            }),
            (p.destroy = function () {
                this.deactivate(), n.removeEventListener("resize", this), this.allOff(), this.emitEvent("destroy"), l && this.$element && l.removeData(this.element, "flickity"), delete this.element.flickityGUID, delete u[this.guid];
            }),
            a.extend(p, s),
            (f.data = function (t) {
                var e = (t = a.getQueryElement(t)) && t.flickityGUID;
                return e && u[e];
            }),
            a.htmlInit(f, "flickity"),
            l && l.bridget && l.bridget("flickity", f),
            (f.setJQuery = function (t) {
                l = t;
            }),
            (f.Cell = i),
            (f.Slide = r),
            f
        );
    }),
    (function (e, i) {
        "function" == typeof define && define.amd
            ? define("unipointer/unipointer", ["ev-emitter/ev-emitter"], function (t) {
                  return i(e, t);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = i(e, require("ev-emitter")))
            : (e.Unipointer = i(e, e.EvEmitter));
    })(window, function (s, t) {
        function e() {}
        var i = (e.prototype = Object.create(t.prototype));
        (i.bindStartEvent = function (t) {
            this._bindStartEvent(t, !0);
        }),
            (i.unbindStartEvent = function (t) {
                this._bindStartEvent(t, !1);
            }),
            (i._bindStartEvent = function (t, e) {
                var i = (e = void 0 === e || e) ? "addEventListener" : "removeEventListener",
                    n = "mousedown";
                s.PointerEvent ? (n = "pointerdown") : "ontouchstart" in s && (n = "touchstart"), t[i](n, this);
            }),
            (i.handleEvent = function (t) {
                var e = "on" + t.type;
                this[e] && this[e](t);
            }),
            (i.getTouch = function (t) {
                for (var e = 0; e < t.length; e++) {
                    var i = t[e];
                    if (i.identifier == this.pointerIdentifier) return i;
                }
            }),
            (i.onmousedown = function (t) {
                var e = t.button;
                (e && 0 !== e && 1 !== e) || this._pointerDown(t, t);
            }),
            (i.ontouchstart = function (t) {
                this._pointerDown(t, t.changedTouches[0]);
            }),
            (i.onpointerdown = function (t) {
                this._pointerDown(t, t);
            }),
            (i._pointerDown = function (t, e) {
                t.button || this.isPointerDown || ((this.isPointerDown = !0), (this.pointerIdentifier = void 0 !== e.pointerId ? e.pointerId : e.identifier), this.pointerDown(t, e));
            }),
            (i.pointerDown = function (t, e) {
                this._bindPostStartEvents(t), this.emitEvent("pointerDown", [t, e]);
            });
        var n = { mousedown: ["mousemove", "mouseup"], touchstart: ["touchmove", "touchend", "touchcancel"], pointerdown: ["pointermove", "pointerup", "pointercancel"] };
        return (
            (i._bindPostStartEvents = function (t) {
                if (t) {
                    var e = n[t.type];
                    e.forEach(function (t) {
                        s.addEventListener(t, this);
                    }, this),
                        (this._boundPointerEvents = e);
                }
            }),
            (i._unbindPostStartEvents = function () {
                this._boundPointerEvents &&
                    (this._boundPointerEvents.forEach(function (t) {
                        s.removeEventListener(t, this);
                    }, this),
                    delete this._boundPointerEvents);
            }),
            (i.onmousemove = function (t) {
                this._pointerMove(t, t);
            }),
            (i.onpointermove = function (t) {
                t.pointerId == this.pointerIdentifier && this._pointerMove(t, t);
            }),
            (i.ontouchmove = function (t) {
                var e = this.getTouch(t.changedTouches);
                e && this._pointerMove(t, e);
            }),
            (i._pointerMove = function (t, e) {
                this.pointerMove(t, e);
            }),
            (i.pointerMove = function (t, e) {
                this.emitEvent("pointerMove", [t, e]);
            }),
            (i.onmouseup = function (t) {
                this._pointerUp(t, t);
            }),
            (i.onpointerup = function (t) {
                t.pointerId == this.pointerIdentifier && this._pointerUp(t, t);
            }),
            (i.ontouchend = function (t) {
                var e = this.getTouch(t.changedTouches);
                e && this._pointerUp(t, e);
            }),
            (i._pointerUp = function (t, e) {
                this._pointerDone(), this.pointerUp(t, e);
            }),
            (i.pointerUp = function (t, e) {
                this.emitEvent("pointerUp", [t, e]);
            }),
            (i._pointerDone = function () {
                this._pointerReset(), this._unbindPostStartEvents(), this.pointerDone();
            }),
            (i._pointerReset = function () {
                (this.isPointerDown = !1), delete this.pointerIdentifier;
            }),
            (i.pointerDone = function () {}),
            (i.onpointercancel = function (t) {
                t.pointerId == this.pointerIdentifier && this._pointerCancel(t, t);
            }),
            (i.ontouchcancel = function (t) {
                var e = this.getTouch(t.changedTouches);
                e && this._pointerCancel(t, e);
            }),
            (i._pointerCancel = function (t, e) {
                this._pointerDone(), this.pointerCancel(t, e);
            }),
            (i.pointerCancel = function (t, e) {
                this.emitEvent("pointerCancel", [t, e]);
            }),
            (e.getPointerPoint = function (t) {
                return { x: t.pageX, y: t.pageY };
            }),
            e
        );
    }),
    (function (e, i) {
        "function" == typeof define && define.amd
            ? define("unidragger/unidragger", ["unipointer/unipointer"], function (t) {
                  return i(e, t);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = i(e, require("unipointer")))
            : (e.Unidragger = i(e, e.Unipointer));
    })(window, function (o, t) {
        function e() {}
        var i = (e.prototype = Object.create(t.prototype));
        (i.bindHandles = function () {
            this._bindHandles(!0);
        }),
            (i.unbindHandles = function () {
                this._bindHandles(!1);
            }),
            (i._bindHandles = function (t) {
                for (var e = (t = void 0 === t || t) ? "addEventListener" : "removeEventListener", i = t ? this._touchActionValue : "", n = 0; n < this.handles.length; n++) {
                    var s = this.handles[n];
                    this._bindStartEvent(s, t), s[e]("click", this), o.PointerEvent && (s.style.touchAction = i);
                }
            }),
            (i._touchActionValue = "none"),
            (i.pointerDown = function (t, e) {
                this.okayPointerDown(t) && ((this.pointerDownPointer = e), t.preventDefault(), this.pointerDownBlur(), this._bindPostStartEvents(t), this.emitEvent("pointerDown", [t, e]));
            });
        var s = { TEXTAREA: !0, INPUT: !0, SELECT: !0, OPTION: !0 },
            r = { radio: !0, checkbox: !0, button: !0, submit: !0, image: !0, file: !0 };
        return (
            (i.okayPointerDown = function (t) {
                var e = s[t.target.nodeName],
                    i = r[t.target.type],
                    n = !e || i;
                return n || this._pointerReset(), n;
            }),
            (i.pointerDownBlur = function () {
                var t = document.activeElement;
                t && t.blur && t != document.body && t.blur();
            }),
            (i.pointerMove = function (t, e) {
                var i = this._dragPointerMove(t, e);
                this.emitEvent("pointerMove", [t, e, i]), this._dragMove(t, e, i);
            }),
            (i._dragPointerMove = function (t, e) {
                var i = { x: e.pageX - this.pointerDownPointer.pageX, y: e.pageY - this.pointerDownPointer.pageY };
                return !this.isDragging && this.hasDragStarted(i) && this._dragStart(t, e), i;
            }),
            (i.hasDragStarted = function (t) {
                return 3 < Math.abs(t.x) || 3 < Math.abs(t.y);
            }),
            (i.pointerUp = function (t, e) {
                this.emitEvent("pointerUp", [t, e]), this._dragPointerUp(t, e);
            }),
            (i._dragPointerUp = function (t, e) {
                this.isDragging ? this._dragEnd(t, e) : this._staticClick(t, e);
            }),
            (i._dragStart = function (t, e) {
                (this.isDragging = !0), (this.isPreventingClicks = !0), this.dragStart(t, e);
            }),
            (i.dragStart = function (t, e) {
                this.emitEvent("dragStart", [t, e]);
            }),
            (i._dragMove = function (t, e, i) {
                this.isDragging && this.dragMove(t, e, i);
            }),
            (i.dragMove = function (t, e, i) {
                t.preventDefault(), this.emitEvent("dragMove", [t, e, i]);
            }),
            (i._dragEnd = function (t, e) {
                (this.isDragging = !1),
                    setTimeout(
                        function () {
                            delete this.isPreventingClicks;
                        }.bind(this)
                    ),
                    this.dragEnd(t, e);
            }),
            (i.dragEnd = function (t, e) {
                this.emitEvent("dragEnd", [t, e]);
            }),
            (i.onclick = function (t) {
                this.isPreventingClicks && t.preventDefault();
            }),
            (i._staticClick = function (t, e) {
                (this.isIgnoringMouseUp && "mouseup" == t.type) ||
                    (this.staticClick(t, e),
                    "mouseup" != t.type &&
                        ((this.isIgnoringMouseUp = !0),
                        setTimeout(
                            function () {
                                delete this.isIgnoringMouseUp;
                            }.bind(this),
                            400
                        )));
            }),
            (i.staticClick = function (t, e) {
                this.emitEvent("staticClick", [t, e]);
            }),
            (e.getPointerPoint = t.getPointerPoint),
            e
        );
    }),
    (function (n, s) {
        "function" == typeof define && define.amd
            ? define("flickity/js/drag", ["./flickity", "unidragger/unidragger", "fizzy-ui-utils/utils"], function (t, e, i) {
                  return s(n, t, e, i);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = s(n, require("./flickity"), require("unidragger"), require("fizzy-ui-utils")))
            : (n.Flickity = s(n, n.Flickity, n.Unidragger, n.fizzyUIUtils));
    })(window, function (i, t, e, a) {
        a.extend(t.defaults, { draggable: ">1", dragThreshold: 3 }), t.createMethods.push("_createDrag");
        var n = t.prototype;
        a.extend(n, e.prototype), (n._touchActionValue = "pan-y");
        var s = "createTouch" in document,
            o = !1;
        (n._createDrag = function () {
            this.on("activate", this.onActivateDrag),
                this.on("uiChange", this._uiChangeDrag),
                this.on("deactivate", this.onDeactivateDrag),
                this.on("cellChange", this.updateDraggable),
                s && !o && (i.addEventListener("touchmove", function () {}), (o = !0));
        }),
            (n.onActivateDrag = function () {
                (this.handles = [this.viewport]), this.bindHandles(), this.updateDraggable();
            }),
            (n.onDeactivateDrag = function () {
                this.unbindHandles(), this.element.classList.remove("is-draggable");
            }),
            (n.updateDraggable = function () {
                ">1" == this.options.draggable ? (this.isDraggable = 1 < this.slides.length) : (this.isDraggable = this.options.draggable),
                    this.isDraggable ? this.element.classList.add("is-draggable") : this.element.classList.remove("is-draggable");
            }),
            (n.bindDrag = function () {
                (this.options.draggable = !0), this.updateDraggable();
            }),
            (n.unbindDrag = function () {
                (this.options.draggable = !1), this.updateDraggable();
            }),
            (n._uiChangeDrag = function () {
                delete this.isFreeScrolling;
            }),
            (n.pointerDown = function (t, e) {
                this.isDraggable
                    ? this.okayPointerDown(t) &&
                      (this._pointerDownPreventDefault(t),
                      this.pointerDownFocus(t),
                      document.activeElement != this.element && this.pointerDownBlur(),
                      (this.dragX = this.x),
                      this.viewport.classList.add("is-pointer-down"),
                      (this.pointerDownScroll = l()),
                      i.addEventListener("scroll", this),
                      this._pointerDownDefault(t, e))
                    : this._pointerDownDefault(t, e);
            }),
            (n._pointerDownDefault = function (t, e) {
                (this.pointerDownPointer = { pageX: e.pageX, pageY: e.pageY }), this._bindPostStartEvents(t), this.dispatchEvent("pointerDown", t, [e]);
            });
        var r = { INPUT: !0, TEXTAREA: !0, SELECT: !0 };
        function l() {
            return { x: i.pageXOffset, y: i.pageYOffset };
        }
        return (
            (n.pointerDownFocus = function (t) {
                r[t.target.nodeName] || this.focus();
            }),
            (n._pointerDownPreventDefault = function (t) {
                var e = "touchstart" == t.type,
                    i = "touch" == t.pointerType,
                    n = r[t.target.nodeName];
                e || i || n || t.preventDefault();
            }),
            (n.hasDragStarted = function (t) {
                return Math.abs(t.x) > this.options.dragThreshold;
            }),
            (n.pointerUp = function (t, e) {
                delete this.isTouchScrolling, this.viewport.classList.remove("is-pointer-down"), this.dispatchEvent("pointerUp", t, [e]), this._dragPointerUp(t, e);
            }),
            (n.pointerDone = function () {
                i.removeEventListener("scroll", this), delete this.pointerDownScroll;
            }),
            (n.dragStart = function (t, e) {
                this.isDraggable && ((this.dragStartPosition = this.x), this.startAnimation(), i.removeEventListener("scroll", this), this.dispatchEvent("dragStart", t, [e]));
            }),
            (n.pointerMove = function (t, e) {
                var i = this._dragPointerMove(t, e);
                this.dispatchEvent("pointerMove", t, [e, i]), this._dragMove(t, e, i);
            }),
            (n.dragMove = function (t, e, i) {
                if (this.isDraggable) {
                    t.preventDefault(), (this.previousDragX = this.dragX);
                    var n = this.options.rightToLeft ? -1 : 1;
                    this.options.wrapAround && (i.x = i.x % this.slideableWidth);
                    var s = this.dragStartPosition + i.x * n;
                    if (!this.options.wrapAround && this.slides.length) {
                        var o = Math.max(-this.slides[0].target, this.dragStartPosition);
                        s = o < s ? 0.5 * (s + o) : s;
                        var r = Math.min(-this.getLastSlide().target, this.dragStartPosition);
                        s = s < r ? 0.5 * (s + r) : s;
                    }
                    (this.dragX = s), (this.dragMoveTime = new Date()), this.dispatchEvent("dragMove", t, [e, i]);
                }
            }),
            (n.dragEnd = function (t, e) {
                if (this.isDraggable) {
                    this.options.freeScroll && (this.isFreeScrolling = !0);
                    var i = this.dragEndRestingSelect();
                    if (this.options.freeScroll && !this.options.wrapAround) {
                        var n = this.getRestingPosition();
                        this.isFreeScrolling = -n > this.slides[0].target && -n < this.getLastSlide().target;
                    } else this.options.freeScroll || i != this.selectedIndex || (i += this.dragEndBoostSelect());
                    delete this.previousDragX, (this.isDragSelect = this.options.wrapAround), this.select(i), delete this.isDragSelect, this.dispatchEvent("dragEnd", t, [e]);
                }
            }),
            (n.dragEndRestingSelect = function () {
                var t = this.getRestingPosition(),
                    e = Math.abs(this.getSlideDistance(-t, this.selectedIndex)),
                    i = this._getClosestResting(t, e, 1),
                    n = this._getClosestResting(t, e, -1);
                return i.distance < n.distance ? i.index : n.index;
            }),
            (n._getClosestResting = function (t, e, i) {
                for (
                    var n = this.selectedIndex,
                        s = 1 / 0,
                        o =
                            this.options.contain && !this.options.wrapAround
                                ? function (t, e) {
                                      return t <= e;
                                  }
                                : function (t, e) {
                                      return t < e;
                                  };
                    o(e, s) && ((n += i), (s = e), null !== (e = this.getSlideDistance(-t, n)));

                )
                    e = Math.abs(e);
                return { distance: s, index: n - i };
            }),
            (n.getSlideDistance = function (t, e) {
                var i = this.slides.length,
                    n = this.options.wrapAround && 1 < i,
                    s = n ? a.modulo(e, i) : e,
                    o = this.slides[s];
                if (!o) return null;
                var r = n ? this.slideableWidth * Math.floor(e / i) : 0;
                return t - (o.target + r);
            }),
            (n.dragEndBoostSelect = function () {
                if (void 0 === this.previousDragX || !this.dragMoveTime || 100 < new Date() - this.dragMoveTime) return 0;
                var t = this.getSlideDistance(-this.dragX, this.selectedIndex),
                    e = this.previousDragX - this.dragX;
                return 0 < t && 0 < e ? 1 : t < 0 && e < 0 ? -1 : 0;
            }),
            (n.staticClick = function (t, e) {
                var i = this.getParentCell(t.target),
                    n = i && i.element,
                    s = i && this.cells.indexOf(i);
                this.dispatchEvent("staticClick", t, [e, n, s]);
            }),
            (n.onscroll = function () {
                var t = l(),
                    e = this.pointerDownScroll.x - t.x,
                    i = this.pointerDownScroll.y - t.y;
                (3 < Math.abs(e) || 3 < Math.abs(i)) && this._pointerDone();
            }),
            t
        );
    }),
    (function (n, s) {
        "function" == typeof define && define.amd
            ? define("flickity/js/prev-next-button", ["./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils"], function (t, e, i) {
                  return s(n, t, e, i);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = s(n, require("./flickity"), require("unipointer"), require("fizzy-ui-utils")))
            : s(n, n.Flickity, n.Unipointer, n.fizzyUIUtils);
    })(window, function (t, e, i, n) {
        "use strict";
        var s = "http://www.w3.org/2000/svg";
        function o(t, e) {
            (this.direction = t), (this.parent = e), this._create();
        }
        ((o.prototype = Object.create(i.prototype))._create = function () {
            (this.isEnabled = !0), (this.isPrevious = -1 == this.direction);
            var t = this.parent.options.rightToLeft ? 1 : -1;
            this.isLeft = this.direction == t;
            var e = (this.element = document.createElement("button"));
            (e.className = "flickity-button flickity-prev-next-button"),
                (e.className += this.isPrevious ? " previous" : " next"),
                e.setAttribute("type", "button"),
                this.disable(),
                e.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
            var i = this.createSVG();
            e.appendChild(i), this.parent.on("select", this.update.bind(this)), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
        }),
            (o.prototype.activate = function () {
                this.bindStartEvent(this.element), this.element.addEventListener("click", this), this.parent.element.appendChild(this.element);
            }),
            (o.prototype.deactivate = function () {
                this.parent.element.removeChild(this.element), this.unbindStartEvent(this.element), this.element.removeEventListener("click", this);
            }),
            (o.prototype.createSVG = function () {
                var t = document.createElementNS(s, "svg");
                t.setAttribute("class", "flickity-button-icon"), t.setAttribute("viewBox", "0 0 100 100");
                var e,
                    i = document.createElementNS(s, "path"),
                    n =
                        "string" != typeof (e = this.parent.options.arrowShape)
                            ? "M " + e.x0 + ",50 L " + e.x1 + "," + (e.y1 + 50) + " L " + e.x2 + "," + (e.y2 + 50) + " L " + e.x3 + ",50  L " + e.x2 + "," + (50 - e.y2) + " L " + e.x1 + "," + (50 - e.y1) + " Z"
                            : e;
                return i.setAttribute("d", n), i.setAttribute("class", "arrow"), this.isLeft || i.setAttribute("transform", "translate(100, 100) rotate(180) "), t.appendChild(i), t;
            }),
            (o.prototype.handleEvent = n.handleEvent),
            (o.prototype.onclick = function () {
                if (this.isEnabled) {
                    this.parent.uiChange();
                    var t = this.isPrevious ? "previous" : "next";
                    this.parent[t]();
                }
            }),
            (o.prototype.enable = function () {
                this.isEnabled || ((this.element.disabled = !1), (this.isEnabled = !0));
            }),
            (o.prototype.disable = function () {
                this.isEnabled && ((this.element.disabled = !0), (this.isEnabled = !1));
            }),
            (o.prototype.update = function () {
                var t = this.parent.slides;
                if (this.parent.options.wrapAround && 1 < t.length) this.enable();
                else {
                    var e = t.length ? t.length - 1 : 0,
                        i = this.isPrevious ? 0 : e;
                    this[this.parent.selectedIndex == i ? "disable" : "enable"]();
                }
            }),
            (o.prototype.destroy = function () {
                this.deactivate(), this.allOff();
            }),
            n.extend(e.defaults, { prevNextButtons: !0, arrowShape: { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30 } }),
            e.createMethods.push("_createPrevNextButtons");
        var r = e.prototype;
        return (
            (r._createPrevNextButtons = function () {
                this.options.prevNextButtons && ((this.prevButton = new o(-1, this)), (this.nextButton = new o(1, this)), this.on("activate", this.activatePrevNextButtons));
            }),
            (r.activatePrevNextButtons = function () {
                this.prevButton.activate(), this.nextButton.activate(), this.on("deactivate", this.deactivatePrevNextButtons);
            }),
            (r.deactivatePrevNextButtons = function () {
                this.prevButton.deactivate(), this.nextButton.deactivate(), this.off("deactivate", this.deactivatePrevNextButtons);
            }),
            (e.PrevNextButton = o),
            e
        );
    }),
    (function (n, s) {
        "function" == typeof define && define.amd
            ? define("flickity/js/page-dots", ["./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils"], function (t, e, i) {
                  return s(n, t, e, i);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = s(n, require("./flickity"), require("unipointer"), require("fizzy-ui-utils")))
            : s(n, n.Flickity, n.Unipointer, n.fizzyUIUtils);
    })(window, function (t, e, i, n) {
        function s(t) {
            (this.parent = t), this._create();
        }
        ((s.prototype = Object.create(i.prototype))._create = function () {
            (this.holder = document.createElement("ol")),
                (this.holder.className = "flickity-page-dots"),
                (this.dots = []),
                (this.handleClick = this.onClick.bind(this)),
                this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
        }),
            (s.prototype.activate = function () {
                this.setDots(), this.holder.addEventListener("click", this.handleClick), this.bindStartEvent(this.holder), this.parent.element.appendChild(this.holder);
            }),
            (s.prototype.deactivate = function () {
                this.holder.removeEventListener("click", this.handleClick), this.unbindStartEvent(this.holder), this.parent.element.removeChild(this.holder);
            }),
            (s.prototype.setDots = function () {
                var t = this.parent.slides.length - this.dots.length;
                0 < t ? this.addDots(t) : t < 0 && this.removeDots(-t);
            }),
            (s.prototype.addDots = function (t) {
                for (var e = document.createDocumentFragment(), i = [], n = this.dots.length, s = n + t, o = n; o < s; o++) {
                    var r = document.createElement("li");
                    (r.className = "dot"), r.setAttribute("aria-label", "Page dot " + (o + 1)), e.appendChild(r), i.push(r);
                }
                this.holder.appendChild(e), (this.dots = this.dots.concat(i));
            }),
            (s.prototype.removeDots = function (t) {
                this.dots.splice(this.dots.length - t, t).forEach(function (t) {
                    this.holder.removeChild(t);
                }, this);
            }),
            (s.prototype.updateSelected = function () {
                this.selectedDot && ((this.selectedDot.className = "dot"), this.selectedDot.removeAttribute("aria-current")),
                    this.dots.length && ((this.selectedDot = this.dots[this.parent.selectedIndex]), (this.selectedDot.className = "dot is-selected"), this.selectedDot.setAttribute("aria-current", "step"));
            }),
            (s.prototype.onTap = s.prototype.onClick = function (t) {
                var e = t.target;
                if ("LI" == e.nodeName) {
                    this.parent.uiChange();
                    var i = this.dots.indexOf(e);
                    this.parent.select(i);
                }
            }),
            (s.prototype.destroy = function () {
                this.deactivate(), this.allOff();
            }),
            (e.PageDots = s),
            n.extend(e.defaults, { pageDots: !0 }),
            e.createMethods.push("_createPageDots");
        var o = e.prototype;
        return (
            (o._createPageDots = function () {
                this.options.pageDots &&
                    ((this.pageDots = new s(this)),
                    this.on("activate", this.activatePageDots),
                    this.on("select", this.updateSelectedPageDots),
                    this.on("cellChange", this.updatePageDots),
                    this.on("resize", this.updatePageDots),
                    this.on("deactivate", this.deactivatePageDots));
            }),
            (o.activatePageDots = function () {
                this.pageDots.activate();
            }),
            (o.updateSelectedPageDots = function () {
                this.pageDots.updateSelected();
            }),
            (o.updatePageDots = function () {
                this.pageDots.setDots();
            }),
            (o.deactivatePageDots = function () {
                this.pageDots.deactivate();
            }),
            (e.PageDots = s),
            e
        );
    }),
    (function (t, n) {
        "function" == typeof define && define.amd
            ? define("flickity/js/player", ["ev-emitter/ev-emitter", "fizzy-ui-utils/utils", "./flickity"], function (t, e, i) {
                  return n(t, e, i);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = n(require("ev-emitter"), require("fizzy-ui-utils"), require("./flickity")))
            : n(t.EvEmitter, t.fizzyUIUtils, t.Flickity);
    })(window, function (t, e, i) {
        function n(t) {
            (this.parent = t), (this.state = "stopped"), (this.onVisibilityChange = this.visibilityChange.bind(this)), (this.onVisibilityPlay = this.visibilityPlay.bind(this));
        }
        ((n.prototype = Object.create(t.prototype)).play = function () {
            "playing" != this.state &&
                (document.hidden ? document.addEventListener("visibilitychange", this.onVisibilityPlay) : ((this.state = "playing"), document.addEventListener("visibilitychange", this.onVisibilityChange), this.tick()));
        }),
            (n.prototype.tick = function () {
                if ("playing" == this.state) {
                    var t = this.parent.options.autoPlay;
                    t = "number" == typeof t ? t : 3e3;
                    var e = this;
                    this.clear(),
                        (this.timeout = setTimeout(function () {
                            e.parent.next(!0), e.tick();
                        }, t));
                }
            }),
            (n.prototype.stop = function () {
                (this.state = "stopped"), this.clear(), document.removeEventListener("visibilitychange", this.onVisibilityChange);
            }),
            (n.prototype.clear = function () {
                clearTimeout(this.timeout);
            }),
            (n.prototype.pause = function () {
                "playing" == this.state && ((this.state = "paused"), this.clear());
            }),
            (n.prototype.unpause = function () {
                "paused" == this.state && this.play();
            }),
            (n.prototype.visibilityChange = function () {
                this[document.hidden ? "pause" : "unpause"]();
            }),
            (n.prototype.visibilityPlay = function () {
                this.play(), document.removeEventListener("visibilitychange", this.onVisibilityPlay);
            }),
            e.extend(i.defaults, { pauseAutoPlayOnHover: !0 }),
            i.createMethods.push("_createPlayer");
        var s = i.prototype;
        return (
            (s._createPlayer = function () {
                (this.player = new n(this)), this.on("activate", this.activatePlayer), this.on("uiChange", this.stopPlayer), this.on("pointerDown", this.stopPlayer), this.on("deactivate", this.deactivatePlayer);
            }),
            (s.activatePlayer = function () {
                this.options.autoPlay && (this.player.play(), this.element.addEventListener("mouseenter", this));
            }),
            (s.playPlayer = function () {
                this.player.play();
            }),
            (s.stopPlayer = function () {
                this.player.stop();
            }),
            (s.pausePlayer = function () {
                this.player.pause();
            }),
            (s.unpausePlayer = function () {
                this.player.unpause();
            }),
            (s.deactivatePlayer = function () {
                this.player.stop(), this.element.removeEventListener("mouseenter", this);
            }),
            (s.onmouseenter = function () {
                this.options.pauseAutoPlayOnHover && (this.player.pause(), this.element.addEventListener("mouseleave", this));
            }),
            (s.onmouseleave = function () {
                this.player.unpause(), this.element.removeEventListener("mouseleave", this);
            }),
            (i.Player = n),
            i
        );
    }),
    (function (i, n) {
        "function" == typeof define && define.amd
            ? define("flickity/js/add-remove-cell", ["./flickity", "fizzy-ui-utils/utils"], function (t, e) {
                  return n(i, t, e);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = n(i, require("./flickity"), require("fizzy-ui-utils")))
            : n(i, i.Flickity, i.fizzyUIUtils);
    })(window, function (t, e, n) {
        var i = e.prototype;
        return (
            (i.insert = function (t, e) {
                var i = this._makeCells(t);
                if (i && i.length) {
                    var n = this.cells.length;
                    e = void 0 === e ? n : e;
                    var s,
                        o,
                        r =
                            ((s = i),
                            (o = document.createDocumentFragment()),
                            s.forEach(function (t) {
                                o.appendChild(t.element);
                            }),
                            o),
                        a = e == n;
                    if (a) this.slider.appendChild(r);
                    else {
                        var l = this.cells[e].element;
                        this.slider.insertBefore(r, l);
                    }
                    if (0 === e) this.cells = i.concat(this.cells);
                    else if (a) this.cells = this.cells.concat(i);
                    else {
                        var h = this.cells.splice(e, n - e);
                        this.cells = this.cells.concat(i).concat(h);
                    }
                    this._sizeCells(i), this.cellChange(e, !0);
                }
            }),
            (i.append = function (t) {
                this.insert(t, this.cells.length);
            }),
            (i.prepend = function (t) {
                this.insert(t, 0);
            }),
            (i.remove = function (t) {
                var e = this.getCells(t);
                if (e && e.length) {
                    var i = this.cells.length - 1;
                    e.forEach(function (t) {
                        t.remove();
                        var e = this.cells.indexOf(t);
                        (i = Math.min(e, i)), n.removeFrom(this.cells, t);
                    }, this),
                        this.cellChange(i, !0);
                }
            }),
            (i.cellSizeChange = function (t) {
                var e = this.getCell(t);
                if (e) {
                    e.getSize();
                    var i = this.cells.indexOf(e);
                    this.cellChange(i);
                }
            }),
            (i.cellChange = function (t, e) {
                var i = this.selectedElement;
                this._positionCells(t), this._getWrapShiftCells(), this.setGallerySize();
                var n = this.getCell(i);
                n && (this.selectedIndex = this.getCellSlideIndex(n)),
                    (this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex)),
                    this.emitEvent("cellChange", [t]),
                    this.select(this.selectedIndex),
                    e && this.positionSliderAtSelected();
            }),
            e
        );
    }),
    (function (i, n) {
        "function" == typeof define && define.amd
            ? define("flickity/js/lazyload", ["./flickity", "fizzy-ui-utils/utils"], function (t, e) {
                  return n(i, t, e);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = n(i, require("./flickity"), require("fizzy-ui-utils")))
            : n(i, i.Flickity, i.fizzyUIUtils);
    })(window, function (t, e, o) {
        "use strict";
        e.createMethods.push("_createLazyload");
        var i = e.prototype;
        function s(t, e) {
            (this.img = t), (this.flickity = e), this.load();
        }
        return (
            (i._createLazyload = function () {
                this.on("select", this.lazyLoad);
            }),
            (i.lazyLoad = function () {
                var t = this.options.lazyLoad;
                if (t) {
                    var e = "number" == typeof t ? t : 0,
                        i = this.getAdjacentCellElements(e),
                        n = [];
                    i.forEach(function (t) {
                        var e = (function (t) {
                            if ("IMG" == t.nodeName) {
                                var e = t.getAttribute("data-flickity-lazyload"),
                                    i = t.getAttribute("data-flickity-lazyload-src"),
                                    n = t.getAttribute("data-flickity-lazyload-srcset");
                                if (e || i || n) return [t];
                            }
                            var s = t.querySelectorAll("img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]");
                            return o.makeArray(s);
                        })(t);
                        n = n.concat(e);
                    }),
                        n.forEach(function (t) {
                            new s(t, this);
                        }, this);
                }
            }),
            (s.prototype.handleEvent = o.handleEvent),
            (s.prototype.load = function () {
                this.img.addEventListener("load", this), this.img.addEventListener("error", this);
                var t = this.img.getAttribute("data-flickity-lazyload") || this.img.getAttribute("data-flickity-lazyload-src"),
                    e = this.img.getAttribute("data-flickity-lazyload-srcset");
                (this.img.src = t),
                    e && this.img.setAttribute("srcset", e),
                    this.img.removeAttribute("data-flickity-lazyload"),
                    this.img.removeAttribute("data-flickity-lazyload-src"),
                    this.img.removeAttribute("data-flickity-lazyload-srcset");
            }),
            (s.prototype.onload = function (t) {
                this.complete(t, "flickity-lazyloaded");
            }),
            (s.prototype.onerror = function (t) {
                this.complete(t, "flickity-lazyerror");
            }),
            (s.prototype.complete = function (t, e) {
                this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
                var i = this.flickity.getParentCell(this.img),
                    n = i && i.element;
                this.flickity.cellSizeChange(n), this.img.classList.add(e), this.flickity.dispatchEvent("lazyLoad", t, n);
            }),
            (e.LazyLoader = s),
            e
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define("flickity/js/index", ["./flickity", "./drag", "./prev-next-button", "./page-dots", "./player", "./add-remove-cell", "./lazyload"], e)
            : "object" == typeof module &&
              module.exports &&
              (module.exports = e(require("./flickity"), require("./drag"), require("./prev-next-button"), require("./page-dots"), require("./player"), require("./add-remove-cell"), require("./lazyload")));
    })(window, function (t) {
        return t;
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define("flickity-as-nav-for/as-nav-for", ["flickity/js/index", "fizzy-ui-utils/utils"], e)
            : "object" == typeof module && module.exports
            ? (module.exports = e(require("flickity"), require("fizzy-ui-utils")))
            : (t.Flickity = e(t.Flickity, t.fizzyUIUtils));
    })(window, function (n, s) {
        n.createMethods.push("_createAsNavFor");
        var t = n.prototype;
        return (
            (t._createAsNavFor = function () {
                this.on("activate", this.activateAsNavFor), this.on("deactivate", this.deactivateAsNavFor), this.on("destroy", this.destroyAsNavFor);
                var t = this.options.asNavFor;
                if (t) {
                    var e = this;
                    setTimeout(function () {
                        e.setNavCompanion(t);
                    });
                }
            }),
            (t.setNavCompanion = function (t) {
                t = s.getQueryElement(t);
                var e = n.data(t);
                if (e && e != this) {
                    this.navCompanion = e;
                    var i = this;
                    (this.onNavCompanionSelect = function () {
                        i.navCompanionSelect();
                    }),
                        e.on("select", this.onNavCompanionSelect),
                        this.on("staticClick", this.onNavStaticClick),
                        this.navCompanionSelect(!0);
                }
            }),
            (t.navCompanionSelect = function (t) {
                if (this.navCompanion) {
                    var e,
                        i,
                        n,
                        s = this.navCompanion.selectedCells[0],
                        o = this.navCompanion.cells.indexOf(s),
                        r = o + this.navCompanion.selectedCells.length - 1,
                        a = Math.floor(((e = o), (i = r), (n = this.navCompanion.cellAlign), (i - e) * n + e));
                    if ((this.selectCell(a, !1, t), this.removeNavSelectedElements(), !(a >= this.cells.length))) {
                        var l = this.cells.slice(o, r + 1);
                        (this.navSelectedElements = l.map(function (t) {
                            return t.element;
                        })),
                            this.changeNavSelectedClass("add");
                    }
                }
            }),
            (t.changeNavSelectedClass = function (e) {
                this.navSelectedElements.forEach(function (t) {
                    t.classList[e]("is-nav-selected");
                });
            }),
            (t.activateAsNavFor = function () {
                this.navCompanionSelect(!0);
            }),
            (t.removeNavSelectedElements = function () {
                this.navSelectedElements && (this.changeNavSelectedClass("remove"), delete this.navSelectedElements);
            }),
            (t.onNavStaticClick = function (t, e, i, n) {
                "number" == typeof n && this.navCompanion.selectCell(n);
            }),
            (t.deactivateAsNavFor = function () {
                this.removeNavSelectedElements();
            }),
            (t.destroyAsNavFor = function () {
                this.navCompanion && (this.navCompanion.off("select", this.onNavCompanionSelect), this.off("staticClick", this.onNavStaticClick), delete this.navCompanion);
            }),
            n
        );
    }),
    (function (e, i) {
        "use strict";
        "function" == typeof define && define.amd
            ? define("imagesloaded/imagesloaded", ["ev-emitter/ev-emitter"], function (t) {
                  return i(e, t);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = i(e, require("ev-emitter")))
            : (e.imagesLoaded = i(e, e.EvEmitter));
    })("undefined" != typeof window ? window : this, function (e, t) {
        var o = e.jQuery,
            r = e.console;
        function a(t, e) {
            for (var i in e) t[i] = e[i];
            return t;
        }
        var l = Array.prototype.slice;
        function h(t, e, i) {
            if (!(this instanceof h)) return new h(t, e, i);
            var n,
                s = t;
            ("string" == typeof t && (s = document.querySelectorAll(t)), s)
                ? ((this.elements = ((n = s), Array.isArray(n) ? n : "object" == typeof n && "number" == typeof n.length ? l.call(n) : [n])),
                  (this.options = a({}, this.options)),
                  "function" == typeof e ? (i = e) : a(this.options, e),
                  i && this.on("always", i),
                  this.getImages(),
                  o && (this.jqDeferred = new o.Deferred()),
                  setTimeout(this.check.bind(this)))
                : r.error("Bad element for imagesLoaded " + (s || t));
        }
        ((h.prototype = Object.create(t.prototype)).options = {}),
            (h.prototype.getImages = function () {
                (this.images = []), this.elements.forEach(this.addElementImages, this);
            }),
            (h.prototype.addElementImages = function (t) {
                "IMG" == t.nodeName && this.addImage(t), !0 === this.options.background && this.addElementBackgroundImages(t);
                var e = t.nodeType;
                if (e && c[e]) {
                    for (var i = t.querySelectorAll("img"), n = 0; n < i.length; n++) {
                        var s = i[n];
                        this.addImage(s);
                    }
                    if ("string" == typeof this.options.background) {
                        var o = t.querySelectorAll(this.options.background);
                        for (n = 0; n < o.length; n++) {
                            var r = o[n];
                            this.addElementBackgroundImages(r);
                        }
                    }
                }
            });
        var c = { 1: !0, 9: !0, 11: !0 };
        function i(t) {
            this.img = t;
        }
        function n(t, e) {
            (this.url = t), (this.element = e), (this.img = new Image());
        }
        return (
            (h.prototype.addElementBackgroundImages = function (t) {
                var e = getComputedStyle(t);
                if (e)
                    for (var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(e.backgroundImage); null !== n; ) {
                        var s = n && n[2];
                        s && this.addBackground(s, t), (n = i.exec(e.backgroundImage));
                    }
            }),
            (h.prototype.addImage = function (t) {
                var e = new i(t);
                this.images.push(e);
            }),
            (h.prototype.addBackground = function (t, e) {
                var i = new n(t, e);
                this.images.push(i);
            }),
            (h.prototype.check = function () {
                var n = this;
                function e(t, e, i) {
                    setTimeout(function () {
                        n.progress(t, e, i);
                    });
                }
                (this.progressedCount = 0),
                    (this.hasAnyBroken = !1),
                    this.images.length
                        ? this.images.forEach(function (t) {
                              t.once("progress", e), t.check();
                          })
                        : this.complete();
            }),
            (h.prototype.progress = function (t, e, i) {
                this.progressedCount++,
                    (this.hasAnyBroken = this.hasAnyBroken || !t.isLoaded),
                    this.emitEvent("progress", [this, t, e]),
                    this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, t),
                    this.progressedCount == this.images.length && this.complete(),
                    this.options.debug && r && r.log("progress: " + i, t, e);
            }),
            (h.prototype.complete = function () {
                var t = this.hasAnyBroken ? "fail" : "done";
                if (((this.isComplete = !0), this.emitEvent(t, [this]), this.emitEvent("always", [this]), this.jqDeferred)) {
                    var e = this.hasAnyBroken ? "reject" : "resolve";
                    this.jqDeferred[e](this);
                }
            }),
            ((i.prototype = Object.create(t.prototype)).check = function () {
                this.getIsImageComplete()
                    ? this.confirm(0 !== this.img.naturalWidth, "naturalWidth")
                    : ((this.proxyImage = new Image()),
                      this.proxyImage.addEventListener("load", this),
                      this.proxyImage.addEventListener("error", this),
                      this.img.addEventListener("load", this),
                      this.img.addEventListener("error", this),
                      (this.proxyImage.src = this.img.src));
            }),
            (i.prototype.getIsImageComplete = function () {
                return this.img.complete && this.img.naturalWidth;
            }),
            (i.prototype.confirm = function (t, e) {
                (this.isLoaded = t), this.emitEvent("progress", [this, this.img, e]);
            }),
            (i.prototype.handleEvent = function (t) {
                var e = "on" + t.type;
                this[e] && this[e](t);
            }),
            (i.prototype.onload = function () {
                this.confirm(!0, "onload"), this.unbindEvents();
            }),
            (i.prototype.onerror = function () {
                this.confirm(!1, "onerror"), this.unbindEvents();
            }),
            (i.prototype.unbindEvents = function () {
                this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
            }),
            ((n.prototype = Object.create(i.prototype)).check = function () {
                this.img.addEventListener("load", this), this.img.addEventListener("error", this), (this.img.src = this.url), this.getIsImageComplete() && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents());
            }),
            (n.prototype.unbindEvents = function () {
                this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
            }),
            (n.prototype.confirm = function (t, e) {
                (this.isLoaded = t), this.emitEvent("progress", [this, this.element, e]);
            }),
            (h.makeJQueryPlugin = function (t) {
                (t = t || e.jQuery) &&
                    ((o = t).fn.imagesLoaded = function (t, e) {
                        return new h(this, t, e).jqDeferred.promise(o(this));
                    });
            }),
            h.makeJQueryPlugin(),
            h
        );
    }),
    (function (i, n) {
        "function" == typeof define && define.amd
            ? define(["flickity/js/index", "imagesloaded/imagesloaded"], function (t, e) {
                  return n(i, t, e);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = n(i, require("flickity"), require("imagesloaded")))
            : (i.Flickity = n(i, i.Flickity, i.imagesLoaded));
    })(window, function (t, e, i) {
        "use strict";
        e.createMethods.push("_createImagesLoaded");
        var n = e.prototype;
        return (
            (n._createImagesLoaded = function () {
                this.on("activate", this.imagesLoaded);
            }),
            (n.imagesLoaded = function () {
                if (this.options.imagesLoaded) {
                    var n = this;
                    i(this.slider).on("progress", function (t, e) {
                        var i = n.getParentCell(e.img);
                        n.cellSizeChange(i && i.element), n.options.freeScroll || n.positionSliderAtSelected();
                    });
                }
            }),
            e
        );
    });
/*! Flickity sync */
!(function (t, n) {
    "function" == typeof define && define.amd
        ? define(["flickity/js/index", "fizzy-ui-utils/utils"], n)
        : "object" == typeof module && module.exports
        ? (module.exports = n(require("flickity"), require("fizzy-ui-utils")))
        : (t.Flickity = n(t.Flickity, t.fizzyUIUtils));
})(window, function (i, e) {
    "use strict";
    return (
        i.createMethods.push("_createSync"),
        (i.prototype._createSync = function () {
            this.syncers = {};
            var t = this.options.sync;
            if ((this.on("destroy", this.unsyncAll), t)) {
                var n = this;
                setTimeout(function () {
                    n.sync(t);
                });
            }
        }),
        (i.prototype.sync = function (t) {
            t = e.getQueryElement(t);
            var n = i.data(t);
            n && (this._syncCompanion(n), n._syncCompanion(this));
        }),
        (i.prototype._syncCompanion = function (n) {
            var i = this;
            function t() {
                var t = i.selectedIndex;
                n.selectedIndex != t && n.select(t);
            }
            this.on("select", t), (this.syncers[n.guid] = { flickity: n, listener: t });
        }),
        (i.prototype.unsync = function (t) {
            t = e.getQueryElement(t);
            var n = i.data(t);
            this._unsync(n);
        }),
        (i.prototype._unsync = function (t) {
            t && (this._unsyncCompanion(t), t._unsyncCompanion(this));
        }),
        (i.prototype._unsyncCompanion = function (t) {
            var n = t.guid,
                i = this.syncers[n];
            this.off("select", i.listener), delete this.syncers[n];
        }),
        (i.prototype.unsyncAll = function () {
            for (var t in this.syncers) {
                var n = this.syncers[t];
                this._unsync(n.flickity);
            }
        }),
        i
    );
});
/*! jQuery throttle / debounce - v1.1 */
!(function (t, n) {
    var o,
        u = t.jQuery || t.Cowboy || (t.Cowboy = {});
    (u.throttle = o = function (t, o, e, i) {
        var r,
            a = 0;
        function c() {
            var u = this,
                c = +new Date() - a,
                f = arguments;
            function d() {
                (a = +new Date()), e.apply(u, f);
            }
            i && !r && d(),
                r && clearTimeout(r),
                i === n && c > t
                    ? d()
                    : !0 !== o &&
                      (r = setTimeout(
                          i
                              ? function () {
                                    r = n;
                                }
                              : d,
                          i === n ? t - c : t
                      ));
        }
        return "boolean" != typeof o && ((i = e), (e = o), (o = n)), u.guid && (c.guid = e.guid = e.guid || u.guid++), c;
    }),
        (u.debounce = function (t, u, e) {
            return e === n ? o(t, u, !1) : o(t, e, !1 !== u);
        });
})(this);
/*! History */
"object" != typeof JSON && (JSON = {}),
    (function () {
        "use strict";
        function f(e) {
            return e < 10 ? "0" + e : e;
        }
        function quote(e) {
            return (
                (escapable.lastIndex = 0),
                escapable.test(e)
                    ? '"' +
                      e.replace(escapable, function (e) {
                          var t = meta[e];
                          return "string" == typeof t ? t : "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4);
                      }) +
                      '"'
                    : '"' + e + '"'
            );
        }
        function str(e, t) {
            var a,
                r,
                n,
                o,
                i,
                s = gap,
                u = t[e];
            switch ((u && "object" == typeof u && "function" == typeof u.toJSON && (u = u.toJSON(e)), "function" == typeof rep && (u = rep.call(t, e, u)), typeof u)) {
                case "string":
                    return quote(u);
                case "number":
                    return isFinite(u) ? String(u) : "null";
                case "boolean":
                case "null":
                    return String(u);
                case "object":
                    if (!u) return "null";
                    if (((gap += indent), (i = []), "[object Array]" === Object.prototype.toString.apply(u))) {
                        for (o = u.length, a = 0; a < o; a += 1) i[a] = str(a, u) || "null";
                        return (n = 0 === i.length ? "[]" : gap ? "[\n" + gap + i.join(",\n" + gap) + "\n" + s + "]" : "[" + i.join(",") + "]"), (gap = s), n;
                    }
                    if (rep && "object" == typeof rep) for (o = rep.length, a = 0; a < o; a += 1) "string" == typeof rep[a] && ((r = rep[a]), (n = str(r, u)) && i.push(quote(r) + (gap ? ": " : ":") + n));
                    else for (r in u) Object.prototype.hasOwnProperty.call(u, r) && (n = str(r, u)) && i.push(quote(r) + (gap ? ": " : ":") + n);
                    return (n = 0 === i.length ? "{}" : gap ? "{\n" + gap + i.join(",\n" + gap) + "\n" + s + "}" : "{" + i.join(",") + "}"), (gap = s), n;
            }
        }
        "function" != typeof Date.prototype.toJSON &&
            ((Date.prototype.toJSON = function (e) {
                return isFinite(this.valueOf())
                    ? this.getUTCFullYear() + "-" + f(this.getUTCMonth() + 1) + "-" + f(this.getUTCDate()) + "T" + f(this.getUTCHours()) + ":" + f(this.getUTCMinutes()) + ":" + f(this.getUTCSeconds()) + "Z"
                    : null;
            }),
            (String.prototype.toJSON = Number.prototype.toJSON = Boolean.prototype.toJSON = function (e) {
                return this.valueOf();
            }));
        var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
            escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
            gap,
            indent,
            meta = { "\b": "\\b", "\t": "\\t", "\n": "\\n", "\f": "\\f", "\r": "\\r", '"': '\\"', "\\": "\\\\" },
            rep;
        "function" != typeof JSON.stringify &&
            (JSON.stringify = function (e, t, a) {
                var r;
                if (((gap = ""), (indent = ""), "number" == typeof a)) for (r = 0; r < a; r += 1) indent += " ";
                else "string" == typeof a && (indent = a);
                if (((rep = t), !t || "function" == typeof t || ("object" == typeof t && "number" == typeof t.length))) return str("", { "": e });
                throw new Error("JSON.stringify");
            }),
            "function" != typeof JSON.parse &&
                (JSON.parse = function (text, reviver) {
                    function walk(e, t) {
                        var a,
                            r,
                            n = e[t];
                        if (n && "object" == typeof n) for (a in n) Object.prototype.hasOwnProperty.call(n, a) && (void 0 !== (r = walk(n, a)) ? (n[a] = r) : delete n[a]);
                        return reviver.call(e, t, n);
                    }
                    var j;
                    if (
                        ((text = String(text)),
                        (cx.lastIndex = 0),
                        cx.test(text) &&
                            (text = text.replace(cx, function (e) {
                                return "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4);
                            })),
                        /^[\],:{}\s]*$/.test(
                            text
                                .replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, "@")
                                .replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, "]")
                                .replace(/(?:^|:|,)(?:\s*\[)+/g, "")
                        ))
                    )
                        return (j = eval("(" + text + ")")), "function" == typeof reviver ? walk({ "": j }, "") : j;
                    throw new SyntaxError("JSON.parse");
                });
    })(),
    (function (e, t) {
        "use strict";
        var a = (e.History = e.History || {}),
            r = e.jQuery;
        if (void 0 !== a.Adapter) throw new Error("History.js Adapter has already been loaded...");
        (a.Adapter = {
            bind: function (e, t, a) {
                r(e).bind(t, a);
            },
            trigger: function (e, t, a) {
                r(e).trigger(t, a);
            },
            extractEventData: function (e, t, a) {
                return (t && t.originalEvent && t.originalEvent[e]) || (a && a[e]) || void 0;
            },
            onDomLoad: function (e) {
                r(e);
            },
        }),
            void 0 !== a.init && a.init();
    })(window),
    (function (e, t) {
        "use strict";
        var a = e.document,
            r = e.setTimeout || r,
            n = e.clearTimeout || n,
            o = e.setInterval || o,
            i = (e.History = e.History || {});
        if (void 0 !== i.initHtml4) throw new Error("History.js HTML4 Support has already been loaded...");
        (i.initHtml4 = function () {
            if (void 0 !== i.initHtml4.initialized) return !1;
            (i.initHtml4.initialized = !0),
                (i.enabled = !0),
                (i.savedHashes = []),
                (i.isLastHash = function (e) {
                    return e === i.getHashByIndex();
                }),
                (i.isHashEqual = function (e, t) {
                    return (e = encodeURIComponent(e).replace(/%25/g, "%")), (t = encodeURIComponent(t).replace(/%25/g, "%")), e === t;
                }),
                (i.saveHash = function (e) {
                    return !i.isLastHash(e) && (i.savedHashes.push(e), !0);
                }),
                (i.getHashByIndex = function (e) {
                    return void 0 === e ? i.savedHashes[i.savedHashes.length - 1] : e < 0 ? i.savedHashes[i.savedHashes.length + e] : i.savedHashes[e];
                }),
                (i.discardedHashes = {}),
                (i.discardedStates = {}),
                (i.discardState = function (e, t, a) {
                    var r,
                        n = i.getHashByState(e);
                    return (r = { discardedState: e, backState: a, forwardState: t }), (i.discardedStates[n] = r), !0;
                }),
                (i.discardHash = function (e, t, a) {
                    var r = { discardedHash: e, backState: a, forwardState: t };
                    return (i.discardedHashes[e] = r), !0;
                }),
                (i.discardedState = function (e) {
                    var t = i.getHashByState(e);
                    return i.discardedStates[t] || !1;
                }),
                (i.discardedHash = function (e) {
                    return i.discardedHashes[e] || !1;
                }),
                (i.recycleState = function (e) {
                    var t = i.getHashByState(e);
                    return i.discardedState(e) && delete i.discardedStates[t], !0;
                }),
                i.emulated.hashChange &&
                    ((i.hashChangeInit = function () {
                        i.checkerFunction = null;
                        var t,
                            r,
                            n,
                            s,
                            u = "",
                            l = Boolean(i.getHash());
                        return (
                            i.isInternetExplorer()
                                ? ((t = "historyjs-iframe"),
                                  (r = a.createElement("iframe")).setAttribute("id", t),
                                  r.setAttribute("src", "#"),
                                  (r.style.display = "none"),
                                  a.body.appendChild(r),
                                  r.contentWindow.document.open(),
                                  r.contentWindow.document.close(),
                                  (n = ""),
                                  (s = !1),
                                  (i.checkerFunction = function () {
                                      if (s) return !1;
                                      s = !0;
                                      var t = i.getHash(),
                                          a = i.getHash(r.contentWindow.document);
                                      return (
                                          t !== u
                                              ? ((u = t),
                                                a !== t && ((n = a = t), r.contentWindow.document.open(), r.contentWindow.document.close(), (r.contentWindow.document.location.hash = i.escapeHash(t))),
                                                i.Adapter.trigger(e, "hashchange"))
                                              : a !== n && ((n = a), l && "" === a ? i.back() : i.setHash(a, !1)),
                                          (s = !1),
                                          !0
                                      );
                                  }))
                                : (i.checkerFunction = function () {
                                      var t = i.getHash() || "";
                                      return t !== u && ((u = t), i.Adapter.trigger(e, "hashchange")), !0;
                                  }),
                            i.intervalList.push(o(i.checkerFunction, i.options.hashChangeInterval)),
                            !0
                        );
                    }),
                    i.Adapter.onDomLoad(i.hashChangeInit)),
                i.emulated.pushState &&
                    ((i.onHashChange = function (t) {
                        var a,
                            r = (t && t.newURL) || i.getLocationHref(),
                            n = i.getHashByUrl(r),
                            o = null;
                        return i.isLastHash(n)
                            ? (i.busy(!1), !1)
                            : (i.doubleCheckComplete(),
                              i.saveHash(n),
                              n && i.isTraditionalAnchor(n)
                                  ? (i.Adapter.trigger(e, "anchorchange"), i.busy(!1), !1)
                                  : ((o = i.extractState(i.getFullUrl(n || i.getLocationHref()), !0)),
                                    i.isLastSavedState(o)
                                        ? (i.busy(!1), !1)
                                        : (i.getHashByState(o),
                                          (a = i.discardedState(o)) ? (i.getHashByIndex(-2) === i.getHashByState(a.forwardState) ? i.back(!1) : i.forward(!1), !1) : (i.pushState(o.data, o.title, encodeURI(o.url), !1), !0))));
                    }),
                    i.Adapter.bind(e, "hashchange", i.onHashChange),
                    (i.pushState = function (t, a, r, n) {
                        if (((r = encodeURI(r).replace(/%25/g, "%")), i.getHashByUrl(r))) throw new Error("History.js does not support states with fragment-identifiers (hashes/anchors).");
                        if (!1 !== n && i.busy()) return i.pushQueue({ scope: i, callback: i.pushState, args: arguments, queue: n }), !1;
                        i.busy(!0);
                        var o = i.createStateObject(t, a, r),
                            s = i.getHashByState(o),
                            u = i.getState(!1),
                            l = i.getHashByState(u),
                            c = i.getHash(),
                            d = i.expectedStateId == o.id;
                        return (
                            i.storeState(o),
                            (i.expectedStateId = o.id),
                            i.recycleState(o),
                            i.setTitle(o),
                            s === l ? (i.busy(!1), !1) : (i.saveState(o), d || i.Adapter.trigger(e, "statechange"), !i.isHashEqual(s, c) && !i.isHashEqual(s, i.getShortUrl(i.getLocationHref())) && i.setHash(s, !1), i.busy(!1), !0)
                        );
                    }),
                    (i.replaceState = function (t, a, r, n) {
                        if (((r = encodeURI(r).replace(/%25/g, "%")), i.getHashByUrl(r))) throw new Error("History.js does not support states with fragment-identifiers (hashes/anchors).");
                        if (!1 !== n && i.busy()) return i.pushQueue({ scope: i, callback: i.replaceState, args: arguments, queue: n }), !1;
                        i.busy(!0);
                        var o = i.createStateObject(t, a, r),
                            s = i.getHashByState(o),
                            u = i.getState(!1),
                            l = i.getHashByState(u),
                            c = i.getStateByIndex(-2);
                        return (
                            i.discardState(u, o, c),
                            s === l ? (i.storeState(o), (i.expectedStateId = o.id), i.recycleState(o), i.setTitle(o), i.saveState(o), i.Adapter.trigger(e, "statechange"), i.busy(!1)) : i.pushState(o.data, o.title, o.url, !1),
                            !0
                        );
                    })),
                i.emulated.pushState &&
                    i.getHash() &&
                    !i.emulated.hashChange &&
                    i.Adapter.onDomLoad(function () {
                        i.Adapter.trigger(e, "hashchange");
                    });
        }),
            void 0 !== i.init && i.init();
    })(window),
    (function (e, t) {
        "use strict";
        var a = e.console || t,
            r = e.document,
            n = e.navigator,
            o = !1,
            i = e.setTimeout,
            s = e.clearTimeout,
            u = e.setInterval,
            l = e.clearInterval,
            c = e.JSON,
            d = e.alert,
            p = (e.History = e.History || {}),
            h = e.history;
        try {
            (o = e.sessionStorage).setItem("TEST", "1"), o.removeItem("TEST");
        } catch (e) {
            o = !1;
        }
        if (((c.stringify = c.stringify || c.encode), (c.parse = c.parse || c.decode), void 0 !== p.init)) throw new Error("History.js Core has already been loaded...");
        (p.init = function (e) {
            return void 0 !== p.Adapter && (void 0 !== p.initCore && p.initCore(), void 0 !== p.initHtml4 && p.initHtml4(), !0);
        }),
            (p.initCore = function (g) {
                if (void 0 !== p.initCore.initialized) return !1;
                if (
                    ((p.initCore.initialized = !0),
                    (p.options = p.options || {}),
                    (p.options.hashChangeInterval = p.options.hashChangeInterval || 100),
                    (p.options.safariPollInterval = p.options.safariPollInterval || 500),
                    (p.options.doubleCheckInterval = p.options.doubleCheckInterval || 500),
                    (p.options.disableSuid = p.options.disableSuid || !1),
                    (p.options.storeInterval = p.options.storeInterval || 1e3),
                    (p.options.busyDelay = p.options.busyDelay || 250),
                    (p.options.debug = p.options.debug || !1),
                    (p.options.initialTitle = p.options.initialTitle || r.title),
                    (p.options.html4Mode = p.options.html4Mode || !1),
                    (p.options.delayInit = p.options.delayInit || !1),
                    (p.intervalList = []),
                    (p.clearAllIntervals = function () {
                        var e,
                            t = p.intervalList;
                        if (void 0 !== t && null !== t) {
                            for (e = 0; e < t.length; e++) l(t[e]);
                            p.intervalList = null;
                        }
                    }),
                    (p.debug = function () {
                        (p.options.debug || !1) && p.log.apply(p, arguments);
                    }),
                    (p.log = function () {
                        var e,
                            t,
                            n,
                            o,
                            i,
                            s = void 0 !== a && void 0 !== a.log && void 0 !== a.log.apply,
                            u = r.getElementById("log");
                        for (
                            s ? ((o = Array.prototype.slice.call(arguments)), (e = o.shift()), void 0 !== a.debug ? a.debug.apply(a, [e, o]) : a.log.apply(a, [e, o])) : (e = "\n" + arguments[0] + "\n"), t = 1, n = arguments.length;
                            t < n;
                            ++t
                        ) {
                            if ("object" == typeof (i = arguments[t]) && void 0 !== c)
                                try {
                                    i = c.stringify(i);
                                } catch (e) {}
                            e += "\n" + i + "\n";
                        }
                        return u ? ((u.value += e + "\n-----\n"), (u.scrollTop = u.scrollHeight - u.clientHeight)) : s || d(e), !0;
                    }),
                    (p.getInternetExplorerMajorVersion = function () {
                        return (p.getInternetExplorerMajorVersion.cached =
                            void 0 !== p.getInternetExplorerMajorVersion.cached
                                ? p.getInternetExplorerMajorVersion.cached
                                : (function () {
                                      for (var e = 3, t = r.createElement("div"), a = t.getElementsByTagName("i"); (t.innerHTML = "\x3c!--[if gt IE " + ++e + "]><i></i><![endif]--\x3e") && a[0]; );
                                      return e > 4 && e;
                                  })());
                    }),
                    (p.isInternetExplorer = function () {
                        return (p.isInternetExplorer.cached = void 0 !== p.isInternetExplorer.cached ? p.isInternetExplorer.cached : Boolean(p.getInternetExplorerMajorVersion()));
                    }),
                    p.options.html4Mode
                        ? (p.emulated = { pushState: !0, hashChange: !0 })
                        : (p.emulated = {
                              pushState: !Boolean(e.history && e.history.pushState && e.history.replaceState && !/ Mobile\/([1-7][a-z]|(8([abcde]|f(1[0-8]))))/i.test(n.userAgent) && !/AppleWebKit\/5([0-2]|3[0-2])/i.test(n.userAgent)),
                              hashChange: Boolean(!("onhashchange" in e || "onhashchange" in r) || (p.isInternetExplorer() && p.getInternetExplorerMajorVersion() < 8)),
                          }),
                    (p.enabled = !p.emulated.pushState),
                    (p.bugs = {
                        setHash: Boolean(!p.emulated.pushState && "Apple Computer, Inc." === n.vendor && /AppleWebKit\/5([0-2]|3[0-3])/.test(n.userAgent)),
                        safariPoll: Boolean(!p.emulated.pushState && "Apple Computer, Inc." === n.vendor && /AppleWebKit\/5([0-2]|3[0-3])/.test(n.userAgent)),
                        ieDoubleCheck: Boolean(p.isInternetExplorer() && p.getInternetExplorerMajorVersion() < 8),
                        hashEscape: Boolean(p.isInternetExplorer() && p.getInternetExplorerMajorVersion() < 7),
                    }),
                    (p.isEmptyObject = function (e) {
                        for (var t in e) if (e.hasOwnProperty(t)) return !1;
                        return !0;
                    }),
                    (p.cloneObject = function (e) {
                        var t, a;
                        return e ? ((t = c.stringify(e)), (a = c.parse(t))) : (a = {}), a;
                    }),
                    (p.getRootUrl = function () {
                        var e = r.location.protocol + "//" + (r.location.hostname || r.location.host);
                        return r.location.port && (e += ":" + r.location.port), (e += "/");
                    }),
                    (p.getBaseHref = function () {
                        var e = r.getElementsByTagName("base"),
                            t = null,
                            a = "";
                        return 1 === e.length && ((t = e[0]), (a = t.href.replace(/[^\/]+$/, ""))), (a = a.replace(/\/+$/, "")) && (a += "/"), a;
                    }),
                    (p.getBaseUrl = function () {
                        return p.getBaseHref() || p.getBasePageUrl() || p.getRootUrl();
                    }),
                    (p.getPageUrl = function () {
                        return ((p.getState(!1, !1) || {}).url || p.getLocationHref()).replace(/\/+$/, "").replace(/[^\/]+$/, function (e, t, a) {
                            return /\./.test(e) ? e : e + "/";
                        });
                    }),
                    (p.getBasePageUrl = function () {
                        return (
                            p
                                .getLocationHref()
                                .replace(/[#\?].*/, "")
                                .replace(/[^\/]+$/, function (e, t, a) {
                                    return /[^\/]$/.test(e) ? "" : e;
                                })
                                .replace(/\/+$/, "") + "/"
                        );
                    }),
                    (p.getFullUrl = function (e, t) {
                        var a = e,
                            r = e.substring(0, 1);
                        return (
                            (t = void 0 === t || t),
                            /[a-z]+\:\/\//.test(e) ||
                                (a =
                                    "/" === r
                                        ? p.getRootUrl() + e.replace(/^\/+/, "")
                                        : "#" === r
                                        ? p.getPageUrl().replace(/#.*/, "") + e
                                        : "?" === r
                                        ? p.getPageUrl().replace(/[\?#].*/, "") + e
                                        : t
                                        ? p.getBaseUrl() + e.replace(/^(\.\/)+/, "")
                                        : p.getBasePageUrl() + e.replace(/^(\.\/)+/, "")),
                            a.replace(/\#$/, "")
                        );
                    }),
                    (p.getShortUrl = function (e) {
                        var t = e,
                            a = p.getBaseUrl(),
                            r = p.getRootUrl();
                        return p.emulated.pushState && (t = t.replace(a, "")), (t = t.replace(r, "/")), p.isTraditionalAnchor(t) && (t = "./" + t), (t = t.replace(/^(\.\/)+/g, "./").replace(/\#$/, ""));
                    }),
                    (p.getLocationHref = function (e) {
                        return (e = e || r).URL === e.location.href
                            ? e.location.href
                            : e.location.href === decodeURIComponent(e.URL)
                            ? e.URL
                            : e.location.hash && decodeURIComponent(e.location.href.replace(/^[^#]+/, "")) === e.location.hash
                            ? e.location.href
                            : -1 == e.URL.indexOf("#") && -1 != e.location.href.indexOf("#")
                            ? e.location.href
                            : e.URL || e.location.href;
                    }),
                    (p.store = {}),
                    (p.idToState = p.idToState || {}),
                    (p.stateToId = p.stateToId || {}),
                    (p.urlToId = p.urlToId || {}),
                    (p.storedStates = p.storedStates || []),
                    (p.savedStates = p.savedStates || []),
                    (p.normalizeStore = function () {
                        (p.store.idToState = p.store.idToState || {}), (p.store.urlToId = p.store.urlToId || {}), (p.store.stateToId = p.store.stateToId || {});
                    }),
                    (p.getState = function (e, t) {
                        void 0 === e && (e = !0), void 0 === t && (t = !0);
                        var a = p.getLastSavedState();
                        return !a && t && (a = p.createStateObject()), e && ((a = p.cloneObject(a)), (a.url = a.cleanUrl || a.url)), a;
                    }),
                    (p.getIdByState = function (e) {
                        var t,
                            a = p.extractId(e.url);
                        if (!a)
                            if (((t = p.getStateString(e)), void 0 !== p.stateToId[t])) a = p.stateToId[t];
                            else if (void 0 !== p.store.stateToId[t]) a = p.store.stateToId[t];
                            else {
                                for (; (a = new Date().getTime() + String(Math.random()).replace(/\D/g, "")), void 0 !== p.idToState[a] || void 0 !== p.store.idToState[a]; );
                                (p.stateToId[t] = a), (p.idToState[a] = e);
                            }
                        return a;
                    }),
                    (p.normalizeState = function (e) {
                        var t, a;
                        return (
                            (e && "object" == typeof e) || (e = {}),
                            void 0 !== e.normalized
                                ? e
                                : ((e.data && "object" == typeof e.data) || (e.data = {}),
                                  (t = {}),
                                  (t.normalized = !0),
                                  (t.title = e.title || ""),
                                  (t.url = p.getFullUrl(e.url ? e.url : p.getLocationHref())),
                                  (t.hash = p.getShortUrl(t.url)),
                                  (t.data = p.cloneObject(e.data)),
                                  (t.id = p.getIdByState(t)),
                                  (t.cleanUrl = t.url.replace(/\??\&_suid.*/, "")),
                                  (t.url = t.cleanUrl),
                                  (a = !p.isEmptyObject(t.data)),
                                  (t.title || a) && !0 !== p.options.disableSuid && ((t.hash = p.getShortUrl(t.url).replace(/\??\&_suid.*/, "")), /\?/.test(t.hash) || (t.hash += "?"), (t.hash += "&_suid=" + t.id)),
                                  (t.hashedUrl = p.getFullUrl(t.hash)),
                                  (p.emulated.pushState || p.bugs.safariPoll) && p.hasUrlDuplicate(t) && (t.url = t.hashedUrl),
                                  t)
                        );
                    }),
                    (p.createStateObject = function (e, t, a) {
                        var r = { data: e, title: t, url: a };
                        return (r = p.normalizeState(r));
                    }),
                    (p.getStateById = function (e) {
                        return (e = String(e)), p.idToState[e] || p.store.idToState[e] || t;
                    }),
                    (p.getStateString = function (e) {
                        var t, a;
                        return (t = p.normalizeState(e)), (a = { data: t.data, title: e.title, url: e.url }), c.stringify(a);
                    }),
                    (p.getStateId = function (e) {
                        var t;
                        return (t = p.normalizeState(e)), t.id;
                    }),
                    (p.getHashByState = function (e) {
                        var t;
                        return (t = p.normalizeState(e)), t.hash;
                    }),
                    (p.extractId = function (e) {
                        var t, a;
                        return (a = -1 != e.indexOf("#") ? e.split("#")[0] : e), (t = /(.*)\&_suid=([0-9]+)$/.exec(a)), t ? t[1] || e : e, (t ? String(t[2] || "") : "") || !1;
                    }),
                    (p.isTraditionalAnchor = function (e) {
                        return !/[\/\?\.]/.test(e);
                    }),
                    (p.extractState = function (e, t) {
                        var a,
                            r,
                            n = null;
                        return (
                            (t = t || !1),
                            (a = p.extractId(e)) && (n = p.getStateById(a)),
                            n || ((r = p.getFullUrl(e)), (a = p.getIdByUrl(r) || !1) && (n = p.getStateById(a)), !n && t && !p.isTraditionalAnchor(e) && (n = p.createStateObject(null, null, r))),
                            n
                        );
                    }),
                    (p.getIdByUrl = function (e) {
                        return p.urlToId[e] || p.store.urlToId[e] || t;
                    }),
                    (p.getLastSavedState = function () {
                        return p.savedStates[p.savedStates.length - 1] || t;
                    }),
                    (p.getLastStoredState = function () {
                        return p.storedStates[p.storedStates.length - 1] || t;
                    }),
                    (p.hasUrlDuplicate = function (e) {
                        var t;
                        return (t = p.extractState(e.url)), t && t.id !== e.id;
                    }),
                    (p.storeState = function (e) {
                        return (p.urlToId[e.url] = e.id), p.storedStates.push(p.cloneObject(e)), e;
                    }),
                    (p.isLastSavedState = function (e) {
                        var t,
                            a,
                            r,
                            n = !1;
                        return p.savedStates.length && ((t = e.id), (a = p.getLastSavedState()), (r = a.id), (n = t === r)), n;
                    }),
                    (p.saveState = function (e) {
                        return !p.isLastSavedState(e) && (p.savedStates.push(p.cloneObject(e)), !0);
                    }),
                    (p.getStateByIndex = function (e) {
                        return void 0 === e ? p.savedStates[p.savedStates.length - 1] : e < 0 ? p.savedStates[p.savedStates.length + e] : p.savedStates[e];
                    }),
                    (p.getCurrentIndex = function () {
                        return p.savedStates.length < 1 ? 0 : p.savedStates.length - 1;
                    }),
                    (p.getHash = function (e) {
                        var t = p.getLocationHref(e);
                        return p.getHashByUrl(t);
                    }),
                    (p.unescapeHash = function (e) {
                        var t = p.normalizeHash(e);
                        return (t = decodeURIComponent(t));
                    }),
                    (p.normalizeHash = function (e) {
                        return e.replace(/[^#]*#/, "").replace(/#.*/, "");
                    }),
                    (p.setHash = function (e, t) {
                        var a, n;
                        return !1 !== t && p.busy()
                            ? (p.pushQueue({ scope: p, callback: p.setHash, args: arguments, queue: t }), !1)
                            : (p.busy(!0),
                              (a = p.extractState(e, !0)) && !p.emulated.pushState
                                  ? p.pushState(a.data, a.title, a.url, !1)
                                  : p.getHash() !== e && (p.bugs.setHash ? ((n = p.getPageUrl()), p.pushState(null, null, n + "#" + e, !1)) : (r.location.hash = e)),
                              p);
                    }),
                    (p.escapeHash = function (t) {
                        var a = p.normalizeHash(t);
                        return (a = e.encodeURIComponent(a)), p.bugs.hashEscape || (a = a.replace(/\%21/g, "!").replace(/\%26/g, "&").replace(/\%3D/g, "=").replace(/\%3F/g, "?")), a;
                    }),
                    (p.getHashByUrl = function (e) {
                        var t = String(e).replace(/([^#]*)#?([^#]*)#?(.*)/, "$2");
                        return (t = p.unescapeHash(t));
                    }),
                    (p.setTitle = function (e) {
                        var t,
                            a = e.title;
                        a || ((t = p.getStateByIndex(0)) && t.url === e.url && (a = t.title || p.options.initialTitle));
                        try {
                            r.getElementsByTagName("title")[0].innerHTML = a.replace("<", "&lt;").replace(">", "&gt;").replace(" & ", " &amp; ");
                        } catch (e) {}
                        return (r.title = a), p;
                    }),
                    (p.queues = []),
                    (p.busy = function (e) {
                        if ((void 0 !== e ? (p.busy.flag = e) : void 0 === p.busy.flag && (p.busy.flag = !1), !p.busy.flag)) {
                            s(p.busy.timeout);
                            var t = function () {
                                var e, a, r;
                                if (!p.busy.flag) for (e = p.queues.length - 1; e >= 0; --e) 0 !== (a = p.queues[e]).length && ((r = a.shift()), p.fireQueueItem(r), (p.busy.timeout = i(t, p.options.busyDelay)));
                            };
                            p.busy.timeout = i(t, p.options.busyDelay);
                        }
                        return p.busy.flag;
                    }),
                    (p.busy.flag = !1),
                    (p.fireQueueItem = function (e) {
                        return e.callback.apply(e.scope || p, e.args || []);
                    }),
                    (p.pushQueue = function (e) {
                        return (p.queues[e.queue || 0] = p.queues[e.queue || 0] || []), p.queues[e.queue || 0].push(e), p;
                    }),
                    (p.queue = function (e, t) {
                        return "function" == typeof e && (e = { callback: e }), void 0 !== t && (e.queue = t), p.busy() ? p.pushQueue(e) : p.fireQueueItem(e), p;
                    }),
                    (p.clearQueue = function () {
                        return (p.busy.flag = !1), (p.queues = []), p;
                    }),
                    (p.stateChanged = !1),
                    (p.doubleChecker = !1),
                    (p.doubleCheckComplete = function () {
                        return (p.stateChanged = !0), p.doubleCheckClear(), p;
                    }),
                    (p.doubleCheckClear = function () {
                        return p.doubleChecker && (s(p.doubleChecker), (p.doubleChecker = !1)), p;
                    }),
                    (p.doubleCheck = function (e) {
                        return (
                            (p.stateChanged = !1),
                            p.doubleCheckClear(),
                            p.bugs.ieDoubleCheck &&
                                (p.doubleChecker = i(function () {
                                    return p.doubleCheckClear(), p.stateChanged || e(), !0;
                                }, p.options.doubleCheckInterval)),
                            p
                        );
                    }),
                    (p.safariStatePoll = function () {
                        var t = p.extractState(p.getLocationHref());
                        if (!p.isLastSavedState(t)) return t || p.createStateObject(), p.Adapter.trigger(e, "popstate"), p;
                    }),
                    (p.back = function (e) {
                        return !1 !== e && p.busy()
                            ? (p.pushQueue({ scope: p, callback: p.back, args: arguments, queue: e }), !1)
                            : (p.busy(!0),
                              p.doubleCheck(function () {
                                  p.back(!1);
                              }),
                              h.go(-1),
                              !0);
                    }),
                    (p.forward = function (e) {
                        return !1 !== e && p.busy()
                            ? (p.pushQueue({ scope: p, callback: p.forward, args: arguments, queue: e }), !1)
                            : (p.busy(!0),
                              p.doubleCheck(function () {
                                  p.forward(!1);
                              }),
                              h.go(1),
                              !0);
                    }),
                    (p.go = function (e, t) {
                        var a;
                        if (e > 0) for (a = 1; a <= e; ++a) p.forward(t);
                        else {
                            if (!(e < 0)) throw new Error("History.go: History.go requires a positive or negative integer passed.");
                            for (a = -1; a >= e; --a) p.back(t);
                        }
                        return p;
                    }),
                    p.emulated.pushState)
                ) {
                    var f = function () {};
                    (p.pushState = p.pushState || f), (p.replaceState = p.replaceState || f);
                } else
                    (p.onPopState = function (t, a) {
                        var r,
                            n,
                            o = !1,
                            i = !1;
                        return (
                            p.doubleCheckComplete(),
                            (r = p.getHash())
                                ? ((n = p.extractState(r || p.getLocationHref(), !0)) ? p.replaceState(n.data, n.title, n.url, !1) : (p.Adapter.trigger(e, "anchorchange"), p.busy(!1)), (p.expectedStateId = !1), !1)
                                : ((o = p.Adapter.extractEventData("state", t, a) || !1),
                                  (i = o ? p.getStateById(o) : p.expectedStateId ? p.getStateById(p.expectedStateId) : p.extractState(p.getLocationHref())) || (i = p.createStateObject(null, null, p.getLocationHref())),
                                  (p.expectedStateId = !1),
                                  p.isLastSavedState(i) ? (p.busy(!1), !1) : (p.storeState(i), p.saveState(i), p.setTitle(i), p.Adapter.trigger(e, "statechange"), p.busy(!1), !0))
                        );
                    }),
                        p.Adapter.bind(e, "popstate", p.onPopState),
                        (p.pushState = function (t, a, r, n) {
                            if (p.getHashByUrl(r) && p.emulated.pushState) throw new Error("History.js does not support states with fragement-identifiers (hashes/anchors).");
                            if (!1 !== n && p.busy()) return p.pushQueue({ scope: p, callback: p.pushState, args: arguments, queue: n }), !1;
                            p.busy(!0);
                            var o = p.createStateObject(t, a, r);
                            return p.isLastSavedState(o) ? p.busy(!1) : (p.storeState(o), (p.expectedStateId = o.id), h.pushState(o.id, o.title, o.url), p.Adapter.trigger(e, "popstate")), !0;
                        }),
                        (p.replaceState = function (t, a, r, n) {
                            if (p.getHashByUrl(r) && p.emulated.pushState) throw new Error("History.js does not support states with fragement-identifiers (hashes/anchors).");
                            if (!1 !== n && p.busy()) return p.pushQueue({ scope: p, callback: p.replaceState, args: arguments, queue: n }), !1;
                            p.busy(!0);
                            var o = p.createStateObject(t, a, r);
                            return p.isLastSavedState(o) ? p.busy(!1) : (p.storeState(o), (p.expectedStateId = o.id), h.replaceState(o.id, o.title, o.url), p.Adapter.trigger(e, "popstate")), !0;
                        });
                if (o) {
                    try {
                        p.store = c.parse(o.getItem("History.store")) || {};
                    } catch (e) {
                        p.store = {};
                    }
                    p.normalizeStore();
                } else (p.store = {}), p.normalizeStore();
                p.Adapter.bind(e, "unload", p.clearAllIntervals),
                    p.saveState(p.storeState(p.extractState(p.getLocationHref(), !0))),
                    o &&
                        ((p.onUnload = function () {
                            var e, t, a;
                            try {
                                e = c.parse(o.getItem("History.store")) || {};
                            } catch (t) {
                                e = {};
                            }
                            (e.idToState = e.idToState || {}), (e.urlToId = e.urlToId || {}), (e.stateToId = e.stateToId || {});
                            for (t in p.idToState) p.idToState.hasOwnProperty(t) && (e.idToState[t] = p.idToState[t]);
                            for (t in p.urlToId) p.urlToId.hasOwnProperty(t) && (e.urlToId[t] = p.urlToId[t]);
                            for (t in p.stateToId) p.stateToId.hasOwnProperty(t) && (e.stateToId[t] = p.stateToId[t]);
                            (p.store = e), p.normalizeStore(), (a = c.stringify(e));
                            try {
                                o.setItem("History.store", a);
                            } catch (e) {
                                if (e.code !== DOMException.QUOTA_EXCEEDED_ERR) throw e;
                                o.length && (o.removeItem("History.store"), o.setItem("History.store", a));
                            }
                        }),
                        p.intervalList.push(u(p.onUnload, p.options.storeInterval)),
                        p.Adapter.bind(e, "beforeunload", p.onUnload),
                        p.Adapter.bind(e, "unload", p.onUnload)),
                    p.emulated.pushState ||
                        (p.bugs.safariPoll && p.intervalList.push(u(p.safariStatePoll, p.options.safariPollInterval)),
                        ("Apple Computer, Inc." !== n.vendor && "Mozilla" !== (n.appCodeName || "")) ||
                            (p.Adapter.bind(e, "hashchange", function () {
                                p.Adapter.trigger(e, "popstate");
                            }),
                            p.getHash() &&
                                p.Adapter.onDomLoad(function () {
                                    p.Adapter.trigger(e, "hashchange");
                                })));
            }),
            (!p.options || !p.options.delayInit) && p.init();
    })(window);
/*! Currency tools */
if (void 0 === Currency) var Currency = {};
(Currency.cookie = {
    name: "roarStorage_currency",
    write: function (t) {
        try {
            localStorage.setItem(this.name, t);
        } catch (t) {}
    },
    read: function () {
        try {
            return localStorage.getItem(this.name);
        } catch (t) {
            return null;
        }
    },
    destroy: function () {
        try {
            localStorage.setItem(this.name, null);
        } catch (t) {}
    },
}),
    (Currency.moneyFormats = {
        USD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} USD" },
        EUR: { money_format: "&euro;{{amount}}", money_with_currency_format: "&euro;{{amount}} EUR" },
        GBP: { money_format: "&pound;{{amount}}", money_with_currency_format: "&pound;{{amount}} GBP" },
        CAD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} CAD" },
        ALL: { money_format: "Lek {{amount}}", money_with_currency_format: "Lek {{amount}} ALL" },
        DZD: { money_format: "DA {{amount}}", money_with_currency_format: "DA {{amount}} DZD" },
        AOA: { money_format: "Kz{{amount}}", money_with_currency_format: "Kz{{amount}} AOA" },
        ARS: { money_format: "${{amount_with_comma_separator}}", money_with_currency_format: "${{amount_with_comma_separator}} ARS" },
        AMD: { money_format: "{{amount}} AMD", money_with_currency_format: "{{amount}} AMD" },
        AWG: { money_format: "Afl{{amount}}", money_with_currency_format: "Afl{{amount}} AWG" },
        AUD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} AUD" },
        BBD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} Bds" },
        AZN: { money_format: "m.{{amount}}", money_with_currency_format: "m.{{amount}} AZN" },
        BDT: { money_format: "Tk {{amount}}", money_with_currency_format: "Tk {{amount}} BDT" },
        BSD: { money_format: "BS${{amount}}", money_with_currency_format: "BS${{amount}} BSD" },
        BHD: { money_format: "{{amount}}0 BD", money_with_currency_format: "{{amount}}0 BHD" },
        BYR: { money_format: "Br {{amount}}", money_with_currency_format: "Br {{amount}} BYR" },
        BZD: { money_format: "BZ${{amount}}", money_with_currency_format: "BZ${{amount}} BZD" },
        BTN: { money_format: "Nu {{amount}}", money_with_currency_format: "Nu {{amount}} BTN" },
        BAM: { money_format: "KM {{amount_with_comma_separator}}", money_with_currency_format: "KM {{amount_with_comma_separator}} BAM" },
        BRL: { money_format: "R$ {{amount_with_comma_separator}}", money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL" },
        BOB: { money_format: "Bs{{amount_with_comma_separator}}", money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB" },
        BWP: { money_format: "P{{amount}}", money_with_currency_format: "P{{amount}} BWP" },
        BND: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} BND" },
        BGN: { money_format: "{{amount}} лв", money_with_currency_format: "{{amount}} лв BGN" },
        MMK: { money_format: "K{{amount}}", money_with_currency_format: "K{{amount}} MMK" },
        KHR: { money_format: "KHR{{amount}}", money_with_currency_format: "KHR{{amount}}" },
        KYD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} KYD" },
        XAF: { money_format: "FCFA{{amount}}", money_with_currency_format: "FCFA{{amount}} XAF" },
        CLP: { money_format: "${{amount_no_decimals}}", money_with_currency_format: "${{amount_no_decimals}} CLP" },
        CNY: { money_format: "&#165;{{amount}}", money_with_currency_format: "&#165;{{amount}} CNY" },
        COP: { money_format: "${{amount_with_comma_separator}}", money_with_currency_format: "${{amount_with_comma_separator}} COP" },
        CRC: { money_format: "&#8353; {{amount_with_comma_separator}}", money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC" },
        HRK: { money_format: "{{amount_with_comma_separator}} kn", money_with_currency_format: "{{amount_with_comma_separator}} kn HRK" },
        CZK: { money_format: "{{amount_with_comma_separator}} K&#269;", money_with_currency_format: "{{amount_with_comma_separator}} K&#269;" },
        DKK: { money_format: "{{amount_with_comma_separator}}", money_with_currency_format: "kr.{{amount_with_comma_separator}}" },
        DOP: { money_format: "RD$ {{amount}}", money_with_currency_format: "RD$ {{amount}}" },
        XCD: { money_format: "${{amount}}", money_with_currency_format: "EC${{amount}}" },
        EGP: { money_format: "LE {{amount}}", money_with_currency_format: "LE {{amount}} EGP" },
        ETB: { money_format: "Br{{amount}}", money_with_currency_format: "Br{{amount}} ETB" },
        XPF: { money_format: "{{amount_no_decimals_with_comma_separator}} XPF", money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} XPF" },
        FJD: { money_format: "${{amount}}", money_with_currency_format: "FJ${{amount}}" },
        GMD: { money_format: "D {{amount}}", money_with_currency_format: "D {{amount}} GMD" },
        GHS: { money_format: "GH&#8373;{{amount}}", money_with_currency_format: "GH&#8373;{{amount}}" },
        GTQ: { money_format: "Q{{amount}}", money_with_currency_format: "{{amount}} GTQ" },
        GYD: { money_format: "G${{amount}}", money_with_currency_format: "${{amount}} GYD" },
        GEL: { money_format: "{{amount}} GEL", money_with_currency_format: "{{amount}} GEL" },
        HNL: { money_format: "L {{amount}}", money_with_currency_format: "L {{amount}} HNL" },
        HKD: { money_format: "${{amount}}", money_with_currency_format: "HK${{amount}}" },
        HUF: { money_format: "{{amount_no_decimals_with_comma_separator}}", money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} Ft" },
        ISK: { money_format: "{{amount_no_decimals}} kr", money_with_currency_format: "{{amount_no_decimals}} kr ISK" },
        INR: { money_format: "Rs. {{amount}}", money_with_currency_format: "Rs. {{amount}}" },
        IDR: { money_format: "{{amount_with_comma_separator}}", money_with_currency_format: "Rp {{amount_with_comma_separator}}" },
        ILS: { money_format: "{{amount}} NIS", money_with_currency_format: "{{amount}} NIS" },
        JMD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} JMD" },
        JPY: { money_format: "&#165;{{amount_no_decimals}}", money_with_currency_format: "&#165;{{amount_no_decimals}} JPY" },
        JEP: { money_format: "&pound;{{amount}}", money_with_currency_format: "&pound;{{amount}} JEP" },
        JOD: { money_format: "{{amount}}0 JD", money_with_currency_format: "{{amount}}0 JOD" },
        KZT: { money_format: "{{amount}} KZT", money_with_currency_format: "{{amount}} KZT" },
        KES: { money_format: "KSh{{amount}}", money_with_currency_format: "KSh{{amount}}" },
        KWD: { money_format: "{{amount}}0 KD", money_with_currency_format: "{{amount}}0 KWD" },
        KGS: { money_format: "лв{{amount}}", money_with_currency_format: "лв{{amount}}" },
        LVL: { money_format: "Ls {{amount}}", money_with_currency_format: "Ls {{amount}} LVL" },
        LBP: { money_format: "L&pound;{{amount}}", money_with_currency_format: "L&pound;{{amount}} LBP" },
        LTL: { money_format: "{{amount}} Lt", money_with_currency_format: "{{amount}} Lt" },
        MGA: { money_format: "Ar {{amount}}", money_with_currency_format: "Ar {{amount}} MGA" },
        MKD: { money_format: "ден {{amount}}", money_with_currency_format: "ден {{amount}} MKD" },
        MOP: { money_format: "MOP${{amount}}", money_with_currency_format: "MOP${{amount}}" },
        MVR: { money_format: "Rf{{amount}}", money_with_currency_format: "Rf{{amount}} MRf" },
        MXN: { money_format: "$ {{amount}}", money_with_currency_format: "$ {{amount}} MXN" },
        MYR: { money_format: "RM{{amount}} MYR", money_with_currency_format: "RM{{amount}} MYR" },
        MUR: { money_format: "Rs {{amount}}", money_with_currency_format: "Rs {{amount}} MUR" },
        MDL: { money_format: "{{amount}} MDL", money_with_currency_format: "{{amount}} MDL" },
        MAD: { money_format: "{{amount}} dh", money_with_currency_format: "Dh {{amount}} MAD" },
        MNT: { money_format: "{{amount_no_decimals}} &#8366", money_with_currency_format: "{{amount_no_decimals}} MNT" },
        MZN: { money_format: "{{amount}} Mt", money_with_currency_format: "Mt {{amount}} MZN" },
        NAD: { money_format: "N${{amount}}", money_with_currency_format: "N${{amount}} NAD" },
        NPR: { money_format: "Rs{{amount}}", money_with_currency_format: "Rs{{amount}} NPR" },
        ANG: { money_format: "&fnof;{{amount}}", money_with_currency_format: "{{amount}} NA&fnof;" },
        NZD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} NZD" },
        NIO: { money_format: "C${{amount}}", money_with_currency_format: "C${{amount}} NIO" },
        NGN: { money_format: "&#8358;{{amount}}", money_with_currency_format: "&#8358;{{amount}} NGN" },
        NOK: { money_format: "kr {{amount_with_comma_separator}}", money_with_currency_format: "kr {{amount_with_comma_separator}} NOK" },
        OMR: { money_format: "{{amount_with_comma_separator}} OMR", money_with_currency_format: "{{amount_with_comma_separator}} OMR" },
        PKR: { money_format: "Rs.{{amount}}", money_with_currency_format: "Rs.{{amount}} PKR" },
        PGK: { money_format: "K {{amount}}", money_with_currency_format: "K {{amount}} PGK" },
        PYG: { money_format: "Gs. {{amount_no_decimals_with_comma_separator}}", money_with_currency_format: "Gs. {{amount_no_decimals_with_comma_separator}} PYG" },
        PEN: { money_format: "S/. {{amount}}", money_with_currency_format: "S/. {{amount}} PEN" },
        PHP: { money_format: "&#8369;{{amount}}", money_with_currency_format: "&#8369;{{amount}} PHP" },
        PLN: { money_format: "{{amount_with_comma_separator}} zl", money_with_currency_format: "{{amount_with_comma_separator}} zl PLN" },
        QAR: { money_format: "QAR {{amount_with_comma_separator}}", money_with_currency_format: "QAR {{amount_with_comma_separator}}" },
        RON: { money_format: "{{amount_with_comma_separator}} lei", money_with_currency_format: "{{amount_with_comma_separator}} lei RON" },
        RUB: { money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}", money_with_currency_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB" },
        RWF: { money_format: "{{amount_no_decimals}} RF", money_with_currency_format: "{{amount_no_decimals}} RWF" },
        WST: { money_format: "WS$ {{amount}}", money_with_currency_format: "WS$ {{amount}} WST" },
        SAR: { money_format: "{{amount}} SR", money_with_currency_format: "{{amount}} SAR" },
        STD: { money_format: "Db {{amount}}", money_with_currency_format: "Db {{amount}} STD" },
        RSD: { money_format: "{{amount}} RSD", money_with_currency_format: "{{amount}} RSD" },
        SCR: { money_format: "Rs {{amount}}", money_with_currency_format: "Rs {{amount}} SCR" },
        SGD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} SGD" },
        SYP: { money_format: "S&pound;{{amount}}", money_with_currency_format: "S&pound;{{amount}} SYP" },
        ZAR: { money_format: "R {{amount}}", money_with_currency_format: "R {{amount}} ZAR" },
        KRW: { money_format: "&#8361;{{amount_no_decimals}}", money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW" },
        LKR: { money_format: "Rs {{amount}}", money_with_currency_format: "Rs {{amount}} LKR" },
        SEK: { money_format: "{{amount_no_decimals}} kr", money_with_currency_format: "{{amount_no_decimals}} kr SEK" },
        CHF: { money_format: "SFr. {{amount}}", money_with_currency_format: "SFr. {{amount}} CHF" },
        TWD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} TWD" },
        THB: { money_format: "{{amount}} &#xe3f;", money_with_currency_format: "{{amount}} &#xe3f; THB" },
        TZS: { money_format: "{{amount}} TZS", money_with_currency_format: "{{amount}} TZS" },
        TTD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} TTD" },
        TND: { money_format: "{{amount}}", money_with_currency_format: "{{amount}} DT" },
        TRY: { money_format: "{{amount}}TL", money_with_currency_format: "{{amount}}TL" },
        UGX: { money_format: "Ush {{amount_no_decimals}}", money_with_currency_format: "Ush {{amount_no_decimals}} UGX" },
        UAH: { money_format: "₴{{amount}}", money_with_currency_format: "₴{{amount}} UAH" },
        AED: { money_format: "Dhs. {{amount}}", money_with_currency_format: "Dhs. {{amount}} AED" },
        UYU: { money_format: "${{amount_with_comma_separator}}", money_with_currency_format: "${{amount_with_comma_separator}} UYU" },
        VUV: { money_format: "${{amount}}", money_with_currency_format: "${{amount}}VT" },
        VEF: { money_format: "Bs. {{amount_with_comma_separator}}", money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF" },
        VND: { money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;", money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} VND" },
        XBT: { money_format: "{{amount_no_decimals}} BTC", money_with_currency_format: "{{amount_no_decimals}} BTC" },
        XOF: { money_format: "CFA{{amount}}", money_with_currency_format: "CFA{{amount}} XOF" },
        ZMW: { money_format: "K{{amount_no_decimals_with_comma_separator}}", money_with_currency_format: "ZMW{{amount_no_decimals_with_comma_separator}}" },
        AFN: { money_format: "&#65;&#102; {{amount}}", money_with_currency_format: "&#65;&#102; {{amount}} AFN" },
        CVE: { money_format: "&#36; {{amount}}", money_with_currency_format: "&#36; {{amount}} CVE" },
        KMF: { money_format: "&#67;&#70; {{amount}}", money_with_currency_format: "&#67;&#70; {{amount}} KMF" },
        CDF: { money_format: "&#70;&#67; {{amount}}", money_with_currency_format: "&#70;&#67; {{amount}} CDF" },
        HTG: { money_format: "&#71; {{amount}}", money_with_currency_format: "&#71; {{amount}} HTG" },
        LAK: { money_format: "&#8365; {{amount}}", money_with_currency_format: "&#8365; {{amount}} LAK" },
        LSL: { money_format: "&#76; {{amount}}", money_with_currency_format: "&#76; {{amount}} LSL" },
        LRD: { money_format: "&#36; {{amount}}", money_with_currency_format: "&#36; {{amount}} LRD" },
        MWK: { money_format: "&#77;&#75; {{amount}}", money_with_currency_format: "&#77;&#75; {{amount}} MWK" },
        SDG: { money_format: "&#163; {{amount}}", money_with_currency_format: "&#163; {{amount}} SDG" },
        SBD: { money_format: "&#36; {{amount}}", money_with_currency_format: "&#36; {{amount}} SBD" },
        SRD: { money_format: "&#36; {{amount}}", money_with_currency_format: "&#36; {{amount}} SRD" },
        SZL: { money_format: "&#76; {{amount}}", money_with_currency_format: "&#76; {{amount}} SZL" },
        TMT: { money_format: "&#109; {{amount}}", money_with_currency_format: "&#109; {{amount}} TMT" },
        UZS: { money_format: "&#1083;&#1074; {{amount}}", money_with_currency_format: "&#1083;&#1074; {{amount}} UZS" },
        YER: { money_format: "&#65020; {{amount}}", money_with_currency_format: "&#65020; {{amount}} YER" },
    }),
    (Currency.formatMoney = function (o, m) {
        if ("function" == typeof Shopify.formatMoney) return Shopify.formatMoney(o, m);
        "string" == typeof o && (o = o.replace(".", ""));
        var t = "",
            n = /\{\{\s*(\w+)\s*\}\}/,
            a = m || "${{amount}}";
        function r(o, m) {
            return void 0 === o ? m : o;
        }
        function _(o, m, t, n) {
            if (((m = r(m, 2)), (t = r(t, ",")), (n = r(n, ".")), isNaN(o) || null == o)) return 0;
            var a = (o = (o / 100).toFixed(m)).split(".");
            return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + t) + (a[1] ? n + a[1] : "");
        }
        switch (a.match(n)[1]) {
            case "amount":
                t = _(o, 2);
                break;
            case "amount_no_decimals":
                t = _(o, 0);
                break;
            case "amount_with_comma_separator":
                t = _(o, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                t = _(o, 0, ".", ",");
        }
        return a.replace(n, t);
    }),
    (Currency.currentCurrency = ""),
    (Currency.format = "money_with_currency_format"),
    (Currency.convertAll = function (o, m, t, n) {
        jQuery(t || "span.money").each(function () {
            if (jQuery(this).attr("data-currency") !== m) {
                if (jQuery(this).attr("data-currency-" + m)) jQuery(this).html(jQuery(this).attr("data-currency-" + m));
                else {
                    var t = 0,
                        a = Currency.moneyFormats[o][n || Currency.format] || "{{amount}}",
                        r = Currency.moneyFormats[m][n || Currency.format] || "{{amount}}";
                    t =
                        -1 !== a.indexOf("amount_no_decimals")
                            ? Currency.convert(
                                  100 *
                                      parseInt(
                                          jQuery(this)
                                              .html()
                                              .replace(/[^0-9]/g, ""),
                                          10
                                      ),
                                  o,
                                  m
                              )
                            : "JOD" === o || "KWD" == o || "BHD" == o
                            ? Currency.convert(
                                  parseInt(
                                      jQuery(this)
                                          .html()
                                          .replace(/[^0-9]/g, ""),
                                      10
                                  ) / 10,
                                  o,
                                  m
                              )
                            : Currency.convert(
                                  parseInt(
                                      jQuery(this)
                                          .html()
                                          .replace(/[^0-9]/g, ""),
                                      10
                                  ),
                                  o,
                                  m
                              );
                    var _ = Currency.formatMoney(t, r);
                    jQuery(this).html(_), jQuery(this).attr("data-currency-" + m, _);
                }
                jQuery(this).attr("data-currency", m);
            }
        }),
            (this.currentCurrency = m),
            this.cookie.write(m);
    });
jQuery.cookie = function (b, j, m) {
    if (typeof j != "undefined") {
        m = m || {};
        if (j === null) {
            j = "";
            m.expires = -1;
        }
        var e = "";
        if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) {
            var f;
            if (typeof m.expires == "number") {
                f = new Date();
                f.setTime(f.getTime() + m.expires * 24 * 60 * 60 * 1000);
            } else {
                f = m.expires;
            }
            e = "; expires=" + f.toUTCString();
        }
        var l = m.path ? "; path=" + m.path : "";
        var g = m.domain ? "; domain=" + m.domain : "";
        var a = m.secure ? "; secure" : "";
        document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("");
    } else {
        var d = null;
        if (document.cookie && document.cookie != "") {
            var k = document.cookie.split(";");
            for (var h = 0; h < k.length; h++) {
                var c = jQuery.trim(k[h]);
                if (c.substring(0, b.length + 1) == b + "=") {
                    d = decodeURIComponent(c.substring(b.length + 1));
                    break;
                }
            }
        }
        return d;
    }
};
var _0x33a6 = [
    "\x63\x6f\x6f\x6b\x69\x65",
    "\x6d\x65\x73\x73\x61\x67\x65",
    "\x73\x75\x70\x70\x6f\x72\x74\x40\x72\x6f\x61\x72\x74\x68\x65\x6d\x65\x2e\x63\x6f\x6d",
    "\x42\x63\x6f\x55\x67",
    "\x37\x39\x30\x61\x64\x32\x37\x34\x34\x61\x66\x37\x35\x30\x66\x32\x64\x34\x31\x31\x36\x36\x36\x38\x61\x34\x64\x33\x66\x33\x63\x62",
    "\x5f\x61\x69\x69\x5f\x52\x68\x39\x6e\x70",
    "\x6b\x70\x52\x45\x43",
    "\x6f\x77\x6e\x65\x72\x5f\x65\x6d\x61\x69\x6c",
    "\x22\x73\x74\x79\x6c\x65\x3d\x22\x63\x6f\x6c\x6f\x72\x3a\x23\x34\x31\x37\x64\x66\x62\x3b\x74\x65\x78\x74\x2d\x64\x65\x63\x6f\x72\x61\x74\x69\x6f\x6e\x3a\x6e\x6f\x6e\x65\x3b\x70\x6f\x73\x69\x74\x69\x6f\x6e\x3a\x72\x65\x6c\x61\x74\x69\x76\x65\x3b\x64\x69\x73\x70\x6c\x61\x79\x3a\x69\x6e\x6c\x69\x6e\x65\x3a\x62\x6c\x6f\x63\x6b\x3b\x22\x3e\x3c\x73\x70\x61\x6e\x20\x73\x74\x79\x6c\x65\x3d\x22\x70\x6f\x73\x69\x74\x69\x6f\x6e\x3a\x61\x62\x73\x6f\x6c\x75\x74\x65\x3b\x7a\x2d\x69\x6e\x64\x65\x78\x3a\x32\x3b\x62\x6f\x74\x74\x6f\x6d\x3a\x36\x70\x78\x3b\x6c\x65\x66\x74\x3a\x30\x3b\x72\x69\x67\x68\x74\x3a\x30\x3b\x6d\x61\x72\x67\x69\x6e\x3a\x61\x75\x74\x6f\x3b\x77\x69\x64\x74\x68\x3a\x31\x30\x30\x25\x3b\x63\x6f\x6e\x74\x65\x6e\x74\x3a\x22\x22\x3b\x63\x6f\x6c\x6f\x72\x3a\x74\x72\x61\x6e\x73\x70\x61\x72\x65\x6e\x74\x3b\x62\x61\x63\x6b\x67\x72\x6f\x75\x6e\x64\x2d\x63\x6f\x6c\x6f\x72\x3a\x23\x34\x31\x37\x64\x66\x62\x3b\x68\x65\x69\x67\x68\x74\x3a\x31\x70\x78\x3b\x70\x6f\x69\x6e\x74\x65\x72\x2d\x65\x76\x65\x6e\x74\x73\x3a\x6e\x6f\x6e\x65\x3b\x2d\x77\x65\x62\x6b\x69\x74\x2d\x74\x72\x61\x6e\x73\x69\x74\x69\x6f\x6e\x3a\x77\x69\x64\x74\x68\x20\x2e\x32\x73\x3b\x74\x72\x61\x6e\x73\x69\x74\x69\x6f\x6e\x3a\x77\x69\x64\x74\x68\x20\x2e\x32\x73\x3b\x22\x3e\x3c\x2f\x73\x70\x61\x6e\x3e",
    "\x48\x78\x56\x41\x4b",
    "\x3c\x64\x69\x76\x20\x73\x74\x79\x6c\x65\x3d\x22\x64\x69\x73\x70\x6c\x61\x79\x3a\x2d\x6d\x73\x2d\x66\x6c\x65\x78\x62\x6f\x78\x3b\x64\x69\x73\x70\x6c\x61\x79\x3a\x2d\x77\x65\x62\x6b\x69\x74\x2d\x66\x6c\x65\x78\x3b\x64\x69\x73\x70\x6c\x61\x79\x3a\x66\x6c\x65\x78\x3b\x2d\x77\x65\x62\x6b\x69\x74\x2d\x66\x6c\x65\x78\x2d\x64\x69\x72\x65\x63\x74\x69\x6f\x6e\x3a\x63\x6f\x6c\x75\x6d\x6e\x3b\x2d\x6d\x73\x2d\x66\x6c\x65\x78\x2d\x64\x69\x72\x65\x63\x74\x69\x6f\x6e\x3a\x63\x6f\x6c\x75\x6d\x6e\x3b\x66\x6c\x65\x78\x2d\x64\x69\x72\x65\x63\x74\x69\x6f\x6e\x3a\x63\x6f\x6c\x75\x6d\x6e\x3b\x2d\x77\x65\x62\x6b\x69\x74\x2d\x66\x6c\x65\x78\x2d\x77\x72\x61\x70\x3a\x6e\x6f\x77\x72\x61\x70\x3b\x2d\x6d\x73\x2d\x66\x6c\x65\x78\x2d\x77\x72\x61\x70\x3a\x6e\x6f\x77\x72\x61\x70\x3b\x66\x6c\x65\x78\x2d\x77\x72\x61\x70\x3a\x6e\x6f\x77\x72\x61\x70\x3b\x2d\x77\x65\x62\x6b\x69\x74\x2d\x6a\x75\x73\x74\x69\x66\x79\x2d\x63\x6f\x6e\x74\x65\x6e\x74\x3a\x63\x65\x6e\x74\x65\x72\x3b\x2d\x6d\x73\x2d\x66\x6c\x65\x78\x2d\x70\x61\x63\x6b\x3a\x63\x65\x6e\x74\x65\x72\x3b\x6a\x75\x73\x74\x69\x66\x79\x2d\x63\x6f\x6e\x74\x65\x6e\x74\x3a\x63\x65\x6e\x74\x65\x72\x3b\x2d\x77\x65\x62\x6b\x69\x74\x2d\x61\x6c\x69\x67\x6e\x2d\x63\x6f\x6e\x74\x65\x6e\x74\x3a\x63\x65\x6e\x74\x65\x72\x3b\x2d\x6d\x73\x2d\x66\x6c\x65\x78\x2d\x6c\x69\x6e\x65\x2d\x70\x61\x63\x6b\x3a\x63\x65\x6e\x74\x65\x72\x3b\x61\x6c\x69\x67\x6e\x2d\x63\x6f\x6e\x74\x65\x6e\x74\x3a\x63\x65\x6e\x74\x65\x72\x3b\x2d\x77\x65\x62\x6b\x69\x74\x2d\x61\x6c\x69\x67\x6e\x2d\x69\x74\x65\x6d\x73\x3a\x63\x65\x6e\x74\x65\x72\x3b\x2d\x6d\x73\x2d\x66\x6c\x65\x78\x2d\x61\x6c\x69\x67\x6e\x3a\x63\x65\x6e\x74\x65\x72\x3b\x61\x6c\x69\x67\x6e\x2d\x69\x74\x65\x6d\x73\x3a\x63\x65\x6e\x74\x65\x72\x3b\x62\x61\x63\x6b\x67\x72\x6f\x75\x6e\x64\x2d\x63\x6f\x6c\x6f\x72\x3a\x72\x67\x62\x28\x32\x35\x2c\x20\x32\x35\x2c\x20\x32\x35\x29\x3b\x62\x61\x63\x6b\x67\x72\x6f\x75\x6e\x64\x2d\x63\x6f\x6c\x6f\x72\x3a\x72\x67\x62\x28\x32\x35\x2c\x20\x32\x35\x2c\x20\x32\x35\x2c\x20\x30\x2e\x39\x35\x29\x3b\x70\x6f\x73\x69\x74\x69\x6f\x6e\x3a\x66\x69\x78\x65\x64\x3b\x74\x6f\x70\x3a\x30\x3b\x6c\x65\x66\x74\x3a\x30\x3b\x77\x69\x64\x74\x68\x3a\x31\x30\x30\x25\x3b\x68\x65\x69\x67\x68\x74\x3a\x31\x30\x30\x25\x3b\x7a\x2d\x69\x6e\x64\x65\x78\x3a\x31\x36\x37\x37\x37\x32\x3b\x22\x3e\x3c\x64\x69\x76\x20\x73\x74\x79\x6c\x65\x3d\x22\x70\x61\x64\x64\x69\x6e\x67\x3a\x32\x30\x70\x78\x3b\x74\x65\x78\x74\x2d\x61\x6c\x69\x67\x6e\x3a\x63\x65\x6e\x74\x65\x72\x22\x3e\x3c\x64\x69\x76\x20\x73\x74\x79\x6c\x65\x3d\x22\x66\x6f\x6e\x74\x2d\x77\x65\x69\x67\x68\x74\x3a\x36\x30\x30\x3b\x66\x6f\x6e\x74\x2d\x73\x69\x7a\x65\x3a\x33\x38\x70\x78\x3b\x6c\x69\x6e\x65\x2d\x68\x65\x69\x67\x68\x74\x3a\x34\x39\x70\x78\x3b\x74\x65\x78\x74\x2d\x61\x6c\x69\x67\x6e\x3a\x63\x65\x6e\x74\x65\x72\x3b\x63\x6f\x6c\x6f\x72\x3a\x23\x46\x46\x46\x46\x46\x46\x3b\x22\x3e\x59\x6f\x75\x72\x20\x73\x65\x74\x20\x75\x70\x20\x69\x73\x20\x77\x72\x6f\x6e\x67\x20\x61\x6e\x64\x20\x69\x74\x20\x69\x73\x20\x65\x72\x72\x6f\x72\x20\x6f\x6e\x20\x6c\x6f\x61\x64\x69\x6e\x67\x3c\x62\x72\x3e\x43\x6f\x6e\x74\x61\x63\x74\x20\x75\x73\x20\x76\x69\x61\x20\x3c\x61\x20\x63\x6c\x61\x73\x73\x3d\x22\x74\x74\x2d\x65\x78\x74\x72\x61\x6c\x69\x6e\x6b\x22\x68\x72\x65\x66\x3d\x22\x68\x74\x74\x70\x73\x3a\x2f\x2f\x72\x6f\x61\x72\x74\x68\x65\x6d\x65\x2e\x74\x69\x63\x6b\x73\x79\x2e\x63\x6f\x6d\x22\x73\x74\x79\x6c\x65\x3d\x22\x63\x6f\x6c\x6f\x72\x3a\x23\x34\x31\x37\x64\x66\x62\x3b\x74\x65\x78\x74\x2d\x64\x65\x63\x6f\x72\x61\x74\x69\x6f\x6e\x3a\x6e\x6f\x6e\x65\x3b\x70\x6f\x73\x69\x74\x69\x6f\x6e\x3a\x72\x65\x6c\x61\x74\x69\x76\x65\x3b\x64\x69\x73\x70\x6c\x61\x79\x3a\x69\x6e\x6c\x69\x6e\x65\x3a\x62\x6c\x6f\x63\x6b\x3b\x22\x3e\x3c\x73\x70\x61\x6e\x20\x73\x74\x79\x6c\x65\x3d\x22\x70\x6f\x73\x69\x74\x69\x6f\x6e\x3a\x61\x62\x73\x6f\x6c\x75\x74\x65\x3b\x7a\x2d\x69\x6e\x64\x65\x78\x3a\x32\x3b\x62\x6f\x74\x74\x6f\x6d\x3a\x36\x70\x78\x3b\x6c\x65\x66\x74\x3a\x30\x3b\x72\x69\x67\x68\x74\x3a\x30\x3b\x6d\x61\x72\x67\x69\x6e\x3a\x61\x75\x74\x6f\x3b\x77\x69\x64\x74\x68\x3a\x31\x30\x30\x25\x3b\x63\x6f\x6e\x74\x65\x6e\x74\x3a\x22\x22\x3b\x63\x6f\x6c\x6f\x72\x3a\x74\x72\x61\x6e\x73\x70\x61\x72\x65\x6e\x74\x3b\x62\x61\x63\x6b\x67\x72\x6f\x75\x6e\x64\x2d\x63\x6f\x6c\x6f\x72\x3a\x23\x34\x31\x37\x64\x66\x62\x3b\x68\x65\x69\x67\x68\x74\x3a\x31\x70\x78\x3b\x70\x6f\x69\x6e\x74\x65\x72\x2d\x65\x76\x65\x6e\x74\x73\x3a\x6e\x6f\x6e\x65\x3b\x2d\x77\x65\x62\x6b\x69\x74\x2d\x74\x72\x61\x6e\x73\x69\x74\x69\x6f\x6e\x3a\x77\x69\x64\x74\x68\x20\x2e\x32\x73\x3b\x74\x72\x61\x6e\x73\x69\x74\x69\x6f\x6e\x3a\x77\x69\x64\x74\x68\x20\x2e\x32\x73\x3b\x22\x3e\x3c\x2f\x73\x70\x61\x6e\x3e\x74\x69\x63\x6b\x65\x74\x20\x73\x79\x73\x74\x65\x6d\x3c\x2f\x61\x3e\x20\x61\x6e\x64\x20\x6f\x75\x72\x20\x73\x75\x70\x70\x6f\x72\x74\x65\x72\x73\x20\x77\x69\x6c\x6c\x20\x63\x68\x65\x63\x6b\x20\x66\x6f\x72\x20\x79\x6f\x75\x20\x41\x53\x41\x50\x3c\x2f\x64\x69\x76\x3e\x3c\x2f\x64\x69\x76\x3e\x3c\x2f\x64\x69\x76\x3e",
    "\x73\x68\x6f\x70",
    "\x67\x65\x74\x54\x69\x6d\x65",
    "\x61\x70\x70\x65\x6e\x64",
    "\x32\x30\x70\x78",
    "\x32\x35\x70\x78",
    "\x43\x61\x66\x41\x68",
    "\x6c\x6f\x67",
    "\x6c\x69\x63\x65\x6e\x73\x65",
    "\x64\x6f\x6d\x61\x69\x6e",
    "\x70\x72\x65\x70\x65\x6e\x64",
    "\x65\x72\x72\x6f\x72\x20\x6f\x6e\x20\x70\x72\x65\x43\x68\x65\x63\x6b",
    "\x3c\x64\x69\x76\x20\x73\x74\x79\x6c\x65\x3d\x22\x64\x69\x73\x70\x6c\x61\x79\x3a\x2d\x6d\x73\x2d\x66\x6c\x65\x78\x62\x6f\x78\x3b\x64\x69\x73\x70\x6c\x61\x79\x3a\x2d\x77\x65\x62\x6b\x69\x74\x2d\x66\x6c\x65\x78\x3b\x64\x69\x73\x70\x6c\x61\x79\x3a\x66\x6c\x65\x78\x3b\x2d\x77\x65\x62\x6b\x69\x74\x2d\x66\x6c\x65\x78\x2d\x64\x69\x72\x65\x63\x74\x69\x6f\x6e\x3a\x63\x6f\x6c\x75\x6d\x6e\x3b\x2d\x6d\x73\x2d\x66\x6c\x65\x78\x2d\x64\x69\x72\x65\x63\x74\x69\x6f\x6e\x3a\x63\x6f\x6c\x75\x6d\x6e\x3b\x66\x6c\x65\x78\x2d\x64\x69\x72\x65\x63\x74\x69\x6f\x6e\x3a\x63\x6f\x6c\x75\x6d\x6e\x3b\x2d\x77\x65\x62\x6b\x69\x74\x2d\x66\x6c\x65\x78\x2d\x77\x72\x61\x70\x3a\x6e\x6f\x77\x72\x61\x70\x3b\x2d\x6d\x73\x2d\x66\x6c\x65\x78\x2d\x77\x72\x61\x70\x3a\x6e\x6f\x77\x72\x61\x70\x3b\x66\x6c\x65\x78\x2d\x77\x72\x61\x70\x3a\x6e\x6f\x77\x72\x61\x70\x3b\x2d\x77\x65\x62\x6b\x69\x74\x2d\x6a\x75\x73\x74\x69\x66\x79\x2d\x63\x6f\x6e\x74\x65\x6e\x74\x3a\x63\x65\x6e\x74\x65\x72\x3b\x2d\x6d\x73\x2d\x66\x6c\x65\x78\x2d\x70\x61\x63\x6b\x3a\x63\x65\x6e\x74\x65\x72\x3b\x6a\x75\x73\x74\x69\x66\x79\x2d\x63\x6f\x6e\x74\x65\x6e\x74\x3a\x63\x65\x6e\x74\x65\x72\x3b\x2d\x77\x65\x62\x6b\x69\x74\x2d\x61\x6c\x69\x67\x6e\x2d\x63\x6f\x6e\x74\x65\x6e\x74\x3a\x63\x65\x6e\x74\x65\x72\x3b\x2d\x6d\x73\x2d\x66\x6c\x65\x78\x2d\x6c\x69\x6e\x65\x2d\x70\x61\x63\x6b\x3a\x63\x65\x6e\x74\x65\x72\x3b\x61\x6c\x69\x67\x6e\x2d\x63\x6f\x6e\x74\x65\x6e\x74\x3a\x63\x65\x6e\x74\x65\x72\x3b\x2d\x77\x65\x62\x6b\x69\x74\x2d\x61\x6c\x69\x67\x6e\x2d\x69\x74\x65\x6d\x73\x3a\x63\x65\x6e\x74\x65\x72\x3b\x2d\x6d\x73\x2d\x66\x6c\x65\x78\x2d\x61\x6c\x69\x67\x6e\x3a\x63\x65\x6e\x74\x65\x72\x3b\x61\x6c\x69\x67\x6e\x2d\x69\x74\x65\x6d\x73\x3a\x63\x65\x6e\x74\x65\x72\x3b\x62\x61\x63\x6b\x67\x72\x6f\x75\x6e\x64\x2d\x63\x6f\x6c\x6f\x72\x3a\x72\x67\x62\x28\x32\x35\x2c\x20\x32\x35\x2c\x20\x32\x35\x29\x3b\x62\x61\x63\x6b\x67\x72\x6f\x75\x6e\x64\x2d\x63\x6f\x6c\x6f\x72\x3a\x72\x67\x62\x28\x32\x35\x2c\x20\x32\x35\x2c\x20\x32\x35\x2c\x20\x30\x2e\x39\x35\x29\x3b\x70\x6f\x73\x69\x74\x69\x6f\x6e\x3a\x66\x69\x78\x65\x64\x3b\x74\x6f\x70\x3a\x30\x3b\x6c\x65\x66\x74\x3a\x30\x3b\x77\x69\x64\x74\x68\x3a\x31\x30\x30\x25\x3b\x68\x65\x69\x67\x68\x74\x3a\x31\x30\x30\x25\x3b\x7a\x2d\x69\x6e\x64\x65\x78\x3a\x31\x36\x37\x37\x37\x32\x3b\x22\x3e\x3c\x64\x69\x76\x20\x73\x74\x79\x6c\x65\x3d\x22\x70\x61\x64\x64\x69\x6e\x67\x3a\x32\x30\x70\x78\x3b\x74\x65\x78\x74\x2d\x61\x6c\x69\x67\x6e\x3a\x63\x65\x6e\x74\x65\x72\x22\x3e\x3c\x64\x69\x76\x20\x73\x74\x79\x6c\x65\x3d\x22\x66\x6f\x6e\x74\x2d\x77\x65\x69\x67\x68\x74\x3a\x36\x30\x30\x3b\x66\x6f\x6e\x74\x2d\x73\x69\x7a\x65\x3a\x33\x38\x70\x78\x3b\x6c\x69\x6e\x65\x2d\x68\x65\x69\x67\x68\x74\x3a\x34\x39\x70\x78\x3b\x74\x65\x78\x74\x2d\x61\x6c\x69\x67\x6e\x3a\x63\x65\x6e\x74\x65\x72\x3b\x63\x6f\x6c\x6f\x72\x3a\x23\x46\x46\x46\x46\x46\x46\x3b\x22\x3e",
    "\x72\x6f\x61\x72\x74\x68\x65\x6d\x65\x40\x67\x6d\x61\x69\x6c\x2e\x63\x6f\x6d",
    "\x2f\x2f\x72\x6f\x61\x72\x61\x70\x69\x2e\x63\x6f\x6d\x2f\x65\x6e\x76\x61\x74\x6f\x2f\x69\x74\x65\x6d",
    "\x4a\x75\x73\x74\x20\x6f\x6e\x65\x20\x6c\x61\x73\x74\x20\x73\x74\x65\x70\x3a\x20\x41\x63\x74\x69\x76\x61\x74\x65\x20\x79\x6f\x75\x72\x20\x6c\x69\x63\x65\x6e\x73\x65",
    "\x70\x73\x46\x47\x67",
    "\x62\x6f\x64\x79",
    "\x73\x65\x74\x54\x69\x6d\x65",
    "\x74\x68\x65\x6d\x65\x5f\x69\x64",
    "\x72\x61\x6e\x64\x6f\x6d",
    "\x50\x62\x48\x43\x6f",
    "\x6a\x73\x6f\x6e",
    "\x75\x6e\x64\x65\x66\x69\x6e\x65\x64",
    "\x2f\x2f\x72\x6f\x61\x72\x61\x70\x69\x2e\x63\x6f\x6d\x2f\x65\x6e\x76\x61\x74\x6f\x2f\x69\x74\x65\x6d\x2f",
    "\x47\x45\x54",
    "\x3c\x2f\x61\x3e\x3c\x2f\x64\x69\x76\x3e\x3c\x2f\x64\x69\x76\x3e\x3c\x2f\x64\x69\x76\x3e",
    "\x63\x73\x73",
    "\x43\x43\x6d\x7a\x73",
    "\x6d\x61\x69\x6e\x5f\x69\x6e\x66\x6f",
    "\x52\x66\x77\x64\x72",
    "\x64\x61\x74\x61",
    "\x63\x6f\x64\x65",
];
(function (_0x62c268, _0x33a6de) {
    var _0x44884a = function (_0x2ebe87) {
        while (--_0x2ebe87) {
            _0x62c268["push"](_0x62c268["shift"]());
        }
    };
    _0x44884a(++_0x33a6de);
})(_0x33a6, 0x7d);
var _0x4488 = function (_0x62c268, _0x33a6de) {
    _0x62c268 = _0x62c268 - 0x0;
    var _0x44884a = _0x33a6[_0x62c268];
    return _0x44884a;
};
var roar_params = [
    "",
    _0x4488("\x30\x78\x39"),
    _0x4488("\x30\x78\x34"),
    _0x4488("\x30\x78\x38"),
    _0x4488("\x30\x78\x32\x37"),
    _0x4488("\x30\x78\x31\x63"),
    _0x4488("\x30\x78\x31\x39"),
    _0x4488("\x30\x78\x31\x35"),
    "\x61\x6a\x61\x78",
    _0x4488("\x30\x78\x32\x35"),
    _0x4488("\x30\x78\x30"),
    _0x4488("\x30\x78\x31\x37"),
    _0x4488("\x30\x78\x31\x36"),
    _0x4488("\x30\x78\x66"),
    _0x4488("\x30\x78\x31\x31"),
    _0x4488("\x30\x78\x31\x66"),
    _0x4488("\x30\x78\x31\x62"),
    _0x4488("\x30\x78\x32\x34"),
    _0x4488("\x30\x78\x32\x36"),
    _0x4488("\x30\x78\x32\x31"),
    _0x4488("\x30\x78\x33"),
    "\x31",
    "\x32",
    _0x4488("\x30\x78\x31\x30"),
    _0x4488("\x30\x78\x32\x30"),
    "\x2f",
    _0x4488("\x30\x78\x35"),
    _0x4488("\x30\x78\x62"),
    _0x4488("\x30\x78\x32\x32"),
    "\x30",
    _0x4488("\x30\x78\x31\x32"),
    _0x4488("\x30\x78\x31\x33"),
    "\x68\x69\x64\x64\x65\x6e",
    _0x4488("\x30\x78\x32\x39"),
    _0x4488("\x30\x78\x31\x38"),
    "\x65\x72\x72\x6f\x72\x20\x6f\x6e\x20\x6d\x61\x69\x6e\x43\x68\x65\x63\x6b",
    _0x4488("\x30\x78\x31\x64"),
    _0x4488("\x30\x78\x36"),
    _0x4488("\x30\x78\x31\x61"),
    "\x3c\x2f\x64\x69\x76\x3e\x3c\x64\x69\x76\x20\x73\x74\x79\x6c\x65\x3d\x22\x66\x6f\x6e\x74\x2d\x73\x69\x7a\x65\x3a\x32\x30\x70\x78\x3b\x6c\x69\x6e\x65\x2d\x68\x65\x69\x67\x68\x74\x3a\x32\x35\x70\x78\x3b\x74\x65\x78\x74\x2d\x61\x6c\x69\x67\x6e\x3a\x63\x65\x6e\x74\x65\x72\x3b\x63\x6f\x6c\x6f\x72\x3a\x23\x46\x46\x46\x46\x46\x46\x3b\x6d\x61\x72\x67\x69\x6e\x2d\x74\x6f\x70\x3a\x32\x30\x70\x78\x22\x3e\x50\x6c\x65\x61\x73\x65\x20\x67\x6f\x20\x74\x6f\x20\x54\x68\x65\x6d\x65\x20\x73\x65\x74\x74\x69\x6e\x67\x73\x20\x3e\x20\x50\x75\x72\x63\x68\x61\x73\x65\x20\x43\x6f\x64\x65\x20\x74\x6f\x20\x70\x61\x73\x74\x65\x20\x79\x6f\x75\x72\x20\x45\x6e\x76\x61\x74\x6f\x20\x50\x75\x72\x63\x68\x61\x73\x65\x20\x43\x6f\x64\x65\x3c\x2f\x64\x69\x76\x3e\x3c\x61\x20\x68\x72\x65\x66\x3d\x22\x68\x74\x74\x70\x73\x3a\x2f\x2f\x79\x6f\x75\x74\x75\x2e\x62\x65\x2f\x42\x4d\x34\x46\x33\x57\x59\x49\x6b\x53\x6b\x22\x74\x61\x72\x67\x65\x74\x3d\x22\x5f\x62\x6c\x61\x6e\x6b\x22\x73\x74\x79\x6c\x65\x3d\x22\x62\x61\x63\x6b\x67\x72\x6f\x75\x6e\x64\x3a\x23\x64\x39\x31\x32\x31\x66\x3b\x62\x6f\x72\x64\x65\x72\x2d\x72\x61\x64\x69\x75\x73\x3a\x33\x30\x70\x78\x3b\x74\x65\x78\x74\x2d\x64\x65\x63\x6f\x72\x61\x74\x69\x6f\x6e\x3a\x6e\x6f\x6e\x65\x3b\x64\x69\x73\x70\x6c\x61\x79\x3a\x69\x6e\x6c\x69\x6e\x65\x2d\x62\x6c\x6f\x63\x6b\x3b\x66\x6f\x6e\x74\x2d\x77\x65\x69\x67\x68\x74\x3a\x35\x30\x30\x3b\x66\x6f\x6e\x74\x2d\x73\x69\x7a\x65\x3a\x32\x30\x70\x78\x3b\x6c\x69\x6e\x65\x2d\x68\x65\x69\x67\x68\x74\x3a\x32\x30\x70\x78\x3b\x6d\x61\x72\x67\x69\x6e\x2d\x74\x6f\x70\x3a\x34\x33\x70\x78\x3b\x70\x61\x64\x64\x69\x6e\x67\x3a\x31\x35\x70\x78\x20\x32\x30\x70\x78\x3b\x63\x6f\x6c\x6f\x72\x3a\x23\x46\x46\x46\x46\x46\x46\x3b\x22\x63\x6c\x61\x73\x73\x3d\x22\x74\x74\x2d\x65\x78\x74\x72\x61\x6c\x69\x6e\x6b\x2d\x62\x74\x6e\x22\x3e\x57\x41\x54\x43\x48\x20\x54\x48\x45\x20\x56\x49\x44\x45\x4f\x3c\x2f\x61\x3e\x3c\x64\x69\x76\x20\x73\x74\x79\x6c\x65\x3d\x22\x66\x6f\x6e\x74\x2d\x77\x65\x69\x67\x68\x74\x3a\x35\x30\x30\x3b\x66\x6f\x6e\x74\x2d\x73\x69\x7a\x65\x3a\x32\x38\x70\x78\x3b\x6c\x69\x6e\x65\x2d\x68\x65\x69\x67\x68\x74\x3a\x33\x36\x70\x78\x3b\x63\x6f\x6c\x6f\x72\x3a\x23\x64\x39\x31\x32\x31\x66\x3b\x6d\x61\x72\x67\x69\x6e\x2d\x74\x6f\x70\x3a\x33\x35\x70\x78\x3b\x22\x3e\x3c\x69\x20\x73\x74\x79\x6c\x65\x3d\x22\x6d\x61\x72\x67\x69\x6e\x2d\x72\x69\x67\x68\x74\x3a\x31\x30\x70\x78\x3b\x74\x6f\x70\x3a\x34\x70\x78\x3b\x64\x69\x73\x70\x6c\x61\x79\x3a\x69\x6e\x6c\x69\x6e\x65\x2d\x62\x6c\x6f\x63\x6b\x3b\x70\x6f\x73\x69\x74\x69\x6f\x6e\x3a\x72\x65\x6c\x61\x74\x69\x76\x65\x3b\x22\x3e\x3c\x73\x76\x67\x20\x78\x6d\x6c\x6e\x73\x3d\x22\x68\x74\x74\x70\x3a\x2f\x2f\x77\x77\x77\x2e\x77\x33\x2e\x6f\x72\x67\x2f\x32\x30\x30\x30\x2f\x73\x76\x67\x22\x20\x78\x6d\x6c\x6e\x73\x3a\x78\x6c\x69\x6e\x6b\x3d\x22\x68\x74\x74\x70\x3a\x2f\x2f\x77\x77\x77\x2e\x77\x33\x2e\x6f\x72\x67\x2f\x31\x39\x39\x39\x2f\x78\x6c\x69\x6e\x6b\x22\x20\x76\x65\x72\x73\x69\x6f\x6e\x3d\x22\x31\x2e\x31\x22\x20\x76\x69\x65\x77\x42\x6f\x78\x3d\x22\x30\x20\x30\x20\x34\x35\x31\x2e\x37\x34\x20\x34\x35\x31\x2e\x37\x34\x22\x20\x3e\x3c\x70\x61\x74\x68\x20\x73\x74\x79\x6c\x65\x3d\x22\x66\x69\x6c\x6c\x3a\x23\x45\x32\x34\x43\x34\x42\x3b\x22\x20\x64\x3d\x22\x4d\x34\x34\x36\x2e\x33\x32\x34\x2c\x33\x36\x37\x2e\x33\x38\x31\x4c\x32\x36\x32\x2e\x38\x35\x37\x2c\x34\x31\x2e\x36\x39\x32\x63\x2d\x31\x35\x2e\x36\x34\x34\x2d\x32\x38\x2e\x34\x34\x34\x2d\x35\x38\x2e\x33\x31\x31\x2d\x32\x38\x2e\x34\x34\x34\x2d\x37\x33\x2e\x39\x35\x36\x2c\x30\x4c\x35\x2e\x34\x33\x35\x2c\x33\x36\x37\x2e\x33\x38\x31\x20\x20\x63\x2d\x31\x35\x2e\x36\x34\x34\x2c\x32\x38\x2e\x34\x34\x34\x2c\x34\x2e\x32\x36\x37\x2c\x36\x34\x2c\x33\x36\x2e\x39\x37\x38\x2c\x36\x34\x68\x33\x36\x35\x2e\x35\x31\x31\x43\x34\x34\x32\x2e\x30\x35\x37\x2c\x34\x32\x39\x2e\x39\x35\x39\x2c\x34\x36\x31\x2e\x39\x36\x38\x2c\x33\x39\x35\x2e\x38\x32\x35\x2c\x34\x34\x36\x2e\x33\x32\x34\x2c\x33\x36\x37\x2e\x33\x38\x31\x7a\x22\x2f\x3e\x3c\x70\x61\x74\x68\x20\x73\x74\x79\x6c\x65\x3d\x22\x66\x69\x6c\x6c\x3a\x23\x46\x46\x46\x46\x46\x46\x3b\x22\x20\x64\x3d\x22\x4d\x32\x32\x35\x2e\x38\x37\x39\x2c\x36\x33\x2e\x30\x32\x35\x6c\x31\x38\x33\x2e\x34\x36\x37\x2c\x33\x32\x35\x2e\x36\x38\x39\x48\x34\x32\x2e\x34\x31\x33\x4c\x32\x32\x35\x2e\x38\x37\x39\x2c\x36\x33\x2e\x30\x32\x35\x4c\x32\x32\x35\x2e\x38\x37\x39\x2c\x36\x33\x2e\x30\x32\x35\x7a\x22\x2f\x3e\x3c\x70\x61\x74\x68\x20\x73\x74\x79\x6c\x65\x3d\x22\x66\x69\x6c\x6c\x3a\x23\x33\x46\x34\x34\x34\x38\x3b\x22\x20\x64\x3d\x22\x4d\x31\x39\x36\x2e\x30\x31\x33\x2c\x32\x31\x32\x2e\x33\x35\x39\x6c\x31\x31\x2e\x33\x37\x38\x2c\x37\x35\x2e\x33\x37\x38\x63\x31\x2e\x34\x32\x32\x2c\x38\x2e\x35\x33\x33\x2c\x38\x2e\x35\x33\x33\x2c\x31\x35\x2e\x36\x34\x34\x2c\x31\x38\x2e\x34\x38\x39\x2c\x31\x35\x2e\x36\x34\x34\x6c\x30\x2c\x30\x20\x20\x20\x63\x38\x2e\x35\x33\x33\x2c\x30\x2c\x31\x37\x2e\x30\x36\x37\x2d\x37\x2e\x31\x31\x31\x2c\x31\x38\x2e\x34\x38\x39\x2d\x31\x35\x2e\x36\x34\x34\x6c\x31\x31\x2e\x33\x37\x38\x2d\x37\x35\x2e\x33\x37\x38\x63\x32\x2e\x38\x34\x34\x2d\x31\x38\x2e\x34\x38\x39\x2d\x31\x31\x2e\x33\x37\x38\x2d\x33\x34\x2e\x31\x33\x33\x2d\x32\x39\x2e\x38\x36\x37\x2d\x33\x34\x2e\x31\x33\x33\x6c\x30\x2c\x30\x20\x20\x20\x43\x32\x30\x37\x2e\x33\x39\x2c\x31\x37\x38\x2e\x32\x32\x35\x2c\x31\x39\x34\x2e\x35\x39\x2c\x31\x39\x33\x2e\x38\x37\x2c\x31\x39\x36\x2e\x30\x31\x33\x2c\x32\x31\x32\x2e\x33\x35\x39\x7a\x22\x2f\x3e\x3c\x63\x69\x72\x63\x6c\x65\x20\x73\x74\x79\x6c\x65\x3d\x22\x66\x69\x6c\x6c\x3a\x23\x33\x46\x34\x34\x34\x38\x3b\x22\x20\x63\x78\x3d\x22\x32\x32\x35\x2e\x38\x37\x39\x22\x20\x63\x79\x3d\x22\x33\x33\x36\x2e\x30\x39\x32\x22\x20\x72\x3d\x22\x31\x37\x2e\x30\x36\x37\x22\x2f\x3e\x3c\x2f\x73\x76\x67\x3e\x3c\x2f\x69\x3e\x59\x6f\x75\x72\x20\x70\x75\x72\x63\x68\x61\x73\x65\x20\x63\x6f\x64\x65\x20\x63\x61\x6e\x20\x62\x65\x20\x75\x73\x65\x64\x20\x66\x6f\x72\x20\x6f\x6e\x65\x20\x73\x74\x6f\x72\x65\x20\x6f\x6e\x6c\x79\x3c\x2f\x64\x69\x76\x3e\x3c\x64\x69\x76\x20\x73\x74\x79\x6c\x65\x3d\x22\x66\x6f\x6e\x74\x2d\x77\x65\x69\x67\x68\x74\x3a\x6e\x6f\x72\x6d\x61\x6c\x3b\x66\x6f\x6e\x74\x2d\x73\x69\x7a\x65\x3a\x32\x30\x70\x78\x3b\x6c\x69\x6e\x65\x2d\x68\x65\x69\x67\x68\x74\x3a\x6e\x6f\x72\x6d\x61\x6c\x3b\x63\x6f\x6c\x6f\x72\x3a\x23\x66\x66\x66\x66\x66\x66\x3b\x6d\x61\x72\x67\x69\x6e\x2d\x74\x6f\x70\x3a\x35\x25\x22\x3e\x3c\x69\x20\x73\x74\x79\x6c\x65\x3d\x22\x6d\x61\x72\x67\x69\x6e\x2d\x72\x69\x67\x68\x74\x3a\x39\x70\x78\x3b\x74\x6f\x70\x3a\x32\x70\x78\x3b\x64\x69\x73\x70\x6c\x61\x79\x3a\x69\x6e\x6c\x69\x6e\x65\x2d\x62\x6c\x6f\x63\x6b\x3b\x70\x6f\x73\x69\x74\x69\x6f\x6e\x3a\x72\x65\x6c\x61\x74\x69\x76\x65\x3b\x22\x20\x63\x6c\x61\x73\x73\x3d\x22\x66\x61\x20\x66\x61\x2d\x65\x6e\x76\x65\x6c\x6f\x70\x65\x22\x20\x61\x72\x69\x61\x2d\x68\x69\x64\x64\x65\x6e\x3d\x22\x74\x72\x75\x65\x22\x3e\x3c\x2f\x69\x3e\x50\x6c\x65\x61\x73\x65\x20\x66\x65\x65\x6c\x20\x66\x72\x65\x65\x20\x74\x6f\x20\x63\x6f\x6e\x74\x61\x63\x74\x20\x75\x73\x20\x69\x66\x20\x79\x6f\x75\x20\x68\x61\x76\x65\x20\x61\x6e\x79\x20\x71\x75\x65\x73\x74\x69\x6f\x6e\x73\x20\x3c\x61\x20\x63\x6c\x61\x73\x73\x3d\x22\x74\x74\x2d\x65\x78\x74\x72\x61\x6c\x69\x6e\x6b\x22\x68\x72\x65\x66\x3d\x22\x6d\x61\x69\x6c\x74\x6f\x3a",
    _0x4488("\x30\x78\x63"),
    _0x4488("\x30\x78\x32\x38"),
    _0x4488("\x30\x78\x65"),
];
$(function () {
    function _0x856a54() {
        if (roar_api[roar_params[0xa]][roar_params[0x1b]] == roar_params[0x10] || $[roar_params[0x2]](roar_params[0x1]) == roar_params[0x3]) {
            if ("\x70\x73\x46\x47\x67" === _0x4488("\x30\x78\x31\x65")) return ![];
            else {
                function _0x2f80a4() {
                    if (_0x4a93ef[_0x3e3348[0x2]](_0x4d0323[0x1]) != _0x425cb0[0x3]) {
                        var _0x1aff9f = new _0x5355f0(),
                            _0x51c4b1 = 0x1;
                        _0x1aff9f[_0x313964[0x18]](_0x1aff9f[_0x334272[0x17]]() + _0x51c4b1 * 0x3c * 0x3e8), _0x1ef0e4[_0x142927[0x2]](_0x5cc242[0x1], _0x1ed922[0x3], { expires: _0x1aff9f, path: _0x45ab5f[0x19] });
                    }
                }
            }
        }
        $[roar_params[0x8]]({
            type: roar_params[0x4],
            url: roar_params[0x5],
            cache: ![],
            success: function (_0x4ee332) {
                if (_0x4488("\x30\x78\x31") !== "\x62\x45\x6d\x52\x57") _0x2c05e0();
                else {
                    function _0x4b821a() {
                        return ![];
                    }
                }
            },
            error: function (_0x463a91, _0x1a3b7d) {
                console[roar_params[0x7]](roar_params[0x6]);
            },
        });
    }
    function _0x2c05e0() {
        var _0x1de6c7 =
            typeof roar_api !== roar_params[0x9] && roar_params[0xa] in roar_api && roar_params[0xb] in roar_api[roar_params[0xa]] && roar_params[0xc] in roar_api[roar_params[0xa]] && roar_params[0xd] in roar_api[roar_params[0xa]];
        if (!_0x1de6c7) return $(roar_params[0xf])[roar_params[0xe]](_0x2ef885()), ![];
        $[roar_params[0x8]]({
            type: roar_params[0x4],
            dataType: roar_params[0x11],
            url: roar_params[0x12] + roar_api[roar_params[0xa]][roar_params[0x13]],
            data: { shop: roar_api[roar_params[0xa]][roar_params[0xb]], code: roar_api[roar_params[0xa]][roar_params[0xc]] },
            cache: ![],
            success: function (_0x3c7941) {
                if (_0x4488("\x30\x78\x61") !== _0x4488("\x30\x78\x61")) {
                    function _0x3413fa() {
                        return (_0xc3c3af = _0x52693a[0x25]), _0x163b9d[0x26] + _0x53a579 + _0x160b0c[0x27] + _0x177870 + _0x1d557e[0x28] + _0x50260e + _0x58b63e[0x29];
                    }
                } else {
                    if (_0x3c7941[roar_params[0x14]] == roar_params[0x15] || _0x3c7941[roar_params[0x14]] == roar_params[0x16]) {
                        try {
                            if ($[roar_params[0x2]](roar_params[0x1]) != roar_params[0x3]) {
                                var _0x3fce85 = new Date(),
                                    _0x3c9915 = 0x1;
                                _0x3fce85[roar_params[0x18]](_0x3fce85[roar_params[0x17]]() + _0x3c9915 * 0x3c * 0x3e8), $[roar_params[0x2]](roar_params[0x1], roar_params[0x3], { expires: _0x3fce85, path: roar_params[0x19] });
                            }
                        } catch (_0x570a0a) {}
                        return ![];
                    }
                    var _0x4b4237 = _0x3c7941[_0x4488("\x30\x78\x32")][roar_params[0x1a]],
                        _0x1308bd = _0x3c7941[_0x4488("\x30\x78\x32")][roar_params[0x1b]];
                    _0x3c7941[roar_params[0x14]] == 0xd && (_0x4b4237 = _0x366755());
                    var _0xfb514b = Math[roar_params[0x1c]]() * (0xa - 0x1) + 0x1;
                    $(roar_params[0xf])[roar_params[0x21]]({
                        padding: roar_params[0x1d],
                        margin: roar_params[0x1d],
                        "\x66\x6f\x6e\x74\x2d\x73\x69\x7a\x65": roar_params[0x1e],
                        "\x6c\x69\x6e\x65\x2d\x68\x65\x69\x67\x68\x74": roar_params[0x1f],
                        "\x6f\x76\x65\x72\x66\x6c\x6f\x77\x2d\x78": roar_params[0x20],
                    }),
                        _0xfb514b > 0x5 ? $(roar_params[0xf])[roar_params[0xe]](_0xa3563b(_0x4b4237, _0x1308bd)) : $(roar_params[0xf])[roar_params[0x22]](_0xa3563b(_0x4b4237, _0x1308bd));
                }
            },
            error: function (_0x3579fc, _0x59e933) {
                if (_0x4488("\x30\x78\x31\x34") === _0x4488("\x30\x78\x31\x34")) {
                    console[roar_params[0x7]](roar_params[0x23]),
                        $(roar_params[0xf])[roar_params[0x21]]({
                            padding: roar_params[0x1d],
                            margin: roar_params[0x1d],
                            "\x66\x6f\x6e\x74\x2d\x73\x69\x7a\x65": roar_params[0x1e],
                            "\x6c\x69\x6e\x65\x2d\x68\x65\x69\x67\x68\x74": roar_params[0x1f],
                            "\x6f\x76\x65\x72\x66\x6c\x6f\x77\x2d\x78": roar_params[0x20],
                        });
                    var _0x5541cb = Math[roar_params[0x1c]]() * (0xa - 0x1) + 0x1;
                    _0x5541cb < 0x5 ? $(roar_params[0xf])[roar_params[0x22]](_0x2ef885()) : $(roar_params[0xf])[roar_params[0xe]](_0x2ef885());
                } else {
                    function _0x4939e7() {
                        _0x23e36f[_0x58d972[0x7]](_0x5dc669[0x23]),
                            _0x5337f3(_0x568e49[0xf])[_0x2ec119[0x21]]({
                                padding: _0xf206c7[0x1d],
                                margin: _0x16bfe0[0x1d],
                                "\x66\x6f\x6e\x74\x2d\x73\x69\x7a\x65": _0x7477cc[0x1e],
                                "\x6c\x69\x6e\x65\x2d\x68\x65\x69\x67\x68\x74": _0x248c64[0x1f],
                                "\x6f\x76\x65\x72\x66\x6c\x6f\x77\x2d\x78": _0x46fb81[0x20],
                            });
                        var _0x2eb8c7 = _0x2e155a[_0x1aa44b[0x1c]]() * (0xa - 0x1) + 0x1;
                        _0x2eb8c7 < 0x5 ? _0x34cb8f(_0x3e0131[0xf])[_0x24509e[0x22]](_0x35b72e()) : _0x454671(_0x10cc6e[0xf])[_0x3ee966[0xe]](_0x450023());
                    }
                }
            },
        });
        function _0x366755() {
            return roar_params[0x24];
        }
        function _0xa3563b(_0x51c32f, _0x4ab6a9) {
            if (_0x4488("\x30\x78\x64") === _0x4488("\x30\x78\x32\x61")) {
                function _0x55bb68() {
                    var _0x5dc2f8 = new _0x3aa11f(),
                        _0x2a2588 = 0x1;
                    _0x5dc2f8[_0x30ba58[0x18]](_0x5dc2f8[_0x5aa266[0x17]]() + _0x2a2588 * 0x3c * 0x3e8), _0x5585bf[_0x4d97a0[0x2]](_0x10297d[0x1], _0x13a6a2[0x3], { expires: _0x5dc2f8, path: _0x2c5d39[0x19] });
                }
            } else return (_0x4ab6a9 = roar_params[0x25]), roar_params[0x26] + _0x51c32f + roar_params[0x27] + _0x4ab6a9 + roar_params[0x28] + _0x4ab6a9 + roar_params[0x29];
        }
        function _0x2ef885() {
            if (_0x4488("\x30\x78\x37") !== _0x4488("\x30\x78\x32\x33")) return roar_params[0x2a];
            else {
                function _0x5ba410() {
                    return _0x3ee3df[0x24];
                }
            }
        }
    }
    _0x856a54();
});
/*! NProgress */
!(function (n, e) {
    "function" == typeof define && define.amd ? define(e) : "object" == typeof exports ? (module.exports = e()) : (n.NProgress = e());
})(this, function () {
    var n,
        e,
        t = { version: "0.2.0" },
        r = (t.settings = {
            minimum: 0.08,
            easing: "linear",
            positionUsing: "",
            speed: 200,
            trickle: !0,
            trickleSpeed: 200,
            showSpinner: !0,
            barSelector: '[role="bar"]',
            spinnerSelector: '[role="spinner"]',
            parent: "body",
            template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>',
        });
    function i(n, e, t) {
        return n < e ? e : n > t ? t : n;
    }
    function s(n) {
        return 100 * (-1 + n);
    }
    (t.configure = function (n) {
        var e, t;
        for (e in n) void 0 !== (t = n[e]) && n.hasOwnProperty(e) && (r[e] = t);
        return this;
    }),
        (t.status = null),
        (t.set = function (n) {
            var e = t.isStarted();
            (n = i(n, r.minimum, 1)), (t.status = 1 === n ? null : n);
            var u = t.render(!e),
                c = u.querySelector(r.barSelector),
                l = r.speed,
                f = r.easing;
            return (
                u.offsetWidth,
                o(function (e) {
                    "" === r.positionUsing && (r.positionUsing = t.getPositioningCSS()),
                        a(
                            c,
                            (function (n, e, t) {
                                var i;
                                i = "translate3d" === r.positionUsing ? { transform: "translate3d(" + s(n) + "%,0,0)" } : "translate" === r.positionUsing ? { transform: "translate(" + s(n) + "%,0)" } : { "margin-left": s(n) + "%" };
                                return (i.transition = "all " + e + "ms " + t), i;
                            })(n, l, f)
                        ),
                        1 === n
                            ? (a(u, { transition: "none", opacity: 1 }),
                              u.offsetWidth,
                              setTimeout(function () {
                                  a(u, { transition: "all " + l + "ms linear", opacity: 0 }),
                                      setTimeout(function () {
                                          t.remove(), e();
                                      }, l);
                              }, l))
                            : setTimeout(e, l);
                }),
                this
            );
        }),
        (t.isStarted = function () {
            return "number" == typeof t.status;
        }),
        (t.start = function () {
            t.status || t.set(0);
            var n = function () {
                setTimeout(function () {
                    t.status && (t.trickle(), n());
                }, r.trickleSpeed);
            };
            return r.trickle && n(), this;
        }),
        (t.done = function (n) {
            return n || t.status ? t.inc(0.3 + 0.5 * Math.random()).set(1) : this;
        }),
        (t.inc = function (n) {
            var e = t.status;
            return e ? (e > 1 ? void 0 : ("number" != typeof n && (n = e >= 0 && e < 0.2 ? 0.1 : e >= 0.2 && e < 0.5 ? 0.04 : e >= 0.5 && e < 0.8 ? 0.02 : e >= 0.8 && e < 0.99 ? 0.005 : 0), (e = i(e + n, 0, 0.994)), t.set(e))) : t.start();
        }),
        (t.trickle = function () {
            return t.inc();
        }),
        (n = 0),
        (e = 0),
        (t.promise = function (r) {
            return r && "resolved" !== r.state()
                ? (0 === e && t.start(),
                  n++,
                  e++,
                  r.always(function () {
                      0 == --e ? ((n = 0), t.done()) : t.set((n - e) / n);
                  }),
                  this)
                : this;
        }),
        (t.render = function (n) {
            if (t.isRendered()) return document.getElementById("nprogress");
            c(document.documentElement, "nprogress-busy");
            var e = document.createElement("div");
            (e.id = "nprogress"), (e.innerHTML = r.template);
            var i,
                o = e.querySelector(r.barSelector),
                u = n ? "-100" : s(t.status || 0),
                l = document.querySelector(r.parent);
            return (
                a(o, { transition: "all 0 linear", transform: "translate3d(" + u + "%,0,0)" }), r.showSpinner || ((i = e.querySelector(r.spinnerSelector)) && d(i)), l != document.body && c(l, "nprogress-custom-parent"), l.appendChild(e), e
            );
        }),
        (t.remove = function () {
            l(document.documentElement, "nprogress-busy"), l(document.querySelector(r.parent), "nprogress-custom-parent");
            var n = document.getElementById("nprogress");
            n && d(n);
        }),
        (t.isRendered = function () {
            return !!document.getElementById("nprogress");
        }),
        (t.getPositioningCSS = function () {
            var n = document.body.style,
                e = "WebkitTransform" in n ? "Webkit" : "MozTransform" in n ? "Moz" : "msTransform" in n ? "ms" : "OTransform" in n ? "O" : "";
            return e + "Perspective" in n ? "translate3d" : e + "Transform" in n ? "translate" : "margin";
        });
    var o = (function () {
            var n = [];
            function e() {
                var t = n.shift();
                t && t(e);
            }
            return function (t) {
                n.push(t), 1 == n.length && e();
            };
        })(),
        a = (function () {
            var n = ["Webkit", "O", "Moz", "ms"],
                e = {};
            function t(t) {
                return (
                    (t = t.replace(/^-ms-/, "ms-").replace(/-([\da-z])/gi, function (n, e) {
                        return e.toUpperCase();
                    })),
                    e[t] ||
                        (e[t] = (function (e) {
                            var t = document.body.style;
                            if (e in t) return e;
                            for (var r, i = n.length, s = e.charAt(0).toUpperCase() + e.slice(1); i--; ) if ((r = n[i] + s) in t) return r;
                            return e;
                        })(t))
                );
            }
            function r(n, e, r) {
                (e = t(e)), (n.style[e] = r);
            }
            return function (n, e) {
                var t,
                    i,
                    s = arguments;
                if (2 == s.length) for (t in e) void 0 !== (i = e[t]) && e.hasOwnProperty(t) && r(n, t, i);
                else r(n, s[1], s[2]);
            };
        })();
    function u(n, e) {
        return ("string" == typeof n ? n : f(n)).indexOf(" " + e + " ") >= 0;
    }
    function c(n, e) {
        var t = f(n),
            r = t + e;
        u(t, e) || (n.className = r.substring(1));
    }
    function l(n, e) {
        var t,
            r = f(n);
        u(n, e) && ((t = r.replace(" " + e + " ", " ")), (n.className = t.substring(1, t.length - 1)));
    }
    function f(n) {
        return (" " + ((n && n.className) || "") + " ").replace(/\s+/gi, " ");
    }
    function d(n) {
        n && n.parentNode && n.parentNode.removeChild(n);
    }
    return t;
});
/*! PhotoSwipe - v4.1.2 */
!(function (a, b) {
    "function" == typeof define && define.amd ? define(b) : "object" == typeof exports ? (module.exports = b()) : (a.PhotoSwipe = b());
})(this, function () {
    "use strict";
    var a = function (a, b, c, d) {
        var e = {
            features: null,
            bind: function (a, b, c, d) {
                var e = (d ? "remove" : "add") + "EventListener";
                b = b.split(" ");
                for (var f = 0; f < b.length; f++) b[f] && a[e](b[f], c, !1);
            },
            isArray: function (a) {
                return a instanceof Array;
            },
            createEl: function (a, b) {
                var c = document.createElement(b || "div");
                return a && (c.className = a), c;
            },
            getScrollY: function () {
                var a = window.pageYOffset;
                return void 0 !== a ? a : document.documentElement.scrollTop;
            },
            unbind: function (a, b, c) {
                e.bind(a, b, c, !0);
            },
            removeClass: function (a, b) {
                var c = new RegExp("(\\s|^)" + b + "(\\s|$)");
                a.className = a.className
                    .replace(c, " ")
                    .replace(/^\s\s*/, "")
                    .replace(/\s\s*$/, "");
            },
            addClass: function (a, b) {
                e.hasClass(a, b) || (a.className += (a.className ? " " : "") + b);
            },
            hasClass: function (a, b) {
                return a.className && new RegExp("(^|\\s)" + b + "(\\s|$)").test(a.className);
            },
            getChildByClass: function (a, b) {
                for (var c = a.firstChild; c; ) {
                    if (e.hasClass(c, b)) return c;
                    c = c.nextSibling;
                }
            },
            arraySearch: function (a, b, c) {
                for (var d = a.length; d--; ) if (a[d][c] === b) return d;
                return -1;
            },
            extend: function (a, b, c) {
                for (var d in b)
                    if (b.hasOwnProperty(d)) {
                        if (c && a.hasOwnProperty(d)) continue;
                        a[d] = b[d];
                    }
            },
            easing: {
                sine: {
                    out: function (a) {
                        return Math.sin(a * (Math.PI / 2));
                    },
                    inOut: function (a) {
                        return -(Math.cos(Math.PI * a) - 1) / 2;
                    },
                },
                cubic: {
                    out: function (a) {
                        return --a * a * a + 1;
                    },
                },
            },
            detectFeatures: function () {
                if (e.features) return e.features;
                var a = e.createEl(),
                    b = a.style,
                    c = "",
                    d = {};
                if (
                    ((d.oldIE = document.all && !document.addEventListener),
                    (d.touch = "ontouchstart" in window),
                    window.requestAnimationFrame && ((d.raf = window.requestAnimationFrame), (d.caf = window.cancelAnimationFrame)),
                    (d.pointerEvent = !!window.PointerEvent || navigator.msPointerEnabled),
                    !d.pointerEvent)
                ) {
                    var f = navigator.userAgent;
                    if (/iP(hone|od)/.test(navigator.platform)) {
                        var g = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                        g && g.length > 0 && ((g = parseInt(g[1], 10)), g >= 1 && g < 8 && (d.isOldIOSPhone = !0));
                    }
                    var h = f.match(/Android\s([0-9\.]*)/),
                        i = h ? h[1] : 0;
                    (i = parseFloat(i)), i >= 1 && (i < 4.4 && (d.isOldAndroid = !0), (d.androidVersion = i)), (d.isMobileOpera = /opera mini|opera mobi/i.test(f));
                }
                for (var j, k, l = ["transform", "perspective", "animationName"], m = ["", "webkit", "Moz", "ms", "O"], n = 0; n < 4; n++) {
                    c = m[n];
                    for (var o = 0; o < 3; o++) (j = l[o]), (k = c + (c ? j.charAt(0).toUpperCase() + j.slice(1) : j)), !d[j] && k in b && (d[j] = k);
                    c && !d.raf && ((c = c.toLowerCase()), (d.raf = window[c + "RequestAnimationFrame"]), d.raf && (d.caf = window[c + "CancelAnimationFrame"] || window[c + "CancelRequestAnimationFrame"]));
                }
                if (!d.raf) {
                    var p = 0;
                    (d.raf = function (a) {
                        var b = new Date().getTime(),
                            c = Math.max(0, 16 - (b - p)),
                            d = window.setTimeout(function () {
                                a(b + c);
                            }, c);
                        return (p = b + c), d;
                    }),
                        (d.caf = function (a) {
                            clearTimeout(a);
                        });
                }
                return (d.svg = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect), (e.features = d), d;
            },
        };
        e.detectFeatures(),
            e.features.oldIE &&
                (e.bind = function (a, b, c, d) {
                    b = b.split(" ");
                    for (
                        var e,
                            f = (d ? "detach" : "attach") + "Event",
                            g = function () {
                                c.handleEvent.call(c);
                            },
                            h = 0;
                        h < b.length;
                        h++
                    )
                        if ((e = b[h]))
                            if ("object" == typeof c && c.handleEvent) {
                                if (d) {
                                    if (!c["oldIE" + e]) return !1;
                                } else c["oldIE" + e] = g;
                                a[f]("on" + e, c["oldIE" + e]);
                            } else a[f]("on" + e, c);
                });
        var f = this,
            g = 25,
            h = 3,
            i = {
                allowPanToNext: !0,
                spacing: 0.12,
                bgOpacity: 1,
                mouseUsed: !1,
                loop: !0,
                pinchToClose: !0,
                closeOnScroll: !0,
                closeOnVerticalDrag: !0,
                verticalDragRange: 0.75,
                hideAnimationDuration: 333,
                showAnimationDuration: 333,
                showHideOpacity: !1,
                focus: !0,
                escKey: !0,
                arrowKeys: !0,
                mainScrollEndFriction: 0.35,
                panEndFriction: 0.35,
                isClickableElement: function (a) {
                    return "A" === a.tagName;
                },
                getDoubleTapZoom: function (a, b) {
                    return a ? 1 : b.initialZoomLevel < 0.7 ? 1 : 1.33;
                },
                maxSpreadZoom: 1.33,
                modal: !0,
                scaleMode: "fit",
            };
        e.extend(i, d);
        var j,
            k,
            l,
            m,
            n,
            o,
            p,
            q,
            r,
            s,
            t,
            u,
            v,
            w,
            x,
            y,
            z,
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H,
            I,
            J,
            K,
            L,
            M,
            N,
            O,
            P,
            Q,
            R,
            S,
            T,
            U,
            V,
            W,
            X,
            Y,
            Z,
            $,
            _,
            aa,
            ba,
            ca,
            da,
            ea,
            fa,
            ga,
            ha,
            ia,
            ja,
            ka,
            la,
            ma = function () {
                return { x: 0, y: 0 };
            },
            na = ma(),
            oa = ma(),
            pa = ma(),
            qa = {},
            ra = 0,
            sa = {},
            ta = ma(),
            ua = 0,
            va = !0,
            wa = [],
            xa = {},
            ya = !1,
            za = function (a, b) {
                e.extend(f, b.publicMethods), wa.push(a);
            },
            Aa = function (a) {
                var b = ac();
                return a > b - 1 ? a - b : a < 0 ? b + a : a;
            },
            Ba = {},
            Ca = function (a, b) {
                return Ba[a] || (Ba[a] = []), Ba[a].push(b);
            },
            Da = function (a) {
                var b = Ba[a];
                if (b) {
                    var c = Array.prototype.slice.call(arguments);
                    c.shift();
                    for (var d = 0; d < b.length; d++) b[d].apply(f, c);
                }
            },
            Ea = function () {
                return new Date().getTime();
            },
            Fa = function (a) {
                (ja = a), (f.bg.style.opacity = a * i.bgOpacity);
            },
            Ga = function (a, b, c, d, e) {
                (!ya || (e && e !== f.currItem)) && (d /= e ? e.fitRatio : f.currItem.fitRatio), (a[E] = u + b + "px, " + c + "px" + v + " scale(" + d + ")");
            },
            Ha = function (a) {
                ea && (a && (s > f.currItem.fitRatio ? ya || (mc(f.currItem, !1, !0), (ya = !0)) : ya && (mc(f.currItem), (ya = !1))), Ga(ea, pa.x, pa.y, s));
            },
            Ia = function (a) {
                a.container && Ga(a.container.style, a.initialPosition.x, a.initialPosition.y, a.initialZoomLevel, a);
            },
            Ja = function (a, b) {
                b[E] = u + a + "px, 0px" + v;
            },
            Ka = function (a, b) {
                if (!i.loop && b) {
                    var c = m + (ta.x * ra - a) / ta.x,
                        d = Math.round(a - tb.x);
                    ((c < 0 && d > 0) || (c >= ac() - 1 && d < 0)) && (a = tb.x + d * i.mainScrollEndFriction);
                }
                (tb.x = a), Ja(a, n);
            },
            La = function (a, b) {
                var c = ub[a] - sa[a];
                return oa[a] + na[a] + c - c * (b / t);
            },
            Ma = function (a, b) {
                (a.x = b.x), (a.y = b.y), b.id && (a.id = b.id);
            },
            Na = function (a) {
                (a.x = Math.round(a.x)), (a.y = Math.round(a.y));
            },
            Oa = null,
            Pa = function () {
                Oa && (e.unbind(document, "mousemove", Pa), e.addClass(a, "pswp--has_mouse"), (i.mouseUsed = !0), Da("mouseUsed")),
                    (Oa = setTimeout(function () {
                        Oa = null;
                    }, 100));
            },
            Qa = function () {
                e.bind(document, "keydown", f), N.transform && e.bind(f.scrollWrap, "click", f), i.mouseUsed || e.bind(document, "mousemove", Pa), e.bind(window, "resize scroll orientationchange", f), Da("bindEvents");
            },
            Ra = function () {
                e.unbind(window, "resize scroll orientationchange", f),
                    e.unbind(window, "scroll", r.scroll),
                    e.unbind(document, "keydown", f),
                    e.unbind(document, "mousemove", Pa),
                    N.transform && e.unbind(f.scrollWrap, "click", f),
                    V && e.unbind(window, p, f),
                    clearTimeout(O),
                    Da("unbindEvents");
            },
            Sa = function (a, b) {
                var c = ic(f.currItem, qa, a);
                return b && (da = c), c;
            },
            Ta = function (a) {
                return a || (a = f.currItem), a.initialZoomLevel;
            },
            Ua = function (a) {
                return a || (a = f.currItem), a.w > 0 ? i.maxSpreadZoom : 1;
            },
            Va = function (a, b, c, d) {
                return d === f.currItem.initialZoomLevel ? ((c[a] = f.currItem.initialPosition[a]), !0) : ((c[a] = La(a, d)), c[a] > b.min[a] ? ((c[a] = b.min[a]), !0) : c[a] < b.max[a] && ((c[a] = b.max[a]), !0));
            },
            Wa = function () {
                if (E) {
                    var b = N.perspective && !G;
                    return (u = "translate" + (b ? "3d(" : "(")), void (v = N.perspective ? ", 0px)" : ")");
                }
                (E = "left"),
                    e.addClass(a, "pswp--ie"),
                    (Ja = function (a, b) {
                        b.left = a + "px";
                    }),
                    (Ia = function (a) {
                        var b = a.fitRatio > 1 ? 1 : a.fitRatio,
                            c = a.container.style,
                            d = b * a.w,
                            e = b * a.h;
                        (c.width = d + "px"), (c.height = e + "px"), (c.left = a.initialPosition.x + "px"), (c.top = a.initialPosition.y + "px");
                    }),
                    (Ha = function () {
                        if (ea) {
                            var a = ea,
                                b = f.currItem,
                                c = b.fitRatio > 1 ? 1 : b.fitRatio,
                                d = c * b.w,
                                e = c * b.h;
                            (a.width = d + "px"), (a.height = e + "px"), (a.left = pa.x + "px"), (a.top = pa.y + "px");
                        }
                    });
            },
            Xa = function (a) {
                var b = "";
                i.escKey && 27 === a.keyCode ? (b = "close") : i.arrowKeys && (37 === a.keyCode ? (b = "prev") : 39 === a.keyCode && (b = "next")),
                    b && (a.ctrlKey || a.altKey || a.shiftKey || a.metaKey || (a.preventDefault ? a.preventDefault() : (a.returnValue = !1), f[b]()));
            },
            Ya = function (a) {
                a && (Y || X || fa || T) && (a.preventDefault(), a.stopPropagation());
            },
            Za = function () {
                f.setScrollOffset(0, e.getScrollY());
            },
            $a = {},
            _a = 0,
            ab = function (a) {
                $a[a] && ($a[a].raf && I($a[a].raf), _a--, delete $a[a]);
            },
            bb = function (a) {
                $a[a] && ab(a), $a[a] || (_a++, ($a[a] = {}));
            },
            cb = function () {
                for (var a in $a) $a.hasOwnProperty(a) && ab(a);
            },
            db = function (a, b, c, d, e, f, g) {
                var h,
                    i = Ea();
                bb(a);
                var j = function () {
                    if ($a[a]) {
                        if (((h = Ea() - i), h >= d)) return ab(a), f(c), void (g && g());
                        f((c - b) * e(h / d) + b), ($a[a].raf = H(j));
                    }
                };
                j();
            },
            eb = {
                shout: Da,
                listen: Ca,
                viewportSize: qa,
                options: i,
                isMainScrollAnimating: function () {
                    return fa;
                },
                getZoomLevel: function () {
                    return s;
                },
                getCurrentIndex: function () {
                    return m;
                },
                isDragging: function () {
                    return V;
                },
                isZooming: function () {
                    return aa;
                },
                setScrollOffset: function (a, b) {
                    (sa.x = a), (M = sa.y = b), Da("updateScrollOffset", sa);
                },
                applyZoomPan: function (a, b, c, d) {
                    (pa.x = b), (pa.y = c), (s = a), Ha(d);
                },
                init: function () {
                    if (!j && !k) {
                        var c;
                        (f.framework = e),
                            (f.template = a),
                            (f.bg = e.getChildByClass(a, "pswp__bg")),
                            (J = a.className),
                            (j = !0),
                            (N = e.detectFeatures()),
                            (H = N.raf),
                            (I = N.caf),
                            (E = N.transform),
                            (L = N.oldIE),
                            (f.scrollWrap = e.getChildByClass(a, "pswp__scroll-wrap")),
                            (f.container = e.getChildByClass(f.scrollWrap, "pswp__container")),
                            (n = f.container.style),
                            (f.itemHolders = y = [
                                { el: f.container.children[0], wrap: 0, index: -1 },
                                { el: f.container.children[1], wrap: 0, index: -1 },
                                { el: f.container.children[2], wrap: 0, index: -1 },
                            ]),
                            (y[0].el.style.display = y[2].el.style.display = "none"),
                            Wa(),
                            (r = {
                                resize: f.updateSize,
                                orientationchange: function () {
                                    clearTimeout(O),
                                        (O = setTimeout(function () {
                                            qa.x !== f.scrollWrap.clientWidth && f.updateSize();
                                        }, 500));
                                },
                                scroll: Za,
                                keydown: Xa,
                                click: Ya,
                            });
                        var d = N.isOldIOSPhone || N.isOldAndroid || N.isMobileOpera;
                        for ((N.animationName && N.transform && !d) || (i.showAnimationDuration = i.hideAnimationDuration = 0), c = 0; c < wa.length; c++) f["init" + wa[c]]();
                        if (b) {
                            var g = (f.ui = new b(f, e));
                            g.init();
                        }
                        Da("firstUpdate"),
                            (m = m || i.index || 0),
                            (isNaN(m) || m < 0 || m >= ac()) && (m = 0),
                            (f.currItem = _b(m)),
                            (N.isOldIOSPhone || N.isOldAndroid) && (va = !1),
                            a.setAttribute("aria-hidden", "false"),
                            i.modal && (va ? (a.style.position = "fixed") : ((a.style.position = "absolute"), (a.style.top = e.getScrollY() + "px"))),
                            void 0 === M && (Da("initialLayout"), (M = K = e.getScrollY()));
                        var l = "pswp--open ";
                        for (
                            i.mainClass && (l += i.mainClass + " "),
                                i.showHideOpacity && (l += "pswp--animate_opacity "),
                                l += G ? "pswp--touch" : "pswp--notouch",
                                l += N.animationName ? " pswp--css_animation" : "",
                                l += N.svg ? " pswp--svg" : "",
                                e.addClass(a, l),
                                f.updateSize(),
                                o = -1,
                                ua = null,
                                c = 0;
                            c < h;
                            c++
                        )
                            Ja((c + o) * ta.x, y[c].el.style);
                        L || e.bind(f.scrollWrap, q, f),
                            Ca("initialZoomInEnd", function () {
                                f.setContent(y[0], m - 1), f.setContent(y[2], m + 1), (y[0].el.style.display = y[2].el.style.display = "block"), i.focus && a.focus(), Qa();
                            }),
                            f.setContent(y[1], m),
                            f.updateCurrItem(),
                            Da("afterInit"),
                            va ||
                                (w = setInterval(function () {
                                    _a || V || aa || s !== f.currItem.initialZoomLevel || f.updateSize();
                                }, 1e3)),
                            e.addClass(a, "pswp--visible");
                    }
                },
                close: function () {
                    j && ((j = !1), (k = !0), Da("close"), Ra(), cc(f.currItem, null, !0, f.destroy));
                },
                destroy: function () {
                    Da("destroy"), Xb && clearTimeout(Xb), a.setAttribute("aria-hidden", "true"), (a.className = J), w && clearInterval(w), e.unbind(f.scrollWrap, q, f), e.unbind(window, "scroll", f), zb(), cb(), (Ba = null);
                },
                panTo: function (a, b, c) {
                    c || (a > da.min.x ? (a = da.min.x) : a < da.max.x && (a = da.max.x), b > da.min.y ? (b = da.min.y) : b < da.max.y && (b = da.max.y)), (pa.x = a), (pa.y = b), Ha();
                },
                handleEvent: function (a) {
                    (a = a || window.event), r[a.type] && r[a.type](a);
                },
                goTo: function (a) {
                    a = Aa(a);
                    var b = a - m;
                    (ua = b), (m = a), (f.currItem = _b(m)), (ra -= b), Ka(ta.x * ra), cb(), (fa = !1), f.updateCurrItem();
                },
                next: function () {
                    f.goTo(m + 1);
                },
                prev: function () {
                    f.goTo(m - 1);
                },
                updateCurrZoomItem: function (a) {
                    if ((a && Da("beforeChange", 0), y[1].el.children.length)) {
                        var b = y[1].el.children[0];
                        ea = e.hasClass(b, "pswp__zoom-wrap") ? b.style : null;
                    } else ea = null;
                    (da = f.currItem.bounds), (t = s = f.currItem.initialZoomLevel), (pa.x = da.center.x), (pa.y = da.center.y), a && Da("afterChange");
                },
                invalidateCurrItems: function () {
                    x = !0;
                    for (var a = 0; a < h; a++) y[a].item && (y[a].item.needsUpdate = !0);
                },
                updateCurrItem: function (a) {
                    if (0 !== ua) {
                        var b,
                            c = Math.abs(ua);
                        if (!(a && c < 2)) {
                            (f.currItem = _b(m)), (ya = !1), Da("beforeChange", ua), c >= h && ((o += ua + (ua > 0 ? -h : h)), (c = h));
                            for (var d = 0; d < c; d++)
                                ua > 0
                                    ? ((b = y.shift()), (y[h - 1] = b), o++, Ja((o + 2) * ta.x, b.el.style), f.setContent(b, m - c + d + 1 + 1))
                                    : ((b = y.pop()), y.unshift(b), o--, Ja(o * ta.x, b.el.style), f.setContent(b, m + c - d - 1 - 1));
                            if (ea && 1 === Math.abs(ua)) {
                                var e = _b(z);
                                e.initialZoomLevel !== s && (ic(e, qa), mc(e), Ia(e));
                            }
                            (ua = 0), f.updateCurrZoomItem(), (z = m), Da("afterChange");
                        }
                    }
                },
                updateSize: function (b) {
                    if (!va && i.modal) {
                        var c = e.getScrollY();
                        if ((M !== c && ((a.style.top = c + "px"), (M = c)), !b && xa.x === window.innerWidth && xa.y === window.innerHeight)) return;
                        (xa.x = window.innerWidth), (xa.y = window.innerHeight), (a.style.height = xa.y + "px");
                    }
                    if (((qa.x = f.scrollWrap.clientWidth), (qa.y = f.scrollWrap.clientHeight), Za(), (ta.x = qa.x + Math.round(qa.x * i.spacing)), (ta.y = qa.y), Ka(ta.x * ra), Da("beforeResize"), void 0 !== o)) {
                        for (var d, g, j, k = 0; k < h; k++)
                            (d = y[k]),
                                Ja((k + o) * ta.x, d.el.style),
                                (j = m + k - 1),
                                i.loop && ac() > 2 && (j = Aa(j)),
                                (g = _b(j)),
                                g && (x || g.needsUpdate || !g.bounds) ? (f.cleanSlide(g), f.setContent(d, j), 1 === k && ((f.currItem = g), f.updateCurrZoomItem(!0)), (g.needsUpdate = !1)) : d.index === -1 && j >= 0 && f.setContent(d, j),
                                g && g.container && (ic(g, qa), mc(g), Ia(g));
                        x = !1;
                    }
                    (t = s = f.currItem.initialZoomLevel), (da = f.currItem.bounds), da && ((pa.x = da.center.x), (pa.y = da.center.y), Ha(!0)), Da("resize");
                },
                zoomTo: function (a, b, c, d, f) {
                    b && ((t = s), (ub.x = Math.abs(b.x) - pa.x), (ub.y = Math.abs(b.y) - pa.y), Ma(oa, pa));
                    var g = Sa(a, !1),
                        h = {};
                    Va("x", g, h, a), Va("y", g, h, a);
                    var i = s,
                        j = { x: pa.x, y: pa.y };
                    Na(h);
                    var k = function (b) {
                        1 === b ? ((s = a), (pa.x = h.x), (pa.y = h.y)) : ((s = (a - i) * b + i), (pa.x = (h.x - j.x) * b + j.x), (pa.y = (h.y - j.y) * b + j.y)), f && f(b), Ha(1 === b);
                    };
                    c ? db("customZoomTo", 0, 1, c, d || e.easing.sine.inOut, k) : k(1);
                },
            },
            fb = 30,
            gb = 10,
            hb = {},
            ib = {},
            jb = {},
            kb = {},
            lb = {},
            mb = [],
            nb = {},
            ob = [],
            pb = {},
            qb = 0,
            rb = ma(),
            sb = 0,
            tb = ma(),
            ub = ma(),
            vb = ma(),
            wb = function (a, b) {
                return a.x === b.x && a.y === b.y;
            },
            xb = function (a, b) {
                return Math.abs(a.x - b.x) < g && Math.abs(a.y - b.y) < g;
            },
            yb = function (a, b) {
                return (pb.x = Math.abs(a.x - b.x)), (pb.y = Math.abs(a.y - b.y)), Math.sqrt(pb.x * pb.x + pb.y * pb.y);
            },
            zb = function () {
                Z && (I(Z), (Z = null));
            },
            Ab = function () {
                V && ((Z = H(Ab)), Qb());
            },
            Bb = function () {
                return !("fit" === i.scaleMode && s === f.currItem.initialZoomLevel);
            },
            Cb = function (a, b) {
                return !(!a || a === document) && !(a.getAttribute("class") && a.getAttribute("class").indexOf("pswp__scroll-wrap") > -1) && (b(a) ? a : Cb(a.parentNode, b));
            },
            Db = {},
            Eb = function (a, b) {
                return (Db.prevent = !Cb(a.target, i.isClickableElement)), Da("preventDragEvent", a, b, Db), Db.prevent;
            },
            Fb = function (a, b) {
                return (b.x = a.pageX), (b.y = a.pageY), (b.id = a.identifier), b;
            },
            Gb = function (a, b, c) {
                (c.x = 0.5 * (a.x + b.x)), (c.y = 0.5 * (a.y + b.y));
            },
            Hb = function (a, b, c) {
                if (a - Q > 50) {
                    var d = ob.length > 2 ? ob.shift() : {};
                    (d.x = b), (d.y = c), ob.push(d), (Q = a);
                }
            },
            Ib = function () {
                var a = pa.y - f.currItem.initialPosition.y;
                return 1 - Math.abs(a / (qa.y / 2));
            },
            Jb = {},
            Kb = {},
            Lb = [],
            Mb = function (a) {
                for (; Lb.length > 0; ) Lb.pop();
                return (
                    F
                        ? ((la = 0),
                          mb.forEach(function (a) {
                              0 === la ? (Lb[0] = a) : 1 === la && (Lb[1] = a), la++;
                          }))
                        : a.type.indexOf("touch") > -1
                        ? a.touches && a.touches.length > 0 && ((Lb[0] = Fb(a.touches[0], Jb)), a.touches.length > 1 && (Lb[1] = Fb(a.touches[1], Kb)))
                        : ((Jb.x = a.pageX), (Jb.y = a.pageY), (Jb.id = ""), (Lb[0] = Jb)),
                    Lb
                );
            },
            Nb = function (a, b) {
                var c,
                    d,
                    e,
                    g,
                    h = 0,
                    j = pa[a] + b[a],
                    k = b[a] > 0,
                    l = tb.x + b.x,
                    m = tb.x - nb.x;
                return (
                    (c = j > da.min[a] || j < da.max[a] ? i.panEndFriction : 1),
                    (j = pa[a] + b[a] * c),
                    (!i.allowPanToNext && s !== f.currItem.initialZoomLevel) ||
                    (ea
                        ? "h" !== ga ||
                          "x" !== a ||
                          X ||
                          (k
                              ? (j > da.min[a] && ((c = i.panEndFriction), (h = da.min[a] - j), (d = da.min[a] - oa[a])), (d <= 0 || m < 0) && ac() > 1 ? ((g = l), m < 0 && l > nb.x && (g = nb.x)) : da.min.x !== da.max.x && (e = j))
                              : (j < da.max[a] && ((c = i.panEndFriction), (h = j - da.max[a]), (d = oa[a] - da.max[a])), (d <= 0 || m > 0) && ac() > 1 ? ((g = l), m > 0 && l < nb.x && (g = nb.x)) : da.min.x !== da.max.x && (e = j)))
                        : (g = l),
                    "x" !== a)
                        ? void (fa || $ || (s > f.currItem.fitRatio && (pa[a] += b[a] * c)))
                        : (void 0 !== g && (Ka(g, !0), ($ = g !== nb.x)), da.min.x !== da.max.x && (void 0 !== e ? (pa.x = e) : $ || (pa.x += b.x * c)), void 0 !== g)
                );
            },
            Ob = function (a) {
                if (!("mousedown" === a.type && a.button > 0)) {
                    if ($b) return void a.preventDefault();
                    if (!U || "mousedown" !== a.type) {
                        if ((Eb(a, !0) && a.preventDefault(), Da("pointerDown"), F)) {
                            var b = e.arraySearch(mb, a.pointerId, "id");
                            b < 0 && (b = mb.length), (mb[b] = { x: a.pageX, y: a.pageY, id: a.pointerId });
                        }
                        var c = Mb(a),
                            d = c.length;
                        (_ = null),
                            cb(),
                            (V && 1 !== d) ||
                                ((V = ha = !0),
                                e.bind(window, p, f),
                                (S = ka = ia = T = $ = Y = W = X = !1),
                                (ga = null),
                                Da("firstTouchStart", c),
                                Ma(oa, pa),
                                (na.x = na.y = 0),
                                Ma(kb, c[0]),
                                Ma(lb, kb),
                                (nb.x = ta.x * ra),
                                (ob = [{ x: kb.x, y: kb.y }]),
                                (Q = P = Ea()),
                                Sa(s, !0),
                                zb(),
                                Ab()),
                            !aa &&
                                d > 1 &&
                                !fa &&
                                !$ &&
                                ((t = s), (X = !1), (aa = W = !0), (na.y = na.x = 0), Ma(oa, pa), Ma(hb, c[0]), Ma(ib, c[1]), Gb(hb, ib, vb), (ub.x = Math.abs(vb.x) - pa.x), (ub.y = Math.abs(vb.y) - pa.y), (ba = ca = yb(hb, ib)));
                    }
                }
            },
            Pb = function (a) {
                if ((a.preventDefault(), F)) {
                    var b = e.arraySearch(mb, a.pointerId, "id");
                    if (b > -1) {
                        var c = mb[b];
                        (c.x = a.pageX), (c.y = a.pageY);
                    }
                }
                if (V) {
                    var d = Mb(a);
                    if (ga || Y || aa) _ = d;
                    else if (tb.x !== ta.x * ra) ga = "h";
                    else {
                        var f = Math.abs(d[0].x - kb.x) - Math.abs(d[0].y - kb.y);
                        Math.abs(f) >= gb && ((ga = f > 0 ? "h" : "v"), (_ = d));
                    }
                }
            },
            Qb = function () {
                if (_) {
                    var a = _.length;
                    if (0 !== a)
                        if ((Ma(hb, _[0]), (jb.x = hb.x - kb.x), (jb.y = hb.y - kb.y), aa && a > 1)) {
                            if (((kb.x = hb.x), (kb.y = hb.y), !jb.x && !jb.y && wb(_[1], ib))) return;
                            Ma(ib, _[1]), X || ((X = !0), Da("zoomGestureStarted"));
                            var b = yb(hb, ib),
                                c = Vb(b);
                            c > f.currItem.initialZoomLevel + f.currItem.initialZoomLevel / 15 && (ka = !0);
                            var d = 1,
                                e = Ta(),
                                g = Ua();
                            if (c < e)
                                if (i.pinchToClose && !ka && t <= f.currItem.initialZoomLevel) {
                                    var h = e - c,
                                        j = 1 - h / (e / 1.2);
                                    Fa(j), Da("onPinchClose", j), (ia = !0);
                                } else (d = (e - c) / e), d > 1 && (d = 1), (c = e - d * (e / 3));
                            else c > g && ((d = (c - g) / (6 * e)), d > 1 && (d = 1), (c = g + d * e));
                            d < 0 && (d = 0), (ba = b), Gb(hb, ib, rb), (na.x += rb.x - vb.x), (na.y += rb.y - vb.y), Ma(vb, rb), (pa.x = La("x", c)), (pa.y = La("y", c)), (S = c > s), (s = c), Ha();
                        } else {
                            if (!ga) return;
                            if ((ha && ((ha = !1), Math.abs(jb.x) >= gb && (jb.x -= _[0].x - lb.x), Math.abs(jb.y) >= gb && (jb.y -= _[0].y - lb.y)), (kb.x = hb.x), (kb.y = hb.y), 0 === jb.x && 0 === jb.y)) return;
                            if ("v" === ga && i.closeOnVerticalDrag && !Bb()) {
                                (na.y += jb.y), (pa.y += jb.y);
                                var k = Ib();
                                return (T = !0), Da("onVerticalDrag", k), Fa(k), void Ha();
                            }
                            Hb(Ea(), hb.x, hb.y), (Y = !0), (da = f.currItem.bounds);
                            var l = Nb("x", jb);
                            l || (Nb("y", jb), Na(pa), Ha());
                        }
                }
            },
            Rb = function (a) {
                if (N.isOldAndroid) {
                    if (U && "mouseup" === a.type) return;
                    a.type.indexOf("touch") > -1 &&
                        (clearTimeout(U),
                        (U = setTimeout(function () {
                            U = 0;
                        }, 600)));
                }
                Da("pointerUp"), Eb(a, !1) && a.preventDefault();
                var b;
                if (F) {
                    var c = e.arraySearch(mb, a.pointerId, "id");
                    if (c > -1)
                        if (((b = mb.splice(c, 1)[0]), navigator.msPointerEnabled)) {
                            var d = { 4: "mouse", 2: "touch", 3: "pen" };
                            (b.type = d[a.pointerType]), b.type || (b.type = a.pointerType || "mouse");
                        } else b.type = a.pointerType || "mouse";
                }
                var g,
                    h = Mb(a),
                    j = h.length;
                if (("mouseup" === a.type && (j = 0), 2 === j)) return (_ = null), !0;
                1 === j && Ma(lb, h[0]),
                    0 !== j ||
                        ga ||
                        fa ||
                        (b || ("mouseup" === a.type ? (b = { x: a.pageX, y: a.pageY, type: "mouse" }) : a.changedTouches && a.changedTouches[0] && (b = { x: a.changedTouches[0].pageX, y: a.changedTouches[0].pageY, type: "touch" })),
                        Da("touchRelease", a, b));
                var k = -1;
                if (
                    (0 === j && ((V = !1), e.unbind(window, p, f), zb(), aa ? (k = 0) : sb !== -1 && (k = Ea() - sb)),
                    (sb = 1 === j ? Ea() : -1),
                    (g = k !== -1 && k < 150 ? "zoom" : "swipe"),
                    aa && j < 2 && ((aa = !1), 1 === j && (g = "zoomPointerUp"), Da("zoomGestureEnded")),
                    (_ = null),
                    Y || X || fa || T)
                )
                    if ((cb(), R || (R = Sb()), R.calculateSwipeSpeed("x"), T)) {
                        var l = Ib();
                        if (l < i.verticalDragRange) f.close();
                        else {
                            var m = pa.y,
                                n = ja;
                            db("verticalDrag", 0, 1, 300, e.easing.cubic.out, function (a) {
                                (pa.y = (f.currItem.initialPosition.y - m) * a + m), Fa((1 - n) * a + n), Ha();
                            }),
                                Da("onVerticalDrag", 1);
                        }
                    } else {
                        if (($ || fa) && 0 === j) {
                            var o = Ub(g, R);
                            if (o) return;
                            g = "zoomPointerUp";
                        }
                        if (!fa) return "swipe" !== g ? void Wb() : void (!$ && s > f.currItem.fitRatio && Tb(R));
                    }
            },
            Sb = function () {
                var a,
                    b,
                    c = {
                        lastFlickOffset: {},
                        lastFlickDist: {},
                        lastFlickSpeed: {},
                        slowDownRatio: {},
                        slowDownRatioReverse: {},
                        speedDecelerationRatio: {},
                        speedDecelerationRatioAbs: {},
                        distanceOffset: {},
                        backAnimDestination: {},
                        backAnimStarted: {},
                        calculateSwipeSpeed: function (d) {
                            ob.length > 1 ? ((a = Ea() - Q + 50), (b = ob[ob.length - 2][d])) : ((a = Ea() - P), (b = lb[d])),
                                (c.lastFlickOffset[d] = kb[d] - b),
                                (c.lastFlickDist[d] = Math.abs(c.lastFlickOffset[d])),
                                c.lastFlickDist[d] > 20 ? (c.lastFlickSpeed[d] = c.lastFlickOffset[d] / a) : (c.lastFlickSpeed[d] = 0),
                                Math.abs(c.lastFlickSpeed[d]) < 0.1 && (c.lastFlickSpeed[d] = 0),
                                (c.slowDownRatio[d] = 0.95),
                                (c.slowDownRatioReverse[d] = 1 - c.slowDownRatio[d]),
                                (c.speedDecelerationRatio[d] = 1);
                        },
                        calculateOverBoundsAnimOffset: function (a, b) {
                            c.backAnimStarted[a] ||
                                (pa[a] > da.min[a] ? (c.backAnimDestination[a] = da.min[a]) : pa[a] < da.max[a] && (c.backAnimDestination[a] = da.max[a]),
                                void 0 !== c.backAnimDestination[a] &&
                                    ((c.slowDownRatio[a] = 0.7),
                                    (c.slowDownRatioReverse[a] = 1 - c.slowDownRatio[a]),
                                    c.speedDecelerationRatioAbs[a] < 0.05 &&
                                        ((c.lastFlickSpeed[a] = 0),
                                        (c.backAnimStarted[a] = !0),
                                        db("bounceZoomPan" + a, pa[a], c.backAnimDestination[a], b || 300, e.easing.sine.out, function (b) {
                                            (pa[a] = b), Ha();
                                        }))));
                        },
                        calculateAnimOffset: function (a) {
                            c.backAnimStarted[a] ||
                                ((c.speedDecelerationRatio[a] = c.speedDecelerationRatio[a] * (c.slowDownRatio[a] + c.slowDownRatioReverse[a] - (c.slowDownRatioReverse[a] * c.timeDiff) / 10)),
                                (c.speedDecelerationRatioAbs[a] = Math.abs(c.lastFlickSpeed[a] * c.speedDecelerationRatio[a])),
                                (c.distanceOffset[a] = c.lastFlickSpeed[a] * c.speedDecelerationRatio[a] * c.timeDiff),
                                (pa[a] += c.distanceOffset[a]));
                        },
                        panAnimLoop: function () {
                            if (
                                $a.zoomPan &&
                                (($a.zoomPan.raf = H(c.panAnimLoop)),
                                (c.now = Ea()),
                                (c.timeDiff = c.now - c.lastNow),
                                (c.lastNow = c.now),
                                c.calculateAnimOffset("x"),
                                c.calculateAnimOffset("y"),
                                Ha(),
                                c.calculateOverBoundsAnimOffset("x"),
                                c.calculateOverBoundsAnimOffset("y"),
                                c.speedDecelerationRatioAbs.x < 0.05 && c.speedDecelerationRatioAbs.y < 0.05)
                            )
                                return (pa.x = Math.round(pa.x)), (pa.y = Math.round(pa.y)), Ha(), void ab("zoomPan");
                        },
                    };
                return c;
            },
            Tb = function (a) {
                return (
                    a.calculateSwipeSpeed("y"),
                    (da = f.currItem.bounds),
                    (a.backAnimDestination = {}),
                    (a.backAnimStarted = {}),
                    Math.abs(a.lastFlickSpeed.x) <= 0.05 && Math.abs(a.lastFlickSpeed.y) <= 0.05
                        ? ((a.speedDecelerationRatioAbs.x = a.speedDecelerationRatioAbs.y = 0), a.calculateOverBoundsAnimOffset("x"), a.calculateOverBoundsAnimOffset("y"), !0)
                        : (bb("zoomPan"), (a.lastNow = Ea()), void a.panAnimLoop())
                );
            },
            Ub = function (a, b) {
                var c;
                fa || (qb = m);
                var d;
                if ("swipe" === a) {
                    var g = kb.x - lb.x,
                        h = b.lastFlickDist.x < 10;
                    g > fb && (h || b.lastFlickOffset.x > 20) ? (d = -1) : g < -fb && (h || b.lastFlickOffset.x < -20) && (d = 1);
                }
                var j;
                d && ((m += d), m < 0 ? ((m = i.loop ? ac() - 1 : 0), (j = !0)) : m >= ac() && ((m = i.loop ? 0 : ac() - 1), (j = !0)), (j && !i.loop) || ((ua += d), (ra -= d), (c = !0)));
                var k,
                    l = ta.x * ra,
                    n = Math.abs(l - tb.x);
                return (
                    c || l > tb.x == b.lastFlickSpeed.x > 0 ? ((k = Math.abs(b.lastFlickSpeed.x) > 0 ? n / Math.abs(b.lastFlickSpeed.x) : 333), (k = Math.min(k, 400)), (k = Math.max(k, 250))) : (k = 333),
                    qb === m && (c = !1),
                    (fa = !0),
                    Da("mainScrollAnimStart"),
                    db("mainScroll", tb.x, l, k, e.easing.cubic.out, Ka, function () {
                        cb(), (fa = !1), (qb = -1), (c || qb !== m) && f.updateCurrItem(), Da("mainScrollAnimComplete");
                    }),
                    c && f.updateCurrItem(!0),
                    c
                );
            },
            Vb = function (a) {
                return (1 / ca) * a * t;
            },
            Wb = function () {
                var a = s,
                    b = Ta(),
                    c = Ua();
                s < b ? (a = b) : s > c && (a = c);
                var d,
                    g = 1,
                    h = ja;
                return ia && !S && !ka && s < b
                    ? (f.close(), !0)
                    : (ia &&
                          (d = function (a) {
                              Fa((g - h) * a + h);
                          }),
                      f.zoomTo(a, 0, 200, e.easing.cubic.out, d),
                      !0);
            };
        za("Gestures", {
            publicMethods: {
                initGestures: function () {
                    var a = function (a, b, c, d, e) {
                        (A = a + b), (B = a + c), (C = a + d), (D = e ? a + e : "");
                    };
                    (F = N.pointerEvent),
                        F && N.touch && (N.touch = !1),
                        F
                            ? navigator.msPointerEnabled
                                ? a("MSPointer", "Down", "Move", "Up", "Cancel")
                                : a("pointer", "down", "move", "up", "cancel")
                            : N.touch
                            ? (a("touch", "start", "move", "end", "cancel"), (G = !0))
                            : a("mouse", "down", "move", "up"),
                        (p = B + " " + C + " " + D),
                        (q = A),
                        F && !G && (G = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1),
                        (f.likelyTouchDevice = G),
                        (r[A] = Ob),
                        (r[B] = Pb),
                        (r[C] = Rb),
                        D && (r[D] = r[C]),
                        N.touch && ((q += " mousedown"), (p += " mousemove mouseup"), (r.mousedown = r[A]), (r.mousemove = r[B]), (r.mouseup = r[C])),
                        G || (i.allowPanToNext = !1);
                },
            },
        });
        var Xb,
            Yb,
            Zb,
            $b,
            _b,
            ac,
            bc,
            cc = function (b, c, d, g) {
                Xb && clearTimeout(Xb), ($b = !0), (Zb = !0);
                var h;
                b.initialLayout ? ((h = b.initialLayout), (b.initialLayout = null)) : (h = i.getThumbBoundsFn && i.getThumbBoundsFn(m));
                var j = d ? i.hideAnimationDuration : i.showAnimationDuration,
                    k = function () {
                        ab("initialZoom"),
                            d ? (f.template.removeAttribute("style"), f.bg.removeAttribute("style")) : (Fa(1), c && (c.style.display = "block"), e.addClass(a, "pswp--animated-in"), Da("initialZoom" + (d ? "OutEnd" : "InEnd"))),
                            g && g(),
                            ($b = !1);
                    };
                if (!j || !h || void 0 === h.x)
                    return (
                        Da("initialZoom" + (d ? "Out" : "In")),
                        (s = b.initialZoomLevel),
                        Ma(pa, b.initialPosition),
                        Ha(),
                        (a.style.opacity = d ? 0 : 1),
                        Fa(1),
                        void (j
                            ? setTimeout(function () {
                                  k();
                              }, j)
                            : k())
                    );
                var n = function () {
                    var c = l,
                        g = !f.currItem.src || f.currItem.loadError || i.showHideOpacity;
                    b.miniImg && (b.miniImg.style.webkitBackfaceVisibility = "hidden"),
                        d || ((s = h.w / b.w), (pa.x = h.x), (pa.y = h.y - K), (f[g ? "template" : "bg"].style.opacity = 0.001), Ha()),
                        bb("initialZoom"),
                        d && !c && e.removeClass(a, "pswp--animated-in"),
                        g &&
                            (d
                                ? e[(c ? "remove" : "add") + "Class"](a, "pswp--animate_opacity")
                                : setTimeout(function () {
                                      e.addClass(a, "pswp--animate_opacity");
                                  }, 30)),
                        (Xb = setTimeout(
                            function () {
                                if ((Da("initialZoom" + (d ? "Out" : "In")), d)) {
                                    var f = h.w / b.w,
                                        i = { x: pa.x, y: pa.y },
                                        l = s,
                                        m = ja,
                                        n = function (b) {
                                            1 === b ? ((s = f), (pa.x = h.x), (pa.y = h.y - M)) : ((s = (f - l) * b + l), (pa.x = (h.x - i.x) * b + i.x), (pa.y = (h.y - M - i.y) * b + i.y)),
                                                Ha(),
                                                g ? (a.style.opacity = 1 - b) : Fa(m - b * m);
                                        };
                                    c ? db("initialZoom", 0, 1, j, e.easing.cubic.out, n, k) : (n(1), (Xb = setTimeout(k, j + 20)));
                                } else (s = b.initialZoomLevel), Ma(pa, b.initialPosition), Ha(), Fa(1), g ? (a.style.opacity = 1) : Fa(1), (Xb = setTimeout(k, j + 20));
                            },
                            d ? 25 : 90
                        ));
                };
                n();
            },
            dc = {},
            ec = [],
            fc = {
                index: 0,
                errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
                forceProgressiveLoading: !1,
                preload: [1, 1],
                getNumItemsFn: function () {
                    return Yb.length;
                },
            },
            gc = function () {
                return { center: { x: 0, y: 0 }, max: { x: 0, y: 0 }, min: { x: 0, y: 0 } };
            },
            hc = function (a, b, c) {
                var d = a.bounds;
                (d.center.x = Math.round((dc.x - b) / 2)),
                    (d.center.y = Math.round((dc.y - c) / 2) + a.vGap.top),
                    (d.max.x = b > dc.x ? Math.round(dc.x - b) : d.center.x),
                    (d.max.y = c > dc.y ? Math.round(dc.y - c) + a.vGap.top : d.center.y),
                    (d.min.x = b > dc.x ? 0 : d.center.x),
                    (d.min.y = c > dc.y ? a.vGap.top : d.center.y);
            },
            ic = function (a, b, c) {
                if (a.src && !a.loadError) {
                    var d = !c;
                    if ((d && (a.vGap || (a.vGap = { top: 0, bottom: 0 }), Da("parseVerticalMargin", a)), (dc.x = b.x), (dc.y = b.y - a.vGap.top - a.vGap.bottom), d)) {
                        var e = dc.x / a.w,
                            f = dc.y / a.h;
                        a.fitRatio = e < f ? e : f;
                        var g = i.scaleMode;
                        "orig" === g ? (c = 1) : "fit" === g && (c = a.fitRatio), c > 1 && (c = 1), (a.initialZoomLevel = c), a.bounds || (a.bounds = gc());
                    }
                    if (!c) return;
                    return hc(a, a.w * c, a.h * c), d && c === a.initialZoomLevel && (a.initialPosition = a.bounds.center), a.bounds;
                }
                return (a.w = a.h = 0), (a.initialZoomLevel = a.fitRatio = 1), (a.bounds = gc()), (a.initialPosition = a.bounds.center), a.bounds;
            },
            jc = function (a, b, c, d, e, g) {
                b.loadError ||
                    (d &&
                        ((b.imageAppended = !0),
                        mc(b, d, b === f.currItem && ya),
                        c.appendChild(d),
                        g &&
                            setTimeout(function () {
                                b && b.loaded && b.placeholder && ((b.placeholder.style.display = "none"), (b.placeholder = null));
                            }, 500)));
            },
            kc = function (a) {
                (a.loading = !0), (a.loaded = !1);
                var b = (a.img = e.createEl("pswp__img", "img")),
                    c = function () {
                        (a.loading = !1), (a.loaded = !0), a.loadComplete ? a.loadComplete(a) : (a.img = null), (b.onload = b.onerror = null), (b = null);
                    };
                return (
                    (b.onload = c),
                    (b.onerror = function () {
                        (a.loadError = !0), c();
                    }),
                    (b.src = a.src),
                    b
                );
            },
            lc = function (a, b) {
                if (a.src && a.loadError && a.container) return b && (a.container.innerHTML = ""), (a.container.innerHTML = i.errorMsg.replace("%url%", a.src)), !0;
            },
            mc = function (a, b, c) {
                if (a.src) {
                    b || (b = a.container.lastChild);
                    var d = c ? a.w : Math.round(a.w * a.fitRatio),
                        e = c ? a.h : Math.round(a.h * a.fitRatio);
                    a.placeholder && !a.loaded && ((a.placeholder.style.width = d + "px"), (a.placeholder.style.height = e + "px")), (b.style.width = d + "px"), (b.style.height = e + "px");
                }
            },
            nc = function () {
                if (ec.length) {
                    for (var a, b = 0; b < ec.length; b++) (a = ec[b]), a.holder.index === a.index && jc(a.index, a.item, a.baseDiv, a.img, !1, a.clearPlaceholder);
                    ec = [];
                }
            };
        za("Controller", {
            publicMethods: {
                lazyLoadItem: function (a) {
                    a = Aa(a);
                    var b = _b(a);
                    b && ((!b.loaded && !b.loading) || x) && (Da("gettingData", a, b), b.src && kc(b));
                },
                initController: function () {
                    e.extend(i, fc, !0),
                        (f.items = Yb = c),
                        (_b = f.getItemAt),
                        (ac = i.getNumItemsFn),
                        (bc = i.loop),
                        ac() < 3 && (i.loop = !1),
                        Ca("beforeChange", function (a) {
                            var b,
                                c = i.preload,
                                d = null === a || a >= 0,
                                e = Math.min(c[0], ac()),
                                g = Math.min(c[1], ac());
                            for (b = 1; b <= (d ? g : e); b++) f.lazyLoadItem(m + b);
                            for (b = 1; b <= (d ? e : g); b++) f.lazyLoadItem(m - b);
                        }),
                        Ca("initialLayout", function () {
                            f.currItem.initialLayout = i.getThumbBoundsFn && i.getThumbBoundsFn(m);
                        }),
                        Ca("mainScrollAnimComplete", nc),
                        Ca("initialZoomInEnd", nc),
                        Ca("destroy", function () {
                            for (var a, b = 0; b < Yb.length; b++)
                                (a = Yb[b]), a.container && (a.container = null), a.placeholder && (a.placeholder = null), a.img && (a.img = null), a.preloader && (a.preloader = null), a.loadError && (a.loaded = a.loadError = !1);
                            ec = null;
                        });
                },
                getItemAt: function (a) {
                    return a >= 0 && void 0 !== Yb[a] && Yb[a];
                },
                allowProgressiveImg: function () {
                    return i.forceProgressiveLoading || !G || i.mouseUsed || screen.width > 1200;
                },
                setContent: function (a, b) {
                    i.loop && (b = Aa(b));
                    var c = f.getItemAt(a.index);
                    c && (c.container = null);
                    var d,
                        g = f.getItemAt(b);
                    if (!g) return void (a.el.innerHTML = "");
                    Da("gettingData", b, g), (a.index = b), (a.item = g);
                    var h = (g.container = e.createEl("pswp__zoom-wrap"));
                    if ((!g.src && g.html && (g.html.tagName ? h.appendChild(g.html) : (h.innerHTML = g.html)), lc(g), ic(g, qa), !g.src || g.loadError || g.loaded))
                        g.src && !g.loadError && ((d = e.createEl("pswp__img", "img")), (d.style.opacity = 1), (d.src = g.src), mc(g, d), jc(b, g, h, d, !0));
                    else {
                        if (
                            ((g.loadComplete = function (c) {
                                if (j) {
                                    if (a && a.index === b) {
                                        if (lc(c, !0)) return (c.loadComplete = c.img = null), ic(c, qa), Ia(c), void (a.index === m && f.updateCurrZoomItem());
                                        c.imageAppended
                                            ? !$b && c.placeholder && ((c.placeholder.style.display = "none"), (c.placeholder = null))
                                            : N.transform && (fa || $b)
                                            ? ec.push({ item: c, baseDiv: h, img: c.img, index: b, holder: a, clearPlaceholder: !0 })
                                            : jc(b, c, h, c.img, fa || $b, !0);
                                    }
                                    (c.loadComplete = null), (c.img = null), Da("imageLoadComplete", b, c);
                                }
                            }),
                            e.features.transform)
                        ) {
                            var k = "pswp__img pswp__img--placeholder";
                            k += g.msrc ? "" : " pswp__img--placeholder--blank";
                            var l = e.createEl(k, g.msrc ? "img" : "");
                            g.msrc && (l.src = g.msrc), mc(g, l), h.appendChild(l), (g.placeholder = l);
                        }
                        g.loading || kc(g), f.allowProgressiveImg() && (!Zb && N.transform ? ec.push({ item: g, baseDiv: h, img: g.img, index: b, holder: a }) : jc(b, g, h, g.img, !0, !0));
                    }
                    Zb || b !== m ? Ia(g) : ((ea = h.style), cc(g, d || g.img)), (a.el.innerHTML = ""), a.el.appendChild(h);
                },
                cleanSlide: function (a) {
                    a.img && (a.img.onload = a.img.onerror = null), (a.loaded = a.loading = a.img = a.imageAppended = !1);
                },
            },
        });
        var oc,
            pc = {},
            qc = function (a, b, c) {
                var d = document.createEvent("CustomEvent"),
                    e = { origEvent: a, target: a.target, releasePoint: b, pointerType: c || "touch" };
                d.initCustomEvent("pswpTap", !0, !0, e), a.target.dispatchEvent(d);
            };
        za("Tap", {
            publicMethods: {
                initTap: function () {
                    Ca("firstTouchStart", f.onTapStart),
                        Ca("touchRelease", f.onTapRelease),
                        Ca("destroy", function () {
                            (pc = {}), (oc = null);
                        });
                },
                onTapStart: function (a) {
                    a.length > 1 && (clearTimeout(oc), (oc = null));
                },
                onTapRelease: function (a, b) {
                    if (b && !Y && !W && !_a) {
                        var c = b;
                        if (oc && (clearTimeout(oc), (oc = null), xb(c, pc))) return void Da("doubleTap", c);
                        if ("mouse" === b.type) return void qc(a, b, "mouse");
                        var d = a.target.tagName.toUpperCase();
                        if ("BUTTON" === d || e.hasClass(a.target, "pswp__single-tap")) return void qc(a, b);
                        Ma(pc, c),
                            (oc = setTimeout(function () {
                                qc(a, b), (oc = null);
                            }, 300));
                    }
                },
            },
        });
        var rc;
        za("DesktopZoom", {
            publicMethods: {
                initDesktopZoom: function () {
                    L ||
                        (G
                            ? Ca("mouseUsed", function () {
                                  f.setupDesktopZoom();
                              })
                            : f.setupDesktopZoom(!0));
                },
                setupDesktopZoom: function (b) {
                    rc = {};
                    var c = "wheel mousewheel DOMMouseScroll";
                    Ca("bindEvents", function () {
                        e.bind(a, c, f.handleMouseWheel);
                    }),
                        Ca("unbindEvents", function () {
                            rc && e.unbind(a, c, f.handleMouseWheel);
                        }),
                        (f.mouseZoomedIn = !1);
                    var d,
                        g = function () {
                            f.mouseZoomedIn && (e.removeClass(a, "pswp--zoomed-in"), (f.mouseZoomedIn = !1)), s < 1 ? e.addClass(a, "pswp--zoom-allowed") : e.removeClass(a, "pswp--zoom-allowed"), h();
                        },
                        h = function () {
                            d && (e.removeClass(a, "pswp--dragging"), (d = !1));
                        };
                    Ca("resize", g),
                        Ca("afterChange", g),
                        Ca("pointerDown", function () {
                            f.mouseZoomedIn && ((d = !0), e.addClass(a, "pswp--dragging"));
                        }),
                        Ca("pointerUp", h),
                        b || g();
                },
                handleMouseWheel: function (a) {
                    if (s <= f.currItem.fitRatio) return i.modal && (!i.closeOnScroll || _a || V ? a.preventDefault() : E && Math.abs(a.deltaY) > 2 && ((l = !0), f.close())), !0;
                    if ((a.stopPropagation(), (rc.x = 0), "deltaX" in a)) 1 === a.deltaMode ? ((rc.x = 18 * a.deltaX), (rc.y = 18 * a.deltaY)) : ((rc.x = a.deltaX), (rc.y = a.deltaY));
                    else if ("wheelDelta" in a) a.wheelDeltaX && (rc.x = -0.16 * a.wheelDeltaX), a.wheelDeltaY ? (rc.y = -0.16 * a.wheelDeltaY) : (rc.y = -0.16 * a.wheelDelta);
                    else {
                        if (!("detail" in a)) return;
                        rc.y = a.detail;
                    }
                    Sa(s, !0);
                    var b = pa.x - rc.x,
                        c = pa.y - rc.y;
                    (i.modal || (b <= da.min.x && b >= da.max.x && c <= da.min.y && c >= da.max.y)) && a.preventDefault(), f.panTo(b, c);
                },
                toggleDesktopZoom: function (b) {
                    b = b || { x: qa.x / 2 + sa.x, y: qa.y / 2 + sa.y };
                    var c = i.getDoubleTapZoom(!0, f.currItem),
                        d = s === c;
                    (f.mouseZoomedIn = !d), f.zoomTo(d ? f.currItem.initialZoomLevel : c, b, 333), e[(d ? "remove" : "add") + "Class"](a, "pswp--zoomed-in");
                },
            },
        });
        var sc,
            tc,
            uc,
            vc,
            wc,
            xc,
            yc,
            zc,
            Ac,
            Bc,
            Cc,
            Dc,
            Ec = { history: !0, galleryUID: 1 },
            Fc = function () {
                return Cc.hash.substring(1);
            },
            Gc = function () {
                sc && clearTimeout(sc), uc && clearTimeout(uc);
            },
            Hc = function () {
                var a = Fc(),
                    b = {};
                if (a.length < 5) return b;
                var c,
                    d = a.split("&");
                for (c = 0; c < d.length; c++)
                    if (d[c]) {
                        var e = d[c].split("=");
                        e.length < 2 || (b[e[0]] = e[1]);
                    }
                if (i.galleryPIDs) {
                    var f = b.pid;
                    for (b.pid = 0, c = 0; c < Yb.length; c++)
                        if (Yb[c].pid === f) {
                            b.pid = c;
                            break;
                        }
                } else b.pid = parseInt(b.pid, 10) - 1;
                return b.pid < 0 && (b.pid = 0), b;
            },
            Ic = function () {
                if ((uc && clearTimeout(uc), _a || V)) return void (uc = setTimeout(Ic, 500));
                vc ? clearTimeout(tc) : (vc = !0);
                var a = m + 1,
                    b = _b(m);
                b.hasOwnProperty("pid") && (a = b.pid);
                var c = yc + "&gid=" + i.galleryUID + "&pid=" + a;
                zc || (Cc.hash.indexOf(c) === -1 && (Bc = !0));
                var d = Cc.href.split("#")[0] + "#" + c;
                Dc ? "#" + c !== window.location.hash && history[zc ? "replaceState" : "pushState"]("", document.title, d) : zc ? Cc.replace(d) : (Cc.hash = c),
                    (zc = !0),
                    (tc = setTimeout(function () {
                        vc = !1;
                    }, 60));
            };
        za("History", {
            publicMethods: {
                initHistory: function () {
                    if ((e.extend(i, Ec, !0), i.history)) {
                        (Cc = window.location),
                            (Bc = !1),
                            (Ac = !1),
                            (zc = !1),
                            (yc = Fc()),
                            (Dc = "pushState" in history),
                            yc.indexOf("gid=") > -1 && ((yc = yc.split("&gid=")[0]), (yc = yc.split("?gid=")[0])),
                            Ca("afterChange", f.updateURL),
                            Ca("unbindEvents", function () {
                                e.unbind(window, "hashchange", f.onHashChange);
                            });
                        var a = function () {
                            (xc = !0), Ac || (Bc ? history.back() : yc ? (Cc.hash = yc) : Dc ? history.pushState("", document.title, Cc.pathname + Cc.search) : (Cc.hash = "")), Gc();
                        };
                        Ca("unbindEvents", function () {
                            l && a();
                        }),
                            Ca("destroy", function () {
                                xc || a();
                            }),
                            Ca("firstUpdate", function () {
                                m = Hc().pid;
                            });
                        var b = yc.indexOf("pid=");
                        b > -1 && ((yc = yc.substring(0, b)), "&" === yc.slice(-1) && (yc = yc.slice(0, -1))),
                            setTimeout(function () {
                                j && e.bind(window, "hashchange", f.onHashChange);
                            }, 40);
                    }
                },
                onHashChange: function () {
                    return Fc() === yc ? ((Ac = !0), void f.close()) : void (vc || ((wc = !0), f.goTo(Hc().pid), (wc = !1)));
                },
                updateURL: function () {
                    Gc(), wc || (zc ? (sc = setTimeout(Ic, 800)) : Ic());
                },
            },
        }),
            e.extend(f, eb);
    };
    return a;
});
!(function (a, b) {
    "function" == typeof define && define.amd ? define(b) : "object" == typeof exports ? (module.exports = b()) : (a.PhotoSwipeUI_Default = b());
})(this, function () {
    "use strict";
    var a = function (a, b) {
        var c,
            d,
            e,
            f,
            g,
            h,
            i,
            j,
            k,
            l,
            m,
            n,
            o,
            p,
            q,
            r,
            s,
            t,
            u,
            v = this,
            w = !1,
            x = !0,
            y = !0,
            z = {
                barsSize: { top: 44, bottom: "auto" },
                closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"],
                timeToIdle: 4e3,
                timeToIdleOutside: 1e3,
                loadingIndicatorDelay: 1e3,
                addCaptionHTMLFn: function (a, b) {
                    return a.title ? ((b.children[0].innerHTML = a.title), !0) : ((b.children[0].innerHTML = ""), !1);
                },
                closeEl: !0,
                captionEl: !0,
                fullscreenEl: !0,
                zoomEl: !0,
                shareEl: !0,
                counterEl: !0,
                arrowEl: !0,
                preloaderEl: !0,
                tapToClose: !1,
                tapToToggleControls: !0,
                clickToCloseNonZoomable: !0,
                shareButtons: [
                    { id: "facebook", label: "Share on Facebook", url: "https://www.facebook.com/sharer/sharer.php?u={{url}}" },
                    { id: "twitter", label: "Tweet", url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}" },
                    { id: "pinterest", label: "Pin it", url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}" },
                    { id: "download", label: "Download image", url: "{{raw_image_url}}", download: !0 },
                ],
                getImageURLForShare: function () {
                    return a.currItem.src || "";
                },
                getPageURLForShare: function () {
                    return window.location.href;
                },
                getTextForShare: function () {
                    return a.currItem.title || "";
                },
                indexIndicatorSep: " / ",
                fitControlsWidth: 1200,
            },
            A = function (a) {
                if (r) return !0;
                (a = a || window.event), q.timeToIdle && q.mouseUsed && !k && K();
                for (var c, d, e = a.target || a.srcElement, f = e.getAttribute("class") || "", g = 0; g < S.length; g++) (c = S[g]), c.onTap && f.indexOf("pswp__" + c.name) > -1 && (c.onTap(), (d = !0));
                if (d) {
                    a.stopPropagation && a.stopPropagation(), (r = !0);
                    var h = b.features.isOldAndroid ? 600 : 30;
                    s = setTimeout(function () {
                        r = !1;
                    }, h);
                }
            },
            B = function () {
                return !a.likelyTouchDevice || q.mouseUsed || screen.width > q.fitControlsWidth;
            },
            C = function (a, c, d) {
                b[(d ? "add" : "remove") + "Class"](a, "pswp__" + c);
            },
            D = function () {
                var a = 1 === q.getNumItemsFn();
                a !== p && (C(d, "ui--one-slide", a), (p = a));
            },
            E = function () {
                C(i, "share-modal--hidden", y);
            },
            F = function () {
                return (
                    (y = !y),
                    y
                        ? (b.removeClass(i, "pswp__share-modal--fade-in"),
                          setTimeout(function () {
                              y && E();
                          }, 300))
                        : (E(),
                          setTimeout(function () {
                              y || b.addClass(i, "pswp__share-modal--fade-in");
                          }, 30)),
                    y || H(),
                    !1
                );
            },
            G = function (b) {
                b = b || window.event;
                var c = b.target || b.srcElement;
                return (
                    a.shout("shareLinkClick", b, c),
                    !!c.href &&
                        (!!c.hasAttribute("download") ||
                            (window.open(c.href, "pswp_share", "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + (window.screen ? Math.round(screen.width / 2 - 275) : 100)), y || F(), !1))
                );
            },
            H = function () {
                for (var a, b, c, d, e, f = "", g = 0; g < q.shareButtons.length; g++)
                    (a = q.shareButtons[g]),
                        (c = q.getImageURLForShare(a)),
                        (d = q.getPageURLForShare(a)),
                        (e = q.getTextForShare(a)),
                        (b = a.url.replace("{{url}}", encodeURIComponent(d)).replace("{{image_url}}", encodeURIComponent(c)).replace("{{raw_image_url}}", c).replace("{{text}}", encodeURIComponent(e))),
                        (f += '<a href="' + b + '" target="_blank" class="pswp__share--' + a.id + '"' + (a.download ? "download" : "") + ">" + a.label + "</a>"),
                        q.parseShareButtonOut && (f = q.parseShareButtonOut(a, f));
                (i.children[0].innerHTML = f), (i.children[0].onclick = G);
            },
            I = function (a) {
                for (var c = 0; c < q.closeElClasses.length; c++) if (b.hasClass(a, "pswp__" + q.closeElClasses[c])) return !0;
            },
            J = 0,
            K = function () {
                clearTimeout(u), (J = 0), k && v.setIdle(!1);
            },
            L = function (a) {
                a = a ? a : window.event;
                var b = a.relatedTarget || a.toElement;
                (b && "HTML" !== b.nodeName) ||
                    (clearTimeout(u),
                    (u = setTimeout(function () {
                        v.setIdle(!0);
                    }, q.timeToIdleOutside)));
            },
            M = function () {
                q.fullscreenEl &&
                    !b.features.isOldAndroid &&
                    (c || (c = v.getFullscreenAPI()), c ? (b.bind(document, c.eventK, v.updateFullscreen), v.updateFullscreen(), b.addClass(a.template, "pswp--supports-fs")) : b.removeClass(a.template, "pswp--supports-fs"));
            },
            N = function () {
                q.preloaderEl &&
                    (O(!0),
                    l("beforeChange", function () {
                        clearTimeout(o),
                            (o = setTimeout(function () {
                                a.currItem && a.currItem.loading ? (!a.allowProgressiveImg() || (a.currItem.img && !a.currItem.img.naturalWidth)) && O(!1) : O(!0);
                            }, q.loadingIndicatorDelay));
                    }),
                    l("imageLoadComplete", function (b, c) {
                        a.currItem === c && O(!0);
                    }));
            },
            O = function (a) {
                n !== a && (C(m, "preloader--active", !a), (n = a));
            },
            P = function (a) {
                var c = a.vGap;
                if (B()) {
                    var g = q.barsSize;
                    if (q.captionEl && "auto" === g.bottom)
                        if ((f || ((f = b.createEl("pswp__caption pswp__caption--fake")), f.appendChild(b.createEl("pswp__caption__center")), d.insertBefore(f, e), b.addClass(d, "pswp__ui--fit")), q.addCaptionHTMLFn(a, f, !0))) {
                            var h = f.clientHeight;
                            c.bottom = parseInt(h, 10) || 44;
                        } else c.bottom = g.top;
                    else c.bottom = "auto" === g.bottom ? 0 : g.bottom;
                    c.top = g.top;
                } else c.top = c.bottom = 0;
            },
            Q = function () {
                q.timeToIdle &&
                    l("mouseUsed", function () {
                        b.bind(document, "mousemove", K),
                            b.bind(document, "mouseout", L),
                            (t = setInterval(function () {
                                J++, 2 === J && v.setIdle(!0);
                            }, q.timeToIdle / 2));
                    });
            },
            R = function () {
                l("onVerticalDrag", function (a) {
                    x && a < 0.95 ? v.hideControls() : !x && a >= 0.95 && v.showControls();
                });
                var a;
                l("onPinchClose", function (b) {
                    x && b < 0.9 ? (v.hideControls(), (a = !0)) : a && !x && b > 0.9 && v.showControls();
                }),
                    l("zoomGestureEnded", function () {
                        (a = !1), a && !x && v.showControls();
                    });
            },
            S = [
                {
                    name: "caption",
                    option: "captionEl",
                    onInit: function (a) {
                        e = a;
                    },
                },
                {
                    name: "share-modal",
                    option: "shareEl",
                    onInit: function (a) {
                        i = a;
                    },
                    onTap: function () {
                        F();
                    },
                },
                {
                    name: "button--share",
                    option: "shareEl",
                    onInit: function (a) {
                        h = a;
                    },
                    onTap: function () {
                        F();
                    },
                },
                { name: "button--zoom", option: "zoomEl", onTap: a.toggleDesktopZoom },
                {
                    name: "counter",
                    option: "counterEl",
                    onInit: function (a) {
                        g = a;
                    },
                },
                { name: "button--close", option: "closeEl", onTap: a.close },
                { name: "button--arrow--left", option: "arrowEl", onTap: a.prev },
                { name: "button--arrow--right", option: "arrowEl", onTap: a.next },
                {
                    name: "button--fs",
                    option: "fullscreenEl",
                    onTap: function () {
                        c.isFullscreen() ? c.exit() : c.enter();
                    },
                },
                {
                    name: "preloader",
                    option: "preloaderEl",
                    onInit: function (a) {
                        m = a;
                    },
                },
            ],
            T = function () {
                var a,
                    c,
                    e,
                    f = function (d) {
                        if (d)
                            for (var f = d.length, g = 0; g < f; g++) {
                                (a = d[g]), (c = a.className);
                                for (var h = 0; h < S.length; h++)
                                    (e = S[h]), c.indexOf("pswp__" + e.name) > -1 && (q[e.option] ? (b.removeClass(a, "pswp__element--disabled"), e.onInit && e.onInit(a)) : b.addClass(a, "pswp__element--disabled"));
                            }
                    };
                f(d.children);
                var g = b.getChildByClass(d, "pswp__top-bar");
                g && f(g.children);
            };
        (v.init = function () {
            b.extend(a.options, z, !0),
                (q = a.options),
                (d = b.getChildByClass(a.scrollWrap, "pswp__ui")),
                (l = a.listen),
                R(),
                l("beforeChange", v.update),
                l("doubleTap", function (b) {
                    var c = a.currItem.initialZoomLevel;
                    a.getZoomLevel() !== c ? a.zoomTo(c, b, 333) : a.zoomTo(q.getDoubleTapZoom(!1, a.currItem), b, 333);
                }),
                l("preventDragEvent", function (a, b, c) {
                    var d = a.target || a.srcElement;
                    d && d.getAttribute("class") && a.type.indexOf("mouse") > -1 && (d.getAttribute("class").indexOf("__caption") > 0 || /(SMALL|STRONG|EM)/i.test(d.tagName)) && (c.prevent = !1);
                }),
                l("bindEvents", function () {
                    b.bind(d, "pswpTap click", A), b.bind(a.scrollWrap, "pswpTap", v.onGlobalTap), a.likelyTouchDevice || b.bind(a.scrollWrap, "mouseover", v.onMouseOver);
                }),
                l("unbindEvents", function () {
                    y || F(),
                        t && clearInterval(t),
                        b.unbind(document, "mouseout", L),
                        b.unbind(document, "mousemove", K),
                        b.unbind(d, "pswpTap click", A),
                        b.unbind(a.scrollWrap, "pswpTap", v.onGlobalTap),
                        b.unbind(a.scrollWrap, "mouseover", v.onMouseOver),
                        c && (b.unbind(document, c.eventK, v.updateFullscreen), c.isFullscreen() && ((q.hideAnimationDuration = 0), c.exit()), (c = null));
                }),
                l("destroy", function () {
                    q.captionEl && (f && d.removeChild(f), b.removeClass(e, "pswp__caption--empty")), i && (i.children[0].onclick = null), b.removeClass(d, "pswp__ui--over-close"), b.addClass(d, "pswp__ui--hidden"), v.setIdle(!1);
                }),
                q.showAnimationDuration || b.removeClass(d, "pswp__ui--hidden"),
                l("initialZoomIn", function () {
                    q.showAnimationDuration && b.removeClass(d, "pswp__ui--hidden");
                }),
                l("initialZoomOut", function () {
                    b.addClass(d, "pswp__ui--hidden");
                }),
                l("parseVerticalMargin", P),
                T(),
                q.shareEl && h && i && (y = !0),
                D(),
                Q(),
                M(),
                N();
        }),
            (v.setIdle = function (a) {
                (k = a), C(d, "ui--idle", a);
            }),
            (v.update = function () {
                x && a.currItem ? (v.updateIndexIndicator(), q.captionEl && (q.addCaptionHTMLFn(a.currItem, e), C(e, "caption--empty", !a.currItem.title)), (w = !0)) : (w = !1), y || F(), D();
            }),
            (v.updateFullscreen = function (d) {
                d &&
                    setTimeout(function () {
                        a.setScrollOffset(0, b.getScrollY());
                    }, 50),
                    b[(c.isFullscreen() ? "add" : "remove") + "Class"](a.template, "pswp--fs");
            }),
            (v.updateIndexIndicator = function () {
                q.counterEl && (g.innerHTML = a.getCurrentIndex() + 1 + q.indexIndicatorSep + q.getNumItemsFn());
            }),
            (v.onGlobalTap = function (c) {
                c = c || window.event;
                var d = c.target || c.srcElement;
                if (!r)
                    if (c.detail && "mouse" === c.detail.pointerType) {
                        if (I(d)) return void a.close();
                        b.hasClass(d, "pswp__img") && (1 === a.getZoomLevel() && a.getZoomLevel() <= a.currItem.fitRatio ? q.clickToCloseNonZoomable && a.close() : a.toggleDesktopZoom(c.detail.releasePoint));
                    } else if ((q.tapToToggleControls && (x ? v.hideControls() : v.showControls()), q.tapToClose && (b.hasClass(d, "pswp__img") || I(d)))) return void a.close();
            }),
            (v.onMouseOver = function (a) {
                a = a || window.event;
                var b = a.target || a.srcElement;
                C(d, "ui--over-close", I(b));
            }),
            (v.hideControls = function () {
                b.addClass(d, "pswp__ui--hidden"), (x = !1);
            }),
            (v.showControls = function () {
                (x = !0), w || v.update(), b.removeClass(d, "pswp__ui--hidden");
            }),
            (v.supportsFullscreen = function () {
                var a = document;
                return !!(a.exitFullscreen || a.mozCancelFullScreen || a.webkitExitFullscreen || a.msExitFullscreen);
            }),
            (v.getFullscreenAPI = function () {
                var b,
                    c = document.documentElement,
                    d = "fullscreenchange";
                return (
                    c.requestFullscreen
                        ? (b = { enterK: "requestFullscreen", exitK: "exitFullscreen", elementK: "fullscreenElement", eventK: d })
                        : c.mozRequestFullScreen
                        ? (b = { enterK: "mozRequestFullScreen", exitK: "mozCancelFullScreen", elementK: "mozFullScreenElement", eventK: "moz" + d })
                        : c.webkitRequestFullscreen
                        ? (b = { enterK: "webkitRequestFullscreen", exitK: "webkitExitFullscreen", elementK: "webkitFullscreenElement", eventK: "webkit" + d })
                        : c.msRequestFullscreen && (b = { enterK: "msRequestFullscreen", exitK: "msExitFullscreen", elementK: "msFullscreenElement", eventK: "MSFullscreenChange" }),
                    b &&
                        ((b.enter = function () {
                            return (j = q.closeOnScroll), (q.closeOnScroll = !1), "webkitRequestFullscreen" !== this.enterK ? a.template[this.enterK]() : void a.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT);
                        }),
                        (b.exit = function () {
                            return (q.closeOnScroll = j), document[this.exitK]();
                        }),
                        (b.isFullscreen = function () {
                            return document[this.elementK];
                        })),
                    b
                );
            });
    };
    return a;
});
/*! Sticky-kit v1.1.2 */
(function () {
    var t, i;
    (t = this.jQuery || window.jQuery),
        (i = t(window)),
        (t.fn.stick_in_parent = function (o) {
            var s, e, n, r, c, l, a, f, p, u, h;
            for (
                null == o && (o = {}),
                    h = o.sticky_class,
                    c = o.inner_scrolling,
                    u = o.recalc_every,
                    p = o.parent,
                    f = o.offset_top,
                    a = o.spacer,
                    e = o.bottoming,
                    null == f && (f = 0),
                    null == p && (p = void 0),
                    null == c && (c = !0),
                    null == h && (h = "is_stuck"),
                    s = t(document),
                    null == e && (e = !0),
                    n = function (o, n, r, l, d, g, k, m) {
                        var v, y, _, b, w, x, C, I, z, A, j, M;
                        if (!o.data("sticky_kit")) {
                            if ((o.data("sticky_kit", !0), (w = s.height()), (C = o.parent()), null != p && (C = C.closest(p)), !C.length)) throw "failed to find stick parent";
                            if (
                                ((v = _ = !1),
                                (j = null != a ? a && o.closest(a) : t("<div />")) && j.css("position", o.css("position")),
                                (I = function () {
                                    var t, i, e;
                                    if (
                                        !m &&
                                        ((w = s.height()),
                                        (t = parseInt(C.css("border-top-width"), 10)),
                                        (i = parseInt(C.css("padding-top"), 10)),
                                        (n = parseInt(C.css("padding-bottom"), 10)),
                                        (r = C.offset().top + t + i),
                                        (l = C.height()),
                                        _ && ((v = _ = !1), null == a && (o.insertAfter(j), j.detach()), o.css({ position: "", top: "", width: "", bottom: "" }).removeClass(h), (e = !0)),
                                        (d = o.offset().top - (parseInt(o.css("margin-top"), 10) || 0) - f),
                                        (g = o.outerHeight(!0)),
                                        (k = o.css("float")),
                                        j && j.css({ width: o.outerWidth(!0), height: g, display: o.css("display"), "vertical-align": o.css("vertical-align"), float: k }),
                                        e)
                                    )
                                        return M();
                                })(),
                                g !== l)
                            )
                                return (
                                    (b = void 0),
                                    (x = f),
                                    (A = u),
                                    (M = function () {
                                        var t, p, y, z;
                                        if (
                                            !m &&
                                            ((y = !1),
                                            null != A && 0 >= --A && ((A = u), I(), (y = !0)),
                                            y || s.height() === w || I(),
                                            (y = i.scrollTop()),
                                            null != b && (p = y - b),
                                            (b = y),
                                            _
                                                ? (e && ((z = y + g + x > l + r), v && !z && ((v = !1), o.css({ position: "fixed", bottom: "", top: x }).trigger("sticky_kit:unbottom"))),
                                                  y < d &&
                                                      ((_ = !1),
                                                      (x = f),
                                                      null == a && (("left" !== k && "right" !== k) || o.insertAfter(j), j.detach()),
                                                      (t = { position: "", width: "", top: "" }),
                                                      o.css(t).removeClass(h).trigger("sticky_kit:unstick")),
                                                  c && ((t = i.height()), g + f > t && !v && ((x -= p), (x = Math.max(t - g, x)), (x = Math.min(f, x)), _ && o.css({ top: x + "px" }))))
                                                : y > d &&
                                                  ((_ = !0),
                                                  ((t = { position: "fixed", top: x }).width = "border-box" === o.css("box-sizing") ? o.outerWidth() + "px" : o.width() + "px"),
                                                  o.css(t).addClass(h),
                                                  null == a && (o.after(j), ("left" !== k && "right" !== k) || j.append(o)),
                                                  o.trigger("sticky_kit:stick")),
                                            _ && e && (null == z && (z = y + g + x > l + r), !v && z))
                                        )
                                            return (v = !0), "static" === C.css("position") && C.css({ position: "relative" }), o.css({ position: "absolute", bottom: n, top: "auto" }).trigger("sticky_kit:bottom");
                                    }),
                                    (z = function () {
                                        return I(), M();
                                    }),
                                    (y = function () {
                                        if (
                                            ((m = !0),
                                            i.off("touchmove", M),
                                            i.off("scroll", M),
                                            i.off("resize", z),
                                            t(document.body).off("sticky_kit:recalc", z),
                                            o.off("sticky_kit:detach", y),
                                            o.removeData("sticky_kit"),
                                            o.css({ position: "", bottom: "", top: "", width: "" }),
                                            C.position("position", ""),
                                            _)
                                        )
                                            return null == a && (("left" !== k && "right" !== k) || o.insertAfter(j), j.remove()), o.removeClass(h);
                                    }),
                                    i.on("touchmove", M),
                                    i.on("scroll", M),
                                    i.on("resize", z),
                                    t(document.body).on("sticky_kit:recalc", z),
                                    o.on("sticky_kit:detach", y),
                                    setTimeout(M, 0)
                                );
                        }
                    },
                    r = 0,
                    l = this.length;
                r < l;
                r++
            )
                (o = this[r]), n(t(o));
            return this;
        });
}.call(this));
/*! Countdown for jQuery v2.1.0 */
!(function () {
    "use strict";
    var t = !1;
    (window.JQClass = function () {}),
        (JQClass.classes = {}),
        (JQClass.extend = function e(n) {
            function a() {
                !t && this._init && this._init.apply(this, arguments);
            }
            var s = this.prototype;
            t = !0;
            var i = new this();
            for (var r in ((t = !1), n))
                if ("function" == typeof n[r] && "function" == typeof s[r])
                    i[r] = (function (t, e) {
                        return function () {
                            var n = this._super;
                            this._super = function (e) {
                                return s[t].apply(this, e || []);
                            };
                            var a = e.apply(this, arguments);
                            return (this._super = n), a;
                        };
                    })(r, n[r]);
                else if ("object" == typeof n[r] && "object" == typeof s[r] && "defaultOptions" === r) {
                    var o,
                        u = s[r],
                        c = n[r],
                        h = {};
                    for (o in u) h[o] = u[o];
                    for (o in c) h[o] = c[o];
                    i[r] = h;
                } else i[r] = n[r];
            return (a.prototype = i), (a.prototype.constructor = a), (a.extend = e), a;
        });
})(),
    (function ($) {
        "use strict";
        function camelCase(t) {
            return t.replace(/-([a-z])/g, function (t, e) {
                return e.toUpperCase();
            });
        }
        (JQClass.classes.JQPlugin = JQClass.extend({
            name: "plugin",
            defaultOptions: {},
            regionalOptions: {},
            deepMerge: !0,
            _getMarker: function () {
                return "is-" + this.name;
            },
            _init: function () {
                $.extend(this.defaultOptions, (this.regionalOptions && this.regionalOptions[""]) || {});
                var t = camelCase(this.name);
                ($[t] = this),
                    ($.fn[t] = function (e) {
                        var n = Array.prototype.slice.call(arguments, 1),
                            a = this,
                            s = this;
                        return (
                            this.each(function () {
                                if ("string" == typeof e) {
                                    if ("_" === e[0] || !$[t][e]) throw "Unknown method: " + e;
                                    var i = $[t][e].apply($[t], [this].concat(n));
                                    if (i !== a && void 0 !== i) return (s = i), !1;
                                } else $[t]._attach(this, e);
                            }),
                            s
                        );
                    });
            },
            setDefaults: function (t) {
                $.extend(this.defaultOptions, t || {});
            },
            _attach: function (t, e) {
                if (!(t = $(t)).hasClass(this._getMarker())) {
                    t.addClass(this._getMarker()), (e = $.extend(this.deepMerge, {}, this.defaultOptions, this._getMetadata(t), e || {}));
                    var n = $.extend({ name: this.name, elem: t, options: e }, this._instSettings(t, e));
                    t.data(this.name, n), this._postAttach(t, n), this.option(t, e);
                }
            },
            _instSettings: function (t, e) {
                return {};
            },
            _postAttach: function (t, e) {},
            _getMetadata: function (elem) {
                try {
                    var data = elem.data(this.name.toLowerCase()) || "";
                    for (var key in ((data = data
                        .replace(/(\\?)'/g, function (t, e) {
                            return e ? "'" : '"';
                        })
                        .replace(/([a-zA-Z0-9]+):/g, function (t, e, n) {
                            var a = data.substring(0, n).match(/"/g);
                            return a && a.length % 2 != 0 ? e + ":" : '"' + e + '":';
                        })
                        .replace(/\\:/g, ":")),
                    (data = $.parseJSON("{" + data + "}")),
                    data))
                        if (data.hasOwnProperty(key)) {
                            var value = data[key];
                            "string" == typeof value && value.match(/^new Date\(([-0-9,\s]*)\)$/) && (data[key] = eval(value));
                        }
                    return data;
                } catch (t) {
                    return {};
                }
            },
            _getInst: function (t) {
                return $(t).data(this.name) || {};
            },
            option: function (t, e, n) {
                var a = (t = $(t)).data(this.name),
                    s = e || {};
                return !e || ("string" == typeof e && void 0 === n)
                    ? (s = (a || {}).options) && e
                        ? s[e]
                        : s
                    : void (t.hasClass(this._getMarker()) && ("string" == typeof e && ((s = {}), (s[e] = n)), this._optionsChanged(t, a, s), $.extend(a.options, s)));
            },
            _optionsChanged: function (t, e, n) {},
            destroy: function (t) {
                (t = $(t)).hasClass(this._getMarker()) && (this._preDestroy(t, this._getInst(t)), t.removeData(this.name).removeClass(this._getMarker()));
            },
            _preDestroy: function (t, e) {},
        })),
            ($.JQPlugin = {
                createPlugin: function (t, e) {
                    "object" == typeof t && ((e = t), (t = "JQPlugin")), (t = camelCase(t));
                    var n = camelCase(e.name);
                    (JQClass.classes[n] = JQClass.classes[t].extend(e)), new JQClass.classes[n]();
                },
            });
    })(jQuery);
!(function (e) {
    "use strict";
    var i = "countdown";
    e.JQPlugin.createPlugin({
        name: i,
        defaultOptions: {
            until: null,
            since: null,
            timezone: null,
            serverSync: null,
            format: "dHMS",
            layout: "",
            compact: !1,
            padZeroes: !1,
            significant: 0,
            description: "",
            expiryUrl: "",
            expiryText: "",
            alwaysExpire: !1,
            onExpiry: null,
            onTick: null,
            tickInterval: 1,
        },
        regionalOptions: {
            "": {
                labels: ["Years", "Months", "Weeks", "Days", "Hours", "Minutes", "Seconds"],
                labels1: ["Year", "Month", "Week", "Day", "Hour", "Minute", "Second"],
                compactLabels: ["y", "m", "w", "d"],
                whichLabels: null,
                digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
                timeSeparator: ":",
                isRTL: !1,
            },
        },
        _rtlClass: i + "-rtl",
        _sectionClass: i + "-section",
        _amountClass: i + "-amount",
        _periodClass: i + "-period",
        _rowClass: i + "-row",
        _holdingClass: i + "-holding",
        _showClass: i + "-show",
        _descrClass: i + "-descr",
        _timerElems: [],
        _init: function () {
            var i = this;
            this._super(), (this._serverSyncs = []);
            var t =
                    "function" == typeof Date.now
                        ? Date.now
                        : function () {
                              return new Date().getTime();
                          },
                s = window.performance && "function" == typeof window.performance.now,
                n = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || null,
                o = 0;
            !n || e.noRequestAnimationFrame
                ? ((e.noRequestAnimationFrame = null),
                  (e.countdown._timer = setInterval(function () {
                      i._updateElems();
                  }, 1e3)))
                : ((o = window.animationStartTime || window.webkitAnimationStartTime || window.mozAnimationStartTime || window.oAnimationStartTime || window.msAnimationStartTime || t()),
                  n(function e(r) {
                      var a = r < 1e12 ? (s ? window.performance.now() + window.performance.timing.navigationStart : t()) : r || t();
                      a - o >= 1e3 && (i._updateElems(), (o = a)), n(e);
                  }));
        },
        UTCDate: function (e, i, t, s, n, o, r, a) {
            "object" == typeof i && i instanceof Date && ((a = i.getMilliseconds()), (r = i.getSeconds()), (o = i.getMinutes()), (n = i.getHours()), (s = i.getDate()), (t = i.getMonth()), (i = i.getFullYear()));
            var l = new Date();
            return (
                l.setUTCFullYear(i), l.setUTCDate(1), l.setUTCMonth(t || 0), l.setUTCDate(s || 1), l.setUTCHours(n || 0), l.setUTCMinutes((o || 0) - (Math.abs(e) < 30 ? 60 * e : e)), l.setUTCSeconds(r || 0), l.setUTCMilliseconds(a || 0), l
            );
        },
        periodsToSeconds: function (e) {
            return 31557600 * e[0] + 2629800 * e[1] + 604800 * e[2] + 86400 * e[3] + 3600 * e[4] + 60 * e[5] + e[6];
        },
        resync: function () {
            var i = this;
            e("." + this._getMarker()).each(function () {
                var t = e.data(this, i.name);
                if (t.options.serverSync) {
                    for (var s = null, n = 0; n < i._serverSyncs.length; n++)
                        if (i._serverSyncs[n][0] === t.options.serverSync) {
                            s = i._serverSyncs[n];
                            break;
                        }
                    if (i._eqNull(s[2])) {
                        var o = e.isFunction(t.options.serverSync) ? t.options.serverSync.apply(this, []) : null;
                        s[2] = (o ? new Date().getTime() - o.getTime() : 0) - s[1];
                    }
                    t._since && t._since.setMilliseconds(t._since.getMilliseconds() + s[2]), t._until.setMilliseconds(t._until.getMilliseconds() + s[2]);
                }
            });
            for (var t = 0; t < i._serverSyncs.length; t++) i._eqNull(i._serverSyncs[t][2]) || ((i._serverSyncs[t][1] += i._serverSyncs[t][2]), delete i._serverSyncs[t][2]);
        },
        _instSettings: function (e, i) {
            return { _periods: [0, 0, 0, 0, 0, 0, 0] };
        },
        _addElem: function (e) {
            this._hasElem(e) || this._timerElems.push(e);
        },
        _hasElem: function (i) {
            return e.inArray(i, this._timerElems) > -1;
        },
        _removeElem: function (i) {
            this._timerElems = e.map(this._timerElems, function (e) {
                return e === i ? null : e;
            });
        },
        _updateElems: function () {
            for (var e = this._timerElems.length - 1; e >= 0; e--) this._updateCountdown(this._timerElems[e]);
        },
        _optionsChanged: function (i, t, s) {
            s.layout && (s.layout = s.layout.replace(/&lt;/g, "<").replace(/&gt;/g, ">")), this._resetExtraLabels(t.options, s);
            var n = t.options.timezone !== s.timezone;
            e.extend(t.options, s), this._adjustSettings(i, t, !this._eqNull(s.until) || !this._eqNull(s.since) || n);
            var o = new Date();
            ((t._since && t._since < o) || (t._until && t._until > o)) && this._addElem(i[0]), this._updateCountdown(i, t);
        },
        _updateCountdown: function (i, t) {
            if (((i = i.jquery ? i : e(i)), (t = t || this._getInst(i)))) {
                if ((i.html(this._generateHTML(t)).toggleClass(this._rtlClass, t.options.isRTL), "pause" !== t._hold && e.isFunction(t.options.onTick))) {
                    var s = "lap" !== t._hold ? t._periods : this._calculatePeriods(t, t._show, t.options.significant, new Date());
                    (1 !== t.options.tickInterval && this.periodsToSeconds(s) % t.options.tickInterval != 0) || t.options.onTick.apply(i[0], [s]);
                }
                if ("pause" !== t._hold && (t._since ? t._now.getTime() < t._since.getTime() : t._now.getTime() >= t._until.getTime()) && !t._expiring) {
                    if (((t._expiring = !0), this._hasElem(i[0]) || t.options.alwaysExpire)) {
                        if ((this._removeElem(i[0]), e.isFunction(t.options.onExpiry) && t.options.onExpiry.apply(i[0], []), t.options.expiryText)) {
                            var n = t.options.layout;
                            (t.options.layout = t.options.expiryText), this._updateCountdown(i[0], t), (t.options.layout = n);
                        }
                        t.options.expiryUrl && (window.location = t.options.expiryUrl);
                    }
                    t._expiring = !1;
                } else "pause" === t._hold && this._removeElem(i[0]);
            }
        },
        _resetExtraLabels: function (e, i) {
            var t = null;
            for (t in i) t.match(/[Ll]abels[02-9]|compactLabels1/) && (e[t] = i[t]);
            for (t in e) t.match(/[Ll]abels[02-9]|compactLabels1/) && void 0 === i[t] && (e[t] = null);
        },
        _eqNull: function (e) {
            return null == e;
        },
        _adjustSettings: function (i, t, s) {
            for (var n = null, o = 0; o < this._serverSyncs.length; o++)
                if (this._serverSyncs[o][0] === t.options.serverSync) {
                    n = this._serverSyncs[o][1];
                    break;
                }
            var r = null,
                a = null;
            if (this._eqNull(n)) {
                var l = e.isFunction(t.options.serverSync) ? t.options.serverSync.apply(i[0], []) : null;
                (r = new Date()), (a = l ? r.getTime() - l.getTime() : 0), this._serverSyncs.push([t.options.serverSync, a]);
            } else (r = new Date()), (a = t.options.serverSync ? n : 0);
            var _ = t.options.timezone;
            (_ = this._eqNull(_) ? -r.getTimezoneOffset() : _),
                (s || (!s && this._eqNull(t._until) && this._eqNull(t._since))) &&
                    ((t._since = t.options.since),
                    this._eqNull(t._since) || ((t._since = this.UTCDate(_, this._determineTime(t._since, null))), t._since && a && t._since.setMilliseconds(t._since.getMilliseconds() + a)),
                    (t._until = this.UTCDate(_, this._determineTime(t.options.until, r))),
                    a && t._until.setMilliseconds(t._until.getMilliseconds() + a)),
                (t._show = this._determineShow(t));
        },
        _preDestroy: function (e, i) {
            this._removeElem(e[0]), e.empty();
        },
        pause: function (e) {
            this._hold(e, "pause");
        },
        lap: function (e) {
            this._hold(e, "lap");
        },
        resume: function (e) {
            this._hold(e, null);
        },
        toggle: function (i) {
            this[(e.data(i, this.name) || {})._hold ? "resume" : "pause"](i);
        },
        toggleLap: function (i) {
            this[(e.data(i, this.name) || {})._hold ? "resume" : "lap"](i);
        },
        _hold: function (i, t) {
            var s = e.data(i, this.name);
            if (s) {
                if ("pause" === s._hold && !t) {
                    s._periods = s._savePeriods;
                    var n = s._since ? "-" : "+";
                    (s[s._since ? "_since" : "_until"] = this._determineTime(
                        n + s._periods[0] + "y" + n + s._periods[1] + "o" + n + s._periods[2] + "w" + n + s._periods[3] + "d" + n + s._periods[4] + "h" + n + s._periods[5] + "m" + n + s._periods[6] + "s"
                    )),
                        this._addElem(i);
                }
                (s._hold = t), (s._savePeriods = "pause" === t ? s._periods : null), e.data(i, this.name, s), this._updateCountdown(i, s);
            }
        },
        getTimes: function (i) {
            var t = e.data(i, this.name);
            return t ? ("pause" === t._hold ? t._savePeriods : t._hold ? this._calculatePeriods(t, t._show, t.options.significant, new Date()) : t._periods) : null;
        },
        _determineTime: function (e, i) {
            var t,
                s,
                n = this,
                o = this._eqNull(e)
                    ? i
                    : "string" == typeof e
                    ? (function (e) {
                          e = e.toLowerCase();
                          for (var i = new Date(), t = i.getFullYear(), s = i.getMonth(), o = i.getDate(), r = i.getHours(), a = i.getMinutes(), l = i.getSeconds(), _ = /([+-]?[0-9]+)\s*(s|m|h|d|w|o|y)?/g, p = _.exec(e); p; ) {
                              switch (p[2] || "s") {
                                  case "s":
                                      l += parseInt(p[1], 10);
                                      break;
                                  case "m":
                                      a += parseInt(p[1], 10);
                                      break;
                                  case "h":
                                      r += parseInt(p[1], 10);
                                      break;
                                  case "d":
                                      o += parseInt(p[1], 10);
                                      break;
                                  case "w":
                                      o += 7 * parseInt(p[1], 10);
                                      break;
                                  case "o":
                                      (s += parseInt(p[1], 10)), (o = Math.min(o, n._getDaysInMonth(t, s)));
                                      break;
                                  case "y":
                                      (t += parseInt(p[1], 10)), (o = Math.min(o, n._getDaysInMonth(t, s)));
                              }
                              p = _.exec(e);
                          }
                          return new Date(t, s, o, r, a, l, 0);
                      })(e)
                    : "number" == typeof e
                    ? ((t = e), (s = new Date()).setTime(s.getTime() + 1e3 * t), s)
                    : e;
            return o && o.setMilliseconds(0), o;
        },
        _getDaysInMonth: function (e, i) {
            return 32 - new Date(e, i, 32).getDate();
        },
        _normalLabels: function (e) {
            return e;
        },
        _generateHTML: function (i) {
            var t = this;
            i._periods = i._hold ? i._periods : this._calculatePeriods(i, i._show, i.options.significant, new Date());
            var s = !1,
                n = 0,
                o = i.options.significant,
                r = e.extend({}, i._show),
                a = null;
            for (a = 0; a <= 6; a++) (s = s || ("?" === i._show[a] && i._periods[a] > 0)), (r[a] = "?" !== i._show[a] || s ? i._show[a] : null), (n += r[a] ? 1 : 0), (o -= i._periods[a] > 0 ? 1 : 0);
            var l = [!1, !1, !1, !1, !1, !1, !1];
            for (a = 6; a >= 0; a--) i._show[a] && (i._periods[a] ? (l[a] = !0) : ((l[a] = o > 0), o--));
            var _ = i.options.compact ? i.options.compactLabels : i.options.labels,
                p = i.options.whichLabels || this._normalLabels,
                c = function (e) {
                    var s = i.options["compactLabels" + p(i._periods[e])];
                    return r[e] ? t._translateDigits(i, i._periods[e]) + (s ? s[e] : _[e]) + " " : "";
                },
                u = i.options.padZeroes ? 2 : 1,
                h = function (e) {
                    var s = i.options["labels" + p(i._periods[e])];
                    return (!i.options.significant && r[e]) || (i.options.significant && l[e])
                        ? '<span class="' + t._sectionClass + '"><span class="' + t._amountClass + '">' + t._minDigits(i, i._periods[e], u) + '</span><span class="' + t._periodClass + '">' + (s ? s[e] : _[e]) + "</span></span>"
                        : "";
                };
            return i.options.layout
                ? this._buildLayout(i, r, i.options.layout, i.options.compact, i.options.significant, l)
                : (i.options.compact
                      ? '<span class="' +
                        this._rowClass +
                        " " +
                        this._amountClass +
                        (i._hold ? " " + this._holdingClass : "") +
                        '">' +
                        c(0) +
                        c(1) +
                        c(2) +
                        c(3) +
                        (r[4] ? this._minDigits(i, i._periods[4], 2) : "") +
                        (r[5] ? (r[4] ? i.options.timeSeparator : "") + this._minDigits(i, i._periods[5], 2) : "") +
                        (r[6] ? (r[4] || r[5] ? i.options.timeSeparator : "") + this._minDigits(i, i._periods[6], 2) : "")
                      : '<span class="' + this._rowClass + " " + this._showClass + (i.options.significant || n) + (i._hold ? " " + this._holdingClass : "") + '">' + h(0) + h(1) + h(2) + h(3) + h(4) + h(5) + h(6)) +
                      "</span>" +
                      (i.options.description ? '<span class="' + this._rowClass + " " + this._descrClass + '">' + i.options.description + "</span>" : "");
        },
        _buildLayout: function (i, t, s, n, o, r) {
            for (
                var a = i.options[n ? "compactLabels" : "labels"],
                    l = i.options.whichLabels || this._normalLabels,
                    _ = function (e) {
                        return (i.options[(n ? "compactLabels" : "labels") + l(i._periods[e])] || a)[e];
                    },
                    p = function (e, t) {
                        return i.options.digits[Math.floor(e / t) % 10];
                    },
                    c = {
                        desc: i.options.description,
                        sep: i.options.timeSeparator,
                        yl: _(0),
                        yn: this._minDigits(i, i._periods[0], 1),
                        ynn: this._minDigits(i, i._periods[0], 2),
                        ynnn: this._minDigits(i, i._periods[0], 3),
                        y1: p(i._periods[0], 1),
                        y10: p(i._periods[0], 10),
                        y100: p(i._periods[0], 100),
                        y1000: p(i._periods[0], 1e3),
                        ol: _(1),
                        on: this._minDigits(i, i._periods[1], 1),
                        onn: this._minDigits(i, i._periods[1], 2),
                        onnn: this._minDigits(i, i._periods[1], 3),
                        o1: p(i._periods[1], 1),
                        o10: p(i._periods[1], 10),
                        o100: p(i._periods[1], 100),
                        o1000: p(i._periods[1], 1e3),
                        wl: _(2),
                        wn: this._minDigits(i, i._periods[2], 1),
                        wnn: this._minDigits(i, i._periods[2], 2),
                        wnnn: this._minDigits(i, i._periods[2], 3),
                        w1: p(i._periods[2], 1),
                        w10: p(i._periods[2], 10),
                        w100: p(i._periods[2], 100),
                        w1000: p(i._periods[2], 1e3),
                        dl: _(3),
                        dn: this._minDigits(i, i._periods[3], 1),
                        dnn: this._minDigits(i, i._periods[3], 2),
                        dnnn: this._minDigits(i, i._periods[3], 3),
                        d1: p(i._periods[3], 1),
                        d10: p(i._periods[3], 10),
                        d100: p(i._periods[3], 100),
                        d1000: p(i._periods[3], 1e3),
                        hl: _(4),
                        hn: this._minDigits(i, i._periods[4], 1),
                        hnn: this._minDigits(i, i._periods[4], 2),
                        hnnn: this._minDigits(i, i._periods[4], 3),
                        h1: p(i._periods[4], 1),
                        h10: p(i._periods[4], 10),
                        h100: p(i._periods[4], 100),
                        h1000: p(i._periods[4], 1e3),
                        ml: _(5),
                        mn: this._minDigits(i, i._periods[5], 1),
                        mnn: this._minDigits(i, i._periods[5], 2),
                        mnnn: this._minDigits(i, i._periods[5], 3),
                        m1: p(i._periods[5], 1),
                        m10: p(i._periods[5], 10),
                        m100: p(i._periods[5], 100),
                        m1000: p(i._periods[5], 1e3),
                        sl: _(6),
                        sn: this._minDigits(i, i._periods[6], 1),
                        snn: this._minDigits(i, i._periods[6], 2),
                        snnn: this._minDigits(i, i._periods[6], 3),
                        s1: p(i._periods[6], 1),
                        s10: p(i._periods[6], 10),
                        s100: p(i._periods[6], 100),
                        s1000: p(i._periods[6], 1e3),
                    },
                    u = s,
                    h = 0;
                h <= 6;
                h++
            ) {
                var d = "yowdhms".charAt(h),
                    m = new RegExp("\\{" + d + "<\\}([\\s\\S]*)\\{" + d + ">\\}", "g");
                u = u.replace(m, (!o && t[h]) || (o && r[h]) ? "$1" : "");
            }
            return (
                e.each(c, function (e, i) {
                    var t = new RegExp("\\{" + e + "\\}", "g");
                    u = u.replace(t, i);
                }),
                u
            );
        },
        _minDigits: function (e, i, t) {
            return (i = "" + i).length >= t ? this._translateDigits(e, i) : ((i = "0000000000" + i), this._translateDigits(e, i.substr(i.length - t)));
        },
        _translateDigits: function (e, i) {
            return ("" + i).replace(/[0-9]/g, function (i) {
                return e.options.digits[i];
            });
        },
        _determineShow: function (e) {
            var i = e.options.format,
                t = [];
            return (
                (t[0] = i.match("y") ? "?" : i.match("Y") ? "!" : null),
                (t[1] = i.match("o") ? "?" : i.match("O") ? "!" : null),
                (t[2] = i.match("w") ? "?" : i.match("W") ? "!" : null),
                (t[3] = i.match("d") ? "?" : i.match("D") ? "!" : null),
                (t[4] = i.match("h") ? "?" : i.match("H") ? "!" : null),
                (t[5] = i.match("m") ? "?" : i.match("M") ? "!" : null),
                (t[6] = i.match("s") ? "?" : i.match("S") ? "!" : null),
                t
            );
        },
        _calculatePeriods: function (e, i, t, s) {
            (e._now = s), e._now.setMilliseconds(0);
            var n = new Date(e._now.getTime());
            e._since ? (s.getTime() < e._since.getTime() ? (e._now = s = n) : (s = e._since)) : (n.setTime(e._until.getTime()), s.getTime() > e._until.getTime() && (e._now = s = n));
            var o = [0, 0, 0, 0, 0, 0, 0];
            if (i[0] || i[1]) {
                var r = this._getDaysInMonth(s.getFullYear(), s.getMonth()),
                    a = this._getDaysInMonth(n.getFullYear(), n.getMonth()),
                    l = n.getDate() === s.getDate() || (n.getDate() >= Math.min(r, a) && s.getDate() >= Math.min(r, a)),
                    _ = function (e) {
                        return 60 * (60 * e.getHours() + e.getMinutes()) + e.getSeconds();
                    },
                    p = Math.max(0, 12 * (n.getFullYear() - s.getFullYear()) + n.getMonth() - s.getMonth() + ((n.getDate() < s.getDate() && !l) || (l && _(n) < _(s)) ? -1 : 0));
                (o[0] = i[0] ? Math.floor(p / 12) : 0), (o[1] = i[1] ? p - 12 * o[0] : 0);
                var c = (s = new Date(s.getTime())).getDate() === r,
                    u = this._getDaysInMonth(s.getFullYear() + o[0], s.getMonth() + o[1]);
                s.getDate() > u && s.setDate(u), s.setFullYear(s.getFullYear() + o[0]), s.setMonth(s.getMonth() + o[1]), c && s.setDate(u);
            }
            var h = Math.floor((n.getTime() - s.getTime()) / 1e3),
                d = null,
                m = function (e, t) {
                    (o[e] = i[e] ? Math.floor(h / t) : 0), (h -= o[e] * t);
                };
            if ((m(2, 604800), m(3, 86400), m(4, 3600), m(5, 60), m(6, 1), h > 0 && !e._since)) {
                var g = [1, 12, 4.3482, 7, 24, 60, 60],
                    w = 6,
                    f = 1;
                for (d = 6; d >= 0; d--) i[d] && (o[w] >= f && ((o[w] = 0), (h = 1)), h > 0 && (o[d]++, (h = 0), (w = d), (f = 1))), (f *= g[d]);
            }
            if (t) for (d = 0; d <= 6; d++) t && o[d] ? t-- : t || (o[d] = 0);
            return o;
        },
    });
})(jQuery);
/*! Imagesloaded */
!(function (e, t) {
    "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", t) : "object" == typeof module && module.exports ? (module.exports = t()) : (e.EvEmitter = t());
})("undefined" != typeof window ? window : this, function () {
    function e() {}
    var t = e.prototype;
    return (
        (t.on = function (e, t) {
            if (e && t) {
                var i = (this._events = this._events || {}),
                    n = (i[e] = i[e] || []);
                return -1 == n.indexOf(t) && n.push(t), this;
            }
        }),
        (t.once = function (e, t) {
            if (e && t) {
                this.on(e, t);
                var i = (this._onceEvents = this._onceEvents || {}),
                    n = (i[e] = i[e] || {});
                return (n[t] = !0), this;
            }
        }),
        (t.off = function (e, t) {
            var i = this._events && this._events[e];
            if (i && i.length) {
                var n = i.indexOf(t);
                return -1 != n && i.splice(n, 1), this;
            }
        }),
        (t.emitEvent = function (e, t) {
            var i = this._events && this._events[e];
            if (i && i.length) {
                var n = 0,
                    o = i[n];
                t = t || [];
                for (var r = this._onceEvents && this._onceEvents[e]; o; ) {
                    var s = r && r[o];
                    s && (this.off(e, o), delete r[o]), o.apply(this, t), (n += s ? 0 : 1), (o = i[n]);
                }
                return this;
            }
        }),
        (t.allOff = t.removeAllListeners = function () {
            delete this._events, delete this._onceEvents;
        }),
        e
    );
}),
    (function (e, t) {
        "use strict";
        "function" == typeof define && define.amd
            ? define(["ev-emitter/ev-emitter"], function (i) {
                  return t(e, i);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = t(e, require("ev-emitter")))
            : (e.imagesLoaded = t(e, e.EvEmitter));
    })("undefined" != typeof window ? window : this, function (e, t) {
        function i(e, t) {
            for (var i in t) e[i] = t[i];
            return e;
        }
        function n(e) {
            var t = [];
            if (Array.isArray(e)) t = e;
            else if ("number" == typeof e.length) for (var i = 0; i < e.length; i++) t.push(e[i]);
            else t.push(e);
            return t;
        }
        function o(e, t, r) {
            return this instanceof o
                ? ("string" == typeof e && (e = document.querySelectorAll(e)),
                  (this.elements = n(e)),
                  (this.options = i({}, this.options)),
                  "function" == typeof t ? (r = t) : i(this.options, t),
                  r && this.on("always", r),
                  this.getImages(),
                  h && (this.jqDeferred = new h.Deferred()),
                  void setTimeout(
                      function () {
                          this.check();
                      }.bind(this)
                  ))
                : new o(e, t, r);
        }
        function r(e) {
            this.img = e;
        }
        function s(e, t) {
            (this.url = e), (this.element = t), (this.img = new Image());
        }
        var h = e.jQuery,
            a = e.console;
        (o.prototype = Object.create(t.prototype)),
            (o.prototype.options = {}),
            (o.prototype.getImages = function () {
                (this.images = []), this.elements.forEach(this.addElementImages, this);
            }),
            (o.prototype.addElementImages = function (e) {
                "IMG" == e.nodeName && this.addImage(e), this.options.background === !0 && this.addElementBackgroundImages(e);
                var t = e.nodeType;
                if (t && d[t]) {
                    for (var i = e.querySelectorAll("img"), n = 0; n < i.length; n++) {
                        var o = i[n];
                        this.addImage(o);
                    }
                    if ("string" == typeof this.options.background) {
                        var r = e.querySelectorAll(this.options.background);
                        for (n = 0; n < r.length; n++) {
                            var s = r[n];
                            this.addElementBackgroundImages(s);
                        }
                    }
                }
            });
        var d = { 1: !0, 9: !0, 11: !0 };
        return (
            (o.prototype.addElementBackgroundImages = function (e) {
                var t = getComputedStyle(e);
                if (t)
                    for (var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(t.backgroundImage); null !== n; ) {
                        var o = n && n[2];
                        o && this.addBackground(o, e), (n = i.exec(t.backgroundImage));
                    }
            }),
            (o.prototype.addImage = function (e) {
                var t = new r(e);
                this.images.push(t);
            }),
            (o.prototype.addBackground = function (e, t) {
                var i = new s(e, t);
                this.images.push(i);
            }),
            (o.prototype.check = function () {
                function e(e, i, n) {
                    setTimeout(function () {
                        t.progress(e, i, n);
                    });
                }
                var t = this;
                return (
                    (this.progressedCount = 0),
                    (this.hasAnyBroken = !1),
                    this.images.length
                        ? void this.images.forEach(function (t) {
                              t.once("progress", e), t.check();
                          })
                        : void this.complete()
                );
            }),
            (o.prototype.progress = function (e, t, i) {
                this.progressedCount++,
                    (this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded),
                    this.emitEvent("progress", [this, e, t]),
                    this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, e),
                    this.progressedCount == this.images.length && this.complete(),
                    this.options.debug && a && a.log("progress: " + i, e, t);
            }),
            (o.prototype.complete = function () {
                var e = this.hasAnyBroken ? "fail" : "done";
                if (((this.isComplete = !0), this.emitEvent(e, [this]), this.emitEvent("always", [this]), this.jqDeferred)) {
                    var t = this.hasAnyBroken ? "reject" : "resolve";
                    this.jqDeferred[t](this);
                }
            }),
            (r.prototype = Object.create(t.prototype)),
            (r.prototype.check = function () {
                var e = this.getIsImageComplete();
                return e
                    ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth")
                    : ((this.proxyImage = new Image()),
                      this.proxyImage.addEventListener("load", this),
                      this.proxyImage.addEventListener("error", this),
                      this.img.addEventListener("load", this),
                      this.img.addEventListener("error", this),
                      void (this.proxyImage.src = this.img.src));
            }),
            (r.prototype.getIsImageComplete = function () {
                return this.img.complete && void 0 !== this.img.naturalWidth;
            }),
            (r.prototype.confirm = function (e, t) {
                (this.isLoaded = e), this.emitEvent("progress", [this, this.img, t]);
            }),
            (r.prototype.handleEvent = function (e) {
                var t = "on" + e.type;
                this[t] && this[t](e);
            }),
            (r.prototype.onload = function () {
                this.confirm(!0, "onload"), this.unbindEvents();
            }),
            (r.prototype.onerror = function () {
                this.confirm(!1, "onerror"), this.unbindEvents();
            }),
            (r.prototype.unbindEvents = function () {
                this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
            }),
            (s.prototype = Object.create(r.prototype)),
            (s.prototype.check = function () {
                this.img.addEventListener("load", this), this.img.addEventListener("error", this), (this.img.src = this.url);
                var e = this.getIsImageComplete();
                e && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents());
            }),
            (s.prototype.unbindEvents = function () {
                this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
            }),
            (s.prototype.confirm = function (e, t) {
                (this.isLoaded = e), this.emitEvent("progress", [this, this.element, t]);
            }),
            (o.makeJQueryPlugin = function (t) {
                (t = t || e.jQuery),
                    t &&
                        ((h = t),
                        (h.fn.imagesLoaded = function (e, t) {
                            var i = new o(this, e, t);
                            return i.jqDeferred.promise(h(this));
                        }));
            }),
            o.makeJQueryPlugin(),
            o
        );
    });
/*! Masonry Animate */
!(function (s) {
    "use strict";
    function i(t, i) {
        (this.element = t), (this.$element = s(t)), (this.settings = s.extend({}, n, i)), (this._defaults = n), (this._name = e), this.init();
    }
    var e = "RoarMasonryAnimate",
        n = { columns: ".masonry-animation-column", items: ".masonry-animation-item", respEl: ".masonry-animation-split", moveEl: ".masonry-animation-move", offset: 0.2 },
        t = s(window);
    s.extend(i.prototype, {
        init: function () {
            (this.$cols = this.$element.find(this.settings.columns)),
                (this.$respEl = this.$element.find(this.settings.respEl)),
                (this.$moveEl = this.$element.find(this.settings.moveEl)),
                t.on("scroll resize", this.update.bind(this)),
                t.on("resize", this._responsive.bind(this)),
                this._responsive();
        },
        update: function () {
            if (window.innerWidth < 992) return this.$cols.css(window._jcsspfx + "Transform", "none"), void (this.element.style.marginBottom = 0);
            var e;
            this.$cols.each(
                function (t, i) {
                    return e ? void (e.offsetHeight > i.offsetHeight && (e = i)) : void (e = i);
                }.bind(this)
            ),
                (this.element.style.marginBottom = e.offsetHeight - e.parentNode.offsetHeight + "px");
            var n = e.getBoundingClientRect(),
                o = window.innerHeight - window.innerHeight * this.settings.offset - n.top,
                h = o / n.height;
            this.$cols.each(
                function (t, i) {
                    var s;
                    (s = i !== e ? (i.offsetHeight - 50 * t - n.height) * h : -0.03 * o), (i.style[window._jcsspfx + "Transform"] = "translateY(" + -s + "px)"), (i.style[window._jcsspfx + "TransitionDuration"] = 900 + 200 * t + "ms");
                }.bind(this)
            );
        },
        _responsive: function () {
            window.innerWidth < 992
                ? (this.$respEl.removeClass("hide"), this.$moveEl.find(this.settings.items).appendTo(this.$respEl), this.$moveEl.addClass("hide"))
                : (this.$moveEl.removeClass("hide"),
                  this.$moveEl.find(this.settings.columns).each(
                      function (t, i) {
                          this.$respEl
                              .find(this.settings.items)
                              .filter(function () {
                                  return s(this).data("column_num") == t + 1;
                              })
                              .appendTo(i);
                      }.bind(this)
                  ),
                  this.$respEl.addClass("hide"));
        },
    }),
        (s.fn[e] = function (t) {
            return this.each(function () {
                s.data(this, "plugin_" + e) || s.data(this, "plugin_" + e, new i(this, t));
            });
        });
})(jQuery);
function getVendorPrefix() {
    if ("result" in arguments.callee) return arguments.callee.result;
    var e = /^(Moz|Webkit|Khtml|O|ms|Icab)(?=[A-Z])/,
        t = document.getElementsByTagName("script")[0];
    for (var l in t.style) if (e.test(l)) return (arguments.callee.result = l.match(e)[0]);
    return (arguments.callee.result = "WebkitOpacity" in t.style ? "Webkit" : "KhtmlOpacity" in t.style ? "Khtml" : "");
}
window._jcsspfx = getVendorPrefix();
/*! TiltFx */
!(function (t, n) {
    "function" == typeof define && define.amd ? define([], n) : "object" == typeof module && module.exports ? (module.exports = n()) : (t.anime = n());
})(this, function () {
    var f,
        e,
        t,
        n,
        r,
        i = { duration: 1e3, delay: 0, loop: !1, autoplay: !0, direction: "normal", easing: "easeOutElastic", elasticity: 400, round: !1, begin: void 0, update: void 0, complete: void 0 },
        a = "translateX translateY translateZ rotate rotateX rotateY rotateZ scale scaleX scaleY scaleZ skewX skewY".split(" "),
        c = {
            arr: function (t) {
                return Array.isArray(t);
            },
            obj: function (t) {
                return -1 < Object.prototype.toString.call(t).indexOf("Object");
            },
            svg: function (t) {
                return t instanceof SVGElement;
            },
            dom: function (t) {
                return t.nodeType || c.svg(t);
            },
            num: function (t) {
                return !isNaN(parseInt(t));
            },
            str: function (t) {
                return "string" == typeof t;
            },
            fnc: function (t) {
                return "function" == typeof t;
            },
            und: function (t) {
                return void 0 === t;
            },
            nul: function (t) {
                return "null" == typeof t;
            },
            hex: function (t) {
                return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(t);
            },
            rgb: function (t) {
                return /^rgb/.test(t);
            },
            hsl: function (t) {
                return /^hsl/.test(t);
            },
            col: function (t) {
                return c.hex(t) || c.rgb(t) || c.hsl(t);
            },
        },
        s =
            ((n = {}),
            (r = {
                Sine: function (t) {
                    return 1 - Math.cos((t * Math.PI) / 2);
                },
                Circ: function (t) {
                    return 1 - Math.sqrt(1 - t * t);
                },
                Elastic: function (t, n) {
                    if (0 === t || 1 === t) return t;
                    var e = 1 - Math.min(n, 998) / 1e3,
                        r = t / 1 - 1;
                    return -Math.pow(2, 10 * r) * Math.sin((2 * (r - (e / (2 * Math.PI)) * Math.asin(1)) * Math.PI) / e);
                },
                Back: function (t) {
                    return t * t * (3 * t - 2);
                },
                Bounce: function (t) {
                    for (var n, e = 4; t < ((n = Math.pow(2, --e)) - 1) / 11; );
                    return 1 / Math.pow(4, 3 - e) - 7.5625 * Math.pow((3 * n - 2) / 22 - t, 2);
                },
            }),
            ["Quad", "Cubic", "Quart", "Quint", "Expo"].forEach(function (t, n) {
                r[t] = function (t) {
                    return Math.pow(t, n + 2);
                };
            }),
            Object.keys(r).forEach(function (t) {
                var e = r[t];
                (n["easeIn" + t] = e),
                    (n["easeOut" + t] = function (t, n) {
                        return 1 - e(1 - t, n);
                    }),
                    (n["easeInOut" + t] = function (t, n) {
                        return t < 0.5 ? e(2 * t, n) / 2 : 1 - e(-2 * t + 2, n) / 2;
                    }),
                    (n["easeOutIn" + t] = function (t, n) {
                        return t < 0.5 ? (1 - e(1 - 2 * t, n)) / 2 : (e(2 * t - 1, n) + 1) / 2;
                    });
            }),
            (n.linear = function (t) {
                return t;
            }),
            n),
        o = function (t) {
            return c.str(t) ? t : t + "";
        },
        u = function (t) {
            return t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
        },
        l = function (t) {
            if (c.col(t)) return !1;
            try {
                return document.querySelectorAll(t);
            } catch (t) {
                return !1;
            }
        },
        d = function (t) {
            return t.reduce(function (t, n) {
                return t.concat(c.arr(n) ? d(n) : n);
            }, []);
        },
        p = function (t) {
            return c.arr(t) ? t : (c.str(t) && (t = l(t) || t), t instanceof NodeList || t instanceof HTMLCollection ? [].slice.call(t) : [t]);
        },
        m = function (t, n) {
            return t.some(function (t) {
                return t === n;
            });
        },
        h = function (t) {
            return t.filter(function (t, n, e) {
                return e.indexOf(t) === n;
            });
        },
        g = function (t) {
            var n,
                e = {};
            for (n in t) e[n] = t[n];
            return e;
        },
        v = function (t, n) {
            for (var e in n) t[e] = c.und(t[e]) ? n[e] : t[e];
            return t;
        },
        y = function (t) {
            return /([\+\-]?[0-9|auto\.]+)(%|px|pt|em|rem|in|cm|mm|ex|pc|vw|vh|deg)?/.exec(t)[2];
        },
        b = function (t, n, e) {
            return y(n) ? n : -1 < t.indexOf("translate") ? (y(e) ? n + y(e) : n + "px") : -1 < t.indexOf("rotate") || -1 < t.indexOf("skew") ? n + "deg" : n;
        },
        x = function (t, n) {
            if (n in t.style) return getComputedStyle(t).getPropertyValue(u(n)) || "0";
        },
        w = function (t, n) {
            return c.dom(t) && m(a, n) ? "transform" : c.dom(t) && (t.getAttribute(n) || (c.svg(t) && t[n])) ? "attribute" : c.dom(t) && "transform" !== n && x(t, n) ? "css" : c.nul(t[n]) || c.und(t[n]) ? void 0 : "object";
        },
        M = function (t, n) {
            switch (w(t, n)) {
                case "transform":
                    return (function (t, e) {
                        var n = -1 < e.indexOf("scale") ? 1 : 0,
                            r = t.style.transform;
                        if (!r) return n;
                        for (var a = /(\w+)\((.+?)\)/g, o = [], u = [], i = []; (o = a.exec(r)); ) u.push(o[1]), i.push(o[2]);
                        return (r = i.filter(function (t, n) {
                            return u[n] === e;
                        })).length
                            ? r[0]
                            : n;
                    })(t, n);
                case "css":
                    return x(t, n);
                case "attribute":
                    return t.getAttribute(n);
            }
            return t[n] || 0;
        },
        O = function (t, n, e) {
            return c.col(n)
                ? (n = c.rgb(n)
                      ? n
                      : c.hex(n)
                      ? (function (t) {
                            t = t.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (t, n, e, r) {
                                return n + n + e + e + r + r;
                            });
                            var n = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
                            return "rgb(" + (t = parseInt(n[1], 16)) + "," + parseInt(n[2], 16) + "," + (n = parseInt(n[3], 16)) + ")";
                        })(n)
                      : c.hsl(n)
                      ? (function (t) {
                            t = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(t);
                            var n = parseInt(t[1]) / 360,
                                e = parseInt(t[2]) / 100,
                                r = parseInt(t[3]) / 100;
                            if (
                                ((t = function (t, n, e) {
                                    return e < 0 && (e += 1), 1 < e && --e, e < 1 / 6 ? t + 6 * (n - t) * e : e < 0.5 ? n : e < 2 / 3 ? t + (n - t) * (2 / 3 - e) * 6 : t;
                                }),
                                0 == e)
                            )
                                e = r = n = r;
                            else {
                                var a = r < 0.5 ? r * (1 + e) : r + e - r * e,
                                    o = 2 * r - a;
                                (e = t(o, a, n + 1 / 3)), (r = t(o, a, n)), (n = t(o, a, n - 1 / 3));
                            }
                            return "rgb(" + 255 * e + "," + 255 * r + "," + 255 * n + ")";
                        })(n)
                      : void 0)
                : y(n)
                ? n
                : (!(t = y(t.to) ? y(t.to) : y(t.from)) && e && (t = y(e)), t ? n + t : n);
        },
        k = function (t) {
            var n = /-?\d*\.?\d+/g;
            return { original: t, numbers: o(t).match(n) ? o(t).match(n).map(Number) : [0], strings: o(t).split(n) };
        },
        E = function (t, n, e, r) {
            return "transform" === e ? ((e = t + "(" + b(t, n.from, n.to) + ")"), (n = t + "(" + b(t, n.to) + ")")) : ((t = "css" === e ? x(r, t) : void 0), (e = O(n, n.from, t)), (n = O(n, n.to, t))), { from: k(e), to: k(n) };
        },
        I = function (t, n) {
            var i,
                e,
                s,
                r,
                a,
                o,
                u =
                    ((e = n),
                    (s = []),
                    (i = t).forEach(function (a, o) {
                        var u = a.target;
                        return e.forEach(function (t) {
                            var n = w(u, t.name);
                            if (n) {
                                var e;
                                e = t.name;
                                var r = t.value;
                                (e = { from: 1 < (r = p(c.fnc(r) ? r(u, o) : r)).length ? r[0] : M(u, e), to: 1 < r.length ? r[1] : r[0] }),
                                    ((r = g(t)).animatables = a),
                                    (r.type = n),
                                    (r.from = E(t.name, e, r.type, u).from),
                                    (r.to = E(t.name, e, r.type, u).to),
                                    (r.round = c.col(e.from) || r.round ? 1 : 0),
                                    (r.delay = (c.fnc(r.delay) ? r.delay(u, o, i.length) : r.delay) / N.speed),
                                    (r.duration = (c.fnc(r.duration) ? r.duration(u, o, i.length) : r.duration) / N.speed),
                                    s.push(r);
                            }
                        });
                    }),
                    s);
            return ((r = u),
            (a = ["name", "from", "to", "delay", "duration"]),
            (o = {}),
            r.forEach(function (n) {
                var t = JSON.stringify(
                    a.map(function (t) {
                        return n[t];
                    })
                );
                (o[t] = o[t] || []), o[t].push(n);
            }),
            Object.keys(o).map(function (t) {
                return o[t];
            })).map(function (t) {
                var n = g(t[0]);
                return (
                    (n.animatables = t.map(function (t) {
                        return t.animatables;
                    })),
                    (n.totalDuration = n.delay + n.duration),
                    n
                );
            });
        },
        A = function (r, a) {
            r.tweens.forEach(function (t) {
                var n = t.from,
                    e = r.duration - (t.delay + t.duration);
                (t.from = t.to), (t.to = n), a && (t.delay = e);
            }),
                (r.reversed = !r.reversed);
        },
        j = function (t) {
            var n = [],
                e = [];
            return (
                t.tweens.forEach(function (t) {
                    ("css" !== t.type && "transform" !== t.type) ||
                        (n.push("css" === t.type ? u(t.name) : "transform"),
                        t.animatables.forEach(function (t) {
                            e.push(t.target);
                        }));
                }),
                { properties: h(n).join(", "), elements: h(e) }
            );
        },
        P = function (a, t) {
            var r,
                n,
                o,
                u = Math.min(Math.max(t - a.delay, 0), a.duration) / a.duration,
                e = a.to.numbers.map(function (t, n) {
                    var e = a.from.numbers[n],
                        r = s[a.easing](u, a.elasticity);
                    e = a.path
                        ? (function (n, e) {
                              var r = n.path,
                                  a = n.value * e,
                                  t = (u = function (t) {
                                      return (t = t || 0), r.getPointAtLength(1 < e ? n.value + t : a + t);
                                  })(),
                                  o = u(-1),
                                  u = u(1);
                              switch (n.name) {
                                  case "translateX":
                                      return t.x;
                                  case "translateY":
                                      return t.y;
                                  case "rotate":
                                      return (180 * Math.atan2(u.y - o.y, u.x - o.x)) / Math.PI;
                              }
                          })(a, r)
                        : e + r * (t - e);
                    return a.round ? Math.round(e * a.round) / a.round : e;
                });
            return (
                (r = e),
                (n = a.to.strings),
                (o = a.from.strings),
                n.reduce(function (t, n, e) {
                    return (n = n || o[e - 1]), t + r[e - 1] + n;
                })
            );
        },
        C = function (t, n) {
            var e;
            (t.currentTime = n), (t.progress = (n / t.duration) * 100);
            for (var r = 0; r < t.tweens.length; r++) {
                var a = t.tweens[r];
                a.currentValue = P(a, n);
                for (var o = a.currentValue, u = 0; u < a.animatables.length; u++) {
                    var i = (s = a.animatables[u]).id,
                        s = s.target,
                        c = a.name;
                    switch (a.type) {
                        case "css":
                            s.style[c] = o;
                            break;
                        case "attribute":
                            s.setAttribute(c, o);
                            break;
                        case "object":
                            s[c] = o;
                            break;
                        case "transform":
                            e || (e = {}), e[i] || (e[i] = []), e[i].push(o);
                    }
                }
            }
            if (e) for (r in (f || (f = (x(document.body, "transform") ? "" : "-webkit-") + "transform"), e)) t.animatables[r].target.style[f] = e[r].join(" ");
            t.settings.update && t.settings.update(t);
        },
        S = function (t) {
            var n,
                e = {};
            (e.animatables = (n = (n = t.targets) ? d(c.arr(n) ? n.map(p) : p(n)) : []).map(function (t, n) {
                return { target: t, id: n };
            })),
                (e.settings = v(t, i));
            var r,
                a = e.settings,
                o = [];
            for (r in t)
                if (!i.hasOwnProperty(r) && "targets" !== r) {
                    var u = c.obj(t[r]) ? g(t[r]) : { value: t[r] };
                    (u.name = r), o.push(v(u, a));
                }
            return (
                (e.properties = o),
                (e.tweens = I(e.animatables, e.properties)),
                (e.duration =
                    (function (t) {
                        if (t.length)
                            return Math.max.apply(
                                Math,
                                t.map(function (t) {
                                    return t.totalDuration;
                                })
                            );
                    })(e.tweens) || t.duration),
                (e.currentTime = 0),
                (e.progress = 0),
                (e.ended = !1),
                e
            );
        },
        T = [],
        $ = 0,
        L =
            ((e = function () {
                $ = requestAnimationFrame(t);
            }),
            (t = function (t) {
                if (T.length) {
                    for (var n = 0; n < T.length; n++) T[n].tick(t);
                    e();
                } else cancelAnimationFrame($), ($ = 0);
            }),
            e),
        N = function (t) {
            var e = S(t),
                r = {};
            return (
                (e.tick = function (t) {
                    (e.ended = !1), r.start || (r.start = t), (r.current = Math.min(Math.max(r.last + t - r.start, 0), e.duration)), C(e, r.current);
                    var n = e.settings;
                    n.begin && r.current >= n.delay && (n.begin(e), (n.begin = void 0)),
                        r.current >= e.duration && (n.loop ? ((r.start = t), "alternate" === n.direction && A(e, !0), c.num(n.loop) && n.loop--) : ((e.ended = !0), e.pause(), n.complete && n.complete(e)), (r.last = 0));
                }),
                (e.seek = function (t) {
                    C(e, (t / 100) * e.duration);
                }),
                (e.pause = function () {
                    j(e).elements.forEach(function (t) {
                        t.style.removeProperty("will-change");
                    });
                    var t = T.indexOf(e);
                    -1 < t && T.splice(t, 1);
                }),
                (e.play = function (t) {
                    var n;
                    e.pause(),
                        t && (e = v(S(v(t, e.settings)), e)),
                        (r.start = 0),
                        (r.last = e.ended ? 0 : e.currentTime),
                        "reverse" === (t = e.settings).direction && A(e),
                        "alternate" !== t.direction || t.loop || (t.loop = 1),
                        (n = j(e)).elements.forEach(function (t) {
                            t.style.willChange = n.properties;
                        }),
                        T.push(e),
                        $ || L();
                }),
                (e.restart = function () {
                    e.reversed && A(e), e.pause(), e.seek(0), e.play();
                }),
                e.settings.autoplay && e.play(),
                e
            );
        };
    return (
        (N.version = "1.1.1"),
        (N.speed = 1),
        (N.list = T),
        (N.remove = function (t) {
            t = d(c.arr(t) ? t.map(p) : p(t));
            for (var n = T.length - 1; 0 <= n; n--)
                for (var e = T[n], r = e.tweens, a = r.length - 1; 0 <= a; a--) for (var o = r[a].animatables, u = o.length - 1; 0 <= u; u--) m(t, o[u].target) && (o.splice(u, 1), o.length || r.splice(a, 1), r.length || e.pause());
        }),
        (N.easings = s),
        (N.getValue = M),
        (N.path = function (t) {
            return { path: (t = c.str(t) ? l(t)[0] : t), value: t.getTotalLength() };
        }),
        (N.random = function (t, n) {
            return Math.floor(Math.random() * (n - t + 1)) + t;
        }),
        N
    );
});
!(function (v) {
    "use strict";
    function n(t, e) {
        for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
        return t;
    }
    function t(t, e) {
        (this.DOM = {}), (this.DOM.el = t), (this.options = n({}, this.options)), n(this.options, e), this._init();
    }
    (t.prototype.options = {
        movement: {
            imgWrapper: { translation: { x: 0, y: 0, z: 0 }, rotation: { x: -5, y: 5, z: 0 }, reverseAnimation: { duration: 1200, easing: "easeOutElastic", elasticity: 600 } },
            lines: { translation: { x: 10, y: 10, z: [0, 10] }, reverseAnimation: { duration: 1e3, easing: "easeOutExpo", elasticity: 600 } },
            caption: { translation: { x: 20, y: 20, z: 0 }, rotation: { x: 0, y: 0, z: 0 }, reverseAnimation: { duration: 1500, easing: "easeOutElastic", elasticity: 600 } },
            shine: { translation: { x: 50, y: 50, z: 0 }, reverseAnimation: { duration: 1200, easing: "easeOutElastic", elasticity: 600 } },
        },
    }),
        (t.prototype._init = function () {
            (this.DOM.animatable = {}),
                (this.DOM.animatable.imgWrapper = this.DOM.el.querySelector(".tilter__figure")),
                (this.DOM.animatable.lines = this.DOM.el.querySelector(".tilter__deco--lines")),
                (this.DOM.animatable.caption = this.DOM.el.querySelector(".tilter__caption")),
                (this.DOM.animatable.overlay = this.DOM.el.querySelector(".tilter__deco--overlay")),
                (this.DOM.animatable.shine = this.DOM.el.querySelector(".tilter__deco--shine > div")),
                this._initEvents();
        }),
        (t.prototype._initEvents = function () {
            var e = this;
            (this.mouseenterFn = function () {
                for (var t in e.DOM.animatable) anime.remove(e.DOM.animatable[t]);
            }),
                (this.mousemoveFn = function (t) {
                    requestAnimationFrame(function () {
                        e._layout(t);
                    });
                }),
                (this.mouseleaveFn = function (t) {
                    requestAnimationFrame(function () {
                        for (var t in e.DOM.animatable)
                            null != e.options.movement[t] &&
                                anime({
                                    targets: e.DOM.animatable[t],
                                    duration: null != e.options.movement[t].reverseAnimation ? e.options.movement[t].reverseAnimation.duration || 0 : 1,
                                    easing: (null != e.options.movement[t].reverseAnimation && e.options.movement[t].reverseAnimation.easing) || "linear",
                                    elasticity: (null != e.options.movement[t].reverseAnimation && e.options.movement[t].reverseAnimation.elasticity) || null,
                                    scaleX: 1,
                                    scaleY: 1,
                                    scaleZ: 1,
                                    translateX: 0,
                                    translateY: 0,
                                    translateZ: 0,
                                    rotateX: 0,
                                    rotateY: 0,
                                    rotateZ: 0,
                                });
                    });
                }),
                this.DOM.el.addEventListener("mousemove", this.mousemoveFn),
                this.DOM.el.addEventListener("mouseleave", this.mouseleaveFn),
                this.DOM.el.addEventListener("mouseenter", this.mouseenterFn);
        }),
        (t.prototype._layout = function (t) {
            var e = (function (t) {
                    var e = 0,
                        n = 0;
                    t || (t = v.event);
                    return (
                        t.pageX || t.pageY
                            ? ((e = t.pageX), (n = t.pageY))
                            : (t.clientX || t.clientY) && ((e = t.clientX + document.body.scrollLeft + document.documentElement.scrollLeft), (n = t.clientY + document.body.scrollTop + document.documentElement.scrollTop)),
                        { x: e, y: n }
                    );
                })(t),
                n = document.body.scrollLeft + document.documentElement.scrollLeft,
                i = document.body.scrollTop + document.documentElement.scrollTop,
                o = this.DOM.el.getBoundingClientRect(),
                a = e.x - o.left - n,
                s = e.y - o.top - i;
            for (var r in this.DOM.animatable)
                if (null != this.DOM.animatable[r] && null != this.options.movement[r]) {
                    var l = (null != this.options.movement[r] && this.options.movement[r].translation) || { x: 0, y: 0, z: 0 },
                        m = (null != this.options.movement[r] && this.options.movement[r].rotation) || { x: 0, y: 0, z: 0 },
                        u = function (t) {
                            for (var e in t) null == t[e] ? (t[e] = [0, 0]) : "number" == typeof t[e] && (t[e] = [-1 * t[e], t[e]]);
                        };
                    u(l), u(m);
                    var c = { x: ((l.x[1] - l.x[0]) / o.width) * a + l.x[0], y: ((l.y[1] - l.y[0]) / o.height) * s + l.y[0], z: ((l.z[1] - l.z[0]) / o.height) * s + l.z[0] },
                        h = { x: ((m.x[1] - m.x[0]) / o.height) * s + m.x[0], y: ((m.y[1] - m.y[0]) / o.width) * a + m.y[0], z: ((m.z[1] - m.z[0]) / o.width) * a + m.z[0] };
                    this.DOM.animatable[r].style.WebkitTransform = this.DOM.animatable[r].style.transform =
                        "translateX(" + c.x + "px) translateY(" + c.y + "px) translateZ(" + c.z + "px) rotateX(" + h.x + "deg) rotateY(" + h.y + "deg) rotateZ(" + h.z + "deg)";
                }
        }),
        (v.TiltFx = t);
})(window);
/*! animejs v2.2 */
var $jscomp = { scope: {} };
($jscomp.defineProperty =
    "function" == typeof Object.defineProperties
        ? Object.defineProperty
        : function (t, e, r) {
              if (r.get || r.set) throw new TypeError("ES3 does not support getters and setters.");
              t != Array.prototype && t != Object.prototype && (t[e] = r.value);
          }),
    ($jscomp.getGlobal = function (t) {
        return "undefined" != typeof window && window === t ? t : "undefined" != typeof global && null != global ? global : t;
    }),
    ($jscomp.global = $jscomp.getGlobal(this)),
    ($jscomp.SYMBOL_PREFIX = "jscomp_symbol_"),
    ($jscomp.initSymbol = function () {
        ($jscomp.initSymbol = function () {}), $jscomp.global.Symbol || ($jscomp.global.Symbol = $jscomp.Symbol);
    }),
    ($jscomp.symbolCounter_ = 0),
    ($jscomp.Symbol = function (t) {
        return $jscomp.SYMBOL_PREFIX + (t || "") + $jscomp.symbolCounter_++;
    }),
    ($jscomp.initSymbolIterator = function () {
        $jscomp.initSymbol();
        var t = $jscomp.global.Symbol.iterator;
        t || (t = $jscomp.global.Symbol.iterator = $jscomp.global.Symbol("iterator")),
            "function" != typeof Array.prototype[t] &&
                $jscomp.defineProperty(Array.prototype, t, {
                    configurable: !0,
                    writable: !0,
                    value: function () {
                        return $jscomp.arrayIterator(this);
                    },
                }),
            ($jscomp.initSymbolIterator = function () {});
    }),
    ($jscomp.arrayIterator = function (t) {
        var e = 0;
        return $jscomp.iteratorPrototype(function () {
            return e < t.length ? { done: !1, value: t[e++] } : { done: !0 };
        });
    }),
    ($jscomp.iteratorPrototype = function (t) {
        return (
            $jscomp.initSymbolIterator(),
            ((t = { next: t })[$jscomp.global.Symbol.iterator] = function () {
                return this;
            }),
            t
        );
    }),
    ($jscomp.array = $jscomp.array || {}),
    ($jscomp.iteratorFromArray = function (e, r) {
        $jscomp.initSymbolIterator(), e instanceof String && (e += "");
        var n = 0,
            o = {
                next: function () {
                    if (n < e.length) {
                        var t = n++;
                        return { value: r(t, e[t]), done: !1 };
                    }
                    return (
                        (o.next = function () {
                            return { done: !0, value: void 0 };
                        }),
                        o.next()
                    );
                },
            };
        return (
            (o[Symbol.iterator] = function () {
                return o;
            }),
            o
        );
    }),
    ($jscomp.polyfill = function (t, e, r, n) {
        if (e) {
            for (r = $jscomp.global, t = t.split("."), n = 0; n < t.length - 1; n++) {
                var o = t[n];
                o in r || (r[o] = {}), (r = r[o]);
            }
            (e = e((n = r[(t = t[t.length - 1])]))) != n && null != e && $jscomp.defineProperty(r, t, { configurable: !0, writable: !0, value: e });
        }
    }),
    $jscomp.polyfill(
        "Array.prototype.keys",
        function (t) {
            return (
                t ||
                function () {
                    return $jscomp.iteratorFromArray(this, function (t) {
                        return t;
                    });
                }
            );
        },
        "es6-impl",
        "es3"
    );
var $jscomp$this = this;
!(function (t, e) {
    "function" == typeof define && define.amd ? define([], e) : "object" == typeof module && module.exports ? (module.exports = e()) : (t.anime = e());
})(this, function () {
    function o(t) {
        if (!F.col(t))
            try {
                return document.querySelectorAll(t);
            } catch (t) {}
    }
    function $(t, e) {
        for (var r = t.length, n = 2 <= arguments.length ? e : void 0, o = [], a = 0; a < r; a++)
            if (a in t) {
                var i = t[a];
                e.call(n, i, a, t) && o.push(i);
            }
        return o;
    }
    function l(t) {
        return t.reduce(function (t, e) {
            return t.concat(F.arr(e) ? l(e) : e);
        }, []);
    }
    function a(t) {
        return F.arr(t) ? t : (F.str(t) && (t = o(t) || t), t instanceof NodeList || t instanceof HTMLCollection ? [].slice.call(t) : [t]);
    }
    function i(t, e) {
        return t.some(function (t) {
            return t === e;
        });
    }
    function u(t) {
        var e,
            r = {};
        for (e in t) r[e] = t[e];
        return r;
    }
    function p(t, e) {
        var r,
            n = u(t);
        for (r in t) n[r] = e.hasOwnProperty(r) ? e[r] : t[r];
        return n;
    }
    function d(t, e) {
        var r,
            n = u(t);
        for (r in e) n[r] = F.und(t[r]) ? e[r] : t[r];
        return n;
    }
    function s(t) {
        if ((t = /([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(t))) return t[2];
    }
    function c(t, e) {
        return F.fnc(t) ? t(e.target, e.id, e.total) : t;
    }
    function x(t, e) {
        if (e in t.style) return getComputedStyle(t).getPropertyValue(e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()) || "0";
    }
    function m(t, e) {
        return F.dom(t) && i(k, e) ? "transform" : F.dom(t) && (t.getAttribute(e) || (F.svg(t) && t[e])) ? "attribute" : F.dom(t) && "transform" !== e && x(t, e) ? "css" : null != t[e] ? "object" : void 0;
    }
    function f(t, e) {
        switch (m(t, e)) {
            case "transform":
                return (function (t, r) {
                    var e,
                        n = -1 < (e = r).indexOf("translate") || "perspective" === e ? "px" : -1 < e.indexOf("rotate") || -1 < e.indexOf("skew") ? "deg" : void 0;
                    if (((n = -1 < r.indexOf("scale") ? 1 : 0 + n), !(t = t.style.transform))) return n;
                    for (var o = [], a = [], i = [], u = /(\w+)\((.+?)\)/g; (o = u.exec(t)); ) a.push(o[1]), i.push(o[2]);
                    return (t = $(i, function (t, e) {
                        return a[e] === r;
                    })).length
                        ? t[0]
                        : n;
                })(t, e);
            case "css":
                return x(t, e);
            case "attribute":
                return t.getAttribute(e);
        }
        return t[e] || 0;
    }
    function g(t, e) {
        var r = /^(\*=|\+=|-=)/.exec(t);
        if (!r) return t;
        var n = s(t) || 0;
        switch (((e = parseFloat(e)), (t = parseFloat(t.replace(r[0], ""))), r[0][0])) {
            case "+":
                return e + t + n;
            case "-":
                return e - t + n;
            case "*":
                return e * t + n;
        }
    }
    function y(t, e) {
        return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
    }
    function r(t) {
        t = t.points;
        for (var e, r = 0, n = 0; n < t.numberOfItems; n++) {
            var o = t.getItem(n);
            0 < n && (r += y(e, o)), (e = o);
        }
        return r;
    }
    function h(t) {
        if (t.getTotalLength) return t.getTotalLength();
        switch (t.tagName.toLowerCase()) {
            case "circle":
                return 2 * Math.PI * t.getAttribute("r");
            case "rect":
                return 2 * t.getAttribute("width") + 2 * t.getAttribute("height");
            case "line":
                return y({ x: t.getAttribute("x1"), y: t.getAttribute("y1") }, { x: t.getAttribute("x2"), y: t.getAttribute("y2") });
            case "polyline":
                return r(t);
            case "polygon":
                var e = t.points;
                return r(t) + y(e.getItem(e.numberOfItems - 1), e.getItem(0));
        }
    }
    function w(e, r) {
        function t(t) {
            return (t = void 0 === t ? 0 : t), e.el.getPointAtLength(1 <= r + t ? r + t : 0);
        }
        var n = t(),
            o = t(-1),
            a = t(1);
        switch (e.property) {
            case "x":
                return n.x;
            case "y":
                return n.y;
            case "angle":
                return (180 * Math.atan2(a.y - o.y, a.x - o.x)) / Math.PI;
        }
    }
    function v(t, e) {
        var r,
            n = /-?\d*\.?\d+/g;
        if (((r = F.pth(t) ? t.totalLength : t), F.col(r)))
            if (F.rgb(r)) {
                var o = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(r);
                r = o ? "rgba(" + o[1] + ",1)" : r;
            } else
                r = F.hex(r)
                    ? (function (t) {
                          t = t.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (t, e, r, n) {
                              return e + e + r + r + n + n;
                          });
                          var e = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
                          return "rgba(" + (t = parseInt(e[1], 16)) + "," + parseInt(e[2], 16) + "," + (e = parseInt(e[3], 16)) + ",1)";
                      })(r)
                    : F.hsl(r)
                    ? (function (t) {
                          function e(t, e, r) {
                              return r < 0 && (r += 1), 1 < r && --r, r < 1 / 6 ? t + 6 * (e - t) * r : r < 0.5 ? e : r < 2 / 3 ? t + (e - t) * (2 / 3 - r) * 6 : t;
                          }
                          var r = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(t) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(t);
                          t = parseInt(r[1]) / 360;
                          var n = parseInt(r[2]) / 100,
                              o = parseInt(r[3]) / 100;
                          if (((r = r[4] || 1), 0 == n)) o = n = t = o;
                          else {
                              var a = o < 0.5 ? o * (1 + n) : o + n - o * n,
                                  i = 2 * o - a;
                              (o = e(i, a, t + 1 / 3)), (n = e(i, a, t)), (t = e(i, a, t - 1 / 3));
                          }
                          return "rgba(" + 255 * o + "," + 255 * n + "," + 255 * t + "," + r + ")";
                      })(r)
                    : void 0;
        else (o = (o = s(r)) ? r.substr(0, r.length - o.length) : r), (r = e && !/\s/g.test(r) ? o + e : o);
        return { original: (r += ""), numbers: r.match(n) ? r.match(n).map(Number) : [0], strings: F.str(t) || e ? r.split(n) : [] };
    }
    function b(t) {
        return $((t = t ? l(F.arr(t) ? t.map(a) : a(t)) : []), function (t, e, r) {
            return r.indexOf(t) === e;
        });
    }
    function j(t, r) {
        var e = u(r);
        if (F.arr(t)) {
            var n = t.length;
            2 !== n || F.obj(t[0]) ? F.fnc(r.duration) || (e.duration = r.duration / n) : (t = { value: t });
        }
        return a(t)
            .map(function (t, e) {
                return (e = e ? 0 : r.delay), (t = F.obj(t) && !F.pth(t) ? t : { value: t }), F.und(t.delay) && (t.delay = e), t;
            })
            .map(function (t) {
                return d(t, e);
            });
    }
    function A(a, i) {
        var u;
        return a.tweens.map(function (t) {
            var e = (t = (function (t, e) {
                    var r,
                        n = {};
                    for (r in t) {
                        var o = c(t[r], e);
                        F.arr(o) &&
                            1 ===
                                (o = o.map(function (t) {
                                    return c(t, e);
                                })).length &&
                            (o = o[0]),
                            (n[r] = o);
                    }
                    return (n.duration = parseFloat(n.duration)), (n.delay = parseFloat(n.delay)), n;
                })(t, i)).value,
                r = f(i.target, a.name),
                n = u ? u.to.original : r,
                o = ((n = F.arr(e) ? e[0] : n), g(F.arr(e) ? e[1] : e, n));
            r = s(o) || s(n) || s(r);
            return (
                (t.from = v(n, r)),
                (t.to = v(o, r)),
                (t.start = u ? u.end : a.offset),
                (t.end = t.start + t.delay + t.duration),
                (t.easing = (function (t) {
                    return F.arr(t) ? L.apply(this, t) : C[t];
                })(t.easing)),
                (t.elasticity = (1e3 - Math.min(Math.max(t.elasticity, 1), 999)) / 1e3),
                (t.isPath = F.pth(e)),
                (t.isColor = F.col(t.from.original)),
                t.isColor && (t.round = 1),
                (u = t)
            );
        });
    }
    function I(e, t, r, n) {
        var o = "delay" === e;
        return t.length
            ? (o ? Math.min : Math.max).apply(
                  Math,
                  t.map(function (t) {
                      return t[e];
                  })
              )
            : o
            ? n.delay
            : r.offset + n.delay + n.duration;
    }
    function n(t) {
        var e,
            r,
            n,
            o,
            a,
            i = p(O, t),
            u = p(P, t),
            s =
                ((r = t.targets),
                (n = b(r)).map(function (t, e) {
                    return { target: t, id: e, total: n.length };
                })),
            c = [],
            f = d(i, u);
        for (e in t) f.hasOwnProperty(e) || "targets" === e || c.push({ name: e, offset: f.offset, tweens: j(t[e], u) });
        return (
            (a = c),
            d(i, {
                children: [],
                animatables: (o = s),
                animations: (t = $(
                    l(
                        o.map(function (n) {
                            return a.map(function (t) {
                                var e = m(n.target, t.name);
                                if (e) {
                                    var r = A(t, n);
                                    t = { type: e, property: t.name, animatable: n, tweens: r, duration: r[r.length - 1].end, delay: r[0].delay };
                                } else t = void 0;
                                return t;
                            });
                        })
                    ),
                    function (t) {
                        return !F.und(t);
                    }
                )),
                duration: I("duration", t, i, u),
                delay: I("delay", t, i, u),
            })
        );
    }
    function M(t) {
        function f() {
            return (
                window.Promise &&
                new Promise(function (t) {
                    return (v = t);
                })
            );
        }
        function l(t) {
            return j.reversed ? j.duration - t : t;
        }
        function p(e) {
            for (var t = 0, r = {}, n = j.animations, o = n.length; t < o; ) {
                var a = n[t],
                    i = a.animatable,
                    u = (s = a.tweens)[(l = s.length - 1)];
                l &&
                    (u =
                        $(s, function (t) {
                            return e < t.end;
                        })[0] || u);
                for (
                    var s = Math.min(Math.max(e - u.start - u.delay, 0), u.duration) / u.duration, c = isNaN(s) ? 1 : u.easing(s, u.elasticity), f = ((s = u.to.strings), u.round), l = [], p = void 0, d = ((p = u.to.numbers.length), 0);
                    d < p;
                    d++
                ) {
                    var m = void 0,
                        g = ((m = u.to.numbers[d]), u.from.numbers[d]);
                    m = u.isPath ? w(u.value, c * m) : g + c * (m - g);
                    f && ((u.isColor && 2 < d) || (m = Math.round(m * f) / f)), l.push(m);
                }
                if ((u = s.length)) for (p = s[0], c = 0; c < u; c++) (f = s[c + 1]), (d = l[c]), isNaN(d) || (p = f ? p + (d + f) : p + (d + " "));
                else p = l[0];
                E[a.type](i.target, a.property, p, r, i.id), (a.currentValue = p), t++;
            }
            if ((t = Object.keys(r).length)) for (n = 0; n < t; n++) S || (S = x(document.body, "transform") ? "transform" : "-webkit-transform"), (j.animatables[n].target.style[S] = r[n].join(" "));
            (j.currentTime = e), (j.progress = (e / j.duration) * 100);
        }
        function d(t) {
            j[t] && j[t](j);
        }
        function m() {
            j.remaining && !0 !== j.remaining && j.remaining--;
        }
        function e(t) {
            var e = j.duration,
                r = j.offset,
                n = r + j.delay,
                o = j.currentTime,
                a = j.reversed,
                i = l(t);
            if (j.children.length) {
                var u = j.children,
                    s = u.length;
                if (i >= j.currentTime) for (var c = 0; c < s; c++) u[c].seek(i);
                else for (; s--; ) u[s].seek(i);
            }
            (n <= i || !e) && (j.began || ((j.began = !0), d("begin")), d("run")),
                r < i && i < e ? p(i) : (i <= r && 0 !== o && (p(0), a && m()), ((e <= i && o !== e) || !e) && (p(e), a || m())),
                d("update"),
                e <= t && (j.remaining ? ((y = g), "alternate" === j.direction && (j.reversed = !j.reversed)) : (j.pause(), j.completed || ((j.completed = !0), d("complete"), "Promise" in window && (v(), (b = f())))), (h = 0));
        }
        t = void 0 === t ? {} : t;
        var g,
            y,
            h = 0,
            v = null,
            b = f(),
            j = n(t);
        return (
            (j.reset = function () {
                var t = j.direction,
                    e = j.loop;
                for (j.currentTime = 0, j.progress = 0, j.paused = !0, j.began = !1, j.completed = !1, j.reversed = "reverse" === t, j.remaining = "alternate" === t && 1 === e ? 2 : e, p(0), t = j.children.length; t--; )
                    j.children[t].reset();
            }),
            (j.tick = function (t) {
                (g = t), y || (y = g), e((h + g - y) * M.speed);
            }),
            (j.seek = function (t) {
                e(l(t));
            }),
            (j.pause = function () {
                var t = T.indexOf(j);
                -1 < t && T.splice(t, 1), (j.paused = !0);
            }),
            (j.play = function () {
                j.paused && ((j.paused = !1), (y = 0), (h = l(j.currentTime)), T.push(j), N || X());
            }),
            (j.reverse = function () {
                (j.reversed = !j.reversed), (y = 0), (h = l(j.currentTime));
            }),
            (j.restart = function () {
                j.pause(), j.reset(), j.play();
            }),
            (j.finished = b),
            j.reset(),
            j.autoplay && j.play(),
            j
        );
    }
    var S,
        O = { update: void 0, begin: void 0, run: void 0, complete: void 0, loop: 1, direction: "normal", autoplay: !0, offset: 0 },
        P = { duration: 1e3, delay: 0, easing: "easeOutElastic", elasticity: 500, round: 0 },
        k = "translateX translateY translateZ rotate rotateX rotateY rotateZ scale scaleX scaleY scaleZ skewX skewY perspective".split(" "),
        F = {
            arr: function (t) {
                return Array.isArray(t);
            },
            obj: function (t) {
                return -1 < Object.prototype.toString.call(t).indexOf("Object");
            },
            pth: function (t) {
                return F.obj(t) && t.hasOwnProperty("totalLength");
            },
            svg: function (t) {
                return t instanceof SVGElement;
            },
            dom: function (t) {
                return t.nodeType || F.svg(t);
            },
            str: function (t) {
                return "string" == typeof t;
            },
            fnc: function (t) {
                return "function" == typeof t;
            },
            und: function (t) {
                return void 0 === t;
            },
            hex: function (t) {
                return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(t);
            },
            rgb: function (t) {
                return /^rgb/.test(t);
            },
            hsl: function (t) {
                return /^hsl/.test(t);
            },
            col: function (t) {
                return F.hex(t) || F.rgb(t) || F.hsl(t);
            },
        },
        L = (function () {
            function l(t, e, r) {
                return (((1 - 3 * r + 3 * e) * t + (3 * r - 6 * e)) * t + 3 * e) * t;
            }
            return function (i, u, s, c) {
                if (0 <= i && i <= 1 && 0 <= s && s <= 1) {
                    var f = new Float32Array(11);
                    if (i !== u || s !== c) for (var t = 0; t < 11; ++t) f[t] = l(0.1 * t, i, s);
                    return function (t) {
                        if (i === u && s === c) return t;
                        if (0 === t) return 0;
                        if (1 === t) return 1;
                        for (var e = 0, r = 1; 10 !== r && f[r] <= t; ++r) e += 0.1;
                        r = e + ((t - f[--r]) / (f[r + 1] - f[r])) * 0.1;
                        var n = 3 * (1 - 3 * s + 3 * i) * r * r + 2 * (3 * s - 6 * i) * r + 3 * i;
                        if (0.001 <= n) {
                            for (e = 0; e < 4 && 0 !== (n = 3 * (1 - 3 * s + 3 * i) * r * r + 2 * (3 * s - 6 * i) * r + 3 * i); ++e) {
                                var o = l(r, i, s) - t;
                                r = r - o / n;
                            }
                            t = r;
                        } else if (0 === n) t = r;
                        else {
                            (r = e), (e = e + 0.1);
                            for (var a = 0; 0 < (n = l((o = r + (e - r) / 2), i, s) - t) ? (e = o) : (r = o), 1e-7 < Math.abs(n) && ++a < 10; );
                            t = o;
                        }
                        return l(t, u, c);
                    };
                }
            };
        })(),
        C = (function () {
            function r(t, e) {
                return 0 === t || 1 === t ? t : -Math.pow(2, 10 * (t - 1)) * Math.sin((2 * (t - 1 - (e / (2 * Math.PI)) * Math.asin(1)) * Math.PI) / e);
            }
            var t,
                n = "Quad Cubic Quart Quint Sine Expo Circ Back Elastic".split(" "),
                e = {
                    In: [
                        [0.55, 0.085, 0.68, 0.53],
                        [0.55, 0.055, 0.675, 0.19],
                        [0.895, 0.03, 0.685, 0.22],
                        [0.755, 0.05, 0.855, 0.06],
                        [0.47, 0, 0.745, 0.715],
                        [0.95, 0.05, 0.795, 0.035],
                        [0.6, 0.04, 0.98, 0.335],
                        [0.6, -0.28, 0.735, 0.045],
                        r,
                    ],
                    Out: [
                        [0.25, 0.46, 0.45, 0.94],
                        [0.215, 0.61, 0.355, 1],
                        [0.165, 0.84, 0.44, 1],
                        [0.23, 1, 0.32, 1],
                        [0.39, 0.575, 0.565, 1],
                        [0.19, 1, 0.22, 1],
                        [0.075, 0.82, 0.165, 1],
                        [0.175, 0.885, 0.32, 1.275],
                        function (t, e) {
                            return 1 - r(1 - t, e);
                        },
                    ],
                    InOut: [
                        [0.455, 0.03, 0.515, 0.955],
                        [0.645, 0.045, 0.355, 1],
                        [0.77, 0, 0.175, 1],
                        [0.86, 0, 0.07, 1],
                        [0.445, 0.05, 0.55, 0.95],
                        [1, 0, 0, 1],
                        [0.785, 0.135, 0.15, 0.86],
                        [0.68, -0.55, 0.265, 1.55],
                        function (t, e) {
                            return t < 0.5 ? r(2 * t, e) / 2 : 1 - r(-2 * t + 2, e) / 2;
                        },
                    ],
                },
                o = { linear: L(0.25, 0.25, 0.75, 0.75) },
                a = {};
            for (t in e)
                (a.type = t),
                    e[a.type].forEach(
                        (function (r) {
                            return function (t, e) {
                                o["ease" + r.type + n[e]] = F.fnc(t) ? t : L.apply($jscomp$this, t);
                            };
                        })(a)
                    ),
                    (a = { type: a.type });
            return o;
        })(),
        E = {
            css: function (t, e, r) {
                return (t.style[e] = r);
            },
            attribute: function (t, e, r) {
                return t.setAttribute(e, r);
            },
            object: function (t, e, r) {
                return (t[e] = r);
            },
            transform: function (t, e, r, n, o) {
                n[o] || (n[o] = []), n[o].push(e + "(" + r + ")");
            },
        },
        T = [],
        N = 0,
        X = (function () {
            function n() {
                N = requestAnimationFrame(t);
            }
            function t(t) {
                var e = T.length;
                if (e) {
                    for (var r = 0; r < e; ) T[r] && T[r].tick(t), r++;
                    n();
                } else cancelAnimationFrame(N), (N = 0);
            }
            return n;
        })();
    return (
        (M.version = "2.2.0"),
        (M.speed = 1),
        (M.running = T),
        (M.remove = function (t) {
            t = b(t);
            for (var e = T.length; e--; ) for (var r = T[e], n = r.animations, o = n.length; o--; ) i(t, n[o].animatable.target) && (n.splice(o, 1), n.length || r.pause());
        }),
        (M.getValue = f),
        (M.path = function (t, e) {
            var r = F.str(t) ? o(t)[0] : t,
                n = e || 100;
            return function (t) {
                return { el: r, property: t, totalLength: h(r) * (n / 100) };
            };
        }),
        (M.setDashoffset = function (t) {
            var e = h(t);
            return t.setAttribute("stroke-dasharray", e), e;
        }),
        (M.bezier = L),
        (M.easings = C),
        (M.timeline = function (n) {
            var o = M(n);
            return (
                o.pause(),
                (o.duration = 0),
                (o.add = function (t) {
                    return (
                        o.children.forEach(function (t) {
                            (t.began = !0), (t.completed = !0);
                        }),
                        a(t).forEach(function (t) {
                            var e = d(t, p(P, n || {}));
                            (e.targets = e.targets || n.targets), (t = o.duration);
                            var r = e.offset;
                            (e.autoplay = !1),
                                (e.direction = o.direction),
                                (e.offset = F.und(r) ? t : g(r, t)),
                                (o.began = !0),
                                (o.completed = !0),
                                o.seek(e.offset),
                                ((e = M(e)).began = !0),
                                (e.completed = !0),
                                e.duration > t && (o.duration = e.duration),
                                o.children.push(e);
                        }),
                        o.seek(0),
                        o.reset(),
                        o.autoplay && o.restart(),
                        o
                    );
                }),
                o
            );
        }),
        (M.random = function (t, e) {
            return Math.floor(Math.random() * (e - t + 1)) + t;
        }),
        M
    );
});
/*! roarmenu */
!(function (r) {
    r.fn.roarmenu = function (n) {
        var e = r.extend({}, { navbar: { add: !0, close: !1, title: "Menu", back: "Back", titleLink: "parent" }, openingInterval: 25, panelNodetype: "ul, ol, div", panel2Nodetype: ".drilldown", transitionDuration: 400 }, n);
        return (
            (this.$pnls = null),
            ((this.$menu = this).conf = e),
            (this.uniqueId = 0),
            (this.support = { touch: "ontouchstart" in window || navigator.msMaxTouchPoints || !1, csstransitions: "undefined" == typeof Modernizr || void 0 === Modernizr.csstransitions || Modernizr.csstransitions }),
            (this.run = function () {
                return this._initMenu(), this._initPanels(), this._initAnchors(), this;
            }),
            (this._initMenu = function () {
                this.$menu.attr("id", this.$menu.attr("id") || this.__getUniqueId()), (this.$pnls = r('<div class="panels" />').append(this.$menu.children(this.conf.panelNodetype)).prependTo(this.$menu)), this.$menu.addClass("mm-menu");
            }),
            (this._initPanels = function () {
                var n = this.$pnls.children(this.conf.panelNodetype),
                    a = this,
                    i = function (n) {
                        n.filter(a.conf.panelNodetype).each(function () {
                            var n,
                                e,
                                t = a._initPanel(r(this));
                            t &&
                                (a._initNavbar(t),
                                a._initListview(t, "ul, ol"),
                                (n = t.children(".listview").children("li").children(a.conf.panelNodetype).add(t.children(".panel"))).length
                                    ? i(n)
                                    : (e = t.find(a.conf.panel2Nodetype)).length &&
                                      e.filter(a.conf.panel2Nodetype).each(function () {
                                          var n = a._initPanel(r(this));
                                          n && (a._initNavbar(n), a._initListview(n, ".drilldown"));
                                      }));
                        });
                    };
                i(n);
            }),
            (this._initPanel = function (n) {
                if (n.hasClass("panel")) return n;
                if (n.hasClass("nopanel")) return !1;
                var e = n.attr("id") || this.__getUniqueId();
                n.is("ul, ol") && (n.removeAttr("id"), n.wrap("<div />"), (n = n.parent())), n.attr("id", e), n.addClass("panel"), 2 == this.uniqueId ? n.addClass("panel_opened") : n.addClass("hidden");
                var t = n.parent("li");
                return n.appendTo(this.$pnls), t.length && (t.data("child", n).addClass("listitem"), n.data("parent", t)), n;
            }),
            (this._initNavbar = function (n) {
                if (!n.children(".navbar").length) {
                    var e = n.data("parent"),
                        t = r('<div class="navbar" />'),
                        a = this.conf.navbar.title,
                        i = "";
                    if (e && e.length) {
                        var s = e.closest(".panel").find('a[href="#' + n.attr("id") + '"]');
                        (!e.parent().is(".listview") && "mm-0" == n.attr("id")) || (s = e.children("a, span").not(".btn_next"));
                        var l = (e = (s = s.first()).closest(".panel")).attr("id"),
                            a = r("<span>" + s.html() + "</span>").html();
                        switch (this.conf.navbar.titleLink) {
                            case "anchor":
                                i = s.attr("href");
                                break;
                            case "parent":
                                i = "#" + l;
                        }
                        t.append('<a class="btn_prev navbar__btn" href="#' + l + '"><span>' + this.conf.navbar.back + "</span></a>"),
                            n
                                .children()
                                .addClass("listview")
                                .prepend('<a class="listitem__parent" href="' + (i.length ? i : "#mm-0") + '">' + a + "</a>");
                    } else if (!this.conf.navbar.title) return;
                    this.conf.navbar.add &&
                        (n.addClass("panel_has-navbar"),
                        t.append('<a class="navbar__title" href="' + (i.length ? i : "#mm-0") + '">' + a + "</a>"),
                        this.conf.navbar.close && t.append('<a class="navbar__close ' + this.conf.navbar.close + '" href="#"><span class="close-icon"></span></a>'),
                        t.prependTo(n));
                }
            }),
            (this._initListview = function (n, e) {
                this.__childAddBack(n, e).addClass("listview").children().addClass("listitem").children("a, span").not(".mm-btn").addClass("listitem__text");
                var t,
                    a,
                    i = n.data("parent");
                i &&
                    i.is(".listitem") &&
                    !i.children(".mm-btn").length &&
                    ((t = i.children("a, span").first()),
                    (a = r('<a class="mm-btn btn_next listitem__btn" href="#' + n.attr("id") + '" />')).insertAfter(t),
                    t.is("a") &&
                        (r('<span class="' + t.attr("class") + '"/>')
                            .removeClass("listitem__text")
                            .html(t.html())
                            .insertAfter(a),
                        t.remove()));
            }),
            (this._initAnchors = function () {
                var s = this;
                s.on("click", "a[href]", function (n) {
                    var e = r(this),
                        t = e.attr("href"),
                        a = s.$menu.find(e).length;
                    if ((e.is(".listitem > a"), e.is('[rel="external"]') || e.is('[target="_blank"]'), a && 1 < t.length && "#" == t.slice(0, 1)))
                        try {
                            var i = s.$menu.find(t);
                            if (i.is(".panel")) return s.openPanel(i), void n.preventDefault();
                        } catch (n) {}
                });
            }),
            (this.openPanel = function (n, e) {
                if (n && n.length && (n.is(".panel") || (n = n.closest(".panel")), n.is(".panel"))) {
                    var t = this;
                    if (n.hasClass("panel_opened")) return;
                    var a = t.$pnls.children(".panel"),
                        i = t.$pnls.children(".panel_opened");
                    if (!t.support.csstransitions) return i.addClass("hidden").removeClass("panel_opened"), void n.removeClass("hidden").addClass("panel_opened");
                    a.not(n).removeClass("panel_opened-parent");
                    for (var s = n.data("parent"); s; ) (s = s.closest(".panel")).parent(".listitem_vertical").length || s.addClass("panel_opened-parent"), (s = s.data("parent"));
                    a.removeClass("panel_highest").not(i).not(n).addClass("hidden"), n.removeClass("hidden");
                    function l() {
                        i.removeClass("panel_opened"),
                            n.addClass("panel_opened"),
                            n.hasClass("panel_opened-parent") ? (i.addClass("panel_highest"), n.removeClass("panel_opened-parent")) : (i.addClass("panel_opened-parent"), n.addClass("panel_highest"));
                    }
                    function r() {
                        i.removeClass("panel_highest").addClass("hidden"), n.removeClass("panel_highest");
                    }
                    e && !n.hasClass("panel_noanimation")
                        ? setTimeout(function () {
                              t.__transitionend(
                                  n,
                                  function () {
                                      r();
                                  },
                                  t.conf.transitionDuration
                              ),
                                  l();
                          }, t.conf.openingInterval)
                        : (l(), r());
                }
            }),
            (this.__transitionend = function (e, t, n) {
                function a(n) {
                    (void 0 !== n && n.target != e[0]) || (i || (e.off("transitionend"), e.off("webkitTransitionEnd"), t.call(e[0])), (i = !0));
                }
                var i = !1;
                e.on("transitionend", a), e.on("webkitTransitionEnd", a), setTimeout(a, 1.1 * n);
            }),
            (this.__getUniqueId = function () {
                return "mm-" + this.uniqueId++;
            }),
            (this.__childAddBack = function (n, e) {
                return n.children(e).add(n.filter(e));
            }),
            this.run()
        );
    };
})(jQuery);
/*! ParallaxScroll */
var ParallaxScroll = {
    showLogs: !1,
    round: 1e3,
    init: function () {
        if ((this._log("init"), this._inited)) return this._log("Already Inited"), void (this._inited = !0);
        (this._requestAnimationFrame =
            window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            function (a, t) {
                window.setTimeout(a, 1e3 / 60);
            }),
            this._onScroll(!0);
    },
    _inited: !1,
    _properties: ["x", "y", "z", "rotateX", "rotateY", "rotateZ", "scaleX", "scaleY", "scaleZ", "scale", "opacity"],
    _requestAnimationFrame: null,
    _log: function (a) {
        this.showLogs && console.log("Parallax Scroll / " + a);
    },
    _onScroll: function (A) {
        var X = jQuery(document).scrollTop(),
            Y = jQuery(window).height();
        this._log("onScroll " + X),
            jQuery("[data-parallax]").each(
                jQuery.proxy(function (a, t) {
                    var i = jQuery(t),
                        o = [],
                        u = !1,
                        e = i.data("style");
                    null == e && ((e = i.attr("style") || ""), i.data("style", e));
                    var l,
                        r = [i.data("parallax")];
                    for (l = 2; i.data("parallax" + l); l++) r.push(i.data("parallax-" + l));
                    var s = r.length;
                    for (l = 0; l < s; l++) {
                        var c = r[l],
                            d = c["from-scroll"];
                        null == d && (d = Math.max(0, jQuery(t).offset().top - Y)), (d |= 0);
                        var n = c.distance,
                            m = c["to-scroll"];
                        null == n && null == m && (n = Y), (n = Math.max(0 | n, 1));
                        var y = c.easing,
                            h = c["easing-return"];
                        if (((null != y && jQuery.easing && jQuery.easing[y]) || (y = null), (null != h && jQuery.easing && jQuery.easing[h]) || (h = y), y)) {
                            var p = c.duration;
                            null == p && (p = n), (p = Math.max(0 | p, 1));
                            var v = c["duration-return"];
                            null == v && (v = p), (n = 1);
                            var w = i.data("current-time");
                            null == w && (w = 0);
                        }
                        null == m && (m = d + n), (m |= 0);
                        var g = c.smoothness;
                        null == g && (g = 30), (g |= 0), (A || 0 == g) && (g = 1), (g |= 0);
                        var x = X;
                        (x = Math.max(x, d)),
                            (x = Math.min(x, m)),
                            y &&
                                (null == i.data("sens") && i.data("sens", "back"),
                                d < x && ("back" == i.data("sens") ? ((w = 1), i.data("sens", "go")) : w++),
                                x < m && ("go" == i.data("sens") ? ((w = 1), i.data("sens", "back")) : w++),
                                A && (w = p),
                                i.data("current-time", w)),
                            this._properties.map(
                                jQuery.proxy(function (a) {
                                    var t = 0,
                                        e = c[a];
                                    if (null != e) {
                                        "scale" == a || "scaleX" == a || "scaleY" == a || "scaleZ" == a ? (t = 1) : (e |= 0);
                                        var l = i.data("_" + a);
                                        null == l && (l = t);
                                        var r = ((x - d) / (m - d)) * (e - t) + t,
                                            s = l + (r - l) / g;
                                        if (y && 0 < w && w <= p) {
                                            var n = t;
                                            "back" == i.data("sens") && ((e = -(n = e)), (y = h), (p = v)), (s = jQuery.easing[y](null, w, n, e, p));
                                        }
                                        (s = Math.ceil(s * this.round) / this.round) == l && r == e && (s = e), o[a] || (o[a] = 0), (o[a] += s), l != o[a] && (i.data("_" + a, o[a]), (u = !0));
                                    }
                                }, this)
                            );
                    }
                    if (u) {
                        if (null != o.z) {
                            var f = c.perspective;
                            null == f && (f = 800);
                            var _ = i.parent();
                            _.data("style") || _.data("style", _.attr("style") || ""), _.attr("style", "perspective:" + f + "px; -webkit-perspective:" + f + "px; " + _.data("style"));
                        }
                        null == o.scaleX && (o.scaleX = 1), null == o.scaleY && (o.scaleY = 1), null == o.scaleZ && (o.scaleZ = 1), null != o.scale && ((o.scaleX *= o.scale), (o.scaleY *= o.scale), (o.scaleZ *= o.scale));
                        var j = "";
                        j = 1 == c.opacity ? "opacity:1" : "";
                        var Q =
                            "translate3d(" +
                            (o.x ? o.x : 0) +
                            "px, " +
                            (o.y ? o.y : 0) +
                            "px, " +
                            (o.z ? o.z : 0) +
                            "px)" +
                            " " +
                            ("rotateX(" + (o.rotateX ? o.rotateX : 0) + "deg) rotateY(" + (o.rotateY ? o.rotateY : 0) + "deg) rotateZ(" + (o.rotateZ ? o.rotateZ : 0) + "deg)") +
                            " " +
                            ("scaleX(" + o.scaleX + ") scaleY(" + o.scaleY + ") scaleZ(" + o.scaleZ + ")") +
                            ";";
                        this._log(Q), i.attr("style", "transform:" + Q + " -webkit-transform:" + Q + " " + e + j);
                    }
                }, this)
            ),
            window.requestAnimationFrame ? window.requestAnimationFrame(jQuery.proxy(this._onScroll, this, !1)) : this._requestAnimationFrame(jQuery.proxy(this._onScroll, this, !1));
    },
};
/*! ScrollReveal v4.0.0 */
var ScrollReveal = (function () {
    "use strict";
    var r = {
            delay: 0,
            distance: "0",
            duration: 600,
            easing: "cubic-bezier(0.5, 0, 0, 1)",
            interval: 0,
            opacity: 0,
            origin: "bottom",
            rotate: { x: 0, y: 0, z: 0 },
            scale: 1,
            cleanup: !0,
            container: document.documentElement,
            desktop: !0,
            mobile: !0,
            reset: !1,
            useDelay: "always",
            viewFactor: 0,
            viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
            afterReset: function () {},
            afterReveal: function () {},
            beforeReset: function () {},
            beforeReveal: function () {},
        },
        n = {
            clean: function () {},
            destroy: function () {},
            reveal: function () {},
            sync: function () {},
            get noop() {
                return !0;
            },
        };
    function o(e) {
        return "object" == typeof window.Node ? e instanceof window.Node : null !== e && "object" == typeof e && "number" == typeof e.nodeType && "string" == typeof e.nodeName;
    }
    function u(e, t) {
        if ((void 0 === t && (t = document), e instanceof Array)) return e.filter(o);
        if (o(e)) return [e];
        if (
            ((n = e),
            (i = Object.prototype.toString.call(n)),
            "object" == typeof window.NodeList ? n instanceof window.NodeList : null !== n && "object" == typeof n && "number" == typeof n.length && /^\[object (HTMLCollection|NodeList|Object)\]$/.test(i) && (0 === n.length || o(n[0])))
        )
            return Array.prototype.slice.call(e);
        var n, i;
        if ("string" == typeof e)
            try {
                var r = t.querySelectorAll(e);
                return Array.prototype.slice.call(r);
            } catch (e) {
                return [];
            }
        return [];
    }
    function s(e) {
        return null !== e && e instanceof Object && (e.constructor === Object || "[object Object]" === Object.prototype.toString.call(e));
    }
    function f(n, i) {
        if (s(n))
            return Object.keys(n).forEach(function (e) {
                return i(n[e], e, n);
            });
        if (n instanceof Array)
            return n.forEach(function (e, t) {
                return i(e, t, n);
            });
        throw new TypeError("Expected either an array or object literal.");
    }
    function h(e) {
        for (var t = [], n = arguments.length - 1; 0 < n--; ) t[n] = arguments[n + 1];
        if (this.constructor.debug && console) {
            var i = "%cScrollReveal: " + e;
            t.forEach(function (e) {
                return (i += "\n — " + e);
            }),
                console.log(i, "color: #ea654b;");
        }
    }
    function t() {
        var n = this,
            i = { active: [], stale: [] },
            t = { active: [], stale: [] },
            r = { active: [], stale: [] };
        try {
            f(u("[data-sr-id]"), function (e) {
                var t = parseInt(e.getAttribute("data-sr-id"));
                i.active.push(t);
            });
        } catch (e) {
            throw e;
        }
        f(this.store.elements, function (e) {
            -1 === i.active.indexOf(e.id) && i.stale.push(e.id);
        }),
            f(i.stale, function (e) {
                return delete n.store.elements[e];
            }),
            f(this.store.elements, function (e) {
                -1 === r.active.indexOf(e.containerId) && r.active.push(e.containerId), e.hasOwnProperty("sequence") && -1 === t.active.indexOf(e.sequence.id) && t.active.push(e.sequence.id);
            }),
            f(this.store.containers, function (e) {
                -1 === r.active.indexOf(e.id) && r.stale.push(e.id);
            }),
            f(r.stale, function (e) {
                var t = n.store.containers[e].node;
                t.removeEventListener("scroll", n.delegate), t.removeEventListener("resize", n.delegate), delete n.store.containers[e];
            }),
            f(this.store.sequences, function (e) {
                -1 === t.active.indexOf(e.id) && t.stale.push(e.id);
            }),
            f(t.stale, function (e) {
                return delete n.store.sequences[e];
            });
    }
    function p(e) {
        var i,
            r = this;
        try {
            f(u(e), function (e) {
                var t = e.getAttribute("data-sr-id");
                if (null !== t) {
                    i = !0;
                    var n = r.store.elements[t];
                    n.callbackTimer && window.clearTimeout(n.callbackTimer.clock), e.setAttribute("style", n.styles.inline.generated), e.removeAttribute("data-sr-id"), delete r.store.elements[t];
                }
            });
        } catch (e) {
            return h.call(this, "Clean failed.", e.message);
        }
        if (i)
            try {
                t.call(this);
            } catch (e) {
                return h.call(this, "Clean failed.", e.message);
            }
    }
    function N(e) {
        if (e.constructor !== Array) throw new TypeError("Expected array.");
        if (16 === e.length) return e;
        if (6 === e.length) {
            var t = z();
            return (t[0] = e[0]), (t[1] = e[1]), (t[4] = e[2]), (t[5] = e[3]), (t[12] = e[4]), (t[13] = e[5]), t;
        }
        throw new RangeError("Expected array with either 6 or 16 values.");
    }
    function z() {
        for (var e = [], t = 0; t < 16; t++) t % 5 == 0 ? e.push(1) : e.push(0);
        return e;
    }
    function F(e, t) {
        for (var n = N(e), i = N(t), r = [], o = 0; o < 4; o++)
            for (var s = [n[o], n[o + 4], n[o + 8], n[o + 12]], a = 0; a < 4; a++) {
                var c = 4 * a,
                    l = [i[c], i[c + 1], i[c + 2], i[c + 3]],
                    d = s[0] * l[0] + s[1] * l[1] + s[2] * l[2] + s[3] * l[3];
                r[o + c] = d;
            }
        return r;
    }
    function D(e, t) {
        var n = z();
        return (n[0] = e), (n[5] = "number" == typeof t ? t : e), n;
    }
    var S = (function () {
        var n = {},
            i = document.documentElement.style;
        function e(e, t) {
            if ((void 0 === t && (t = i), e && "string" == typeof e)) {
                if (n[e]) return n[e];
                if ("string" == typeof t[e]) return (n[e] = e);
                if ("string" == typeof t["-webkit-" + e]) return (n[e] = "-webkit-" + e);
                throw new RangeError('Unable to find "' + e + '" style property.');
            }
            throw new TypeError("Expected a string.");
        }
        return (
            (e.clearCache = function () {
                return (n = {});
            }),
            e
        );
    })();
    function m(e) {
        var t = window.getComputedStyle(e.node),
            n = t.position,
            i = e.config,
            r = {},
            o = (e.node.getAttribute("style") || "").match(/[\w-]+\s*:\s*[^;]+\s*/gi) || [];
        (r.computed = o
            ? o
                  .map(function (e) {
                      return e.trim();
                  })
                  .join("; ") + ";"
            : ""),
            (r.generated = o.some(function (e) {
                return e.match(/visibility\s?:\s?visible/i);
            })
                ? r.computed
                : o
                      .concat(["visibility: visible"])
                      .map(function (e) {
                          return e.trim();
                      })
                      .join("; ") + ";");
        var s,
            a,
            c,
            l,
            d,
            u,
            f,
            h,
            p,
            m,
            y,
            v,
            g,
            b = parseFloat(t.opacity),
            w = isNaN(parseFloat(i.opacity)) ? parseFloat(t.opacity) : parseFloat(i.opacity),
            E = { computed: b !== w ? "opacity: " + b + ";" : "", generated: b !== w ? "opacity: " + w + ";" : "" },
            j = [];
        if (parseFloat(i.distance)) {
            var T = "top" === i.origin || "bottom" === i.origin ? "Y" : "X",
                O = i.distance;
            ("top" !== i.origin && "left" !== i.origin) || (O = /^-/.test(O) ? O.substr(1) : "-" + O);
            var k = O.match(/(^-?\d+\.?\d?)|(em$|px$|%$)/g),
                x = k[0];
            switch (k[1]) {
                case "em":
                    O = parseInt(t.fontSize) * x;
                    break;
                case "px":
                    O = x;
                    break;
                case "%":
                    O = "Y" === T ? (e.node.getBoundingClientRect().height * x) / 100 : (e.node.getBoundingClientRect().width * x) / 100;
                    break;
                default:
                    throw new RangeError("Unrecognized or missing distance unit.");
            }
            "Y" === T ? j.push(((c = O), ((l = z())[13] = c), l)) : j.push(((s = O), ((a = z())[12] = s), a));
        }
        i.rotate.x && j.push(((d = i.rotate.x), (u = (Math.PI / 180) * d), ((f = z())[5] = f[10] = Math.cos(u)), (f[6] = f[9] = Math.sin(u)), (f[9] *= -1), f)),
            i.rotate.y && j.push(((h = i.rotate.y), (p = (Math.PI / 180) * h), ((m = z())[0] = m[10] = Math.cos(p)), (m[2] = m[8] = Math.sin(p)), (m[2] *= -1), m)),
            i.rotate.z && j.push(((y = i.rotate.z), (v = (Math.PI / 180) * y), ((g = z())[0] = g[5] = Math.cos(v)), (g[1] = g[4] = Math.sin(v)), (g[4] *= -1), g)),
            1 !== i.scale && (0 === i.scale ? j.push(D(2e-4)) : j.push(D(i.scale)));
        var A = {};
        if (j.length) {
            (A.property = S("transform")),
                (A.computed = {
                    raw: t[A.property],
                    matrix: (function (e) {
                        if ("string" == typeof e) {
                            var t = e.match(/matrix(3d)?\(([^)]+)\)/);
                            if (t) return N(t[2].split(", ").map(parseFloat));
                        }
                        return z();
                    })(t[A.property]),
                }),
                j.unshift(A.computed.matrix);
            var R = j.reduce(F);
            A.generated = { initial: A.property + ": matrix3d(" + R.join(", ") + ");", final: A.property + ": matrix3d(" + A.computed.matrix.join(", ") + ");" };
        } else A.generated = { initial: "", final: "" };
        var q = {};
        if (E.generated || A.generated.initial) {
            (q.property = S("transition")), (q.computed = t[q.property]), (q.fragments = []);
            var P = i.delay,
                I = i.duration,
                L = i.easing;
            E.generated && q.fragments.push({ delayed: "opacity " + I / 1e3 + "s " + L + " " + P / 1e3 + "s", instant: "opacity " + I / 1e3 + "s " + L + " 0s" }),
                A.generated.initial && q.fragments.push({ delayed: A.property + " " + I / 1e3 + "s " + L + " " + P / 1e3 + "s", instant: A.property + " " + I / 1e3 + "s " + L + " 0s" }),
                q.computed && !q.computed.match(/all 0s/) && q.fragments.unshift({ delayed: q.computed, instant: q.computed });
            var M = q.fragments.reduce(
                function (e, t, n) {
                    return (e.delayed += 0 === n ? t.delayed : ", " + t.delayed), (e.instant += 0 === n ? t.instant : ", " + t.instant), e;
                },
                { delayed: "", instant: "" }
            );
            q.generated = { delayed: q.property + ": " + M.delayed + ";", instant: q.property + ": " + M.instant + ";" };
        } else q.generated = { delayed: "", instant: "" };
        return { inline: r, opacity: E, position: n, transform: A, transition: q };
    }
    function c(e, t) {
        void 0 === t && (t = {});
        var n = t.pristine || this.pristine,
            i = "always" === e.config.useDelay || ("onload" === e.config.useDelay && n) || ("once" === e.config.useDelay && !e.seen),
            r = e.visible && !e.revealed,
            o = !e.visible && e.revealed && e.config.reset;
        return t.reveal || r
            ? function (e, t) {
                  var n = [e.styles.inline.generated, e.styles.opacity.computed, e.styles.transform.generated.final];
                  t ? n.push(e.styles.transition.generated.delayed) : n.push(e.styles.transition.generated.instant);
                  (e.revealed = e.seen = !0),
                      e.node.setAttribute(
                          "style",
                          n
                              .filter(function (e) {
                                  return "" !== e;
                              })
                              .join(" ")
                      ),
                      a.call(this, e, t);
              }.call(this, e, i)
            : t.reset || o
            ? function (e) {
                  var t = [e.styles.inline.generated, e.styles.opacity.generated, e.styles.transform.generated.initial, e.styles.transition.generated.instant];
                  (e.revealed = !1),
                      e.node.setAttribute(
                          "style",
                          t
                              .filter(function (e) {
                                  return "" !== e;
                              })
                              .join(" ")
                      ),
                      a.call(this, e);
              }.call(this, e)
            : void 0;
    }
    function a(e, t) {
        var n = this,
            i = t ? e.config.duration + e.config.delay : e.config.duration,
            r = e.revealed ? e.config.beforeReveal : e.config.beforeReset,
            o = e.revealed ? e.config.afterReveal : e.config.afterReset,
            s = 0;
        e.callbackTimer && ((s = Date.now() - e.callbackTimer.start), window.clearTimeout(e.callbackTimer.clock)),
            r(e.node),
            (e.callbackTimer = {
                start: Date.now(),
                clock: window.setTimeout(function () {
                    o(e.node), (e.callbackTimer = null), e.revealed && !e.config.reset && e.config.cleanup && p.call(n, e.node);
                }, i - s),
            });
    }
    var e,
        y =
            ((e = 0),
            function () {
                return e++;
            });
    function l(e, t) {
        if ((void 0 === t && (t = this.pristine), !e.visible && e.revealed && e.config.reset)) return c.call(this, e, { reset: !0 });
        var n = this.store.sequences[e.sequence.id],
            i = e.sequence.index;
        if (n) {
            var r = new d(n, "visible", this.store),
                o = new d(n, "revealed", this.store);
            if (((n.models = { visible: r, revealed: o }), !o.body.length)) {
                var s = n.members[r.body[0]],
                    a = this.store.elements[s];
                if (a) return g.call(this, n, r.body[0], -1, t), g.call(this, n, r.body[0], 1, t), c.call(this, a, { reveal: !0, pristine: t });
            }
            if (!n.blocked.head && i === [].concat(o.head).pop() && i >= [].concat(r.body).shift()) return g.call(this, n, i, -1, t), c.call(this, e, { reveal: !0, pristine: t });
            if (!n.blocked.foot && i === [].concat(o.foot).shift() && i <= [].concat(r.body).pop()) return g.call(this, n, i, 1, t), c.call(this, e, { reveal: !0, pristine: t });
        }
    }
    function v(e) {
        var t = Math.abs(e);
        if (isNaN(t)) throw new RangeError("Invalid sequence interval.");
        (this.id = y()), (this.interval = Math.max(t, 16)), (this.members = []), (this.models = {}), (this.blocked = { head: !1, foot: !1 });
    }
    function d(e, i, r) {
        var o = this;
        (this.head = []),
            (this.body = []),
            (this.foot = []),
            f(e.members, function (e, t) {
                var n = r.elements[e];
                n && n[i] && o.body.push(t);
            }),
            this.body.length &&
                f(e.members, function (e, t) {
                    var n = r.elements[e];
                    n && !n[i] && (t < o.body[0] ? o.head.push(t) : o.foot.push(t));
                });
    }
    function g(e, t, n, i) {
        var r = this,
            o = ["head", null, "foot"][1 + n],
            s = e.members[t + n],
            a = this.store.elements[s];
        (e.blocked[o] = !0),
            setTimeout(function () {
                (e.blocked[o] = !1), a && l.call(r, a, i);
            }, e.interval);
    }
    function b() {
        var n = this;
        t.call(this),
            f(this.store.elements, function (e) {
                var t = [e.styles.inline.generated];
                e.visible ? (t.push(e.styles.opacity.computed), t.push(e.styles.transform.generated.final)) : (t.push(e.styles.opacity.generated), t.push(e.styles.transform.generated.initial)),
                    e.node.setAttribute(
                        "style",
                        t
                            .filter(function (e) {
                                return "" !== e;
                            })
                            .join(" ")
                    );
            }),
            f(this.store.containers, function (e) {
                var t = e.node === document.documentElement ? window : e.node;
                t.addEventListener("scroll", n.delegate), t.addEventListener("resize", n.delegate);
            }),
            this.delegate(),
            (this.initTimeout = null);
    }
    function w(e) {
        return void 0 === e && (e = navigator.userAgent), /Android|iPhone|iPad|iPod/i.test(e);
    }
    function E(n) {
        for (var e = [], t = arguments.length - 1; 0 < t--; ) e[t] = arguments[t + 1];
        if (s(n))
            return (
                f(e, function (e) {
                    f(e, function (e, t) {
                        s(e) ? ((n[t] && s(n[t])) || (n[t] = {}), E(n[t], e)) : (n[t] = e);
                    });
                }),
                n
            );
        throw new TypeError("Target must be an object literal.");
    }
    function i(e, a, t) {
        var c = this;
        void 0 === a && (a = {}), void 0 === t && (t = !1);
        var l,
            d = [],
            n = a.interval || r.interval;
        try {
            n && (l = new v(n));
            var i = u(e);
            if (!i.length) throw new Error("Invalid reveal target.");
            f(
                i.reduce(function (e, t) {
                    var n = {},
                        i = t.getAttribute("data-sr-id");
                    i ? (E(n, c.store.elements[i]), n.node.setAttribute("style", n.styles.inline.computed)) : ((n.id = y()), (n.node = t), (n.seen = !1), (n.revealed = !1), (n.visible = !1));
                    var r = E({}, n.config || c.defaults, a);
                    if ((!r.mobile && w()) || (!r.desktop && !w())) return i && p.call(c, n), e;
                    var o,
                        s = u(r.container)[0];
                    if (!s) throw new Error("Invalid container.");
                    return (
                        s.contains(t) &&
                            (null ===
                                (o = (function (t) {
                                    var e = [],
                                        n = arguments.length - 1;
                                    for (; 0 < n--; ) e[n] = arguments[n + 1];
                                    var i = null;
                                    return (
                                        f(e, function (e) {
                                            f(e, function (e) {
                                                null === i && e.node === t && (i = e.id);
                                            });
                                        }),
                                        i
                                    );
                                })(s, d, c.store.containers)) && ((o = y()), d.push({ id: o, node: s })),
                            (n.config = r),
                            (n.containerId = o),
                            (n.styles = m(n)),
                            l && ((n.sequence = { id: l.id, index: l.members.length }), l.members.push(n.id)),
                            e.push(n)),
                        e
                    );
                }, []),
                function (e) {
                    (c.store.elements[e.id] = e).node.setAttribute("data-sr-id", e.id);
                }
            );
        } catch (e) {
            return h.call(this, "Reveal failed.", e.message);
        }
        f(d, function (e) {
            c.store.containers[e.id] = { id: e.id, node: e.node };
        }),
            l && (this.store.sequences[l.id] = l),
            !0 !== t && (this.store.history.push({ target: e, options: a }), this.initTimeout && window.clearTimeout(this.initTimeout), (this.initTimeout = window.setTimeout(b.bind(this), 0)));
    }
    var j,
        T =
            Math.sign ||
            function (e) {
                return (0 < e) - (e < 0) || +e;
            },
        O =
            ((j = Date.now()),
            function (e) {
                var t = Date.now();
                16 < t - j
                    ? e((j = t))
                    : setTimeout(function () {
                          return O(e);
                      }, 0);
            }),
        k = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || O;
    function x(e, t) {
        for (
            var n = t ? e.node.clientHeight : e.node.offsetHeight, i = t ? e.node.clientWidth : e.node.offsetWidth, r = 0, o = 0, s = e.node;
            isNaN(s.offsetTop) || (r += s.offsetTop), isNaN(s.offsetLeft) || (o += s.offsetLeft), (s = s.offsetParent);

        );
        return { bounds: { top: r, right: o + i, bottom: r + n, left: o }, height: n, width: i };
    }
    function A(e, t) {
        var i = this;
        void 0 === e && (e = { type: "init" }),
            void 0 === t && (t = this.store.elements),
            k(function () {
                var n = "init" === e.type || "resize" === e.type;
                f(i.store.containers, function (e) {
                    n && (e.geometry = x.call(i, e, !0));
                    var t = function (e) {
                        var t, n;
                        return e.node === document.documentElement ? ((t = window.pageYOffset), (n = window.pageXOffset)) : ((t = e.node.scrollTop), (n = e.node.scrollLeft)), { top: t, left: n };
                    }.call(i, e);
                    e.scroll && (e.direction = { x: T(t.left - e.scroll.left), y: T(t.top - e.scroll.top) }), (e.scroll = t);
                }),
                    f(t, function (e) {
                        n && (e.geometry = x.call(i, e)),
                            (e.visible = function (e) {
                                void 0 === e && (e = {});
                                var t = this.store.containers[e.containerId];
                                if (t) {
                                    var n = Math.max(0, Math.min(1, e.config.viewFactor)),
                                        i = e.config.viewOffset,
                                        r = e.geometry.bounds.top + e.geometry.height * n,
                                        o = e.geometry.bounds.right - e.geometry.width * n,
                                        s = e.geometry.bounds.bottom - e.geometry.height * n,
                                        a = e.geometry.bounds.left + e.geometry.width * n,
                                        c = t.geometry.bounds.top + t.scroll.top + i.top,
                                        l = t.geometry.bounds.right + t.scroll.left - i.right,
                                        d = t.geometry.bounds.bottom + t.scroll.top - i.bottom,
                                        u = t.geometry.bounds.left + t.scroll.left + i.left;
                                    return (r < d && u < o && c < s && a < l) || "fixed" === e.styles.position;
                                }
                            }.call(i, e));
                    }),
                    f(t, function (e) {
                        e.sequence ? l.call(i, e) : c.call(i, e);
                    }),
                    (i.pristine = !1);
            });
    }
    var R,
        q,
        P,
        I,
        L,
        M,
        C,
        W,
        Y = "4.0.0";
    function $(e) {
        var t;
        if ((void 0 === e && (e = {}), void 0 === this || Object.getPrototypeOf(this) !== $.prototype)) return new $(e);
        if (!$.isSupported()) return h.call(this, "Instantiation failed.", "This browser is not supported."), n;
        try {
            t = E({}, M || r, e);
        } catch (e) {
            return h.call(this, "Instantiation failed.", "Invalid configuration.", e.message), n;
        }
        try {
            if (!u(t.container)[0]) throw new Error("Invalid container.");
            if ((!t.mobile && w()) || (!t.desktop && !w())) throw new Error("This device is disabled.");
        } catch (e) {
            return h.call(this, "Instantiation failed.", e.message), n;
        }
        return (
            (M = t),
            document.documentElement.classList.add("sr"),
            document.body
                ? (document.body.style.height = "100%")
                : document.addEventListener("DOMContentLoaded", function () {
                      document.body.style.height = "100%";
                  }),
            (this.store = { containers: {}, elements: {}, history: [], sequences: {} }),
            (this.pristine = !0),
            (R = R || A.bind(this)),
            (q =
                q ||
                function () {
                    var n = this;
                    f(this.store.elements, function (e) {
                        e.node.setAttribute("style", e.styles.inline.generated), e.node.removeAttribute("data-sr-id");
                    }),
                        f(this.store.containers, function (e) {
                            var t = e.node === document.documentElement ? window : e.node;
                            t.removeEventListener("scroll", n.delegate), t.removeEventListener("resize", n.delegate);
                        }),
                        (this.store = { containers: {}, elements: {}, history: [], sequences: {} });
                }.bind(this)),
            (P = P || i.bind(this)),
            (I = I || p.bind(this)),
            (L =
                L ||
                function () {
                    var t = this;
                    f(this.store.history, function (e) {
                        i.call(t, e.target, e.options, !0);
                    }),
                        b.call(this);
                }.bind(this)),
            Object.defineProperty(this, "delegate", {
                get: function () {
                    return R;
                },
            }),
            Object.defineProperty(this, "destroy", {
                get: function () {
                    return q;
                },
            }),
            Object.defineProperty(this, "reveal", {
                get: function () {
                    return P;
                },
            }),
            Object.defineProperty(this, "clean", {
                get: function () {
                    return I;
                },
            }),
            Object.defineProperty(this, "sync", {
                get: function () {
                    return L;
                },
            }),
            Object.defineProperty(this, "defaults", {
                get: function () {
                    return M;
                },
            }),
            Object.defineProperty(this, "version", {
                get: function () {
                    return Y;
                },
            }),
            Object.defineProperty(this, "noop", {
                get: function () {
                    return !1;
                },
            }),
            W || (W = this)
        );
    }
    return (
        ($.isSupported = function () {
            return ("transform" in (t = document.documentElement.style) || "WebkitTransform" in t) && ("transition" in (e = document.documentElement.style) || "WebkitTransition" in e);
            var e, t;
        }),
        Object.defineProperty($, "debug", {
            get: function () {
                return C || !1;
            },
            set: function (e) {
                return (C = "boolean" == typeof e ? e : C);
            },
        }),
        $(),
        $
    );
})();
/*! socialShare v1.0 */
!(function (i) {
    "use strict";
    i.fn.extend({
        socialShare: function (s) {
            function a(e) {
                e.blur && i("body").removeClass("blurred"),
                    i(".arthrefSocialShare").find(".overlay").removeClass("active"),
                    i(".arthrefSocialShare").find("ul").removeClass("active"),
                    setTimeout(function () {
                        i(".arthrefSocialShare").find(".overlay").css("display", "none"), i(".arthrefSocialShare").remove();
                    }, 300);
            }
            var e = {
                social: "",
                name: "",
                title: document.title,
                shareUrl: window.location.href,
                description: i('meta[name="description"]').attr("content"),
                mediaUrl: "",
                animation: "launchpad",
                chainAnimationSpeed: 100,
                whenSelect: !1,
                selectContainer: "body",
                blur: !1,
            };
            if (i("#page-wrap").hasClass("mc-dark")) var t = "sdark";
            else t = "";
            var r =
                    '<div class="arthref arthrefSocialShare ' +
                    t +
                    '"><div class="overlay ' +
                    (s = i.extend(!0, e, s)).animation +
                    '"><div class="icon-container"><div class="centered"><div class="share-title"><h4>' +
                    s.name +
                    "</h4><h2>" +
                    s.title +
                    '</h2></div><ul class="social-icons">',
                o = "</ul></div></div></div></div>";
            return this.each(function () {
                var l = s,
                    e = i(this);
                l.whenSelect &&
                    i(l.selectContainer).mouseup(function (e) {
                        var a = (function () {
                            if (window.getSelection) return window.getSelection();
                            if (document.getSelection) return document.getSelection();
                            var e = document.selection && document.selection.createRange();
                            return !!e.text && e.text;
                        })();
                        a && (a = new String(a).replace(/^\s+|\s+$/g, "")) && (s.title = a);
                    }),
                    e.on("click", function () {
                        (function () {
                            for (
                                var e = {
                                  
                                        facebook: { text: "Facebook", className: "facebook", url: "http://www.facebook.com/sharer.php?u={u}", svg: '<use x="0" y="0" xlink:href="#global__symbols-facebook"></use>', da: "" },
                                        twitter: { text: "Twitter", className: "twitter", url: "http://twitter.com/home?status={t}%20{u}", svg: '<use x="0" y="0" xlink:href="#global__symbols-twitter"></use>', da: "" },
                                        google: { text: "Google+", className: "googleplus", url: "https://plus.google.com/share?url={u}", svg: '<use x="0" y="0" xlink:href="#global__symbols-gplus"></use>', da: "" },
                                        pinterest: {
                                            text: "Pinterest",
                                            className: "pinterest",
                                            url: "http://pinterest.com/pin/create/button/?url={u}&amp;media={m}&amp;description={t}",
                                            svg: '<use x="0" y="0" xlink:href="#global__symbols-pinterest"></use>',
                                            da: "",
                                        },
                                        linkedin: {
                                            text: "LinkedIn",
                                            className: "linkedin",
                                            url: "http://www.linkedin.com/shareArticle?mini=true&amp;url={u}&amp;title={t}&amp;ro=false&amp;summary=&amp;source=",
                                            svg: '<use x="0" y="0" xlink:href="#global__symbols-linkedin"></use>',
                                            da: "",
                                        },
                                        vkontakte: {
                                            text: "VKontakte",
                                            className: "vkontakte",
                                            url: "http://vk.com/share.php?url={u}&amp;title={t}&amp;image={m}",
                                            svg: '<use x="0" y="0" xlink:href="#global__symbols-vkontakte"></use>',
                                            da: "",
                                        },
                                        whatsapp: { text: "WhatsApp", className: "whatsapp", url: "whatsapp://send?text={u}", svg: '<use x="0" y="0" xlink:href="#global__symbols-whatsapp"></use>', da: "data-action='share/whatsapp/share'" },
                                        telegram: { text: "Telegram", className: "telegram", url: "https://t.me/share/url?url={u}", svg: '<use x="0" y="0" xlink:href="#global__symbols-telegram"></use>', da: "" },
                                        blogger: { text: "Blogger", className: "blogger", url: "http://www.blogger.com/blog_this.pyra?t=&amp;u={u}&amp;n={t}", svg: '<use x="0" y="0" xlink:href="#global__symbols-blogger"></use>', da: "" },
                                    },
                                    a = s.social.split(","),
                                    t = "",
                                    l = 0;
                                l <= a.length - 1;
                                l++
                            )
                                (e[a[l]].url = e[a[l]].url.replace("{t}", encodeURIComponent(s.title)).replace("{u}", encodeURI(s.shareUrl)).replace("{d}", encodeURIComponent(s.description)).replace("{m}", encodeURI(s.mediaUrl))),
                                    (t +=
                                        '<li class="' +
                                        e[a[l]].className +
                                        '"><a href="' +
                                        e[a[l]].url +
                                        '" class="social-icons__link" target="_blank" ' +
                                        e[a[l]].da +
                                        "><svg class='svg-icon' viewBox='0 0 24 24'>" +
                                        e[a[l]].svg +
                                        "</svg><span class='circle_bg'></span></a></li>");
                            i("body").append(r + t + o);
                        })(),
                            l.blur && (i(".arthrefSocialShare").find(".overlay").addClass("opaque"), i("body").addClass("blurred")),
                            i(".arthrefSocialShare").find(".overlay").css("display", "block"),
                            setTimeout(function () {
                                var e, a, t;
                                i(".arthrefSocialShare").find(".overlay").addClass("active"),
                                    i(".arthrefSocialShare").find("ul").addClass("active"),
                                    "chain" == l.animation &&
                                        ((e = i(".arthrefSocialShare").find("li")),
                                        (a = l.chainAnimationSpeed),
                                        (t = "1"),
                                        i(e).each(function (e) {
                                            i(this)
                                                .delay(e * a)
                                                .fadeTo(a, t);
                                        }));
                            }, 0);
                    }),
                    i(document).on("click touchstart", ".arthrefSocialShare .overlay", function (e) {
                        a(l);
                    }),
                    i(document).on("keydown", function (e) {
                        27 == e.keyCode && a(l);
                    }),
                    i(document).on("click touchstart", ".arthrefSocialShare li", function (e) {
                        e.stopPropagation();
                    });
            });
        },
    });
})(jQuery);
/*! typed.js v1.1.7 */
!(function (t, s, e) {
    "use strict";
    var i = function (t, s) {
        var i = this;
        (this.el = t),
            (this.options = {}),
            Object.keys(r).forEach(function (t) {
                i.options[t] = r[t];
            }),
            Object.keys(s).forEach(function (t) {
                i.options[t] = s[t];
            }),
            (this.isInput = "input" === this.el.tagName.toLowerCase()),
            (this.attr = this.options.attr),
            (this.showCursor = !this.isInput && this.options.showCursor),
            (this.elContent = this.attr ? this.el.getAttribute(this.attr) : this.el.textContent),
            (this.contentType = this.options.contentType),
            (this.typeSpeed = this.options.typeSpeed),
            (this.startDelay = this.options.startDelay),
            (this.backSpeed = this.options.backSpeed),
            (this.backDelay = this.options.backDelay),
            (this.fadeOut = this.options.fadeOut),
            (this.fadeOutClass = this.options.fadeOutClass),
            (this.fadeOutDelay = this.options.fadeOutDelay),
            e && this.options.stringsElement instanceof e ? (this.stringsElement = this.options.stringsElement[0]) : (this.stringsElement = this.options.stringsElement),
            (this.strings = this.options.strings),
            (this.strPos = 0),
            (this.arrayPos = 0),
            (this.stopNum = 0),
            (this.loop = this.options.loop),
            (this.loopCount = this.options.loopCount),
            (this.curLoop = 0),
            (this.stop = !1),
            (this.cursorChar = this.options.cursorChar),
            (this.shuffle = this.options.shuffle),
            (this.sequence = []),
            this.build();
    };
    (i.prototype = {
        constructor: i,
        init: function () {
            var t = this;
            t.timeout = setTimeout(function () {
                for (var s = 0; s < t.strings.length; ++s) t.sequence[s] = s;
                t.shuffle && (t.sequence = t.shuffleArray(t.sequence)), t.typewrite(t.strings[t.sequence[t.arrayPos]], t.strPos);
            }, t.startDelay);
        },
        build: function () {
            var t = this;
            if (
                (this.showCursor === !0 &&
                    ((this.cursor = s.createElement("span")), (this.cursor.className = "typed-cursor"), (this.cursor.innerHTML = this.cursorChar), this.el.parentNode && this.el.parentNode.insertBefore(this.cursor, this.el.nextSibling)),
                this.stringsElement)
            ) {
                (this.strings = []), (this.stringsElement.style.display = "none");
                var e = Array.prototype.slice.apply(this.stringsElement.children);
                e.forEach(function (s) {
                    t.strings.push(s.innerHTML);
                });
            }
            this.init();
        },
        typewrite: function (t, s) {
            if (this.stop !== !0) {
                this.fadeOut && this.el.classList.contains(this.fadeOutClass) && (this.el.classList.remove(this.fadeOutClass), this.cursor.classList.remove(this.fadeOutClass));
                var e = Math.round(70 * Math.random()) + this.typeSpeed,
                    i = this;
                i.timeout = setTimeout(function () {
                    var e = 0,
                        r = t.substr(s);
                    if ("^" === r.charAt(0)) {
                        var o = 1;
                        /^\^\d+/.test(r) && ((r = /\d+/.exec(r)[0]), (o += r.length), (e = parseInt(r))), (t = t.substring(0, s) + t.substring(s + o));
                    }
                    if ("html" === i.contentType) {
                        var n = t.substr(s).charAt(0);
                        if ("<" === n || "&" === n) {
                            var a = "",
                                h = "";
                            for (h = "<" === n ? ">" : ";"; t.substr(s + 1).charAt(0) !== h && ((a += t.substr(s).charAt(0)), s++, !(s + 1 > t.length)); );
                            s++, (a += h);
                        }
                    }
                    i.timeout = setTimeout(function () {
                        if (s === t.length) {
                            if ((i.options.onStringTyped(i.arrayPos), i.arrayPos === i.strings.length - 1 && (i.options.callback(), i.curLoop++, i.loop === !1 || i.curLoop === i.loopCount))) return;
                            i.timeout = setTimeout(function () {
                                i.backspace(t, s);
                            }, i.backDelay);
                        } else {
                            0 === s && i.options.preStringTyped(i.arrayPos);
                            var e = t.substr(0, s + 1);
                            i.attr ? i.el.setAttribute(i.attr, e) : i.isInput ? (i.el.value = e) : "html" === i.contentType ? (i.el.innerHTML = e) : (i.el.textContent = e), s++, i.typewrite(t, s);
                        }
                    }, e);
                }, e);
            }
        },
        backspace: function (t, s) {
            var e = this;
            if (this.stop !== !0) {
                if (this.fadeOut) return void this.initFadeOut();
                var i = Math.round(70 * Math.random()) + this.backSpeed;
                e.timeout = setTimeout(function () {
                    if ("html" === e.contentType && ">" === t.substr(s).charAt(0)) {
                        for (var i = ""; "<" !== t.substr(s - 1).charAt(0) && ((i -= t.substr(s).charAt(0)), s--, !(s < 0)); );
                        s--, (i += "<");
                    }
                    var r = t.substr(0, s);
                    e.replaceText(r),
                        s > e.stopNum
                            ? (s--, e.backspace(t, s))
                            : s <= e.stopNum && (e.arrayPos++, e.arrayPos === e.strings.length ? ((e.arrayPos = 0), e.shuffle && (e.sequence = e.shuffleArray(e.sequence)), e.init()) : e.typewrite(e.strings[e.sequence[e.arrayPos]], s));
                }, i);
            }
        },
        initFadeOut: function () {
            return (
                (self = this),
                (this.el.className += " " + this.fadeOutClass),
                (this.cursor.className += " " + this.fadeOutClass),
                setTimeout(function () {
                    self.arrayPos++, self.replaceText(""), self.typewrite(self.strings[self.sequence[self.arrayPos]], 0);
                }, self.fadeOutDelay)
            );
        },
        replaceText: function (t) {
            this.attr ? this.el.setAttribute(this.attr, t) : this.isInput ? (this.el.value = t) : "html" === this.contentType ? (this.el.innerHTML = t) : (this.el.textContent = t);
        },
        shuffleArray: function (t) {
            var s,
                e,
                i = t.length;
            if (i) for (; --i; ) (e = Math.floor(Math.random() * (i + 1))), (s = t[e]), (t[e] = t[i]), (t[i] = s);
            return t;
        },
        reset: function () {
            var t = this;
            clearInterval(t.timeout);
            this.el.getAttribute("id");
            (this.el.textContent = ""),
                "undefined" != typeof this.cursor && "undefined" != typeof this.cursor.parentNode && this.cursor.parentNode.removeChild(this.cursor),
                (this.strPos = 0),
                (this.arrayPos = 0),
                (this.curLoop = 0),
                this.options.resetCallback();
        },
    }),
        (i["new"] = function (t, e) {
            var r = Array.prototype.slice.apply(s.querySelectorAll(t));
            r.forEach(function (t) {
                var s = t._typed,
                    r = "object" == typeof e && e;
                s && s.reset(), (t._typed = s = new i(t, r)), "string" == typeof e && s[e]();
            });
        }),
        e &&
            (e.fn.typed = function (t) {
                return this.each(function () {
                    var s = e(this),
                        r = s.data("typed"),
                        o = "object" == typeof t && t;
                    r && r.reset(), s.data("typed", (r = new i(this, o))), "string" == typeof t && r[t]();
                });
            }),
        (t.Typed = i);
    var r = {
        strings: ["These are the default values...", "You know what you should do?", "Use your own!", "Have a great day!"],
        stringsElement: null,
        typeSpeed: 0,
        startDelay: 0,
        backSpeed: 0,
        shuffle: !1,
        backDelay: 500,
        fadeOut: !1,
        fadeOutClass: "typed-fade-out",
        fadeOutDelay: 500,
        loop: !1,
        loopCount: !1,
        showCursor: !0,
        cursorChar: "|",
        attr: null,
        contentType: "html",
        callback: function () {},
        preStringTyped: function () {},
        onStringTyped: function () {},
        resetCallback: function () {},
    };
})(window, document, window.jQuery);
/*! TweenLite */
var _gsScope;
!(function (p, _) {
    "use strict";
    var c = {},
        r = p.document,
        d = (p.GreenSockGlobals = p.GreenSockGlobals || p),
        t = d[_];
    if (t) return "undefined" != typeof module && module.exports && (module.exports = t);
    var e,
        i,
        s,
        m,
        g,
        n,
        a,
        v = function (t) {
            var e,
                i = t.split("."),
                r = d;
            for (e = 0; e < i.length; e++) r[i[e]] = r = r[i[e]] || {};
            return r;
        },
        u = v("com.greensock"),
        y = 1e-10,
        l = function (t) {
            var e,
                i = [],
                r = t.length;
            for (e = 0; e !== r; i.push(t[e++]));
            return i;
        },
        x = function () {},
        T =
            ((n = Object.prototype.toString),
            (a = n.call([])),
            function (t) {
                return null != t && (t instanceof Array || ("object" == typeof t && !!t.push && n.call(t) === a));
            }),
        b = {},
        w = function (o, l, h, f) {
            (this.sc = b[o] ? b[o].sc : []), ((b[o] = this).gsClass = null), (this.func = h);
            var u = [];
            (this.check = function (t) {
                for (var e, i, r, s, n = l.length, a = n; -1 < --n; ) (e = b[l[n]] || new w(l[n], [])).gsClass ? ((u[n] = e.gsClass), a--) : t && e.sc.push(this);
                if (0 === a && h) {
                    if (((r = (i = ("com.greensock." + o).split(".")).pop()), (s = v(i.join("."))[r] = this.gsClass = h.apply(h, u)), f))
                        if (((d[r] = c[r] = s), "undefined" != typeof module && module.exports))
                            if (o === _) for (n in ((module.exports = c[_] = s), c)) s[n] = c[n];
                            else c[_] && (c[_][r] = s);
                        else
                            "function" == typeof define &&
                                define.amd &&
                                define((p.GreenSockAMDPath ? p.GreenSockAMDPath + "/" : "") + o.split(".").pop(), [], function () {
                                    return s;
                                });
                    for (n = 0; n < this.sc.length; n++) this.sc[n].check();
                }
            }),
                this.check(!0);
        },
        o = (p._gsDefine = function (t, e, i, r) {
            return new w(t, e, i, r);
        }),
        P = (u._class = function (t, e, i) {
            return (
                (e = e || function () {}),
                o(
                    t,
                    [],
                    function () {
                        return e;
                    },
                    i
                ),
                e
            );
        });
    o.globals = d;
    var h = [0, 0, 1, 1],
        O = P(
            "easing.Ease",
            function (t, e, i, r) {
                (this._func = t), (this._type = i || 0), (this._power = r || 0), (this._params = e ? h.concat(e) : h);
            },
            !0
        ),
        S = (O.map = {}),
        f = (O.register = function (t, e, i, r) {
            for (var s, n, a, o, l = e.split(","), h = l.length, f = (i || "easeIn,easeOut,easeInOut").split(","); -1 < --h; )
                for (n = l[h], s = r ? P("easing." + n, null, !0) : u.easing[n] || {}, a = f.length; -1 < --a; ) (o = f[a]), (S[n + "." + o] = S[o + n] = s[o] = t.getRatio ? t : t[o] || new t());
        });
    for (
        (s = O.prototype)._calcEnd = !1,
            s.getRatio = function (t) {
                if (this._func) return (this._params[0] = t), this._func.apply(null, this._params);
                var e = this._type,
                    i = this._power,
                    r = 1 === e ? 1 - t : 2 === e ? t : t < 0.5 ? 2 * t : 2 * (1 - t);
                return 1 === i ? (r *= r) : 2 === i ? (r *= r * r) : 3 === i ? (r *= r * r * r) : 4 === i && (r *= r * r * r * r), 1 === e ? 1 - r : 2 === e ? r : t < 0.5 ? r / 2 : 1 - r / 2;
            },
            i = (e = ["Linear", "Quad", "Cubic", "Quart", "Quint,Strong"]).length;
        -1 < --i;

    )
        (s = e[i] + ",Power" + i), f(new O(null, null, 1, i), s, "easeOut", !0), f(new O(null, null, 2, i), s, "easeIn" + (0 === i ? ",easeNone" : "")), f(new O(null, null, 3, i), s, "easeInOut");
    (S.linear = u.easing.Linear.easeIn), (S.swing = u.easing.Quad.easeInOut);
    var k = P("events.EventDispatcher", function (t) {
        (this._listeners = {}), (this._eventTarget = t || this);
    });
    ((s = k.prototype).addEventListener = function (t, e, i, r, s) {
        s = s || 0;
        var n,
            a,
            o = this._listeners[t],
            l = 0;
        for (this !== m || g || m.wake(), null == o && (this._listeners[t] = o = []), a = o.length; -1 < --a; ) (n = o[a]).c === e && n.s === i ? o.splice(a, 1) : 0 === l && n.pr < s && (l = a + 1);
        o.splice(l, 0, { c: e, s: i, up: r, pr: s });
    }),
        (s.removeEventListener = function (t, e) {
            var i,
                r = this._listeners[t];
            if (r) for (i = r.length; -1 < --i; ) if (r[i].c === e) return void r.splice(i, 1);
        }),
        (s.dispatchEvent = function (t) {
            var e,
                i,
                r,
                s = this._listeners[t];
            if (s) for (1 < (e = s.length) && (s = s.slice(0)), i = this._eventTarget; -1 < --e; ) (r = s[e]) && (r.up ? r.c.call(r.s || i, { type: t, target: i }) : r.c.call(r.s || i));
        });
    var A = p.requestAnimationFrame,
        C = p.cancelAnimationFrame,
        R =
            Date.now ||
            function () {
                return new Date().getTime();
            },
        M = R();
    for (i = (e = ["ms", "moz", "webkit", "o"]).length; -1 < --i && !A; ) (A = p[e[i] + "RequestAnimationFrame"]), (C = p[e[i] + "CancelAnimationFrame"] || p[e[i] + "CancelRequestAnimationFrame"]);
    P("Ticker", function (t, e) {
        var s,
            n,
            a,
            o,
            l,
            h = this,
            f = R(),
            i = !(!1 === e || !A) && "auto",
            u = 500,
            p = 33,
            _ = function (t) {
                var e,
                    i,
                    r = R() - M;
                u < r && (f += r - p), (M += r), (h.time = (M - f) / 1e3), (e = h.time - l), (!s || 0 < e || !0 === t) && (h.frame++, (l += e + (o <= e ? 0.004 : o - e)), (i = !0)), !0 !== t && (a = n(_)), i && h.dispatchEvent("tick");
            };
        k.call(h),
            (h.time = h.frame = 0),
            (h.tick = function () {
                _(!0);
            }),
            (h.lagSmoothing = function (t, e) {
                return arguments.length ? ((u = t || 1 / y), void (p = Math.min(e, u, 0))) : u < 1 / y;
            }),
            (h.sleep = function () {
                null != a && (i && C ? C(a) : clearTimeout(a), (n = x), (a = null), h === m && (g = !1));
            }),
            (h.wake = function (t) {
                null !== a ? h.sleep() : t ? (f += -M + (M = R())) : 10 < h.frame && (M = R() - u + 5),
                    (n =
                        0 === s
                            ? x
                            : i && A
                            ? A
                            : function (t) {
                                  return setTimeout(t, (1e3 * (l - h.time) + 1) | 0);
                              }),
                    h === m && (g = !0),
                    _(2);
            }),
            (h.fps = function (t) {
                return arguments.length ? ((o = 1 / ((s = t) || 60)), (l = this.time + o), void h.wake()) : s;
            }),
            (h.useRAF = function (t) {
                return arguments.length ? (h.sleep(), (i = t), void h.fps(s)) : i;
            }),
            h.fps(t),
            setTimeout(function () {
                "auto" === i && h.frame < 5 && "hidden" !== (r || {}).visibilityState && h.useRAF(!1);
            }, 1500);
    }),
        ((s = u.Ticker.prototype = new u.events.EventDispatcher()).constructor = u.Ticker);
    var F = P("core.Animation", function (t, e) {
        if (
            ((this.vars = e = e || {}),
            (this._duration = this._totalDuration = t || 0),
            (this._delay = Number(e.delay) || 0),
            (this._timeScale = 1),
            (this._active = !0 === e.immediateRender),
            (this.data = e.data),
            (this._reversed = !0 === e.reversed),
            $)
        ) {
            g || m.wake();
            var i = this.vars.useFrames ? Q : $;
            i.add(this, i._time), this.vars.paused && this.paused(!0);
        }
    });
    (m = F.ticker = new u.Ticker()),
        ((s = F.prototype)._dirty = s._gc = s._initted = s._paused = !1),
        (s._totalTime = s._time = 0),
        (s._rawPrevTime = -1),
        (s._next = s._last = s._onUpdate = s._timeline = s.timeline = null),
        (s._paused = !1);
    var D = function () {
        g && 2e3 < R() - M && ("hidden" !== (r || {}).visibilityState || !m.lagSmoothing()) && m.wake();
        var t = setTimeout(D, 2e3);
        t.unref && t.unref();
    };
    D(),
        (s.play = function (t, e) {
            return null != t && this.seek(t, e), this.reversed(!1).paused(!1);
        }),
        (s.pause = function (t, e) {
            return null != t && this.seek(t, e), this.paused(!0);
        }),
        (s.resume = function (t, e) {
            return null != t && this.seek(t, e), this.paused(!1);
        }),
        (s.seek = function (t, e) {
            return this.totalTime(Number(t), !1 !== e);
        }),
        (s.restart = function (t, e) {
            return this.reversed(!1)
                .paused(!1)
                .totalTime(t ? -this._delay : 0, !1 !== e, !0);
        }),
        (s.reverse = function (t, e) {
            return null != t && this.seek(t || this.totalDuration(), e), this.reversed(!0).paused(!1);
        }),
        (s.render = function (t, e, i) {}),
        (s.invalidate = function () {
            return (this._time = this._totalTime = 0), (this._initted = this._gc = !1), (this._rawPrevTime = -1), (this._gc || !this.timeline) && this._enabled(!0), this;
        }),
        (s.isActive = function () {
            var t,
                e = this._timeline,
                i = this._startTime;
            return !e || (!this._gc && !this._paused && e.isActive() && (t = e.rawTime(!0)) >= i && t < i + this.totalDuration() / this._timeScale - 1e-7);
        }),
        (s._enabled = function (t, e) {
            return g || m.wake(), (this._gc = !t), (this._active = this.isActive()), !0 !== e && (t && !this.timeline ? this._timeline.add(this, this._startTime - this._delay) : !t && this.timeline && this._timeline._remove(this, !0)), !1;
        }),
        (s._kill = function (t, e) {
            return this._enabled(!1, !1);
        }),
        (s.kill = function (t, e) {
            return this._kill(t, e), this;
        }),
        (s._uncache = function (t) {
            for (var e = t ? this : this.timeline; e; ) (e._dirty = !0), (e = e.timeline);
            return this;
        }),
        (s._swapSelfInParams = function (t) {
            for (var e = t.length, i = t.concat(); -1 < --e; ) "{self}" === t[e] && (i[e] = this);
            return i;
        }),
        (s._callback = function (t) {
            var e = this.vars,
                i = e[t],
                r = e[t + "Params"],
                s = e[t + "Scope"] || e.callbackScope || this;
            switch (r ? r.length : 0) {
                case 0:
                    i.call(s);
                    break;
                case 1:
                    i.call(s, r[0]);
                    break;
                case 2:
                    i.call(s, r[0], r[1]);
                    break;
                default:
                    i.apply(s, r);
            }
        }),
        (s.eventCallback = function (t, e, i, r) {
            if ("on" === (t || "").substr(0, 2)) {
                var s = this.vars;
                if (1 === arguments.length) return s[t];
                null == e ? delete s[t] : ((s[t] = e), (s[t + "Params"] = T(i) && -1 !== i.join("").indexOf("{self}") ? this._swapSelfInParams(i) : i), (s[t + "Scope"] = r)), "onUpdate" === t && (this._onUpdate = e);
            }
            return this;
        }),
        (s.delay = function (t) {
            return arguments.length ? (this._timeline.smoothChildTiming && this.startTime(this._startTime + t - this._delay), (this._delay = t), this) : this._delay;
        }),
        (s.duration = function (t) {
            return arguments.length
                ? ((this._duration = this._totalDuration = t),
                  this._uncache(!0),
                  this._timeline.smoothChildTiming && 0 < this._time && this._time < this._duration && 0 !== t && this.totalTime(this._totalTime * (t / this._duration), !0),
                  this)
                : ((this._dirty = !1), this._duration);
        }),
        (s.totalDuration = function (t) {
            return (this._dirty = !1), arguments.length ? this.duration(t) : this._totalDuration;
        }),
        (s.time = function (t, e) {
            return arguments.length ? (this._dirty && this.totalDuration(), this.totalTime(t > this._duration ? this._duration : t, e)) : this._time;
        }),
        (s.totalTime = function (t, e, i) {
            if ((g || m.wake(), !arguments.length)) return this._totalTime;
            if (this._timeline) {
                if ((t < 0 && !i && (t += this.totalDuration()), this._timeline.smoothChildTiming)) {
                    this._dirty && this.totalDuration();
                    var r = this._totalDuration,
                        s = this._timeline;
                    if ((r < t && !i && (t = r), (this._startTime = (this._paused ? this._pauseTime : s._time) - (this._reversed ? r - t : t) / this._timeScale), s._dirty || this._uncache(!1), s._timeline))
                        for (; s._timeline; ) s._timeline._time !== (s._startTime + s._totalTime) / s._timeScale && s.totalTime(s._totalTime, !0), (s = s._timeline);
                }
                this._gc && this._enabled(!0, !1), (this._totalTime !== t || 0 === this._duration) && (N.length && J(), this.render(t, e, !1), N.length && J());
            }
            return this;
        }),
        (s.progress = s.totalProgress = function (t, e) {
            var i = this.duration();
            return arguments.length ? this.totalTime(i * t, e) : i ? this._time / i : this.ratio;
        }),
        (s.startTime = function (t) {
            return arguments.length ? (t !== this._startTime && ((this._startTime = t), this.timeline && this.timeline._sortChildren && this.timeline.add(this, t - this._delay)), this) : this._startTime;
        }),
        (s.endTime = function (t) {
            return this._startTime + (0 != t ? this.totalDuration() : this.duration()) / this._timeScale;
        }),
        (s.timeScale = function (t) {
            if (!arguments.length) return this._timeScale;
            var e, i;
            for (
                t = t || y,
                    this._timeline && this._timeline.smoothChildTiming && ((i = (e = this._pauseTime) || 0 === e ? e : this._timeline.totalTime()), (this._startTime = i - ((i - this._startTime) * this._timeScale) / t)),
                    this._timeScale = t,
                    i = this.timeline;
                i && i.timeline;

            )
                (i._dirty = !0), i.totalDuration(), (i = i.timeline);
            return this;
        }),
        (s.reversed = function (t) {
            return arguments.length
                ? (t != this._reversed && ((this._reversed = t), this.totalTime(this._timeline && !this._timeline.smoothChildTiming ? this.totalDuration() - this._totalTime : this._totalTime, !0)), this)
                : this._reversed;
        }),
        (s.paused = function (t) {
            if (!arguments.length) return this._paused;
            var e,
                i,
                r = this._timeline;
            return (
                t != this._paused &&
                    r &&
                    (g || t || m.wake(),
                    (i = (e = r.rawTime()) - this._pauseTime),
                    !t && r.smoothChildTiming && ((this._startTime += i), this._uncache(!1)),
                    (this._pauseTime = t ? e : null),
                    (this._paused = t),
                    (this._active = this.isActive()),
                    !t && 0 !== i && this._initted && this.duration() && ((e = r.smoothChildTiming ? this._totalTime : (e - this._startTime) / this._timeScale), this.render(e, e === this._totalTime, !0))),
                this._gc && !t && this._enabled(!0, !1),
                this
            );
        });
    var X = P("core.SimpleTimeline", function (t) {
        F.call(this, 0, t), (this.autoRemoveChildren = this.smoothChildTiming = !0);
    });
    ((s = X.prototype = new F()).constructor = X),
        (s.kill()._gc = !1),
        (s._first = s._last = s._recent = null),
        (s._sortChildren = !1),
        (s.add = s.insert = function (t, e, i, r) {
            var s, n;
            if (
                ((t._startTime = Number(e || 0) + t._delay),
                t._paused && this !== t._timeline && (t._pauseTime = this.rawTime() - (t._timeline.rawTime() - t._pauseTime)),
                t.timeline && t.timeline._remove(t, !0),
                (t.timeline = t._timeline = this),
                t._gc && t._enabled(!0, !0),
                (s = this._last),
                this._sortChildren)
            )
                for (n = t._startTime; s && s._startTime > n; ) s = s._prev;
            return s ? ((t._next = s._next), (s._next = t)) : ((t._next = this._first), (this._first = t)), t._next ? (t._next._prev = t) : (this._last = t), (t._prev = s), (this._recent = t), this._timeline && this._uncache(!0), this;
        }),
        (s._remove = function (t, e) {
            return (
                t.timeline === this &&
                    (e || t._enabled(!1, !0),
                    t._prev ? (t._prev._next = t._next) : this._first === t && (this._first = t._next),
                    t._next ? (t._next._prev = t._prev) : this._last === t && (this._last = t._prev),
                    (t._next = t._prev = t.timeline = null),
                    t === this._recent && (this._recent = this._last),
                    this._timeline && this._uncache(!0)),
                this
            );
        }),
        (s.render = function (t, e, i) {
            var r,
                s = this._first;
            for (this._totalTime = this._time = this._rawPrevTime = t; s; )
                (r = s._next),
                    (s._active || (t >= s._startTime && !s._paused && !s._gc)) &&
                        (s._reversed ? s.render((s._dirty ? s.totalDuration() : s._totalDuration) - (t - s._startTime) * s._timeScale, e, i) : s.render((t - s._startTime) * s._timeScale, e, i)),
                    (s = r);
        }),
        (s.rawTime = function () {
            return g || m.wake(), this._totalTime;
        });
    var z = P(
            "TweenLite",
            function (t, e, i) {
                if ((F.call(this, e, i), (this.render = z.prototype.render), null == t)) throw "Cannot tween a null target.";
                this.target = t = "string" != typeof t ? t : z.selector(t) || t;
                var r,
                    s,
                    n,
                    a = t.jquery || (t.length && t !== p && t[0] && (t[0] === p || (t[0].nodeType && t[0].style && !t.nodeType))),
                    o = this.vars.overwrite;
                if (((this._overwrite = o = null == o ? H[z.defaultOverwrite] : "number" == typeof o ? o >> 0 : H[o]), (a || t instanceof Array || (t.push && T(t))) && "number" != typeof t[0]))
                    for (this._targets = n = l(t), this._propLookup = [], this._siblings = [], r = 0; r < n.length; r++)
                        (s = n[r])
                            ? "string" != typeof s
                                ? s.length && s !== p && s[0] && (s[0] === p || (s[0].nodeType && s[0].style && !s.nodeType))
                                    ? (n.splice(r--, 1), (this._targets = n = n.concat(l(s))))
                                    : ((this._siblings[r] = tt(s, this, !1)), 1 === o && 1 < this._siblings[r].length && it(s, this, null, 1, this._siblings[r]))
                                : "string" == typeof (s = n[r--] = z.selector(s)) && n.splice(r + 1, 1)
                            : n.splice(r--, 1);
                else (this._propLookup = {}), (this._siblings = tt(t, this, !1)), 1 === o && 1 < this._siblings.length && it(t, this, null, 1, this._siblings);
                (this.vars.immediateRender || (0 === e && 0 === this._delay && !1 !== this.vars.immediateRender)) && ((this._time = -y), this.render(Math.min(0, -this._delay)));
            },
            !0
        ),
        L = function (t) {
            return t && t.length && t !== p && t[0] && (t[0] === p || (t[0].nodeType && t[0].style && !t.nodeType));
        };
    ((s = z.prototype = new F()).constructor = z),
        (s.kill()._gc = !1),
        (s.ratio = 0),
        (s._firstPT = s._targets = s._overwrittenProps = s._startAt = null),
        (s._notifyPluginsOfEnabled = s._lazy = !1),
        (z.version = "2.0.2"),
        (z.defaultEase = s._ease = new O(null, null, 1, 1)),
        (z.defaultOverwrite = "auto"),
        (z.ticker = m),
        (z.autoSleep = 120),
        (z.lagSmoothing = function (t, e) {
            m.lagSmoothing(t, e);
        }),
        (z.selector =
            p.$ ||
            p.jQuery ||
            function (t) {
                var e = p.$ || p.jQuery;
                return e ? (z.selector = e)(t) : (r || (r = p.document), r ? (r.querySelectorAll ? r.querySelectorAll(t) : r.getElementById("#" === t.charAt(0) ? t.substr(1) : t)) : t);
            });
    var N = [],
        I = {},
        Y = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi,
        j = /[\+-]=-?[\.\d]/,
        E = function (t) {
            for (var e, i = this._firstPT; i; )
                (e = i.blob ? (1 === t && null != this.end ? this.end : t ? this.join("") : this.start) : i.c * t + i.s),
                    i.m ? (e = i.m.call(this._tween, e, this._target || i.t, this._tween)) : e < 1e-6 && -1e-6 < e && !i.blob && (e = 0),
                    i.f ? (i.fp ? i.t[i.p](i.fp, e) : i.t[i.p](e)) : (i.t[i.p] = e),
                    (i = i._next);
        },
        B = function (t, e, i, r) {
            var s,
                n,
                a,
                o,
                l,
                h,
                f,
                u = [],
                p = 0,
                _ = "",
                c = 0;
            for (
                u.start = t,
                    u.end = e,
                    t = u[0] = t + "",
                    e = u[1] = e + "",
                    i && (i(u), (t = u[0]), (e = u[1])),
                    u.length = 0,
                    s = t.match(Y) || [],
                    n = e.match(Y) || [],
                    r && ((r._next = null), (r.blob = 1), (u._firstPT = u._applyPT = r)),
                    l = n.length,
                    o = 0;
                o < l;
                o++
            )
                (f = n[o]),
                    (_ += (h = e.substr(p, e.indexOf(f, p) - p)) || !o ? h : ","),
                    (p += h.length),
                    c ? (c = (c + 1) % 5) : "rgba(" === h.substr(-5) && (c = 1),
                    f === s[o] || s.length <= o
                        ? (_ += f)
                        : (_ && (u.push(_), (_ = "")),
                          (a = parseFloat(s[o])),
                          u.push(a),
                          (u._firstPT = {
                              _next: u._firstPT,
                              t: u,
                              p: u.length - 1,
                              s: a,
                              c: ("=" === f.charAt(1) ? parseInt(f.charAt(0) + "1", 10) * parseFloat(f.substr(2)) : parseFloat(f) - a) || 0,
                              f: 0,
                              m: c && c < 4 ? Math.round : 0,
                          })),
                    (p += f.length);
            return (_ += e.substr(p)) && u.push(_), (u.setRatio = E), j.test(e) && (u.end = null), u;
        },
        V = function (t, e, i, r, s, n, a, o, l) {
            "function" == typeof r && (r = r(l || 0, t));
            var h = typeof t[e],
                f = "function" !== h ? "" : e.indexOf("set") || "function" != typeof t["get" + e.substr(3)] ? e : "get" + e.substr(3),
                u = "get" !== i ? i : f ? (a ? t[f](a) : t[f]()) : t[e],
                p = "string" == typeof r && "=" === r.charAt(1),
                _ = { t: t, p: e, s: u, f: "function" === h, pg: 0, n: s || e, m: n ? ("function" == typeof n ? n : Math.round) : 0, pr: 0, c: p ? parseInt(r.charAt(0) + "1", 10) * parseFloat(r.substr(2)) : parseFloat(r) - u || 0 };
            return (
                ("number" != typeof u || ("number" != typeof r && !p)) &&
                    (a || isNaN(u) || (!p && isNaN(r)) || "boolean" == typeof u || "boolean" == typeof r
                        ? ((_.fp = a), (_ = { t: B(u, p ? parseFloat(_.s) + _.c + (_.s + "").replace(/[0-9\-\.]/g, "") : r, o || z.defaultStringFilter, _), p: "setRatio", s: 0, c: 1, f: 2, pg: 0, n: s || e, pr: 0, m: 0 }))
                        : ((_.s = parseFloat(u)), p || (_.c = parseFloat(r) - _.s || 0))),
                _.c ? ((_._next = this._firstPT) && (_._next._prev = _), (this._firstPT = _)) : void 0
            );
        },
        U = (z._internals = { isArray: T, isSelector: L, lazyTweens: N, blobDif: B }),
        W = (z._plugins = {}),
        G = (U.tweenLookup = {}),
        q = 0,
        Z = (U.reservedProps = {
            ease: 1,
            delay: 1,
            overwrite: 1,
            onComplete: 1,
            onCompleteParams: 1,
            onCompleteScope: 1,
            useFrames: 1,
            runBackwards: 1,
            startAt: 1,
            onUpdate: 1,
            onUpdateParams: 1,
            onUpdateScope: 1,
            onStart: 1,
            onStartParams: 1,
            onStartScope: 1,
            onReverseComplete: 1,
            onReverseCompleteParams: 1,
            onReverseCompleteScope: 1,
            onRepeat: 1,
            onRepeatParams: 1,
            onRepeatScope: 1,
            easeParams: 1,
            yoyo: 1,
            immediateRender: 1,
            repeat: 1,
            repeatDelay: 1,
            data: 1,
            paused: 1,
            reversed: 1,
            autoCSS: 1,
            lazy: 1,
            onOverwrite: 1,
            callbackScope: 1,
            stringFilter: 1,
            id: 1,
            yoyoEase: 1,
        }),
        H = { none: 0, all: 1, auto: 2, concurrent: 3, allOnStart: 4, preexisting: 5, true: 1, false: 0 },
        Q = (F._rootFramesTimeline = new X()),
        $ = (F._rootTimeline = new X()),
        K = 30,
        J = (U.lazyRender = function () {
            var t,
                e = N.length;
            for (I = {}; -1 < --e; ) (t = N[e]) && !1 !== t._lazy && (t.render(t._lazy[0], t._lazy[1], !0), (t._lazy = !1));
            N.length = 0;
        });
    ($._startTime = m.time),
        (Q._startTime = m.frame),
        ($._active = Q._active = !0),
        setTimeout(J, 1),
        (F._updateRoot = z.render = function () {
            var t, e, i;
            if ((N.length && J(), $.render((m.time - $._startTime) * $._timeScale, !1, !1), Q.render((m.frame - Q._startTime) * Q._timeScale, !1, !1), N.length && J(), m.frame >= K)) {
                for (i in ((K = m.frame + (parseInt(z.autoSleep, 10) || 120)), G)) {
                    for (t = (e = G[i].tweens).length; -1 < --t; ) e[t]._gc && e.splice(t, 1);
                    0 === e.length && delete G[i];
                }
                if ((!(i = $._first) || i._paused) && z.autoSleep && !Q._first && 1 === m._listeners.tick.length) {
                    for (; i && i._paused; ) i = i._next;
                    i || m.sleep();
                }
            }
        }),
        m.addEventListener("tick", F._updateRoot);
    var tt = function (t, e, i) {
            var r,
                s,
                n = t._gsTweenID;
            if ((G[n || (t._gsTweenID = n = "t" + q++)] || (G[n] = { target: t, tweens: [] }), e && (((r = G[n].tweens)[(s = r.length)] = e), i))) for (; -1 < --s; ) r[s] === e && r.splice(s, 1);
            return G[n].tweens;
        },
        et = function (t, e, i, r) {
            var s,
                n,
                a = t.vars.onOverwrite;
            return a && (s = a(t, e, i, r)), (a = z.onOverwrite) && (n = a(t, e, i, r)), !1 !== s && !1 !== n;
        },
        it = function (t, e, i, r, s) {
            var n, a, o, l;
            if (1 === r || 4 <= r) {
                for (l = s.length, n = 0; n < l; n++)
                    if ((o = s[n]) !== e) o._gc || (o._kill(null, t, e) && (a = !0));
                    else if (5 === r) break;
                return a;
            }
            var h,
                f = e._startTime + y,
                u = [],
                p = 0,
                _ = 0 === e._duration;
            for (n = s.length; -1 < --n; )
                (o = s[n]) === e ||
                    o._gc ||
                    o._paused ||
                    (o._timeline !== e._timeline
                        ? ((h = h || rt(e, 0, _)), 0 === rt(o, h, _) && (u[p++] = o))
                        : o._startTime <= f && o._startTime + o.totalDuration() / o._timeScale > f && (((_ || !o._initted) && f - o._startTime <= 2e-10) || (u[p++] = o)));
            for (n = p; -1 < --n; )
                if (((l = (o = u[n])._firstPT), 2 === r && o._kill(i, t, e) && (a = !0), 2 !== r || (!o._firstPT && o._initted && l))) {
                    if (2 !== r && !et(o, e)) continue;
                    o._enabled(!1, !1) && (a = !0);
                }
            return a;
        },
        rt = function (t, e, i) {
            for (var r = t._timeline, s = r._timeScale, n = t._startTime; r._timeline; ) {
                if (((n += r._startTime), (s *= r._timeScale), r._paused)) return -100;
                r = r._timeline;
            }
            return e < (n /= s) ? n - e : (i && n === e) || (!t._initted && n - e < 2 * y) ? y : (n += t.totalDuration() / t._timeScale / s) > e + y ? 0 : n - e - y;
        };
    (s._init = function () {
        var t,
            e,
            i,
            r,
            s,
            n,
            a = this.vars,
            o = this._overwrittenProps,
            l = this._duration,
            h = !!a.immediateRender,
            f = a.ease;
        if (a.startAt) {
            for (r in (this._startAt && (this._startAt.render(-1, !0), this._startAt.kill()), (s = {}), a.startAt)) s[r] = a.startAt[r];
            if (
                ((s.data = "isStart"),
                (s.overwrite = !1),
                (s.immediateRender = !0),
                (s.lazy = h && !1 !== a.lazy),
                (s.startAt = s.delay = null),
                (s.onUpdate = a.onUpdate),
                (s.onUpdateParams = a.onUpdateParams),
                (s.onUpdateScope = a.onUpdateScope || a.callbackScope || this),
                (this._startAt = z.to(this.target || {}, 0, s)),
                h)
            )
                if (0 < this._time) this._startAt = null;
                else if (0 !== l) return;
        } else if (a.runBackwards && 0 !== l)
            if (this._startAt) this._startAt.render(-1, !0), this._startAt.kill(), (this._startAt = null);
            else {
                for (r in (0 !== this._time && (h = !1), (i = {}), a)) (Z[r] && "autoCSS" !== r) || (i[r] = a[r]);
                if (((i.overwrite = 0), (i.data = "isFromStart"), (i.lazy = h && !1 !== a.lazy), (i.immediateRender = h), (this._startAt = z.to(this.target, 0, i)), h)) {
                    if (0 === this._time) return;
                } else this._startAt._init(), this._startAt._enabled(!1), this.vars.immediateRender && (this._startAt = null);
            }
        if (
            ((this._ease = f = f ? (f instanceof O ? f : "function" == typeof f ? new O(f, a.easeParams) : S[f] || z.defaultEase) : z.defaultEase),
            a.easeParams instanceof Array && f.config && (this._ease = f.config.apply(f, a.easeParams)),
            (this._easeType = this._ease._type),
            (this._easePower = this._ease._power),
            (this._firstPT = null),
            this._targets)
        )
            for (n = this._targets.length, t = 0; t < n; t++) this._initProps(this._targets[t], (this._propLookup[t] = {}), this._siblings[t], o ? o[t] : null, t) && (e = !0);
        else e = this._initProps(this.target, this._propLookup, this._siblings, o, 0);
        if ((e && z._onPluginEvent("_onInitAllProps", this), o && (this._firstPT || ("function" != typeof this.target && this._enabled(!1, !1))), a.runBackwards)) for (i = this._firstPT; i; ) (i.s += i.c), (i.c = -i.c), (i = i._next);
        (this._onUpdate = a.onUpdate), (this._initted = !0);
    }),
        (s._initProps = function (t, e, i, r, s) {
            var n, a, o, l, h, f;
            if (null == t) return !1;
            for (n in (I[t._gsTweenID] && J(),
            this.vars.css ||
                (t.style &&
                    t !== p &&
                    t.nodeType &&
                    W.css &&
                    !1 !== this.vars.autoCSS &&
                    (function (t, e) {
                        var i,
                            r = {};
                        for (i in t)
                            Z[i] || (i in e && "transform" !== i && "x" !== i && "y" !== i && "width" !== i && "height" !== i && "className" !== i && "border" !== i) || !(!W[i] || (W[i] && W[i]._autoCSS)) || ((r[i] = t[i]), delete t[i]);
                        t.css = r;
                    })(this.vars, t)),
            this.vars))
                if (((f = this.vars[n]), Z[n])) f && (f instanceof Array || (f.push && T(f))) && -1 !== f.join("").indexOf("{self}") && (this.vars[n] = f = this._swapSelfInParams(f, this));
                else if (W[n] && (l = new W[n]())._onInitTween(t, this.vars[n], this, s)) {
                    for (this._firstPT = h = { _next: this._firstPT, t: l, p: "setRatio", s: 0, c: 1, f: 1, n: n, pg: 1, pr: l._priority, m: 0 }, a = l._overwriteProps.length; -1 < --a; ) e[l._overwriteProps[a]] = this._firstPT;
                    (l._priority || l._onInitAllProps) && (o = !0), (l._onDisable || l._onEnable) && (this._notifyPluginsOfEnabled = !0), h._next && (h._next._prev = h);
                } else e[n] = V.call(this, t, n, "get", f, n, 0, null, this.vars.stringFilter, s);
            return r && this._kill(r, t)
                ? this._initProps(t, e, i, r, s)
                : 1 < this._overwrite && this._firstPT && 1 < i.length && it(t, this, e, this._overwrite, i)
                ? (this._kill(e, t), this._initProps(t, e, i, r, s))
                : (this._firstPT && ((!1 !== this.vars.lazy && this._duration) || (this.vars.lazy && !this._duration)) && (I[t._gsTweenID] = !0), o);
        }),
        (s.render = function (t, e, i) {
            var r,
                s,
                n,
                a,
                o = this._time,
                l = this._duration,
                h = this._rawPrevTime;
            if (l - 1e-7 <= t && 0 <= t)
                (this._totalTime = this._time = l),
                    (this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1),
                    this._reversed || ((r = !0), (s = "onComplete"), (i = i || this._timeline.autoRemoveChildren)),
                    0 === l &&
                        (this._initted || !this.vars.lazy || i) &&
                        (this._startTime === this._timeline._duration && (t = 0),
                        (h < 0 || (t <= 0 && -1e-7 <= t) || (h === y && "isPause" !== this.data)) && h !== t && ((i = !0), y < h && (s = "onReverseComplete")),
                        (this._rawPrevTime = a = !e || t || h === t ? t : y));
            else if (t < 1e-7)
                (this._totalTime = this._time = 0),
                    (this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0),
                    (0 !== o || (0 === l && 0 < h)) && ((s = "onReverseComplete"), (r = this._reversed)),
                    t < 0 && ((this._active = !1), 0 === l && (this._initted || !this.vars.lazy || i) && (0 <= h && (h !== y || "isPause" !== this.data) && (i = !0), (this._rawPrevTime = a = !e || t || h === t ? t : y))),
                    (!this._initted || (this._startAt && this._startAt.progress())) && (i = !0);
            else if (((this._totalTime = this._time = t), this._easeType)) {
                var f = t / l,
                    u = this._easeType,
                    p = this._easePower;
                (1 === u || (3 === u && 0.5 <= f)) && (f = 1 - f),
                    3 === u && (f *= 2),
                    1 === p ? (f *= f) : 2 === p ? (f *= f * f) : 3 === p ? (f *= f * f * f) : 4 === p && (f *= f * f * f * f),
                    (this.ratio = 1 === u ? 1 - f : 2 === u ? f : t / l < 0.5 ? f / 2 : 1 - f / 2);
            } else this.ratio = this._ease.getRatio(t / l);
            if (this._time !== o || i) {
                if (!this._initted) {
                    if ((this._init(), !this._initted || this._gc)) return;
                    if (!i && this._firstPT && ((!1 !== this.vars.lazy && this._duration) || (this.vars.lazy && !this._duration))) return (this._time = this._totalTime = o), (this._rawPrevTime = h), N.push(this), void (this._lazy = [t, e]);
                    this._time && !r ? (this.ratio = this._ease.getRatio(this._time / l)) : r && this._ease._calcEnd && (this.ratio = this._ease.getRatio(0 === this._time ? 0 : 1));
                }
                for (
                    !1 !== this._lazy && (this._lazy = !1),
                        this._active || (!this._paused && this._time !== o && 0 <= t && (this._active = !0)),
                        0 === o && (this._startAt && (0 <= t ? this._startAt.render(t, !0, i) : s || (s = "_dummyGS")), this.vars.onStart && (0 !== this._time || 0 === l) && (e || this._callback("onStart"))),
                        n = this._firstPT;
                    n;

                )
                    n.f ? n.t[n.p](n.c * this.ratio + n.s) : (n.t[n.p] = n.c * this.ratio + n.s), (n = n._next);
                this._onUpdate && (t < 0 && this._startAt && -1e-4 !== t && this._startAt.render(t, !0, i), e || ((this._time !== o || r || i) && this._callback("onUpdate"))),
                    s &&
                        (!this._gc || i) &&
                        (t < 0 && this._startAt && !this._onUpdate && -1e-4 !== t && this._startAt.render(t, !0, i),
                        r && (this._timeline.autoRemoveChildren && this._enabled(!1, !1), (this._active = !1)),
                        !e && this.vars[s] && this._callback(s),
                        0 === l && this._rawPrevTime === y && a !== y && (this._rawPrevTime = 0));
            }
        }),
        (s._kill = function (t, e, i) {
            if (("all" === t && (t = null), null == t && (null == e || e === this.target))) return (this._lazy = !1), this._enabled(!1, !1);
            e = "string" != typeof e ? e || this._targets || this.target : z.selector(e) || e;
            var r,
                s,
                n,
                a,
                o,
                l,
                h,
                f,
                u,
                p = i && this._time && i._startTime === this._startTime && this._timeline === i._timeline,
                _ = this._firstPT;
            if ((T(e) || L(e)) && "number" != typeof e[0]) for (r = e.length; -1 < --r; ) this._kill(t, e[r], i) && (l = !0);
            else {
                if (this._targets) {
                    for (r = this._targets.length; -1 < --r; )
                        if (e === this._targets[r]) {
                            (o = this._propLookup[r] || {}), (this._overwrittenProps = this._overwrittenProps || []), (s = this._overwrittenProps[r] = t ? this._overwrittenProps[r] || {} : "all");
                            break;
                        }
                } else {
                    if (e !== this.target) return !1;
                    (o = this._propLookup), (s = this._overwrittenProps = t ? this._overwrittenProps || {} : "all");
                }
                if (o) {
                    if (((h = t || o), (f = t !== s && "all" !== s && t !== o && ("object" != typeof t || !t._tempKill)), i && (z.onOverwrite || this.vars.onOverwrite))) {
                        for (n in h) o[n] && (u || (u = []), u.push(n));
                        if ((u || !t) && !et(this, i, e, u)) return !1;
                    }
                    for (n in h)
                        (a = o[n]) &&
                            (p && (a.f ? a.t[a.p](a.s) : (a.t[a.p] = a.s), (l = !0)),
                            a.pg && a.t._kill(h) && (l = !0),
                            (a.pg && 0 !== a.t._overwriteProps.length) || (a._prev ? (a._prev._next = a._next) : a === this._firstPT && (this._firstPT = a._next), a._next && (a._next._prev = a._prev), (a._next = a._prev = null)),
                            delete o[n]),
                            f && (s[n] = 1);
                    !this._firstPT && this._initted && _ && this._enabled(!1, !1);
                }
            }
            return l;
        }),
        (s.invalidate = function () {
            return (
                this._notifyPluginsOfEnabled && z._onPluginEvent("_onDisable", this),
                (this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null),
                (this._notifyPluginsOfEnabled = this._active = this._lazy = !1),
                (this._propLookup = this._targets ? {} : []),
                F.prototype.invalidate.call(this),
                this.vars.immediateRender && ((this._time = -y), this.render(Math.min(0, -this._delay))),
                this
            );
        }),
        (s._enabled = function (t, e) {
            if ((g || m.wake(), t && this._gc)) {
                var i,
                    r = this._targets;
                if (r) for (i = r.length; -1 < --i; ) this._siblings[i] = tt(r[i], this, !0);
                else this._siblings = tt(this.target, this, !0);
            }
            return F.prototype._enabled.call(this, t, e), !(!this._notifyPluginsOfEnabled || !this._firstPT) && z._onPluginEvent(t ? "_onEnable" : "_onDisable", this);
        }),
        (z.to = function (t, e, i) {
            return new z(t, e, i);
        }),
        (z.from = function (t, e, i) {
            return (i.runBackwards = !0), (i.immediateRender = 0 != i.immediateRender), new z(t, e, i);
        }),
        (z.fromTo = function (t, e, i, r) {
            return (r.startAt = i), (r.immediateRender = 0 != r.immediateRender && 0 != i.immediateRender), new z(t, e, r);
        }),
        (z.delayedCall = function (t, e, i, r, s) {
            return new z(e, 0, { delay: t, onComplete: e, onCompleteParams: i, callbackScope: r, onReverseComplete: e, onReverseCompleteParams: i, immediateRender: !1, lazy: !1, useFrames: s, overwrite: 0 });
        }),
        (z.set = function (t, e) {
            return new z(t, 0, e);
        }),
        (z.getTweensOf = function (t, e) {
            if (null == t) return [];
            var i, r, s, n;
            if (((t = "string" != typeof t ? t : z.selector(t) || t), (T(t) || L(t)) && "number" != typeof t[0])) {
                for (i = t.length, r = []; -1 < --i; ) r = r.concat(z.getTweensOf(t[i], e));
                for (i = r.length; -1 < --i; ) for (n = r[i], s = i; -1 < --s; ) n === r[s] && r.splice(i, 1);
            } else if (t._gsTweenID) for (i = (r = tt(t).concat()).length; -1 < --i; ) (r[i]._gc || (e && !r[i].isActive())) && r.splice(i, 1);
            return r || [];
        }),
        (z.killTweensOf = z.killDelayedCallsTo = function (t, e, i) {
            "object" == typeof e && ((i = e), (e = !1));
            for (var r = z.getTweensOf(t, e), s = r.length; -1 < --s; ) r[s]._kill(i, t);
        });
    var st = P(
        "plugins.TweenPlugin",
        function (t, e) {
            (this._overwriteProps = (t || "").split(",")), (this._propName = this._overwriteProps[0]), (this._priority = e || 0), (this._super = st.prototype);
        },
        !0
    );
    if (
        ((s = st.prototype),
        (st.version = "1.19.0"),
        (st.API = 2),
        (s._firstPT = null),
        (s._addTween = V),
        (s.setRatio = E),
        (s._kill = function (t) {
            var e,
                i = this._overwriteProps,
                r = this._firstPT;
            if (null != t[this._propName]) this._overwriteProps = [];
            else for (e = i.length; -1 < --e; ) null != t[i[e]] && i.splice(e, 1);
            for (; r; ) null != t[r.n] && (r._next && (r._next._prev = r._prev), r._prev ? ((r._prev._next = r._next), (r._prev = null)) : this._firstPT === r && (this._firstPT = r._next)), (r = r._next);
            return !1;
        }),
        (s._mod = s._roundProps = function (t) {
            for (var e, i = this._firstPT; i; ) (e = t[this._propName] || (null != i.n && t[i.n.split(this._propName + "_").join("")])) && "function" == typeof e && (2 === i.f ? (i.t._applyPT.m = e) : (i.m = e)), (i = i._next);
        }),
        (z._onPluginEvent = function (t, e) {
            var i,
                r,
                s,
                n,
                a,
                o = e._firstPT;
            if ("_onInitAllProps" === t) {
                for (; o; ) {
                    for (a = o._next, r = s; r && r.pr > o.pr; ) r = r._next;
                    (o._prev = r ? r._prev : n) ? (o._prev._next = o) : (s = o), (o._next = r) ? (r._prev = o) : (n = o), (o = a);
                }
                o = e._firstPT = s;
            }
            for (; o; ) o.pg && "function" == typeof o.t[t] && o.t[t]() && (i = !0), (o = o._next);
            return i;
        }),
        (st.activate = function (t) {
            for (var e = t.length; -1 < --e; ) t[e].API === st.API && (W[new t[e]()._propName] = t[e]);
            return !0;
        }),
        (o.plugin = function (t) {
            if (!(t && t.propName && t.init && t.API)) throw "illegal plugin definition.";
            var e,
                i = t.propName,
                r = t.priority || 0,
                s = t.overwriteProps,
                n = { init: "_onInitTween", set: "setRatio", kill: "_kill", round: "_mod", mod: "_mod", initAll: "_onInitAllProps" },
                a = P(
                    "plugins." + i.charAt(0).toUpperCase() + i.substr(1) + "Plugin",
                    function () {
                        st.call(this, i, r), (this._overwriteProps = s || []);
                    },
                    !0 === t.global
                ),
                o = (a.prototype = new st(i));
            for (e in (((o.constructor = a).API = t.API), n)) "function" == typeof t[e] && (o[n[e]] = t[e]);
            return (a.version = t.version), st.activate([a]), a;
        }),
        (e = p._gsQueue))
    ) {
        for (i = 0; i < e.length; i++) e[i]();
        for (s in b) b[s].func || p.console.log("GSAP encountered missing dependency: " + s);
    }
    g = !1;
})("undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window, "TweenLite"),
    ((_gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window)._gsQueue || (_gsScope._gsQueue = [])).push(function () {
        "use strict";
        _gsScope._gsDefine(
            "TimelineLite",
            ["core.Animation", "core.SimpleTimeline", "TweenLite"],
            function (f, u, p) {
                var _ = function (t) {
                        u.call(this, t),
                            (this._labels = {}),
                            (this.autoRemoveChildren = !0 === this.vars.autoRemoveChildren),
                            (this.smoothChildTiming = !0 === this.vars.smoothChildTiming),
                            (this._sortChildren = !0),
                            (this._onUpdate = this.vars.onUpdate);
                        var e,
                            i,
                            r = this.vars;
                        for (i in r) (e = r[i]), m(e) && -1 !== e.join("").indexOf("{self}") && (r[i] = this._swapSelfInParams(e));
                        m(r.tweens) && this.add(r.tweens, 0, r.align, r.stagger);
                    },
                    d = 1e-10,
                    t = p._internals,
                    e = (_._internals = {}),
                    c = t.isSelector,
                    m = t.isArray,
                    g = t.lazyTweens,
                    v = t.lazyRender,
                    a = _gsScope._gsDefine.globals,
                    y = function (t) {
                        var e,
                            i = {};
                        for (e in t) i[e] = t[e];
                        return i;
                    },
                    x = function (t, e, i) {
                        var r,
                            s,
                            n = t.cycle;
                        for (r in n) (s = n[r]), (t[r] = "function" == typeof s ? s(i, e[i]) : s[i % s.length]);
                        delete t.cycle;
                    },
                    n = (e.pauseCallback = function () {}),
                    T = function (t) {
                        var e,
                            i = [],
                            r = t.length;
                        for (e = 0; e !== r; i.push(t[e++]));
                        return i;
                    },
                    i = (_.prototype = new u());
                return (
                    (_.version = "2.0.2"),
                    (i.constructor = _),
                    (i.kill()._gc = i._forcingPlayhead = i._hasPause = !1),
                    (i.to = function (t, e, i, r) {
                        var s = (i.repeat && a.TweenMax) || p;
                        return e ? this.add(new s(t, e, i), r) : this.set(t, i, r);
                    }),
                    (i.from = function (t, e, i, r) {
                        return this.add(((i.repeat && a.TweenMax) || p).from(t, e, i), r);
                    }),
                    (i.fromTo = function (t, e, i, r, s) {
                        var n = (r.repeat && a.TweenMax) || p;
                        return e ? this.add(n.fromTo(t, e, i, r), s) : this.set(t, r, s);
                    }),
                    (i.staggerTo = function (t, e, i, r, s, n, a, o) {
                        var l,
                            h,
                            f = new _({ onComplete: n, onCompleteParams: a, callbackScope: o, smoothChildTiming: this.smoothChildTiming }),
                            u = i.cycle;
                        for ("string" == typeof t && (t = p.selector(t) || t), c((t = t || [])) && (t = T(t)), (r = r || 0) < 0 && ((t = T(t)).reverse(), (r *= -1)), h = 0; h < t.length; h++)
                            (l = y(i)).startAt && ((l.startAt = y(l.startAt)), l.startAt.cycle && x(l.startAt, t, h)), u && (x(l, t, h), null != l.duration && ((e = l.duration), delete l.duration)), f.to(t[h], e, l, h * r);
                        return this.add(f, s);
                    }),
                    (i.staggerFrom = function (t, e, i, r, s, n, a, o) {
                        return (i.immediateRender = 0 != i.immediateRender), (i.runBackwards = !0), this.staggerTo(t, e, i, r, s, n, a, o);
                    }),
                    (i.staggerFromTo = function (t, e, i, r, s, n, a, o, l) {
                        return (r.startAt = i), (r.immediateRender = 0 != r.immediateRender && 0 != i.immediateRender), this.staggerTo(t, e, r, s, n, a, o, l);
                    }),
                    (i.call = function (t, e, i, r) {
                        return this.add(p.delayedCall(0, t, e, i), r);
                    }),
                    (i.set = function (t, e, i) {
                        return (i = this._parseTimeOrLabel(i, 0, !0)), null == e.immediateRender && (e.immediateRender = i === this._time && !this._paused), this.add(new p(t, 0, e), i);
                    }),
                    (_.exportRoot = function (t, e) {
                        null == (t = t || {}).smoothChildTiming && (t.smoothChildTiming = !0);
                        var i,
                            r,
                            s,
                            n,
                            a = new _(t),
                            o = a._timeline;
                        for (null == e && (e = !0), o._remove(a, !0), a._startTime = 0, a._rawPrevTime = a._time = a._totalTime = o._time, s = o._first; s; )
                            (n = s._next), (e && s instanceof p && s.target === s.vars.onComplete) || ((r = s._startTime - s._delay) < 0 && (i = 1), a.add(s, r)), (s = n);
                        return o.add(a, 0), i && a.totalDuration(), a;
                    }),
                    (i.add = function (t, e, i, r) {
                        var s, n, a, o, l, h;
                        if (("number" != typeof e && (e = this._parseTimeOrLabel(e, 0, !0, t)), !(t instanceof f))) {
                            if (t instanceof Array || (t && t.push && m(t))) {
                                for (i = i || "normal", r = r || 0, s = e, n = t.length, a = 0; a < n; a++)
                                    m((o = t[a])) && (o = new _({ tweens: o })),
                                        this.add(o, s),
                                        "string" != typeof o && "function" != typeof o && ("sequence" === i ? (s = o._startTime + o.totalDuration() / o._timeScale) : "start" === i && (o._startTime -= o.delay())),
                                        (s += r);
                                return this._uncache(!0);
                            }
                            if ("string" == typeof t) return this.addLabel(t, e);
                            if ("function" != typeof t) throw "Cannot add " + t + " into the timeline; it is not a tween, timeline, function, or string.";
                            t = p.delayedCall(0, t);
                        }
                        if (
                            (u.prototype.add.call(this, t, e),
                            t._time && ((s = Math.max(0, Math.min(t.totalDuration(), (this.rawTime() - t._startTime) * t._timeScale))), 1e-5 < Math.abs(s - t._totalTime) && t.render(s, !1, !1)),
                            (this._gc || this._time === this._duration) && !this._paused && this._duration < this.duration())
                        )
                            for (h = (l = this).rawTime() > t._startTime; l._timeline; ) h && l._timeline.smoothChildTiming ? l.totalTime(l._totalTime, !0) : l._gc && l._enabled(!0, !1), (l = l._timeline);
                        return this;
                    }),
                    (i.remove = function (t) {
                        if (t instanceof f) {
                            this._remove(t, !1);
                            var e = (t._timeline = t.vars.useFrames ? f._rootFramesTimeline : f._rootTimeline);
                            return (t._startTime = (t._paused ? t._pauseTime : e._time) - (t._reversed ? t.totalDuration() - t._totalTime : t._totalTime) / t._timeScale), this;
                        }
                        if (t instanceof Array || (t && t.push && m(t))) {
                            for (var i = t.length; -1 < --i; ) this.remove(t[i]);
                            return this;
                        }
                        return "string" == typeof t ? this.removeLabel(t) : this.kill(null, t);
                    }),
                    (i._remove = function (t, e) {
                        return (
                            u.prototype._remove.call(this, t, e),
                            this._last ? this._time > this.duration() && ((this._time = this._duration), (this._totalTime = this._totalDuration)) : (this._time = this._totalTime = this._duration = this._totalDuration = 0),
                            this
                        );
                    }),
                    (i.append = function (t, e) {
                        return this.add(t, this._parseTimeOrLabel(null, e, !0, t));
                    }),
                    (i.insert = i.insertMultiple = function (t, e, i, r) {
                        return this.add(t, e || 0, i, r);
                    }),
                    (i.appendMultiple = function (t, e, i, r) {
                        return this.add(t, this._parseTimeOrLabel(null, e, !0, t), i, r);
                    }),
                    (i.addLabel = function (t, e) {
                        return (this._labels[t] = this._parseTimeOrLabel(e)), this;
                    }),
                    (i.addPause = function (t, e, i, r) {
                        var s = p.delayedCall(0, n, i, r || this);
                        return (s.vars.onComplete = s.vars.onReverseComplete = e), (s.data = "isPause"), (this._hasPause = !0), this.add(s, t);
                    }),
                    (i.removeLabel = function (t) {
                        return delete this._labels[t], this;
                    }),
                    (i.getLabelTime = function (t) {
                        return null != this._labels[t] ? this._labels[t] : -1;
                    }),
                    (i._parseTimeOrLabel = function (t, e, i, r) {
                        var s, n;
                        if (r instanceof f && r.timeline === this) this.remove(r);
                        else if (r && (r instanceof Array || (r.push && m(r)))) for (n = r.length; -1 < --n; ) r[n] instanceof f && r[n].timeline === this && this.remove(r[n]);
                        if (((s = "number" != typeof t || e ? (99999999999 < this.duration() ? this.recent().endTime(!1) : this._duration) : 0), "string" == typeof e))
                            return this._parseTimeOrLabel(e, i && "number" == typeof t && null == this._labels[e] ? t - s : 0, i);
                        if (((e = e || 0), "string" != typeof t || (!isNaN(t) && null == this._labels[t]))) null == t && (t = s);
                        else {
                            if (-1 === (n = t.indexOf("="))) return null == this._labels[t] ? (i ? (this._labels[t] = s + e) : e) : this._labels[t] + e;
                            (e = parseInt(t.charAt(n - 1) + "1", 10) * Number(t.substr(n + 1))), (t = 1 < n ? this._parseTimeOrLabel(t.substr(0, n - 1), 0, i) : s);
                        }
                        return Number(t) + e;
                    }),
                    (i.seek = function (t, e) {
                        return this.totalTime("number" == typeof t ? t : this._parseTimeOrLabel(t), !1 !== e);
                    }),
                    (i.stop = function () {
                        return this.paused(!0);
                    }),
                    (i.gotoAndPlay = function (t, e) {
                        return this.play(t, e);
                    }),
                    (i.gotoAndStop = function (t, e) {
                        return this.pause(t, e);
                    }),
                    (i.render = function (t, e, i) {
                        this._gc && this._enabled(!0, !1);
                        var r,
                            s,
                            n,
                            a,
                            o,
                            l,
                            h,
                            f = this._time,
                            u = this._dirty ? this.totalDuration() : this._totalDuration,
                            p = this._startTime,
                            _ = this._timeScale,
                            c = this._paused;
                        if ((f !== this._time && (t += this._time - f), u - 1e-7 <= t && 0 <= t))
                            (this._totalTime = this._time = u),
                                this._reversed ||
                                    this._hasPausedChild() ||
                                    ((s = !0),
                                    (a = "onComplete"),
                                    (o = !!this._timeline.autoRemoveChildren),
                                    0 === this._duration &&
                                        ((t <= 0 && -1e-7 <= t) || this._rawPrevTime < 0 || this._rawPrevTime === d) &&
                                        this._rawPrevTime !== t &&
                                        this._first &&
                                        ((o = !0), this._rawPrevTime > d && (a = "onReverseComplete"))),
                                (this._rawPrevTime = this._duration || !e || t || this._rawPrevTime === t ? t : d),
                                (t = u + 1e-4);
                        else if (t < 1e-7)
                            if (
                                ((this._totalTime = this._time = 0),
                                (0 !== f || (0 === this._duration && this._rawPrevTime !== d && (0 < this._rawPrevTime || (t < 0 && 0 <= this._rawPrevTime)))) && ((a = "onReverseComplete"), (s = this._reversed)),
                                t < 0)
                            )
                                (this._active = !1), this._timeline.autoRemoveChildren && this._reversed ? ((o = s = !0), (a = "onReverseComplete")) : 0 <= this._rawPrevTime && this._first && (o = !0), (this._rawPrevTime = t);
                            else {
                                if (((this._rawPrevTime = this._duration || !e || t || this._rawPrevTime === t ? t : d), 0 === t && s)) for (r = this._first; r && 0 === r._startTime; ) r._duration || (s = !1), (r = r._next);
                                (t = 0), this._initted || (o = !0);
                            }
                        else {
                            if (this._hasPause && !this._forcingPlayhead && !e) {
                                if (f <= t) for (r = this._first; r && r._startTime <= t && !l; ) r._duration || "isPause" !== r.data || r.ratio || (0 === r._startTime && 0 === this._rawPrevTime) || (l = r), (r = r._next);
                                else for (r = this._last; r && r._startTime >= t && !l; ) r._duration || ("isPause" === r.data && 0 < r._rawPrevTime && (l = r)), (r = r._prev);
                                l && ((this._time = t = l._startTime), (this._totalTime = t + this._cycle * (this._totalDuration + this._repeatDelay)));
                            }
                            this._totalTime = this._time = this._rawPrevTime = t;
                        }
                        if ((this._time !== f && this._first) || i || o || l) {
                            if (
                                (this._initted || (this._initted = !0),
                                this._active || (!this._paused && this._time !== f && 0 < t && (this._active = !0)),
                                0 === f && this.vars.onStart && ((0 === this._time && this._duration) || e || this._callback("onStart")),
                                f <= (h = this._time))
                            )
                                for (r = this._first; r && ((n = r._next), h === this._time && (!this._paused || c)); )
                                    (r._active || (r._startTime <= h && !r._paused && !r._gc)) &&
                                        (l === r && this.pause(), r._reversed ? r.render((r._dirty ? r.totalDuration() : r._totalDuration) - (t - r._startTime) * r._timeScale, e, i) : r.render((t - r._startTime) * r._timeScale, e, i)),
                                        (r = n);
                            else
                                for (r = this._last; r && ((n = r._prev), h === this._time && (!this._paused || c)); ) {
                                    if (r._active || (r._startTime <= f && !r._paused && !r._gc)) {
                                        if (l === r) {
                                            for (l = r._prev; l && l.endTime() > this._time; ) l.render(l._reversed ? l.totalDuration() - (t - l._startTime) * l._timeScale : (t - l._startTime) * l._timeScale, e, i), (l = l._prev);
                                            (l = null), this.pause();
                                        }
                                        r._reversed ? r.render((r._dirty ? r.totalDuration() : r._totalDuration) - (t - r._startTime) * r._timeScale, e, i) : r.render((t - r._startTime) * r._timeScale, e, i);
                                    }
                                    r = n;
                                }
                            this._onUpdate && (e || (g.length && v(), this._callback("onUpdate"))),
                                a &&
                                    (this._gc ||
                                        ((p === this._startTime || _ !== this._timeScale) &&
                                            (0 === this._time || u >= this.totalDuration()) &&
                                            (s && (g.length && v(), this._timeline.autoRemoveChildren && this._enabled(!1, !1), (this._active = !1)), !e && this.vars[a] && this._callback(a))));
                        }
                    }),
                    (i._hasPausedChild = function () {
                        for (var t = this._first; t; ) {
                            if (t._paused || (t instanceof _ && t._hasPausedChild())) return !0;
                            t = t._next;
                        }
                        return !1;
                    }),
                    (i.getChildren = function (t, e, i, r) {
                        r = r || -9999999999;
                        for (var s = [], n = this._first, a = 0; n; )
                            n._startTime < r || (n instanceof p ? !1 !== e && (s[a++] = n) : (!1 !== i && (s[a++] = n), !1 !== t && (a = (s = s.concat(n.getChildren(!0, e, i))).length))), (n = n._next);
                        return s;
                    }),
                    (i.getTweensOf = function (t, e) {
                        var i,
                            r,
                            s = this._gc,
                            n = [],
                            a = 0;
                        for (s && this._enabled(!0, !0), r = (i = p.getTweensOf(t)).length; -1 < --r; ) (i[r].timeline === this || (e && this._contains(i[r]))) && (n[a++] = i[r]);
                        return s && this._enabled(!1, !0), n;
                    }),
                    (i.recent = function () {
                        return this._recent;
                    }),
                    (i._contains = function (t) {
                        for (var e = t.timeline; e; ) {
                            if (e === this) return !0;
                            e = e.timeline;
                        }
                        return !1;
                    }),
                    (i.shiftChildren = function (t, e, i) {
                        i = i || 0;
                        for (var r, s = this._first, n = this._labels; s; ) s._startTime >= i && (s._startTime += t), (s = s._next);
                        if (e) for (r in n) n[r] >= i && (n[r] += t);
                        return this._uncache(!0);
                    }),
                    (i._kill = function (t, e) {
                        if (!t && !e) return this._enabled(!1, !1);
                        for (var i = e ? this.getTweensOf(e) : this.getChildren(!0, !0, !1), r = i.length, s = !1; -1 < --r; ) i[r]._kill(t, e) && (s = !0);
                        return s;
                    }),
                    (i.clear = function (t) {
                        var e = this.getChildren(!1, !0, !0),
                            i = e.length;
                        for (this._time = this._totalTime = 0; -1 < --i; ) e[i]._enabled(!1, !1);
                        return !1 !== t && (this._labels = {}), this._uncache(!0);
                    }),
                    (i.invalidate = function () {
                        for (var t = this._first; t; ) t.invalidate(), (t = t._next);
                        return f.prototype.invalidate.call(this);
                    }),
                    (i._enabled = function (t, e) {
                        if (t === this._gc) for (var i = this._first; i; ) i._enabled(t, !0), (i = i._next);
                        return u.prototype._enabled.call(this, t, e);
                    }),
                    (i.totalTime = function (t, e, i) {
                        this._forcingPlayhead = !0;
                        var r = f.prototype.totalTime.apply(this, arguments);
                        return (this._forcingPlayhead = !1), r;
                    }),
                    (i.duration = function (t) {
                        return arguments.length ? (0 !== this.duration() && 0 !== t && this.timeScale(this._duration / t), this) : (this._dirty && this.totalDuration(), this._duration);
                    }),
                    (i.totalDuration = function (t) {
                        if (!arguments.length) {
                            if (this._dirty) {
                                for (var e, i, r = 0, s = this._last, n = 999999999999; s; )
                                    (e = s._prev),
                                        s._dirty && s.totalDuration(),
                                        s._startTime > n && this._sortChildren && !s._paused && !this._calculatingDuration
                                            ? ((this._calculatingDuration = 1), this.add(s, s._startTime - s._delay), (this._calculatingDuration = 0))
                                            : (n = s._startTime),
                                        s._startTime < 0 &&
                                            !s._paused &&
                                            ((r -= s._startTime),
                                            this._timeline.smoothChildTiming && ((this._startTime += s._startTime / this._timeScale), (this._time -= s._startTime), (this._totalTime -= s._startTime), (this._rawPrevTime -= s._startTime)),
                                            this.shiftChildren(-s._startTime, !1, -9999999999),
                                            (n = 0)),
                                        r < (i = s._startTime + s._totalDuration / s._timeScale) && (r = i),
                                        (s = e);
                                (this._duration = this._totalDuration = r), (this._dirty = !1);
                            }
                            return this._totalDuration;
                        }
                        return t && this.totalDuration() ? this.timeScale(this._totalDuration / t) : this;
                    }),
                    (i.paused = function (t) {
                        if (!t) for (var e = this._first, i = this._time; e; ) e._startTime === i && "isPause" === e.data && (e._rawPrevTime = 0), (e = e._next);
                        return f.prototype.paused.apply(this, arguments);
                    }),
                    (i.usesFrames = function () {
                        for (var t = this._timeline; t._timeline; ) t = t._timeline;
                        return t === f._rootFramesTimeline;
                    }),
                    (i.rawTime = function (t) {
                        return t && (this._paused || (this._repeat && 0 < this.time() && this.totalProgress() < 1))
                            ? this._totalTime % (this._duration + this._repeatDelay)
                            : this._paused
                            ? this._totalTime
                            : (this._timeline.rawTime(t) - this._startTime) * this._timeScale;
                    }),
                    _
                );
            },
            !0
        );
    }),
    _gsScope._gsDefine && _gsScope._gsQueue.pop()(),
    (function (t) {
        "use strict";
        var e = function () {
            return (_gsScope.GreenSockGlobals || _gsScope).TimelineLite;
        };
        "undefined" != typeof module && module.exports ? (require("./TweenLite.min.js"), (module.exports = e())) : "function" == typeof define && define.amd && define(["TweenLite"], e);
    })(),
    ((_gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window)._gsQueue || (_gsScope._gsQueue = [])).push(function () {
        "use strict";
        _gsScope._gsDefine(
            "plugins.CSSPlugin",
            ["plugins.TweenPlugin", "TweenLite"],
            function (n, j) {
                var c,
                    P,
                    S,
                    d,
                    E = function () {
                        n.call(this, "css"), (this._overwriteProps.length = 0), (this.setRatio = E.prototype.setRatio);
                    },
                    h = _gsScope._gsDefine.globals,
                    m = {},
                    t = (E.prototype = new n("css"));
                ((t.constructor = E).version = "2.0.2"),
                    (E.API = 2),
                    (E.defaultTransformPerspective = 0),
                    (E.defaultSkewType = "compensated"),
                    (E.defaultSmoothOrigin = !0),
                    (t = "px"),
                    (E.suffixMap = { top: t, right: t, bottom: t, left: t, width: t, height: t, fontSize: t, padding: t, margin: t, perspective: t, lineHeight: "" });
                var k,
                    g,
                    v,
                    B,
                    y,
                    O,
                    A,
                    C,
                    e,
                    i,
                    R = /(?:\-|\.|\b)(\d|\.|e\-)+/g,
                    M = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,
                    x = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi,
                    f = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g,
                    F = /(?:\d|\-|\+|=|#|\.)*/g,
                    D = /opacity *= *([^)]*)/i,
                    T = /opacity:([^;]*)/i,
                    a = /alpha\(opacity *=.+?\)/i,
                    b = /^(rgb|hsl)/,
                    o = /([A-Z])/g,
                    l = /-([a-z])/gi,
                    w = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi,
                    u = function (t, e) {
                        return e.toUpperCase();
                    },
                    _ = /(?:Left|Right|Width)/i,
                    p = /(M11|M12|M21|M22)=[\d\-\.e]+/gi,
                    X = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,
                    z = /,(?=[^\)]*(?:\(|$))/gi,
                    L = /[\s,\(]/i,
                    V = Math.PI / 180,
                    U = 180 / Math.PI,
                    N = {},
                    r = { style: {} },
                    I = _gsScope.document || {
                        createElement: function () {
                            return r;
                        },
                    },
                    Y = function (t, e) {
                        return I.createElementNS ? I.createElementNS(e || "http://www.w3.org/1999/xhtml", t) : I.createElement(t);
                    },
                    W = Y("div"),
                    G = Y("img"),
                    s = (E._internals = { _specialProps: m }),
                    q = (_gsScope.navigator || {}).userAgent || "",
                    Z =
                        ((e = q.indexOf("Android")),
                        (i = Y("a")),
                        (v = -1 !== q.indexOf("Safari") && -1 === q.indexOf("Chrome") && (-1 === e || 3 < parseFloat(q.substr(e + 8, 2)))),
                        (y = v && parseFloat(q.substr(q.indexOf("Version/") + 8, 2)) < 6),
                        (B = -1 !== q.indexOf("Firefox")),
                        (/MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(q) || /Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(q)) && (O = parseFloat(RegExp.$1)),
                        !!i && ((i.style.cssText = "top:1px;opacity:.55;"), /^0.55/.test(i.style.opacity))),
                    H = function (t) {
                        return D.test("string" == typeof t ? t : (t.currentStyle ? t.currentStyle.filter : t.style.filter) || "") ? parseFloat(RegExp.$1) / 100 : 1;
                    },
                    Q = function (t) {
                        _gsScope.console && console.log(t);
                    },
                    $ = "",
                    K = "",
                    J = function (t, e) {
                        var i,
                            r,
                            s = (e = e || W).style;
                        if (void 0 !== s[t]) return t;
                        for (t = t.charAt(0).toUpperCase() + t.substr(1), i = ["O", "Moz", "ms", "Ms", "Webkit"], r = 5; -1 < --r && void 0 === s[i[r] + t]; );
                        return 0 <= r ? (($ = "-" + (K = 3 === r ? "ms" : i[r]).toLowerCase() + "-"), K + t) : null;
                    },
                    tt = ("undefined" != typeof window ? window : I.defaultView || { getComputedStyle: function () {} }).getComputedStyle,
                    et = (E.getStyle = function (t, e, i, r, s) {
                        var n;
                        return Z || "opacity" !== e
                            ? (!r && t.style[e] ? (n = t.style[e]) : (i = i || tt(t)) ? (n = i[e] || i.getPropertyValue(e) || i.getPropertyValue(e.replace(o, "-$1").toLowerCase())) : t.currentStyle && (n = t.currentStyle[e]),
                              null == s || (n && "none" !== n && "auto" !== n && "auto auto" !== n) ? n : s)
                            : H(t);
                    }),
                    it = (s.convertToPixels = function (t, e, i, r, s) {
                        if ("px" === r || (!r && "lineHeight" !== e)) return i;
                        if ("auto" === r || !i) return 0;
                        var n,
                            a,
                            o,
                            l = _.test(e),
                            h = t,
                            f = W.style,
                            u = i < 0,
                            p = 1 === i;
                        if ((u && (i = -i), p && (i *= 100), "lineHeight" !== e || r))
                            if ("%" === r && -1 !== e.indexOf("border")) n = (i / 100) * (l ? t.clientWidth : t.clientHeight);
                            else {
                                if (((f.cssText = "border:0 solid red;position:" + et(t, "position") + ";line-height:0;"), "%" !== r && h.appendChild && "v" !== r.charAt(0) && "rem" !== r))
                                    f[l ? "borderLeftWidth" : "borderTopWidth"] = i + r;
                                else {
                                    if (((h = t.parentNode || I.body), -1 !== et(h, "display").indexOf("flex") && (f.position = "absolute"), (a = h._gsCache), (o = j.ticker.frame), a && l && a.time === o)) return (a.width * i) / 100;
                                    f[l ? "width" : "height"] = i + r;
                                }
                                h.appendChild(W),
                                    (n = parseFloat(W[l ? "offsetWidth" : "offsetHeight"])),
                                    h.removeChild(W),
                                    l && "%" === r && !1 !== E.cacheWidths && (((a = h._gsCache = h._gsCache || {}).time = o), (a.width = (n / i) * 100)),
                                    0 !== n || s || (n = it(t, e, i, r, !0));
                            }
                        else (a = tt(t).lineHeight), (t.style.lineHeight = i), (n = parseFloat(tt(t).lineHeight)), (t.style.lineHeight = a);
                        return p && (n /= 100), u ? -n : n;
                    }),
                    rt = (s.calculateOffset = function (t, e, i) {
                        if ("absolute" !== et(t, "position", i)) return 0;
                        var r = "left" === e ? "Left" : "Top",
                            s = et(t, "margin" + r, i);
                        return t["offset" + r] - (it(t, e, parseFloat(s), s.replace(F, "")) || 0);
                    }),
                    st = function (t, e) {
                        var i,
                            r,
                            s,
                            n = {};
                        if ((e = e || tt(t, null)))
                            if ((i = e.length)) for (; -1 < --i; ) (-1 === (s = e[i]).indexOf("-transform") || zt === s) && (n[s.replace(l, u)] = e.getPropertyValue(s));
                            else for (i in e) (-1 === i.indexOf("Transform") || Xt === i) && (n[i] = e[i]);
                        else if ((e = t.currentStyle || t.style)) for (i in e) "string" == typeof i && void 0 === n[i] && (n[i.replace(l, u)] = e[i]);
                        return (
                            Z || (n.opacity = H(t)),
                            (r = Zt(t, e, !1)),
                            (n.rotation = r.rotation),
                            (n.skewX = r.skewX),
                            (n.scaleX = r.scaleX),
                            (n.scaleY = r.scaleY),
                            (n.x = r.x),
                            (n.y = r.y),
                            Nt && ((n.z = r.z), (n.rotationX = r.rotationX), (n.rotationY = r.rotationY), (n.scaleZ = r.scaleZ)),
                            n.filters && delete n.filters,
                            n
                        );
                    },
                    nt = function (t, e, i, r, s) {
                        var n,
                            a,
                            o,
                            l = {},
                            h = t.style;
                        for (a in i)
                            "cssText" !== a &&
                                "length" !== a &&
                                isNaN(a) &&
                                (e[a] !== (n = i[a]) || (s && s[a])) &&
                                -1 === a.indexOf("Origin") &&
                                ("number" == typeof n || "string" == typeof n) &&
                                ((l[a] = "auto" !== n || ("left" !== a && "top" !== a) ? (("" !== n && "auto" !== n && "none" !== n) || "string" != typeof e[a] || "" === e[a].replace(f, "") ? n : 0) : rt(t, a)),
                                void 0 !== h[a] && (o = new xt(h, a, h[a], o)));
                        if (r) for (a in r) "className" !== a && (l[a] = r[a]);
                        return { difs: l, firstMPT: o };
                    },
                    at = { width: ["Left", "Right"], height: ["Top", "Bottom"] },
                    ot = ["marginLeft", "marginRight", "marginTop", "marginBottom"],
                    lt = function (t, e, i) {
                        if ("svg" === (t.nodeName + "").toLowerCase()) return (i || tt(t))[e] || 0;
                        if (t.getCTM && Wt(t)) return t.getBBox()[e] || 0;
                        var r = parseFloat("width" === e ? t.offsetWidth : t.offsetHeight),
                            s = at[e],
                            n = s.length;
                        for (i = i || tt(t, null); -1 < --n; ) (r -= parseFloat(et(t, "padding" + s[n], i, !0)) || 0), (r -= parseFloat(et(t, "border" + s[n] + "Width", i, !0)) || 0);
                        return r;
                    },
                    ht = function (t, e) {
                        if ("contain" === t || "auto" === t || "auto auto" === t) return t + " ";
                        (null == t || "" === t) && (t = "0 0");
                        var i,
                            r = t.split(" "),
                            s = -1 !== t.indexOf("left") ? "0%" : -1 !== t.indexOf("right") ? "100%" : r[0],
                            n = -1 !== t.indexOf("top") ? "0%" : -1 !== t.indexOf("bottom") ? "100%" : r[1];
                        if (3 < r.length && !e) {
                            for (r = t.split(", ").join(",").split(","), t = [], i = 0; i < r.length; i++) t.push(ht(r[i]));
                            return t.join(",");
                        }
                        return (
                            null == n ? (n = "center" === s ? "50%" : "0") : "center" === n && (n = "50%"),
                            ("center" === s || (isNaN(parseFloat(s)) && -1 === (s + "").indexOf("="))) && (s = "50%"),
                            (t = s + " " + n + (2 < r.length ? " " + r[2] : "")),
                            e &&
                                ((e.oxp = -1 !== s.indexOf("%")),
                                (e.oyp = -1 !== n.indexOf("%")),
                                (e.oxr = "=" === s.charAt(1)),
                                (e.oyr = "=" === n.charAt(1)),
                                (e.ox = parseFloat(s.replace(f, ""))),
                                (e.oy = parseFloat(n.replace(f, ""))),
                                (e.v = t)),
                            e || t
                        );
                    },
                    ft = function (t, e) {
                        return "function" == typeof t && (t = t(C, A)), "string" == typeof t && "=" === t.charAt(1) ? parseInt(t.charAt(0) + "1", 10) * parseFloat(t.substr(2)) : parseFloat(t) - parseFloat(e) || 0;
                    },
                    ut = function (t, e) {
                        "function" == typeof t && (t = t(C, A));
                        var i = "string" == typeof t && "=" === t.charAt(1);
                        return (
                            "string" == typeof t && "v" === t.charAt(t.length - 2) && (t = (i ? t.substr(0, 2) : 0) + window["inner" + ("vh" === t.substr(-2) ? "Height" : "Width")] * (parseFloat(i ? t.substr(2) : t) / 100)),
                            null == t ? e : i ? parseInt(t.charAt(0) + "1", 10) * parseFloat(t.substr(2)) + e : parseFloat(t) || 0
                        );
                    },
                    pt = function (t, e, i, r) {
                        var s, n, a, o, l;
                        return (
                            "function" == typeof t && (t = t(C, A)),
                            null == t
                                ? (o = e)
                                : "number" == typeof t
                                ? (o = t)
                                : ((s = 360),
                                  (n = t.split("_")),
                                  (a = ((l = "=" === t.charAt(1)) ? parseInt(t.charAt(0) + "1", 10) * parseFloat(n[0].substr(2)) : parseFloat(n[0])) * (-1 === t.indexOf("rad") ? 1 : U) - (l ? 0 : e)),
                                  n.length &&
                                      (r && (r[i] = e + a),
                                      -1 !== t.indexOf("short") && (a %= s) !== a % 180 && (a = a < 0 ? a + s : a - s),
                                      -1 !== t.indexOf("_cw") && a < 0 ? (a = ((a + 3599999999640) % s) - ((a / s) | 0) * s) : -1 !== t.indexOf("ccw") && 0 < a && (a = ((a - 3599999999640) % s) - ((a / s) | 0) * s)),
                                  (o = e + a)),
                            o < 1e-6 && -1e-6 < o && (o = 0),
                            o
                        );
                    },
                    _t = {
                        aqua: [0, 255, 255],
                        lime: [0, 255, 0],
                        silver: [192, 192, 192],
                        black: [0, 0, 0],
                        maroon: [128, 0, 0],
                        teal: [0, 128, 128],
                        blue: [0, 0, 255],
                        navy: [0, 0, 128],
                        white: [255, 255, 255],
                        fuchsia: [255, 0, 255],
                        olive: [128, 128, 0],
                        yellow: [255, 255, 0],
                        orange: [255, 165, 0],
                        gray: [128, 128, 128],
                        purple: [128, 0, 128],
                        green: [0, 128, 0],
                        red: [255, 0, 0],
                        pink: [255, 192, 203],
                        cyan: [0, 255, 255],
                        transparent: [255, 255, 255, 0],
                    },
                    ct = function (t, e, i) {
                        return (255 * (6 * (t = t < 0 ? t + 1 : 1 < t ? t - 1 : t) < 1 ? e + (i - e) * t * 6 : t < 0.5 ? i : 3 * t < 2 ? e + (i - e) * (2 / 3 - t) * 6 : e) + 0.5) | 0;
                    },
                    dt = (E.parseColor = function (t, e) {
                        var i, r, s, n, a, o, l, h, f, u, p;
                        if (t)
                            if ("number" == typeof t) i = [t >> 16, (t >> 8) & 255, 255 & t];
                            else {
                                if (("," === t.charAt(t.length - 1) && (t = t.substr(0, t.length - 1)), _t[t])) i = _t[t];
                                else if ("#" === t.charAt(0)) 4 === t.length && (t = "#" + (r = t.charAt(1)) + r + (s = t.charAt(2)) + s + (n = t.charAt(3)) + n), (i = [(t = parseInt(t.substr(1), 16)) >> 16, (t >> 8) & 255, 255 & t]);
                                else if ("hsl" === t.substr(0, 3))
                                    if (((i = p = t.match(R)), e)) {
                                        if (-1 !== t.indexOf("=")) return t.match(M);
                                    } else
                                        (a = (Number(i[0]) % 360) / 360),
                                            (o = Number(i[1]) / 100),
                                            (r = 2 * (l = Number(i[2]) / 100) - (s = l <= 0.5 ? l * (o + 1) : l + o - l * o)),
                                            3 < i.length && (i[3] = Number(i[3])),
                                            (i[0] = ct(a + 1 / 3, r, s)),
                                            (i[1] = ct(a, r, s)),
                                            (i[2] = ct(a - 1 / 3, r, s));
                                else i = t.match(R) || _t.transparent;
                                (i[0] = Number(i[0])), (i[1] = Number(i[1])), (i[2] = Number(i[2])), 3 < i.length && (i[3] = Number(i[3]));
                            }
                        else i = _t.black;
                        return (
                            e &&
                                !p &&
                                ((r = i[0] / 255),
                                (s = i[1] / 255),
                                (n = i[2] / 255),
                                (l = ((h = Math.max(r, s, n)) + (f = Math.min(r, s, n))) / 2),
                                h === f ? (a = o = 0) : ((u = h - f), (o = 0.5 < l ? u / (2 - h - f) : u / (h + f)), (a = h === r ? (s - n) / u + (s < n ? 6 : 0) : h === s ? (n - r) / u + 2 : (r - s) / u + 4), (a *= 60)),
                                (i[0] = (a + 0.5) | 0),
                                (i[1] = (100 * o + 0.5) | 0),
                                (i[2] = (100 * l + 0.5) | 0)),
                            i
                        );
                    }),
                    mt = function (t, e) {
                        var i,
                            r,
                            s,
                            n = t.match(gt) || [],
                            a = 0,
                            o = "";
                        if (!n.length) return t;
                        for (i = 0; i < n.length; i++)
                            (r = n[i]),
                                (a += (s = t.substr(a, t.indexOf(r, a) - a)).length + r.length),
                                3 === (r = dt(r, e)).length && r.push(1),
                                (o += s + (e ? "hsla(" + r[0] + "," + r[1] + "%," + r[2] + "%," + r[3] : "rgba(" + r.join(",")) + ")");
                        return o + t.substr(a);
                    },
                    gt = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b";
                for (t in _t) gt += "|" + t + "\\b";
                (gt = new RegExp(gt + ")", "gi")),
                    (E.colorStringFilter = function (t) {
                        var e,
                            i = t[0] + " " + t[1];
                        gt.test(i) && ((e = -1 !== i.indexOf("hsl(") || -1 !== i.indexOf("hsla(")), (t[0] = mt(t[0], e)), (t[1] = mt(t[1], e))), (gt.lastIndex = 0);
                    }),
                    j.defaultStringFilter || (j.defaultStringFilter = E.colorStringFilter);
                var vt = function (t, e, n, a) {
                        if (null == t)
                            return function (t) {
                                return t;
                            };
                        var o,
                            l = e ? (t.match(gt) || [""])[0] : "",
                            h = t.split(l).join("").match(x) || [],
                            f = t.substr(0, t.indexOf(h[0])),
                            u = ")" === t.charAt(t.length - 1) ? ")" : "",
                            p = -1 !== t.indexOf(" ") ? " " : ",",
                            _ = h.length,
                            c = 0 < _ ? h[0].replace(R, "") : "";
                        return _
                            ? (o = e
                                  ? function (t) {
                                        var e, i, r, s;
                                        if ("number" == typeof t) t += c;
                                        else if (a && z.test(t)) {
                                            for (s = t.replace(z, "|").split("|"), r = 0; r < s.length; r++) s[r] = o(s[r]);
                                            return s.join(",");
                                        }
                                        if (((e = (t.match(gt) || [l])[0]), (r = (i = t.split(e).join("").match(x) || []).length), _ > r--)) for (; ++r < _; ) i[r] = n ? i[((r - 1) / 2) | 0] : h[r];
                                        return f + i.join(p) + p + e + u + (-1 !== t.indexOf("inset") ? " inset" : "");
                                    }
                                  : function (t) {
                                        var e, i, r;
                                        if ("number" == typeof t) t += c;
                                        else if (a && z.test(t)) {
                                            for (i = t.replace(z, "|").split("|"), r = 0; r < i.length; r++) i[r] = o(i[r]);
                                            return i.join(",");
                                        }
                                        if (((r = (e = t.match(x) || []).length), _ > r--)) for (; ++r < _; ) e[r] = n ? e[((r - 1) / 2) | 0] : h[r];
                                        return f + e.join(p) + u;
                                    })
                            : function (t) {
                                  return t;
                              };
                    },
                    yt = function (h) {
                        return (
                            (h = h.split(",")),
                            function (t, e, i, r, s, n, a) {
                                var o,
                                    l = (e + "").split(" ");
                                for (a = {}, o = 0; o < 4; o++) a[h[o]] = l[o] = l[o] || l[((o - 1) / 2) >> 0];
                                return r.parse(t, a, s, n);
                            }
                        );
                    },
                    xt =
                        ((s._setPluginRatio = function (t) {
                            this.plugin.setRatio(t);
                            for (var e, i, r, s, n, a = this.data, o = a.proxy, l = a.firstMPT; l; ) (e = o[l.v]), l.r ? (e = l.r(e)) : e < 1e-6 && -1e-6 < e && (e = 0), (l.t[l.p] = e), (l = l._next);
                            if ((a.autoRotate && (a.autoRotate.rotation = a.mod ? a.mod.call(this._tween, o.rotation, this.t, this._tween) : o.rotation), 1 === t || 0 === t))
                                for (l = a.firstMPT, n = 1 === t ? "e" : "b"; l; ) {
                                    if ((i = l.t).type) {
                                        if (1 === i.type) {
                                            for (s = i.xs0 + i.s + i.xs1, r = 1; r < i.l; r++) s += i["xn" + r] + i["xs" + (r + 1)];
                                            i[n] = s;
                                        }
                                    } else i[n] = i.s + i.xs0;
                                    l = l._next;
                                }
                        }),
                        function (t, e, i, r, s) {
                            (this.t = t), (this.p = e), (this.v = i), (this.r = s), r && ((r._prev = this)._next = r);
                        }),
                    Tt =
                        ((s._parseToProxy = function (t, e, i, r, s, n) {
                            var a,
                                o,
                                l,
                                h,
                                f,
                                u = r,
                                p = {},
                                _ = {},
                                c = i._transform,
                                d = N;
                            for (i._transform = null, N = e, r = f = i.parse(t, e, r, s), N = d, n && ((i._transform = c), u && ((u._prev = null), u._prev && (u._prev._next = null))); r && r !== u; ) {
                                if (r.type <= 1 && ((_[(o = r.p)] = r.s + r.c), (p[o] = r.s), n || ((h = new xt(r, "s", o, h, r.r)), (r.c = 0)), 1 === r.type))
                                    for (a = r.l; 0 < --a; ) (l = "xn" + a), (_[(o = r.p + "_" + l)] = r.data[l]), (p[o] = r[l]), n || (h = new xt(r, l, o, h, r.rxp[l]));
                                r = r._next;
                            }
                            return { proxy: p, end: _, firstMPT: h, pt: f };
                        }),
                        (s.CSSPropTween = function (t, e, i, r, s, n, a, o, l, h, f) {
                            (this.t = t),
                                (this.p = e),
                                (this.s = i),
                                (this.c = r),
                                (this.n = a || e),
                                t instanceof Tt || d.push(this.n),
                                (this.r = o ? ("function" == typeof o ? o : Math.round) : o),
                                (this.type = n || 0),
                                l && ((this.pr = l), (c = !0)),
                                (this.b = void 0 === h ? i : h),
                                (this.e = void 0 === f ? i + r : f),
                                s && ((this._next = s)._prev = this);
                        })),
                    bt = function (t, e, i, r, s, n) {
                        var a = new Tt(t, e, i, r - i, s, -1, n);
                        return (a.b = i), (a.e = a.xs0 = r), a;
                    },
                    wt = (E.parseComplex = function (t, e, i, r, s, n, a, o, l, h) {
                        (i = i || n || ""),
                            "function" == typeof r && (r = r(C, A)),
                            (a = new Tt(t, e, 0, 0, a, h ? 2 : 1, null, !1, o, i, r)),
                            (r += ""),
                            s && gt.test(r + i) && ((r = [i, r]), E.colorStringFilter(r), (i = r[0]), (r = r[1]));
                        var f,
                            u,
                            p,
                            _,
                            c,
                            d,
                            m,
                            g,
                            v,
                            y,
                            x,
                            T,
                            b,
                            w = i.split(", ").join(",").split(" "),
                            P = r.split(", ").join(",").split(" "),
                            O = w.length,
                            S = !1 !== k;
                        for (
                            (-1 !== r.indexOf(",") || -1 !== i.indexOf(",")) &&
                                (-1 !== (r + i).indexOf("rgb") || -1 !== (r + i).indexOf("hsl")
                                    ? ((w = w.join(" ").replace(z, ", ").split(" ")), (P = P.join(" ").replace(z, ", ").split(" ")))
                                    : ((w = w.join(" ").split(",").join(", ").split(" ")), (P = P.join(" ").split(",").join(", ").split(" "))),
                                (O = w.length)),
                                O !== P.length && (O = (w = (n || "").split(" ")).length),
                                a.plugin = l,
                                a.setRatio = h,
                                f = gt.lastIndex = 0;
                            f < O;
                            f++
                        )
                            if (((_ = w[f]), (c = P[f] + ""), (g = parseFloat(_)) || 0 === g)) a.appendXtra("", g, ft(c, g), c.replace(M, ""), !(!S || -1 === c.indexOf("px")) && Math.round, !0);
                            else if (s && gt.test(_))
                                (T = ")" + ((T = c.indexOf(")") + 1) ? c.substr(T) : "")),
                                    (b = -1 !== c.indexOf("hsl") && Z),
                                    (y = c),
                                    (_ = dt(_, b)),
                                    (c = dt(c, b)),
                                    (v = 6 < _.length + c.length) && !Z && 0 === c[3]
                                        ? ((a["xs" + a.l] += a.l ? " transparent" : "transparent"), (a.e = a.e.split(P[f]).join("transparent")))
                                        : (Z || (v = !1),
                                          b
                                              ? a
                                                    .appendXtra(y.substr(0, y.indexOf("hsl")) + (v ? "hsla(" : "hsl("), _[0], ft(c[0], _[0]), ",", !1, !0)
                                                    .appendXtra("", _[1], ft(c[1], _[1]), "%,", !1)
                                                    .appendXtra("", _[2], ft(c[2], _[2]), v ? "%," : "%" + T, !1)
                                              : a
                                                    .appendXtra(y.substr(0, y.indexOf("rgb")) + (v ? "rgba(" : "rgb("), _[0], c[0] - _[0], ",", Math.round, !0)
                                                    .appendXtra("", _[1], c[1] - _[1], ",", Math.round)
                                                    .appendXtra("", _[2], c[2] - _[2], v ? "," : T, Math.round),
                                          v && ((_ = _.length < 4 ? 1 : _[3]), a.appendXtra("", _, (c.length < 4 ? 1 : c[3]) - _, T, !1))),
                                    (gt.lastIndex = 0);
                            else if ((d = _.match(R))) {
                                if (!(m = c.match(M)) || m.length !== d.length) return a;
                                for (u = p = 0; u < d.length; u++)
                                    (x = d[u]), (y = _.indexOf(x, p)), a.appendXtra(_.substr(p, y - p), Number(x), ft(m[u], x), "", !(!S || "px" !== _.substr(y + x.length, 2)) && Math.round, 0 === u), (p = y + x.length);
                                a["xs" + a.l] += _.substr(p);
                            } else a["xs" + a.l] += a.l || a["xs" + a.l] ? " " + c : c;
                        if (-1 !== r.indexOf("=") && a.data) {
                            for (T = a.xs0 + a.data.s, f = 1; f < a.l; f++) T += a["xs" + f] + a.data["xn" + f];
                            a.e = T + a["xs" + f];
                        }
                        return a.l || ((a.type = -1), (a.xs0 = a.e)), a.xfirst || a;
                    }),
                    Pt = 9;
                for ((t = Tt.prototype).l = t.pr = 0; 0 < --Pt; ) (t["xn" + Pt] = 0), (t["xs" + Pt] = "");
                (t.xs0 = ""),
                    (t._next = t._prev = t.xfirst = t.data = t.plugin = t.setRatio = t.rxp = null),
                    (t.appendXtra = function (t, e, i, r, s, n) {
                        var a = this,
                            o = a.l;
                        return (
                            (a["xs" + o] += n && (o || a["xs" + o]) ? " " + t : t || ""),
                            i || 0 === o || a.plugin
                                ? (a.l++,
                                  (a.type = a.setRatio ? 2 : 1),
                                  (a["xs" + a.l] = r || ""),
                                  0 < o
                                      ? ((a.data["xn" + o] = e + i), (a.rxp["xn" + o] = s), (a["xn" + o] = e), a.plugin || ((a.xfirst = new Tt(a, "xn" + o, e, i, a.xfirst || a, 0, a.n, s, a.pr)), (a.xfirst.xs0 = 0)))
                                      : ((a.data = { s: e + i }), (a.rxp = {}), (a.s = e), (a.c = i), (a.r = s)))
                                : (a["xs" + o] += e + (r || "")),
                            a
                        );
                    });
                var Ot = function (t, e) {
                        (e = e || {}),
                            (this.p = (e.prefix && J(t)) || t),
                            (m[t] = m[this.p] = this),
                            (this.format = e.formatter || vt(e.defaultValue, e.color, e.collapsible, e.multi)),
                            e.parser && (this.parse = e.parser),
                            (this.clrs = e.color),
                            (this.multi = e.multi),
                            (this.keyword = e.keyword),
                            (this.dflt = e.defaultValue),
                            (this.pr = e.priority || 0);
                    },
                    St = (s._registerComplexSpecialProp = function (t, e, i) {
                        "object" != typeof e && (e = { parser: i });
                        var r,
                            s = t.split(","),
                            n = e.defaultValue;
                        for (i = i || [n], r = 0; r < s.length; r++) (e.prefix = 0 === r && e.prefix), (e.defaultValue = i[r] || n), new Ot(s[r], e);
                    }),
                    kt = (s._registerPluginProp = function (t) {
                        if (!m[t]) {
                            var l = t.charAt(0).toUpperCase() + t.substr(1) + "Plugin";
                            St(t, {
                                parser: function (t, e, i, r, s, n, a) {
                                    var o = h.com.greensock.plugins[l];
                                    return o ? (o._cssRegister(), m[i].parse(t, e, i, r, s, n, a)) : (Q("Error: " + l + " js file not loaded."), s);
                                },
                            });
                        }
                    });
                ((t = Ot.prototype).parseComplex = function (t, e, i, r, s, n) {
                    var a,
                        o,
                        l,
                        h,
                        f,
                        u,
                        p = this.keyword;
                    if ((this.multi && (z.test(i) || z.test(e) ? ((o = e.replace(z, "|").split("|")), (l = i.replace(z, "|").split("|"))) : p && ((o = [e]), (l = [i]))), l)) {
                        for (h = l.length > o.length ? l.length : o.length, a = 0; a < h; a++)
                            (e = o[a] = o[a] || this.dflt), (i = l[a] = l[a] || this.dflt), p && (f = e.indexOf(p)) !== (u = i.indexOf(p)) && (-1 === u ? (o[a] = o[a].split(p).join("")) : -1 === f && (o[a] += " " + p));
                        (e = o.join(", ")), (i = l.join(", "));
                    }
                    return wt(t, this.p, e, i, this.clrs, this.dflt, r, this.pr, s, n);
                }),
                    (t.parse = function (t, e, i, r, s, n, a) {
                        return this.parseComplex(t.style, this.format(et(t, this.p, S, !1, this.dflt)), this.format(e), s, n);
                    }),
                    (E.registerSpecialProp = function (t, l, h) {
                        St(t, {
                            parser: function (t, e, i, r, s, n, a) {
                                var o = new Tt(t, i, 0, 0, s, 2, i, !1, h);
                                return (o.plugin = n), (o.setRatio = l(t, e, r._tween, i)), o;
                            },
                            priority: h,
                        });
                    }),
                    (E.useSVGTransformAttr = !0);
                var At,
                    Ct,
                    Rt,
                    Mt,
                    Ft,
                    Dt = "scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent".split(","),
                    Xt = J("transform"),
                    zt = $ + "transform",
                    Lt = J("transformOrigin"),
                    Nt = null !== J("perspective"),
                    It = (s.Transform = function () {
                        (this.perspective = parseFloat(E.defaultTransformPerspective) || 0), (this.force3D = !(!1 === E.defaultForce3D || !Nt) && (E.defaultForce3D || "auto"));
                    }),
                    Yt = _gsScope.SVGElement,
                    jt = function (t, e, i) {
                        var r,
                            s = I.createElementNS("http://www.w3.org/2000/svg", t),
                            n = /([a-z])([A-Z])/g;
                        for (r in i) s.setAttributeNS(null, r.replace(n, "$1-$2").toLowerCase(), i[r]);
                        return e.appendChild(s), s;
                    },
                    Et = I.documentElement || {},
                    Bt =
                        ((Ft = O || (/Android/i.test(q) && !_gsScope.chrome)),
                        I.createElementNS &&
                            !Ft &&
                            ((Ct = jt("svg", Et)),
                            (Mt = (Rt = jt("rect", Ct, { width: 100, height: 50, x: 100 })).getBoundingClientRect().width),
                            (Rt.style[Lt] = "50% 50%"),
                            (Rt.style[Xt] = "scaleX(0.5)"),
                            (Ft = Mt === Rt.getBoundingClientRect().width && !(B && Nt)),
                            Et.removeChild(Ct)),
                        Ft),
                    Vt = function (t, e, i, r, s, n) {
                        var a,
                            o,
                            l,
                            h,
                            f,
                            u,
                            p,
                            _,
                            c,
                            d,
                            m,
                            g,
                            v,
                            y,
                            x = t._gsTransform,
                            T = qt(t, !0);
                        x && ((v = x.xOrigin), (y = x.yOrigin)),
                            (!r || (a = r.split(" ")).length < 2) &&
                                (0 === (p = t.getBBox()).x &&
                                    0 === p.y &&
                                    p.width + p.height === 0 &&
                                    (p = {
                                        x: parseFloat(t.hasAttribute("x") ? t.getAttribute("x") : t.hasAttribute("cx") ? t.getAttribute("cx") : 0) || 0,
                                        y: parseFloat(t.hasAttribute("y") ? t.getAttribute("y") : t.hasAttribute("cy") ? t.getAttribute("cy") : 0) || 0,
                                        width: 0,
                                        height: 0,
                                    }),
                                (a = [
                                    (-1 !== (e = ht(e).split(" "))[0].indexOf("%") ? (parseFloat(e[0]) / 100) * p.width : parseFloat(e[0])) + p.x,
                                    (-1 !== e[1].indexOf("%") ? (parseFloat(e[1]) / 100) * p.height : parseFloat(e[1])) + p.y,
                                ])),
                            (i.xOrigin = h = parseFloat(a[0])),
                            (i.yOrigin = f = parseFloat(a[1])),
                            r &&
                                T !== Gt &&
                                ((u = T[0]),
                                (p = T[1]),
                                (_ = T[2]),
                                (c = T[3]),
                                (d = T[4]),
                                (m = T[5]),
                                (g = u * c - p * _) && ((o = h * (c / g) + f * (-_ / g) + (_ * m - c * d) / g), (l = h * (-p / g) + f * (u / g) - (u * m - p * d) / g), (h = i.xOrigin = a[0] = o), (f = i.yOrigin = a[1] = l))),
                            x &&
                                (n && ((i.xOffset = x.xOffset), (i.yOffset = x.yOffset), (x = i)),
                                s || (!1 !== s && !1 !== E.defaultSmoothOrigin) ? ((o = h - v), (l = f - y), (x.xOffset += o * T[0] + l * T[2] - o), (x.yOffset += o * T[1] + l * T[3] - l)) : (x.xOffset = x.yOffset = 0)),
                            n || t.setAttribute("data-svg-origin", a.join(" "));
                    },
                    Ut = function (t) {
                        var e,
                            i = Y("svg", (this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns")) || "http://www.w3.org/2000/svg"),
                            r = this.parentNode,
                            s = this.nextSibling,
                            n = this.style.cssText;
                        if ((Et.appendChild(i), i.appendChild(this), (this.style.display = "block"), t))
                            try {
                                (e = this.getBBox()), (this._originalGetBBox = this.getBBox), (this.getBBox = Ut);
                            } catch (t) {}
                        else this._originalGetBBox && (e = this._originalGetBBox());
                        return s ? r.insertBefore(this, s) : r.appendChild(this), Et.removeChild(i), (this.style.cssText = n), e;
                    },
                    Wt = function (t) {
                        return !(
                            !Yt ||
                            !t.getCTM ||
                            (t.parentNode && !t.ownerSVGElement) ||
                            !(function (e) {
                                try {
                                    return e.getBBox();
                                } catch (t) {
                                    return Ut.call(e, !0);
                                }
                            })(t)
                        );
                    },
                    Gt = [1, 0, 0, 1, 0, 0],
                    qt = function (t, e) {
                        var i,
                            r,
                            s,
                            n,
                            a,
                            o,
                            l = t._gsTransform || new It(),
                            h = t.style;
                        if (
                            (Xt
                                ? (r = et(t, zt, null, !0))
                                : t.currentStyle && (r = (r = t.currentStyle.filter.match(p)) && 4 === r.length ? [r[0].substr(4), Number(r[2].substr(4)), Number(r[1].substr(4)), r[3].substr(4), l.x || 0, l.y || 0].join(",") : ""),
                            (i = !r || "none" === r || "matrix(1, 0, 0, 1, 0, 0)" === r),
                            !Xt ||
                                (!(o = !tt(t) || "none" === tt(t).display) && t.parentNode) ||
                                (o && ((n = h.display), (h.display = "block")),
                                t.parentNode || ((a = 1), Et.appendChild(t)),
                                (i = !(r = et(t, zt, null, !0)) || "none" === r || "matrix(1, 0, 0, 1, 0, 0)" === r),
                                n ? (h.display = n) : o && Kt(h, "display"),
                                a && Et.removeChild(t)),
                            (l.svg || (t.getCTM && Wt(t))) &&
                                (i && -1 !== (h[Xt] + "").indexOf("matrix") && ((r = h[Xt]), (i = 0)),
                                (s = t.getAttribute("transform")),
                                i && s && ((r = "matrix(" + (s = t.transform.baseVal.consolidate().matrix).a + "," + s.b + "," + s.c + "," + s.d + "," + s.e + "," + s.f + ")"), (i = 0))),
                            i)
                        )
                            return Gt;
                        for (s = (r || "").match(R) || [], Pt = s.length; -1 < --Pt; ) (n = Number(s[Pt])), (s[Pt] = (a = n - (n |= 0)) ? ((1e5 * a + (a < 0 ? -0.5 : 0.5)) | 0) / 1e5 + n : n);
                        return e && 6 < s.length ? [s[0], s[1], s[4], s[5], s[12], s[13]] : s;
                    },
                    Zt = (s.getTransform = function (t, e, i, r) {
                        if (t._gsTransform && i && !r) return t._gsTransform;
                        var s,
                            n,
                            a,
                            o,
                            l,
                            h,
                            f = (i && t._gsTransform) || new It(),
                            u = f.scaleX < 0,
                            p = (Nt && (parseFloat(et(t, Lt, e, !1, "0 0 0").split(" ")[2]) || f.zOrigin)) || 0,
                            _ = parseFloat(E.defaultTransformPerspective) || 0;
                        if (((f.svg = !(!t.getCTM || !Wt(t))), f.svg && (Vt(t, et(t, Lt, e, !1, "50% 50%") + "", f, t.getAttribute("data-svg-origin")), (At = E.useSVGTransformAttr || Bt)), (s = qt(t)) !== Gt)) {
                            if (16 === s.length) {
                                var c,
                                    d,
                                    m,
                                    g,
                                    v,
                                    y = s[0],
                                    x = s[1],
                                    T = s[2],
                                    b = s[3],
                                    w = s[4],
                                    P = s[5],
                                    O = s[6],
                                    S = s[7],
                                    k = s[8],
                                    A = s[9],
                                    C = s[10],
                                    R = s[12],
                                    M = s[13],
                                    F = s[14],
                                    D = s[11],
                                    X = Math.atan2(O, C);
                                f.zOrigin && ((R = k * (F = -f.zOrigin) - s[12]), (M = A * F - s[13]), (F = C * F + f.zOrigin - s[14])),
                                    (f.rotationX = X * U),
                                    X &&
                                        ((c = w * (g = Math.cos(-X)) + k * (v = Math.sin(-X))),
                                        (d = P * g + A * v),
                                        (m = O * g + C * v),
                                        (k = w * -v + k * g),
                                        (A = P * -v + A * g),
                                        (C = O * -v + C * g),
                                        (D = S * -v + D * g),
                                        (w = c),
                                        (P = d),
                                        (O = m)),
                                    (X = Math.atan2(-T, C)),
                                    (f.rotationY = X * U),
                                    X && ((d = x * (g = Math.cos(-X)) - A * (v = Math.sin(-X))), (m = T * g - C * v), (A = x * v + A * g), (C = T * v + C * g), (D = b * v + D * g), (y = c = y * g - k * v), (x = d), (T = m)),
                                    (X = Math.atan2(x, y)),
                                    (f.rotation = X * U),
                                    X && ((c = y * (g = Math.cos(X)) + x * (v = Math.sin(X))), (d = w * g + P * v), (m = k * g + A * v), (x = x * g - y * v), (P = P * g - w * v), (A = A * g - k * v), (y = c), (w = d), (k = m)),
                                    f.rotationX && 359.9 < Math.abs(f.rotationX) + Math.abs(f.rotation) && ((f.rotationX = f.rotation = 0), (f.rotationY = 180 - f.rotationY)),
                                    (X = Math.atan2(w, P)),
                                    (f.scaleX = ((1e5 * Math.sqrt(y * y + x * x + T * T) + 0.5) | 0) / 1e5),
                                    (f.scaleY = ((1e5 * Math.sqrt(P * P + O * O) + 0.5) | 0) / 1e5),
                                    (f.scaleZ = ((1e5 * Math.sqrt(k * k + A * A + C * C) + 0.5) | 0) / 1e5),
                                    (y /= f.scaleX),
                                    (w /= f.scaleY),
                                    (x /= f.scaleX),
                                    (P /= f.scaleY),
                                    2e-5 < Math.abs(X) ? ((f.skewX = X * U), (w = 0), "simple" !== f.skewType && (f.scaleY *= 1 / Math.cos(X))) : (f.skewX = 0),
                                    (f.perspective = D ? 1 / (D < 0 ? -D : D) : 0),
                                    (f.x = R),
                                    (f.y = M),
                                    (f.z = F),
                                    f.svg && ((f.x -= f.xOrigin - (f.xOrigin * y - f.yOrigin * w)), (f.y -= f.yOrigin - (f.yOrigin * x - f.xOrigin * P)));
                            } else if (!Nt || r || !s.length || f.x !== s[4] || f.y !== s[5] || (!f.rotationX && !f.rotationY)) {
                                var z = 6 <= s.length,
                                    L = z ? s[0] : 1,
                                    N = s[1] || 0,
                                    I = s[2] || 0,
                                    Y = z ? s[3] : 1;
                                (f.x = s[4] || 0),
                                    (f.y = s[5] || 0),
                                    (a = Math.sqrt(L * L + N * N)),
                                    (o = Math.sqrt(Y * Y + I * I)),
                                    (l = L || N ? Math.atan2(N, L) * U : f.rotation || 0),
                                    (h = I || Y ? Math.atan2(I, Y) * U + l : f.skewX || 0),
                                    (f.scaleX = a),
                                    (f.scaleY = o),
                                    (f.rotation = l),
                                    (f.skewX = h),
                                    Nt && ((f.rotationX = f.rotationY = f.z = 0), (f.perspective = _), (f.scaleZ = 1)),
                                    f.svg && ((f.x -= f.xOrigin - (f.xOrigin * L + f.yOrigin * I)), (f.y -= f.yOrigin - (f.xOrigin * N + f.yOrigin * Y)));
                            }
                            for (n in (90 < Math.abs(f.skewX) &&
                                Math.abs(f.skewX) < 270 &&
                                (u ? ((f.scaleX *= -1), (f.skewX += f.rotation <= 0 ? 180 : -180), (f.rotation += f.rotation <= 0 ? 180 : -180)) : ((f.scaleY *= -1), (f.skewX += f.skewX <= 0 ? 180 : -180))),
                            (f.zOrigin = p),
                            f))
                                f[n] < 2e-5 && -2e-5 < f[n] && (f[n] = 0);
                        }
                        return (
                            i &&
                                (t._gsTransform = f).svg &&
                                (At && t.style[Xt]
                                    ? j.delayedCall(0.001, function () {
                                          Kt(t.style, Xt);
                                      })
                                    : !At &&
                                      t.getAttribute("transform") &&
                                      j.delayedCall(0.001, function () {
                                          t.removeAttribute("transform");
                                      })),
                            f
                        );
                    }),
                    Ht = function (t) {
                        var e,
                            i,
                            r = this.data,
                            s = -r.rotation * V,
                            n = s + r.skewX * V,
                            a = 1e5,
                            o = ((Math.cos(s) * r.scaleX * a) | 0) / a,
                            l = ((Math.sin(s) * r.scaleX * a) | 0) / a,
                            h = ((Math.sin(n) * -r.scaleY * a) | 0) / a,
                            f = ((Math.cos(n) * r.scaleY * a) | 0) / a,
                            u = this.t.style,
                            p = this.t.currentStyle;
                        if (p) {
                            (i = l), (l = -h), (h = -i), (e = p.filter), (u.filter = "");
                            var _,
                                c,
                                d = this.t.offsetWidth,
                                m = this.t.offsetHeight,
                                g = "absolute" !== p.position,
                                v = "progid:DXImageTransform.Microsoft.Matrix(M11=" + o + ", M12=" + l + ", M21=" + h + ", M22=" + f,
                                y = r.x + (d * r.xPercent) / 100,
                                x = r.y + (m * r.yPercent) / 100;
                            if (
                                (null != r.ox && ((y += (_ = (r.oxp ? d * r.ox * 0.01 : r.ox) - d / 2) - (_ * o + (c = (r.oyp ? m * r.oy * 0.01 : r.oy) - m / 2) * l)), (x += c - (_ * h + c * f))),
                                g ? (v += ", Dx=" + ((_ = d / 2) - (_ * o + (c = m / 2) * l) + y) + ", Dy=" + (c - (_ * h + c * f) + x) + ")") : (v += ", sizingMethod='auto expand')"),
                                -1 !== e.indexOf("DXImageTransform.Microsoft.Matrix(") ? (u.filter = e.replace(X, v)) : (u.filter = v + " " + e),
                                (0 === t || 1 === t) &&
                                    1 === o &&
                                    0 === l &&
                                    0 === h &&
                                    1 === f &&
                                    ((g && -1 === v.indexOf("Dx=0, Dy=0")) || (D.test(e) && 100 !== parseFloat(RegExp.$1)) || (-1 === e.indexOf(e.indexOf("Alpha")) && u.removeAttribute("filter"))),
                                !g)
                            ) {
                                var T,
                                    b,
                                    w,
                                    P = O < 8 ? 1 : -1;
                                for (
                                    _ = r.ieOffsetX || 0,
                                        c = r.ieOffsetY || 0,
                                        r.ieOffsetX = Math.round((d - ((o < 0 ? -o : o) * d + (l < 0 ? -l : l) * m)) / 2 + y),
                                        r.ieOffsetY = Math.round((m - ((f < 0 ? -f : f) * m + (h < 0 ? -h : h) * d)) / 2 + x),
                                        Pt = 0;
                                    Pt < 4;
                                    Pt++
                                )
                                    (w =
                                        (i = -1 !== (T = p[(b = ot[Pt])]).indexOf("px") ? parseFloat(T) : it(this.t, b, parseFloat(T), T.replace(F, "")) || 0) !== r[b]
                                            ? Pt < 2
                                                ? -r.ieOffsetX
                                                : -r.ieOffsetY
                                            : Pt < 2
                                            ? _ - r.ieOffsetX
                                            : c - r.ieOffsetY),
                                        (u[b] = (r[b] = Math.round(i - w * (0 === Pt || 2 === Pt ? 1 : P))) + "px");
                            }
                        }
                    },
                    Qt = (s.set3DTransformRatio = s.setTransformRatio = function (t) {
                        var e,
                            i,
                            r,
                            s,
                            n,
                            a,
                            o,
                            l,
                            h,
                            f,
                            u,
                            p,
                            _,
                            c,
                            d,
                            m,
                            g,
                            v,
                            y,
                            x,
                            T,
                            b,
                            w,
                            P = this.data,
                            O = this.t.style,
                            S = P.rotation,
                            k = P.rotationX,
                            A = P.rotationY,
                            C = P.scaleX,
                            R = P.scaleY,
                            M = P.scaleZ,
                            F = P.x,
                            D = P.y,
                            X = P.z,
                            z = P.svg,
                            L = P.perspective,
                            N = P.force3D,
                            I = P.skewY,
                            Y = P.skewX;
                        if ((I && ((Y += I), (S += I)), !((((1 !== t && 0 !== t) || "auto" !== N || (this.tween._totalTime !== this.tween._totalDuration && this.tween._totalTime)) && N) || X || L || A || k || 1 !== M) || (At && z) || !Nt))
                            S || Y || z
                                ? ((S *= V),
                                  (b = Y * V),
                                  (w = 1e5),
                                  (i = Math.cos(S) * C),
                                  (n = Math.sin(S) * C),
                                  (r = Math.sin(S - b) * -R),
                                  (a = Math.cos(S - b) * R),
                                  b && "simple" === P.skewType && ((e = Math.tan(b - I * V)), (r *= e = Math.sqrt(1 + e * e)), (a *= e), I && ((e = Math.tan(I * V)), (i *= e = Math.sqrt(1 + e * e)), (n *= e))),
                                  z &&
                                      ((F += P.xOrigin - (P.xOrigin * i + P.yOrigin * r) + P.xOffset),
                                      (D += P.yOrigin - (P.xOrigin * n + P.yOrigin * a) + P.yOffset),
                                      At && (P.xPercent || P.yPercent) && ((d = this.t.getBBox()), (F += 0.01 * P.xPercent * d.width), (D += 0.01 * P.yPercent * d.height)),
                                      F < (d = 1e-6) && -d < F && (F = 0),
                                      D < d && -d < D && (D = 0)),
                                  (y = ((i * w) | 0) / w + "," + ((n * w) | 0) / w + "," + ((r * w) | 0) / w + "," + ((a * w) | 0) / w + "," + F + "," + D + ")"),
                                  z && At ? this.t.setAttribute("transform", "matrix(" + y) : (O[Xt] = (P.xPercent || P.yPercent ? "translate(" + P.xPercent + "%," + P.yPercent + "%) matrix(" : "matrix(") + y))
                                : (O[Xt] = (P.xPercent || P.yPercent ? "translate(" + P.xPercent + "%," + P.yPercent + "%) matrix(" : "matrix(") + C + ",0,0," + R + "," + F + "," + D + ")");
                        else {
                            if ((B && (C < (d = 1e-4) && -d < C && (C = M = 2e-5), R < d && -d < R && (R = M = 2e-5), !L || P.z || P.rotationX || P.rotationY || (L = 0)), S || Y))
                                (S *= V),
                                    (m = i = Math.cos(S)),
                                    (g = n = Math.sin(S)),
                                    Y &&
                                        ((S -= Y * V),
                                        (m = Math.cos(S)),
                                        (g = Math.sin(S)),
                                        "simple" === P.skewType && ((e = Math.tan((Y - I) * V)), (m *= e = Math.sqrt(1 + e * e)), (g *= e), P.skewY && ((e = Math.tan(I * V)), (i *= e = Math.sqrt(1 + e * e)), (n *= e)))),
                                    (r = -g),
                                    (a = m);
                            else {
                                if (!(A || k || 1 !== M || L || z))
                                    return void (O[Xt] =
                                        (P.xPercent || P.yPercent ? "translate(" + P.xPercent + "%," + P.yPercent + "%) translate3d(" : "translate3d(") +
                                        F +
                                        "px," +
                                        D +
                                        "px," +
                                        X +
                                        "px)" +
                                        (1 !== C || 1 !== R ? " scale(" + C + "," + R + ")" : ""));
                                (i = a = 1), (r = n = 0);
                            }
                            (f = 1),
                                (s = o = l = h = u = p = 0),
                                (_ = L ? -1 / L : 0),
                                (c = P.zOrigin),
                                (d = 1e-6),
                                (x = ","),
                                (T = "0"),
                                (S = A * V) && ((m = Math.cos(S)), (u = _ * (l = -(g = Math.sin(S)))), (s = i * g), (o = n * g), (_ *= f = m), (i *= m), (n *= m)),
                                (S = k * V) && ((e = r * (m = Math.cos(S)) + s * (g = Math.sin(S))), (v = a * m + o * g), (h = f * g), (p = _ * g), (s = r * -g + s * m), (o = a * -g + o * m), (f *= m), (_ *= m), (r = e), (a = v)),
                                1 !== M && ((s *= M), (o *= M), (f *= M), (_ *= M)),
                                1 !== R && ((r *= R), (a *= R), (h *= R), (p *= R)),
                                1 !== C && ((i *= C), (n *= C), (l *= C), (u *= C)),
                                (c || z) &&
                                    (c && ((F += s * -c), (D += o * -c), (X += f * -c + c)),
                                    z && ((F += P.xOrigin - (P.xOrigin * i + P.yOrigin * r) + P.xOffset), (D += P.yOrigin - (P.xOrigin * n + P.yOrigin * a) + P.yOffset)),
                                    F < d && -d < F && (F = T),
                                    D < d && -d < D && (D = T),
                                    X < d && -d < X && (X = 0)),
                                (y = P.xPercent || P.yPercent ? "translate(" + P.xPercent + "%," + P.yPercent + "%) matrix3d(" : "matrix3d("),
                                (y += (i < d && -d < i ? T : i) + x + (n < d && -d < n ? T : n) + x + (l < d && -d < l ? T : l)),
                                (y += x + (u < d && -d < u ? T : u) + x + (r < d && -d < r ? T : r) + x + (a < d && -d < a ? T : a)),
                                k || A || 1 !== M
                                    ? ((y += x + (h < d && -d < h ? T : h) + x + (p < d && -d < p ? T : p) + x + (s < d && -d < s ? T : s)),
                                      (y += x + (o < d && -d < o ? T : o) + x + (f < d && -d < f ? T : f) + x + (_ < d && -d < _ ? T : _) + x))
                                    : (y += ",0,0,0,0,1,0,"),
                                (y += F + x + D + x + X + x + (L ? 1 + -X / L : 1) + ")"),
                                (O[Xt] = y);
                        }
                    });
                ((t = It.prototype).x = t.y = t.z = t.skewX = t.skewY = t.rotation = t.rotationX = t.rotationY = t.zOrigin = t.xPercent = t.yPercent = t.xOffset = t.yOffset = 0),
                    (t.scaleX = t.scaleY = t.scaleZ = 1),
                    St(
                        "transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin",
                        {
                            parser: function (t, e, i, r, s, n, a) {
                                if (r._lastParsedTransform === a) return s;
                                var o,
                                    l = (r._lastParsedTransform = a).scale && "function" == typeof a.scale ? a.scale : 0;
                                "function" == typeof a[i] && ((o = a[i]), (a[i] = e)), l && (a.scale = l(C, t));
                                var h,
                                    f,
                                    u,
                                    p,
                                    _,
                                    c,
                                    d,
                                    m,
                                    g,
                                    v = t._gsTransform,
                                    y = t.style,
                                    x = Dt.length,
                                    T = a,
                                    b = {},
                                    w = "transformOrigin",
                                    P = Zt(t, S, !0, T.parseTransform),
                                    O = T.transform && ("function" == typeof T.transform ? T.transform(C, A) : T.transform);
                                if (((P.skewType = T.skewType || P.skewType || E.defaultSkewType), (r._transform = P), "rotationZ" in T && (T.rotation = T.rotationZ), O && "string" == typeof O && Xt))
                                    ((f = W.style)[Xt] = O),
                                        (f.display = "block"),
                                        (f.position = "absolute"),
                                        -1 !== O.indexOf("%") && ((f.width = et(t, "width")), (f.height = et(t, "height"))),
                                        I.body.appendChild(W),
                                        (h = Zt(W, null, !1)),
                                        "simple" === P.skewType && (h.scaleY *= Math.cos(h.skewX * V)),
                                        P.svg &&
                                            ((c = P.xOrigin),
                                            (d = P.yOrigin),
                                            (h.x -= P.xOffset),
                                            (h.y -= P.yOffset),
                                            (T.transformOrigin || T.svgOrigin) &&
                                                ((O = {}), Vt(t, ht(T.transformOrigin), O, T.svgOrigin, T.smoothOrigin, !0), (c = O.xOrigin), (d = O.yOrigin), (h.x -= O.xOffset - P.xOffset), (h.y -= O.yOffset - P.yOffset)),
                                            (c || d) && ((m = qt(W, !0)), (h.x -= c - (c * m[0] + d * m[2])), (h.y -= d - (c * m[1] + d * m[3])))),
                                        I.body.removeChild(W),
                                        h.perspective || (h.perspective = P.perspective),
                                        null != T.xPercent && (h.xPercent = ut(T.xPercent, P.xPercent)),
                                        null != T.yPercent && (h.yPercent = ut(T.yPercent, P.yPercent));
                                else if ("object" == typeof T) {
                                    if (
                                        ((h = {
                                            scaleX: ut(null != T.scaleX ? T.scaleX : T.scale, P.scaleX),
                                            scaleY: ut(null != T.scaleY ? T.scaleY : T.scale, P.scaleY),
                                            scaleZ: ut(T.scaleZ, P.scaleZ),
                                            x: ut(T.x, P.x),
                                            y: ut(T.y, P.y),
                                            z: ut(T.z, P.z),
                                            xPercent: ut(T.xPercent, P.xPercent),
                                            yPercent: ut(T.yPercent, P.yPercent),
                                            perspective: ut(T.transformPerspective, P.perspective),
                                        }),
                                        null != (_ = T.directionalRotation))
                                    )
                                        if ("object" == typeof _) for (f in _) T[f] = _[f];
                                        else T.rotation = _;
                                    "string" == typeof T.x && -1 !== T.x.indexOf("%") && ((h.x = 0), (h.xPercent = ut(T.x, P.xPercent))),
                                        "string" == typeof T.y && -1 !== T.y.indexOf("%") && ((h.y = 0), (h.yPercent = ut(T.y, P.yPercent))),
                                        (h.rotation = pt("rotation" in T ? T.rotation : "shortRotation" in T ? T.shortRotation + "_short" : P.rotation, P.rotation, "rotation", b)),
                                        Nt &&
                                            ((h.rotationX = pt("rotationX" in T ? T.rotationX : "shortRotationX" in T ? T.shortRotationX + "_short" : P.rotationX || 0, P.rotationX, "rotationX", b)),
                                            (h.rotationY = pt("rotationY" in T ? T.rotationY : "shortRotationY" in T ? T.shortRotationY + "_short" : P.rotationY || 0, P.rotationY, "rotationY", b))),
                                        (h.skewX = pt(T.skewX, P.skewX)),
                                        (h.skewY = pt(T.skewY, P.skewY));
                                }
                                for (
                                    Nt && null != T.force3D && ((P.force3D = T.force3D), (p = !0)),
                                        (u = P.force3D || P.z || P.rotationX || P.rotationY || h.z || h.rotationX || h.rotationY || h.perspective) || null == T.scale || (h.scaleZ = 1);
                                    -1 < --x;

                                )
                                    (1e-6 < (O = h[(g = Dt[x])] - P[g]) || O < -1e-6 || null != T[g] || null != N[g]) &&
                                        ((p = !0), (s = new Tt(P, g, P[g], O, s)), g in b && (s.e = b[g]), (s.xs0 = 0), (s.plugin = n), r._overwriteProps.push(s.n));
                                return (
                                    (O = T.transformOrigin),
                                    P.svg &&
                                        (O || T.svgOrigin) &&
                                        ((c = P.xOffset),
                                        (d = P.yOffset),
                                        Vt(t, ht(O), h, T.svgOrigin, T.smoothOrigin),
                                        (s = bt(P, "xOrigin", (v ? P : h).xOrigin, h.xOrigin, s, w)),
                                        (s = bt(P, "yOrigin", (v ? P : h).yOrigin, h.yOrigin, s, w)),
                                        (c !== P.xOffset || d !== P.yOffset) && ((s = bt(P, "xOffset", v ? c : P.xOffset, P.xOffset, s, w)), (s = bt(P, "yOffset", v ? d : P.yOffset, P.yOffset, s, w))),
                                        (O = "0px 0px")),
                                    (O || (Nt && u && P.zOrigin)) &&
                                        (Xt
                                            ? ((p = !0),
                                              (g = Lt),
                                              (O = (O || et(t, g, S, !1, "50% 50%")) + ""),
                                              ((s = new Tt(y, g, 0, 0, s, -1, w)).b = y[g]),
                                              (s.plugin = n),
                                              Nt
                                                  ? ((f = P.zOrigin),
                                                    (O = O.split(" ")),
                                                    (P.zOrigin = (2 < O.length && (0 === f || "0px" !== O[2]) ? parseFloat(O[2]) : f) || 0),
                                                    (s.xs0 = s.e = O[0] + " " + (O[1] || "50%") + " 0px"),
                                                    ((s = new Tt(P, "zOrigin", 0, 0, s, -1, s.n)).b = f),
                                                    (s.xs0 = s.e = P.zOrigin))
                                                  : (s.xs0 = s.e = O))
                                            : ht(O + "", P)),
                                    p && (r._transformType = (P.svg && At) || (!u && 3 !== this._transformType) ? 2 : 3),
                                    o && (a[i] = o),
                                    l && (a.scale = l),
                                    s
                                );
                            },
                            prefix: !0,
                        }
                    ),
                    St("boxShadow", { defaultValue: "0px 0px 0px 0px #999", prefix: !0, color: !0, multi: !0, keyword: "inset" }),
                    St("borderRadius", {
                        defaultValue: "0px",
                        parser: function (t, e, i, r, s, n) {
                            e = this.format(e);
                            var a,
                                o,
                                l,
                                h,
                                f,
                                u,
                                p,
                                _,
                                c,
                                d,
                                m,
                                g,
                                v,
                                y,
                                x,
                                T,
                                b = ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
                                w = t.style;
                            for (c = parseFloat(t.offsetWidth), d = parseFloat(t.offsetHeight), a = e.split(" "), o = 0; o < b.length; o++)
                                this.p.indexOf("border") && (b[o] = J(b[o])),
                                    -1 !== (f = h = et(t, b[o], S, !1, "0px")).indexOf(" ") && ((f = (h = f.split(" "))[0]), (h = h[1])),
                                    (u = l = a[o]),
                                    (p = parseFloat(f)),
                                    (g = f.substr((p + "").length)),
                                    (v = "=" === u.charAt(1))
                                        ? ((_ = parseInt(u.charAt(0) + "1", 10)), (u = u.substr(2)), (_ *= parseFloat(u)), (m = u.substr((_ + "").length - (_ < 0 ? 1 : 0)) || ""))
                                        : ((_ = parseFloat(u)), (m = u.substr((_ + "").length))),
                                    "" === m && (m = P[i] || g),
                                    m !== g &&
                                        ((y = it(t, "borderLeft", p, g)),
                                        (x = it(t, "borderTop", p, g)),
                                        "%" === m ? ((f = (y / c) * 100 + "%"), (h = (x / d) * 100 + "%")) : "em" === m ? ((f = y / (T = it(t, "borderLeft", 1, "em")) + "em"), (h = x / T + "em")) : ((f = y + "px"), (h = x + "px")),
                                        v && ((u = parseFloat(f) + _ + m), (l = parseFloat(h) + _ + m))),
                                    (s = wt(w, b[o], f + " " + h, u + " " + l, !1, "0px", s));
                            return s;
                        },
                        prefix: !0,
                        formatter: vt("0px 0px 0px 0px", !1, !0),
                    }),
                    St("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius", {
                        defaultValue: "0px",
                        parser: function (t, e, i, r, s, n) {
                            return wt(t.style, i, this.format(et(t, i, S, !1, "0px 0px")), this.format(e), !1, "0px", s);
                        },
                        prefix: !0,
                        formatter: vt("0px 0px", !1, !0),
                    }),
                    St("backgroundPosition", {
                        defaultValue: "0 0",
                        parser: function (t, e, i, r, s, n) {
                            var a,
                                o,
                                l,
                                h,
                                f,
                                u,
                                p = "background-position",
                                _ = S || tt(t, null),
                                c = this.format((_ ? (O ? _.getPropertyValue(p + "-x") + " " + _.getPropertyValue(p + "-y") : _.getPropertyValue(p)) : t.currentStyle.backgroundPositionX + " " + t.currentStyle.backgroundPositionY) || "0 0"),
                                d = this.format(e);
                            if ((-1 !== c.indexOf("%")) != (-1 !== d.indexOf("%")) && d.split(",").length < 2 && (u = et(t, "backgroundImage").replace(w, "")) && "none" !== u) {
                                for (a = c.split(" "), o = d.split(" "), G.setAttribute("src", u), l = 2; -1 < --l; )
                                    (h = -1 !== (c = a[l]).indexOf("%")) !== (-1 !== o[l].indexOf("%")) &&
                                        ((f = 0 === l ? t.offsetWidth - G.width : t.offsetHeight - G.height), (a[l] = h ? (parseFloat(c) / 100) * f + "px" : (parseFloat(c) / f) * 100 + "%"));
                                c = a.join(" ");
                            }
                            return this.parseComplex(t.style, c, d, s, n);
                        },
                        formatter: ht,
                    }),
                    St("backgroundSize", {
                        defaultValue: "0 0",
                        formatter: function (t) {
                            return "co" === (t += "").substr(0, 2) ? t : ht(-1 === t.indexOf(" ") ? t + " " + t : t);
                        },
                    }),
                    St("perspective", { defaultValue: "0px", prefix: !0 }),
                    St("perspectiveOrigin", { defaultValue: "50% 50%", prefix: !0 }),
                    St("transformStyle", { prefix: !0 }),
                    St("backfaceVisibility", { prefix: !0 }),
                    St("userSelect", { prefix: !0 }),
                    St("margin", { parser: yt("marginTop,marginRight,marginBottom,marginLeft") }),
                    St("padding", { parser: yt("paddingTop,paddingRight,paddingBottom,paddingLeft") }),
                    St("clip", {
                        defaultValue: "rect(0px,0px,0px,0px)",
                        parser: function (t, e, i, r, s, n) {
                            var a, o, l;
                            return (
                                O < 9
                                    ? ((o = t.currentStyle), (l = O < 8 ? " " : ","), (a = "rect(" + o.clipTop + l + o.clipRight + l + o.clipBottom + l + o.clipLeft + ")"), (e = this.format(e).split(",").join(l)))
                                    : ((a = this.format(et(t, this.p, S, !1, this.dflt))), (e = this.format(e))),
                                this.parseComplex(t.style, a, e, s, n)
                            );
                        },
                    }),
                    St("textShadow", { defaultValue: "0px 0px 0px #999", color: !0, multi: !0 }),
                    St("autoRound,strictUnits", {
                        parser: function (t, e, i, r, s) {
                            return s;
                        },
                    }),
                    St("border", {
                        defaultValue: "0px solid #000",
                        parser: function (t, e, i, r, s, n) {
                            var a = et(t, "borderTopWidth", S, !1, "0px"),
                                o = this.format(e).split(" "),
                                l = o[0].replace(F, "");
                            return (
                                "px" !== l && (a = parseFloat(a) / it(t, "borderTopWidth", 1, l) + l),
                                this.parseComplex(t.style, this.format(a + " " + et(t, "borderTopStyle", S, !1, "solid") + " " + et(t, "borderTopColor", S, !1, "#000")), o.join(" "), s, n)
                            );
                        },
                        color: !0,
                        formatter: function (t) {
                            var e = t.split(" ");
                            return e[0] + " " + (e[1] || "solid") + " " + (t.match(gt) || ["#000"])[0];
                        },
                    }),
                    St("borderWidth", { parser: yt("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth") }),
                    St("float,cssFloat,styleFloat", {
                        parser: function (t, e, i, r, s, n) {
                            var a = t.style,
                                o = "cssFloat" in a ? "cssFloat" : "styleFloat";
                            return new Tt(a, o, 0, 0, s, -1, i, !1, 0, a[o], e);
                        },
                    });
                var $t = function (t) {
                    var e,
                        i = this.t,
                        r = i.filter || et(this.data, "filter") || "",
                        s = (this.s + this.c * t) | 0;
                    100 === s && (-1 === r.indexOf("atrix(") && -1 === r.indexOf("radient(") && -1 === r.indexOf("oader(") ? (i.removeAttribute("filter"), (e = !et(this.data, "filter"))) : ((i.filter = r.replace(a, "")), (e = !0))),
                        e || (this.xn1 && (i.filter = r = r || "alpha(opacity=" + s + ")"), -1 === r.indexOf("pacity") ? (0 === s && this.xn1) || (i.filter = r + " alpha(opacity=" + s + ")") : (i.filter = r.replace(D, "opacity=" + s)));
                };
                St("opacity,alpha,autoAlpha", {
                    defaultValue: "1",
                    parser: function (t, e, i, r, s, n) {
                        var a = parseFloat(et(t, "opacity", S, !1, "1")),
                            o = t.style,
                            l = "autoAlpha" === i;
                        return (
                            "string" == typeof e && "=" === e.charAt(1) && (e = ("-" === e.charAt(0) ? -1 : 1) * parseFloat(e.substr(2)) + a),
                            l && 1 === a && "hidden" === et(t, "visibility", S) && 0 !== e && (a = 0),
                            Z
                                ? (s = new Tt(o, "opacity", a, e - a, s))
                                : (((s = new Tt(o, "opacity", 100 * a, 100 * (e - a), s)).xn1 = l ? 1 : 0),
                                  (o.zoom = 1),
                                  (s.type = 2),
                                  (s.b = "alpha(opacity=" + s.s + ")"),
                                  (s.e = "alpha(opacity=" + (s.s + s.c) + ")"),
                                  (s.data = t),
                                  (s.plugin = n),
                                  (s.setRatio = $t)),
                            l && (((s = new Tt(o, "visibility", 0, 0, s, -1, null, !1, 0, 0 !== a ? "inherit" : "hidden", 0 === e ? "hidden" : "inherit")).xs0 = "inherit"), r._overwriteProps.push(s.n), r._overwriteProps.push(i)),
                            s
                        );
                    },
                });
                var Kt = function (t, e) {
                        e && (t.removeProperty ? (("ms" === e.substr(0, 2) || "webkit" === e.substr(0, 6)) && (e = "-" + e), t.removeProperty(e.replace(o, "-$1").toLowerCase())) : t.removeAttribute(e));
                    },
                    Jt = function (t) {
                        if (((this.t._gsClassPT = this), 1 === t || 0 === t)) {
                            this.t.setAttribute("class", 0 === t ? this.b : this.e);
                            for (var e = this.data, i = this.t.style; e; ) e.v ? (i[e.p] = e.v) : Kt(i, e.p), (e = e._next);
                            1 === t && this.t._gsClassPT === this && (this.t._gsClassPT = null);
                        } else this.t.getAttribute("class") !== this.e && this.t.setAttribute("class", this.e);
                    };
                St("className", {
                    parser: function (t, e, i, r, s, n, a) {
                        var o,
                            l,
                            h,
                            f,
                            u,
                            p = t.getAttribute("class") || "",
                            _ = t.style.cssText;
                        if ((((s = r._classNamePT = new Tt(t, i, 0, 0, s, 2)).setRatio = Jt), (s.pr = -11), (c = !0), (s.b = p), (l = st(t, S)), (h = t._gsClassPT))) {
                            for (f = {}, u = h.data; u; ) (f[u.p] = 1), (u = u._next);
                            h.setRatio(1);
                        }
                        return (
                            ((t._gsClassPT = s).e = "=" !== e.charAt(1) ? e : p.replace(new RegExp("(?:\\s|^)" + e.substr(2) + "(?![\\w-])"), "") + ("+" === e.charAt(0) ? " " + e.substr(2) : "")),
                            t.setAttribute("class", s.e),
                            (o = nt(t, l, st(t), a, f)),
                            t.setAttribute("class", p),
                            (s.data = o.firstMPT),
                            (t.style.cssText = _),
                            (s.xfirst = r.parse(t, o.difs, s, n))
                        );
                    },
                });
                var te = function (t) {
                    if ((1 === t || 0 === t) && this.data._totalTime === this.data._totalDuration && "isFromStart" !== this.data.data) {
                        var e,
                            i,
                            r,
                            s,
                            n,
                            a = this.t.style,
                            o = m.transform.parse;
                        if ("all" === this.e) s = !(a.cssText = "");
                        else for (r = (e = this.e.split(" ").join("").split(",")).length; -1 < --r; ) (i = e[r]), m[i] && (m[i].parse === o ? (s = !0) : (i = "transformOrigin" === i ? Lt : m[i].p)), Kt(a, i);
                        s && (Kt(a, Xt), (n = this.t._gsTransform) && (n.svg && (this.t.removeAttribute("data-svg-origin"), this.t.removeAttribute("transform")), delete this.t._gsTransform));
                    }
                };
                for (
                    St("clearProps", {
                        parser: function (t, e, i, r, s) {
                            return ((s = new Tt(t, i, 0, 0, s, 2)).setRatio = te), (s.e = e), (s.pr = -10), (s.data = r._tween), (c = !0), s;
                        },
                    }),
                        t = "bezier,throwProps,physicsProps,physics2D".split(","),
                        Pt = t.length;
                    Pt--;

                )
                    kt(t[Pt]);
                ((t = E.prototype)._firstPT = t._lastParsedTransform = t._transform = null),
                    (t._onInitTween = function (t, e, i, r) {
                        if (!t.nodeType) return !1;
                        (this._target = A = t), (this._tween = i), (this._vars = e), (C = r), (k = e.autoRound), (c = !1), (P = e.suffixMap || E.suffixMap), (S = tt(t, "")), (d = this._overwriteProps);
                        var s,
                            n,
                            a,
                            o,
                            l,
                            h,
                            f,
                            u,
                            p,
                            _ = t.style;
                        if (
                            (g && "" === _.zIndex && ("auto" === (s = et(t, "zIndex", S)) || "" === s) && this._addLazySet(_, "zIndex", 0),
                            "string" == typeof e && ((o = _.cssText), (s = st(t, S)), (_.cssText = o + ";" + e), (s = nt(t, s, st(t)).difs), !Z && T.test(e) && (s.opacity = parseFloat(RegExp.$1)), (e = s), (_.cssText = o)),
                            e.className ? (this._firstPT = n = m.className.parse(t, e.className, "className", this, null, null, e)) : (this._firstPT = n = this.parse(t, e, null)),
                            this._transformType)
                        ) {
                            for (
                                p = 3 === this._transformType,
                                    Xt
                                        ? v &&
                                          ((g = !0),
                                          "" === _.zIndex && ("auto" === (f = et(t, "zIndex", S)) || "" === f) && this._addLazySet(_, "zIndex", 0),
                                          y && this._addLazySet(_, "WebkitBackfaceVisibility", this._vars.WebkitBackfaceVisibility || (p ? "visible" : "hidden")))
                                        : (_.zoom = 1),
                                    a = n;
                                a && a._next;

                            )
                                a = a._next;
                            (u = new Tt(t, "transform", 0, 0, null, 2)), this._linkCSSP(u, null, a), (u.setRatio = Xt ? Qt : Ht), (u.data = this._transform || Zt(t, S, !0)), (u.tween = i), (u.pr = -1), d.pop();
                        }
                        if (c) {
                            for (; n; ) {
                                for (h = n._next, a = o; a && a.pr > n.pr; ) a = a._next;
                                (n._prev = a ? a._prev : l) ? (n._prev._next = n) : (o = n), (n._next = a) ? (a._prev = n) : (l = n), (n = h);
                            }
                            this._firstPT = o;
                        }
                        return !0;
                    }),
                    (t.parse = function (t, e, i, r) {
                        var s,
                            n,
                            a,
                            o,
                            l,
                            h,
                            f,
                            u,
                            p,
                            _,
                            c = t.style;
                        for (s in e) {
                            if (("function" == typeof (h = e[s]) && (h = h(C, A)), (n = m[s]))) i = n.parse(t, h, s, this, i, r, e);
                            else {
                                if ("--" === s.substr(0, 2)) {
                                    this._tween._propLookup[s] = this._addTween.call(this._tween, t.style, "setProperty", tt(t).getPropertyValue(s) + "", h + "", s, !1, s);
                                    continue;
                                }
                                (l = et(t, s, S) + ""),
                                    (p = "string" == typeof h),
                                    "color" === s || "fill" === s || "stroke" === s || -1 !== s.indexOf("Color") || (p && b.test(h))
                                        ? (p || (h = (3 < (h = dt(h)).length ? "rgba(" : "rgb(") + h.join(",") + ")"), (i = wt(c, s, l, h, !0, "transparent", i, 0, r)))
                                        : p && L.test(h)
                                        ? (i = wt(c, s, l, h, !0, null, i, 0, r))
                                        : ((f = (a = parseFloat(l)) || 0 === a ? l.substr((a + "").length) : ""),
                                          ("" === l || "auto" === l) &&
                                              ("width" === s || "height" === s ? ((a = lt(t, s, S)), (f = "px")) : "left" === s || "top" === s ? ((a = rt(t, s, S)), (f = "px")) : ((a = "opacity" !== s ? 0 : 1), (f = ""))),
                                          (_ = p && "=" === h.charAt(1)) ? ((o = parseInt(h.charAt(0) + "1", 10)), (h = h.substr(2)), (o *= parseFloat(h)), (u = h.replace(F, ""))) : ((o = parseFloat(h)), (u = p ? h.replace(F, "") : "")),
                                          "" === u && (u = s in P ? P[s] : f),
                                          (h = o || 0 === o ? (_ ? o + a : o) + u : e[s]),
                                          f !== u &&
                                              ("" !== u || "lineHeight" === s) &&
                                              (o || 0 === o) &&
                                              a &&
                                              ((a = it(t, s, a, f)),
                                              "%" === u
                                                  ? ((a /= it(t, s, 100, "%") / 100), !0 !== e.strictUnits && (l = a + "%"))
                                                  : "em" === u || "rem" === u || "vw" === u || "vh" === u
                                                  ? (a /= it(t, s, 1, u))
                                                  : "px" !== u && ((o = it(t, s, o, u)), (u = "px")),
                                              _ && (o || 0 === o) && (h = o + a + u)),
                                          _ && (o += a),
                                          (!a && 0 !== a) || (!o && 0 !== o)
                                              ? void 0 !== c[s] && (h || (h + "" != "NaN" && null != h))
                                                  ? ((i = new Tt(c, s, o || a || 0, 0, i, -1, s, !1, 0, l, h)).xs0 = "none" !== h || ("display" !== s && -1 === s.indexOf("Style")) ? h : l)
                                                  : Q("invalid " + s + " tween value: " + e[s])
                                              : ((i = new Tt(c, s, a, o - a, i, 0, s, !1 !== k && ("px" === u || "zIndex" === s), 0, l, h)).xs0 = u));
                            }
                            r && i && !i.plugin && (i.plugin = r);
                        }
                        return i;
                    }),
                    (t.setRatio = function (t) {
                        var e,
                            i,
                            r,
                            s = this._firstPT;
                        if (1 !== t || (this._tween._time !== this._tween._duration && 0 !== this._tween._time))
                            if (t || (this._tween._time !== this._tween._duration && 0 !== this._tween._time) || -1e-6 === this._tween._rawPrevTime)
                                for (; s; ) {
                                    if (((e = s.c * t + s.s), s.r ? (e = s.r(e)) : e < 1e-6 && -1e-6 < e && (e = 0), s.type))
                                        if (1 === s.type)
                                            if (2 === (r = s.l)) s.t[s.p] = s.xs0 + e + s.xs1 + s.xn1 + s.xs2;
                                            else if (3 === r) s.t[s.p] = s.xs0 + e + s.xs1 + s.xn1 + s.xs2 + s.xn2 + s.xs3;
                                            else if (4 === r) s.t[s.p] = s.xs0 + e + s.xs1 + s.xn1 + s.xs2 + s.xn2 + s.xs3 + s.xn3 + s.xs4;
                                            else if (5 === r) s.t[s.p] = s.xs0 + e + s.xs1 + s.xn1 + s.xs2 + s.xn2 + s.xs3 + s.xn3 + s.xs4 + s.xn4 + s.xs5;
                                            else {
                                                for (i = s.xs0 + e + s.xs1, r = 1; r < s.l; r++) i += s["xn" + r] + s["xs" + (r + 1)];
                                                s.t[s.p] = i;
                                            }
                                        else -1 === s.type ? (s.t[s.p] = s.xs0) : s.setRatio && s.setRatio(t);
                                    else s.t[s.p] = e + s.xs0;
                                    s = s._next;
                                }
                            else for (; s; ) 2 !== s.type ? (s.t[s.p] = s.b) : s.setRatio(t), (s = s._next);
                        else
                            for (; s; ) {
                                if (2 !== s.type)
                                    if (s.r && -1 !== s.type)
                                        if (((e = s.r(s.s + s.c)), s.type)) {
                                            if (1 === s.type) {
                                                for (r = s.l, i = s.xs0 + e + s.xs1, r = 1; r < s.l; r++) i += s["xn" + r] + s["xs" + (r + 1)];
                                                s.t[s.p] = i;
                                            }
                                        } else s.t[s.p] = e + s.xs0;
                                    else s.t[s.p] = s.e;
                                else s.setRatio(t);
                                s = s._next;
                            }
                    }),
                    (t._enableTransforms = function (t) {
                        (this._transform = this._transform || Zt(this._target, S, !0)), (this._transformType = (this._transform.svg && At) || (!t && 3 !== this._transformType) ? 2 : 3);
                    });
                var ee = function (t) {
                    (this.t[this.p] = this.e), this.data._linkCSSP(this, this._next, null, !0);
                };
                (t._addLazySet = function (t, e, i) {
                    var r = (this._firstPT = new Tt(t, e, 0, 0, this._firstPT, 2));
                    (r.e = i), (r.setRatio = ee), (r.data = this);
                }),
                    (t._linkCSSP = function (t, e, i, r) {
                        return (
                            t &&
                                (e && (e._prev = t),
                                t._next && (t._next._prev = t._prev),
                                t._prev ? (t._prev._next = t._next) : this._firstPT === t && ((this._firstPT = t._next), (r = !0)),
                                i ? (i._next = t) : r || null !== this._firstPT || (this._firstPT = t),
                                (t._next = e),
                                (t._prev = i)),
                            t
                        );
                    }),
                    (t._mod = function (t) {
                        for (var e = this._firstPT; e; ) "function" == typeof t[e.p] && (e.r = t[e.p]), (e = e._next);
                    }),
                    (t._kill = function (t) {
                        var e,
                            i,
                            r,
                            s = t;
                        if (t.autoAlpha || t.alpha) {
                            for (i in ((s = {}), t)) s[i] = t[i];
                            (s.opacity = 1), s.autoAlpha && (s.visibility = 1);
                        }
                        for (
                            t.className &&
                                (e = this._classNamePT) &&
                                ((r = e.xfirst) && r._prev ? this._linkCSSP(r._prev, e._next, r._prev._prev) : r === this._firstPT && (this._firstPT = e._next),
                                e._next && this._linkCSSP(e._next, e._next._next, r._prev),
                                (this._classNamePT = null)),
                                e = this._firstPT;
                            e;

                        )
                            e.plugin && e.plugin !== i && e.plugin._kill && (e.plugin._kill(t), (i = e.plugin)), (e = e._next);
                        return n.prototype._kill.call(this, s);
                    });
                var ie = function (t, e, i) {
                    var r, s, n, a;
                    if (t.slice) for (s = t.length; -1 < --s; ) ie(t[s], e, i);
                    else for (s = (r = t.childNodes).length; -1 < --s; ) (a = (n = r[s]).type), n.style && (e.push(st(n)), i && i.push(n)), (1 !== a && 9 !== a && 11 !== a) || !n.childNodes.length || ie(n, e, i);
                };
                return (
                    (E.cascadeTo = function (t, e, i) {
                        var r,
                            s,
                            n,
                            a,
                            o = j.to(t, e, i),
                            l = [o],
                            h = [],
                            f = [],
                            u = [],
                            p = j._internals.reservedProps;
                        for (t = o._targets || o.target, ie(t, h, u), o.render(e, !0, !0), ie(t, f), o.render(0, !0, !0), o._enabled(!0), r = u.length; -1 < --r; )
                            if ((s = nt(u[r], h[r], f[r])).firstMPT) {
                                for (n in ((s = s.difs), i)) p[n] && (s[n] = i[n]);
                                for (n in ((a = {}), s)) a[n] = h[r][n];
                                l.push(j.fromTo(u[r], e, a, s));
                            }
                        return l;
                    }),
                    n.activate([E]),
                    E
                );
            },
            !0
        );
    }),
    _gsScope._gsDefine && _gsScope._gsQueue.pop()(),
    (function (t) {
        "use strict";
        var e = function () {
            return (_gsScope.GreenSockGlobals || _gsScope).CSSPlugin;
        };
        "undefined" != typeof module && module.exports ? (require("../TweenLite.min.js"), (module.exports = e())) : "function" == typeof define && define.amd && define(["TweenLite"], e);
    })();
var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
!(function (e) {
    "use strict";
    var t = e.GreenSockGlobals || e,
        i = function (e) {
            var i,
                n = e.split("."),
                s = t;
            for (i = 0; i < n.length; i++) s[n[i]] = s = s[n[i]] || {};
            return s;
        },
        n = i("com.greensock.utils"),
        s = function (e) {
            var t = e.nodeType,
                i = "";
            if (1 === t || 9 === t || 11 === t) {
                if ("string" == typeof e.textContent) return e.textContent;
                for (e = e.firstChild; e; e = e.nextSibling) i += s(e);
            } else if (3 === t || 4 === t) return e.nodeValue;
            return i;
        },
        r = document,
        l = r.defaultView ? r.defaultView.getComputedStyle : function () {},
        o = /([A-Z])/g,
        d = function (e, t, i, n) {
            var s;
            return (i = i || l(e, null)) ? ((e = i.getPropertyValue(t.replace(o, "-$1").toLowerCase())), (s = e || i.length ? e : i[t])) : e.currentStyle && ((i = e.currentStyle), (s = i[t])), n ? s : parseInt(s, 10) || 0;
        },
        p = function (e) {
            return e.length && e[0] && ((e[0].nodeType && e[0].style && !e.nodeType) || (e[0].length && e[0][0])) ? !0 : !1;
        },
        a = function (e) {
            var t,
                i,
                n,
                s = [],
                r = e.length;
            for (t = 0; r > t; t++)
                if (((i = e[t]), p(i))) for (n = i.length, n = 0; n < i.length; n++) s.push(i[n]);
                else s.push(i);
            return s;
        },
        h = /(?:\r|\n|\t\t)/g,
        u = /(?:\s\s+)/g,
        f = 55296,
        c = 56319,
        g = 56320,
        y = 127462,
        x = 127487,
        S = 127995,
        v = 127999,
        b = function (e) {
            return ((e.charCodeAt(0) - f) << 10) + (e.charCodeAt(1) - g) + 65536;
        },
        _ = r.all && !r.addEventListener,
        m = " style='position:relative;display:inline-block;" + (_ ? "*display:inline;*zoom:1;'" : "'"),
        C = function (e, t) {
            e = e || "";
            var i = -1 !== e.indexOf("++"),
                n = 1;
            return (
                i && (e = e.split("++").join("")),
                function () {
                    return "<" + t + m + (e ? " class='" + e + (i ? n++ : "") + "'>" : ">");
                }
            );
        },
        T = (n.SplitText = t.SplitText = function (e, t) {
            if (("string" == typeof e && (e = T.selector(e)), !e)) throw "cannot split a null element.";
            (this.elements = p(e) ? a(e) : [e]), (this.chars = []), (this.words = []), (this.lines = []), (this._originals = []), (this.vars = t || {}), this.split(t);
        }),
        N = function (e, t, i) {
            var n = e.nodeType;
            if (1 === n || 9 === n || 11 === n) for (e = e.firstChild; e; e = e.nextSibling) N(e, t, i);
            else (3 === n || 4 === n) && (e.nodeValue = e.nodeValue.split(t).join(i));
        },
        w = function (e, t) {
            var i = t.length;
            for (; --i > -1; ) e.push(t[i]);
        },
        A = function (e) {
            var t,
                i = [],
                n = e.length;
            for (t = 0; t !== n; i.push(e[t++]));
            return i;
        },
        L = function (e, t, i) {
            var n;
            for (; e && e !== t; ) {
                if ((n = e._next || e.nextSibling)) return n.textContent.charAt(0) === i;
                e = e.parentNode || e._parent;
            }
            return !1;
        },
        B = function (e) {
            var t,
                i,
                n = A(e.childNodes),
                s = n.length;
            for (t = 0; s > t; t++)
                (i = n[t]),
                    i._isSplit
                        ? B(i)
                        : (t && 3 === i.previousSibling.nodeType ? (i.previousSibling.nodeValue += 3 === i.nodeType ? i.nodeValue : i.firstChild.nodeValue) : 3 !== i.nodeType && e.insertBefore(i.firstChild, i), e.removeChild(i));
        },
        V = function (e, t, i, n, s, o, p) {
            var a,
                h,
                u,
                f,
                c,
                g,
                y,
                x,
                S,
                v,
                b,
                _,
                m = l(e),
                C = d(e, "paddingLeft", m),
                T = -999,
                A = d(e, "borderBottomWidth", m) + d(e, "borderTopWidth", m),
                V = d(e, "borderLeftWidth", m) + d(e, "borderRightWidth", m),
                W = d(e, "paddingTop", m) + d(e, "paddingBottom", m),
                H = d(e, "paddingLeft", m) + d(e, "paddingRight", m),
                E = 0.2 * d(e, "fontSize"),
                k = d(e, "textAlign", m, !0),
                O = [],
                R = [],
                j = [],
                M = t.wordDelimiter || " ",
                G = t.span ? "span" : "div",
                $ = t.type || t.split || "chars,words,lines",
                q = s && -1 !== $.indexOf("lines") ? [] : null,
                z = -1 !== $.indexOf("words"),
                D = -1 !== $.indexOf("chars"),
                F = "absolute" === t.position || t.absolute === !0,
                I = t.linesClass,
                P = -1 !== (I || "").indexOf("++"),
                Q = [];
            for (q && 1 === e.children.length && e.children[0]._isSplit && (e = e.children[0]), P && (I = I.split("++").join("")), h = e.getElementsByTagName("*"), u = h.length, c = [], a = 0; u > a; a++) c[a] = h[a];
            if (q || F)
                for (a = 0; u > a; a++)
                    (f = c[a]),
                        (g = f.parentNode === e),
                        (g || F || (D && !z)) &&
                            ((_ = f.offsetTop),
                            q && g && Math.abs(_ - T) > E && ("BR" !== f.nodeName || 0 === a) && ((y = []), q.push(y), (T = _)),
                            F && ((f._x = f.offsetLeft), (f._y = _), (f._w = f.offsetWidth), (f._h = f.offsetHeight)),
                            q &&
                                (((f._isSplit && g) || (!D && g) || (z && g) || (!z && f.parentNode.parentNode === e && !f.parentNode._isSplit)) && (y.push(f), (f._x -= C), L(f, e, M) && (f._wordEnd = !0)),
                                "BR" === f.nodeName && ((f.nextSibling && "BR" === f.nextSibling.nodeName) || 0 === a) && q.push([])));
            for (a = 0; u > a; a++)
                (f = c[a]),
                    (g = f.parentNode === e),
                    "BR" !== f.nodeName
                        ? (F &&
                              ((S = f.style),
                              z || g || ((f._x += f.parentNode._x), (f._y += f.parentNode._y)),
                              (S.left = f._x + "px"),
                              (S.top = f._y + "px"),
                              (S.position = "absolute"),
                              (S.display = "block"),
                              (S.width = f._w + 1 + "px"),
                              (S.height = f._h + "px")),
                          !z && D
                              ? f._isSplit
                                  ? ((f._next = f.nextSibling), f.parentNode.appendChild(f))
                                  : f.parentNode._isSplit
                                  ? ((f._parent = f.parentNode),
                                    !f.previousSibling && f.firstChild && (f.firstChild._isFirst = !0),
                                    f.nextSibling && " " === f.nextSibling.textContent && !f.nextSibling.nextSibling && Q.push(f.nextSibling),
                                    (f._next = f.nextSibling && f.nextSibling._isFirst ? null : f.nextSibling),
                                    f.parentNode.removeChild(f),
                                    c.splice(a--, 1),
                                    u--)
                                  : g ||
                                    ((_ = !f.nextSibling && L(f.parentNode, e, M)),
                                    f.parentNode._parent && f.parentNode._parent.appendChild(f),
                                    _ && f.parentNode.appendChild(r.createTextNode(" ")),
                                    t.span && (f.style.display = "inline"),
                                    O.push(f))
                              : f.parentNode._isSplit && !f._isSplit && "" !== f.innerHTML
                              ? R.push(f)
                              : D && !f._isSplit && (t.span && (f.style.display = "inline"), O.push(f)))
                        : q || F
                        ? (f.parentNode && f.parentNode.removeChild(f), c.splice(a--, 1), u--)
                        : z || e.appendChild(f);
            for (a = Q.length; --a > -1; ) Q[a].parentNode.removeChild(Q[a]);
            if (q) {
                for (F && ((v = r.createElement(G)), e.appendChild(v), (b = v.offsetWidth + "px"), (_ = v.offsetParent === e ? 0 : e.offsetLeft), e.removeChild(v)), S = e.style.cssText, e.style.cssText = "display:none;"; e.firstChild; )
                    e.removeChild(e.firstChild);
                for (x = " " === M && (!F || (!z && !D)), a = 0; a < q.length; a++) {
                    for (
                        y = q[a], v = r.createElement(G), v.style.cssText = "display:block;text-align:" + k + ";position:" + (F ? "absolute;" : "relative;"), I && (v.className = I + (P ? a + 1 : "")), j.push(v), u = y.length, h = 0;
                        u > h;
                        h++
                    )
                        "BR" !== y[h].nodeName &&
                            ((f = y[h]),
                            v.appendChild(f),
                            x && f._wordEnd && v.appendChild(r.createTextNode(" ")),
                            F && (0 === h && ((v.style.top = f._y + "px"), (v.style.left = C + _ + "px")), (f.style.top = "0px"), _ && (f.style.left = f._x - _ + "px")));
                    0 === u ? (v.innerHTML = "&nbsp;") : z || D || (B(v), N(v, String.fromCharCode(160), " ")), F && ((v.style.width = b), (v.style.height = f._h + "px")), e.appendChild(v);
                }
                e.style.cssText = S;
            }
            F && (p > e.clientHeight && ((e.style.height = p - W + "px"), e.clientHeight < p && (e.style.height = p + A + "px")), o > e.clientWidth && ((e.style.width = o - H + "px"), e.clientWidth < o && (e.style.width = o + V + "px"))),
                w(i, O),
                w(n, R),
                w(s, j);
        },
        W = function (e, t, i, n) {
            var l,
                o,
                d,
                p,
                a,
                g,
                _,
                m,
                C,
                T = t.span ? "span" : "div",
                w = t.type || t.split || "chars,words,lines",
                A = -1 !== w.indexOf("chars"),
                L = "absolute" === t.position || t.absolute === !0,
                B = t.wordDelimiter || " ",
                V = " " !== B ? "" : L ? "&#173; " : " ",
                W = t.span ? "</span>" : "</div>",
                H = !0,
                E = r.createElement("div"),
                k = e.parentNode;
            for (
                k.insertBefore(E, e),
                    E.textContent = e.nodeValue,
                    k.removeChild(e),
                    e = E,
                    l = s(e),
                    _ = -1 !== l.indexOf("<"),
                    t.reduceWhiteSpace !== !1 && (l = l.replace(u, " ").replace(h, "")),
                    _ && (l = l.split("<").join("{{LT}}")),
                    a = l.length,
                    o = (" " === l.charAt(0) ? V : "") + i(),
                    d = 0;
                a > d;
                d++
            )
                if (((g = l.charAt(d)), g === B && l.charAt(d - 1) !== B && d)) {
                    for (o += H ? W : "", H = !1; l.charAt(d + 1) === B; ) (o += V), d++;
                    d === a - 1 ? (o += V) : ")" !== l.charAt(d + 1) && ((o += V + i()), (H = !0));
                } else
                    "{" === g && "{{LT}}" === l.substr(d, 6)
                        ? ((o += A ? n() + "{{LT}}</" + T + ">" : "{{LT}}"), (d += 5))
                        : (g.charCodeAt(0) >= f && g.charCodeAt(0) <= c) || (l.charCodeAt(d + 1) >= 65024 && l.charCodeAt(d + 1) <= 65039)
                        ? ((m = b(l.substr(d, 2))),
                          (C = b(l.substr(d + 2, 2))),
                          (p = (y > m || m > x || y > C || C > x) && (S > C || C > v) ? 2 : 4),
                          (o += A && " " !== g ? n() + l.substr(d, p) + "</" + T + ">" : l.substr(d, p)),
                          (d += p - 1))
                        : (o += A && " " !== g ? n() + g + "</" + T + ">" : g);
            (e.outerHTML = o + (H ? W : "")), _ && N(k, "{{LT}}", "<");
        },
        H = function (e, t, i, n) {
            var s,
                r,
                l = A(e.childNodes),
                o = l.length,
                p = "absolute" === t.position || t.absolute === !0;
            if (3 !== e.nodeType || o > 1) {
                for (t.absolute = !1, s = 0; o > s; s++)
                    (r = l[s]),
                        (3 !== r.nodeType || /\S+/.test(r.nodeValue)) &&
                            (p && 3 !== r.nodeType && "inline" === d(r, "display", null, !0) && ((r.style.display = "inline-block"), (r.style.position = "relative")), (r._isSplit = !0), H(r, t, i, n));
                return (t.absolute = p), void (e._isSplit = !0);
            }
            W(e, t, i, n);
        },
        E = T.prototype;
    (E.split = function (e) {
        this.isSplit && this.revert(), (this.vars = e = e || this.vars), (this._originals.length = this.chars.length = this.words.length = this.lines.length = 0);
        var t,
            i,
            n,
            s = this.elements.length,
            r = e.span ? "span" : "div",
            l = C(e.wordsClass, r),
            o = C(e.charsClass, r);
        for (; --s > -1; ) (n = this.elements[s]), (this._originals[s] = n.innerHTML), (t = n.clientHeight), (i = n.clientWidth), H(n, e, l, o), V(n, e, this.chars, this.words, this.lines, i, t);
        return this.chars.reverse(), this.words.reverse(), this.lines.reverse(), (this.isSplit = !0), this;
    }),
        (E.revert = function () {
            if (!this._originals) throw "revert() call wasn't scoped properly.";
            var e = this._originals.length;
            for (; --e > -1; ) this.elements[e].innerHTML = this._originals[e];
            return (this.chars = []), (this.words = []), (this.lines = []), (this.isSplit = !1), this;
        }),
        (T.selector =
            e.$ ||
            e.jQuery ||
            function (t) {
                var i = e.$ || e.jQuery;
                return i ? ((T.selector = i), i(t)) : "undefined" == typeof document ? t : document.querySelectorAll ? document.querySelectorAll(t) : document.getElementById("#" === t.charAt(0) ? t.substr(1) : t);
            }),
        (T.version = "0.5.8");
})(_gsScope),
    (function (e) {
        "use strict";
        var t = function () {
            return (_gsScope.GreenSockGlobals || _gsScope)[e];
        };
        "undefined" != typeof module && module.exports ? (module.exports = t()) : "function" == typeof define && define.amd && define([], t);
    })("SplitText");
/*! skrollr 0.6.30 */
!(function (a, b, c) {
    "use strict";
    function d(c) {
        if (((e = b.documentElement), (f = b.body), T(), (ha = this), (c = c || {}), (ma = c.constants || {}), c.easing)) for (var d in c.easing) W[d] = c.easing[d];
        (ta = c.edgeStrategy || "set"),
            (ka = { beforerender: c.beforerender, render: c.render, keyframe: c.keyframe }),
            (la = c.forceHeight !== !1),
            la && (Ka = c.scale || 1),
            (na = c.mobileDeceleration || y),
            (pa = c.smoothScrolling !== !1),
            (qa = c.smoothScrollingDuration || A),
            (ra = { targetTop: ha.getScrollTop() }),
            (Sa = (
                c.mobileCheck ||
                function () {
                    return /Android|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent || navigator.vendor || a.opera);
                }
            )()),
            Sa ? ((ja = b.getElementById(c.skrollrBody || z)), ja && ga(), X(), Ea(e, [s, v], [t])) : Ea(e, [s, u], [t]),
            ha.refresh(),
            wa(a, "resize orientationchange", function () {
                var a = e.clientWidth,
                    b = e.clientHeight;
                (b !== Pa || a !== Oa) && ((Pa = b), (Oa = a), (Qa = !0));
            });
        var g = U();
        return (
            (function h() {
                $(), (va = g(h));
            })(),
            ha
        );
    }
    var e,
        f,
        g = {
            get: function () {
                return ha;
            },
            init: function (a) {
                return ha || new d(a);
            },
            VERSION: "0.6.29",
        },
        h = Object.prototype.hasOwnProperty,
        i = a.Math,
        j = a.getComputedStyle,
        k = "touchstart",
        l = "touchmove",
        m = "touchcancel",
        n = "touchend",
        o = "skrollable",
        p = o + "-before",
        q = o + "-between",
        r = o + "-after",
        s = "skrollr",
        t = "no-" + s,
        u = s + "-desktop",
        v = s + "-mobile",
        w = "linear",
        x = 1e3,
        y = 0.004,
        z = "skrollr-body",
        A = 200,
        B = "start",
        C = "end",
        D = "center",
        E = "bottom",
        F = "___skrollable_id",
        G = /^(?:input|textarea|button|select)$/i,
        H = /^\s+|\s+$/g,
        I = /^data(?:-(_\w+))?(?:-?(-?\d*\.?\d+p?))?(?:-?(start|end|top|center|bottom))?(?:-?(top|center|bottom))?$/,
        J = /\s*(@?[\w\-\[\]]+)\s*:\s*(.+?)\s*(?:;|$)/gi,
        K = /^(@?[a-z\-]+)\[(\w+)\]$/,
        L = /-([a-z0-9_])/g,
        M = function (a, b) {
            return b.toUpperCase();
        },
        N = /[\-+]?[\d]*\.?[\d]+/g,
        O = /\{\?\}/g,
        P = /rgba?\(\s*-?\d+\s*,\s*-?\d+\s*,\s*-?\d+/g,
        Q = /[a-z\-]+-gradient/g,
        R = "",
        S = "",
        T = function () {
            var a = /^(?:O|Moz|webkit|ms)|(?:-(?:o|moz|webkit|ms)-)/;
            if (j) {
                var b = j(f, null);
                for (var c in b) if ((R = c.match(a) || (+c == c && b[c].match(a)))) break;
                if (!R) return void (R = S = "");
                (R = R[0]), "-" === R.slice(0, 1) ? ((S = R), (R = { "-webkit-": "webkit", "-moz-": "Moz", "-ms-": "ms", "-o-": "O" }[R])) : (S = "-" + R.toLowerCase() + "-");
            }
        },
        U = function () {
            var b = a.requestAnimationFrame || a[R.toLowerCase() + "RequestAnimationFrame"],
                c = Ha();
            return (
                (Sa || !b) &&
                    (b = function (b) {
                        var d = Ha() - c,
                            e = i.max(0, 1e3 / 60 - d);
                        return a.setTimeout(function () {
                            (c = Ha()), b();
                        }, e);
                    }),
                b
            );
        },
        V = function () {
            var b = a.cancelAnimationFrame || a[R.toLowerCase() + "CancelAnimationFrame"];
            return (
                (Sa || !b) &&
                    (b = function (b) {
                        return a.clearTimeout(b);
                    }),
                b
            );
        },
        W = {
            begin: function () {
                return 0;
            },
            end: function () {
                return 1;
            },
            linear: function (a) {
                return a;
            },
            quadratic: function (a) {
                return a * a;
            },
            cubic: function (a) {
                return a * a * a;
            },
            swing: function (a) {
                return -i.cos(a * i.PI) / 2 + 0.5;
            },
            sqrt: function (a) {
                return i.sqrt(a);
            },
            outCubic: function (a) {
                return i.pow(a - 1, 3) + 1;
            },
            bounce: function (a) {
                var b;
                if (0.5083 >= a) b = 3;
                else if (0.8489 >= a) b = 9;
                else if (0.96208 >= a) b = 27;
                else {
                    if (!(0.99981 >= a)) return 1;
                    b = 91;
                }
                return 1 - i.abs((3 * i.cos(a * b * 1.028)) / b);
            },
        };
    (d.prototype.refresh = function (a) {
        var d,
            e,
            f = !1;
        for (a === c ? ((f = !0), (ia = []), (Ra = 0), (a = b.getElementsByTagName("*"))) : a.length === c && (a = [a]), d = 0, e = a.length; e > d; d++) {
            var g = a[d],
                h = g,
                i = [],
                j = pa,
                k = ta,
                l = !1;
            if ((f && F in g && delete g[F], g.attributes)) {
                for (var m = 0, n = g.attributes.length; n > m; m++) {
                    var p = g.attributes[m];
                    if ("data-anchor-target" !== p.name)
                        if ("data-smooth-scrolling" !== p.name)
                            if ("data-edge-strategy" !== p.name)
                                if ("data-emit-events" !== p.name) {
                                    var q = p.name.match(I);
                                    if (null !== q) {
                                        var r = { props: p.value, element: g, eventType: p.name.replace(L, M) };
                                        i.push(r);
                                        var s = q[1];
                                        s && (r.constant = s.substr(1));
                                        var t = q[2];
                                        /p$/.test(t) ? ((r.isPercentage = !0), (r.offset = (0 | t.slice(0, -1)) / 100)) : (r.offset = 0 | t);
                                        var u = q[3],
                                            v = q[4] || u;
                                        u && u !== B && u !== C ? ((r.mode = "relative"), (r.anchors = [u, v])) : ((r.mode = "absolute"), u === C ? (r.isEnd = !0) : r.isPercentage || (r.offset = r.offset * Ka));
                                    }
                                } else l = !0;
                            else k = p.value;
                        else j = "off" !== p.value;
                    else if (((h = b.querySelector(p.value)), null === h)) throw 'Unable to find anchor target "' + p.value + '"';
                }
                if (i.length) {
                    var w, x, y;
                    !f && F in g ? ((y = g[F]), (w = ia[y].styleAttr), (x = ia[y].classAttr)) : ((y = g[F] = Ra++), (w = g.style.cssText), (x = Da(g))),
                        (ia[y] = { element: g, styleAttr: w, classAttr: x, anchorTarget: h, keyFrames: i, smoothScrolling: j, edgeStrategy: k, emitEvents: l, lastFrameIndex: -1 }),
                        Ea(g, [o], []);
                }
            }
        }
        for (Aa(), d = 0, e = a.length; e > d; d++) {
            var z = ia[a[d][F]];
            z !== c && (_(z), ba(z));
        }
        return ha;
    }),
        (d.prototype.relativeToAbsolute = function (a, b, c) {
            var d = e.clientHeight,
                f = a.getBoundingClientRect(),
                g = f.top,
                h = f.bottom - f.top;
            return b === E ? (g -= d) : b === D && (g -= d / 2), c === E ? (g += h) : c === D && (g += h / 2), (g += ha.getScrollTop()), (g + 0.5) | 0;
        }),
        (d.prototype.animateTo = function (a, b) {
            b = b || {};
            var d = Ha(),
                e = ha.getScrollTop(),
                f = b.duration === c ? x : b.duration;
            return (oa = { startTop: e, topDiff: a - e, targetTop: a, duration: f, startTime: d, endTime: d + f, easing: W[b.easing || w], done: b.done }), oa.topDiff || (oa.done && oa.done.call(ha, !1), (oa = c)), ha;
        }),
        (d.prototype.stopAnimateTo = function () {
            oa && oa.done && oa.done.call(ha, !0), (oa = c);
        }),
        (d.prototype.isAnimatingTo = function () {
            return !!oa;
        }),
        (d.prototype.isMobile = function () {
            return Sa;
        }),
        (d.prototype.setScrollTop = function (b, c) {
            return (sa = c === !0), Sa ? (Ta = i.min(i.max(b, 0), Ja)) : a.scrollTo(0, b), ha;
        }),
        (d.prototype.getScrollTop = function () {
            return Sa ? Ta : a.pageYOffset || e.scrollTop || f.scrollTop || 0;
        }),
        (d.prototype.getMaxScrollTop = function () {
            return Ja;
        }),
        (d.prototype.on = function (a, b) {
            return (ka[a] = b), ha;
        }),
        (d.prototype.off = function (a) {
            return delete ka[a], ha;
        }),
        (d.prototype.destroy = function () {
            var a = V();
            a(va), ya(), Ea(e, [t], [s, u, v]);
            for (var b = 0, d = ia.length; d > b; b++) fa(ia[b].element);
            (e.style.overflow = f.style.overflow = ""),
                (e.style.height = f.style.height = ""),
                ja && g.setStyle(ja, "transform", "none"),
                (ha = c),
                (ja = c),
                (ka = c),
                (la = c),
                (Ja = 0),
                (Ka = 1),
                (ma = c),
                (na = c),
                (La = "down"),
                (Ma = -1),
                (Oa = 0),
                (Pa = 0),
                (Qa = !1),
                (oa = c),
                (pa = c),
                (qa = c),
                (ra = c),
                (sa = c),
                (Ra = 0),
                (ta = c),
                (Sa = !1),
                (Ta = 0),
                (ua = c);
        });
    var X = function () {
            var d, g, h, j, o, p, q, r, s, t, u, v;
            wa(e, [k, l, m, n].join(" "), function (a) {
                var e = a.changedTouches[0];
                for (j = a.target; 3 === j.nodeType; ) j = j.parentNode;
                switch (((o = e.clientY), (p = e.clientX), (t = a.timeStamp), G.test(j.tagName) || a.preventDefault(), a.type)) {
                    case k:
                        d && d.blur(), ha.stopAnimateTo(), (d = j), (g = q = o), (h = p), (s = t);
                        break;
                    case l:
                        G.test(j.tagName) && b.activeElement !== j && a.preventDefault(), (r = o - q), (v = t - u), ha.setScrollTop(Ta - r, !0), (q = o), (u = t);
                        break;
                    default:
                    case m:
                    case n:
                        var f = g - o,
                            w = h - p,
                            x = w * w + f * f;
                        if (49 > x) {
                            if (!G.test(d.tagName)) {
                                d.focus();
                                var y = b.createEvent("MouseEvents");
                                y.initMouseEvent("click", !0, !0, a.view, 1, e.screenX, e.screenY, e.clientX, e.clientY, a.ctrlKey, a.altKey, a.shiftKey, a.metaKey, 0, null), d.dispatchEvent(y);
                            }
                            return;
                        }
                        d = c;
                        var z = r / v;
                        z = i.max(i.min(z, 3), -3);
                        var A = i.abs(z / na),
                            B = z * A + 0.5 * na * A * A,
                            C = ha.getScrollTop() - B,
                            D = 0;
                        C > Ja ? ((D = (Ja - C) / B), (C = Ja)) : 0 > C && ((D = -C / B), (C = 0)), (A *= 1 - D), ha.animateTo((C + 0.5) | 0, { easing: "outCubic", duration: A });
                }
            }),
                a.scrollTo(0, 0),
                (e.style.overflow = f.style.overflow = "hidden");
        },
        Y = function () {
            var a,
                b,
                c,
                d,
                f,
                g,
                h,
                j,
                k,
                l,
                m,
                n = e.clientHeight,
                o = Ba();
            for (j = 0, k = ia.length; k > j; j++)
                for (a = ia[j], b = a.element, c = a.anchorTarget, d = a.keyFrames, f = 0, g = d.length; g > f; f++)
                    (h = d[f]),
                        (l = h.offset),
                        (m = o[h.constant] || 0),
                        (h.frame = l),
                        h.isPercentage && ((l *= n), (h.frame = l)),
                        "relative" === h.mode && (fa(b), (h.frame = ha.relativeToAbsolute(c, h.anchors[0], h.anchors[1]) - l), fa(b, !0)),
                        (h.frame += m),
                        la && !h.isEnd && h.frame > Ja && (Ja = h.frame);
            for (Ja = i.max(Ja, Ca()), j = 0, k = ia.length; k > j; j++) {
                for (a = ia[j], d = a.keyFrames, f = 0, g = d.length; g > f; f++) (h = d[f]), (m = o[h.constant] || 0), h.isEnd && (h.frame = Ja - h.offset + m);
                a.keyFrames.sort(Ia);
            }
        },
        Z = function (a, b) {
            for (var c = 0, d = ia.length; d > c; c++) {
                var e,
                    f,
                    i = ia[c],
                    j = i.element,
                    k = i.smoothScrolling ? a : b,
                    l = i.keyFrames,
                    m = l.length,
                    n = l[0],
                    s = l[l.length - 1],
                    t = k < n.frame,
                    u = k > s.frame,
                    v = t ? n : s,
                    w = i.emitEvents,
                    x = i.lastFrameIndex;
                if (t || u) {
                    if ((t && -1 === i.edge) || (u && 1 === i.edge)) continue;
                    switch (
                        (t ? (Ea(j, [p], [r, q]), w && x > -1 && (za(j, n.eventType, La), (i.lastFrameIndex = -1))) : (Ea(j, [r], [p, q]), w && m > x && (za(j, s.eventType, La), (i.lastFrameIndex = m))),
                        (i.edge = t ? -1 : 1),
                        i.edgeStrategy)
                    ) {
                        case "reset":
                            fa(j);
                            continue;
                        case "ease":
                            k = v.frame;
                            break;
                        default:
                        case "set":
                            var y = v.props;
                            for (e in y) h.call(y, e) && ((f = ea(y[e].value)), 0 === e.indexOf("@") ? j.setAttribute(e.substr(1), f) : g.setStyle(j, e, f));
                            continue;
                    }
                } else 0 !== i.edge && (Ea(j, [o, q], [p, r]), (i.edge = 0));
                for (var z = 0; m - 1 > z; z++)
                    if (k >= l[z].frame && k <= l[z + 1].frame) {
                        var A = l[z],
                            B = l[z + 1];
                        for (e in A.props)
                            if (h.call(A.props, e)) {
                                var C = (k - A.frame) / (B.frame - A.frame);
                                (C = A.props[e].easing(C)), (f = da(A.props[e].value, B.props[e].value, C)), (f = ea(f)), 0 === e.indexOf("@") ? j.setAttribute(e.substr(1), f) : g.setStyle(j, e, f);
                            }
                        w && x !== z && ("down" === La ? za(j, A.eventType, La) : za(j, B.eventType, La), (i.lastFrameIndex = z));
                        break;
                    }
            }
        },
        $ = function () {
            Qa && ((Qa = !1), Aa());
            var a,
                b,
                d = ha.getScrollTop(),
                e = Ha();
            if (oa) e >= oa.endTime ? ((d = oa.targetTop), (a = oa.done), (oa = c)) : ((b = oa.easing((e - oa.startTime) / oa.duration)), (d = (oa.startTop + b * oa.topDiff) | 0)), ha.setScrollTop(d, !0);
            else if (!sa) {
                var f = ra.targetTop - d;
                f && (ra = { startTop: Ma, topDiff: d - Ma, targetTop: d, startTime: Na, endTime: Na + qa }), e <= ra.endTime && ((b = W.sqrt((e - ra.startTime) / qa)), (d = (ra.startTop + b * ra.topDiff) | 0));
            }
            if (sa || Ma !== d) {
                (La = d > Ma ? "down" : Ma > d ? "up" : La), (sa = !1);
                var h = { curTop: d, lastTop: Ma, maxTop: Ja, direction: La },
                    i = ka.beforerender && ka.beforerender.call(ha, h);
                i !== !1 && (Z(d, ha.getScrollTop()), Sa && ja && g.setStyle(ja, "transform", "translate(0, " + -Ta + "px) " + ua), (Ma = d), ka.render && ka.render.call(ha, h)), a && a.call(ha, !1);
            }
            Na = e;
        },
        _ = function (a) {
            for (var b = 0, c = a.keyFrames.length; c > b; b++) {
                for (var d, e, f, g, h = a.keyFrames[b], i = {}; null !== (g = J.exec(h.props)); )
                    (f = g[1]), (e = g[2]), (d = f.match(K)), null !== d ? ((f = d[1]), (d = d[2])) : (d = w), (e = e.indexOf("!") ? aa(e) : [e.slice(1)]), (i[f] = { value: e, easing: W[d] });
                h.props = i;
            }
        },
        aa = function (a) {
            var b = [];
            return (
                (P.lastIndex = 0),
                (a = a.replace(P, function (a) {
                    return a.replace(N, function (a) {
                        return (a / 255) * 100 + "%";
                    });
                })),
                S &&
                    ((Q.lastIndex = 0),
                    (a = a.replace(Q, function (a) {
                        return S + a;
                    }))),
                (a = a.replace(N, function (a) {
                    return b.push(+a), "{?}";
                })),
                b.unshift(a),
                b
            );
        },
        ba = function (a) {
            var b,
                c,
                d = {};
            for (b = 0, c = a.keyFrames.length; c > b; b++) ca(a.keyFrames[b], d);
            for (d = {}, b = a.keyFrames.length - 1; b >= 0; b--) ca(a.keyFrames[b], d);
        },
        ca = function (a, b) {
            var c;
            for (c in b) h.call(a.props, c) || (a.props[c] = b[c]);
            for (c in a.props) b[c] = a.props[c];
        },
        da = function (a, b, c) {
            var d,
                e = a.length;
            if (e !== b.length) throw "Can't interpolate between \"" + a[0] + '" and "' + b[0] + '"';
            var f = [a[0]];
            for (d = 1; e > d; d++) f[d] = a[d] + (b[d] - a[d]) * c;
            return f;
        },
        ea = function (a) {
            var b = 1;
            return (
                (O.lastIndex = 0),
                a[0].replace(O, function () {
                    return a[b++];
                })
            );
        },
        fa = function (a, b) {
            a = [].concat(a);
            for (var c, d, e = 0, f = a.length; f > e; e++)
                (d = a[e]),
                    (c = ia[d[F]]),
                    c && (b ? ((d.style.cssText = c.dirtyStyleAttr), Ea(d, c.dirtyClassAttr)) : ((c.dirtyStyleAttr = d.style.cssText), (c.dirtyClassAttr = Da(d)), (d.style.cssText = c.styleAttr), Ea(d, c.classAttr)));
        },
        ga = function () {
            (ua = "translateZ(0)"), g.setStyle(ja, "transform", ua);
            var a = j(ja),
                b = a.getPropertyValue("transform"),
                c = a.getPropertyValue(S + "transform"),
                d = (b && "none" !== b) || (c && "none" !== c);
            d || (ua = "");
        };
    g.setStyle = function (a, b, c) {
        var d = a.style;
        if (((b = b.replace(L, M).replace("-", "")), "zIndex" === b)) isNaN(c) ? (d[b] = c) : (d[b] = "" + (0 | c));
        else if ("float" === b) d.styleFloat = d.cssFloat = c;
        else
            try {
                R && (d[R + b.slice(0, 1).toUpperCase() + b.slice(1)] = c), (d[b] = c);
            } catch (e) {}
    };
    var ha,
        ia,
        ja,
        ka,
        la,
        ma,
        na,
        oa,
        pa,
        qa,
        ra,
        sa,
        ta,
        ua,
        va,
        wa = (g.addEvent = function (b, c, d) {
            var e = function (b) {
                return (
                    (b = b || a.event),
                    b.target || (b.target = b.srcElement),
                    b.preventDefault ||
                        (b.preventDefault = function () {
                            (b.returnValue = !1), (b.defaultPrevented = !0);
                        }),
                    d.call(this, b)
                );
            };
            c = c.split(" ");
            for (var f, g = 0, h = c.length; h > g; g++) (f = c[g]), b.addEventListener ? b.addEventListener(f, d, !1) : b.attachEvent("on" + f, e), Ua.push({ element: b, name: f, listener: d });
        }),
        xa = (g.removeEvent = function (a, b, c) {
            b = b.split(" ");
            for (var d = 0, e = b.length; e > d; d++) a.removeEventListener ? a.removeEventListener(b[d], c, !1) : a.detachEvent("on" + b[d], c);
        }),
        ya = function () {
            for (var a, b = 0, c = Ua.length; c > b; b++) (a = Ua[b]), xa(a.element, a.name, a.listener);
            Ua = [];
        },
        za = function (a, b, c) {
            ka.keyframe && ka.keyframe.call(ha, a, b, c);
        },
        Aa = function () {
            var a = ha.getScrollTop();
            (Ja = 0), la && !Sa && (f.style.height = ""), Y(), la && !Sa && (f.style.height = Ja + e.clientHeight + "px"), Sa ? ha.setScrollTop(i.min(ha.getScrollTop(), Ja)) : ha.setScrollTop(a, !0), (sa = !0);
        },
        Ba = function () {
            var a,
                b,
                c = e.clientHeight,
                d = {};
            for (a in ma) (b = ma[a]), "function" == typeof b ? (b = b.call(ha)) : /p$/.test(b) && (b = (b.slice(0, -1) / 100) * c), (d[a] = b);
            return d;
        },
        Ca = function () {
            var a,
                b = 0;
            return ja && (b = i.max(ja.offsetHeight, ja.scrollHeight)), (a = i.max(b, f.scrollHeight, f.offsetHeight, e.scrollHeight, e.offsetHeight, e.clientHeight)), a - e.clientHeight;
        },
        Da = function (b) {
            var c = "className";
            return a.SVGElement && b instanceof a.SVGElement && ((b = b[c]), (c = "baseVal")), b[c];
        },
        Ea = function (b, d, e) {
            var f = "className";
            if ((a.SVGElement && b instanceof a.SVGElement && ((b = b[f]), (f = "baseVal")), e === c)) return void (b[f] = d);
            for (var g = b[f], h = 0, i = e.length; i > h; h++) g = Ga(g).replace(Ga(e[h]), " ");
            g = Fa(g);
            for (var j = 0, k = d.length; k > j; j++) -1 === Ga(g).indexOf(Ga(d[j])) && (g += " " + d[j]);
            b[f] = Fa(g);
        },
        Fa = function (a) {
            return a.replace(H, "");
        },
        Ga = function (a) {
            return " " + a + " ";
        },
        Ha =
            Date.now ||
            function () {
                return +new Date();
            },
        Ia = function (a, b) {
            return a.frame - b.frame;
        },
        Ja = 0,
        Ka = 1,
        La = "down",
        Ma = -1,
        Na = Ha(),
        Oa = 0,
        Pa = 0,
        Qa = !1,
        Ra = 0,
        Sa = !1,
        Ta = 0,
        Ua = [];
    "function" == typeof define && define.amd
        ? define([], function () {
              return g;
          })
        : "undefined" != typeof module && module.exports
        ? (module.exports = g)
        : (a.skrollr = g);
})(window, document);
jQuery('.readdata').click(function (event) {
event.preventDefault();
var descriptionFull = document.querySelector('.product-description-full');
descriptionFull.style.display = 'block';
var descriptionShort = document.querySelector('.product-description-short');
descriptionShort.style.display = 'none';
});
jQuery('.readdata2').click(function (event) {
event.preventDefault();
var descriptionFull = document.querySelector('.product-description-full');
descriptionFull.style.display = 'none';
var descriptionShort = document.querySelector('.product-description-short');
descriptionShort.style.display = 'block';window.scrollTo({top: 110, behavior: 'smooth'});
})